(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9056"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9056"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6jbMY", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $497da9736ab9cb12$export$6503ec6e8aabbaf; }, function (v) { return $497da9736ab9cb12$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $497da9736ab9cb12$export$f7ad0328861e2f03; }, function (v) { return $497da9736ab9cb12$export$f7ad0328861e2f03 = v; });
var $497da9736ab9cb12$export$6503ec6e8aabbaf;
var $497da9736ab9cb12$export$f7ad0328861e2f03;
"use strict";
var $497da9736ab9cb12$var$mapping = new Map();
function $497da9736ab9cb12$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$497da9736ab9cb12$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $497da9736ab9cb12$var$resolve(id) {
    var resolved = $497da9736ab9cb12$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$497da9736ab9cb12$export$6503ec6e8aabbaf = $497da9736ab9cb12$var$register;
$497da9736ab9cb12$export$f7ad0328861e2f03 = $497da9736ab9cb12$var$resolve;

});

parcelRegister("84ov9", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $5e01b3e70e752a4f$export$bdfd709ae4826697; }, function (v) { return $5e01b3e70e752a4f$export$bdfd709ae4826697 = v; });
var $5e01b3e70e752a4f$export$bdfd709ae4826697;
var $5e01b3e70e752a4f$export$c9e73fbda7da57b6;
var $5e01b3e70e752a4f$export$5a759dc7a1cfb72a;
"use strict";
var $5e01b3e70e752a4f$var$bundleURL = {};
function $5e01b3e70e752a4f$var$getBundleURLCached(id) {
    var value = $5e01b3e70e752a4f$var$bundleURL[id];
    if (!value) {
        value = $5e01b3e70e752a4f$var$getBundleURL();
        $5e01b3e70e752a4f$var$bundleURL[id] = value;
    }
    return value;
}
function $5e01b3e70e752a4f$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $5e01b3e70e752a4f$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $5e01b3e70e752a4f$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $5e01b3e70e752a4f$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$5e01b3e70e752a4f$export$bdfd709ae4826697 = $5e01b3e70e752a4f$var$getBundleURLCached;
$5e01b3e70e752a4f$export$c9e73fbda7da57b6 = $5e01b3e70e752a4f$var$getBaseURL;
$5e01b3e70e752a4f$export$5a759dc7a1cfb72a = $5e01b3e70e752a4f$var$getOrigin;

});

parcelRegister("iHOCm", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $d9e381cb875a5dc0$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $d9e381cb875a5dc0$export$5f0017c582d45a2d; });
function $d9e381cb875a5dc0$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("63F7w", function(module, exports) {

var $iHOCm = parcelRequire("iHOCm");
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.38
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined1) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.38", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    ///////////
    // Helper
    //////////
    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function enumerize(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function has(str1, str2) {
        return (typeof str1 === "undefined" ? "undefined" : (0, $iHOCm._)(str1)) === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function lowerize(str) {
        return str.toLowerCase();
    }, majorize = function majorize(version) {
        return (typeof version === "undefined" ? "undefined" : (0, $iHOCm._)(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined1;
    }, trim = function trim(str, len) {
        if ((typeof str === "undefined" ? "undefined" : (0, $iHOCm._)(str)) === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return (typeof len === "undefined" ? "undefined" : (0, $iHOCm._)(len)) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function rgxMapper(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if ((typeof q === "undefined" ? "undefined" : (0, $iHOCm._)(q)) === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if ((0, $iHOCm._)(q[1]) == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if ((0, $iHOCm._)(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined1;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined1;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined1;
                    } else this[q] = match ? match : undefined1;
                }
            }
            i += 2;
        }
    }, strMapper = function strMapper(str, map) {
        for(var i in map){
            // check if current value is array
            if ((0, $iHOCm._)(map[i]) === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined1 : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined1 : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function UAParser1(ua, extensions) {
        if ((typeof ua === "undefined" ? "undefined" : (0, $iHOCm._)(ua)) === OBJ_TYPE) {
            extensions = ua;
            ua = undefined1;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = (typeof window1 === "undefined" ? "undefined" : (0, $iHOCm._)(window1)) !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined1;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined1;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined1;
            _browser[VERSION] = undefined1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && (0, $iHOCm._)(_navigator.brave.isBrave) == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined1;
            _device[MODEL] = undefined1;
            _device[TYPE] = undefined1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && (0, $iHOCm._)(_navigator.standalone) !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined1;
            _engine[VERSION] = undefined1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined1;
            _os[VERSION] = undefined1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = (typeof ua === "undefined" ? "undefined" : (0, $iHOCm._)(ua)) === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if ((typeof exports === "undefined" ? "undefined" : (0, $iHOCm._)(exports)) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ((typeof define === "undefined" ? "undefined" : (0, $iHOCm._)(define)) === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if ((typeof window1 === "undefined" ? "undefined" : (0, $iHOCm._)(window1)) !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = (typeof window1 === "undefined" ? "undefined" : (0, $iHOCm._)(window1)) !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : undefined);

});

parcelRegister("ffHpO", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return assert; });
$parcel$export(module.exports, "object", function () { return object; });
$parcel$export(module.exports, "define", function () { return define; });
$parcel$export(module.exports, "optional", function () { return optional; });
$parcel$export(module.exports, "array", function () { return array; });
$parcel$export(module.exports, "boolean", function () { return _boolean; });
$parcel$export(module.exports, "literal", function () { return literal; });
$parcel$export(module.exports, "number", function () { return number; });
$parcel$export(module.exports, "string", function () { return string; });
$parcel$export(module.exports, "union", function () { return union; });
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ 
var $4iNIH = parcelRequire("4iNIH");

var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $37wUF = parcelRequire("37wUF");

var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $lgyFD = parcelRequire("lgyFD");

var $3F6om = parcelRequire("3F6om");

var $fCPXk = parcelRequire("fCPXk");

var $8xYJx = parcelRequire("8xYJx");

var $iHOCm = parcelRequire("iHOCm");

var $kra6d = parcelRequire("kra6d");

var $4pNo8 = parcelRequire("4pNo8");

var $33z5g = parcelRequire("33z5g");

var $33z5g = parcelRequire("33z5g");
var StructError = /*#__PURE__*/ function(TypeError1) {
    "use strict";
    (0, $37wUF._)(StructError, TypeError1);
    var _super = (0, $4pNo8._)(StructError);
    function StructError(failure, failures) {
        (0, $fvacx._)(this, StructError);
        var _this;
        var cached;
        var message = failure.message, explanation = failure.explanation, rest = (0, $lgyFD._)(failure, [
            "message",
            "explanation"
        ]);
        var path = failure.path;
        var msg = path.length === 0 ? message : "At path: ".concat(path.join("."), " -- ").concat(message);
        _this = _super.call(this, explanation !== null && explanation !== void 0 ? explanation : msg);
        if (explanation != null) _this.cause = msg;
        Object.assign((0, $4iNIH._)(_this), rest);
        _this.name = _this.constructor.name;
        _this.failures = function() {
            return cached !== null && cached !== void 0 ? cached : cached = [
                failure
            ].concat((0, $8xYJx._)(failures()));
        };
        return _this;
    }
    return StructError;
}((0, $kra6d._)(TypeError));
/**
 * Check if a value is an iterator.
 */ function isIterable(x) {
    return isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a non-array object.
 */ function isNonArrayObject(x) {
    return isObject(x) && !Array.isArray(x);
}
/**
 * Check if a value is a plain object.
 */ function isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function print(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $iHOCm._)(value)) === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : "".concat(value);
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function shiftIterator(input) {
    var _input_next = input.next(), done = _input_next.done, value = _input_next.value;
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    var path = context.path, branch = context.branch;
    var type = struct.type;
    var refinement = result.refinement, _result_message = result.message, message = _result_message === void 0 ? "Expected a value of type `".concat(type, "`").concat(refinement ? " with refinement `".concat(refinement, "`") : "", ", but received: `").concat(print(value), "`") : _result_message;
    return (0, $ioWVw._)((0, $e2Ogy._)({
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch
    }, result), {
        message: message
    });
}
/**
 * Convert a validation result to an iterable of failures.
 */ function toFailures(result, context, struct, value) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, failure, err;
    return (0, $33z5g.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!isIterable(result)) result = [
                    result
                ];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = result[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                r = _step.value;
                failure = toFailure(r, context, struct, value);
                if (!failure) return [
                    3,
                    4
                ];
                return [
                    4,
                    failure
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function run(value, struct) {
    var options, _options_path, path, _options_branch, branch, _options_coerce, coerce, _options_mask, mask, ctx, status, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, failure, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, k, v, s, ts, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, t, err, err, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, failure1, err;
    var _arguments = arguments;
    return (0, $33z5g.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                _options_path = options.path, path = _options_path === void 0 ? [] : _options_path, _options_branch = options.branch, branch = _options_branch === void 0 ? [
                    value
                ] : _options_branch, _options_coerce = options.coerce, coerce = _options_coerce === void 0 ? false : _options_coerce, _options_mask = options.mask, mask = _options_mask === void 0 ? false : _options_mask;
                ctx = {
                    path: path,
                    branch: branch,
                    mask: mask
                };
                if (coerce) value = struct.coercer(value, ctx);
                status = "valid";
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = struct.validator(value, ctx)[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                failure = _step.value;
                failure.explanation = options.message;
                status = "not_valid";
                return [
                    4,
                    [
                        failure,
                        undefined
                    ]
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                _state.label = 9;
            case 9:
                _state.trys.push([
                    9,
                    21,
                    22,
                    23
                ]);
                _iterator1 = struct.entries(value, ctx)[Symbol.iterator]();
                _state.label = 10;
            case 10:
                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                    3,
                    20
                ];
                _step_value = (0, $3F6om._)(_step1.value, 3), k = _step_value[0], v = _step_value[1], s = _step_value[2];
                ts = run(v, s, {
                    path: k === undefined ? path : (0, $8xYJx._)(path).concat([
                        k
                    ]),
                    branch: k === undefined ? branch : (0, $8xYJx._)(branch).concat([
                        v
                    ]),
                    coerce: coerce,
                    mask: mask,
                    message: options.message
                });
                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                _state.label = 11;
            case 11:
                _state.trys.push([
                    11,
                    17,
                    18,
                    19
                ]);
                _iterator2 = ts[Symbol.iterator]();
                _state.label = 12;
            case 12:
                if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                    3,
                    16
                ];
                t = _step2.value;
                if (!t[0]) return [
                    3,
                    14
                ];
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                return [
                    4,
                    [
                        t[0],
                        undefined
                    ]
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    15
                ];
            case 14:
                if (coerce) {
                    v = t[1];
                    if (k === undefined) value = v;
                    else if (value instanceof Map) value.set(k, v);
                    else if (value instanceof Set) value.add(v);
                    else if (isObject(value)) {
                        if (v !== undefined || k in value) value[k] = v;
                    }
                }
                _state.label = 15;
            case 15:
                _iteratorNormalCompletion2 = true;
                return [
                    3,
                    12
                ];
            case 16:
                return [
                    3,
                    19
                ];
            case 17:
                err = _state.sent();
                _didIteratorError2 = true;
                _iteratorError2 = err;
                return [
                    3,
                    19
                ];
            case 18:
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                        _iterator2["return"]();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
                return [
                    7
                ];
            case 19:
                _iteratorNormalCompletion1 = true;
                return [
                    3,
                    10
                ];
            case 20:
                return [
                    3,
                    23
                ];
            case 21:
                err = _state.sent();
                _didIteratorError1 = true;
                _iteratorError1 = err;
                return [
                    3,
                    23
                ];
            case 22:
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
                return [
                    7
                ];
            case 23:
                _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                if (!(status !== "not_valid")) return [
                    3,
                    31
                ];
                _state.label = 24;
            case 24:
                _state.trys.push([
                    24,
                    29,
                    30,
                    31
                ]);
                _iterator3 = struct.refiner(value, ctx)[Symbol.iterator]();
                _state.label = 25;
            case 25:
                if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                    3,
                    28
                ];
                failure1 = _step3.value;
                failure1.explanation = options.message;
                status = "not_refined";
                return [
                    4,
                    [
                        failure1,
                        undefined
                    ]
                ];
            case 26:
                _state.sent();
                _state.label = 27;
            case 27:
                _iteratorNormalCompletion3 = true;
                return [
                    3,
                    25
                ];
            case 28:
                return [
                    3,
                    31
                ];
            case 29:
                err = _state.sent();
                _didIteratorError3 = true;
                _iteratorError3 = err;
                return [
                    3,
                    31
                ];
            case 30:
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                        _iterator3["return"]();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
                return [
                    7
                ];
            case 31:
                if (!(status === "valid")) return [
                    3,
                    33
                ];
                return [
                    4,
                    [
                        undefined,
                        value
                    ]
                ];
            case 32:
                _state.sent();
                _state.label = 33;
            case 33:
                return [
                    2
                ];
        }
    });
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ var Struct = /*#__PURE__*/ function() {
    "use strict";
    function Struct(props) {
        var _this = this;
        (0, $fvacx._)(this, Struct);
        var type = props.type, schema = props.schema, validator = props.validator, refiner = props.refiner, _props_coercer = props.coercer, coercer = _props_coercer === void 0 ? function(value) {
            return value;
        } : _props_coercer, _props_entries = props.entries, entries = _props_entries === void 0 ? function() {
            return (0, $33z5g.__generator)(this, function(_state) {
                return [
                    2
                ];
            });
        } : _props_entries;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = function(value, context) {
            var result = validator(value, context);
            return toFailures(result, context, _this, value);
        };
        else this.validator = function() {
            return [];
        };
        if (refiner) this.refiner = function(value, context) {
            var result = refiner(value, context);
            return toFailures(result, context, _this, value);
        };
        else this.refiner = function() {
            return [];
        };
    }
    (0, $3D4gQ._)(Struct, [
        {
            /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ key: "assert",
            value: function assert1(value, message) {
                return assert(value, this, message);
            }
        },
        {
            /**
     * Create a value with the struct's coercion logic, then validate it.
     */ key: "create",
            value: function create1(value, message) {
                return create(value, this, message);
            }
        },
        {
            /**
     * Check if a value passes the struct's validation.
     */ key: "is",
            value: function is1(value) {
                return is(value, this);
            }
        },
        {
            /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema. Masking applies recursively to
     * props of `object` structs only.
     */ key: "mask",
            value: function mask1(value, message) {
                return mask(value, this, message);
            }
        },
        {
            /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `coerce` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful. Also, `mask` will turn on
     * masking of the unknown `object` props recursively if passed.
     */ key: "validate",
            value: function validate1(value) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return validate(value, this, options);
            }
        }
    ]);
    return Struct;
}();
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function assert(value, struct, message) {
    var result = validate(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function create(value, struct, message) {
    var result = validate(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function mask(value, struct, message) {
    var result = validate(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function is(value, struct) {
    var result = validate(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function validate(value, struct) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var tuples = run(value, struct, options);
    var tuple = shiftIterator(tuples);
    if (tuple[0]) {
        var error = new StructError(tuple[0], function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = tuples[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        t = _step.value;
                        if (!t[0]) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            t[0]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return [
            error,
            undefined
        ];
    } else {
        var v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function assign() {
    for(var _len = arguments.length, Structs = new Array(_len), _key = 0; _key < _len; _key++){
        Structs[_key] = arguments[_key];
    }
    var _Object;
    var isType = Structs[0].type === "type";
    var schemas = Structs.map(function(s) {
        return s.schema;
    });
    var schema = (_Object = Object).assign.apply(_Object, [
        {}
    ].concat((0, $8xYJx._)(schemas)));
    return isType ? type(schema) : object(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function define(name, validator) {
    return new Struct({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function deprecated(struct, log) {
    return new Struct((0, $ioWVw._)((0, $e2Ogy._)({}, struct), {
        refiner: function(value, ctx) {
            return value === undefined || struct.refiner(value, ctx);
        },
        validator: function(value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    }));
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function dynamic(fn) {
    return new Struct({
        type: "dynamic",
        schema: null,
        entries: function(value, ctx) {
            var struct;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        struct = fn(value, ctx);
                        return [
                            5,
                            (0, $33z5g.__values)(struct.entries(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner: function(value, ctx) {
            var struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function lazy(fn) {
    var struct;
    return new Struct({
        type: "lazy",
        schema: null,
        entries: function(value, ctx) {
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        struct !== null && struct !== void 0 ? struct : struct = fn();
                        return [
                            5,
                            (0, $33z5g.__values)(struct.entries(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.coercer(value, ctx);
        },
        refiner: function(value, ctx) {
            struct !== null && struct !== void 0 ? struct : struct = fn();
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function omit(struct, keys) {
    var schema = struct.schema;
    var subschema = (0, $e2Ogy._)({}, schema);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            delete subschema[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    switch(struct.type){
        case "type":
            return type(subschema);
        default:
            return object(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function partial(struct) {
    var isStruct = struct instanceof Struct;
    var schema = isStruct ? (0, $e2Ogy._)({}, struct.schema) : (0, $e2Ogy._)({}, struct);
    for(var key in schema)schema[key] = optional(schema[key]);
    if (isStruct && struct.type === "type") return type(schema);
    return object(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function pick(struct, keys) {
    var schema = struct.schema;
    var subschema = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            subschema[key] = schema[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    switch(struct.type){
        case "type":
            return type(subschema);
        default:
            return object(subschema);
    }
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function struct(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return define(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function any() {
    return define("any", function() {
        return true;
    });
}
function array(Element) {
    return new Struct({
        type: "array",
        schema: Element,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, i, v, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Element && Array.isArray(value))) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = value.entries()[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        _step_value = (0, $3F6om._)(_step.value, 2), i = _step_value[0], v = _step_value[1];
                        return [
                            4,
                            [
                                i,
                                v,
                                Element
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator: function(value) {
            return Array.isArray(value) || "Expected an array value, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function bigint() {
    return define("bigint", function(value) {
        return (typeof value === "undefined" ? "undefined" : (0, $iHOCm._)(value)) === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function _boolean() {
    return define("boolean", function(value) {
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function date() {
    return define("date", function(value) {
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: ".concat(print(value));
    });
}
function enums(values) {
    var schema = {};
    var description = values.map(function(v) {
        return print(v);
    }).join();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            schema[key] = key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return new Struct({
        type: "enums",
        schema: schema,
        validator: function(value) {
            return values.includes(value) || "Expected one of `".concat(description, "`, but received: ").concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function func() {
    return define("func", function(value) {
        return typeof value === "function" || "Expected a function, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function instance(Class) {
    return define("instance", function(value) {
        return value instanceof Class || "Expected a `".concat(Class.name, "` instance, but received: ").concat(print(value));
    });
}
/**
 * Ensure that a value is an integer.
 */ function integer() {
    return define("integer", function(value) {
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function intersection(Structs) {
    return new Struct({
        type: "intersection",
        schema: null,
        entries: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $33z5g.__values)(S.entries(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $33z5g.__values)(S.validator(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        refiner: function(value, ctx) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, S, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = Structs[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        S = _step.value;
                        return [
                            5,
                            (0, $33z5g.__values)(S.refiner(value, ctx))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        }
    });
}
function literal(constant) {
    var description = print(constant);
    var t = typeof constant === "undefined" ? "undefined" : (0, $iHOCm._)(constant);
    return new Struct({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator: function(value) {
            return value === constant || "Expected the literal `".concat(description, "`, but received: ").concat(print(value));
        }
    });
}
function map(Key, Value) {
    return new Struct({
        type: "map",
        schema: null,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, k, v, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Key && Value && value instanceof Map)) return [
                            3,
                            9
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        _iterator = value.entries()[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        _step_value = (0, $3F6om._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                        return [
                            4,
                            [
                                k,
                                k,
                                Key
                            ]
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            [
                                k,
                                v,
                                Value
                            ]
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator: function(value) {
            return value instanceof Map || "Expected a `Map` object, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function never() {
    return define("never", function() {
        return false;
    });
}
/**
 * Augment an existing struct to allow `null` values.
 */ function nullable(struct) {
    return new Struct((0, $ioWVw._)((0, $e2Ogy._)({}, struct), {
        validator: function(value, ctx) {
            return value === null || struct.validator(value, ctx);
        },
        refiner: function(value, ctx) {
            return value === null || struct.refiner(value, ctx);
        }
    }));
}
/**
 * Ensure that a value is a number.
 */ function number() {
    return define("number", function(value) {
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: ".concat(print(value));
    });
}
function object(schema) {
    var knowns = schema ? Object.keys(schema) : [];
    var Never = never();
    return new Struct({
        type: "object",
        schema: schema ? schema : null,
        entries: function(value) {
            var unknowns, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key1, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(schema && isObject(value))) return [
                            3,
                            16
                        ];
                        unknowns = new Set(Object.keys(value));
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = knowns[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        key = _step.value;
                        unknowns["delete"](key);
                        return [
                            4,
                            [
                                key,
                                value[key],
                                schema[key]
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            14,
                            15,
                            16
                        ]);
                        _iterator1 = unknowns[Symbol.iterator]();
                        _state.label = 10;
                    case 10:
                        if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                            3,
                            13
                        ];
                        key1 = _step1.value;
                        return [
                            4,
                            [
                                key1,
                                value[key1],
                                Never
                            ]
                        ];
                    case 11:
                        _state.sent();
                        _state.label = 12;
                    case 12:
                        _iteratorNormalCompletion1 = true;
                        return [
                            3,
                            10
                        ];
                    case 13:
                        return [
                            3,
                            16
                        ];
                    case 14:
                        err = _state.sent();
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                        return [
                            3,
                            16
                        ];
                    case 15:
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                        return [
                            7
                        ];
                    case 16:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value, ctx) {
            if (!isNonArrayObject(value)) return value;
            var coerced = (0, $e2Ogy._)({}, value);
            // The `object` struct has special behaviour enabled by the mask flag.
            // When masking, properties that are not in the schema are deleted from
            // the coerced object instead of eventually failing validaiton.
            if (ctx.mask && schema) {
                for(var key in coerced)if (schema[key] === undefined) delete coerced[key];
            }
            return coerced;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function optional(struct) {
    return new Struct((0, $ioWVw._)((0, $e2Ogy._)({}, struct), {
        validator: function(value, ctx) {
            return value === undefined || struct.validator(value, ctx);
        },
        refiner: function(value, ctx) {
            return value === undefined || struct.refiner(value, ctx);
        }
    }));
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function record(Key, Value) {
    return new Struct({
        type: "record",
        schema: null,
        entries: function(value) {
            var _tmp, _tmp1, _i, k, v;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isObject(value)) return [
                            3,
                            5
                        ];
                        _tmp = [];
                        for(_tmp1 in value)_tmp.push(_tmp1);
                        _i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(_i < _tmp.length)) return [
                            3,
                            5
                        ];
                        k = _tmp[_i];
                        v = value[k];
                        return [
                            4,
                            [
                                k,
                                k,
                                Key
                            ]
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            [
                                k,
                                v,
                                Value
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _i++;
                        return [
                            3,
                            1
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return isNonArrayObject(value) ? (0, $e2Ogy._)({}, value) : value;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function regexp() {
    return define("regexp", function(value) {
        return value instanceof RegExp;
    });
}
function set(Element) {
    return new Struct({
        type: "set",
        schema: null,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!(Element && value instanceof Set)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = value[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        v = _step.value;
                        return [
                            4,
                            [
                                v,
                                v,
                                Element
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        coercer: function(value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator: function(value) {
            return value instanceof Set || "Expected a `Set` object, but received: ".concat(print(value));
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function string() {
    return define("string", function(value) {
        return typeof value === "string" || "Expected a string, but received: ".concat(print(value));
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function tuple(Structs) {
    var Never = never();
    return new Struct({
        type: "tuple",
        schema: null,
        entries: function(value) {
            var length, i;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!Array.isArray(value)) return [
                            3,
                            4
                        ];
                        length = Math.max(Structs.length, value.length);
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < length)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            [
                                i,
                                value[i],
                                Structs[i] || Never
                            ]
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return Array.isArray(value) || "Expected an array, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return Array.isArray(value) ? value.slice() : value;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function type(schema) {
    var keys = Object.keys(schema);
    return new Struct({
        type: "type",
        schema: schema,
        entries: function(value) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, k, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!isObject(value)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = keys[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        k = _step.value;
                        return [
                            4,
                            [
                                k,
                                value[k],
                                schema[k]
                            ]
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        },
        validator: function(value) {
            return isNonArrayObject(value) || "Expected an object, but received: ".concat(print(value));
        },
        coercer: function(value) {
            return isNonArrayObject(value) ? (0, $e2Ogy._)({}, value) : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function union(Structs) {
    var description = Structs.map(function(s) {
        return s.type;
    }).join(" | ");
    return new Struct({
        type: "union",
        schema: null,
        coercer: function(value, ctx) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Structs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var S = _step.value;
                    var _S_validate = (0, $3F6om._)(S.validate(value, {
                        coerce: true,
                        mask: ctx.mask
                    }), 2), error = _S_validate[0], coerced = _S_validate[1];
                    if (!error) return coerced;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return value;
        },
        validator: function(value, ctx) {
            var failures = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Structs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var S = _step.value;
                    var _run = (0, $fCPXk._)(run(value, S, ctx)), tuples = _run.slice(0);
                    var _tuples = (0, $3F6om._)(tuples, 1), first = _tuples[0];
                    if (!first[0]) return [];
                    else {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = tuples[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _step_value = (0, $3F6om._)(_step1.value, 1), failure = _step_value[0];
                                if (failure) failures.push(failure);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                "Expected the value to satisfy a union of `".concat(description, "`, but received: ").concat(print(value))
            ].concat((0, $8xYJx._)(failures));
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function unknown() {
    return define("unknown", function() {
        return true;
    });
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function coerce(struct, condition, coercer) {
    return new Struct((0, $ioWVw._)((0, $e2Ogy._)({}, struct), {
        coercer: function(value, ctx) {
            return is(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    }));
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function defaulted(struct, fallback) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return coerce(struct, unknown(), function(x) {
        var f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && isPlainObject(x) && isPlainObject(f)) {
            var ret = (0, $e2Ogy._)({}, x);
            var changed = false;
            for(var key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function trimmed(struct) {
    return coerce(struct, string(), function(x) {
        return x.trim();
    });
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function empty(struct) {
    return refine(struct, "empty", function(value) {
        var size = getSize(value);
        return size === 0 || "Expected an empty ".concat(struct.type, " but received one with a size of `").concat(size, "`");
    });
}
function getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function max(struct, threshold) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var exclusive = options.exclusive;
    return refine(struct, "max", function(value) {
        return exclusive ? value < threshold : value <= threshold || "Expected a ".concat(struct.type, " less than ").concat(exclusive ? "" : "or equal to ").concat(threshold, " but received `").concat(value, "`");
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function min(struct, threshold) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var exclusive = options.exclusive;
    return refine(struct, "min", function(value) {
        return exclusive ? value > threshold : value >= threshold || "Expected a ".concat(struct.type, " greater than ").concat(exclusive ? "" : "or equal to ").concat(threshold, " but received `").concat(value, "`");
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function nonempty(struct) {
    return refine(struct, "nonempty", function(value) {
        var size = getSize(value);
        return size > 0 || "Expected a nonempty ".concat(struct.type, " but received an empty one");
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function pattern(struct, regexp) {
    return refine(struct, "pattern", function(value) {
        return regexp.test(value) || "Expected a ".concat(struct.type, " matching `/").concat(regexp.source, '/` but received "').concat(value, '"');
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function size(struct, min) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : min;
    var expected = "Expected a ".concat(struct.type);
    var of = min === max ? "of `".concat(min, "`") : "between `".concat(min, "` and `").concat(max, "`");
    return refine(struct, "size", function(value) {
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || "".concat(expected, " ").concat(of, " but received `").concat(value, "`");
        else if (value instanceof Map || value instanceof Set) {
            var size = value.size;
            return min <= size && size <= max || "".concat(expected, " with a size ").concat(of, " but received one with a size of `").concat(size, "`");
        } else {
            var length = value.length;
            return min <= length && length <= max || "".concat(expected, " with a length ").concat(of, " but received one with a length of `").concat(length, "`");
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function refine(struct, name, refiner) {
    return new Struct((0, $ioWVw._)((0, $e2Ogy._)({}, struct), {
        refiner: function(value, ctx) {
            var result, failures, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, failure, err;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            5,
                            (0, $33z5g.__values)(struct.refiner(value, ctx))
                        ];
                    case 1:
                        _state.sent();
                        result = refiner(value, ctx);
                        failures = toFailures(result, ctx, struct, value);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = failures[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        failure = _step.value;
                        return [
                            4,
                            (0, $ioWVw._)((0, $e2Ogy._)({}, failure), {
                                refinement: name
                            })
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        }
    }));
}

});
parcelRegister("4iNIH", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $321f6939fb8fe65b$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $321f6939fb8fe65b$export$f3b8ed2e4a5d10b8; });
function $321f6939fb8fe65b$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("fvacx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $02e993422eac0630$export$2996f80ef42b8419; });
function $02e993422eac0630$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("3D4gQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2a4853b079fa8356$export$d60067ff2358eee8; });
function $2a4853b079fa8356$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2a4853b079fa8356$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $2a4853b079fa8356$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a4853b079fa8356$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("37wUF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $245b8e62f7993d5b$export$7e4530ad35d3bb8; });

var $l7kvn = parcelRequire("l7kvn");
function $245b8e62f7993d5b$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $l7kvn._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("l7kvn", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $f5fa284b0ac3c117$export$c2c98ac76e997b63; });
function $f5fa284b0ac3c117$export$c2c98ac76e997b63(o, p) {
    $f5fa284b0ac3c117$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f5fa284b0ac3c117$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("e2Ogy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a3983e5cae5aa06a$export$581ff339ea0ba762; });

var $98Dv3 = parcelRequire("98Dv3");
function $a3983e5cae5aa06a$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $98Dv3._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("98Dv3", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $6a738044a4ad7d4c$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $6a738044a4ad7d4c$export$1e71eb4bef00f6b0; });
function $6a738044a4ad7d4c$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("ioWVw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d6582d82bfa55d06$export$4fa2f4023c9cbda5; });
function $d6582d82bfa55d06$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d6582d82bfa55d06$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d6582d82bfa55d06$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("lgyFD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f7b5fc7751bc0139$export$69fdd232f62cde60; });

var $bISl5 = parcelRequire("bISl5");
function $f7b5fc7751bc0139$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $bISl5._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("bISl5", function(module, exports) {

$parcel$export(module.exports, "_object_without_properties_loose", function () { return $888df4623b63a92f$export$7a4a7e38737aceb4; });
function $888df4623b63a92f$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("3F6om", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2aaa28b943882f84$export$fdf2a89c76341bbf; });

var $6jMCr = parcelRequire("6jMCr");

var $55F7y = parcelRequire("55F7y");

var $btuLw = parcelRequire("btuLw");

var $g5jax = parcelRequire("g5jax");
function $2aaa28b943882f84$export$fdf2a89c76341bbf(arr, i) {
    return (0, $6jMCr._array_with_holes)(arr) || (0, $55F7y._iterable_to_array_limit)(arr, i) || (0, $g5jax._unsupported_iterable_to_array)(arr, i) || (0, $btuLw._non_iterable_rest)();
}

});
parcelRegister("6jMCr", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $499a3b2989029824$export$e6256bf45c68d561; });
function $499a3b2989029824$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("55F7y", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $3b4d51255e89172a$export$2fd15edff6687200; });
function $3b4d51255e89172a$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("btuLw", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $85aa448ce7620c37$export$60dbc22abd7da546; });
function $85aa448ce7620c37$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("g5jax", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $bb5bfb8d521801f3$export$a5be06335b3a083c; });

var $4bROD = parcelRequire("4bROD");
function $bb5bfb8d521801f3$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $4bROD._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $4bROD._array_like_to_array)(o, minLen);
}

});
parcelRegister("4bROD", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $30d1ef2ef9c66484$export$79e617b1955a2616; });
function $30d1ef2ef9c66484$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("fCPXk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b602b501808b28f2$export$e62c166da838fa3; });

var $6jMCr = parcelRequire("6jMCr");

var $cD9Fo = parcelRequire("cD9Fo");

var $btuLw = parcelRequire("btuLw");

var $g5jax = parcelRequire("g5jax");
function $b602b501808b28f2$export$e62c166da838fa3(arr) {
    return (0, $6jMCr._array_with_holes)(arr) || (0, $cD9Fo._iterable_to_array)(arr) || (0, $g5jax._unsupported_iterable_to_array)(arr) || (0, $btuLw._non_iterable_rest)();
}

});
parcelRegister("cD9Fo", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $9320a02271fa3b79$export$1eb58a6e75231000; });
function $9320a02271fa3b79$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("8xYJx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6390842e993559ee$export$1b5e630bc3aea29f; });

var $8JmWe = parcelRequire("8JmWe");

var $cD9Fo = parcelRequire("cD9Fo");

var $jbGee = parcelRequire("jbGee");

var $g5jax = parcelRequire("g5jax");
function $6390842e993559ee$export$1b5e630bc3aea29f(arr) {
    return (0, $8JmWe._array_without_holes)(arr) || (0, $cD9Fo._iterable_to_array)(arr) || (0, $g5jax._unsupported_iterable_to_array)(arr) || (0, $jbGee._non_iterable_spread)();
}

});
parcelRegister("8JmWe", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $65b451c600c68538$export$7e0947b5ad3404e2; });

var $4bROD = parcelRequire("4bROD");
function $65b451c600c68538$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $4bROD._array_like_to_array)(arr);
}

});

parcelRegister("jbGee", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $df7fcd1d2e4d2a7d$export$e6f3c4780d19eb2b; });
function $df7fcd1d2e4d2a7d$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kra6d", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ee0e29c6cc03a479$export$2466d533fda16e33; });

var $iZYNC = parcelRequire("iZYNC");

var $eZJmj = parcelRequire("eZJmj");

var $9IaO9 = parcelRequire("9IaO9");

var $l7kvn = parcelRequire("l7kvn");
function $ee0e29c6cc03a479$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ee0e29c6cc03a479$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $9IaO9._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $iZYNC._construct)(Class, arguments, (0, $eZJmj._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $l7kvn._set_prototype_of)(Wrapper, Class);
    };
    return $ee0e29c6cc03a479$export$2466d533fda16e33(Class);
}

});
parcelRegister("iZYNC", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $dd4d15fb8d790c02$export$2d841144c5f8c4ab; });

var $enxlk = parcelRequire("enxlk");

var $l7kvn = parcelRequire("l7kvn");
function $dd4d15fb8d790c02$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $enxlk._is_native_reflect_construct)()) $dd4d15fb8d790c02$export$2d841144c5f8c4ab = Reflect.construct;
    else $dd4d15fb8d790c02$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $l7kvn._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $dd4d15fb8d790c02$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRegister("enxlk", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $a77d13e1a9eca991$export$685354647fba1516; });
function $a77d13e1a9eca991$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("eZJmj", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $aea9f28acfd405fc$export$f09211a7d3c496a1; });
function $aea9f28acfd405fc$export$f09211a7d3c496a1(o) {
    $aea9f28acfd405fc$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $aea9f28acfd405fc$export$f09211a7d3c496a1(o);
}

});

parcelRegister("9IaO9", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $71209b5215df45dd$export$514eda94019f4334; });
function $71209b5215df45dd$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("4pNo8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $336fceaed7b914f1$export$8dd05c13f5255580; });

var $eZJmj = parcelRequire("eZJmj");

var $enxlk = parcelRequire("enxlk");

var $Ifr2g = parcelRequire("Ifr2g");
function $336fceaed7b914f1$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $enxlk._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $eZJmj._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eZJmj._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $Ifr2g._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("Ifr2g", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $0850154189ccd92a$export$ef97c660ca164e52; });

var $4iNIH = parcelRequire("4iNIH");

var $iHOCm = parcelRequire("iHOCm");
function $0850154189ccd92a$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $iHOCm._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $4iNIH._assert_this_initialized)(self);
}

});


parcelRegister("33z5g", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $239cddd141ca067f$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $239cddd141ca067f$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $iHOCm = parcelRequire("iHOCm");
var $239cddd141ca067f$var$extendStatics = function extendStatics1(d, b) {
    $239cddd141ca067f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $239cddd141ca067f$var$extendStatics(d, b);
};
function $239cddd141ca067f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $239cddd141ca067f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $239cddd141ca067f$export$18ce0697a983be9b = function __assign1() {
    $239cddd141ca067f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $239cddd141ca067f$export$18ce0697a983be9b.apply(this, arguments);
};
function $239cddd141ca067f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $239cddd141ca067f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $239cddd141ca067f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $239cddd141ca067f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $239cddd141ca067f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $239cddd141ca067f$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $iHOCm._)(x)) === "symbol" ? x : "".concat(x);
}
function $239cddd141ca067f$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $iHOCm._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $239cddd141ca067f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $239cddd141ca067f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $239cddd141ca067f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $239cddd141ca067f$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $239cddd141ca067f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $239cddd141ca067f$export$45d3717a4c69092e(o, m, p);
}
function $239cddd141ca067f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $239cddd141ca067f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $239cddd141ca067f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($239cddd141ca067f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $239cddd141ca067f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $239cddd141ca067f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $239cddd141ca067f$export$10c90e4f7922046c(v) {
    return this instanceof $239cddd141ca067f$export$10c90e4f7922046c ? (this.v = v, this) : new $239cddd141ca067f$export$10c90e4f7922046c(v);
}
function $239cddd141ca067f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $239cddd141ca067f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $239cddd141ca067f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $239cddd141ca067f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $239cddd141ca067f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $239cddd141ca067f$export$19a8beecd37a4c45 === "function" ? $239cddd141ca067f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $239cddd141ca067f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $239cddd141ca067f$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $239cddd141ca067f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $239cddd141ca067f$export$45d3717a4c69092e(result, mod, k);
    }
    $239cddd141ca067f$var$__setModuleDefault(result, mod);
    return result;
}
function $239cddd141ca067f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $239cddd141ca067f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $239cddd141ca067f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $239cddd141ca067f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $239cddd141ca067f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $239cddd141ca067f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $239cddd141ca067f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $239cddd141ca067f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $239cddd141ca067f$export$2e2bcd8739ae039 = {
    __extends: $239cddd141ca067f$export$a8ba968b8961cb8a,
    __assign: $239cddd141ca067f$export$18ce0697a983be9b,
    __rest: $239cddd141ca067f$export$3c9a16f847548506,
    __decorate: $239cddd141ca067f$export$29e00dfd3077644b,
    __param: $239cddd141ca067f$export$d5ad3fd78186038f,
    __metadata: $239cddd141ca067f$export$f1db080c865becb9,
    __awaiter: $239cddd141ca067f$export$1050f835b63b671e,
    __generator: $239cddd141ca067f$export$67ebef60e6f28a6,
    __createBinding: $239cddd141ca067f$export$45d3717a4c69092e,
    __exportStar: $239cddd141ca067f$export$f33643c0debef087,
    __values: $239cddd141ca067f$export$19a8beecd37a4c45,
    __read: $239cddd141ca067f$export$8d051b38c9118094,
    __spread: $239cddd141ca067f$export$afc72e2116322959,
    __spreadArrays: $239cddd141ca067f$export$6388937ca91ccae8,
    __spreadArray: $239cddd141ca067f$export$1216008129fb82ed,
    __await: $239cddd141ca067f$export$10c90e4f7922046c,
    __asyncGenerator: $239cddd141ca067f$export$e427f37a30a4de9b,
    __asyncDelegator: $239cddd141ca067f$export$bbd80228419bb833,
    __asyncValues: $239cddd141ca067f$export$e3b29a3d6162315f,
    __makeTemplateObject: $239cddd141ca067f$export$4fb47efe1390b86f,
    __importStar: $239cddd141ca067f$export$c21735bcef00d192,
    __importDefault: $239cddd141ca067f$export$da59b14a69baef04,
    __classPrivateFieldGet: $239cddd141ca067f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $239cddd141ca067f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $239cddd141ca067f$export$81fdc39f203e4e04,
    __addDisposableResource: $239cddd141ca067f$export$88ac25d8e944e405,
    __disposeResources: $239cddd141ca067f$export$8f076105dc360e92
};

});


parcelRegister("cuHyt", function(module, exports) {
"use strict";
var $918a127ba2ff3235$var$__assign = module.exports && module.exports.__assign || function() {
    $918a127ba2ff3235$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $918a127ba2ff3235$var$__assign.apply(this, arguments);
};

var $9kJDO = parcelRequire("9kJDO");

var $gGVh9 = parcelRequire("gGVh9");

var $cpf5X = parcelRequire("cpf5X");

var $aoUIw = parcelRequire("aoUIw");

var $lwcK5 = parcelRequire("lwcK5");
var $918a127ba2ff3235$var$customCards = {};
var $918a127ba2ff3235$var$cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard"
};
var $918a127ba2ff3235$var$ORIGINAL_TEST_ORDER = [
    $918a127ba2ff3235$var$cardNames.VISA,
    $918a127ba2ff3235$var$cardNames.MASTERCARD,
    $918a127ba2ff3235$var$cardNames.AMERICAN_EXPRESS,
    $918a127ba2ff3235$var$cardNames.DINERS_CLUB,
    $918a127ba2ff3235$var$cardNames.DISCOVER,
    $918a127ba2ff3235$var$cardNames.JCB,
    $918a127ba2ff3235$var$cardNames.UNIONPAY,
    $918a127ba2ff3235$var$cardNames.MAESTRO,
    $918a127ba2ff3235$var$cardNames.ELO,
    $918a127ba2ff3235$var$cardNames.MIR,
    $918a127ba2ff3235$var$cardNames.HIPER,
    $918a127ba2ff3235$var$cardNames.HIPERCARD
];
var $918a127ba2ff3235$var$testOrder = $lwcK5.clone($918a127ba2ff3235$var$ORIGINAL_TEST_ORDER);
function $918a127ba2ff3235$var$findType(cardType) {
    return $918a127ba2ff3235$var$customCards[cardType] || $9kJDO[cardType];
}
function $918a127ba2ff3235$var$getAllCardTypes() {
    return $918a127ba2ff3235$var$testOrder.map(function(cardType) {
        return $lwcK5.clone($918a127ba2ff3235$var$findType(cardType));
    });
}
function $918a127ba2ff3235$var$getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) ignoreErrorForNotExisting = false;
    var position = $918a127ba2ff3235$var$testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) throw new Error('"' + name + '" is not a supported card type.');
    return position;
}
function $918a127ba2ff3235$var$creditCardType(cardNumber) {
    var results = [];
    if (!$cpf5X.isValidInputType(cardNumber)) return results;
    if (cardNumber.length === 0) return $918a127ba2ff3235$var$getAllCardTypes();
    $918a127ba2ff3235$var$testOrder.forEach(function(cardType) {
        var cardConfiguration = $918a127ba2ff3235$var$findType(cardType);
        $gGVh9.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    var bestMatch = $aoUIw.findBestMatch(results);
    if (bestMatch) return [
        bestMatch
    ];
    return results;
}
$918a127ba2ff3235$var$creditCardType.getTypeInfo = function(cardType) {
    return $lwcK5.clone($918a127ba2ff3235$var$findType(cardType));
};
$918a127ba2ff3235$var$creditCardType.removeCard = function(name) {
    var position = $918a127ba2ff3235$var$getCardPosition(name);
    $918a127ba2ff3235$var$testOrder.splice(position, 1);
};
$918a127ba2ff3235$var$creditCardType.addCard = function(config) {
    var existingCardPosition = $918a127ba2ff3235$var$getCardPosition(config.type, true);
    $918a127ba2ff3235$var$customCards[config.type] = config;
    if (existingCardPosition === -1) $918a127ba2ff3235$var$testOrder.push(config.type);
};
$918a127ba2ff3235$var$creditCardType.updateCard = function(cardType, updates) {
    var originalObject = $918a127ba2ff3235$var$customCards[cardType] || $9kJDO[cardType];
    if (!originalObject) throw new Error('"' + cardType + "\" is not a recognized type. Use `addCard` instead.'");
    if (updates.type && originalObject.type !== updates.type) throw new Error("Cannot overwrite type parameter.");
    var clonedCard = $lwcK5.clone(originalObject);
    clonedCard = $918a127ba2ff3235$var$__assign($918a127ba2ff3235$var$__assign({}, clonedCard), updates);
    $918a127ba2ff3235$var$customCards[clonedCard.type] = clonedCard;
};
$918a127ba2ff3235$var$creditCardType.changeOrder = function(name, position) {
    var currentPosition = $918a127ba2ff3235$var$getCardPosition(name);
    $918a127ba2ff3235$var$testOrder.splice(currentPosition, 1);
    $918a127ba2ff3235$var$testOrder.splice(position, 0, name);
};
$918a127ba2ff3235$var$creditCardType.resetModifications = function() {
    $918a127ba2ff3235$var$testOrder = $lwcK5.clone($918a127ba2ff3235$var$ORIGINAL_TEST_ORDER);
    $918a127ba2ff3235$var$customCards = {};
};
$918a127ba2ff3235$var$creditCardType.types = $918a127ba2ff3235$var$cardNames;
module.exports = $918a127ba2ff3235$var$creditCardType;

});
parcelRegister("9kJDO", function(module, exports) {
"use strict";
var $6cb962b54adfe38e$var$cardTypes = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [
            4
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [
            [
                51,
                55
            ],
            [
                2221,
                2229
            ],
            [
                223,
                229
            ],
            [
                23,
                26
            ],
            [
                270,
                271
            ],
            2720
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [
            34,
            37
        ],
        gaps: [
            4,
            10
        ],
        lengths: [
            15
        ],
        code: {
            name: "CID",
            size: 4
        }
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [
            [
                300,
                305
            ],
            36,
            38,
            39
        ],
        gaps: [
            4,
            10
        ],
        lengths: [
            14,
            16,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [
            6011,
            [
                644,
                649
            ],
            65
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            19
        ],
        code: {
            name: "CID",
            size: 3
        }
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [
            2131,
            1800,
            [
                3528,
                3589
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [
            620,
            [
                624,
                626
            ],
            [
                62100,
                62182
            ],
            [
                62184,
                62187
            ],
            [
                62185,
                62197
            ],
            [
                62200,
                62205
            ],
            [
                622010,
                622999
            ],
            622018,
            [
                622019,
                622999
            ],
            [
                62207,
                62209
            ],
            [
                622126,
                622925
            ],
            [
                623,
                626
            ],
            6270,
            6272,
            6276,
            [
                627700,
                627779
            ],
            [
                627781,
                627799
            ],
            [
                6282,
                6289
            ],
            6291,
            6292,
            810,
            [
                8110,
                8131
            ],
            [
                8132,
                8151
            ],
            [
                8152,
                8163
            ],
            [
                8164,
                8171
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            14,
            15,
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVN",
            size: 3
        }
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [
            493698,
            [
                500000,
                504174
            ],
            [
                504176,
                506698
            ],
            [
                506779,
                508999
            ],
            [
                56,
                59
            ],
            63,
            67,
            6
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [
            401178,
            401179,
            438935,
            457631,
            457632,
            431274,
            451416,
            457393,
            504175,
            [
                506699,
                506778
            ],
            [
                509000,
                509999
            ],
            627780,
            636297,
            636368,
            [
                650031,
                650033
            ],
            [
                650035,
                650051
            ],
            [
                650405,
                650439
            ],
            [
                650485,
                650538
            ],
            [
                650541,
                650598
            ],
            [
                650700,
                650718
            ],
            [
                650720,
                650727
            ],
            [
                650901,
                650978
            ],
            [
                651652,
                651679
            ],
            [
                655000,
                655019
            ],
            [
                655021,
                655058
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVE",
            size: 3
        }
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [
            [
                2200,
                2204
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVP2",
            size: 3
        }
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [
            637095,
            63737423,
            63743358,
            637568,
            637599,
            637609,
            637612
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [
            606282
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    }
};
module.exports = $6cb962b54adfe38e$var$cardTypes;

});

parcelRegister("gGVh9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addMatchingCardsToResults = void 0;

var $lwcK5 = parcelRequire("lwcK5");

var $zRnhs = parcelRequire("zRnhs");
function $c26cff5458eec680$var$addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for(i = 0; i < cardConfiguration.patterns.length; i++){
        var pattern = cardConfiguration.patterns[i];
        if (!$zRnhs.matches(cardNumber, pattern)) continue;
        var clonedCardConfiguration = $lwcK5.clone(cardConfiguration);
        if (Array.isArray(pattern)) patternLength = String(pattern[0]).length;
        else patternLength = String(pattern).length;
        if (cardNumber.length >= patternLength) clonedCardConfiguration.matchStrength = patternLength;
        results.push(clonedCardConfiguration);
        break;
    }
}
module.exports.addMatchingCardsToResults = $c26cff5458eec680$var$addMatchingCardsToResults;

});
parcelRegister("lwcK5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = void 0;
function $faa6788030aced86$var$clone(originalObject) {
    if (!originalObject) return null;
    return JSON.parse(JSON.stringify(originalObject));
}
module.exports.clone = $faa6788030aced86$var$clone;

});

parcelRegister("zRnhs", function(module, exports) {
"use strict";
/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.matches = void 0;
function $06bcac0fac75ce99$var$matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}
function $06bcac0fac75ce99$var$matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}
function $06bcac0fac75ce99$var$matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) return $06bcac0fac75ce99$var$matchesRange(cardNumber, pattern[0], pattern[1]);
    return $06bcac0fac75ce99$var$matchesPattern(cardNumber, pattern);
}
module.exports.matches = $06bcac0fac75ce99$var$matches;

});


parcelRegister("cpf5X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidInputType = void 0;
function $908387685d049d7e$var$isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
module.exports.isValidInputType = $908387685d049d7e$var$isValidInputType;

});

parcelRegister("aoUIw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findBestMatch = void 0;
function $7928241bc10d85ef$var$hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function(result) {
        return result.matchStrength;
    }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */ return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
}
function $7928241bc10d85ef$var$findBestMatch(results) {
    if (!$7928241bc10d85ef$var$hasEnoughResultsToDetermineBestMatch(results)) return null;
    return results.reduce(function(bestMatch, result) {
        if (!bestMatch) return result;
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */ if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) return result;
        return bestMatch;
    });
}
module.exports.findBestMatch = $7928241bc10d85ef$var$findBestMatch;

});


parcelRegister("i3sxR", function(module, exports) {


module.exports = (parcelRequire("goo3h"))((parcelRequire("6jbMY")).resolve("9X5QH")).then(function() {
    return parcelRequire("7cfD3");
});

});
parcelRegister("goo3h", function(module, exports) {
"use strict";

var $1puqr = parcelRequire("1puqr");
module.exports = $1puqr(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("1puqr", function(module, exports) {
"use strict";
var $106fba1aa0f43298$var$cachedBundles = {};
var $106fba1aa0f43298$var$cachedPreloads = {};
var $106fba1aa0f43298$var$cachedPrefetches = {};
function $106fba1aa0f43298$var$getCache(type) {
    switch(type){
        case "preload":
            return $106fba1aa0f43298$var$cachedPreloads;
        case "prefetch":
            return $106fba1aa0f43298$var$cachedPrefetches;
        default:
            return $106fba1aa0f43298$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $106fba1aa0f43298$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("b8Qo5", function(module, exports) {


module.exports = (parcelRequire("goo3h"))((parcelRequire("6jbMY")).resolve("1GR46")).then(function() {
    return parcelRequire("1BgTA");
});

});

var $1e34b019401d5b45$exports = {};


(parcelRequire("6jbMY")).register((parcelRequire("84ov9")).getBundleURL("cFmZx"), JSON.parse('["cFmZx","index.js","9X5QH","intl-tel-input.74b54d71.js","1GR46","utils.851f02d3.js"]'));

function $3ccd832df3dc4d34$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $3ccd832df3dc4d34$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $3ccd832df3dc4d34$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $3ccd832df3dc4d34$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $fvacx = parcelRequire("fvacx");

var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $3F6om = parcelRequire("3F6om");

var $33z5g = parcelRequire("33z5g");


var $fvacx = parcelRequire("fvacx");

var $e2Ogy = parcelRequire("e2Ogy");

var $33z5g = parcelRequire("33z5g");

var $3F6om = parcelRequire("3F6om");

var $iHOCm = parcelRequire("iHOCm");
"use strict";
function $3d0caa012eb8204d$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $25f106ae2f1f1b82$exports = {};
// shim for using process in browser
var $25f106ae2f1f1b82$var$process = $25f106ae2f1f1b82$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $25f106ae2f1f1b82$var$cachedSetTimeout;
var $25f106ae2f1f1b82$var$cachedClearTimeout;
function $25f106ae2f1f1b82$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $25f106ae2f1f1b82$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $25f106ae2f1f1b82$var$cachedSetTimeout = setTimeout;
        else $25f106ae2f1f1b82$var$cachedSetTimeout = $25f106ae2f1f1b82$var$defaultSetTimout;
    } catch (e) {
        $25f106ae2f1f1b82$var$cachedSetTimeout = $25f106ae2f1f1b82$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $25f106ae2f1f1b82$var$cachedClearTimeout = clearTimeout;
        else $25f106ae2f1f1b82$var$cachedClearTimeout = $25f106ae2f1f1b82$var$defaultClearTimeout;
    } catch (e) {
        $25f106ae2f1f1b82$var$cachedClearTimeout = $25f106ae2f1f1b82$var$defaultClearTimeout;
    }
})();
function $25f106ae2f1f1b82$var$runTimeout(fun) {
    if ($25f106ae2f1f1b82$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($25f106ae2f1f1b82$var$cachedSetTimeout === $25f106ae2f1f1b82$var$defaultSetTimout || !$25f106ae2f1f1b82$var$cachedSetTimeout) && setTimeout) {
        $25f106ae2f1f1b82$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $25f106ae2f1f1b82$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $25f106ae2f1f1b82$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $25f106ae2f1f1b82$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $25f106ae2f1f1b82$var$runClearTimeout(marker) {
    if ($25f106ae2f1f1b82$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($25f106ae2f1f1b82$var$cachedClearTimeout === $25f106ae2f1f1b82$var$defaultClearTimeout || !$25f106ae2f1f1b82$var$cachedClearTimeout) && clearTimeout) {
        $25f106ae2f1f1b82$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $25f106ae2f1f1b82$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $25f106ae2f1f1b82$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $25f106ae2f1f1b82$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $25f106ae2f1f1b82$var$queue = [];
var $25f106ae2f1f1b82$var$draining = false;
var $25f106ae2f1f1b82$var$currentQueue;
var $25f106ae2f1f1b82$var$queueIndex = -1;
function $25f106ae2f1f1b82$var$cleanUpNextTick() {
    if (!$25f106ae2f1f1b82$var$draining || !$25f106ae2f1f1b82$var$currentQueue) return;
    $25f106ae2f1f1b82$var$draining = false;
    if ($25f106ae2f1f1b82$var$currentQueue.length) $25f106ae2f1f1b82$var$queue = $25f106ae2f1f1b82$var$currentQueue.concat($25f106ae2f1f1b82$var$queue);
    else $25f106ae2f1f1b82$var$queueIndex = -1;
    if ($25f106ae2f1f1b82$var$queue.length) $25f106ae2f1f1b82$var$drainQueue();
}
function $25f106ae2f1f1b82$var$drainQueue() {
    if ($25f106ae2f1f1b82$var$draining) return;
    var timeout = $25f106ae2f1f1b82$var$runTimeout($25f106ae2f1f1b82$var$cleanUpNextTick);
    $25f106ae2f1f1b82$var$draining = true;
    var len = $25f106ae2f1f1b82$var$queue.length;
    while(len){
        $25f106ae2f1f1b82$var$currentQueue = $25f106ae2f1f1b82$var$queue;
        $25f106ae2f1f1b82$var$queue = [];
        while(++$25f106ae2f1f1b82$var$queueIndex < len)if ($25f106ae2f1f1b82$var$currentQueue) $25f106ae2f1f1b82$var$currentQueue[$25f106ae2f1f1b82$var$queueIndex].run();
        $25f106ae2f1f1b82$var$queueIndex = -1;
        len = $25f106ae2f1f1b82$var$queue.length;
    }
    $25f106ae2f1f1b82$var$currentQueue = null;
    $25f106ae2f1f1b82$var$draining = false;
    $25f106ae2f1f1b82$var$runClearTimeout(timeout);
}
$25f106ae2f1f1b82$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $25f106ae2f1f1b82$var$queue.push(new $25f106ae2f1f1b82$var$Item(fun, args));
    if ($25f106ae2f1f1b82$var$queue.length === 1 && !$25f106ae2f1f1b82$var$draining) $25f106ae2f1f1b82$var$runTimeout($25f106ae2f1f1b82$var$drainQueue);
};
// v8 likes predictible objects
function $25f106ae2f1f1b82$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$25f106ae2f1f1b82$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$25f106ae2f1f1b82$var$process.title = "browser";
$25f106ae2f1f1b82$var$process.browser = true;
$25f106ae2f1f1b82$var$process.env = {};
$25f106ae2f1f1b82$var$process.argv = [];
$25f106ae2f1f1b82$var$process.version = ""; // empty string to avoid regexp issues
$25f106ae2f1f1b82$var$process.versions = {};
function $25f106ae2f1f1b82$var$noop() {}
$25f106ae2f1f1b82$var$process.on = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.addListener = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.once = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.off = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.removeListener = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.removeAllListeners = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.emit = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.prependListener = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.prependOnceListener = $25f106ae2f1f1b82$var$noop;
$25f106ae2f1f1b82$var$process.listeners = function(name) {
    return [];
};
$25f106ae2f1f1b82$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$25f106ae2f1f1b82$var$process.cwd = function() {
    return "/";
};
$25f106ae2f1f1b82$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$25f106ae2f1f1b82$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
var $fb882fc60a9cef2f$var$toString = Object.prototype.toString;
var $fb882fc60a9cef2f$var$getPrototypeOf = Object.getPrototypeOf;
var $fb882fc60a9cef2f$var$kindOf = function(cache) {
    return function(thing) {
        var str = $fb882fc60a9cef2f$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $fb882fc60a9cef2f$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $fb882fc60a9cef2f$var$kindOf(thing) === type;
    };
};
var $fb882fc60a9cef2f$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $iHOCm._)(thing)) === type;
    };
};
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $fb882fc60a9cef2f$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $fb882fc60a9cef2f$var$isUndefined = $fb882fc60a9cef2f$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $fb882fc60a9cef2f$var$isBuffer(val) {
    return val !== null && !$fb882fc60a9cef2f$var$isUndefined(val) && val.constructor !== null && !$fb882fc60a9cef2f$var$isUndefined(val.constructor) && $fb882fc60a9cef2f$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $fb882fc60a9cef2f$var$isArrayBuffer = $fb882fc60a9cef2f$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $fb882fc60a9cef2f$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $fb882fc60a9cef2f$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $fb882fc60a9cef2f$var$isString = $fb882fc60a9cef2f$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $fb882fc60a9cef2f$var$isFunction = $fb882fc60a9cef2f$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $fb882fc60a9cef2f$var$isNumber = $fb882fc60a9cef2f$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $fb882fc60a9cef2f$var$isObject = function(thing) {
    return thing !== null && typeof thing === "object";
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $fb882fc60a9cef2f$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $fb882fc60a9cef2f$var$isPlainObject = function(val) {
    if ($fb882fc60a9cef2f$var$kindOf(val) !== "object") return false;
    var prototype = $fb882fc60a9cef2f$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $fb882fc60a9cef2f$var$isDate = $fb882fc60a9cef2f$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $fb882fc60a9cef2f$var$isFile = $fb882fc60a9cef2f$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $fb882fc60a9cef2f$var$isBlob = $fb882fc60a9cef2f$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $fb882fc60a9cef2f$var$isFileList = $fb882fc60a9cef2f$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $fb882fc60a9cef2f$var$isStream = function(val) {
    return $fb882fc60a9cef2f$var$isObject(val) && $fb882fc60a9cef2f$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ var $fb882fc60a9cef2f$var$isFormData = function(thing) {
    var kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $fb882fc60a9cef2f$var$isFunction(thing.append) && ((kind = $fb882fc60a9cef2f$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $fb882fc60a9cef2f$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $fb882fc60a9cef2f$var$isURLSearchParams = $fb882fc60a9cef2f$var$kindOfTest("URLSearchParams");
var $fb882fc60a9cef2f$var$_map = (0, $3F6om._)([
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($fb882fc60a9cef2f$var$kindOfTest), 4), $fb882fc60a9cef2f$var$isReadableStream = $fb882fc60a9cef2f$var$_map[0], $fb882fc60a9cef2f$var$isRequest = $fb882fc60a9cef2f$var$_map[1], $fb882fc60a9cef2f$var$isResponse = $fb882fc60a9cef2f$var$_map[2], $fb882fc60a9cef2f$var$isHeaders = $fb882fc60a9cef2f$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $fb882fc60a9cef2f$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $fb882fc60a9cef2f$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    var i;
    var l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($fb882fc60a9cef2f$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $fb882fc60a9cef2f$var$findKey(obj, key) {
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $fb882fc60a9cef2f$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
}();
var $fb882fc60a9cef2f$var$isContextDefined = function(context) {
    return !$fb882fc60a9cef2f$var$isUndefined(context) && context !== $fb882fc60a9cef2f$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $fb882fc60a9cef2f$var$merge() {
    var caseless = ($fb882fc60a9cef2f$var$isContextDefined(this) && this || {}).caseless;
    var result = {};
    var assignValue = function(val, key) {
        var targetKey = caseless && $fb882fc60a9cef2f$var$findKey(result, key) || key;
        if ($fb882fc60a9cef2f$var$isPlainObject(result[targetKey]) && $fb882fc60a9cef2f$var$isPlainObject(val)) result[targetKey] = $fb882fc60a9cef2f$var$merge(result[targetKey], val);
        else if ($fb882fc60a9cef2f$var$isPlainObject(val)) result[targetKey] = $fb882fc60a9cef2f$var$merge({}, val);
        else if ($fb882fc60a9cef2f$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(var i = 0, l = arguments.length; i < l; i++)arguments[i] && $fb882fc60a9cef2f$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $fb882fc60a9cef2f$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $fb882fc60a9cef2f$var$forEach(b, function(val, key) {
        if (thisArg && $fb882fc60a9cef2f$var$isFunction(val)) a[key] = (0, $3d0caa012eb8204d$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $fb882fc60a9cef2f$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $fb882fc60a9cef2f$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $fb882fc60a9cef2f$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $fb882fc60a9cef2f$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $fb882fc60a9cef2f$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $fb882fc60a9cef2f$var$toArray = function(thing) {
    if (!thing) return null;
    if ($fb882fc60a9cef2f$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$fb882fc60a9cef2f$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $fb882fc60a9cef2f$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && $fb882fc60a9cef2f$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $fb882fc60a9cef2f$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $fb882fc60a9cef2f$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $fb882fc60a9cef2f$var$isHTMLForm = $fb882fc60a9cef2f$var$kindOfTest("HTMLFormElement");
var $fb882fc60a9cef2f$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var $fb882fc60a9cef2f$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $fb882fc60a9cef2f$var$isRegExp = $fb882fc60a9cef2f$var$kindOfTest("RegExp");
var $fb882fc60a9cef2f$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $fb882fc60a9cef2f$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $fb882fc60a9cef2f$var$freezeMethods = function(obj) {
    $fb882fc60a9cef2f$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($fb882fc60a9cef2f$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        var value = obj[name];
        if (!$fb882fc60a9cef2f$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
var $fb882fc60a9cef2f$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $fb882fc60a9cef2f$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $fb882fc60a9cef2f$var$noop = function() {};
var $fb882fc60a9cef2f$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
var $fb882fc60a9cef2f$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
var $fb882fc60a9cef2f$var$DIGIT = "0123456789";
var $fb882fc60a9cef2f$var$ALPHABET = {
    DIGIT: $fb882fc60a9cef2f$var$DIGIT,
    ALPHA: $fb882fc60a9cef2f$var$ALPHA,
    ALPHA_DIGIT: $fb882fc60a9cef2f$var$ALPHA + $fb882fc60a9cef2f$var$ALPHA.toUpperCase() + $fb882fc60a9cef2f$var$DIGIT
};
var $fb882fc60a9cef2f$var$generateString = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16, alphabet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fb882fc60a9cef2f$var$ALPHABET.ALPHA_DIGIT;
    var str = "";
    var length = alphabet.length;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $fb882fc60a9cef2f$var$isSpecCompliantForm(thing) {
    return !!(thing && $fb882fc60a9cef2f$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
var $fb882fc60a9cef2f$var$toJSONObject = function(obj) {
    var stack = new Array(10);
    var visit = function(source, i) {
        if ($fb882fc60a9cef2f$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                var target = $fb882fc60a9cef2f$var$isArray(source) ? [] : {};
                $fb882fc60a9cef2f$var$forEach(source, function(value, key) {
                    var reducedValue = visit(value, i + 1);
                    !$fb882fc60a9cef2f$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $fb882fc60a9cef2f$var$isAsyncFn = $fb882fc60a9cef2f$var$kindOfTest("AsyncFunction");
var $fb882fc60a9cef2f$var$isThenable = function(thing) {
    return thing && ($fb882fc60a9cef2f$var$isObject(thing) || $fb882fc60a9cef2f$var$isFunction(thing)) && $fb882fc60a9cef2f$var$isFunction(thing.then) && $fb882fc60a9cef2f$var$isFunction(thing["catch"]);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
var $fb882fc60a9cef2f$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $fb882fc60a9cef2f$var$_global.addEventListener("message", function(param) {
            var source = param.source, data = param.data;
            if (source === $fb882fc60a9cef2f$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $fb882fc60a9cef2f$var$_global.postMessage(token, "*");
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === "function", $fb882fc60a9cef2f$var$isFunction($fb882fc60a9cef2f$var$_global.postMessage));
var $fb882fc60a9cef2f$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($fb882fc60a9cef2f$var$_global) : typeof $25f106ae2f1f1b82$exports !== "undefined" && $25f106ae2f1f1b82$exports.nextTick || $fb882fc60a9cef2f$var$_setImmediate;
var // *********************
$fb882fc60a9cef2f$export$2e2bcd8739ae039 = {
    isArray: $fb882fc60a9cef2f$var$isArray,
    isArrayBuffer: $fb882fc60a9cef2f$var$isArrayBuffer,
    isBuffer: $fb882fc60a9cef2f$var$isBuffer,
    isFormData: $fb882fc60a9cef2f$var$isFormData,
    isArrayBufferView: $fb882fc60a9cef2f$var$isArrayBufferView,
    isString: $fb882fc60a9cef2f$var$isString,
    isNumber: $fb882fc60a9cef2f$var$isNumber,
    isBoolean: $fb882fc60a9cef2f$var$isBoolean,
    isObject: $fb882fc60a9cef2f$var$isObject,
    isPlainObject: $fb882fc60a9cef2f$var$isPlainObject,
    isReadableStream: $fb882fc60a9cef2f$var$isReadableStream,
    isRequest: $fb882fc60a9cef2f$var$isRequest,
    isResponse: $fb882fc60a9cef2f$var$isResponse,
    isHeaders: $fb882fc60a9cef2f$var$isHeaders,
    isUndefined: $fb882fc60a9cef2f$var$isUndefined,
    isDate: $fb882fc60a9cef2f$var$isDate,
    isFile: $fb882fc60a9cef2f$var$isFile,
    isBlob: $fb882fc60a9cef2f$var$isBlob,
    isRegExp: $fb882fc60a9cef2f$var$isRegExp,
    isFunction: $fb882fc60a9cef2f$var$isFunction,
    isStream: $fb882fc60a9cef2f$var$isStream,
    isURLSearchParams: $fb882fc60a9cef2f$var$isURLSearchParams,
    isTypedArray: $fb882fc60a9cef2f$var$isTypedArray,
    isFileList: $fb882fc60a9cef2f$var$isFileList,
    forEach: $fb882fc60a9cef2f$var$forEach,
    merge: $fb882fc60a9cef2f$var$merge,
    extend: $fb882fc60a9cef2f$var$extend,
    trim: $fb882fc60a9cef2f$var$trim,
    stripBOM: $fb882fc60a9cef2f$var$stripBOM,
    inherits: $fb882fc60a9cef2f$var$inherits,
    toFlatObject: $fb882fc60a9cef2f$var$toFlatObject,
    kindOf: $fb882fc60a9cef2f$var$kindOf,
    kindOfTest: $fb882fc60a9cef2f$var$kindOfTest,
    endsWith: $fb882fc60a9cef2f$var$endsWith,
    toArray: $fb882fc60a9cef2f$var$toArray,
    forEachEntry: $fb882fc60a9cef2f$var$forEachEntry,
    matchAll: $fb882fc60a9cef2f$var$matchAll,
    isHTMLForm: $fb882fc60a9cef2f$var$isHTMLForm,
    hasOwnProperty: $fb882fc60a9cef2f$var$hasOwnProperty,
    hasOwnProp: $fb882fc60a9cef2f$var$hasOwnProperty,
    reduceDescriptors: $fb882fc60a9cef2f$var$reduceDescriptors,
    freezeMethods: $fb882fc60a9cef2f$var$freezeMethods,
    toObjectSet: $fb882fc60a9cef2f$var$toObjectSet,
    toCamelCase: $fb882fc60a9cef2f$var$toCamelCase,
    noop: $fb882fc60a9cef2f$var$noop,
    toFiniteNumber: $fb882fc60a9cef2f$var$toFiniteNumber,
    findKey: $fb882fc60a9cef2f$var$findKey,
    global: $fb882fc60a9cef2f$var$_global,
    isContextDefined: $fb882fc60a9cef2f$var$isContextDefined,
    ALPHABET: $fb882fc60a9cef2f$var$ALPHABET,
    generateString: $fb882fc60a9cef2f$var$generateString,
    isSpecCompliantForm: $fb882fc60a9cef2f$var$isSpecCompliantForm,
    toJSONObject: $fb882fc60a9cef2f$var$toJSONObject,
    isAsyncFn: $fb882fc60a9cef2f$var$isAsyncFn,
    isThenable: $fb882fc60a9cef2f$var$isThenable,
    setImmediate: $fb882fc60a9cef2f$var$_setImmediate,
    asap: $fb882fc60a9cef2f$var$asap
};





var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $33z5g = parcelRequire("33z5g");




"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $32604bf3eba12907$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).inherits($32604bf3eba12907$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
var $32604bf3eba12907$var$prototype = $32604bf3eba12907$var$AxiosError.prototype;
var $32604bf3eba12907$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach(function(code) {
    $32604bf3eba12907$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($32604bf3eba12907$var$AxiosError, $32604bf3eba12907$var$descriptors);
Object.defineProperty($32604bf3eba12907$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$32604bf3eba12907$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($32604bf3eba12907$var$prototype);
    (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, function(prop) {
        return prop !== "isAxiosError";
    });
    $32604bf3eba12907$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $32604bf3eba12907$export$2e2bcd8739ae039 = $32604bf3eba12907$var$AxiosError;


// eslint-disable-next-line strict
var $58c127046c689796$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $4iNIH = parcelRequire("4iNIH");

var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $37wUF = parcelRequire("37wUF");

var $iHOCm = parcelRequire("iHOCm");

var $4pNo8 = parcelRequire("4pNo8");
var $8fd3fe1a1a12d4b2$export$a143d493d941bafc;
var $8fd3fe1a1a12d4b2$export$e4cf37d7f6fb9e0a;
var $8fd3fe1a1a12d4b2$export$f99ded8fe4b79145;
var $8fd3fe1a1a12d4b2$export$599f31c3813fae4d;
"use strict";
var $69fd196979dd1dd7$export$a48f0734ac7c2329;
var $69fd196979dd1dd7$export$d622b2ad8d90c771;
var $69fd196979dd1dd7$export$6100ba28696e12de;
"use strict";
$69fd196979dd1dd7$export$a48f0734ac7c2329 = $69fd196979dd1dd7$var$byteLength;
$69fd196979dd1dd7$export$d622b2ad8d90c771 = $69fd196979dd1dd7$var$toByteArray;
$69fd196979dd1dd7$export$6100ba28696e12de = $69fd196979dd1dd7$var$fromByteArray;
var $69fd196979dd1dd7$var$lookup = [];
var $69fd196979dd1dd7$var$revLookup = [];
var $69fd196979dd1dd7$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $69fd196979dd1dd7$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $69fd196979dd1dd7$var$i = 0, $69fd196979dd1dd7$var$len = $69fd196979dd1dd7$var$code.length; $69fd196979dd1dd7$var$i < $69fd196979dd1dd7$var$len; ++$69fd196979dd1dd7$var$i){
    $69fd196979dd1dd7$var$lookup[$69fd196979dd1dd7$var$i] = $69fd196979dd1dd7$var$code[$69fd196979dd1dd7$var$i];
    $69fd196979dd1dd7$var$revLookup[$69fd196979dd1dd7$var$code.charCodeAt($69fd196979dd1dd7$var$i)] = $69fd196979dd1dd7$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$69fd196979dd1dd7$var$revLookup["-".charCodeAt(0)] = 62;
$69fd196979dd1dd7$var$revLookup["_".charCodeAt(0)] = 63;
function $69fd196979dd1dd7$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $69fd196979dd1dd7$var$byteLength(b64) {
    var lens = $69fd196979dd1dd7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $69fd196979dd1dd7$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $69fd196979dd1dd7$var$toByteArray(b64) {
    var tmp;
    var lens = $69fd196979dd1dd7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $69fd196979dd1dd7$var$Arr($69fd196979dd1dd7$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i)] << 18 | $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i)] << 2 | $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i)] << 10 | $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $69fd196979dd1dd7$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $69fd196979dd1dd7$var$tripletToBase64(num) {
    return $69fd196979dd1dd7$var$lookup[num >> 18 & 0x3F] + $69fd196979dd1dd7$var$lookup[num >> 12 & 0x3F] + $69fd196979dd1dd7$var$lookup[num >> 6 & 0x3F] + $69fd196979dd1dd7$var$lookup[num & 0x3F];
}
function $69fd196979dd1dd7$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($69fd196979dd1dd7$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $69fd196979dd1dd7$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($69fd196979dd1dd7$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($69fd196979dd1dd7$var$lookup[tmp >> 2] + $69fd196979dd1dd7$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($69fd196979dd1dd7$var$lookup[tmp >> 10] + $69fd196979dd1dd7$var$lookup[tmp >> 4 & 0x3F] + $69fd196979dd1dd7$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $cf4c97038d8c09fb$export$aafa59e2e03f2942;
var $cf4c97038d8c09fb$export$68d8715fc104d294;
$cf4c97038d8c09fb$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$cf4c97038d8c09fb$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $8fd3fe1a1a12d4b2$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8fd3fe1a1a12d4b2$export$a143d493d941bafc = $8fd3fe1a1a12d4b2$var$Buffer;
$8fd3fe1a1a12d4b2$export$e4cf37d7f6fb9e0a = $8fd3fe1a1a12d4b2$var$SlowBuffer;
$8fd3fe1a1a12d4b2$export$f99ded8fe4b79145 = 50;
var $8fd3fe1a1a12d4b2$var$K_MAX_LENGTH = 0x7fffffff;
$8fd3fe1a1a12d4b2$export$599f31c3813fae4d = $8fd3fe1a1a12d4b2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8fd3fe1a1a12d4b2$var$Buffer.TYPED_ARRAY_SUPPORT = $8fd3fe1a1a12d4b2$var$typedArraySupport();
if (!$8fd3fe1a1a12d4b2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8fd3fe1a1a12d4b2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8fd3fe1a1a12d4b2$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8fd3fe1a1a12d4b2$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8fd3fe1a1a12d4b2$var$createBuffer(length) {
    if (length > $8fd3fe1a1a12d4b2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8fd3fe1a1a12d4b2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8fd3fe1a1a12d4b2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8fd3fe1a1a12d4b2$var$allocUnsafe(arg);
    }
    return $8fd3fe1a1a12d4b2$var$from(arg, encodingOrOffset, length);
}
$8fd3fe1a1a12d4b2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8fd3fe1a1a12d4b2$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8fd3fe1a1a12d4b2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8fd3fe1a1a12d4b2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $iHOCm._)(value)));
    if ($8fd3fe1a1a12d4b2$var$isInstance(value, ArrayBuffer) || value && $8fd3fe1a1a12d4b2$var$isInstance(value.buffer, ArrayBuffer)) return $8fd3fe1a1a12d4b2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8fd3fe1a1a12d4b2$var$isInstance(value, SharedArrayBuffer) || value && $8fd3fe1a1a12d4b2$var$isInstance(value.buffer, SharedArrayBuffer))) return $8fd3fe1a1a12d4b2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8fd3fe1a1a12d4b2$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $8fd3fe1a1a12d4b2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8fd3fe1a1a12d4b2$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $iHOCm._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8fd3fe1a1a12d4b2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8fd3fe1a1a12d4b2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8fd3fe1a1a12d4b2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8fd3fe1a1a12d4b2$var$Buffer, Uint8Array);
function $8fd3fe1a1a12d4b2$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8fd3fe1a1a12d4b2$var$alloc(size, fill, encoding) {
    $8fd3fe1a1a12d4b2$var$assertSize(size);
    if (size <= 0) return $8fd3fe1a1a12d4b2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8fd3fe1a1a12d4b2$var$createBuffer(size).fill(fill, encoding) : $8fd3fe1a1a12d4b2$var$createBuffer(size).fill(fill);
    return $8fd3fe1a1a12d4b2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8fd3fe1a1a12d4b2$var$Buffer.alloc = function(size, fill, encoding) {
    return $8fd3fe1a1a12d4b2$var$alloc(size, fill, encoding);
};
function $8fd3fe1a1a12d4b2$var$allocUnsafe(size) {
    $8fd3fe1a1a12d4b2$var$assertSize(size);
    return $8fd3fe1a1a12d4b2$var$createBuffer(size < 0 ? 0 : $8fd3fe1a1a12d4b2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8fd3fe1a1a12d4b2$var$Buffer.allocUnsafe = function(size) {
    return $8fd3fe1a1a12d4b2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8fd3fe1a1a12d4b2$var$Buffer.allocUnsafeSlow = function(size) {
    return $8fd3fe1a1a12d4b2$var$allocUnsafe(size);
};
function $8fd3fe1a1a12d4b2$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8fd3fe1a1a12d4b2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $8fd3fe1a1a12d4b2$var$byteLength(string, encoding) | 0;
    var buf = $8fd3fe1a1a12d4b2$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8fd3fe1a1a12d4b2$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $8fd3fe1a1a12d4b2$var$checked(array.length) | 0;
    var buf = $8fd3fe1a1a12d4b2$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8fd3fe1a1a12d4b2$var$fromArrayView(arrayView) {
    if ($8fd3fe1a1a12d4b2$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $8fd3fe1a1a12d4b2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8fd3fe1a1a12d4b2$var$fromArrayLike(arrayView);
}
function $8fd3fe1a1a12d4b2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8fd3fe1a1a12d4b2$var$Buffer.prototype);
    return buf;
}
function $8fd3fe1a1a12d4b2$var$fromObject(obj) {
    if ($8fd3fe1a1a12d4b2$var$Buffer.isBuffer(obj)) {
        var len = $8fd3fe1a1a12d4b2$var$checked(obj.length) | 0;
        var buf = $8fd3fe1a1a12d4b2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8fd3fe1a1a12d4b2$var$numberIsNaN(obj.length)) return $8fd3fe1a1a12d4b2$var$createBuffer(0);
        return $8fd3fe1a1a12d4b2$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8fd3fe1a1a12d4b2$var$fromArrayLike(obj.data);
}
function $8fd3fe1a1a12d4b2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8fd3fe1a1a12d4b2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8fd3fe1a1a12d4b2$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8fd3fe1a1a12d4b2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8fd3fe1a1a12d4b2$var$Buffer.alloc(+length);
}
$8fd3fe1a1a12d4b2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8fd3fe1a1a12d4b2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8fd3fe1a1a12d4b2$var$Buffer.compare = function compare(a, b) {
    if ($8fd3fe1a1a12d4b2$var$isInstance(a, Uint8Array)) a = $8fd3fe1a1a12d4b2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8fd3fe1a1a12d4b2$var$isInstance(b, Uint8Array)) b = $8fd3fe1a1a12d4b2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(a) || !$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8fd3fe1a1a12d4b2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8fd3fe1a1a12d4b2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8fd3fe1a1a12d4b2$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $8fd3fe1a1a12d4b2$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($8fd3fe1a1a12d4b2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(buf)) buf = $8fd3fe1a1a12d4b2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8fd3fe1a1a12d4b2$var$byteLength(string, encoding) {
    if ($8fd3fe1a1a12d4b2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8fd3fe1a1a12d4b2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $iHOCm._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8fd3fe1a1a12d4b2$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8fd3fe1a1a12d4b2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8fd3fe1a1a12d4b2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8fd3fe1a1a12d4b2$var$Buffer.byteLength = $8fd3fe1a1a12d4b2$var$byteLength;
function $8fd3fe1a1a12d4b2$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8fd3fe1a1a12d4b2$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8fd3fe1a1a12d4b2$var$utf8Slice(this, start, end);
        case "ascii":
            return $8fd3fe1a1a12d4b2$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8fd3fe1a1a12d4b2$var$latin1Slice(this, start, end);
        case "base64":
            return $8fd3fe1a1a12d4b2$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8fd3fe1a1a12d4b2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8fd3fe1a1a12d4b2$var$Buffer.prototype._isBuffer = true;
function $8fd3fe1a1a12d4b2$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$8fd3fe1a1a12d4b2$var$swap(this, i, i + 1);
    return this;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $8fd3fe1a1a12d4b2$var$swap(this, i, i + 3);
        $8fd3fe1a1a12d4b2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $8fd3fe1a1a12d4b2$var$swap(this, i, i + 7);
        $8fd3fe1a1a12d4b2$var$swap(this, i + 1, i + 6);
        $8fd3fe1a1a12d4b2$var$swap(this, i + 2, i + 5);
        $8fd3fe1a1a12d4b2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8fd3fe1a1a12d4b2$var$utf8Slice(this, 0, length);
    return $8fd3fe1a1a12d4b2$var$slowToString.apply(this, arguments);
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.toLocaleString = $8fd3fe1a1a12d4b2$var$Buffer.prototype.toString;
$8fd3fe1a1a12d4b2$var$Buffer.prototype.equals = function equals(b) {
    if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8fd3fe1a1a12d4b2$var$Buffer.compare(this, b) === 0;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $8fd3fe1a1a12d4b2$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8fd3fe1a1a12d4b2$var$customInspectSymbol) $8fd3fe1a1a12d4b2$var$Buffer.prototype[$8fd3fe1a1a12d4b2$var$customInspectSymbol] = $8fd3fe1a1a12d4b2$var$Buffer.prototype.inspect;
$8fd3fe1a1a12d4b2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8fd3fe1a1a12d4b2$var$isInstance(target, Uint8Array)) target = $8fd3fe1a1a12d4b2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $iHOCm._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8fd3fe1a1a12d4b2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8fd3fe1a1a12d4b2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8fd3fe1a1a12d4b2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8fd3fe1a1a12d4b2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8fd3fe1a1a12d4b2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8fd3fe1a1a12d4b2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8fd3fe1a1a12d4b2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8fd3fe1a1a12d4b2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8fd3fe1a1a12d4b2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8fd3fe1a1a12d4b2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8fd3fe1a1a12d4b2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8fd3fe1a1a12d4b2$var$utf8Write(buf, string, offset, length) {
    return $8fd3fe1a1a12d4b2$var$blitBuffer($8fd3fe1a1a12d4b2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8fd3fe1a1a12d4b2$var$asciiWrite(buf, string, offset, length) {
    return $8fd3fe1a1a12d4b2$var$blitBuffer($8fd3fe1a1a12d4b2$var$asciiToBytes(string), buf, offset, length);
}
function $8fd3fe1a1a12d4b2$var$base64Write(buf, string, offset, length) {
    return $8fd3fe1a1a12d4b2$var$blitBuffer($8fd3fe1a1a12d4b2$var$base64ToBytes(string), buf, offset, length);
}
function $8fd3fe1a1a12d4b2$var$ucs2Write(buf, string, offset, length) {
    return $8fd3fe1a1a12d4b2$var$blitBuffer($8fd3fe1a1a12d4b2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8fd3fe1a1a12d4b2$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8fd3fe1a1a12d4b2$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8fd3fe1a1a12d4b2$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8fd3fe1a1a12d4b2$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8fd3fe1a1a12d4b2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8fd3fe1a1a12d4b2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $69fd196979dd1dd7$export$6100ba28696e12de(buf);
    else return $69fd196979dd1dd7$export$6100ba28696e12de(buf.slice(start, end));
}
function $8fd3fe1a1a12d4b2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8fd3fe1a1a12d4b2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $8fd3fe1a1a12d4b2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8fd3fe1a1a12d4b2$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $8fd3fe1a1a12d4b2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8fd3fe1a1a12d4b2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8fd3fe1a1a12d4b2$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8fd3fe1a1a12d4b2$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8fd3fe1a1a12d4b2$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $8fd3fe1a1a12d4b2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8fd3fe1a1a12d4b2$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8fd3fe1a1a12d4b2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8fd3fe1a1a12d4b2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readUintLE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readUintBE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readUint8 = $8fd3fe1a1a12d4b2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readUint16LE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readUint16BE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readUint32LE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readUint32BE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readBigUInt64LE = $8fd3fe1a1a12d4b2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8fd3fe1a1a12d4b2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $8fd3fe1a1a12d4b2$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readBigUInt64BE = $8fd3fe1a1a12d4b2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8fd3fe1a1a12d4b2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $8fd3fe1a1a12d4b2$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readBigInt64LE = $8fd3fe1a1a12d4b2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8fd3fe1a1a12d4b2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $8fd3fe1a1a12d4b2$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readBigInt64BE = $8fd3fe1a1a12d4b2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8fd3fe1a1a12d4b2$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $8fd3fe1a1a12d4b2$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 4, this.length);
    return $cf4c97038d8c09fb$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 4, this.length);
    return $cf4c97038d8c09fb$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 8, this.length);
    return $cf4c97038d8c09fb$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkOffset(offset, 8, this.length);
    return $cf4c97038d8c09fb$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $8fd3fe1a1a12d4b2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUintLE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUintBE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUint8 = $8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUint16LE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUint16BE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUint32LE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUint32BE = $8fd3fe1a1a12d4b2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8fd3fe1a1a12d4b2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8fd3fe1a1a12d4b2$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8fd3fe1a1a12d4b2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8fd3fe1a1a12d4b2$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeBigUInt64LE = $8fd3fe1a1a12d4b2$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $8fd3fe1a1a12d4b2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeBigUInt64BE = $8fd3fe1a1a12d4b2$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $8fd3fe1a1a12d4b2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeBigInt64LE = $8fd3fe1a1a12d4b2$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $8fd3fe1a1a12d4b2$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeBigInt64BE = $8fd3fe1a1a12d4b2$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $8fd3fe1a1a12d4b2$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $8fd3fe1a1a12d4b2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8fd3fe1a1a12d4b2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $cf4c97038d8c09fb$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8fd3fe1a1a12d4b2$var$writeFloat(this, value, offset, true, noAssert);
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8fd3fe1a1a12d4b2$var$writeFloat(this, value, offset, false, noAssert);
};
function $8fd3fe1a1a12d4b2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8fd3fe1a1a12d4b2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $cf4c97038d8c09fb$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8fd3fe1a1a12d4b2$var$writeDouble(this, value, offset, true, noAssert);
};
$8fd3fe1a1a12d4b2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8fd3fe1a1a12d4b2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8fd3fe1a1a12d4b2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8fd3fe1a1a12d4b2$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8fd3fe1a1a12d4b2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8fd3fe1a1a12d4b2$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $8fd3fe1a1a12d4b2$var$Buffer.isBuffer(val) ? val : $8fd3fe1a1a12d4b2$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $8fd3fe1a1a12d4b2$var$errors = {};
function $8fd3fe1a1a12d4b2$var$E(sym, getMessage, Base) {
    $8fd3fe1a1a12d4b2$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $37wUF._)(NodeError, Base);
        var _super = (0, $4pNo8._)(NodeError);
        function NodeError() {
            (0, $fvacx._)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $4iNIH._)(_this), "message", {
                value: getMessage.apply((0, $4iNIH._)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $3D4gQ._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$8fd3fe1a1a12d4b2$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$8fd3fe1a1a12d4b2$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $iHOCm._)(actual));
}, TypeError);
$8fd3fe1a1a12d4b2$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $8fd3fe1a1a12d4b2$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $iHOCm._)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $8fd3fe1a1a12d4b2$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $8fd3fe1a1a12d4b2$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $8fd3fe1a1a12d4b2$var$checkBounds(buf, offset, byteLength) {
    $8fd3fe1a1a12d4b2$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8fd3fe1a1a12d4b2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8fd3fe1a1a12d4b2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $iHOCm._)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $8fd3fe1a1a12d4b2$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $8fd3fe1a1a12d4b2$var$checkBounds(buf, offset, byteLength);
}
function $8fd3fe1a1a12d4b2$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $8fd3fe1a1a12d4b2$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $8fd3fe1a1a12d4b2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8fd3fe1a1a12d4b2$var$validateNumber(value, type);
        throw new $8fd3fe1a1a12d4b2$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $8fd3fe1a1a12d4b2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8fd3fe1a1a12d4b2$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $8fd3fe1a1a12d4b2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8fd3fe1a1a12d4b2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8fd3fe1a1a12d4b2$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8fd3fe1a1a12d4b2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8fd3fe1a1a12d4b2$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8fd3fe1a1a12d4b2$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8fd3fe1a1a12d4b2$var$base64ToBytes(str) {
    return $69fd196979dd1dd7$export$d622b2ad8d90c771($8fd3fe1a1a12d4b2$var$base64clean(str));
}
function $8fd3fe1a1a12d4b2$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8fd3fe1a1a12d4b2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8fd3fe1a1a12d4b2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $8fd3fe1a1a12d4b2$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8fd3fe1a1a12d4b2$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $8fd3fe1a1a12d4b2$var$BufferBigIntNotDefined : fn;
}
function $8fd3fe1a1a12d4b2$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $d6d050533c0dcf50$require$Buffer = $8fd3fe1a1a12d4b2$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $d6d050533c0dcf50$var$isVisitable(thing) {
    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $d6d050533c0dcf50$var$removeBrackets(key) {
    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $d6d050533c0dcf50$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d6d050533c0dcf50$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $d6d050533c0dcf50$var$isFlatArray(arr) {
    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(arr) && !arr.some($d6d050533c0dcf50$var$isVisitable);
}
var $d6d050533c0dcf50$var$predicates = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toFlatObject((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $d6d050533c0dcf50$var$toFormData(obj, formData, options) {
    if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $58c127046c689796$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    var useBlob = _Blob && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $d6d050533c0dcf50$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(value) && $d6d050533c0dcf50$var$isFlatArray(value) || ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFileList(value) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d6d050533c0dcf50$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d6d050533c0dcf50$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($d6d050533c0dcf50$var$isVisitable(value)) return true;
        formData.append($d6d050533c0dcf50$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var stack = [];
    var exposedHelpers = Object.assign($d6d050533c0dcf50$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d6d050533c0dcf50$var$isVisitable
    });
    function build(value, path) {
        if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            var result = !((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $d6d050533c0dcf50$export$2e2bcd8739ae039 = $d6d050533c0dcf50$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $7a2380b458170241$var$encode(str) {
    var charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $7a2380b458170241$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $d6d050533c0dcf50$export$2e2bcd8739ae039)(params, this, options);
}
var $7a2380b458170241$var$prototype = $7a2380b458170241$var$AxiosURLSearchParams.prototype;
$7a2380b458170241$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$7a2380b458170241$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $7a2380b458170241$var$encode);
    } : $7a2380b458170241$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $7a2380b458170241$export$2e2bcd8739ae039 = $7a2380b458170241$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $120394699f31bec2$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $120394699f31bec2$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var _encode = options && options.encode || $120394699f31bec2$var$encode;
    var serializeFn = options && options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $7a2380b458170241$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

"use strict";
var $1435996e915cfb96$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $fvacx._)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, $3D4gQ._)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
var $1435996e915cfb96$export$2e2bcd8739ae039 = $1435996e915cfb96$var$InterceptorManager;





"use strict";
var $539cfb2eff172381$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






var $e2Ogy = parcelRequire("e2Ogy");

"use strict";
var $72eba12c7e2c151a$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $7a2380b458170241$export$2e2bcd8739ae039);


"use strict";
var $3416a3eae50258cd$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $a08fe0a098537980$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $a99870243368291c$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $72eba12c7e2c151a$export$2e2bcd8739ae039),
        FormData: (0, $3416a3eae50258cd$export$2e2bcd8739ae039),
        Blob: (0, $a08fe0a098537980$export$2e2bcd8739ae039)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $f17bc3f7e607e757$exports = {};

$parcel$export($f17bc3f7e607e757$exports, "hasBrowserEnv", function () { return $f17bc3f7e607e757$export$c4996c4b7b93b0bf; });
$parcel$export($f17bc3f7e607e757$exports, "navigator", function () { return $f17bc3f7e607e757$export$ec7c8efa7f5790ae; });
$parcel$export($f17bc3f7e607e757$exports, "hasStandardBrowserEnv", function () { return $f17bc3f7e607e757$export$c0bcc9250309d66; });
$parcel$export($f17bc3f7e607e757$exports, "hasStandardBrowserWebWorkerEnv", function () { return $f17bc3f7e607e757$export$c81692cf5af97dac; });
$parcel$export($f17bc3f7e607e757$exports, "origin", function () { return $f17bc3f7e607e757$export$f710a83a91838a36; });
var $f17bc3f7e607e757$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
var $f17bc3f7e607e757$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $f17bc3f7e607e757$export$c0bcc9250309d66 = $f17bc3f7e607e757$export$c4996c4b7b93b0bf && (!$f17bc3f7e607e757$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($f17bc3f7e607e757$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $f17bc3f7e607e757$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
}();
var $f17bc3f7e607e757$export$f710a83a91838a36 = $f17bc3f7e607e757$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $9ab2e02cabae72e0$export$2e2bcd8739ae039 = (0, $e2Ogy._)({}, $f17bc3f7e607e757$exports, (0, $a99870243368291c$export$2e2bcd8739ae039));


"use strict";
function $72f2475fd6c4d469$export$2e2bcd8739ae039(data, options) {
    return (0, $d6d050533c0dcf50$export$2e2bcd8739ae039)(data, new (0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).isNode && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $aba21a951af61e2a$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $aba21a951af61e2a$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $aba21a951af61e2a$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === "__proto__") return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $aba21a951af61e2a$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFormData(formData) && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        var obj = {};
        (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEachEntry(formData, function(name, value) {
            buildPath($aba21a951af61e2a$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $aba21a951af61e2a$export$2e2bcd8739ae039 = $aba21a951af61e2a$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $b06ec05f230d54c5$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $b06ec05f230d54c5$var$defaults = {
    transitional: (0, $539cfb2eff172381$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || "";
            var hasJSONContentType = contentType.indexOf("application/json") > -1;
            var isObjectPayload = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $aba21a951af61e2a$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isBuffer(data) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isStream(data) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFile(data) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isBlob(data) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $72f2475fd6c4d469$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    var _FormData = this.env && this.env.FormData;
                    return (0, $d6d050533c0dcf50$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $b06ec05f230d54c5$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $b06ec05f230d54c5$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === "json";
            if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isResponse(data) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $32604bf3eba12907$export$2e2bcd8739ae039).from(e, (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], function(method) {
    $b06ec05f230d54c5$var$defaults.headers[method] = {};
});
var $b06ec05f230d54c5$export$2e2bcd8739ae039 = $b06ec05f230d54c5$var$defaults;



var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $3F6om = parcelRequire("3F6om");

var $8xYJx = parcelRequire("8xYJx");


"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $3a3f656a5adb73aa$var$ignoreDuplicateOf = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $3a3f656a5adb73aa$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $3a3f656a5adb73aa$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
var $80635f2cd4c3a678$var$$internals = Symbol("internals");
function $80635f2cd4c3a678$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $80635f2cd4c3a678$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(value) ? value.map($80635f2cd4c3a678$var$normalizeValue) : String(value);
}
function $80635f2cd4c3a678$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $80635f2cd4c3a678$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $80635f2cd4c3a678$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $80635f2cd4c3a678$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, _char, str) {
        return _char.toUpperCase() + str;
    });
}
function $80635f2cd4c3a678$var$buildAccessors(obj, header) {
    var accessorName = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $80635f2cd4c3a678$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $fvacx._)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $3D4gQ._)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $80635f2cd4c3a678$var$normalizeHeader(_header);
                    if (!lHeader) throw new Error("header name must be a non-empty string");
                    var key = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $80635f2cd4c3a678$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$80635f2cd4c3a678$var$isValidHeaderName(header)) setHeaders((0, $3a3f656a5adb73aa$export$2e2bcd8739ae039)(header), valueOrRewrite);
                else if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isHeaders(header)) try {
                    for(var _iterator = header.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $3F6om._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        setHeader(value, key, rewrite);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $80635f2cd4c3a678$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $80635f2cd4c3a678$var$parseTokens(value);
                        if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError("parser must be boolean|regexp|function");
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $80635f2cd4c3a678$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $80635f2cd4c3a678$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $80635f2cd4c3a678$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).findKey(self, _header);
                        if (key && (!matcher || $80635f2cd4c3a678$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $80635f2cd4c3a678$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    var key = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).findKey(headers, header);
                    if (key) {
                        self[key] = $80635f2cd4c3a678$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $80635f2cd4c3a678$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $80635f2cd4c3a678$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $8xYJx._)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $3F6om._)(param, 2), header = _param[0], value = _param[1];
                    return header + ": " + value;
                }).join("\n");
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "AxiosHeaders";
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$80635f2cd4c3a678$var$$internals] = this[$80635f2cd4c3a678$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $80635f2cd4c3a678$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $80635f2cd4c3a678$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$80635f2cd4c3a678$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).reduceDescriptors($80635f2cd4c3a678$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).freezeMethods($80635f2cd4c3a678$var$AxiosHeaders);
var $80635f2cd4c3a678$export$2e2bcd8739ae039 = $80635f2cd4c3a678$var$AxiosHeaders;


"use strict";
function $775c6f405814188f$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $b06ec05f230d54c5$export$2e2bcd8739ae039);
    var context = response || config;
    var headers = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).from(context.headers);
    var data = context.data;
    (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $e0c4d3c9dc2973b5$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $5fdb043304fb14ae$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $32604bf3eba12907$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).inherits($5fdb043304fb14ae$var$CanceledError, (0, $32604bf3eba12907$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $5fdb043304fb14ae$export$2e2bcd8739ae039 = $5fdb043304fb14ae$var$CanceledError;




var $3F6om = parcelRequire("3F6om");



var $3F6om = parcelRequire("3F6om");


"use strict";
function $76adb3deb9668538$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $cf90afd3a12f410a$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}





var $98Dv3 = parcelRequire("98Dv3");

var $8xYJx = parcelRequire("8xYJx");
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $37ecee5058ddbd3b$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $37ecee5058ddbd3b$export$2e2bcd8739ae039 = $37ecee5058ddbd3b$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $8a246fc9b23d32b0$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    return [
        throttled,
        flush
    ];
}
var $8a246fc9b23d32b0$export$2e2bcd8739ae039 = $8a246fc9b23d32b0$var$throttle;



var $d653cf2ea8cc8fdd$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $37ecee5058ddbd3b$export$2e2bcd8739ae039)(50, 250);
    return (0, $8a246fc9b23d32b0$export$2e2bcd8739ae039)(function(e) {
        var loaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var progressBytes = loaded - bytesNotified;
        var rate = _speedometer(progressBytes);
        var inRange = loaded <= total;
        bytesNotified = loaded;
        var data = (0, $98Dv3._)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? "download" : "upload", true);
        listener(data);
    }, freq);
};
var $d653cf2ea8cc8fdd$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $d653cf2ea8cc8fdd$export$5d35863c355a22a9 = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).asap(function() {
            return fn.apply(void 0, (0, $8xYJx._)(args));
        });
    };
};



var $fCPXk = parcelRequire("fCPXk");

var $8xYJx = parcelRequire("8xYJx");




"use strict";
var $909a9d24ff2a9bd6$export$2e2bcd8739ae039 = (0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = (0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $9772420e7033d881$export$2e2bcd8739ae039 = (0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write: function(name, value, expires, path, domain, secure) {
        var cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read: function(name) {
        var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function(name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};


"use strict";
function $abd2b047e973dfbd$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $365509b45776954a$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $04b1d76f724e927a$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $abd2b047e973dfbd$export$2e2bcd8739ae039)(requestedURL)) return (0, $365509b45776954a$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}



var $e2Ogy = parcelRequire("e2Ogy");


"use strict";
var $9182980d57328bd1$var$headersToObject = function(thing) {
    return thing instanceof (0, $80635f2cd4c3a678$export$2e2bcd8739ae039) ? (0, $e2Ogy._)({}, thing) : thing;
};
function $9182980d57328bd1$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isPlainObject(target) && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b) {
            return mergeDeepProperties($9182980d57328bd1$var$headersToObject(a), $9182980d57328bd1$var$headersToObject(b), true);
        }
    };
    (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(config1[prop], config2[prop], prop);
        (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $0fdbf4690c070dba$export$2e2bcd8739ae039 = function(config) {
    var newConfig = (0, $9182980d57328bd1$export$2e2bcd8739ae039)({}, config);
    var data = newConfig.data, withXSRFToken = newConfig.withXSRFToken, xsrfHeaderName = newConfig.xsrfHeaderName, xsrfCookieName = newConfig.xsrfCookieName, headers = newConfig.headers, auth = newConfig.auth;
    newConfig.headers = headers = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $120394699f31bec2$export$2e2bcd8739ae039)((0, $04b1d76f724e927a$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    var contentType;
    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            var _ref = (0, $fCPXk._)(contentType ? contentType.split(";").map(function(token) {
                return token.trim();
            }).filter(Boolean) : []), type = _ref[0], tokens = _ref.slice(1);
            headers.setContentType([
                type || "multipart/form-data"
            ].concat((0, $8xYJx._)(tokens)).join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $909a9d24ff2a9bd6$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $9772420e7033d881$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


var $df9fa653ac624740$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $df9fa653ac624740$export$2e2bcd8739ae039 = $df9fa653ac624740$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $0fdbf4690c070dba$export$2e2bcd8739ae039)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $76adb3deb9668538$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Request aborted", (0, $32604bf3eba12907$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Network Error", (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = _config.transitional || (0, $539cfb2eff172381$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $32604bf3eba12907$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $32604bf3eba12907$export$2e2bcd8739ae039).ETIMEDOUT : (0, $32604bf3eba12907$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $3F6om._)((0, $d653cf2ea8cc8fdd$export$c1b28109d46c3592)(onDownloadProgress, true), 2), downloadThrottled = ref[0], flushDownload = ref[1], ref;
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $3F6om._)((0, $d653cf2ea8cc8fdd$export$c1b28109d46c3592)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $5fdb043304fb14ae$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        var protocol = (0, $cf90afd3a12f410a$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};




var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $3F6om = parcelRequire("3F6om");

var $8xYJx = parcelRequire("8xYJx");

var $33z5g = parcelRequire("33z5g");






var $9ca9dcf47e63c21f$var$composeSignals = function(signals, timeout) {
    var length = (signals = signals ? signals.filter(Boolean) : []).length;
    if (timeout || length) {
        var controller = new AbortController();
        var aborted;
        var onabort = function onabort(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                var err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $32604bf3eba12907$export$2e2bcd8739ae039) ? err : new (0, $5fdb043304fb14ae$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        var timer = timeout && setTimeout(function() {
            timer = null;
            onabort(new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("timeout ".concat(timeout, " of ms exceeded"), (0, $32604bf3eba12907$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        var unsubscribe = function() {
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach(function(signal) {
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach(function(signal) {
            return signal.addEventListener("abort", onabort);
        });
        var signal = controller.signal;
        signal.unsubscribe = function() {
            return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).asap(unsubscribe);
        };
        return signal;
    }
};
var $9ca9dcf47e63c21f$export$2e2bcd8739ae039 = $9ca9dcf47e63c21f$var$composeSignals;


function $0bdee9a2c95dfe06$export$44f75e6c8de0f9e(inner, awaitWrap) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: awaitWrap(value)
        };
    }
    if (typeof Symbol === "function" && Symbol.iterator) iter[Symbol.iterator] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        return pump("return", value);
    };
    return iter;
}


function $264f04852172a648$export$adaf682ac3edfe45(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $264f04852172a648$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $264f04852172a648$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $264f04852172a648$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $264f04852172a648$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $264f04852172a648$var$AsyncFromSyncIterator(s);
}



function $3ab79c87312e855a$export$14d68ad33f8c0242(value) {
    this.wrapped = value;
}


function $4c8fc8f9da5a8eea$export$491e832825b6666e(value) {
    return new (0, $3ab79c87312e855a$export$14d68ad33f8c0242)(value);
}



function $a17361ccd86bed7f$export$f6ee6a12e55075bb(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, $3ab79c87312e855a$export$14d68ad33f8c0242);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) $a17361ccd86bed7f$export$f6ee6a12e55075bb.prototype[Symbol.asyncIterator] = function() {
    return this;
};
$a17361ccd86bed7f$export$f6ee6a12e55075bb.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$a17361ccd86bed7f$export$f6ee6a12e55075bb.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$a17361ccd86bed7f$export$f6ee6a12e55075bb.prototype.return = function(arg) {
    return this._invoke("return", arg);
};


function $53d521e0b6af84a1$export$a1b373fcf543ed3a(fn) {
    return function() {
        return new (0, $a17361ccd86bed7f$export$f6ee6a12e55075bb)(fn.apply(this, arguments));
    };
}



var $33z5g = parcelRequire("33z5g");

var $33z5g = parcelRequire("33z5g");
var $7c82e94819b8a66f$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $33z5g.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $7c82e94819b8a66f$export$f9f241124ee3198e = function() {
    var _ref = (0, $53d521e0b6af84a1$export$a1b373fcf543ed3a)(function(iterable, chunkSize) {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $264f04852172a648$export$adaf682ac3edfe45)($7c82e94819b8a66f$var$readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $4c8fc8f9da5a8eea$export$491e832825b6666e)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $33z5g.__values)((0, $0bdee9a2c95dfe06$export$44f75e6c8de0f9e)((0, $264f04852172a648$export$adaf682ac3edfe45)($7c82e94819b8a66f$export$71b051935044bd5d(chunk, chunkSize)), (0, $4c8fc8f9da5a8eea$export$491e832825b6666e)))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return function readBytes(iterable, chunkSize) {
        return _ref.apply(this, arguments);
    };
}();
var $7c82e94819b8a66f$var$readStream = function() {
    var _ref = (0, $53d521e0b6af84a1$export$a1b373fcf543ed3a)(function(stream) {
        var reader, _ref, done, value;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, $33z5g.__values)((0, $0bdee9a2c95dfe06$export$44f75e6c8de0f9e)((0, $264f04852172a648$export$adaf682ac3edfe45)(stream), (0, $4c8fc8f9da5a8eea$export$491e832825b6666e)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, $4c8fc8f9da5a8eea$export$491e832825b6666e)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, $4c8fc8f9da5a8eea$export$491e832825b6666e)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return function readStream(stream) {
        return _ref.apply(this, arguments);
    };
}();
var $7c82e94819b8a66f$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = $7c82e94819b8a66f$export$f9f241124ee3198e(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $33z5g.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator["return"]();
        }
    }, {
        highWaterMark: 2
    });
};






var $890b9cdd2958af4b$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
var $890b9cdd2958af4b$var$isReadableStreamSupported = $890b9cdd2958af4b$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
var $890b9cdd2958af4b$var$encodeText = $890b9cdd2958af4b$var$isFetchSupported && (typeof TextEncoder === "function" ? function(encoder) {
    return function(str) {
        return encoder.encode(str);
    };
}(new TextEncoder()) : function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(str) {
        var _;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = Uint8Array.bind;
                    return [
                        4,
                        new Response(str).arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        new (_.apply(Uint8Array, [
                            void 0,
                            _state.sent()
                        ]))
                    ];
            }
        });
    });
    return function(str) {
        return _ref.apply(this, arguments);
    };
}());
var $890b9cdd2958af4b$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $8xYJx._)(args));
    } catch (e) {
        return false;
    }
};
var $890b9cdd2958af4b$var$supportsRequestStream = $890b9cdd2958af4b$var$isReadableStreamSupported && $890b9cdd2958af4b$var$test(function() {
    var duplexAccessed = false;
    var hasContentType = new Request((0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
var $890b9cdd2958af4b$var$DEFAULT_CHUNK_SIZE = 65536;
var $890b9cdd2958af4b$var$supportsResponseStream = $890b9cdd2958af4b$var$isReadableStreamSupported && $890b9cdd2958af4b$var$test(function() {
    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
});
var $890b9cdd2958af4b$var$resolvers = {
    stream: $890b9cdd2958af4b$var$supportsResponseStream && function(res) {
        return res.body;
    }
};
$890b9cdd2958af4b$var$isFetchSupported && function(res) {
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach(function(type) {
        !$890b9cdd2958af4b$var$resolvers[type] && ($890b9cdd2958af4b$var$resolvers[type] = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFunction(res[type]) ? function(res) {
            return res[type]();
        } : function(_, config) {
            throw new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Response type '".concat(type, "' is not supported"), (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
}(new Response);
var $890b9cdd2958af4b$var$getBodyLength = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(body) {
        var _request;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (body == null) return [
                        2,
                        0
                    ];
                    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isBlob(body)) return [
                        2,
                        body.size
                    ];
                    if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return [
                        3,
                        2
                    ];
                    _request = new Request((0, $9ab2e02cabae72e0$export$2e2bcd8739ae039).origin, {
                        method: "POST",
                        body: body
                    });
                    return [
                        4,
                        _request.arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 2:
                    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArrayBuffer(body)) return [
                        2,
                        body.byteLength
                    ];
                    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
                    if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(body)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $890b9cdd2958af4b$var$encodeText(body)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getBodyLength(body) {
        return _ref.apply(this, arguments);
    };
}();
var $890b9cdd2958af4b$var$resolveBodyLength = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(headers, body) {
        var length;
        return (0, $33z5g.__generator)(this, function(_state) {
            length = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
            return [
                2,
                length == null ? $890b9cdd2958af4b$var$getBodyLength(body) : length
            ];
        });
    });
    return function resolveBodyLength(headers, body) {
        return _ref.apply(this, arguments);
    };
}();
var $890b9cdd2958af4b$export$2e2bcd8739ae039 = $890b9cdd2958af4b$var$isFetchSupported && function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(config) {
        var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, composedSignal, request, unsubscribe, requestContentLength, _tmp, _request, contentTypeHeader, _progressEventDecorator, onProgress, flush, isCredentialsSupported, response, isStreamResponse, options, responseContentLength, _ref, onProgress1, flush1, responseData, err;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _resolveConfig = (0, $0fdbf4690c070dba$export$2e2bcd8739ae039)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? "same-origin" : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions;
                    responseType = responseType ? (responseType + "").toLowerCase() : "text";
                    composedSignal = (0, $9ca9dcf47e63c21f$export$2e2bcd8739ae039)([
                        signal,
                        cancelToken && cancelToken.toAbortSignal()
                    ], timeout);
                    unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                        composedSignal.unsubscribe();
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    _tmp = onUploadProgress && $890b9cdd2958af4b$var$supportsRequestStream && method !== "get" && method !== "head";
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $890b9cdd2958af4b$var$resolveBodyLength(headers, data)
                    ];
                case 2:
                    _tmp = (requestContentLength = _state.sent()) !== 0;
                    _state.label = 3;
                case 3:
                    if (_tmp) {
                        _request = new Request(url, {
                            method: "POST",
                            body: data,
                            duplex: "half"
                        });
                        ;
                        if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
                        if (_request.body) {
                            _progressEventDecorator = (0, $3F6om._)((0, $d653cf2ea8cc8fdd$export$d9fadd12586c18d6)(requestContentLength, (0, $d653cf2ea8cc8fdd$export$c1b28109d46c3592)((0, $d653cf2ea8cc8fdd$export$5d35863c355a22a9)(onUploadProgress))), 2), onProgress = _progressEventDecorator[0], flush = _progressEventDecorator[1];
                            data = (0, $7c82e94819b8a66f$export$b0119225647bd83)(_request.body, $890b9cdd2958af4b$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                        }
                    }
                    if (!(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
                    // Cloudflare Workers throws when credentials are defined
                    // see https://github.com/cloudflare/workerd/issues/902
                    isCredentialsSupported = "credentials" in Request.prototype;
                    request = new Request(url, (0, $ioWVw._)((0, $e2Ogy._)({}, fetchOptions), {
                        signal: composedSignal,
                        method: method.toUpperCase(),
                        headers: headers.normalize().toJSON(),
                        body: data,
                        duplex: "half",
                        credentials: isCredentialsSupported ? withCredentials : undefined
                    }));
                    return [
                        4,
                        fetch(request)
                    ];
                case 4:
                    response = _state.sent();
                    isStreamResponse = $890b9cdd2958af4b$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
                    if ($890b9cdd2958af4b$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                        options = {};
                        [
                            "status",
                            "statusText",
                            "headers"
                        ].forEach(function(prop) {
                            options[prop] = response[prop];
                        });
                        responseContentLength = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
                        _ref = (0, $3F6om._)(onDownloadProgress && (0, $d653cf2ea8cc8fdd$export$d9fadd12586c18d6)(responseContentLength, (0, $d653cf2ea8cc8fdd$export$c1b28109d46c3592)((0, $d653cf2ea8cc8fdd$export$5d35863c355a22a9)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref[0], flush1 = _ref[1];
                        response = new Response((0, $7c82e94819b8a66f$export$b0119225647bd83)(response.body, $890b9cdd2958af4b$var$DEFAULT_CHUNK_SIZE, onProgress1, function() {
                            flush1 && flush1();
                            unsubscribe && unsubscribe();
                        }), options);
                    }
                    responseType = responseType || "text";
                    return [
                        4,
                        $890b9cdd2958af4b$var$resolvers[(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).findKey($890b9cdd2958af4b$var$resolvers, responseType) || "text"](response, config)
                    ];
                case 5:
                    responseData = _state.sent();
                    !isStreamResponse && unsubscribe && unsubscribe();
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            (0, $76adb3deb9668538$export$2e2bcd8739ae039)(resolve, reject, {
                                data: responseData,
                                headers: (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).from(response.headers),
                                status: response.status,
                                statusText: response.statusText,
                                config: config,
                                request: request
                            });
                        })
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    err = _state.sent();
                    unsubscribe && unsubscribe();
                    if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Network Error", (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                        cause: err.cause || err
                    });
                    throw (0, $32604bf3eba12907$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}();



var $e7b3fb427d88dbbb$var$knownAdapters = {
    http: (0, $58c127046c689796$export$2e2bcd8739ae039),
    xhr: (0, $df9fa653ac624740$export$2e2bcd8739ae039),
    fetch: (0, $890b9cdd2958af4b$export$2e2bcd8739ae039)
};
(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach($e7b3fb427d88dbbb$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $e7b3fb427d88dbbb$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
var $e7b3fb427d88dbbb$var$isResolvedHandle = function(adapter) {
    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
};
var $e7b3fb427d88dbbb$export$2e2bcd8739ae039 = {
    getAdapter: function(adapters) {
        adapters = (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        var length = adapters.length;
        var nameOrAdapter;
        var adapter;
        var rejectedReasons = {};
        for(var i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            var id = void 0;
            adapter = nameOrAdapter;
            if (!$e7b3fb427d88dbbb$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e7b3fb427d88dbbb$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Unknown adapter '".concat(id, "'"));
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            var reasons = Object.entries(rejectedReasons).map(function(param) {
                var _param = (0, $3F6om._)(param, 2), id = _param[0], state = _param[1];
                return "adapter ".concat(id, " ") + (state === false ? "is not supported by the environment" : "is not available in the build");
            });
            var s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e7b3fb427d88dbbb$var$renderReason).join("\n") : " " + $e7b3fb427d88dbbb$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("There is no suitable adapter to dispatch the request " + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e7b3fb427d88dbbb$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $c13df41d4aa77564$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $5fdb043304fb14ae$export$2e2bcd8739ae039)(null, config);
}
function $c13df41d4aa77564$export$2e2bcd8739ae039(config) {
    $c13df41d4aa77564$var$throwIfCancellationRequested(config);
    config.headers = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $775c6f405814188f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    var adapter = (0, $e7b3fb427d88dbbb$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $b06ec05f230d54c5$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $c13df41d4aa77564$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $775c6f405814188f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $e0c4d3c9dc2973b5$export$2e2bcd8739ae039)(reason)) {
            $c13df41d4aa77564$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $775c6f405814188f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}





var $iHOCm = parcelRequire("iHOCm");
var $bec039b0e685d877$export$a4ad2735b021c132 = "1.7.7";



"use strict";
var $01ad73f08969d25a$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $01ad73f08969d25a$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $iHOCm._)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $01ad73f08969d25a$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $01ad73f08969d25a$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $bec039b0e685d877$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $32604bf3eba12907$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$01ad73f08969d25a$var$deprecatedWarnings[opt]) {
            $01ad73f08969d25a$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $01ad73f08969d25a$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("options must be an object", (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $32604bf3eba12907$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $32604bf3eba12907$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $01ad73f08969d25a$export$2e2bcd8739ae039 = {
    assertOptions: $01ad73f08969d25a$var$assertOptions,
    validators: $01ad73f08969d25a$var$validators
};



"use strict";
var $29ad66d5f20324ab$var$validators = (0, $01ad73f08969d25a$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $29ad66d5f20324ab$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $fvacx._)(this, Axios);
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $1435996e915cfb96$export$2e2bcd8739ae039)(),
            response: new (0, $1435996e915cfb96$export$2e2bcd8739ae039)()
        };
    }
    (0, $3D4gQ._)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var err, dummy, stack;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) {
                                    ;
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                                    // slice off the Error: ... line
                                    stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                                    try {
                                        if (!err.stack) err.stack = stack;
                                        else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                                    } catch (e) {
                                    // ignore the case where "stack" is an un-writable property
                                    }
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === "string") {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $9182980d57328bd1$export$2e2bcd8739ae039)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $01ad73f08969d25a$export$2e2bcd8739ae039).assertOptions(transitional, {
                    silentJSONParsing: $29ad66d5f20324ab$var$validators.transitional($29ad66d5f20324ab$var$validators["boolean"]),
                    forcedJSONParsing: $29ad66d5f20324ab$var$validators.transitional($29ad66d5f20324ab$var$validators["boolean"]),
                    clarifyTimeoutError: $29ad66d5f20324ab$var$validators.transitional($29ad66d5f20324ab$var$validators["boolean"])
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $01ad73f08969d25a$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                        encode: $29ad66d5f20324ab$var$validators["function"],
                        serialize: $29ad66d5f20324ab$var$validators["function"]
                    }, true);
                }
                // Set config.method
                config.method = (config.method || this.defaults.method || "get").toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
                headers && (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach([
                    "delete",
                    "get",
                    "head",
                    "post",
                    "put",
                    "patch",
                    "common"
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var chain = [
                        (0, $c13df41d4aa77564$export$2e2bcd8739ae039).bind(this),
                        undefined
                    ];
                    chain.unshift.apply(chain, requestInterceptorChain);
                    chain.push.apply(chain, responseInterceptorChain);
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                i = 0;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, $c13df41d4aa77564$export$2e2bcd8739ae039).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $9182980d57328bd1$export$2e2bcd8739ae039)(this.defaults, config);
                var fullPath = (0, $04b1d76f724e927a$export$2e2bcd8739ae039)(config.baseURL, config.url);
                return (0, $120394699f31bec2$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $29ad66d5f20324ab$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $9182980d57328bd1$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $9182980d57328bd1$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $29ad66d5f20324ab$var$Axios.prototype[method] = generateHTTPMethod();
    $29ad66d5f20324ab$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $29ad66d5f20324ab$export$2e2bcd8739ae039 = $29ad66d5f20324ab$var$Axios;







var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $5725cfdf0e1b8f53$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $fvacx._)(this, CancelToken);
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $5fdb043304fb14ae$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $3D4gQ._)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $5725cfdf0e1b8f53$export$2e2bcd8739ae039 = $5725cfdf0e1b8f53$var$CancelToken;






"use strict";
function $ce772aebdba9caaf$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $f98a21916438125d$export$2e2bcd8739ae039(payload) {
    return (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}





var $3F6om = parcelRequire("3F6om");
var $308d50e64f6a7bd4$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($308d50e64f6a7bd4$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $3F6om._)(param, 2), key = _param[0], value = _param[1];
    $308d50e64f6a7bd4$var$HttpStatusCode[value] = key;
});
var $308d50e64f6a7bd4$export$2e2bcd8739ae039 = $308d50e64f6a7bd4$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $4b0de528f5b5ca15$var$createInstance(defaultConfig) {
    var context = new (0, $29ad66d5f20324ab$export$2e2bcd8739ae039)(defaultConfig);
    var instance = (0, $3d0caa012eb8204d$export$2e2bcd8739ae039)((0, $29ad66d5f20324ab$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).extend(instance, (0, $29ad66d5f20324ab$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $4b0de528f5b5ca15$var$createInstance((0, $9182980d57328bd1$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $4b0de528f5b5ca15$var$axios = $4b0de528f5b5ca15$var$createInstance((0, $b06ec05f230d54c5$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$4b0de528f5b5ca15$var$axios.Axios = (0, $29ad66d5f20324ab$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$4b0de528f5b5ca15$var$axios.CanceledError = (0, $5fdb043304fb14ae$export$2e2bcd8739ae039);
$4b0de528f5b5ca15$var$axios.CancelToken = (0, $5725cfdf0e1b8f53$export$2e2bcd8739ae039);
$4b0de528f5b5ca15$var$axios.isCancel = (0, $e0c4d3c9dc2973b5$export$2e2bcd8739ae039);
$4b0de528f5b5ca15$var$axios.VERSION = (0, $bec039b0e685d877$export$a4ad2735b021c132);
$4b0de528f5b5ca15$var$axios.toFormData = (0, $d6d050533c0dcf50$export$2e2bcd8739ae039);
// Expose AxiosError class
$4b0de528f5b5ca15$var$axios.AxiosError = (0, $32604bf3eba12907$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$4b0de528f5b5ca15$var$axios.Cancel = $4b0de528f5b5ca15$var$axios.CanceledError;
// Expose all/spread
$4b0de528f5b5ca15$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$4b0de528f5b5ca15$var$axios.spread = (0, $ce772aebdba9caaf$export$2e2bcd8739ae039);
// Expose isAxiosError
$4b0de528f5b5ca15$var$axios.isAxiosError = (0, $f98a21916438125d$export$2e2bcd8739ae039);
// Expose mergeConfig
$4b0de528f5b5ca15$var$axios.mergeConfig = (0, $9182980d57328bd1$export$2e2bcd8739ae039);
$4b0de528f5b5ca15$var$axios.AxiosHeaders = (0, $80635f2cd4c3a678$export$2e2bcd8739ae039);
$4b0de528f5b5ca15$var$axios.formToJSON = function(thing) {
    return (0, $aba21a951af61e2a$export$2e2bcd8739ae039)((0, $fb882fc60a9cef2f$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$4b0de528f5b5ca15$var$axios.getAdapter = (0, $e7b3fb427d88dbbb$export$2e2bcd8739ae039).getAdapter;
$4b0de528f5b5ca15$var$axios.HttpStatusCode = (0, $308d50e64f6a7bd4$export$2e2bcd8739ae039);
$4b0de528f5b5ca15$var$axios["default"] = $4b0de528f5b5ca15$var$axios;
var // this module should only have a default export
$4b0de528f5b5ca15$export$2e2bcd8739ae039 = $4b0de528f5b5ca15$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $cb6772dd8eb0b9ca$export$1c00760e9e5a4e95 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).Axios, $cb6772dd8eb0b9ca$export$c1fbed17c2f6a328 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).AxiosError, $cb6772dd8eb0b9ca$export$1ab0c6b20d94fa14 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).CanceledError, $cb6772dd8eb0b9ca$export$3b22524397b493c6 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).isCancel, $cb6772dd8eb0b9ca$export$fd08e3cb425f0d61 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).CancelToken, $cb6772dd8eb0b9ca$export$a4ad2735b021c132 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).VERSION, $cb6772dd8eb0b9ca$export$84bf76cd7afc7469 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).all, $cb6772dd8eb0b9ca$export$848c9b7ead0df967 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).Cancel, $cb6772dd8eb0b9ca$export$fbafdbe06a5b5a9a = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).isAxiosError, $cb6772dd8eb0b9ca$export$3ae0fd4797ed47c8 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).spread, $cb6772dd8eb0b9ca$export$10ae0d317ea97f8b = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).toFormData, $cb6772dd8eb0b9ca$export$4e7d6ff0f3e6520 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).AxiosHeaders, $cb6772dd8eb0b9ca$export$a972f69c851492b3 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).HttpStatusCode, $cb6772dd8eb0b9ca$export$86d7c59254d6a2c9 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).formToJSON, $cb6772dd8eb0b9ca$export$17ddc20a97d669e2 = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).getAdapter, $cb6772dd8eb0b9ca$export$7ec1ebcfa9d8bd6a = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).mergeConfig;



var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");
var $695867e7be5066b8$exports = {};
$695867e7be5066b8$exports = JSON.parse('{"name":"webflow-js-controller-funnel","version":"0.14.36","private":true,"license":"UNLICENSED","author":"Adtractive","source":"src/index.ts","scripts":{"build":"parcel build src/index.ts","check":"tsc --noEmit","ci":"npm run build && npm run test && npm run lint && npm run check","deploy":"../scripts/deployFunnel.sh","test":"jest"},"browserslist":"> 0.3%, last 7 major versions","dependencies":{"@stripe/stripe-js":"^4.3.0","axios":"^1.7.3","bowser":"^2.11.0","braintree-web":"^3.105.0","card-validator":"^10.0.0","country-state-city":"^3.2.1","intl-tel-input":"^19.2.20","localforage":"^1.10.0","superstruct":"^2.0.2","ua-parser-js":"^1.0.38","uuid":"^10.0.0"},"devDependencies":{"@babel/core":"^7.25.2","@babel/plugin-proposal-optional-chaining":"^7.21.0","@babel/plugin-proposal-private-methods":"^7.18.6","@babel/preset-env":"^7.25.3","@parcel/compressor-brotli":"^2.12.0","@parcel/compressor-gzip":"^2.12.0","@parcel/config-default":"^2.12.0","@parcel/packager-ts":"2.12.0","@parcel/transformer-typescript-tsc":"^2.12.0","@parcel/transformer-typescript-types":"2.12.0","@parcel/validator-typescript":"^2.12.0","@sentry/browser":"^8.22.0","@sentry/tracing":"^7.114.0","@types/braintree-web":"^3.96.12","@types/google.maps":"^3.55.12","@types/googlepay":"^0.7.6","@types/intl-tel-input":"^18.1.4","@types/jest":"^29.5.12","@types/jquery":"^3.5.30","@types/node":"^22.1.0","@types/ua-parser-js":"^0.7.39","@types/uuid":"^10.0.0","buffer":"^6.0.3","dotenv":"^16.4.5","jest":"^29.7.0","jest-environment-jsdom":"^29.7.0","parcel":"^2.12.0","process":"^0.11.10","ts-jest":"^29.2.4","ts-node":"^10.9.2","typescript":"^5.5.4"}}');


var $42a1df290c3667d2$var$configs = JSON.parse(atob("eyJwcm9kdWN0aW9uIjp7IkFQSV9VUkwiOiJodHRwczovL2FwaS5ub2RlMzMuYWkiLCJNQUtFX1dIX1VSTCI6Imh0dHBzOi8vaG9vay5ldTEubWFrZS5jb20va2kzYzl0MTc1Z2Q4MnM5dGM0dHpnODBvNGE3N3N6M3EiLCJNQUtFX1BQX1VSTCI6Imh0dHBzOi8vaG9vay5ldTEubWFrZS5jb20vaTFjcjU2amt5czNhZ2dhbDY3cmNqeGdzaXV2eGhmNWQiLCJCUl9JRCI6IkJDUjJETjRUWTNNMzNFWVkiLCJCUl9LRVkiOiJwcm9kdWN0aW9uX3E3eTlnbnpqXzQ5MnhjeXQ4cno5ZDl3cTkiLCJNQUtFX1BBWU1FTlRfQkFMQU5DRVJfVVJMIjoiaHR0cHM6Ly9ob29rLmV1MS5tYWtlLmNvbS8wMjljNGFldzNiZXF6c2YwbmQ0d2ZoaDBoamdkZDR5OCIsIlRPS0VOIjoiWVdSdGFXNDZUV2x1WkdFeElRPT0iLCJQTEFDRVNfQVBJIjoiQUl6YVN5Q2lzLXpZWXFqbi13UklPQl82Mm1EM3l3SVFnZ2hLRjBNIn0sInN0YWdpbmciOnsiQVBJX1VSTCI6Imh0dHBzOi8vc3RhZ2luZy5hcGkuYWR0cmFjdGl2ZS5pbyIsIk1BS0VfV0hfVVJMIjoiaHR0cHM6Ly9ob29rLmV1MS5tYWtlLmNvbS9raTNjOXQxNzVnZDgyczl0YzR0emc4MG80YTc3c3ozcSIsIk1BS0VfUFBfVVJMIjoiaHR0cHM6Ly9ob29rLmV1MS5tYWtlLmNvbS9pMWNyNTZqa3lzM2FnZ2FsNjdyY2p4Z3NpdXZ4aGY1ZCIsIkJSX0lEIjoiQkNSMkRONFRZM00zM0VZWSIsIkJSX0tFWSI6InByb2R1Y3Rpb25fcTd5OWduempfNDkyeGN5dDhyejlkOXdxOSIsIk1BS0VfUEFZTUVOVF9CQUxBTkNFUl9VUkwiOiJodHRwczovL2hvb2suZXUxLm1ha2UuY29tLzAyOWM0YWV3M2JlcXpzZjBuZDR3ZmhoMGhqZ2RkNHk4IiwiVE9LRU4iOiJjM1JoWjJsdVp5MWhaSFJ5WVdOMGFYWmxMV0Z3YVMxaFpHMXBiam90YUVkWlkyRldWQzVJVmpNaExWVitlVjVDVW41bFoyUjRLVVptT1hBPSIsIlBMQUNFU19BUEkiOiJBSXphU3lDaXMtellZcWpuLXdSSU9CXzYybUQzeXdJUWdnaEtGME0ifX0"));
var $42a1df290c3667d2$export$e506a1d27d1eaa20 = (0, $ioWVw._)((0, $e2Ogy._)({}, window.DEBUG ? $42a1df290c3667d2$var$configs.staging : $42a1df290c3667d2$var$configs.production), {
    ENV: window.DEBUG ? "staging" : "production",
    RELEASE: (0, $695867e7be5066b8$exports.version)
});
console.log("v".concat($42a1df290c3667d2$export$e506a1d27d1eaa20.RELEASE));




var $33z5g = parcelRequire("33z5g");
var $aabffe8b682b8373$export$562bc4a862c31607 = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(fn) {
        var retries, delay, error;
        var _arguments = arguments;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retries = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 3, delay = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 500;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fn()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    if (retries <= 1) throw error;
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, delay);
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        $aabffe8b682b8373$export$562bc4a862c31607(fn, retries - 1, delay * 2)
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function backoff(fn) {
        return _ref.apply(this, arguments);
    };
}();



var $3F6om = parcelRequire("3F6om");
var $5afc064d4f10b824$export$7138c24907de3954 = function(urlOrPath, params) {
    var excludeExistingParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // Determine if the input is a URL or a path by checking if it includes "://"
    var isUrl = urlOrPath.includes("://");
    var base = urlOrPath;
    if (!isUrl && typeof window !== "undefined") base = "".concat(window.origin, "/").concat(urlOrPath.startsWith("/") ? urlOrPath.slice(1) : urlOrPath);
    var url = new URL(base);
    // If excluding existing parameters, clear them
    if (excludeExistingParams) url.search = "";
    if (params) {
        var searchParams = new URLSearchParams(params);
        searchParams.forEach(function(value, key) {
            url.searchParams.set(key, value);
        });
    }
    return url.toString();
};
var $5afc064d4f10b824$export$29f5936f887dc758 = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.href;
    try {
        var urlObject = new URL(url);
        var pathSegments = urlObject.pathname.split("/").filter(function(segment) {
            return segment !== "";
        });
        return pathSegments[pathSegments.length - 1] || "";
    } catch (e) {
        return "";
    }
};
var $5afc064d4f10b824$export$8244edb2ebc64140 = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : location.href;
    try {
        var pathSegments = new URL(url).pathname.split("/");
        var lastSegment = pathSegments[pathSegments.length - 1];
        var locale = lastSegment.split("-")[0];
        return locale;
    } catch (e) {
        return "";
    }
};
function $5afc064d4f10b824$export$49b9065228a93aae(param) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var urlParams = new URLSearchParams(window.location.search);
    var params = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = urlParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $3F6om._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            params[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (typeof param === "string" && param.length > 0) return params[param] || fallback;
    return params;
}
var $5afc064d4f10b824$export$4f2e34905c9fb7fa = function(params) {
    var url = new URL(window.location.href);
    var isUrlUpdated = false;
    // Iterate over the parameters to add or update them
    Object.entries(params).forEach(function(param) {
        var _param = (0, $3F6om._)(param, 2), key = _param[0], value = _param[1];
        if (!url.searchParams.has(key)) {
            url.searchParams.append(key, value);
            isUrlUpdated = true;
        } else if (url.searchParams.get(key) !== value) {
            url.searchParams.set(key, value);
            isUrlUpdated = true;
        }
    });
    if (isUrlUpdated) window.history.pushState({}, "", url.toString());
};
var $5afc064d4f10b824$export$4f9c066ec897736f = function(paramsToRemove) {
    var url = new URL(window.location.href);
    var isParamRemoved = false;
    var params = Array.isArray(paramsToRemove) ? paramsToRemove : [
        paramsToRemove
    ];
    params.forEach(function(param) {
        if (url.searchParams.has(param)) {
            url.searchParams["delete"](param);
            isParamRemoved = true;
        }
    });
    if (isParamRemoved) window.history.pushState({}, "", url.toString());
};



var $e2Ogy = parcelRequire("e2Ogy");

var $3F6om = parcelRequire("3F6om");
var $4b0c2be39d3732e4$export$a6cdc56e425d0d0a = function(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value) && typeof value !== "function";
};
var $4b0c2be39d3732e4$export$94df19ecb868bc1a = function(obj, key) {
    return typeof obj === "object" && obj !== null && key in obj;
};


var $4aacaa5cfd9fe25b$export$4be65e66cfa2648a = function(key) {
    var cookies = document.cookie.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        var _cookie_split = (0, $3F6om._)(cookie.split("="), 2), cookieName = _cookie_split[0], cookieValue = _cookie_split[1];
        if (cookieName.trim() === key) return decodeURIComponent(cookieValue);
    }
    return null;
};
var $4aacaa5cfd9fe25b$export$110700823644f4a6 = function(key, value) {
    document.cookie = key + "=" + encodeURIComponent(value) + "; path=/";
};
var $4aacaa5cfd9fe25b$export$6a874b7a74007875 = function(key) {
    if ($4aacaa5cfd9fe25b$export$4be65e66cfa2648a(key) !== null) document.cookie = "".concat(key, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");
};
var $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35 = function(key, value) {
    var expiryMin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 60;
    var valueStr = (0, $4b0c2be39d3732e4$export$a6cdc56e425d0d0a)(value) ? JSON.stringify(value) : value;
    var encodedValue = encodeURIComponent(valueStr);
    var expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + expiryMin * 60000);
    document.cookie = key + "=" + encodedValue + ";expires=" + expiryDate.toUTCString() + ";path=/";
};



var $27fc5057b004f1e0$export$b8d9f037f0c03914 = function() {
    var params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
    var fbclid = params["fbclid"] || undefined;
    var fbclidParsed = fbclid ? String(fbclid).replace(/[\[\]\'\"]/g, "").split(",") : undefined;
    var isFbclidArray = fbclidParsed && Array.isArray(fbclidParsed);
    if (isFbclidArray) fbclid = fbclidParsed[0];
    var fbc = fbclid ? "fb.1.".concat(Math.floor(Date.now() / 1000), ".").concat(fbclid) : undefined;
    var fbp = fbclid ? "fb.1.".concat(Math.floor(Date.now() / 1000), ".").concat(Math.floor(Math.random() * 1000000000 + 1000000000)) : "";
    return (0, $e2Ogy._)({
        affId: params["affid"],
        custom_ttp: (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("_ttp") || undefined,
        custom_fbc: fbc,
        custom_fbp: fbp,
        custom_fbclid: fbclid,
        custom_gclid: params["gclid"],
        custom_ttclid: params["ttclid"],
        custom_wbraid: params["wbraid"],
        custom_gbraid: params["gbraid"],
        custom_order_vlmid: params["vlmid"],
        custom_order_auid: params["utm_auid"],
        custom_ob_click_id: params["ob_click_id"],
        custom_gl: params["_gl"] || params["__gl"],
        custom_taboola_clid: params["taboola_clid"],
        custom_vcid: params["vcid"],
        custom_order_m_ab_var: params["m_ab_var"],
        custom_order_m_ab_name: params["m_ab_name"],
        custom_order_ab_name: params["ab_name"],
        custom_order_ab_var: params["ab_var"]
    }, $27fc5057b004f1e0$export$1bdba1f0d9c2d49c());
};
var $27fc5057b004f1e0$export$dbb70a91bbe8b436 = function(params) {
    var fbclid = params.get("fbclid") || undefined;
    var fbclidParsed = fbclid ? String(fbclid).replace(/[\[\]\'\"]/g, "").split(",") : undefined;
    var isFbclidArray = fbclidParsed && Array.isArray(fbclidParsed);
    if (isFbclidArray) fbclid = fbclidParsed[0];
    var fbc = fbclid ? "fb.1.".concat(Math.floor(Date.now() / 1000), ".").concat(fbclid) : undefined;
    var fbp = fbclid ? "fb.1.".concat(Math.floor(Date.now() / 1000), ".").concat(Math.floor(Math.random() * 1000000000 + 1000000000)) : "";
    return (0, $e2Ogy._)({
        affId: params.get("affid") || undefined,
        custom_ttp: (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("_ttp") || undefined,
        custom_fbc: fbc,
        custom_fbp: fbp,
        custom_fbclid: fbclid,
        custom_gclid: params.get("gclid") || "",
        custom_ttclid: params.get("ttclid") || "",
        custom_wbraid: params.get("wbraid") || "",
        custom_gbraid: params.get("gbraid") || "",
        custom_order_vlmid: params.get("vlmid") || "",
        custom_order_auid: params.get("utm_auid") || "",
        custom_ob_click_id: params.get("ob_click_id") || "",
        custom_gl: params.get("_gl") || params.get("__gl") || "",
        custom_taboola_clid: params.get("taboola_clid") || "",
        custom_vcid: params.get("vcid") || ""
    }, $27fc5057b004f1e0$export$1bdba1f0d9c2d49c());
};
var $27fc5057b004f1e0$export$fa3c4e23308a0d5b = function() {
    var urlParamsCookie = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("urlParams");
    var gaParameter = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("_ga");
    var urlParams = urlParamsCookie ? JSON.parse(urlParamsCookie) : {};
    var getParam = function(key) {
        return urlParams[key] || undefined;
    };
    var fbclid = getParam("fbclid");
    var fbclidParsed = fbclid ? String(fbclid).replace(/[\[\]\'\"]/g, "").split(",") : undefined;
    var isFbclidArray = fbclidParsed && Array.isArray(fbclidParsed);
    if (isFbclidArray) fbclid = fbclidParsed[0];
    var fbc = fbclid ? "fb.1.".concat(Math.floor(Date.now() / 1000), ".").concat(fbclid) : undefined;
    var fbp = fbclid ? "fb.1.".concat(Math.floor(Date.now() / 1000), ".").concat(Math.floor(Math.random() * 1000000000 + 1000000000)) : "";
    return (0, $e2Ogy._)({
        custom_order_affId: getParam("affid"),
        custom_order_ttp: (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("_ttp") || undefined,
        custom_order_fbc: fbc,
        custom_order_fbp: fbp,
        custom_order_fbclid: fbclid,
        custom_order_gclid: getParam("gclid") || "",
        custom_order_ga: gaParameter || "",
        custom_order_ttclid: getParam("ttclid") || "",
        custom_order_wbraid: getParam("wbraid") || "",
        custom_order_gbraid: getParam("gbraid") || "",
        custom_order_vlmid: getParam("vlmid") || "",
        custom_order_auid: getParam("utm_auid") || "",
        custom_order_ob_click_id: getParam("ob_click_id") || "",
        custom_order_gl: getParam("_gl") || getParam("__gl") || "",
        custom_order_taboola_clid: getParam("taboola_clid") || "",
        custom_order_http_referer: getParam("http_referer") || "",
        custom_order_vcid: getParam("vcid") || ""
    }, $27fc5057b004f1e0$export$1bdba1f0d9c2d49c());
};
var $27fc5057b004f1e0$export$1bdba1f0d9c2d49c = function() {
    var _window, _window$FLAGS;
    var params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
    var customParams = {};
    params["ad_id"] && (customParams.custom_order_ad_id = params["ad_id"]);
    params["campaign_id"] && (customParams.custom_order_campaign_id = params["campaign_id"]);
    params["platform"] && (customParams.custom_order_platform = params["platform"]);
    params["publisher_name"] && (customParams.custom_order_publisher_name = params["publisher_name"]);
    params["site_id"] && (customParams.custom_order_site_id = params["site_id"]);
    params["creative_id"] && (customParams.custom_order_creative_id = params["creative_id"]);
    params["creative_name"] && (customParams.custom_order_creative_name = params["creative_name"]);
    params["flight_id"] && (customParams.custom_order_flight_id = params["flight_id"]);
    params["flight_name"] && (customParams.custom_order_flight_name = params["flight_name"]);
    params["f_ver"] && (customParams.custom_order_f_ver = params["f_ver"]);
    var controllerVersion = ((_window = window) === null || _window === void 0 ? void 0 : (_window$FLAGS = _window.FLAGS) === null || _window$FLAGS === void 0 ? void 0 : _window$FLAGS.controller_v) || "not_found";
    customParams.custom_order_controller_version = controllerVersion;
    // MediaGo
    params["mg_tracking_id"] && (customParams.custom_order_mg_tracking_id = params["mg_tracking_id"]);
    // Newsbreak
    params["nb_tracking_id"] && (customParams.custom_order_nb_tracking_id = params["nb_tracking_id"]);
    params["newsbreak_cid"] && (customParams.custom_order_newsbreak_cid = params["newsbreak_cid"]);
    // Taboola
    params["tb_click_id"] && (customParams.custom_order_tb_click_id = params["tb_click_id"]);
    // Snapchat
    params["ScCid"] && (customParams.custom_order_ScCid = params["ScCid"]);
    // Rumble
    params["rb_click_id"] && (customParams.custom_order_rb_click_id = params["rb_click_id"]);
    params["force"] && (customParams.custom_order_force = params["force"]);
    return customParams;
};


var $6ce0d775c50793cb$var$instance = (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).create({
    baseURL: (0, $42a1df290c3667d2$export$e506a1d27d1eaa20).API_URL,
    headers: {
        Authorization: "Basic ".concat((0, $42a1df290c3667d2$export$e506a1d27d1eaa20).TOKEN)
    }
});
$6ce0d775c50793cb$var$instance.interceptors.response.use(function(response) {
    response.data = response.data.data.result;
    return response;
}, function(error) {
    var errorInfo = {
        reqData: error.response && error.response.data,
        reqStatus: error.response && error.response.status,
        reqHeaders: error.response && error.response.headers,
        reqConfig: error.config
    };
    Errors.report(error, errorInfo, true);
    return Promise.reject(error);
});
var $6ce0d775c50793cb$export$bf71da7aebe9ddc1 = function Api() {
    "use strict";
    (0, $fvacx._)(this, Api);
};
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.reportAffId = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).post("https://trackaffidv2-f2ow6o2dfq-uc.a.run.app", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, {
                        data: data
                    }, false, false);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.sendImportantErrorToMake = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(e) {
        var metaCountry, country, makeError, url;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    metaCountry = document.querySelector('meta[name="cf-country-code"]');
                    country = metaCountry ? metaCountry.content : "unknown";
                    makeError = {
                        country: country,
                        version: (0, $42a1df290c3667d2$export$e506a1d27d1eaa20).RELEASE,
                        url: window.location.href,
                        sentryEventId: e.sentryEventId || "N/A",
                        message: window.DEBUG ? "TEST: ".concat(e.message) : e.message,
                        error_message: window.DEBUG ? "TEST: ".concat(e.message) : e.message
                    };
                    if (e !== null && e !== void 0 && e.email) makeError.email = e.email;
                    if (e !== null && e !== void 0 && e.orderId) makeError.orderId = e.orderId;
                    url = (0, $5afc064d4f10b824$export$7138c24907de3954)((0, $42a1df290c3667d2$export$e506a1d27d1eaa20).MAKE_WH_URL, makeError);
                    return [
                        4,
                        (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).get(url)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(e) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.sendPaymentTypeToMake = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(props) {
        var url;
        return (0, $33z5g.__generator)(this, function(_state) {
            try {
                url = (0, $5afc064d4f10b824$export$7138c24907de3954)((0, $42a1df290c3667d2$export$e506a1d27d1eaa20).MAKE_PP_URL, {
                    source: props.source,
                    order: props.orderId,
                    url: window.location.href,
                    paypalBillerId: String(props.ppId)
                });
                (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).get(url);
            } catch (e) {
                Errors.report(e, {
                    props: props
                }, false, false);
            }
            return [
                2
            ];
        });
    });
    return function(props) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.getGwConfig = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(currency, country) {
        var href, url, res, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!currency || currency !== "USD") return [
                        2,
                        undefined
                    ];
                    href = document.location.href;
                    url = "".concat((0, $42a1df290c3667d2$export$e506a1d27d1eaa20).MAKE_PAYMENT_BALANCER_URL, "?country=").concat(country, "&url=").concat(href);
                    return [
                        4,
                        (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).get(url)
                    ];
                case 1:
                    res = _state.sent();
                    if (res.data === "Accepted") return [
                        2,
                        undefined
                    ];
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, undefined, undefined, false);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(currency, country) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.fetchStates = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(country) {
        var url;
        return (0, $33z5g.__generator)(this, function(_state) {
            url = "".concat((0, $42a1df290c3667d2$export$e506a1d27d1eaa20).API_URL, "/states");
            return [
                2,
                (0, $aabffe8b682b8373$export$562bc4a862c31607)(/*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var res;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).post(url, {
                                        country: country
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.data
                                ];
                        }
                    });
                }))
            ];
        });
    });
    return function(country) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.validateZipCode = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(zip) {
        var url, res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "".concat((0, $42a1df290c3667d2$export$e506a1d27d1eaa20).API_URL, "/validate-zip");
                    return [
                        4,
                        (0, $4b0de528f5b5ca15$export$2e2bcd8739ae039).post(url, {
                            zip: zip
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(zip) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.fetchOneClickProduct = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(pid) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/query-product", {
                            client: window.BRAND,
                            productId: pid
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data[0]
                    ];
            }
        });
    });
    return function(pid) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importClick = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        return (0, $33z5g.__generator)(this, function(_state) {
            return [
                2,
                (0, $aabffe8b682b8373$export$562bc4a862c31607)(/*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var res;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $6ce0d775c50793cb$var$instance.post("konnektive/import-click", data)
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    2,
                                    res.data.sessionId
                                ];
                        }
                    });
                }))
            ];
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importLead = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/import-lead", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importOneClick = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/one-click-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importPaypalOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/paypal/import-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.confirmPaypalPayment = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/paypal/confirm", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importCreditCardOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/creditcard/import-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importPaypalUpsell = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/paypal/import-upsale", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importApplePayOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/applePay/import-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importApplePayOrderExpress = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/applePay/import-order-express", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importApplePayUpsell = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/applePay/import-upsale", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importGooglePayOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/googlePay/import-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importGooglePayUpsell = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/googlePay/import-upsale", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importCreditCardUpsell = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/creditcard/import-upsale", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.queryOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(orderId) {
        var res, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/query-order", {
                            orderId: orderId
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, {
                        orderId: orderId,
                        geo: window.GEO
                    }, false, false);
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(orderId) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.updateOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/update-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.updateCustomer = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/update-customer", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        customer: data
                    }, false, false);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
// KLARNA
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.getKlarnaPaymentSession = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(payload) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("klarna/get-payment-session", payload)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(payload) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.getCustomerToken = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("klarna/get-customer-token", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.createKlarnaPaymentsOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("klarna/create-payments-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importKlarnaStripeOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/klarna/import-order-stripe", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importKlarnaStripeUpsell = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/klarna/import-upsale-stripe", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.importKlarnaOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/klarna/import-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data.result
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.createKlarnaCustomerTokenOrder = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("klarna/create-customer-token-order", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
//Everflow
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.sendEveflowAddToCart = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("everflow/track-add-to-cart", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
// Klaviyo
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.sendStartedCheckoutEventV2 = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("klaviyo/started-checkout-v2", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.sendStartedCheckoutEvent = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("klaviyo/started-checkout", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
// events
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.sendGtmDataToBigQuery = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var _getAppUtms, _data$data, _data$data2, _data$data3, _data$data4, _data$data5, res, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("bq/events/gtm", (0, $e2Ogy._)({
                            url: window.location.href,
                            auid: ((_getAppUtms = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)()) === null || _getAppUtms === void 0 ? void 0 : _getAppUtms.custom_order_auid) || "AUID_NOT_FOUND",
                            orderId: data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.transaction_id,
                            email: data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.user_id,
                            client: data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.brand,
                            version: window["main"].getAttribute("data-version"),
                            debug: window.DEBUG || false,
                            sessionId: data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.sessionId,
                            customerId: data === null || data === void 0 ? void 0 : (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.user_id
                        }, data))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    e = _state.sent();
                    console.log(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
$6ce0d775c50793cb$export$bf71da7aebe9ddc1.getMerchants = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(data) {
        var res;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6ce0d775c50793cb$var$instance.post("konnektive/query-merchant", data)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();



var $fvacx = parcelRequire("fvacx");

var $e2Ogy = parcelRequire("e2Ogy");
var $bb370a6f0f5e546c$export$51c33147a10dff3e = function(str1, str2) {
    var precision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var num1 = Number(str1);
    var num2 = Number(str2);
    if (Number.isNaN(num1) || Number.isNaN(num2)) throw new Error("Invalid input: Both arguments must be convertible to numbers.");
    var sum = num1 + num2;
    return parseFloat(sum.toFixed(precision));
};
var $bb370a6f0f5e546c$export$e20716f5fc5c5e79 = function(num) {
    if (typeof num === "number" && !Number.isNaN(num)) return num.toFixed(2);
    else return "0.00";
};
var $bb370a6f0f5e546c$export$6b9b32efe1dab9a1 = function(finalPrice) {
    var quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, shippingPrice = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var qty = quantity <= 0 ? 1 : quantity;
    var unitPriceFloat = Number(finalPrice * 100 / qty).toFixed(2);
    var shipPriceFloat = Number(shippingPrice * 100).toFixed(2);
    var totalAmount = parseFloat(unitPriceFloat) * qty + parseFloat(shipPriceFloat);
    return {
        unitPrice: Math.floor(parseFloat(unitPriceFloat)),
        totalAmount: totalAmount
    };
};
var $bb370a6f0f5e546c$export$fca6a3397460b397 = function(finalPrice) {
    var quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, shippingPrice = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var qty = quantity <= 0 ? 1 : quantity;
    var unitPrice = Number(Number(finalPrice * 100 / qty).toFixed(2));
    var totalAmount = Number(Number(unitPrice * Number(qty) + Number(shippingPrice) * 100).toFixed(0));
    return {
        unitPrice: unitPrice,
        totalAmount: totalAmount
    };
};



var $8db4f4049cc051a6$export$9ab4d56492766a00 = function Gtm() {
    "use strict";
    (0, $fvacx._)(this, Gtm);
};
$8db4f4049cc051a6$export$9ab4d56492766a00.logEvent = function(event) {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.dataLayer) {
        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).sendGtmDataToBigQuery({
            event: event === null || event === void 0 ? void 0 : event.event,
            data: event
        });
        window.dataLayer.push(event);
    }
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackErrorEvent = function(error) {
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent((0, $e2Ogy._)({
        event: "fe_error"
    }, error));
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackBuyButtonClick = function(email, orderId, paymentType, auid, sessionId, mid) {
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent({
        event: "payment_button_click",
        user_id: email,
        transaction_id: orderId,
        brand: window.BRAND,
        auid: auid || "",
        sessionId: sessionId || "",
        payment_type: paymentType || "",
        merchant_id: mid || ""
    });
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackPageView = function(category, productName) {
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent({
        event: "eec.checkoutStep",
        brand: window.BRAND,
        ecommerce: {
            checkout: {
                category: category,
                PageViewProduct: productName
            }
        }
    });
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackEmailPopupOpen = function() {
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent({
        event: "email_popup_open",
        brand: window.BRAND
    });
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackPopupEmailSubmit = function(email) {
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent({
        event: "email_popup_submit",
        brand: window.BRAND,
        user_id: email
    });
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackEmailPopupClose = function(email) {
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent({
        event: "email_popup_closed",
        brand: window.BRAND,
        user_id: email
    });
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackEmail = function(email) {
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent({
        event: "Email_Event",
        user_id: email,
        brand: window.BRAND
    });
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackUpsellButtonClick = function(paymentType, orderId, email, auid) {
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent({
        event: "upsell_payment_button_click",
        user_id: email,
        transaction_id: orderId,
        payment_type: paymentType,
        brand: window.BRAND,
        auid: auid
    });
};
$8db4f4049cc051a6$export$9ab4d56492766a00.trackTransaction = function(lead, product, upsellKey, products) {
    var _products$, _products$2;
    var category = typeof upsellKey === "number" ? "Upsell".concat(upsellKey + 1) : "Order";
    if (typeof upsellKey === "number" && product !== null && product !== void 0 && product.isDownsell) category = "Downsell".concat(upsellKey + 1);
    var isMultipleInitialProducts = Array.isArray(products) && products.length > 1;
    var gwId = isMultipleInitialProducts ? (_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.mid : product.mid;
    var shippingPrice = isMultipleInitialProducts ? (_products$2 = products[0]) === null || _products$2 === void 0 ? void 0 : _products$2.shippingPrice : product.shippingPrice;
    var gtmProducts = [];
    var gtmActionField = {
        id: lead.orderId,
        tax: "",
        coupon: "",
        gw_id: gwId,
        email: lead.emailAddress,
        payment_type: lead.paymentType,
        shipping: shippingPrice,
        revenue: (0, $bb370a6f0f5e546c$export$e20716f5fc5c5e79)(product.finalPrice + shippingPrice)
    };
    var gtmEvent = {
        event: "eec.transaction",
        transaction_id: lead.orderId,
        user_id: lead.customerId,
        auid: lead === null || lead === void 0 ? void 0 : lead.auid,
        sessionId: lead === null || lead === void 0 ? void 0 : lead.sessionId,
        brand: window.BRAND,
        ecommerce: {
            currencyCode: product.currencyCode,
            purchase: {
                actionField: gtmActionField,
                products: gtmProducts
            }
        }
    };
    if (isMultipleInitialProducts) {
        var totalPrice = 0;
        products.forEach(function(el) {
            totalPrice += Number(el.finalPrice);
            gtmActionField.revenue = (0, $bb370a6f0f5e546c$export$e20716f5fc5c5e79)(totalPrice + shippingPrice);
            gtmProducts.push({
                id: String(el.id),
                name: el.name,
                brand: window.BRAND,
                price: String(el.finalPrice),
                quantity: el.quantity,
                category: category,
                variant: "",
                position: ""
            });
        });
    } else gtmProducts.push({
        id: String(product.id),
        name: product.name,
        brand: window.BRAND,
        price: String(product.finalPrice),
        quantity: product.quantity,
        category: category,
        variant: "",
        position: ""
    });
    $8db4f4049cc051a6$export$9ab4d56492766a00.logEvent(gtmEvent);
};




var $fvacx = parcelRequire("fvacx");

var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $33z5g = parcelRequire("33z5g");

var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $e2Ogy = parcelRequire("e2Ogy");

var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $3F6om = parcelRequire("3F6om");

var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $3F6om = parcelRequire("3F6om");
var $5b6d66e75e097da8$var$TrackingHelpers = /*#__PURE__*/ function() {
    "use strict";
    function TrackingHelpers() {
        (0, $fvacx._)(this, TrackingHelpers);
    }
    (0, $3D4gQ._)(TrackingHelpers, null, [
        {
            key: "getAppUtms",
            value: function getAppUtms() {
                var params = this.getUrlParameters();
                if (typeof params === "string") // Handle the unlikely case where params is a string, though it shouldn't happen here
                throw new Error("Unexpected string result from getUrlParameters");
                var fbclid = params["fbclid"] || undefined;
                var fbclidParsed = fbclid ? String(fbclid).replace(/[\[\]\'\"]/g, "").split(",") : undefined;
                var isFbclidArray = fbclidParsed && Array.isArray(fbclidParsed);
                if (isFbclidArray) fbclid = fbclidParsed[0];
                var fbc = fbclid ? "fb.1.".concat(Math.floor(Date.now() / 1000), ".").concat(fbclid) : undefined;
                var fbp = fbclid ? "fb.1.".concat(Math.floor(Date.now() / 1000), ".").concat(Math.floor(Math.random() * 1000000000 + 1000000000)) : "";
                return {
                    affId: params["affid"],
                    custom_ttp: this.getCookie("_ttp") || undefined,
                    custom_fbc: fbc,
                    custom_fbp: fbp,
                    custom_fbclid: fbclid,
                    custom_gclid: params["gclid"],
                    custom_ttclid: params["ttclid"],
                    custom_wbraid: params["wbraid"],
                    custom_gbraid: params["gbraid"],
                    custom_order_vlmid: params["vlmid"],
                    custom_order_auid: params["utm_auid"],
                    custom_ob_click_id: params["ob_click_id"],
                    custom_gl: params["_gl"] || params["__gl"],
                    custom_taboola_clid: params["taboola_clid"]
                };
            }
        },
        {
            key: "getAllUrlParameters",
            value: // This function will return all parameters from the URL as an object
            function getAllUrlParameters() {
                var urlParams = new URLSearchParams(window.location.search);
                var params = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = urlParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $3F6om._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        params[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return params;
            }
        },
        {
            key: "getUrlParameters",
            value: function getUrlParameters(param) {
                var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var urlParams = new URLSearchParams(window.location.search);
                var params = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = urlParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $3F6om._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        params[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (typeof param === "string" && param.length > 0) return params[param] || fallback;
                return params;
            }
        },
        {
            key: "getBrowserInfo",
            value: function getBrowserInfo() {
                var userAgent = navigator.userAgent;
                var browserName = "Unknown";
                var fullVersion = "Unknown";
                if (userAgent.indexOf("Firefox") > -1) browserName = "Mozilla Firefox";
                else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) browserName = "Opera";
                else if (userAgent.indexOf("Chrome") > -1) browserName = "Google Chrome";
                else if (userAgent.indexOf("Safari") > -1) browserName = "Safari";
                else if (userAgent.indexOf("MSIE") > -1 || !!document.DOCUMENT_NODE) browserName = "Internet Explorer";
                var versionMatch = userAgent.match(/(chrome|firefox|opr|opera|safari|msie|trident(?=\/))\/?\s*(\d+)/i);
                if (versionMatch && versionMatch.length > 2) fullVersion = versionMatch[2];
                return {
                    browserName: browserName,
                    fullVersion: fullVersion,
                    userAgent: userAgent
                };
            }
        },
        {
            key: "getScreenSize",
            value: function getScreenSize() {
                return {
                    width: window.screen.width,
                    height: window.screen.height,
                    availableWidth: window.screen.availWidth,
                    availableHeight: window.screen.availHeight
                };
            }
        },
        {
            key: "getCookie",
            value: function getCookie(key) {
                var cookies = document.cookie.split(";");
                for(var i = 0; i < cookies.length; i++){
                    var cookie = cookies[i];
                    var _cookie_split = (0, $3F6om._)(cookie.split("="), 2), cookieName = _cookie_split[0], cookieValue = _cookie_split[1];
                    if (cookieName.trim() === key) return decodeURIComponent(cookieValue);
                }
                return null;
            }
        }
    ]);
    return TrackingHelpers;
}();
var $5b6d66e75e097da8$export$2e2bcd8739ae039 = $5b6d66e75e097da8$var$TrackingHelpers;


var $b1366c713aafa52b$var$TrackingService = /*#__PURE__*/ function() {
    "use strict";
    function TrackingService() {
        (0, $fvacx._)(this, TrackingService);
    }
    (0, $3D4gQ._)(TrackingService, null, [
        {
            key: "trackEvent",
            value: function trackEvent(trackingProject, eventName) {
                var additionalData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var fullUrl = window.location.href;
                var custom_order_auid = (0, $5b6d66e75e097da8$export$2e2bcd8739ae039).getAppUtms().custom_order_auid;
                var baseAdditionalData = this.buildAdditionalData();
                var body = {
                    url: fullUrl,
                    project: trackingProject !== null && trackingProject !== void 0 ? trackingProject : "",
                    event: eventName,
                    auid: custom_order_auid || "",
                    additional_data: (0, $e2Ogy._)({}, baseAdditionalData, additionalData)
                };
                if (navigator.sendBeacon) {
                    var data = JSON.stringify(body);
                    navigator.sendBeacon("".concat(this.baseURL, "tracking/event"), data);
                } else fetch("".concat(this.baseURL, "tracking/event"), {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: this.headers,
                    mode: "no-cors",
                    credentials: "omit"
                })["catch"](function() {
                // Silently fail
                });
            }
        },
        {
            key: "buildAdditionalData",
            value: function buildAdditionalData() {
                var browserInfo = (0, $5b6d66e75e097da8$export$2e2bcd8739ae039).getBrowserInfo();
                var deviceInfo = (0, $5b6d66e75e097da8$export$2e2bcd8739ae039).getScreenSize();
                var additionalParameters = (0, $5b6d66e75e097da8$export$2e2bcd8739ae039).getAllUrlParameters();
                var cookies = document.cookie.split(";").reduce(function(acc, cookie) {
                    var _cookie_trim_split = (0, $3F6om._)(cookie.trim().split("="), 2), key = _cookie_trim_split[0], value = _cookie_trim_split[1];
                    acc[key] = value;
                    return acc;
                }, {});
                var additionalData = (0, $ioWVw._)((0, $e2Ogy._)({}, browserInfo, deviceInfo, additionalParameters), {
                    cookies: cookies
                });
                return additionalData;
            }
        }
    ]);
    return TrackingService;
}();
$b1366c713aafa52b$var$TrackingService.authToken = "99714fd8-3db5-4c85-8fe1-64eb0e5dbfa1";
$b1366c713aafa52b$var$TrackingService.baseURL = "https://trc.node33.ai/";
$b1366c713aafa52b$var$TrackingService.headers = {
    "X-Authorization": $b1366c713aafa52b$var$TrackingService.authToken,
    "Content-Type": "application/json"
};
var $b1366c713aafa52b$export$2e2bcd8739ae039 = $b1366c713aafa52b$var$TrackingService;




var $4e431077f9691399$export$3672a9a17fd672c4 = /*#__PURE__*/ function() {
    "use strict";
    function Tracking() {
        (0, $fvacx._)(this, Tracking);
    }
    (0, $3D4gQ._)(Tracking, null, [
        {
            key: "trackSiftEvent",
            value: /**
   * Track a Sift event using the TrackingService infrastructure
   * @param event The Sift event data
   */ function trackSiftEvent(event) {
                try {
                    // Use the existing TrackingService infrastructure
                    (0, $b1366c713aafa52b$export$2e2bcd8739ae039).trackEvent("sift", event._sift_event_type, event);
                    if (window.DEBUG) console.log("Tracking Sift event:", event._sift_event_type, event);
                } catch (error) {
                    console.error("Error preparing Sift event:", error);
                    Errors.report(error, {
                        eventType: "sift_event_error",
                        eventName: event._sift_event_type
                    }, false, false);
                }
            }
        }
    ]);
    return Tracking;
}();
/**
   * Unified method to track events across different platforms
   * @param eventType The platform for the event ('ga' or 'sift')
   * @param eventData The event data specific to the platform
   */ $4e431077f9691399$export$3672a9a17fd672c4.trackEvent = function(eventType, eventData) {
    switch(eventType){
        case "ga":
            $4e431077f9691399$export$3672a9a17fd672c4.logEvent(eventData);
            break;
        case "sift":
            $4e431077f9691399$export$3672a9a17fd672c4.trackSiftEvent(eventData);
            break;
        default:
            console.warn("Unknown event type: ".concat(eventType));
    }
};
$4e431077f9691399$export$3672a9a17fd672c4.logEvent = function(event) {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.trackingDataLayer) {
        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).sendGtmDataToBigQuery({
            event: event === null || event === void 0 ? void 0 : event.event,
            data: event
        });
        window.trackingDataLayer.push(event);
    }
};
$4e431077f9691399$export$3672a9a17fd672c4.trackErrorEvent = function(error) {
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent((0, $e2Ogy._)({
        event: "fe_error"
    }, error));
};
$4e431077f9691399$export$3672a9a17fd672c4.trackBuyButtonClick = function(email, orderId, buttonType) {
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent({
        event: "payment_button_click",
        user_id: email,
        transaction_id: orderId,
        payment_type: buttonType,
        brand: window.BRAND
    });
};
$4e431077f9691399$export$3672a9a17fd672c4.trackPageView = function(category, productName) {
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent({
        event: "eec.checkoutStep",
        brand: window.BRAND,
        ecommerce: {
            checkout: {
                category: category,
                PageViewProduct: productName
            }
        }
    });
};
$4e431077f9691399$export$3672a9a17fd672c4.trackEmailPopupOpen = function() {
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent({
        event: "email_popup_open",
        brand: window.BRAND
    });
};
$4e431077f9691399$export$3672a9a17fd672c4.trackPopupEmailSubmit = function(email) {
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent({
        event: "email_popup_submit",
        brand: window.BRAND,
        user_id: email
    });
};
$4e431077f9691399$export$3672a9a17fd672c4.trackEmailPopupClose = function(email) {
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent({
        event: "email_popup_closed",
        brand: window.BRAND,
        user_id: email
    });
};
$4e431077f9691399$export$3672a9a17fd672c4.trackEmail = function(email) {
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent({
        event: "Email_Event",
        user_id: email,
        brand: window.BRAND
    });
};
$4e431077f9691399$export$3672a9a17fd672c4.trackUpsellButtonClick = function(paymentType, orderId, email) {
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent({
        event: "upsell_payment_button_click",
        user_id: email,
        transaction_id: orderId,
        payment_type: paymentType,
        brand: window.BRAND
    });
};
$4e431077f9691399$export$3672a9a17fd672c4.trackTransaction = function(lead, product, upsellKey, products) {
    var _products$, _products$2;
    var category = typeof upsellKey === "number" ? "Upsell".concat(upsellKey + 1) : "Order";
    if (typeof upsellKey === "number" && product !== null && product !== void 0 && product.isDownsell) category = "Downsell".concat(upsellKey + 1);
    var isMultipleInitialProducts = Array.isArray(products) && products.length > 1;
    var gwId = isMultipleInitialProducts ? (_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.mid : product.mid;
    var shippingPrice = isMultipleInitialProducts ? (_products$2 = products[0]) === null || _products$2 === void 0 ? void 0 : _products$2.shippingPrice : product.shippingPrice;
    var gtmProducts = [];
    var gtmActionField = {
        id: lead.orderId,
        tax: "",
        coupon: "",
        gw_id: gwId,
        email: lead.emailAddress,
        payment_type: lead.paymentType,
        shipping: shippingPrice,
        revenue: (0, $bb370a6f0f5e546c$export$e20716f5fc5c5e79)(product.finalPrice + shippingPrice)
    };
    var gtmEvent = {
        event: "eec.transaction",
        transaction_id: lead.orderId,
        user_id: lead.emailAddress,
        auid: lead === null || lead === void 0 ? void 0 : lead.auid,
        sessionId: lead === null || lead === void 0 ? void 0 : lead.sessionId,
        brand: window.BRAND,
        ecommerce: {
            currencyCode: product.currencyCode,
            purchase: {
                actionField: gtmActionField,
                products: gtmProducts
            }
        }
    };
    if (isMultipleInitialProducts) {
        var totalPrice = 0;
        products.forEach(function(el) {
            totalPrice += Number(el.finalPrice);
            gtmActionField.revenue = (0, $bb370a6f0f5e546c$export$e20716f5fc5c5e79)(totalPrice + shippingPrice);
            gtmProducts.push({
                id: String(el.id),
                name: el.name,
                brand: window.BRAND,
                price: String(el.finalPrice),
                quantity: el.quantity,
                category: category,
                variant: "",
                position: ""
            });
        });
    } else gtmProducts.push({
        id: String(product.id),
        name: product.name,
        brand: window.BRAND,
        price: String(product.finalPrice),
        quantity: product.quantity,
        category: category,
        variant: "",
        position: ""
    });
    $4e431077f9691399$export$3672a9a17fd672c4.logEvent(gtmEvent);
};




var $63F7w = parcelRequire("63F7w");
var $50a3061aa036fb76$export$d0a8044dce8ff2fc = function() {
    var userAgentCheck = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|webOS|Mobile|Tablet/i.test(navigator.userAgent);
    var screenCheck = window.innerWidth <= 800 && window.innerHeight <= 600;
    return userAgentCheck || screenCheck;
};
function $50a3061aa036fb76$export$a5202107d3e3cdb0() {
    var parser = new (0, (/*@__PURE__*/$parcel$interopDefault($63F7w)))();
    var result = parser.getResult();
    return {
        custom_order_device_browser: result.browser.name,
        custom_order_device_browser_version: result.browser.version,
        custom_order_device_os: result.os.name,
        custom_order_device_os_version: result.os.version,
        custom_order_device_type: result.device.type || "desktop",
        // Default to 'desktop' if not specified
        custom_order_device_user_agent: navigator.userAgent
    };
}



var $98Dv3 = parcelRequire("98Dv3");

var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $1d9736d1009d81e3$export$27924e57e9afff7f = function(input) {
    try {
        return JSON.parse(input);
    } catch (e) {
        return null;
    }
};



var $bb523a3383634612$var$customFieldsToUpsellKeys = function(order) {
    var result = {};
    var custom = order.customFields;
    if (custom !== null && custom !== void 0 && custom.promo1 && custom.promo1 !== "skip") result[custom.promo1] = 0;
    if (custom !== null && custom !== void 0 && custom.promo2 && custom.promo2 !== "skip") result[custom.promo2] = 1;
    if (custom !== null && custom !== void 0 && custom.promo3 && custom.promo3 !== "skip") result[custom.promo3] = 2;
    if (custom !== null && custom !== void 0 && custom.promo4 && custom.promo4 !== "skip") result[custom.promo4] = 3;
    return result;
};
var $bb523a3383634612$export$e8a7701893998d4e = function() {
    var purchasedStr = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("purchased");
    return (0, $1d9736d1009d81e3$export$27924e57e9afff7f)(purchasedStr);
};
var $bb523a3383634612$export$6b835e0e2980707e = function(product, isPurchased, upsellKey) {
    var purchased = $bb523a3383634612$export$e8a7701893998d4e();
    var existingPurchase = purchased !== null && purchased !== void 0 && purchased[product === null || product === void 0 ? void 0 : product.id] ? purchased === null || purchased === void 0 ? void 0 : purchased[product === null || product === void 0 ? void 0 : product.id] : {};
    if (window.DEBUG) {
        console.log("purchased:", JSON.stringify(purchased, null, 2));
        console.log("existingPurchase:", JSON.stringify(existingPurchase, null, 2));
    }
    var urlParams = new URLSearchParams(window.location.search);
    var orderId = urlParams.get("order_id") || urlParams.get("prospect_id") || "";
    var newPurchasedProduct = (0, $ioWVw._)((0, $e2Ogy._)({}, existingPurchase), {
        id: product.id,
        isPurchased: isPurchased || false,
        orderId: orderId
    });
    if (product !== null && product !== void 0 && product.isDownsell) newPurchasedProduct.isDownsell = product === null || product === void 0 ? void 0 : product.isDownsell;
    if (Number.isInteger(upsellKey)) newPurchasedProduct.upsellKey = upsellKey;
    else if (product !== null && product !== void 0 && product.upsellKey) newPurchasedProduct.upsellKey = product === null || product === void 0 ? void 0 : product.upsellKey;
    var newPurchased = (0, $4b0c2be39d3732e4$export$a6cdc56e425d0d0a)(purchased) ? (0, $ioWVw._)((0, $e2Ogy._)({}, purchased), (0, $98Dv3._)({}, product.id, newPurchasedProduct)) : (0, $98Dv3._)({}, product.id, newPurchasedProduct);
    if (window.DEBUG) console.log("newPurchased:", JSON.stringify(newPurchased, null, 2));
    (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("purchased", newPurchased, 15);
};
var $bb523a3383634612$export$29bf7b2214ed1a00 = function(order) {
    var productIdUpsellKeyMap = $bb523a3383634612$var$customFieldsToUpsellKeys(order);
    return order.products.filter(function(p) {
        return p.responseType.toLowerCase() === "success";
    }).map(function(p) {
        return {
            id: parseInt(p.productId, 10),
            mid: p.merchantId,
            sort: parseInt(p.orderItemId, 10),
            key: "",
            name: p.name,
            quantity: parseInt(p.qty, 10),
            fullPrice: parseFloat(p.price),
            finalPrice: parseFloat(p.price),
            discount: "",
            image: p.imageUrl,
            merchantTxnId: p.merchantTxnId,
            upsellKey: productIdUpsellKeyMap[p.productId],
            shippingPrice: parseFloat(p.shipping),
            currencyCode: order.currencyCode,
            currencySymbol: order.currencySymbol,
            mostPopularLabel: false,
            bestValueLabel: false,
            orderId: order.orderId
        };
    }).sort(function(a, b) {
        return a.sort - b.sort;
    });
};




var $5743262db8c9d9ed$export$bf2a34abc2ea9c3 = function(id) {
    var goodId = id.startsWith("#") ? id : "#".concat(id);
    var elements = document.querySelectorAll(goodId);
    var visible = Array.from(elements).filter(function(el) {
        var style = window.getComputedStyle(el);
        return style.display !== "none" && style.visibility !== "hidden" && el.offsetHeight !== 0;
    });
    return visible[0] || null;
};
var $5743262db8c9d9ed$export$3b7aa821f91b0b75 = function(id) {
    var goodId = id.startsWith("#") ? id : "#".concat(id);
    var elements = document.querySelectorAll(goodId);
    var visible = Array.from(elements).filter(function(el) {
        var style = window.getComputedStyle(el);
        return style.display !== "none" && style.visibility !== "hidden" && el.offsetHeight !== 0;
    });
    return visible;
};
var $5743262db8c9d9ed$export$1caa22d7c21a2ee3 = function(el) {
    if (el) {
        var style = window.getComputedStyle(el);
        return style.display === "none" || style.visibility === "hidden" || el.offsetHeight === 0;
    }
    return false;
};
var $5743262db8c9d9ed$export$d395e3b20a2c5108 = function(id) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var el = $5743262db8c9d9ed$export$bf2a34abc2ea9c3(id);
    if (el) el.value = value;
};
var $5743262db8c9d9ed$export$ecf43e4c55e727c6 = function(elementIds, selectedAddon) {
    if (window.DEBUG) {
        console.log("elementIds: ", elementIds);
        console.log("selectedAddon: ", selectedAddon);
    }
    if (Array.isArray(elementIds) && selectedAddon) elementIds.forEach(function(id) {
        var elements = document.querySelectorAll("#".concat(id));
        if (window.DEBUG) console.log("elements: ", elements);
        elements.forEach(function(element) {
            if (window.DEBUG) console.log("element: ", element);
            element.setAttribute("data-product-name", "".concat(selectedAddon.name));
            element.setAttribute("data-shipping-price", "".concat(selectedAddon.shippingPrice));
            element.setAttribute("data-full-price", "".concat(selectedAddon.fullPrice));
            element.setAttribute("data-quantity", "".concat(selectedAddon.quantity));
            element.setAttribute("data-final-price", "".concat(selectedAddon.finalPrice));
            element.setAttribute("data-currency", "".concat(selectedAddon.currencyCode));
            element.setAttribute("data-product-id", "".concat(selectedAddon.id));
            element.setAttribute("data-discount-price", "".concat(selectedAddon.discountPrice));
        });
    });
};




var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $33z5g = parcelRequire("33z5g");

var $4c850424c21bdc2e$export$e2564d8ddd8b7a24 = [
    "de",
    "uk",
    "eu",
    "fr",
    "ch",
    "se",
    "no",
    "dk",
    "it",
    "nl",
    "at"
];






var $7754e9c9dfeff508$export$8f28b0615eb59db7 = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(orderId, productId) {
        var _order$products, order;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).queryOrder(orderId)
                    ];
                case 1:
                    order = _state.sent();
                    return [
                        2,
                        Boolean(order === null || order === void 0 ? void 0 : (_order$products = order.products) === null || _order$products === void 0 ? void 0 : _order$products.find(function(el) {
                            return String(el === null || el === void 0 ? void 0 : el.productId) === String(productId);
                        }))
                    ];
            }
        });
    });
    return function isCurrentProductTaken(orderId, productId) {
        return _ref.apply(this, arguments);
    };
}();
var $7754e9c9dfeff508$export$dea3cb4e0caec01a = function() {
    var slug = (0, $5afc064d4f10b824$export$29f5936f887dc758)();
    var stateIsNotRequired = (0, $4c850424c21bdc2e$export$e2564d8ddd8b7a24).some(function(locale) {
        return slug.startsWith(locale);
    });
    return !stateIsNotRequired;
};
var $7754e9c9dfeff508$var$getKonnektiveLead = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(orderId, campaignId) {
        var _orderInfo$customFiel, params, orderInfo, state, purchased, sessionId;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).queryOrder(orderId)
                    ];
                case 1:
                    orderInfo = _state.sent();
                    if (!orderInfo) {
                        // prospect_id or order_id is probably malformed so we need to remove it
                        (0, $4aacaa5cfd9fe25b$export$6a874b7a74007875)("order_id");
                        (0, $5afc064d4f10b824$export$4f9c066ec897736f)([
                            "order_id",
                            "prospect_id"
                        ]);
                        return [
                            2,
                            {
                                purchased: [],
                                lead: {}
                            }
                        ];
                    }
                    state = $7754e9c9dfeff508$export$dea3cb4e0caec01a() ? orderInfo.state : "";
                    purchased = (0, $bb523a3383634612$export$29bf7b2214ed1a00)(orderInfo);
                    sessionId = params["session_id"] || ((_orderInfo$customFiel = orderInfo.customFields) === null || _orderInfo$customFiel === void 0 ? void 0 : _orderInfo$customFiel.sid);
                    return [
                        2,
                        {
                            purchased: purchased,
                            lead: (0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)({}, (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)()), {
                                state: state,
                                orderId: orderId,
                                sessionId: sessionId,
                                campaignId: campaignId,
                                client: window.BRAND,
                                paySource: orderInfo.paySource,
                                emailAddress: orderInfo.emailAddress,
                                firstName: orderInfo.firstName,
                                lastName: orderInfo.lastName,
                                country: orderInfo.country,
                                city: orderInfo.city,
                                address1: orderInfo.address1,
                                phoneNumber: orderInfo.phoneNumber,
                                postalCode: orderInfo.postalCode,
                                ipAddress: orderInfo.ipAddress,
                                billShipSame: true
                            }), orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.customFields)
                        }
                    ];
            }
        });
    });
    return function getKonnektiveLead(orderId, campaignId) {
        return _ref.apply(this, arguments);
    };
}();
var $7754e9c9dfeff508$export$97850e2d25587c0d = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(campaignId) {
        var params, _params_order_id, _ref, oid, _ref1, lead, purchased;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
                    oid = (_ref = (_params_order_id = params["order_id"]) !== null && _params_order_id !== void 0 ? _params_order_id : params["prospect_id"]) !== null && _ref !== void 0 ? _ref : (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("order_id");
                    if (!oid) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $7754e9c9dfeff508$var$getKonnektiveLead(oid, campaignId)
                    ];
                case 1:
                    _ref1 = _state.sent(), lead = _ref1.lead, purchased = _ref1.purchased;
                    return [
                        2,
                        {
                            lead: lead,
                            purchased: purchased
                        }
                    ];
                case 2:
                    (0, $4aacaa5cfd9fe25b$export$6a874b7a74007875)("purchased");
                    return [
                        2,
                        {
                            lead: {},
                            purchased: []
                        }
                    ];
            }
        });
    });
    return function getLead(campaignId) {
        return _ref.apply(this, arguments);
    };
}();



var $e2Ogy = parcelRequire("e2Ogy");

var $fvacx = parcelRequire("fvacx");
var $a5ff8135e9f311cf$export$f342686c709850c7 = function StorageService() {
    "use strict";
    (0, $fvacx._)(this, StorageService);
};
$a5ff8135e9f311cf$export$f342686c709850c7.fromStorage = function(key, fallback) {
    var storage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : localStorage;
    try {
        var valueRaw = storage.getItem(key);
        return valueRaw ? JSON.parse(valueRaw) : fallback;
    } catch (e) {
        Errors.report(e, {
            key: key
        });
    }
};
$a5ff8135e9f311cf$export$f342686c709850c7.toStorage = function(key) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, storage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : localStorage;
    try {
        var serialized = JSON.stringify(data);
        storage.setItem(key, serialized);
    } catch (e) {
        Errors.report(e, {
            key: data
        });
    }
};
$a5ff8135e9f311cf$export$f342686c709850c7.localStorageSupported = function() {
    var test = "test";
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
};
$a5ff8135e9f311cf$export$f342686c709850c7.sessionStorageSupported = function() {
    var test = "test";
    try {
        sessionStorage.setItem(test, test);
        sessionStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
};



var $13c7326b49cbd18b$export$154e6e3e573edb4e = function(params) {
    var currentParams = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
    var savedPrams = (0, $a5ff8135e9f311cf$export$f342686c709850c7).fromStorage("url_params", undefined, sessionStorage);
    delete currentParams["token"];
    delete currentParams["ba_token"];
    delete currentParams["errorMsg"];
    delete currentParams["cancel_url"];
    delete currentParams["paypalAccept"];
    var mergedParams = (0, $e2Ogy._)({}, savedPrams, currentParams);
    if (params !== null && params !== void 0 && params.orderId) {
        mergedParams.prospect_id = params.orderId;
        mergedParams.order_id = params.orderId;
    }
    if (params !== null && params !== void 0 && params.sessionId) mergedParams.session_id = params.sessionId;
    if (params !== null && params !== void 0 && params.customerId) mergedParams.customer_id = params.customerId;
    if (params !== null && params !== void 0 && params.pid) mergedParams.pid = params.pid;
    (0, $a5ff8135e9f311cf$export$f342686c709850c7).toStorage("url_params", mergedParams, sessionStorage);
    return Object.values(mergedParams).length > 0 ? new URLSearchParams(mergedParams).toString() : "";
};
var $13c7326b49cbd18b$export$ff7962acd6052c28 = function(urlPath, lead, params) {
    var route = window.location.origin;
    if (urlPath.startsWith("/")) route += urlPath;
    else route += "/".concat(urlPath);
    var urlParams = $13c7326b49cbd18b$export$154e6e3e573edb4e((0, $e2Ogy._)({}, lead, params));
    console.log(urlParams);
    window.location.href = urlParams ? "".concat(route, "?").concat(urlParams) : route;
};
var $13c7326b49cbd18b$export$3f6adbb122bb5170 = function() {
    var pathname = window.location.pathname;
    return pathname.includes("products-order") && !window.IS_1_CLICK;
};
var $13c7326b49cbd18b$export$bfaa5087b7d8bc5d = function() {
    var pathname = window.location.pathname;
    return pathname.includes("click-order");
};
var $13c7326b49cbd18b$export$4117b60638bd0579 = function() {
    var pathname = window.location.pathname;
    return pathname.includes("products-order") && window.IS_1_CLICK;
};
var $13c7326b49cbd18b$export$200a98ceebf95bbb = function() {
    var pathname = window.location.pathname;
    return pathname.includes("thank-you");
};
var $13c7326b49cbd18b$export$504c889bcc104ed7 = function(no) {
    var pathname = window.location.pathname;
    if (typeof no === "number") return pathname.includes("promo-order-".concat(no));
    else return pathname.includes("promo-order-");
};





var $3F6om = parcelRequire("3F6om");

var $33z5g = parcelRequire("33z5g");

var $ffHpO = parcelRequire("ffHpO");


var $48bbe448a6f79255$var$emailRe = /^.+@.+\..+$/i;
var $48bbe448a6f79255$export$18148d12c805c5b0 = function(value) {
    if (typeof value === "string" && value.length <= 320) {
        if (!$48bbe448a6f79255$var$emailRe.test(value)) return false;
        var _value_split = (0, $3F6om._)(value.split("@"), 2), local = _value_split[0], domain = _value_split[1];
        return local.length <= 64 && domain.length <= 255;
    }
    return false;
};
var $48bbe448a6f79255$var$emailStr = function() {
    return (0, $ffHpO.define)("email", $48bbe448a6f79255$export$18148d12c805c5b0);
};
var $48bbe448a6f79255$export$bef94a5618bf18bf = function(url) {
    if (!url) return false;
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
};
var $48bbe448a6f79255$export$d45f86db23af717 = function() {
    var _getVisibleElementByI, _getVisibleElementByI2, _getVisibleElementByI3;
    var email = (_getVisibleElementByI = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("emailAddress")) === null || _getVisibleElementByI === void 0 ? void 0 : _getVisibleElementByI.value;
    var firstName = (_getVisibleElementByI2 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("firstName")) === null || _getVisibleElementByI2 === void 0 ? void 0 : _getVisibleElementByI2.value;
    var lastName = (_getVisibleElementByI3 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("lastName")) === null || _getVisibleElementByI3 === void 0 ? void 0 : _getVisibleElementByI3.value;
    if (email && firstName && lastName) return $48bbe448a6f79255$export$18148d12c805c5b0(email) && firstName.length > 0 && lastName.length > 0;
    return false;
};
var $48bbe448a6f79255$export$a7644059e2dddcf = {
    niceType: "Mastercard",
    type: "mastercard",
    patterns: [
        [
            51,
            55
        ],
        [
            2221,
            2229
        ],
        [
            223,
            229
        ],
        [
            23,
            26
        ],
        [
            270,
            271
        ],
        2720
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16
    ],
    code: {
        name: "CVC",
        size: 3
    },
    matchStrength: 2
};
var $48bbe448a6f79255$var$LeadSchema = (0, $ffHpO.object)({
    campaignId: (0, $ffHpO.number)(),
    sessionId: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    client: (0, $ffHpO.string)(),
    orderId: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    paySource: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    customerId: (0, $ffHpO.optional)((0, $ffHpO.number)()),
    firstName: (0, $ffHpO.string)(),
    lastName: (0, $ffHpO.string)(),
    phoneNumber: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    emailAddress: $48bbe448a6f79255$var$emailStr(),
    ipAddress: (0, $ffHpO.string)(),
    country: (0, $ffHpO.string)(),
    city: (0, $ffHpO.string)(),
    state: (0, $ffHpO.string)(),
    address1: (0, $ffHpO.string)(),
    postalCode: (0, $ffHpO.string)(),
    shipPostalCode: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    billShipSame: (0, $ffHpO.boolean)(),
    affId: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_fbc: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_fbp: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_ttp: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_fbclid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_vlmid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_ttclid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_user_agent: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_receive_sms: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_sms_consent: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_http_referer: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_auid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_language: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_10_off_vip: (0, $ffHpO.optional)((0, $ffHpO.boolean)()),
    custom_gl: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_gclid: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_wbraid: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_gbraid: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_taboola_clid: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_ob_click_id: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_order_marketing_opt_in: window.IS_MAIN ? (0, $ffHpO.literal)(true) : (0, $ffHpO.optional)((0, $ffHpO.boolean)()),
    custom_order_affId: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_ttp: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_fbc: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_fbp: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_fbclid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_ga: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_ad_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_gclid: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_order_ttclid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_wbraid: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_order_gbraid: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_order_ob_click_id: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_order_gl: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_order_taboola_clid: (0, $ffHpO.optional)((0, $ffHpO.union)([
        (0, $ffHpO.string)(),
        (0, $ffHpO.array)((0, $ffHpO.string)())
    ])),
    custom_order_http_referer: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_device_browser: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_device_browser_version: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_device_os: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_device_os_version: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_device_type: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_device_user_agent: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_vcid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_vcid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_m_ab_var: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_m_ab_name: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_ab_name: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_ab_var: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_campaign_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_platform: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_publisher_name: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_site_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_creative_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_creative_name: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_flight_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_flight_name: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_mg_tracking_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_nb_tracking_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_newsbreak_cid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_tb_click_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_f_ver: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_ScCid: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_rb_click_id: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_controller_version: (0, $ffHpO.optional)((0, $ffHpO.string)()),
    custom_order_force: (0, $ffHpO.optional)((0, $ffHpO.string)())
});
var $48bbe448a6f79255$export$ea94ad0a55726449 = function(lead) {
    (0, $ffHpO.assert)(lead, $48bbe448a6f79255$var$LeadSchema);
};
var $48bbe448a6f79255$export$3a96efd44caaf481 = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(zip, state, country) {
        var _ref, zipData, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (country !== "US") return [
                        2,
                        zip
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).validateZipCode(zip)
                    ];
                case 2:
                    _ref = _state.sent(), zipData = _ref.state;
                    if (zipData !== null && zipData !== void 0 && zipData.state && state === zipData.state) return [
                        2,
                        zip
                    ];
                    else return [
                        2,
                        $48bbe448a6f79255$var$exampleZipCodes[state]
                    ];
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        $48bbe448a6f79255$var$exampleZipCodes[state]
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function validateZipCode(zip, state, country) {
        return _ref.apply(this, arguments);
    };
}();
var $48bbe448a6f79255$var$exampleZipCodes = {
    AL: "35004",
    AK: "99501",
    AZ: "85001",
    AR: "71601",
    CA: "90001",
    CO: "80001",
    CT: "06001",
    DE: "19701",
    FL: "32003",
    GA: "30002",
    HI: "96701",
    ID: "83201",
    IL: "60001",
    IN: "46001",
    IA: "50001",
    KS: "66002",
    KY: "40003",
    LA: "70001",
    ME: "03901",
    MD: "20601",
    MA: "01001",
    MI: "48001",
    MN: "55001",
    MS: "38601",
    MO: "63005",
    MT: "59001",
    NE: "68001",
    NV: "88901",
    NH: "03031",
    NJ: "07001",
    NM: "87001",
    NY: "10001",
    NC: "27006",
    ND: "58001",
    OH: "43001",
    OK: "73001",
    OR: "97001",
    PA: "15001",
    RI: "02801",
    SC: "29001",
    SD: "57001",
    TN: "37010",
    TX: "75001",
    UT: "84001",
    VT: "05001",
    VA: "20105",
    WA: "98001",
    WV: "24701",
    WI: "53001",
    WY: "82001",
    AS: "96799",
    GU: "96910",
    MP: "96950",
    PR: "00601",
    VI: "00801"
};




var $fvacx = parcelRequire("fvacx");

var $8xYJx = parcelRequire("8xYJx");

var $33z5g = parcelRequire("33z5g");
var $8d17a8b620b4099c$exports = {};
$8d17a8b620b4099c$exports = JSON.parse('[{"name":"Afghanistan","isoCode":"AF","flag":"\uD83C\uDDE6\uD83C\uDDEB","phonecode":"93","currency":"AFN","latitude":"33.00000000","longitude":"65.00000000","timezones":[{"zoneName":"Asia/Kabul","gmtOffset":16200,"gmtOffsetName":"UTC+04:30","abbreviation":"AFT","tzName":"Afghanistan Time"}]},{"name":"Aland Islands","isoCode":"AX","flag":"\uD83C\uDDE6\uD83C\uDDFD","phonecode":"+358-18","currency":"EUR","latitude":"60.11666700","longitude":"19.90000000","timezones":[{"zoneName":"Europe/Mariehamn","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Albania","isoCode":"AL","flag":"\uD83C\uDDE6\uD83C\uDDF1","phonecode":"355","currency":"ALL","latitude":"41.00000000","longitude":"20.00000000","timezones":[{"zoneName":"Europe/Tirane","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Algeria","isoCode":"DZ","flag":"\uD83C\uDDE9\uD83C\uDDFF","phonecode":"213","currency":"DZD","latitude":"28.00000000","longitude":"3.00000000","timezones":[{"zoneName":"Africa/Algiers","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"American Samoa","isoCode":"AS","flag":"\uD83C\uDDE6\uD83C\uDDF8","phonecode":"+1-684","currency":"USD","latitude":"-14.33333333","longitude":"-170.00000000","timezones":[{"zoneName":"Pacific/Pago_Pago","gmtOffset":-39600,"gmtOffsetName":"UTC-11:00","abbreviation":"SST","tzName":"Samoa Standard Time"}]},{"name":"Andorra","isoCode":"AD","flag":"\uD83C\uDDE6\uD83C\uDDE9","phonecode":"376","currency":"EUR","latitude":"42.50000000","longitude":"1.50000000","timezones":[{"zoneName":"Europe/Andorra","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Angola","isoCode":"AO","flag":"\uD83C\uDDE6\uD83C\uDDF4","phonecode":"244","currency":"AOA","latitude":"-12.50000000","longitude":"18.50000000","timezones":[{"zoneName":"Africa/Luanda","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Anguilla","isoCode":"AI","flag":"\uD83C\uDDE6\uD83C\uDDEE","phonecode":"+1-264","currency":"XCD","latitude":"18.25000000","longitude":"-63.16666666","timezones":[{"zoneName":"America/Anguilla","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Antarctica","isoCode":"AQ","flag":"\uD83C\uDDE6\uD83C\uDDF6","phonecode":"672","currency":"AAD","latitude":"-74.65000000","longitude":"4.48000000","timezones":[{"zoneName":"Antarctica/Casey","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AWST","tzName":"Australian Western Standard Time"},{"zoneName":"Antarctica/Davis","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"DAVT","tzName":"Davis Time"},{"zoneName":"Antarctica/DumontDUrville","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"DDUT","tzName":"Dumont d\'Urville Time"},{"zoneName":"Antarctica/Mawson","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"MAWT","tzName":"Mawson Station Time"},{"zoneName":"Antarctica/McMurdo","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"NZDT","tzName":"New Zealand Daylight Time"},{"zoneName":"Antarctica/Palmer","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"CLST","tzName":"Chile Summer Time"},{"zoneName":"Antarctica/Rothera","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ROTT","tzName":"Rothera Research Station Time"},{"zoneName":"Antarctica/Syowa","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"SYOT","tzName":"Showa Station Time"},{"zoneName":"Antarctica/Troll","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"},{"zoneName":"Antarctica/Vostok","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"VOST","tzName":"Vostok Station Time"}]},{"name":"Antigua And Barbuda","isoCode":"AG","flag":"\uD83C\uDDE6\uD83C\uDDEC","phonecode":"+1-268","currency":"XCD","latitude":"17.05000000","longitude":"-61.80000000","timezones":[{"zoneName":"America/Antigua","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Argentina","isoCode":"AR","flag":"\uD83C\uDDE6\uD83C\uDDF7","phonecode":"54","currency":"ARS","latitude":"-34.00000000","longitude":"-64.00000000","timezones":[{"zoneName":"America/Argentina/Buenos_Aires","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Catamarca","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Cordoba","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Jujuy","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/La_Rioja","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Mendoza","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Rio_Gallegos","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Salta","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/San_Juan","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/San_Luis","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Tucuman","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Ushuaia","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"}]},{"name":"Armenia","isoCode":"AM","flag":"\uD83C\uDDE6\uD83C\uDDF2","phonecode":"374","currency":"AMD","latitude":"40.00000000","longitude":"45.00000000","timezones":[{"zoneName":"Asia/Yerevan","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"AMT","tzName":"Armenia Time"}]},{"name":"Aruba","isoCode":"AW","flag":"\uD83C\uDDE6\uD83C\uDDFC","phonecode":"297","currency":"AWG","latitude":"12.50000000","longitude":"-69.96666666","timezones":[{"zoneName":"America/Aruba","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Australia","isoCode":"AU","flag":"\uD83C\uDDE6\uD83C\uDDFA","phonecode":"61","currency":"AUD","latitude":"-27.00000000","longitude":"133.00000000","timezones":[{"zoneName":"Antarctica/Macquarie","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"MIST","tzName":"Macquarie Island Station Time"},{"zoneName":"Australia/Adelaide","gmtOffset":37800,"gmtOffsetName":"UTC+10:30","abbreviation":"ACDT","tzName":"Australian Central Daylight Saving Time"},{"zoneName":"Australia/Brisbane","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"AEST","tzName":"Australian Eastern Standard Time"},{"zoneName":"Australia/Broken_Hill","gmtOffset":37800,"gmtOffsetName":"UTC+10:30","abbreviation":"ACDT","tzName":"Australian Central Daylight Saving Time"},{"zoneName":"Australia/Currie","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AEDT","tzName":"Australian Eastern Daylight Saving Time"},{"zoneName":"Australia/Darwin","gmtOffset":34200,"gmtOffsetName":"UTC+09:30","abbreviation":"ACST","tzName":"Australian Central Standard Time"},{"zoneName":"Australia/Eucla","gmtOffset":31500,"gmtOffsetName":"UTC+08:45","abbreviation":"ACWST","tzName":"Australian Central Western Standard Time (Unofficial)"},{"zoneName":"Australia/Hobart","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AEDT","tzName":"Australian Eastern Daylight Saving Time"},{"zoneName":"Australia/Lindeman","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"AEST","tzName":"Australian Eastern Standard Time"},{"zoneName":"Australia/Lord_Howe","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"LHST","tzName":"Lord Howe Summer Time"},{"zoneName":"Australia/Melbourne","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AEDT","tzName":"Australian Eastern Daylight Saving Time"},{"zoneName":"Australia/Perth","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"AWST","tzName":"Australian Western Standard Time"},{"zoneName":"Australia/Sydney","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AEDT","tzName":"Australian Eastern Daylight Saving Time"}]},{"name":"Austria","isoCode":"AT","flag":"\uD83C\uDDE6\uD83C\uDDF9","phonecode":"43","currency":"EUR","latitude":"47.33333333","longitude":"13.33333333","timezones":[{"zoneName":"Europe/Vienna","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Azerbaijan","isoCode":"AZ","flag":"\uD83C\uDDE6\uD83C\uDDFF","phonecode":"994","currency":"AZN","latitude":"40.50000000","longitude":"47.50000000","timezones":[{"zoneName":"Asia/Baku","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"AZT","tzName":"Azerbaijan Time"}]},{"name":"The Bahamas","isoCode":"BS","flag":"\uD83C\uDDE7\uD83C\uDDF8","phonecode":"+1-242","currency":"BSD","latitude":"24.25000000","longitude":"-76.00000000","timezones":[{"zoneName":"America/Nassau","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America)"}]},{"name":"Bahrain","isoCode":"BH","flag":"\uD83C\uDDE7\uD83C\uDDED","phonecode":"973","currency":"BHD","latitude":"26.00000000","longitude":"50.55000000","timezones":[{"zoneName":"Asia/Bahrain","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Bangladesh","isoCode":"BD","flag":"\uD83C\uDDE7\uD83C\uDDE9","phonecode":"880","currency":"BDT","latitude":"24.00000000","longitude":"90.00000000","timezones":[{"zoneName":"Asia/Dhaka","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"BDT","tzName":"Bangladesh Standard Time"}]},{"name":"Barbados","isoCode":"BB","flag":"\uD83C\uDDE7\uD83C\uDDE7","phonecode":"+1-246","currency":"BBD","latitude":"13.16666666","longitude":"-59.53333333","timezones":[{"zoneName":"America/Barbados","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Belarus","isoCode":"BY","flag":"\uD83C\uDDE7\uD83C\uDDFE","phonecode":"375","currency":"BYN","latitude":"53.00000000","longitude":"28.00000000","timezones":[{"zoneName":"Europe/Minsk","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"MSK","tzName":"Moscow Time"}]},{"name":"Belgium","isoCode":"BE","flag":"\uD83C\uDDE7\uD83C\uDDEA","phonecode":"32","currency":"EUR","latitude":"50.83333333","longitude":"4.00000000","timezones":[{"zoneName":"Europe/Brussels","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Belize","isoCode":"BZ","flag":"\uD83C\uDDE7\uD83C\uDDFF","phonecode":"501","currency":"BZD","latitude":"17.25000000","longitude":"-88.75000000","timezones":[{"zoneName":"America/Belize","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America)"}]},{"name":"Benin","isoCode":"BJ","flag":"\uD83C\uDDE7\uD83C\uDDEF","phonecode":"229","currency":"XOF","latitude":"9.50000000","longitude":"2.25000000","timezones":[{"zoneName":"Africa/Porto-Novo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Bermuda","isoCode":"BM","flag":"\uD83C\uDDE7\uD83C\uDDF2","phonecode":"+1-441","currency":"BMD","latitude":"32.33333333","longitude":"-64.75000000","timezones":[{"zoneName":"Atlantic/Bermuda","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Bhutan","isoCode":"BT","flag":"\uD83C\uDDE7\uD83C\uDDF9","phonecode":"975","currency":"BTN","latitude":"27.50000000","longitude":"90.50000000","timezones":[{"zoneName":"Asia/Thimphu","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"BTT","tzName":"Bhutan Time"}]},{"name":"Bolivia","isoCode":"BO","flag":"\uD83C\uDDE7\uD83C\uDDF4","phonecode":"591","currency":"BOB","latitude":"-17.00000000","longitude":"-65.00000000","timezones":[{"zoneName":"America/La_Paz","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"BOT","tzName":"Bolivia Time"}]},{"name":"Bosnia and Herzegovina","isoCode":"BA","flag":"\uD83C\uDDE7\uD83C\uDDE6","phonecode":"387","currency":"BAM","latitude":"44.00000000","longitude":"18.00000000","timezones":[{"zoneName":"Europe/Sarajevo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Botswana","isoCode":"BW","flag":"\uD83C\uDDE7\uD83C\uDDFC","phonecode":"267","currency":"BWP","latitude":"-22.00000000","longitude":"24.00000000","timezones":[{"zoneName":"Africa/Gaborone","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Bouvet Island","isoCode":"BV","flag":"\uD83C\uDDE7\uD83C\uDDFB","phonecode":"0055","currency":"NOK","latitude":"-54.43333333","longitude":"3.40000000","timezones":[{"zoneName":"Europe/Oslo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Brazil","isoCode":"BR","flag":"\uD83C\uDDE7\uD83C\uDDF7","phonecode":"55","currency":"BRL","latitude":"-10.00000000","longitude":"-55.00000000","timezones":[{"zoneName":"America/Araguaina","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Bahia","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Belem","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Boa_Vista","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AMT","tzName":"Amazon Time (Brazil)[3"},{"zoneName":"America/Campo_Grande","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AMT","tzName":"Amazon Time (Brazil)[3"},{"zoneName":"America/Cuiaba","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"BRT","tzName":"Brasilia Time"},{"zoneName":"America/Eirunepe","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"ACT","tzName":"Acre Time"},{"zoneName":"America/Fortaleza","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Maceio","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Manaus","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AMT","tzName":"Amazon Time (Brazil)"},{"zoneName":"America/Noronha","gmtOffset":-7200,"gmtOffsetName":"UTC-02:00","abbreviation":"FNT","tzName":"Fernando de Noronha Time"},{"zoneName":"America/Porto_Velho","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AMT","tzName":"Amazon Time (Brazil)[3"},{"zoneName":"America/Recife","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Rio_Branco","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"ACT","tzName":"Acre Time"},{"zoneName":"America/Santarem","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Sao_Paulo","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"}]},{"name":"British Indian Ocean Territory","isoCode":"IO","flag":"\uD83C\uDDEE\uD83C\uDDF4","phonecode":"246","currency":"USD","latitude":"-6.00000000","longitude":"71.50000000","timezones":[{"zoneName":"Indian/Chagos","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"IOT","tzName":"Indian Ocean Time"}]},{"name":"Brunei","isoCode":"BN","flag":"\uD83C\uDDE7\uD83C\uDDF3","phonecode":"673","currency":"BND","latitude":"4.50000000","longitude":"114.66666666","timezones":[{"zoneName":"Asia/Brunei","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"BNT","tzName":"Brunei Darussalam Time"}]},{"name":"Bulgaria","isoCode":"BG","flag":"\uD83C\uDDE7\uD83C\uDDEC","phonecode":"359","currency":"BGN","latitude":"43.00000000","longitude":"25.00000000","timezones":[{"zoneName":"Europe/Sofia","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Burkina Faso","isoCode":"BF","flag":"\uD83C\uDDE7\uD83C\uDDEB","phonecode":"226","currency":"XOF","latitude":"13.00000000","longitude":"-2.00000000","timezones":[{"zoneName":"Africa/Ouagadougou","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Burundi","isoCode":"BI","flag":"\uD83C\uDDE7\uD83C\uDDEE","phonecode":"257","currency":"BIF","latitude":"-3.50000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Bujumbura","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Cambodia","isoCode":"KH","flag":"\uD83C\uDDF0\uD83C\uDDED","phonecode":"855","currency":"KHR","latitude":"13.00000000","longitude":"105.00000000","timezones":[{"zoneName":"Asia/Phnom_Penh","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"ICT","tzName":"Indochina Time"}]},{"name":"Cameroon","isoCode":"CM","flag":"\uD83C\uDDE8\uD83C\uDDF2","phonecode":"237","currency":"XAF","latitude":"6.00000000","longitude":"12.00000000","timezones":[{"zoneName":"Africa/Douala","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Canada","isoCode":"CA","flag":"\uD83C\uDDE8\uD83C\uDDE6","phonecode":"1","currency":"CAD","latitude":"60.00000000","longitude":"-95.00000000","timezones":[{"zoneName":"America/Atikokan","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America)"},{"zoneName":"America/Blanc-Sablon","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Cambridge_Bay","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Creston","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Dawson","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Dawson_Creek","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Edmonton","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Fort_Nelson","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Glace_Bay","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Goose_Bay","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Halifax","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Inuvik","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Iqaluit","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Moncton","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Nipigon","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Pangnirtung","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Rainy_River","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Rankin_Inlet","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Regina","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Resolute","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/St_Johns","gmtOffset":-12600,"gmtOffsetName":"UTC-03:30","abbreviation":"NST","tzName":"Newfoundland Standard Time"},{"zoneName":"America/Swift_Current","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Thunder_Bay","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Toronto","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Vancouver","gmtOffset":-28800,"gmtOffsetName":"UTC-08:00","abbreviation":"PST","tzName":"Pacific Standard Time (North America"},{"zoneName":"America/Whitehorse","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Winnipeg","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Yellowknife","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"}]},{"name":"Cape Verde","isoCode":"CV","flag":"\uD83C\uDDE8\uD83C\uDDFB","phonecode":"238","currency":"CVE","latitude":"16.00000000","longitude":"-24.00000000","timezones":[{"zoneName":"Atlantic/Cape_Verde","gmtOffset":-3600,"gmtOffsetName":"UTC-01:00","abbreviation":"CVT","tzName":"Cape Verde Time"}]},{"name":"Cayman Islands","isoCode":"KY","flag":"\uD83C\uDDF0\uD83C\uDDFE","phonecode":"+1-345","currency":"KYD","latitude":"19.50000000","longitude":"-80.50000000","timezones":[{"zoneName":"America/Cayman","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Central African Republic","isoCode":"CF","flag":"\uD83C\uDDE8\uD83C\uDDEB","phonecode":"236","currency":"XAF","latitude":"7.00000000","longitude":"21.00000000","timezones":[{"zoneName":"Africa/Bangui","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Chad","isoCode":"TD","flag":"\uD83C\uDDF9\uD83C\uDDE9","phonecode":"235","currency":"XAF","latitude":"15.00000000","longitude":"19.00000000","timezones":[{"zoneName":"Africa/Ndjamena","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Chile","isoCode":"CL","flag":"\uD83C\uDDE8\uD83C\uDDF1","phonecode":"56","currency":"CLP","latitude":"-30.00000000","longitude":"-71.00000000","timezones":[{"zoneName":"America/Punta_Arenas","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"CLST","tzName":"Chile Summer Time"},{"zoneName":"America/Santiago","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"CLST","tzName":"Chile Summer Time"},{"zoneName":"Pacific/Easter","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EASST","tzName":"Easter Island Summer Time"}]},{"name":"China","isoCode":"CN","flag":"\uD83C\uDDE8\uD83C\uDDF3","phonecode":"86","currency":"CNY","latitude":"35.00000000","longitude":"105.00000000","timezones":[{"zoneName":"Asia/Shanghai","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"CST","tzName":"China Standard Time"},{"zoneName":"Asia/Urumqi","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"XJT","tzName":"China Standard Time"}]},{"name":"Christmas Island","isoCode":"CX","flag":"\uD83C\uDDE8\uD83C\uDDFD","phonecode":"61","currency":"AUD","latitude":"-10.50000000","longitude":"105.66666666","timezones":[{"zoneName":"Indian/Christmas","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"CXT","tzName":"Christmas Island Time"}]},{"name":"Cocos (Keeling) Islands","isoCode":"CC","flag":"\uD83C\uDDE8\uD83C\uDDE8","phonecode":"61","currency":"AUD","latitude":"-12.50000000","longitude":"96.83333333","timezones":[{"zoneName":"Indian/Cocos","gmtOffset":23400,"gmtOffsetName":"UTC+06:30","abbreviation":"CCT","tzName":"Cocos Islands Time"}]},{"name":"Colombia","isoCode":"CO","flag":"\uD83C\uDDE8\uD83C\uDDF4","phonecode":"57","currency":"COP","latitude":"4.00000000","longitude":"-72.00000000","timezones":[{"zoneName":"America/Bogota","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"COT","tzName":"Colombia Time"}]},{"name":"Comoros","isoCode":"KM","flag":"\uD83C\uDDF0\uD83C\uDDF2","phonecode":"269","currency":"KMF","latitude":"-12.16666666","longitude":"44.25000000","timezones":[{"zoneName":"Indian/Comoro","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Congo","isoCode":"CG","flag":"\uD83C\uDDE8\uD83C\uDDEC","phonecode":"242","currency":"XAF","latitude":"-1.00000000","longitude":"15.00000000","timezones":[{"zoneName":"Africa/Brazzaville","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Democratic Republic of the Congo","isoCode":"CD","flag":"\uD83C\uDDE8\uD83C\uDDE9","phonecode":"243","currency":"CDF","latitude":"0.00000000","longitude":"25.00000000","timezones":[{"zoneName":"Africa/Kinshasa","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"},{"zoneName":"Africa/Lubumbashi","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Cook Islands","isoCode":"CK","flag":"\uD83C\uDDE8\uD83C\uDDF0","phonecode":"682","currency":"NZD","latitude":"-21.23333333","longitude":"-159.76666666","timezones":[{"zoneName":"Pacific/Rarotonga","gmtOffset":-36000,"gmtOffsetName":"UTC-10:00","abbreviation":"CKT","tzName":"Cook Island Time"}]},{"name":"Costa Rica","isoCode":"CR","flag":"\uD83C\uDDE8\uD83C\uDDF7","phonecode":"506","currency":"CRC","latitude":"10.00000000","longitude":"-84.00000000","timezones":[{"zoneName":"America/Costa_Rica","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Cote D\'Ivoire (Ivory Coast)","isoCode":"CI","flag":"\uD83C\uDDE8\uD83C\uDDEE","phonecode":"225","currency":"XOF","latitude":"8.00000000","longitude":"-5.00000000","timezones":[{"zoneName":"Africa/Abidjan","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Croatia","isoCode":"HR","flag":"\uD83C\uDDED\uD83C\uDDF7","phonecode":"385","currency":"HRK","latitude":"45.16666666","longitude":"15.50000000","timezones":[{"zoneName":"Europe/Zagreb","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Cuba","isoCode":"CU","flag":"\uD83C\uDDE8\uD83C\uDDFA","phonecode":"53","currency":"CUP","latitude":"21.50000000","longitude":"-80.00000000","timezones":[{"zoneName":"America/Havana","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"CST","tzName":"Cuba Standard Time"}]},{"name":"Cyprus","isoCode":"CY","flag":"\uD83C\uDDE8\uD83C\uDDFE","phonecode":"357","currency":"EUR","latitude":"35.00000000","longitude":"33.00000000","timezones":[{"zoneName":"Asia/Famagusta","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Asia/Nicosia","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Czech Republic","isoCode":"CZ","flag":"\uD83C\uDDE8\uD83C\uDDFF","phonecode":"420","currency":"CZK","latitude":"49.75000000","longitude":"15.50000000","timezones":[{"zoneName":"Europe/Prague","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Denmark","isoCode":"DK","flag":"\uD83C\uDDE9\uD83C\uDDF0","phonecode":"45","currency":"DKK","latitude":"56.00000000","longitude":"10.00000000","timezones":[{"zoneName":"Europe/Copenhagen","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Djibouti","isoCode":"DJ","flag":"\uD83C\uDDE9\uD83C\uDDEF","phonecode":"253","currency":"DJF","latitude":"11.50000000","longitude":"43.00000000","timezones":[{"zoneName":"Africa/Djibouti","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Dominica","isoCode":"DM","flag":"\uD83C\uDDE9\uD83C\uDDF2","phonecode":"+1-767","currency":"XCD","latitude":"15.41666666","longitude":"-61.33333333","timezones":[{"zoneName":"America/Dominica","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Dominican Republic","isoCode":"DO","flag":"\uD83C\uDDE9\uD83C\uDDF4","phonecode":"+1-809 and 1-829","currency":"DOP","latitude":"19.00000000","longitude":"-70.66666666","timezones":[{"zoneName":"America/Santo_Domingo","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"East Timor","isoCode":"TL","flag":"\uD83C\uDDF9\uD83C\uDDF1","phonecode":"670","currency":"USD","latitude":"-8.83333333","longitude":"125.91666666","timezones":[{"zoneName":"Asia/Dili","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"TLT","tzName":"Timor Leste Time"}]},{"name":"Ecuador","isoCode":"EC","flag":"\uD83C\uDDEA\uD83C\uDDE8","phonecode":"593","currency":"USD","latitude":"-2.00000000","longitude":"-77.50000000","timezones":[{"zoneName":"America/Guayaquil","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"ECT","tzName":"Ecuador Time"},{"zoneName":"Pacific/Galapagos","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"GALT","tzName":"Gal\xe1pagos Time"}]},{"name":"Egypt","isoCode":"EG","flag":"\uD83C\uDDEA\uD83C\uDDEC","phonecode":"20","currency":"EGP","latitude":"27.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Cairo","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"El Salvador","isoCode":"SV","flag":"\uD83C\uDDF8\uD83C\uDDFB","phonecode":"503","currency":"USD","latitude":"13.83333333","longitude":"-88.91666666","timezones":[{"zoneName":"America/El_Salvador","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Equatorial Guinea","isoCode":"GQ","flag":"\uD83C\uDDEC\uD83C\uDDF6","phonecode":"240","currency":"XAF","latitude":"2.00000000","longitude":"10.00000000","timezones":[{"zoneName":"Africa/Malabo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Eritrea","isoCode":"ER","flag":"\uD83C\uDDEA\uD83C\uDDF7","phonecode":"291","currency":"ERN","latitude":"15.00000000","longitude":"39.00000000","timezones":[{"zoneName":"Africa/Asmara","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Estonia","isoCode":"EE","flag":"\uD83C\uDDEA\uD83C\uDDEA","phonecode":"372","currency":"EUR","latitude":"59.00000000","longitude":"26.00000000","timezones":[{"zoneName":"Europe/Tallinn","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Ethiopia","isoCode":"ET","flag":"\uD83C\uDDEA\uD83C\uDDF9","phonecode":"251","currency":"ETB","latitude":"8.00000000","longitude":"38.00000000","timezones":[{"zoneName":"Africa/Addis_Ababa","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Falkland Islands","isoCode":"FK","flag":"\uD83C\uDDEB\uD83C\uDDF0","phonecode":"500","currency":"FKP","latitude":"-51.75000000","longitude":"-59.00000000","timezones":[{"zoneName":"Atlantic/Stanley","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"FKST","tzName":"Falkland Islands Summer Time"}]},{"name":"Faroe Islands","isoCode":"FO","flag":"\uD83C\uDDEB\uD83C\uDDF4","phonecode":"298","currency":"DKK","latitude":"62.00000000","longitude":"-7.00000000","timezones":[{"zoneName":"Atlantic/Faroe","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"WET","tzName":"Western European Time"}]},{"name":"Fiji Islands","isoCode":"FJ","flag":"\uD83C\uDDEB\uD83C\uDDEF","phonecode":"679","currency":"FJD","latitude":"-18.00000000","longitude":"175.00000000","timezones":[{"zoneName":"Pacific/Fiji","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"FJT","tzName":"Fiji Time"}]},{"name":"Finland","isoCode":"FI","flag":"\uD83C\uDDEB\uD83C\uDDEE","phonecode":"358","currency":"EUR","latitude":"64.00000000","longitude":"26.00000000","timezones":[{"zoneName":"Europe/Helsinki","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"France","isoCode":"FR","flag":"\uD83C\uDDEB\uD83C\uDDF7","phonecode":"33","currency":"EUR","latitude":"46.00000000","longitude":"2.00000000","timezones":[{"zoneName":"Europe/Paris","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"French Guiana","isoCode":"GF","flag":"\uD83C\uDDEC\uD83C\uDDEB","phonecode":"594","currency":"EUR","latitude":"4.00000000","longitude":"-53.00000000","timezones":[{"zoneName":"America/Cayenne","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"GFT","tzName":"French Guiana Time"}]},{"name":"French Polynesia","isoCode":"PF","flag":"\uD83C\uDDF5\uD83C\uDDEB","phonecode":"689","currency":"XPF","latitude":"-15.00000000","longitude":"-140.00000000","timezones":[{"zoneName":"Pacific/Gambier","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"GAMT","tzName":"Gambier Islands Time"},{"zoneName":"Pacific/Marquesas","gmtOffset":-34200,"gmtOffsetName":"UTC-09:30","abbreviation":"MART","tzName":"Marquesas Islands Time"},{"zoneName":"Pacific/Tahiti","gmtOffset":-36000,"gmtOffsetName":"UTC-10:00","abbreviation":"TAHT","tzName":"Tahiti Time"}]},{"name":"French Southern Territories","isoCode":"TF","flag":"\uD83C\uDDF9\uD83C\uDDEB","phonecode":"262","currency":"EUR","latitude":"-49.25000000","longitude":"69.16700000","timezones":[{"zoneName":"Indian/Kerguelen","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"TFT","tzName":"French Southern and Antarctic Time"}]},{"name":"Gabon","isoCode":"GA","flag":"\uD83C\uDDEC\uD83C\uDDE6","phonecode":"241","currency":"XAF","latitude":"-1.00000000","longitude":"11.75000000","timezones":[{"zoneName":"Africa/Libreville","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"The Gambia","isoCode":"GM","flag":"\uD83C\uDDEC\uD83C\uDDF2","phonecode":"220","currency":"GMD","latitude":"13.46666666","longitude":"-16.56666666","timezones":[{"zoneName":"Africa/Banjul","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Georgia","isoCode":"GE","flag":"\uD83C\uDDEC\uD83C\uDDEA","phonecode":"995","currency":"GEL","latitude":"42.00000000","longitude":"43.50000000","timezones":[{"zoneName":"Asia/Tbilisi","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"GET","tzName":"Georgia Standard Time"}]},{"name":"Germany","isoCode":"DE","flag":"\uD83C\uDDE9\uD83C\uDDEA","phonecode":"49","currency":"EUR","latitude":"51.00000000","longitude":"9.00000000","timezones":[{"zoneName":"Europe/Berlin","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"},{"zoneName":"Europe/Busingen","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Ghana","isoCode":"GH","flag":"\uD83C\uDDEC\uD83C\uDDED","phonecode":"233","currency":"GHS","latitude":"8.00000000","longitude":"-2.00000000","timezones":[{"zoneName":"Africa/Accra","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Gibraltar","isoCode":"GI","flag":"\uD83C\uDDEC\uD83C\uDDEE","phonecode":"350","currency":"GIP","latitude":"36.13333333","longitude":"-5.35000000","timezones":[{"zoneName":"Europe/Gibraltar","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Greece","isoCode":"GR","flag":"\uD83C\uDDEC\uD83C\uDDF7","phonecode":"30","currency":"EUR","latitude":"39.00000000","longitude":"22.00000000","timezones":[{"zoneName":"Europe/Athens","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Greenland","isoCode":"GL","flag":"\uD83C\uDDEC\uD83C\uDDF1","phonecode":"299","currency":"DKK","latitude":"72.00000000","longitude":"-40.00000000","timezones":[{"zoneName":"America/Danmarkshavn","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"},{"zoneName":"America/Nuuk","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"WGT","tzName":"West Greenland Time"},{"zoneName":"America/Scoresbysund","gmtOffset":-3600,"gmtOffsetName":"UTC-01:00","abbreviation":"EGT","tzName":"Eastern Greenland Time"},{"zoneName":"America/Thule","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Grenada","isoCode":"GD","flag":"\uD83C\uDDEC\uD83C\uDDE9","phonecode":"+1-473","currency":"XCD","latitude":"12.11666666","longitude":"-61.66666666","timezones":[{"zoneName":"America/Grenada","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Guadeloupe","isoCode":"GP","flag":"\uD83C\uDDEC\uD83C\uDDF5","phonecode":"590","currency":"EUR","latitude":"16.25000000","longitude":"-61.58333300","timezones":[{"zoneName":"America/Guadeloupe","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Guam","isoCode":"GU","flag":"\uD83C\uDDEC\uD83C\uDDFA","phonecode":"+1-671","currency":"USD","latitude":"13.46666666","longitude":"144.78333333","timezones":[{"zoneName":"Pacific/Guam","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"CHST","tzName":"Chamorro Standard Time"}]},{"name":"Guatemala","isoCode":"GT","flag":"\uD83C\uDDEC\uD83C\uDDF9","phonecode":"502","currency":"GTQ","latitude":"15.50000000","longitude":"-90.25000000","timezones":[{"zoneName":"America/Guatemala","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Guernsey and Alderney","isoCode":"GG","flag":"\uD83C\uDDEC\uD83C\uDDEC","phonecode":"+44-1481","currency":"GBP","latitude":"49.46666666","longitude":"-2.58333333","timezones":[{"zoneName":"Europe/Guernsey","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Guinea","isoCode":"GN","flag":"\uD83C\uDDEC\uD83C\uDDF3","phonecode":"224","currency":"GNF","latitude":"11.00000000","longitude":"-10.00000000","timezones":[{"zoneName":"Africa/Conakry","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Guinea-Bissau","isoCode":"GW","flag":"\uD83C\uDDEC\uD83C\uDDFC","phonecode":"245","currency":"XOF","latitude":"12.00000000","longitude":"-15.00000000","timezones":[{"zoneName":"Africa/Bissau","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Guyana","isoCode":"GY","flag":"\uD83C\uDDEC\uD83C\uDDFE","phonecode":"592","currency":"GYD","latitude":"5.00000000","longitude":"-59.00000000","timezones":[{"zoneName":"America/Guyana","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"GYT","tzName":"Guyana Time"}]},{"name":"Haiti","isoCode":"HT","flag":"\uD83C\uDDED\uD83C\uDDF9","phonecode":"509","currency":"HTG","latitude":"19.00000000","longitude":"-72.41666666","timezones":[{"zoneName":"America/Port-au-Prince","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Heard Island and McDonald Islands","isoCode":"HM","flag":"\uD83C\uDDED\uD83C\uDDF2","phonecode":"672","currency":"AUD","latitude":"-53.10000000","longitude":"72.51666666","timezones":[{"zoneName":"Indian/Kerguelen","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"TFT","tzName":"French Southern and Antarctic Time"}]},{"name":"Honduras","isoCode":"HN","flag":"\uD83C\uDDED\uD83C\uDDF3","phonecode":"504","currency":"HNL","latitude":"15.00000000","longitude":"-86.50000000","timezones":[{"zoneName":"America/Tegucigalpa","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Hong Kong S.A.R.","isoCode":"HK","flag":"\uD83C\uDDED\uD83C\uDDF0","phonecode":"852","currency":"HKD","latitude":"22.25000000","longitude":"114.16666666","timezones":[{"zoneName":"Asia/Hong_Kong","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"HKT","tzName":"Hong Kong Time"}]},{"name":"Hungary","isoCode":"HU","flag":"\uD83C\uDDED\uD83C\uDDFA","phonecode":"36","currency":"HUF","latitude":"47.00000000","longitude":"20.00000000","timezones":[{"zoneName":"Europe/Budapest","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Iceland","isoCode":"IS","flag":"\uD83C\uDDEE\uD83C\uDDF8","phonecode":"354","currency":"ISK","latitude":"65.00000000","longitude":"-18.00000000","timezones":[{"zoneName":"Atlantic/Reykjavik","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"India","isoCode":"IN","flag":"\uD83C\uDDEE\uD83C\uDDF3","phonecode":"91","currency":"INR","latitude":"20.00000000","longitude":"77.00000000","timezones":[{"zoneName":"Asia/Kolkata","gmtOffset":19800,"gmtOffsetName":"UTC+05:30","abbreviation":"IST","tzName":"Indian Standard Time"}]},{"name":"Indonesia","isoCode":"ID","flag":"\uD83C\uDDEE\uD83C\uDDE9","phonecode":"62","currency":"IDR","latitude":"-5.00000000","longitude":"120.00000000","timezones":[{"zoneName":"Asia/Jakarta","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"WIB","tzName":"Western Indonesian Time"},{"zoneName":"Asia/Jayapura","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"WIT","tzName":"Eastern Indonesian Time"},{"zoneName":"Asia/Makassar","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"WITA","tzName":"Central Indonesia Time"},{"zoneName":"Asia/Pontianak","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"WIB","tzName":"Western Indonesian Time"}]},{"name":"Iran","isoCode":"IR","flag":"\uD83C\uDDEE\uD83C\uDDF7","phonecode":"98","currency":"IRR","latitude":"32.00000000","longitude":"53.00000000","timezones":[{"zoneName":"Asia/Tehran","gmtOffset":12600,"gmtOffsetName":"UTC+03:30","abbreviation":"IRDT","tzName":"Iran Daylight Time"}]},{"name":"Iraq","isoCode":"IQ","flag":"\uD83C\uDDEE\uD83C\uDDF6","phonecode":"964","currency":"IQD","latitude":"33.00000000","longitude":"44.00000000","timezones":[{"zoneName":"Asia/Baghdad","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Ireland","isoCode":"IE","flag":"\uD83C\uDDEE\uD83C\uDDEA","phonecode":"353","currency":"EUR","latitude":"53.00000000","longitude":"-8.00000000","timezones":[{"zoneName":"Europe/Dublin","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Israel","isoCode":"IL","flag":"\uD83C\uDDEE\uD83C\uDDF1","phonecode":"972","currency":"ILS","latitude":"31.50000000","longitude":"34.75000000","timezones":[{"zoneName":"Asia/Jerusalem","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"IST","tzName":"Israel Standard Time"}]},{"name":"Italy","isoCode":"IT","flag":"\uD83C\uDDEE\uD83C\uDDF9","phonecode":"39","currency":"EUR","latitude":"42.83333333","longitude":"12.83333333","timezones":[{"zoneName":"Europe/Rome","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Jamaica","isoCode":"JM","flag":"\uD83C\uDDEF\uD83C\uDDF2","phonecode":"+1-876","currency":"JMD","latitude":"18.25000000","longitude":"-77.50000000","timezones":[{"zoneName":"America/Jamaica","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Japan","isoCode":"JP","flag":"\uD83C\uDDEF\uD83C\uDDF5","phonecode":"81","currency":"JPY","latitude":"36.00000000","longitude":"138.00000000","timezones":[{"zoneName":"Asia/Tokyo","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"JST","tzName":"Japan Standard Time"}]},{"name":"Jersey","isoCode":"JE","flag":"\uD83C\uDDEF\uD83C\uDDEA","phonecode":"+44-1534","currency":"GBP","latitude":"49.25000000","longitude":"-2.16666666","timezones":[{"zoneName":"Europe/Jersey","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Jordan","isoCode":"JO","flag":"\uD83C\uDDEF\uD83C\uDDF4","phonecode":"962","currency":"JOD","latitude":"31.00000000","longitude":"36.00000000","timezones":[{"zoneName":"Asia/Amman","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Kazakhstan","isoCode":"KZ","flag":"\uD83C\uDDF0\uD83C\uDDFF","phonecode":"7","currency":"KZT","latitude":"48.00000000","longitude":"68.00000000","timezones":[{"zoneName":"Asia/Almaty","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"ALMT","tzName":"Alma-Ata Time[1"},{"zoneName":"Asia/Aqtau","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"AQTT","tzName":"Aqtobe Time"},{"zoneName":"Asia/Aqtobe","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"AQTT","tzName":"Aqtobe Time"},{"zoneName":"Asia/Atyrau","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"MSD+1","tzName":"Moscow Daylight Time+1"},{"zoneName":"Asia/Oral","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"ORAT","tzName":"Oral Time"},{"zoneName":"Asia/Qostanay","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"QYZST","tzName":"Qyzylorda Summer Time"},{"zoneName":"Asia/Qyzylorda","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"QYZT","tzName":"Qyzylorda Summer Time"}]},{"name":"Kenya","isoCode":"KE","flag":"\uD83C\uDDF0\uD83C\uDDEA","phonecode":"254","currency":"KES","latitude":"1.00000000","longitude":"38.00000000","timezones":[{"zoneName":"Africa/Nairobi","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Kiribati","isoCode":"KI","flag":"\uD83C\uDDF0\uD83C\uDDEE","phonecode":"686","currency":"AUD","latitude":"1.41666666","longitude":"173.00000000","timezones":[{"zoneName":"Pacific/Enderbury","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"PHOT","tzName":"Phoenix Island Time"},{"zoneName":"Pacific/Kiritimati","gmtOffset":50400,"gmtOffsetName":"UTC+14:00","abbreviation":"LINT","tzName":"Line Islands Time"},{"zoneName":"Pacific/Tarawa","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"GILT","tzName":"Gilbert Island Time"}]},{"name":"North Korea","isoCode":"KP","flag":"\uD83C\uDDF0\uD83C\uDDF5","phonecode":"850","currency":"KPW","latitude":"40.00000000","longitude":"127.00000000","timezones":[{"zoneName":"Asia/Pyongyang","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"KST","tzName":"Korea Standard Time"}]},{"name":"South Korea","isoCode":"KR","flag":"\uD83C\uDDF0\uD83C\uDDF7","phonecode":"82","currency":"KRW","latitude":"37.00000000","longitude":"127.50000000","timezones":[{"zoneName":"Asia/Seoul","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"KST","tzName":"Korea Standard Time"}]},{"name":"Kuwait","isoCode":"KW","flag":"\uD83C\uDDF0\uD83C\uDDFC","phonecode":"965","currency":"KWD","latitude":"29.50000000","longitude":"45.75000000","timezones":[{"zoneName":"Asia/Kuwait","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Kyrgyzstan","isoCode":"KG","flag":"\uD83C\uDDF0\uD83C\uDDEC","phonecode":"996","currency":"KGS","latitude":"41.00000000","longitude":"75.00000000","timezones":[{"zoneName":"Asia/Bishkek","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"KGT","tzName":"Kyrgyzstan Time"}]},{"name":"Laos","isoCode":"LA","flag":"\uD83C\uDDF1\uD83C\uDDE6","phonecode":"856","currency":"LAK","latitude":"18.00000000","longitude":"105.00000000","timezones":[{"zoneName":"Asia/Vientiane","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"ICT","tzName":"Indochina Time"}]},{"name":"Latvia","isoCode":"LV","flag":"\uD83C\uDDF1\uD83C\uDDFB","phonecode":"371","currency":"EUR","latitude":"57.00000000","longitude":"25.00000000","timezones":[{"zoneName":"Europe/Riga","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Lebanon","isoCode":"LB","flag":"\uD83C\uDDF1\uD83C\uDDE7","phonecode":"961","currency":"LBP","latitude":"33.83333333","longitude":"35.83333333","timezones":[{"zoneName":"Asia/Beirut","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Lesotho","isoCode":"LS","flag":"\uD83C\uDDF1\uD83C\uDDF8","phonecode":"266","currency":"LSL","latitude":"-29.50000000","longitude":"28.50000000","timezones":[{"zoneName":"Africa/Maseru","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"SAST","tzName":"South African Standard Time"}]},{"name":"Liberia","isoCode":"LR","flag":"\uD83C\uDDF1\uD83C\uDDF7","phonecode":"231","currency":"LRD","latitude":"6.50000000","longitude":"-9.50000000","timezones":[{"zoneName":"Africa/Monrovia","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Libya","isoCode":"LY","flag":"\uD83C\uDDF1\uD83C\uDDFE","phonecode":"218","currency":"LYD","latitude":"25.00000000","longitude":"17.00000000","timezones":[{"zoneName":"Africa/Tripoli","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Liechtenstein","isoCode":"LI","flag":"\uD83C\uDDF1\uD83C\uDDEE","phonecode":"423","currency":"CHF","latitude":"47.26666666","longitude":"9.53333333","timezones":[{"zoneName":"Europe/Vaduz","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Lithuania","isoCode":"LT","flag":"\uD83C\uDDF1\uD83C\uDDF9","phonecode":"370","currency":"EUR","latitude":"56.00000000","longitude":"24.00000000","timezones":[{"zoneName":"Europe/Vilnius","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Luxembourg","isoCode":"LU","flag":"\uD83C\uDDF1\uD83C\uDDFA","phonecode":"352","currency":"EUR","latitude":"49.75000000","longitude":"6.16666666","timezones":[{"zoneName":"Europe/Luxembourg","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Macau S.A.R.","isoCode":"MO","flag":"\uD83C\uDDF2\uD83C\uDDF4","phonecode":"853","currency":"MOP","latitude":"22.16666666","longitude":"113.55000000","timezones":[{"zoneName":"Asia/Macau","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"CST","tzName":"China Standard Time"}]},{"name":"Macedonia","isoCode":"MK","flag":"\uD83C\uDDF2\uD83C\uDDF0","phonecode":"389","currency":"MKD","latitude":"41.83333333","longitude":"22.00000000","timezones":[{"zoneName":"Europe/Skopje","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Madagascar","isoCode":"MG","flag":"\uD83C\uDDF2\uD83C\uDDEC","phonecode":"261","currency":"MGA","latitude":"-20.00000000","longitude":"47.00000000","timezones":[{"zoneName":"Indian/Antananarivo","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Malawi","isoCode":"MW","flag":"\uD83C\uDDF2\uD83C\uDDFC","phonecode":"265","currency":"MWK","latitude":"-13.50000000","longitude":"34.00000000","timezones":[{"zoneName":"Africa/Blantyre","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Malaysia","isoCode":"MY","flag":"\uD83C\uDDF2\uD83C\uDDFE","phonecode":"60","currency":"MYR","latitude":"2.50000000","longitude":"112.50000000","timezones":[{"zoneName":"Asia/Kuala_Lumpur","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"MYT","tzName":"Malaysia Time"},{"zoneName":"Asia/Kuching","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"MYT","tzName":"Malaysia Time"}]},{"name":"Maldives","isoCode":"MV","flag":"\uD83C\uDDF2\uD83C\uDDFB","phonecode":"960","currency":"MVR","latitude":"3.25000000","longitude":"73.00000000","timezones":[{"zoneName":"Indian/Maldives","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"MVT","tzName":"Maldives Time"}]},{"name":"Mali","isoCode":"ML","flag":"\uD83C\uDDF2\uD83C\uDDF1","phonecode":"223","currency":"XOF","latitude":"17.00000000","longitude":"-4.00000000","timezones":[{"zoneName":"Africa/Bamako","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Malta","isoCode":"MT","flag":"\uD83C\uDDF2\uD83C\uDDF9","phonecode":"356","currency":"EUR","latitude":"35.83333333","longitude":"14.58333333","timezones":[{"zoneName":"Europe/Malta","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Man (Isle of)","isoCode":"IM","flag":"\uD83C\uDDEE\uD83C\uDDF2","phonecode":"+44-1624","currency":"GBP","latitude":"54.25000000","longitude":"-4.50000000","timezones":[{"zoneName":"Europe/Isle_of_Man","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Marshall Islands","isoCode":"MH","flag":"\uD83C\uDDF2\uD83C\uDDED","phonecode":"692","currency":"USD","latitude":"9.00000000","longitude":"168.00000000","timezones":[{"zoneName":"Pacific/Kwajalein","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"MHT","tzName":"Marshall Islands Time"},{"zoneName":"Pacific/Majuro","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"MHT","tzName":"Marshall Islands Time"}]},{"name":"Martinique","isoCode":"MQ","flag":"\uD83C\uDDF2\uD83C\uDDF6","phonecode":"596","currency":"EUR","latitude":"14.66666700","longitude":"-61.00000000","timezones":[{"zoneName":"America/Martinique","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Mauritania","isoCode":"MR","flag":"\uD83C\uDDF2\uD83C\uDDF7","phonecode":"222","currency":"MRO","latitude":"20.00000000","longitude":"-12.00000000","timezones":[{"zoneName":"Africa/Nouakchott","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Mauritius","isoCode":"MU","flag":"\uD83C\uDDF2\uD83C\uDDFA","phonecode":"230","currency":"MUR","latitude":"-20.28333333","longitude":"57.55000000","timezones":[{"zoneName":"Indian/Mauritius","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"MUT","tzName":"Mauritius Time"}]},{"name":"Mayotte","isoCode":"YT","flag":"\uD83C\uDDFE\uD83C\uDDF9","phonecode":"262","currency":"EUR","latitude":"-12.83333333","longitude":"45.16666666","timezones":[{"zoneName":"Indian/Mayotte","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Mexico","isoCode":"MX","flag":"\uD83C\uDDF2\uD83C\uDDFD","phonecode":"52","currency":"MXN","latitude":"23.00000000","longitude":"-102.00000000","timezones":[{"zoneName":"America/Bahia_Banderas","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Cancun","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Chihuahua","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Hermosillo","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Matamoros","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Mazatlan","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Merida","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Mexico_City","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Monterrey","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Ojinaga","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Tijuana","gmtOffset":-28800,"gmtOffsetName":"UTC-08:00","abbreviation":"PST","tzName":"Pacific Standard Time (North America"}]},{"name":"Micronesia","isoCode":"FM","flag":"\uD83C\uDDEB\uD83C\uDDF2","phonecode":"691","currency":"USD","latitude":"6.91666666","longitude":"158.25000000","timezones":[{"zoneName":"Pacific/Chuuk","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"CHUT","tzName":"Chuuk Time"},{"zoneName":"Pacific/Kosrae","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"KOST","tzName":"Kosrae Time"},{"zoneName":"Pacific/Pohnpei","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"PONT","tzName":"Pohnpei Standard Time"}]},{"name":"Moldova","isoCode":"MD","flag":"\uD83C\uDDF2\uD83C\uDDE9","phonecode":"373","currency":"MDL","latitude":"47.00000000","longitude":"29.00000000","timezones":[{"zoneName":"Europe/Chisinau","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Monaco","isoCode":"MC","flag":"\uD83C\uDDF2\uD83C\uDDE8","phonecode":"377","currency":"EUR","latitude":"43.73333333","longitude":"7.40000000","timezones":[{"zoneName":"Europe/Monaco","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Mongolia","isoCode":"MN","flag":"\uD83C\uDDF2\uD83C\uDDF3","phonecode":"976","currency":"MNT","latitude":"46.00000000","longitude":"105.00000000","timezones":[{"zoneName":"Asia/Choibalsan","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"CHOT","tzName":"Choibalsan Standard Time"},{"zoneName":"Asia/Hovd","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"HOVT","tzName":"Hovd Time"},{"zoneName":"Asia/Ulaanbaatar","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"ULAT","tzName":"Ulaanbaatar Standard Time"}]},{"name":"Montenegro","isoCode":"ME","flag":"\uD83C\uDDF2\uD83C\uDDEA","phonecode":"382","currency":"EUR","latitude":"42.50000000","longitude":"19.30000000","timezones":[{"zoneName":"Europe/Podgorica","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Montserrat","isoCode":"MS","flag":"\uD83C\uDDF2\uD83C\uDDF8","phonecode":"+1-664","currency":"XCD","latitude":"16.75000000","longitude":"-62.20000000","timezones":[{"zoneName":"America/Montserrat","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Morocco","isoCode":"MA","flag":"\uD83C\uDDF2\uD83C\uDDE6","phonecode":"212","currency":"MAD","latitude":"32.00000000","longitude":"-5.00000000","timezones":[{"zoneName":"Africa/Casablanca","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WEST","tzName":"Western European Summer Time"}]},{"name":"Mozambique","isoCode":"MZ","flag":"\uD83C\uDDF2\uD83C\uDDFF","phonecode":"258","currency":"MZN","latitude":"-18.25000000","longitude":"35.00000000","timezones":[{"zoneName":"Africa/Maputo","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Myanmar","isoCode":"MM","flag":"\uD83C\uDDF2\uD83C\uDDF2","phonecode":"95","currency":"MMK","latitude":"22.00000000","longitude":"98.00000000","timezones":[{"zoneName":"Asia/Yangon","gmtOffset":23400,"gmtOffsetName":"UTC+06:30","abbreviation":"MMT","tzName":"Myanmar Standard Time"}]},{"name":"Namibia","isoCode":"NA","flag":"\uD83C\uDDF3\uD83C\uDDE6","phonecode":"264","currency":"NAD","latitude":"-22.00000000","longitude":"17.00000000","timezones":[{"zoneName":"Africa/Windhoek","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"WAST","tzName":"West Africa Summer Time"}]},{"name":"Nauru","isoCode":"NR","flag":"\uD83C\uDDF3\uD83C\uDDF7","phonecode":"674","currency":"AUD","latitude":"-0.53333333","longitude":"166.91666666","timezones":[{"zoneName":"Pacific/Nauru","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"NRT","tzName":"Nauru Time"}]},{"name":"Nepal","isoCode":"NP","flag":"\uD83C\uDDF3\uD83C\uDDF5","phonecode":"977","currency":"NPR","latitude":"28.00000000","longitude":"84.00000000","timezones":[{"zoneName":"Asia/Kathmandu","gmtOffset":20700,"gmtOffsetName":"UTC+05:45","abbreviation":"NPT","tzName":"Nepal Time"}]},{"name":"Bonaire, Sint Eustatius and Saba","isoCode":"BQ","flag":"\uD83C\uDDE7\uD83C\uDDF6","phonecode":"599","currency":"USD","latitude":"12.15000000","longitude":"-68.26666700","timezones":[{"zoneName":"America/Anguilla","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Netherlands","isoCode":"NL","flag":"\uD83C\uDDF3\uD83C\uDDF1","phonecode":"31","currency":"EUR","latitude":"52.50000000","longitude":"5.75000000","timezones":[{"zoneName":"Europe/Amsterdam","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"New Caledonia","isoCode":"NC","flag":"\uD83C\uDDF3\uD83C\uDDE8","phonecode":"687","currency":"XPF","latitude":"-21.50000000","longitude":"165.50000000","timezones":[{"zoneName":"Pacific/Noumea","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"NCT","tzName":"New Caledonia Time"}]},{"name":"New Zealand","isoCode":"NZ","flag":"\uD83C\uDDF3\uD83C\uDDFF","phonecode":"64","currency":"NZD","latitude":"-41.00000000","longitude":"174.00000000","timezones":[{"zoneName":"Pacific/Auckland","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"NZDT","tzName":"New Zealand Daylight Time"},{"zoneName":"Pacific/Chatham","gmtOffset":49500,"gmtOffsetName":"UTC+13:45","abbreviation":"CHAST","tzName":"Chatham Standard Time"}]},{"name":"Nicaragua","isoCode":"NI","flag":"\uD83C\uDDF3\uD83C\uDDEE","phonecode":"505","currency":"NIO","latitude":"13.00000000","longitude":"-85.00000000","timezones":[{"zoneName":"America/Managua","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Niger","isoCode":"NE","flag":"\uD83C\uDDF3\uD83C\uDDEA","phonecode":"227","currency":"XOF","latitude":"16.00000000","longitude":"8.00000000","timezones":[{"zoneName":"Africa/Niamey","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Nigeria","isoCode":"NG","flag":"\uD83C\uDDF3\uD83C\uDDEC","phonecode":"234","currency":"NGN","latitude":"10.00000000","longitude":"8.00000000","timezones":[{"zoneName":"Africa/Lagos","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Niue","isoCode":"NU","flag":"\uD83C\uDDF3\uD83C\uDDFA","phonecode":"683","currency":"NZD","latitude":"-19.03333333","longitude":"-169.86666666","timezones":[{"zoneName":"Pacific/Niue","gmtOffset":-39600,"gmtOffsetName":"UTC-11:00","abbreviation":"NUT","tzName":"Niue Time"}]},{"name":"Norfolk Island","isoCode":"NF","flag":"\uD83C\uDDF3\uD83C\uDDEB","phonecode":"672","currency":"AUD","latitude":"-29.03333333","longitude":"167.95000000","timezones":[{"zoneName":"Pacific/Norfolk","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"NFT","tzName":"Norfolk Time"}]},{"name":"Northern Mariana Islands","isoCode":"MP","flag":"\uD83C\uDDF2\uD83C\uDDF5","phonecode":"+1-670","currency":"USD","latitude":"15.20000000","longitude":"145.75000000","timezones":[{"zoneName":"Pacific/Saipan","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"ChST","tzName":"Chamorro Standard Time"}]},{"name":"Norway","isoCode":"NO","flag":"\uD83C\uDDF3\uD83C\uDDF4","phonecode":"47","currency":"NOK","latitude":"62.00000000","longitude":"10.00000000","timezones":[{"zoneName":"Europe/Oslo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Oman","isoCode":"OM","flag":"\uD83C\uDDF4\uD83C\uDDF2","phonecode":"968","currency":"OMR","latitude":"21.00000000","longitude":"57.00000000","timezones":[{"zoneName":"Asia/Muscat","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"GST","tzName":"Gulf Standard Time"}]},{"name":"Pakistan","isoCode":"PK","flag":"\uD83C\uDDF5\uD83C\uDDF0","phonecode":"92","currency":"PKR","latitude":"30.00000000","longitude":"70.00000000","timezones":[{"zoneName":"Asia/Karachi","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"PKT","tzName":"Pakistan Standard Time"}]},{"name":"Palau","isoCode":"PW","flag":"\uD83C\uDDF5\uD83C\uDDFC","phonecode":"680","currency":"USD","latitude":"7.50000000","longitude":"134.50000000","timezones":[{"zoneName":"Pacific/Palau","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"PWT","tzName":"Palau Time"}]},{"name":"Palestinian Territory Occupied","isoCode":"PS","flag":"\uD83C\uDDF5\uD83C\uDDF8","phonecode":"970","currency":"ILS","latitude":"31.90000000","longitude":"35.20000000","timezones":[{"zoneName":"Asia/Gaza","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Asia/Hebron","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Panama","isoCode":"PA","flag":"\uD83C\uDDF5\uD83C\uDDE6","phonecode":"507","currency":"PAB","latitude":"9.00000000","longitude":"-80.00000000","timezones":[{"zoneName":"America/Panama","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Papua new Guinea","isoCode":"PG","flag":"\uD83C\uDDF5\uD83C\uDDEC","phonecode":"675","currency":"PGK","latitude":"-6.00000000","longitude":"147.00000000","timezones":[{"zoneName":"Pacific/Bougainville","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"BST","tzName":"Bougainville Standard Time[6"},{"zoneName":"Pacific/Port_Moresby","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"PGT","tzName":"Papua New Guinea Time"}]},{"name":"Paraguay","isoCode":"PY","flag":"\uD83C\uDDF5\uD83C\uDDFE","phonecode":"595","currency":"PYG","latitude":"-23.00000000","longitude":"-58.00000000","timezones":[{"zoneName":"America/Asuncion","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"PYST","tzName":"Paraguay Summer Time"}]},{"name":"Peru","isoCode":"PE","flag":"\uD83C\uDDF5\uD83C\uDDEA","phonecode":"51","currency":"PEN","latitude":"-10.00000000","longitude":"-76.00000000","timezones":[{"zoneName":"America/Lima","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"PET","tzName":"Peru Time"}]},{"name":"Philippines","isoCode":"PH","flag":"\uD83C\uDDF5\uD83C\uDDED","phonecode":"63","currency":"PHP","latitude":"13.00000000","longitude":"122.00000000","timezones":[{"zoneName":"Asia/Manila","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"PHT","tzName":"Philippine Time"}]},{"name":"Pitcairn Island","isoCode":"PN","flag":"\uD83C\uDDF5\uD83C\uDDF3","phonecode":"870","currency":"NZD","latitude":"-25.06666666","longitude":"-130.10000000","timezones":[{"zoneName":"Pacific/Pitcairn","gmtOffset":-28800,"gmtOffsetName":"UTC-08:00","abbreviation":"PST","tzName":"Pacific Standard Time (North America"}]},{"name":"Poland","isoCode":"PL","flag":"\uD83C\uDDF5\uD83C\uDDF1","phonecode":"48","currency":"PLN","latitude":"52.00000000","longitude":"20.00000000","timezones":[{"zoneName":"Europe/Warsaw","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Portugal","isoCode":"PT","flag":"\uD83C\uDDF5\uD83C\uDDF9","phonecode":"351","currency":"EUR","latitude":"39.50000000","longitude":"-8.00000000","timezones":[{"zoneName":"Atlantic/Azores","gmtOffset":-3600,"gmtOffsetName":"UTC-01:00","abbreviation":"AZOT","tzName":"Azores Standard Time"},{"zoneName":"Atlantic/Madeira","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"WET","tzName":"Western European Time"},{"zoneName":"Europe/Lisbon","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"WET","tzName":"Western European Time"}]},{"name":"Puerto Rico","isoCode":"PR","flag":"\uD83C\uDDF5\uD83C\uDDF7","phonecode":"+1-787 and 1-939","currency":"USD","latitude":"18.25000000","longitude":"-66.50000000","timezones":[{"zoneName":"America/Puerto_Rico","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Qatar","isoCode":"QA","flag":"\uD83C\uDDF6\uD83C\uDDE6","phonecode":"974","currency":"QAR","latitude":"25.50000000","longitude":"51.25000000","timezones":[{"zoneName":"Asia/Qatar","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Reunion","isoCode":"RE","flag":"\uD83C\uDDF7\uD83C\uDDEA","phonecode":"262","currency":"EUR","latitude":"-21.15000000","longitude":"55.50000000","timezones":[{"zoneName":"Indian/Reunion","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"RET","tzName":"R\xe9union Time"}]},{"name":"Romania","isoCode":"RO","flag":"\uD83C\uDDF7\uD83C\uDDF4","phonecode":"40","currency":"RON","latitude":"46.00000000","longitude":"25.00000000","timezones":[{"zoneName":"Europe/Bucharest","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Russia","isoCode":"RU","flag":"\uD83C\uDDF7\uD83C\uDDFA","phonecode":"7","currency":"RUB","latitude":"60.00000000","longitude":"100.00000000","timezones":[{"zoneName":"Asia/Anadyr","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"ANAT","tzName":"Anadyr Time[4"},{"zoneName":"Asia/Barnaul","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"KRAT","tzName":"Krasnoyarsk Time"},{"zoneName":"Asia/Chita","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"YAKT","tzName":"Yakutsk Time"},{"zoneName":"Asia/Irkutsk","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"IRKT","tzName":"Irkutsk Time"},{"zoneName":"Asia/Kamchatka","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"PETT","tzName":"Kamchatka Time"},{"zoneName":"Asia/Khandyga","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"YAKT","tzName":"Yakutsk Time"},{"zoneName":"Asia/Krasnoyarsk","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"KRAT","tzName":"Krasnoyarsk Time"},{"zoneName":"Asia/Magadan","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"MAGT","tzName":"Magadan Time"},{"zoneName":"Asia/Novokuznetsk","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"KRAT","tzName":"Krasnoyarsk Time"},{"zoneName":"Asia/Novosibirsk","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"NOVT","tzName":"Novosibirsk Time"},{"zoneName":"Asia/Omsk","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"OMST","tzName":"Omsk Time"},{"zoneName":"Asia/Sakhalin","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"SAKT","tzName":"Sakhalin Island Time"},{"zoneName":"Asia/Srednekolymsk","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"SRET","tzName":"Srednekolymsk Time"},{"zoneName":"Asia/Tomsk","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"MSD+3","tzName":"Moscow Daylight Time+3"},{"zoneName":"Asia/Ust-Nera","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"VLAT","tzName":"Vladivostok Time"},{"zoneName":"Asia/Vladivostok","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"VLAT","tzName":"Vladivostok Time"},{"zoneName":"Asia/Yakutsk","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"YAKT","tzName":"Yakutsk Time"},{"zoneName":"Asia/Yekaterinburg","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"YEKT","tzName":"Yekaterinburg Time"},{"zoneName":"Europe/Astrakhan","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"SAMT","tzName":"Samara Time"},{"zoneName":"Europe/Kaliningrad","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Europe/Kirov","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"MSK","tzName":"Moscow Time"},{"zoneName":"Europe/Moscow","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"MSK","tzName":"Moscow Time"},{"zoneName":"Europe/Samara","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"SAMT","tzName":"Samara Time"},{"zoneName":"Europe/Saratov","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"MSD","tzName":"Moscow Daylight Time+4"},{"zoneName":"Europe/Ulyanovsk","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"SAMT","tzName":"Samara Time"},{"zoneName":"Europe/Volgograd","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"MSK","tzName":"Moscow Standard Time"}]},{"name":"Rwanda","isoCode":"RW","flag":"\uD83C\uDDF7\uD83C\uDDFC","phonecode":"250","currency":"RWF","latitude":"-2.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Kigali","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Saint Helena","isoCode":"SH","flag":"\uD83C\uDDF8\uD83C\uDDED","phonecode":"290","currency":"SHP","latitude":"-15.95000000","longitude":"-5.70000000","timezones":[{"zoneName":"Atlantic/St_Helena","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Saint Kitts And Nevis","isoCode":"KN","flag":"\uD83C\uDDF0\uD83C\uDDF3","phonecode":"+1-869","currency":"XCD","latitude":"17.33333333","longitude":"-62.75000000","timezones":[{"zoneName":"America/St_Kitts","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Saint Lucia","isoCode":"LC","flag":"\uD83C\uDDF1\uD83C\uDDE8","phonecode":"+1-758","currency":"XCD","latitude":"13.88333333","longitude":"-60.96666666","timezones":[{"zoneName":"America/St_Lucia","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Saint Pierre and Miquelon","isoCode":"PM","flag":"\uD83C\uDDF5\uD83C\uDDF2","phonecode":"508","currency":"EUR","latitude":"46.83333333","longitude":"-56.33333333","timezones":[{"zoneName":"America/Miquelon","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"PMDT","tzName":"Pierre & Miquelon Daylight Time"}]},{"name":"Saint Vincent And The Grenadines","isoCode":"VC","flag":"\uD83C\uDDFB\uD83C\uDDE8","phonecode":"+1-784","currency":"XCD","latitude":"13.25000000","longitude":"-61.20000000","timezones":[{"zoneName":"America/St_Vincent","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Saint-Barthelemy","isoCode":"BL","flag":"\uD83C\uDDE7\uD83C\uDDF1","phonecode":"590","currency":"EUR","latitude":"18.50000000","longitude":"-63.41666666","timezones":[{"zoneName":"America/St_Barthelemy","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Saint-Martin (French part)","isoCode":"MF","flag":"\uD83C\uDDF2\uD83C\uDDEB","phonecode":"590","currency":"EUR","latitude":"18.08333333","longitude":"-63.95000000","timezones":[{"zoneName":"America/Marigot","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Samoa","isoCode":"WS","flag":"\uD83C\uDDFC\uD83C\uDDF8","phonecode":"685","currency":"WST","latitude":"-13.58333333","longitude":"-172.33333333","timezones":[{"zoneName":"Pacific/Apia","gmtOffset":50400,"gmtOffsetName":"UTC+14:00","abbreviation":"WST","tzName":"West Samoa Time"}]},{"name":"San Marino","isoCode":"SM","flag":"\uD83C\uDDF8\uD83C\uDDF2","phonecode":"378","currency":"EUR","latitude":"43.76666666","longitude":"12.41666666","timezones":[{"zoneName":"Europe/San_Marino","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Sao Tome and Principe","isoCode":"ST","flag":"\uD83C\uDDF8\uD83C\uDDF9","phonecode":"239","currency":"STD","latitude":"1.00000000","longitude":"7.00000000","timezones":[{"zoneName":"Africa/Sao_Tome","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Saudi Arabia","isoCode":"SA","flag":"\uD83C\uDDF8\uD83C\uDDE6","phonecode":"966","currency":"SAR","latitude":"25.00000000","longitude":"45.00000000","timezones":[{"zoneName":"Asia/Riyadh","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Senegal","isoCode":"SN","flag":"\uD83C\uDDF8\uD83C\uDDF3","phonecode":"221","currency":"XOF","latitude":"14.00000000","longitude":"-14.00000000","timezones":[{"zoneName":"Africa/Dakar","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Serbia","isoCode":"RS","flag":"\uD83C\uDDF7\uD83C\uDDF8","phonecode":"381","currency":"RSD","latitude":"44.00000000","longitude":"21.00000000","timezones":[{"zoneName":"Europe/Belgrade","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Seychelles","isoCode":"SC","flag":"\uD83C\uDDF8\uD83C\uDDE8","phonecode":"248","currency":"SCR","latitude":"-4.58333333","longitude":"55.66666666","timezones":[{"zoneName":"Indian/Mahe","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"SCT","tzName":"Seychelles Time"}]},{"name":"Sierra Leone","isoCode":"SL","flag":"\uD83C\uDDF8\uD83C\uDDF1","phonecode":"232","currency":"SLL","latitude":"8.50000000","longitude":"-11.50000000","timezones":[{"zoneName":"Africa/Freetown","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Singapore","isoCode":"SG","flag":"\uD83C\uDDF8\uD83C\uDDEC","phonecode":"65","currency":"SGD","latitude":"1.36666666","longitude":"103.80000000","timezones":[{"zoneName":"Asia/Singapore","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"SGT","tzName":"Singapore Time"}]},{"name":"Slovakia","isoCode":"SK","flag":"\uD83C\uDDF8\uD83C\uDDF0","phonecode":"421","currency":"EUR","latitude":"48.66666666","longitude":"19.50000000","timezones":[{"zoneName":"Europe/Bratislava","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Slovenia","isoCode":"SI","flag":"\uD83C\uDDF8\uD83C\uDDEE","phonecode":"386","currency":"EUR","latitude":"46.11666666","longitude":"14.81666666","timezones":[{"zoneName":"Europe/Ljubljana","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Solomon Islands","isoCode":"SB","flag":"\uD83C\uDDF8\uD83C\uDDE7","phonecode":"677","currency":"SBD","latitude":"-8.00000000","longitude":"159.00000000","timezones":[{"zoneName":"Pacific/Guadalcanal","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"SBT","tzName":"Solomon Islands Time"}]},{"name":"Somalia","isoCode":"SO","flag":"\uD83C\uDDF8\uD83C\uDDF4","phonecode":"252","currency":"SOS","latitude":"10.00000000","longitude":"49.00000000","timezones":[{"zoneName":"Africa/Mogadishu","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"South Africa","isoCode":"ZA","flag":"\uD83C\uDDFF\uD83C\uDDE6","phonecode":"27","currency":"ZAR","latitude":"-29.00000000","longitude":"24.00000000","timezones":[{"zoneName":"Africa/Johannesburg","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"SAST","tzName":"South African Standard Time"}]},{"name":"South Georgia","isoCode":"GS","flag":"\uD83C\uDDEC\uD83C\uDDF8","phonecode":"500","currency":"GBP","latitude":"-54.50000000","longitude":"-37.00000000","timezones":[{"zoneName":"Atlantic/South_Georgia","gmtOffset":-7200,"gmtOffsetName":"UTC-02:00","abbreviation":"GST","tzName":"South Georgia and the South Sandwich Islands Time"}]},{"name":"South Sudan","isoCode":"SS","flag":"\uD83C\uDDF8\uD83C\uDDF8","phonecode":"211","currency":"SSP","latitude":"7.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Juba","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Spain","isoCode":"ES","flag":"\uD83C\uDDEA\uD83C\uDDF8","phonecode":"34","currency":"EUR","latitude":"40.00000000","longitude":"-4.00000000","timezones":[{"zoneName":"Africa/Ceuta","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"},{"zoneName":"Atlantic/Canary","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"WET","tzName":"Western European Time"},{"zoneName":"Europe/Madrid","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Sri Lanka","isoCode":"LK","flag":"\uD83C\uDDF1\uD83C\uDDF0","phonecode":"94","currency":"LKR","latitude":"7.00000000","longitude":"81.00000000","timezones":[{"zoneName":"Asia/Colombo","gmtOffset":19800,"gmtOffsetName":"UTC+05:30","abbreviation":"IST","tzName":"Indian Standard Time"}]},{"name":"Sudan","isoCode":"SD","flag":"\uD83C\uDDF8\uD83C\uDDE9","phonecode":"249","currency":"SDG","latitude":"15.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Khartoum","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EAT","tzName":"Eastern African Time"}]},{"name":"Suriname","isoCode":"SR","flag":"\uD83C\uDDF8\uD83C\uDDF7","phonecode":"597","currency":"SRD","latitude":"4.00000000","longitude":"-56.00000000","timezones":[{"zoneName":"America/Paramaribo","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"SRT","tzName":"Suriname Time"}]},{"name":"Svalbard And Jan Mayen Islands","isoCode":"SJ","flag":"\uD83C\uDDF8\uD83C\uDDEF","phonecode":"47","currency":"NOK","latitude":"78.00000000","longitude":"20.00000000","timezones":[{"zoneName":"Arctic/Longyearbyen","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Swaziland","isoCode":"SZ","flag":"\uD83C\uDDF8\uD83C\uDDFF","phonecode":"268","currency":"SZL","latitude":"-26.50000000","longitude":"31.50000000","timezones":[{"zoneName":"Africa/Mbabane","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"SAST","tzName":"South African Standard Time"}]},{"name":"Sweden","isoCode":"SE","flag":"\uD83C\uDDF8\uD83C\uDDEA","phonecode":"46","currency":"SEK","latitude":"62.00000000","longitude":"15.00000000","timezones":[{"zoneName":"Europe/Stockholm","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Switzerland","isoCode":"CH","flag":"\uD83C\uDDE8\uD83C\uDDED","phonecode":"41","currency":"CHF","latitude":"47.00000000","longitude":"8.00000000","timezones":[{"zoneName":"Europe/Zurich","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Syria","isoCode":"SY","flag":"\uD83C\uDDF8\uD83C\uDDFE","phonecode":"963","currency":"SYP","latitude":"35.00000000","longitude":"38.00000000","timezones":[{"zoneName":"Asia/Damascus","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Taiwan","isoCode":"TW","flag":"\uD83C\uDDF9\uD83C\uDDFC","phonecode":"886","currency":"TWD","latitude":"23.50000000","longitude":"121.00000000","timezones":[{"zoneName":"Asia/Taipei","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"CST","tzName":"China Standard Time"}]},{"name":"Tajikistan","isoCode":"TJ","flag":"\uD83C\uDDF9\uD83C\uDDEF","phonecode":"992","currency":"TJS","latitude":"39.00000000","longitude":"71.00000000","timezones":[{"zoneName":"Asia/Dushanbe","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"TJT","tzName":"Tajikistan Time"}]},{"name":"Tanzania","isoCode":"TZ","flag":"\uD83C\uDDF9\uD83C\uDDFF","phonecode":"255","currency":"TZS","latitude":"-6.00000000","longitude":"35.00000000","timezones":[{"zoneName":"Africa/Dar_es_Salaam","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Thailand","isoCode":"TH","flag":"\uD83C\uDDF9\uD83C\uDDED","phonecode":"66","currency":"THB","latitude":"15.00000000","longitude":"100.00000000","timezones":[{"zoneName":"Asia/Bangkok","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"ICT","tzName":"Indochina Time"}]},{"name":"Togo","isoCode":"TG","flag":"\uD83C\uDDF9\uD83C\uDDEC","phonecode":"228","currency":"XOF","latitude":"8.00000000","longitude":"1.16666666","timezones":[{"zoneName":"Africa/Lome","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Tokelau","isoCode":"TK","flag":"\uD83C\uDDF9\uD83C\uDDF0","phonecode":"690","currency":"NZD","latitude":"-9.00000000","longitude":"-172.00000000","timezones":[{"zoneName":"Pacific/Fakaofo","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"TKT","tzName":"Tokelau Time"}]},{"name":"Tonga","isoCode":"TO","flag":"\uD83C\uDDF9\uD83C\uDDF4","phonecode":"676","currency":"TOP","latitude":"-20.00000000","longitude":"-175.00000000","timezones":[{"zoneName":"Pacific/Tongatapu","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"TOT","tzName":"Tonga Time"}]},{"name":"Trinidad And Tobago","isoCode":"TT","flag":"\uD83C\uDDF9\uD83C\uDDF9","phonecode":"+1-868","currency":"TTD","latitude":"11.00000000","longitude":"-61.00000000","timezones":[{"zoneName":"America/Port_of_Spain","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Tunisia","isoCode":"TN","flag":"\uD83C\uDDF9\uD83C\uDDF3","phonecode":"216","currency":"TND","latitude":"34.00000000","longitude":"9.00000000","timezones":[{"zoneName":"Africa/Tunis","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Turkey","isoCode":"TR","flag":"\uD83C\uDDF9\uD83C\uDDF7","phonecode":"90","currency":"TRY","latitude":"39.00000000","longitude":"35.00000000","timezones":[{"zoneName":"Europe/Istanbul","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Turkmenistan","isoCode":"TM","flag":"\uD83C\uDDF9\uD83C\uDDF2","phonecode":"993","currency":"TMT","latitude":"40.00000000","longitude":"60.00000000","timezones":[{"zoneName":"Asia/Ashgabat","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"TMT","tzName":"Turkmenistan Time"}]},{"name":"Turks And Caicos Islands","isoCode":"TC","flag":"\uD83C\uDDF9\uD83C\uDDE8","phonecode":"+1-649","currency":"USD","latitude":"21.75000000","longitude":"-71.58333333","timezones":[{"zoneName":"America/Grand_Turk","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Tuvalu","isoCode":"TV","flag":"\uD83C\uDDF9\uD83C\uDDFB","phonecode":"688","currency":"AUD","latitude":"-8.00000000","longitude":"178.00000000","timezones":[{"zoneName":"Pacific/Funafuti","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"TVT","tzName":"Tuvalu Time"}]},{"name":"Uganda","isoCode":"UG","flag":"\uD83C\uDDFA\uD83C\uDDEC","phonecode":"256","currency":"UGX","latitude":"1.00000000","longitude":"32.00000000","timezones":[{"zoneName":"Africa/Kampala","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Ukraine","isoCode":"UA","flag":"\uD83C\uDDFA\uD83C\uDDE6","phonecode":"380","currency":"UAH","latitude":"49.00000000","longitude":"32.00000000","timezones":[{"zoneName":"Europe/Kiev","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Europe/Simferopol","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"MSK","tzName":"Moscow Time"},{"zoneName":"Europe/Uzhgorod","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Europe/Zaporozhye","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"United Arab Emirates","isoCode":"AE","flag":"\uD83C\uDDE6\uD83C\uDDEA","phonecode":"971","currency":"AED","latitude":"24.00000000","longitude":"54.00000000","timezones":[{"zoneName":"Asia/Dubai","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"GST","tzName":"Gulf Standard Time"}]},{"name":"United Kingdom","isoCode":"GB","flag":"\uD83C\uDDEC\uD83C\uDDE7","phonecode":"44","currency":"GBP","latitude":"54.00000000","longitude":"-2.00000000","timezones":[{"zoneName":"Europe/London","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"United States","isoCode":"US","flag":"\uD83C\uDDFA\uD83C\uDDF8","phonecode":"1","currency":"USD","latitude":"38.00000000","longitude":"-97.00000000","timezones":[{"zoneName":"America/Adak","gmtOffset":-36000,"gmtOffsetName":"UTC-10:00","abbreviation":"HST","tzName":"Hawaii\u2013Aleutian Standard Time"},{"zoneName":"America/Anchorage","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/Boise","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Chicago","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Denver","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Detroit","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Indianapolis","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Knox","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Indiana/Marengo","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Petersburg","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Tell_City","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Indiana/Vevay","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Vincennes","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Winamac","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Juneau","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/Kentucky/Louisville","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Kentucky/Monticello","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Los_Angeles","gmtOffset":-28800,"gmtOffsetName":"UTC-08:00","abbreviation":"PST","tzName":"Pacific Standard Time (North America"},{"zoneName":"America/Menominee","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Metlakatla","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/New_York","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Nome","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/North_Dakota/Beulah","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/North_Dakota/Center","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/North_Dakota/New_Salem","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Phoenix","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Sitka","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/Yakutat","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"Pacific/Honolulu","gmtOffset":-36000,"gmtOffsetName":"UTC-10:00","abbreviation":"HST","tzName":"Hawaii\u2013Aleutian Standard Time"}]},{"name":"United States Minor Outlying Islands","isoCode":"UM","flag":"\uD83C\uDDFA\uD83C\uDDF2","phonecode":"1","currency":"USD","latitude":"0.00000000","longitude":"0.00000000","timezones":[{"zoneName":"Pacific/Midway","gmtOffset":-39600,"gmtOffsetName":"UTC-11:00","abbreviation":"SST","tzName":"Samoa Standard Time"},{"zoneName":"Pacific/Wake","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"WAKT","tzName":"Wake Island Time"}]},{"name":"Uruguay","isoCode":"UY","flag":"\uD83C\uDDFA\uD83C\uDDFE","phonecode":"598","currency":"UYU","latitude":"-33.00000000","longitude":"-56.00000000","timezones":[{"zoneName":"America/Montevideo","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"UYT","tzName":"Uruguay Standard Time"}]},{"name":"Uzbekistan","isoCode":"UZ","flag":"\uD83C\uDDFA\uD83C\uDDFF","phonecode":"998","currency":"UZS","latitude":"41.00000000","longitude":"64.00000000","timezones":[{"zoneName":"Asia/Samarkand","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"UZT","tzName":"Uzbekistan Time"},{"zoneName":"Asia/Tashkent","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"UZT","tzName":"Uzbekistan Time"}]},{"name":"Vanuatu","isoCode":"VU","flag":"\uD83C\uDDFB\uD83C\uDDFA","phonecode":"678","currency":"VUV","latitude":"-16.00000000","longitude":"167.00000000","timezones":[{"zoneName":"Pacific/Efate","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"VUT","tzName":"Vanuatu Time"}]},{"name":"Vatican City State (Holy See)","isoCode":"VA","flag":"\uD83C\uDDFB\uD83C\uDDE6","phonecode":"379","currency":"EUR","latitude":"41.90000000","longitude":"12.45000000","timezones":[{"zoneName":"Europe/Vatican","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Venezuela","isoCode":"VE","flag":"\uD83C\uDDFB\uD83C\uDDEA","phonecode":"58","currency":"VEF","latitude":"8.00000000","longitude":"-66.00000000","timezones":[{"zoneName":"America/Caracas","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"VET","tzName":"Venezuelan Standard Time"}]},{"name":"Vietnam","isoCode":"VN","flag":"\uD83C\uDDFB\uD83C\uDDF3","phonecode":"84","currency":"VND","latitude":"16.16666666","longitude":"107.83333333","timezones":[{"zoneName":"Asia/Ho_Chi_Minh","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"ICT","tzName":"Indochina Time"}]},{"name":"Virgin Islands (British)","isoCode":"VG","flag":"\uD83C\uDDFB\uD83C\uDDEC","phonecode":"+1-284","currency":"USD","latitude":"18.43138300","longitude":"-64.62305000","timezones":[{"zoneName":"America/Tortola","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Virgin Islands (US)","isoCode":"VI","flag":"\uD83C\uDDFB\uD83C\uDDEE","phonecode":"+1-340","currency":"USD","latitude":"18.34000000","longitude":"-64.93000000","timezones":[{"zoneName":"America/St_Thomas","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Wallis And Futuna Islands","isoCode":"WF","flag":"\uD83C\uDDFC\uD83C\uDDEB","phonecode":"681","currency":"XPF","latitude":"-13.30000000","longitude":"-176.20000000","timezones":[{"zoneName":"Pacific/Wallis","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"WFT","tzName":"Wallis & Futuna Time"}]},{"name":"Western Sahara","isoCode":"EH","flag":"\uD83C\uDDEA\uD83C\uDDED","phonecode":"212","currency":"MAD","latitude":"24.50000000","longitude":"-13.00000000","timezones":[{"zoneName":"Africa/El_Aaiun","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WEST","tzName":"Western European Summer Time"}]},{"name":"Yemen","isoCode":"YE","flag":"\uD83C\uDDFE\uD83C\uDDEA","phonecode":"967","currency":"YER","latitude":"15.00000000","longitude":"48.00000000","timezones":[{"zoneName":"Asia/Aden","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Zambia","isoCode":"ZM","flag":"\uD83C\uDDFF\uD83C\uDDF2","phonecode":"260","currency":"ZMW","latitude":"-15.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Lusaka","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Zimbabwe","isoCode":"ZW","flag":"\uD83C\uDDFF\uD83C\uDDFC","phonecode":"263","currency":"ZWL","latitude":"-20.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Harare","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Kosovo","isoCode":"XK","flag":"\uD83C\uDDFD\uD83C\uDDF0","phonecode":"383","currency":"EUR","latitude":"42.56129090","longitude":"20.34030350","timezones":[{"zoneName":"Europe/Belgrade","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Cura\xe7ao","isoCode":"CW","flag":"\uD83C\uDDE8\uD83C\uDDFC","phonecode":"599","currency":"ANG","latitude":"12.11666700","longitude":"-68.93333300","timezones":[{"zoneName":"America/Curacao","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Sint Maarten (Dutch part)","isoCode":"SX","flag":"\uD83C\uDDF8\uD83C\uDDFD","phonecode":"1721","currency":"ANG","latitude":"18.03333300","longitude":"-63.05000000","timezones":[{"zoneName":"America/Anguilla","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]}]');


var $661be17240ad414b$export$f402ac270728efb9 = function(source, code) {
    if (code && source != null) {
        var codex = source.findIndex(function(c) {
            return c.isoCode === code;
        });
        return codex !== -1 ? source[codex] : undefined;
    }
    return undefined;
};
var $661be17240ad414b$export$5459063425dbd5d = function(source, code, countryCode) {
    if (code && countryCode && source != null) {
        var codex = source.findIndex(function(c) {
            return c.isoCode === code && c.countryCode === countryCode;
        });
        return codex !== -1 ? source[codex] : undefined;
    }
    return undefined;
};
function $661be17240ad414b$export$8982a0378820ff7b(entity) {
    return entity.name;
}
var $661be17240ad414b$export$398604a469f7de9a = function(a, b) {
    var // eslint-disable-next-line no-unused-vars
    keyToCompare = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $661be17240ad414b$export$8982a0378820ff7b;
    if (keyToCompare(a) < keyToCompare(b)) return -1;
    if (keyToCompare(a) > keyToCompare(b)) return 1;
    return 0;
};
var $661be17240ad414b$export$4ffa58f6da7470fc = function(keys, arr) {
    var result = arr.map(function(subArr) {
        return Object.fromEntries(keys.map(function(key, index) {
            return [
                key,
                subArr[index]
            ];
        }));
    });
    return result;
};


// Get a country by isoCode.
function $a0ee6d2d3db760af$var$getCountryByCode(isoCode) {
    if (!isoCode) return undefined;
    return (0, $661be17240ad414b$export$f402ac270728efb9)((0, (/*@__PURE__*/$parcel$interopDefault($8d17a8b620b4099c$exports))), isoCode);
}
// Get a list of all countries.
function $a0ee6d2d3db760af$var$getAllCountries() {
    return 0, (/*@__PURE__*/$parcel$interopDefault($8d17a8b620b4099c$exports));
}
function $a0ee6d2d3db760af$var$sortByIsoCode(countries) {
    return countries.sort(function(a, b) {
        return (0, $661be17240ad414b$export$398604a469f7de9a)(a, b, function(entity) {
            return entity.isoCode;
        });
    });
}
var $a0ee6d2d3db760af$export$2e2bcd8739ae039 = {
    getCountryByCode: $a0ee6d2d3db760af$var$getCountryByCode,
    getAllCountries: $a0ee6d2d3db760af$var$getAllCountries,
    sortByIsoCode: $a0ee6d2d3db760af$var$sortByIsoCode
};







var $efc8a778940d2b1e$export$703f3c34cd041799 = {
    wellamoon: [
        "US",
        "CA",
        "MX",
        "FR",
        "IT",
        "NO",
        "AT",
        "ES"
    ],
    "default": [
        "AO",
        "AR",
        "AM",
        "AU",
        "AT",
        "BD",
        "AL",
        "BE",
        "BO",
        "BA",
        "BW",
        "BR",
        "BN",
        "BG",
        "BF",
        "KH",
        "CA",
        "CO",
        "CR",
        "CI",
        "HR",
        "CY",
        "CZ",
        "DK",
        "DJ",
        "EC",
        "EE",
        "ET",
        "FJ",
        "FI",
        "FR",
        "GE",
        "DE",
        "GH",
        "GI",
        "GR",
        "GT",
        "HN",
        "HU",
        "IS",
        "IN",
        "ID",
        "IE",
        "IL",
        "IT",
        "JP",
        "JO",
        "CH",
        "ES",
        "GB",
        "KE",
        "KG",
        "KZ",
        "LK",
        "LU",
        "LV",
        "MA",
        "MD",
        "MK",
        "MT",
        "MU",
        "MW",
        "MX",
        "MZ",
        "NA",
        "NL",
        "NO",
        "NP",
        "NR",
        "NZ",
        "PA",
        "PE",
        "PH",
        "PL",
        "PR",
        "PT",
        "PY",
        "RO",
        "RS",
        "RW",
        "SC",
        "SE",
        "SG",
        "SI",
        "SK",
        "SN",
        "TH",
        "TN",
        "TR",
        "UG",
        "US",
        "UY",
        "UZ",
        "ZA",
        "ZM"
    ]
};




var $43f7f7eb6de5d597$export$d36a5df19cad8743 = {
    names: {
        AL: [
            "Arber",
            "Ariana",
            "Blerim",
            "Elona",
            "Arjan",
            "Mirela",
            "Endrit",
            "Erinda",
            "Eri",
            "Blerta"
        ],
        US: [
            "Liam",
            "Olivia",
            "Noah",
            "Emma",
            "Oliver",
            "Ava",
            "Elijah",
            "Charlotte",
            "William",
            "Sophia"
        ],
        AD: [
            "Marc",
            "Aina",
            "Jordi",
            "Laura",
            "Eric",
            "Maria",
            "David",
            "Anna",
            "Pau",
            "Sofia"
        ],
        AT: [
            "Lukas",
            "Emma",
            "David",
            "Anna",
            "Maximilian",
            "Sophia",
            "Elias",
            "Mia",
            "Leon",
            "Emilia"
        ],
        BE: [
            "Liam",
            "Emma",
            "Noah",
            "Olivia",
            "Lucas",
            "Louise",
            "Adam",
            "Alice",
            "Louis",
            "Mila"
        ],
        BA: [
            "Tarik",
            "Amina",
            "Adin",
            "Lejla",
            "Harun",
            "Emina",
            "Amir",
            "Sara",
            "Armin",
            "Lana"
        ],
        BG: [
            "Georgi",
            "Maria",
            "Ivan",
            "Viktoria",
            "Nikolay",
            "Nikol",
            "Dimitar",
            "Elena",
            "Martin",
            "Gabriela"
        ],
        HR: [
            "Luka",
            "Lucija",
            "David",
            "Mia",
            "Ivan",
            "Ema",
            "Marko",
            "Sara",
            "Josip",
            "Nika"
        ],
        CY: [
            "Andreas",
            "Maria",
            "Georgios",
            "Elena",
            "Nicolas",
            "Anna",
            "Christos",
            "Sophia",
            "Panagiotis",
            "Eleni"
        ],
        CZ: [
            "Jakub",
            "Eli\u0161ka",
            "Jan",
            "Tereza",
            "Adam",
            "Anna",
            "Tom\xe1\u0161",
            "Lucie",
            "Mat\u011Bj",
            "Ad\xe9la"
        ],
        DK: [
            "William",
            "Emma",
            "Noah",
            "Freja",
            "Lucas",
            "Ida",
            "Oscar",
            "Clara",
            "Malthe",
            "Sofia"
        ],
        EE: [
            "Rasmus",
            "Sofia",
            "Henri",
            "Maria",
            "Oskar",
            "Eliise",
            "Maksim",
            "Linda",
            "Kaspar",
            "Mia"
        ],
        FI: [
            "Oliver",
            "Aino",
            "Elias",
            "Eevi",
            "Leo",
            "Emma",
            "Onni",
            "Sofia",
            "Noel",
            "Venla"
        ],
        FR: [
            "Gabriel",
            "Emma",
            "Rapha\xebl",
            "Jade",
            "L\xe9o",
            "Louise",
            "Louis",
            "Alice",
            "Lucas",
            "Chlo\xe9"
        ],
        DE: [
            "Leon",
            "Mia",
            "Finn",
            "Emma",
            "Noah",
            "Sofia",
            "Paul",
            "Lina",
            "Liam",
            "Hannah"
        ],
        GR: [
            "Georgios",
            "Maria",
            "Dimitrios",
            "Eleni",
            "Nikolaos",
            "Anna",
            "Ioannis",
            "Sofia",
            "Konstantinos",
            "Aikaterini"
        ],
        HU: [
            "Bence",
            "Hanna",
            "M\xe1t\xe9",
            "Anna",
            "Levente",
            "No\xe9mi",
            "\xc1d\xe1m",
            "Lili",
            "Dominik",
            "Zo\xe9"
        ],
        IE: [
            "Jack",
            "Emily",
            "James",
            "Sophia",
            "Noah",
            "Grace",
            "Conor",
            "Amelia",
            "Daniel",
            "Ella"
        ],
        IT: [
            "Leonardo",
            "Sofia",
            "Francesco",
            "Aurora",
            "Lorenzo",
            "Giulia",
            "Matteo",
            "Emma",
            "Gabriele",
            "Ginevra"
        ],
        LV: [
            "Markuss",
            "Sofija",
            "Maksims",
            "Em\u012Blija",
            "Artjoms",
            "Mia",
            "Roberts",
            "Elizabete",
            "Noah",
            "Anna"
        ],
        LU: [
            "Liam",
            "Emma",
            "Noah",
            "L\xe9a",
            "Lucas",
            "Mila",
            "Adam",
            "Sofia",
            "Louis",
            "Clara"
        ],
        MK: [
            "Luka",
            "Ana",
            "David",
            "Elena",
            "Nikola",
            "Sara",
            "Marko",
            "Maria",
            "Aleksandar",
            "Iva"
        ],
        MT: [
            "Jake",
            "Ella",
            "Liam",
            "Amy",
            "Ben",
            "Emma",
            "Luke",
            "Maya",
            "Noah",
            "Emily"
        ],
        NL: [
            "Liam",
            "Emma",
            "Noah",
            "Julia",
            "Lucas",
            "Sophie",
            "Levi",
            "Mila",
            "Sem",
            "Zoe"
        ],
        NO: [
            "Oliver",
            "Emma",
            "Oscar",
            "Nora",
            "William",
            "Sofie",
            "Liam",
            "Olivia",
            "Henrik",
            "Mia"
        ],
        PL: [
            "Antoni",
            "Zuzanna",
            "Jakub",
            "Lena",
            "Szymon",
            "Maja",
            "Jan",
            "Amelia",
            "Kacper",
            "Alicja"
        ],
        PT: [
            "Jo\xe3o",
            "Leonor",
            "Martim",
            "Matilde",
            "Tom\xe1s",
            "Beatriz",
            "Rodrigo",
            "Mariana",
            "Miguel",
            "Ana"
        ],
        RO: [
            "Matei",
            "Maria",
            "David",
            "Elena",
            "Andrei",
            "Ioana",
            "Lucas",
            "Andreea",
            "Alexandru",
            "Daria"
        ],
        RU: [
            "Artem",
            "Sofia",
            "Mikhail",
            "Maria",
            "Alexander",
            "Anna",
            "Dmitry",
            "Alina",
            "Ivan",
            "Daria"
        ],
        RS: [
            "Luka",
            "Sofija",
            "Stefan",
            "Jana",
            "Nikola",
            "Teodora",
            "Milo\u0161",
            "Elena",
            "Filip",
            "Sara"
        ],
        SK: [
            "Jakub",
            "Ema",
            "Adam",
            "Sofia",
            "Samuel",
            "Nina",
            "Tom\xe1\u0161",
            "Vikt\xf3ria",
            "Filip",
            "Lucia"
        ],
        SI: [
            "Luka",
            "Eva",
            "Jan",
            "Zala",
            "Jakob",
            "Mia",
            "\u017Dan",
            "Sara",
            "Filip",
            "Lana"
        ],
        ES: [
            "Lucas",
            "Luc\xeda",
            "Hugo",
            "Sof\xeda",
            "Mart\xedn",
            "Mar\xeda",
            "Mateo",
            "Paula",
            "David",
            "Emma"
        ],
        SE: [
            "Liam",
            "Ella",
            "William",
            "Alice",
            "Elias",
            "Lilly",
            "Noah",
            "Astrid",
            "Hugo",
            "Olivia"
        ],
        CH: [
            "Liam",
            "Emma",
            "Noah",
            "Mia",
            "Lucas",
            "Sophia",
            "Leon",
            "Lena",
            "Gabriel",
            "Emilia"
        ],
        UA: [
            "Oleksandr",
            "Sofiya",
            "Danylo",
            "Anastasia",
            "Maksym",
            "Maria",
            "Artem",
            "Anna",
            "Kyrylo",
            "Yana"
        ],
        GB: [
            "Oliver",
            "Olivia",
            "George",
            "Amelia",
            "Noah",
            "Isla",
            "Harry",
            "Ava",
            "Arthur",
            "Mia"
        ]
    },
    cities: {
        AL: [
            "Tirana",
            "Durr\xebs",
            "Vlor\xeb",
            "Elbasan",
            "Shkod\xebr"
        ],
        AD: [
            "Andorra la Vella",
            "Escaldes-Engordany",
            "Encamp",
            "Sant Juli\xe0 de L\xf2ria",
            "La Massana"
        ],
        AT: [
            "Vienna",
            "Graz",
            "Linz",
            "Salzburg",
            "Innsbruck"
        ],
        BY: [
            "Minsk",
            "Gomel",
            "Mogilev",
            "Vitebsk",
            "Grodno"
        ],
        BE: [
            "Brussels",
            "Antwerp",
            "Ghent",
            "Charleroi",
            "Li\xe8ge"
        ],
        BA: [
            "Sarajevo",
            "Banja Luka",
            "Tuzla",
            "Zenica",
            "Bijeljina"
        ],
        BG: [
            "Sofia",
            "Plovdiv",
            "Varna",
            "Burgas",
            "Ruse"
        ],
        HR: [
            "Zagreb",
            "Split",
            "Rijeka",
            "Osijek",
            "Zadar"
        ],
        CY: [
            "Nicosia",
            "Limassol",
            "Larnaca",
            "Paphos",
            "Famagusta"
        ],
        CZ: [
            "Prague",
            "Brno",
            "Ostrava",
            "Plze\u0148",
            "Liberec"
        ],
        DK: [
            "Copenhagen",
            "Aarhus",
            "Odense",
            "Aalborg",
            "Frederiksberg"
        ],
        EE: [
            "Tallinn",
            "Tartu",
            "Narva",
            "P\xe4rnu",
            "Kohtla-J\xe4rve"
        ],
        FI: [
            "Helsinki",
            "Espoo",
            "Tampere",
            "Vantaa",
            "Oulu"
        ],
        FR: [
            "Paris",
            "Marseille",
            "Lyon",
            "Toulouse",
            "Nice"
        ],
        DE: [
            "Berlin",
            "Hamburg",
            "Munich",
            "Cologne",
            "Frankfurt"
        ],
        GR: [
            "Athens",
            "Thessaloniki",
            "Patras",
            "Heraklion",
            "Larissa"
        ],
        HU: [
            "Budapest",
            "Debrecen",
            "Szeged",
            "Miskolc",
            "P\xe9cs"
        ],
        IS: [
            "Reykjav\xedk",
            "K\xf3pavogur",
            "Hafnarfj\xf6r\xf0ur",
            "Akureyri",
            "Reykjanesb\xe6r"
        ],
        IE: [
            "Dublin",
            "Cork",
            "Limerick",
            "Galway",
            "Waterford"
        ],
        IT: [
            "Rome",
            "Milan",
            "Naples",
            "Turin",
            "Palermo"
        ],
        XK: [
            "Pristina",
            "Prizren",
            "Ferizaj",
            "Peja",
            "Gjakova"
        ],
        LV: [
            "Riga",
            "Daugavpils",
            "Liep\u0101ja",
            "Jelgava",
            "J\u016Brmala"
        ],
        LI: [
            "Vaduz",
            "Schaan",
            "Balzers",
            "Triesen",
            "Eschen"
        ],
        LU: [
            "Luxembourg City",
            "Esch-sur-Alzette",
            "Differdange",
            "Dudelange",
            "Ettelbruck"
        ],
        MK: [
            "Skopje",
            "Bitola",
            "Kumanovo",
            "Prilep",
            "Tetovo"
        ],
        MT: [
            "Valletta",
            "Birkirkara",
            "Sliema",
            "Mosta",
            "Rabat"
        ],
        MD: [
            "Chi\u0219in\u0103u",
            "Tiraspol",
            "B\u0103l\u021Bi",
            "Bender",
            "R\xeebni\u021Ba"
        ],
        MC: [
            "Monaco-Ville",
            "Monte Carlo",
            "La Condamine",
            "Fontvieille",
            "Moneghetti"
        ],
        ME: [
            "Podgorica",
            "Nik\u0161i\u0107",
            "Bijelo Polje",
            "Cetinje",
            "Bar"
        ],
        NL: [
            "Amsterdam",
            "Rotterdam",
            "The Hague",
            "Utrecht",
            "Eindhoven"
        ],
        NO: [
            "Oslo",
            "Bergen",
            "Trondheim",
            "Stavanger",
            "Drammen"
        ],
        PL: [
            "Warsaw",
            "Krakow",
            "Lodz",
            "Wroclaw",
            "Poznan"
        ],
        PT: [
            "Lisbon",
            "Porto",
            "Vila Nova de Gaia",
            "Amadora",
            "Braga"
        ],
        RO: [
            "Bucharest",
            "Cluj-Napoca",
            "Timi\u0219oara",
            "Ia\u0219i",
            "Constan\u021Ba"
        ],
        RU: [
            "Moscow",
            "Saint Petersburg",
            "Novosibirsk",
            "Yekaterinburg",
            "Kazan"
        ],
        SM: [
            "San Marino",
            "Serravalle",
            "Borgo Maggiore",
            "Domagnano",
            "Fiorentino"
        ],
        RS: [
            "Belgrade",
            "Novi Sad",
            "Ni\u0161",
            "Kragujevac",
            "Subotica"
        ],
        SK: [
            "Bratislava",
            "Ko\u0161ice",
            "Pre\u0161ov",
            "\u017Dilina",
            "Nitra"
        ],
        SI: [
            "Ljubljana",
            "Maribor",
            "Celje",
            "Kranj",
            "Velenje"
        ],
        ES: [
            "Madrid",
            "Barcelona",
            "Valencia",
            "Seville",
            "Zaragoza"
        ],
        SE: [
            "Stockholm",
            "Gothenburg",
            "Malm\xf6",
            "Uppsala",
            "V\xe4ster\xe5s"
        ],
        CH: [
            "Zurich",
            "Geneva",
            "Basel",
            "Lausanne",
            "Bern"
        ],
        UA: [
            "Kyiv",
            "Kharkiv",
            "Odessa",
            "Dnipro",
            "Donetsk"
        ],
        VA: [
            "Vatican City"
        ],
        US: [
            "New York",
            "Los Angeles",
            "Chicago",
            "Houston",
            "Phoenix",
            "Philadelphia",
            "San Antonio",
            "San Diego",
            "Dallas",
            "San Jose",
            "Austin",
            "Jacksonville",
            "Fort Worth",
            "Columbus",
            "Charlotte"
        ],
        CA: [
            "Toronto",
            "Montreal",
            "Vancouver",
            "Calgary",
            "Edmonton",
            "Ottawa",
            "Winnipeg",
            "Quebec City",
            "Hamilton",
            "Brampton"
        ],
        AU: [
            "Sydney",
            "Melbourne",
            "Brisbane",
            "Perth",
            "Adelaide",
            "Gold Coast",
            "Canberra"
        ],
        NZ: [
            "Auckland",
            "Wellington",
            "Christchurch",
            "Hamilton",
            "Tauranga"
        ],
        GB: [
            "London",
            "Birmingham",
            "Leeds",
            "Glasgow",
            "Sheffield",
            "Bradford",
            "Manchester",
            "Edinburgh",
            "Liverpool",
            "Bristol"
        ]
    }
};


var $8524f178d775a6bd$var$getRandomString = function(array) {
    var randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
};
var $8524f178d775a6bd$var$imageArray = [
    "https://uploads-ssl.webflow.com/64bfa5e0facc755c5e415e1b/64bfc678772b2c24b04208a2_bundle1.png",
    "https://uploads-ssl.webflow.com/64bfa5e0facc755c5e415e1b/64bfc67873964b051ab1c9c5_bundle2.png",
    "https://uploads-ssl.webflow.com/64bfa5e0facc755c5e415e1b/64bfc67877d242c996e64602_bundle3.png",
    "https://uploads-ssl.webflow.com/64bfa5e0facc755c5e415e1b/64bfc67875299ea875b3cc26_bundle4.png"
];
var $8524f178d775a6bd$export$8c60f3bd53dde2c2 = function(productName, images) {
    var maxProductQuantity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var country = window.GEO.country;
    var fomoLocation = $8524f178d775a6bd$var$getRandomString((0, $43f7f7eb6de5d597$export$d36a5df19cad8743).cities[country] || (0, $43f7f7eb6de5d597$export$d36a5df19cad8743).cities.US);
    var fomoName = $8524f178d775a6bd$var$getRandomString((0, $43f7f7eb6de5d597$export$d36a5df19cad8743).names[country] || (0, $43f7f7eb6de5d597$export$d36a5df19cad8743).names.US);
    var fomoMinutes = Math.floor(Math.random() * 30) + 1;
    var number = Math.floor(Math.random() * maxProductQuantity) + 2;
    var fomoImage = images ? images[number - 1] : $8524f178d775a6bd$var$imageArray[number - 1];
    var fomoProduct = "".concat(number).concat(productName || "x Bandoo Box");
    return {
        fomoMinutes: fomoMinutes.toString(),
        fomoLocation: fomoLocation,
        fomoProduct: fomoProduct,
        fomoImage: fomoImage,
        fomoName: fomoName
    };
};
var $8524f178d775a6bd$export$17dc7d01743566bc = function(products, productName) {
    var country = window.GEO.country;
    var fomoLocation = $8524f178d775a6bd$var$getRandomString((0, $43f7f7eb6de5d597$export$d36a5df19cad8743).cities[country] || (0, $43f7f7eb6de5d597$export$d36a5df19cad8743).cities.US);
    var fomoName = $8524f178d775a6bd$var$getRandomString((0, $43f7f7eb6de5d597$export$d36a5df19cad8743).names[country] || (0, $43f7f7eb6de5d597$export$d36a5df19cad8743).names.US);
    var fomoMinutes = Math.floor(Math.random() * 30) + 1;
    var randomIndex = Math.floor(Math.random() * products.length);
    var randomProduct = products[randomIndex];
    var fomoImage = (randomProduct === null || randomProduct === void 0 ? void 0 : randomProduct.imageReference) || (randomProduct === null || randomProduct === void 0 ? void 0 : randomProduct.image);
    var fomoProduct = "".concat((randomProduct === null || randomProduct === void 0 ? void 0 : randomProduct.quantity) || 1).concat(productName);
    var notification = {
        fomoMinutes: fomoMinutes.toString(),
        fomoLocation: fomoLocation,
        fomoProduct: fomoProduct,
        fomoImage: fomoImage,
        fomoName: fomoName
    };
    return notification;
};


var $86f961742fd27aa4$export$9a00dee1beb8f576 = function(str) {
    return str.split(" ").map(function(w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(" ");
};
var $86f961742fd27aa4$export$8e831c751a9f504f = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};


var $13f670394c23e173$export$7bcc3fa3b490ab9e = function UiController() {
    "use strict";
    (0, $fvacx._)(this, UiController);
    this.initDynamicYear = function() {
        var elementId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "current-year", elementIds = arguments.length > 1 ? arguments[1] : void 0;
        if (elementIds && Array.isArray(elementIds)) elementIds.forEach(function(id) {
            document.querySelectorAll("#".concat(id)).forEach(function(element) {
                if (element) element.textContent = "".concat(new Date().getFullYear());
            });
        });
        else document.querySelectorAll("#".concat(elementId)).forEach(function(element) {
            if (element) element.textContent = "".concat(new Date().getFullYear());
        });
    };
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.softenCtas = function() {
    var ctaTexts = document.querySelectorAll("#buttonContent");
    ctaTexts.forEach(function(btn) {
        if (btn.textContent) btn.textContent = "Yes, Add To My Order";
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.getPhoneNumber = function() {
    var componentId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "phoneNumber";
    var _phoneInput$value2;
    var phoneInput = document.getElementById(componentId);
    if (phoneInput && window.intlTelInputGlobals) try {
        var _window$intlTelInputG;
        return ((_window$intlTelInputG = window.intlTelInputGlobals.getInstance(phoneInput).getNumber()) === null || _window$intlTelInputG === void 0 ? void 0 : _window$intlTelInputG.replace(/\D/g, "")) || undefined;
    } catch (e) {
        var _phoneInput$value;
        return (phoneInput === null || phoneInput === void 0 ? void 0 : (_phoneInput$value = phoneInput.value) === null || _phoneInput$value === void 0 ? void 0 : _phoneInput$value.replace(/\D/g, "")) || undefined;
    }
    return (phoneInput === null || phoneInput === void 0 ? void 0 : (_phoneInput$value2 = phoneInput.value) === null || _phoneInput$value2 === void 0 ? void 0 : _phoneInput$value2.replace(/\D/g, "")) || undefined;
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.addSkipAfterFirstCta = function(href) {
    $13f670394c23e173$export$7bcc3fa3b490ab9e.removeFirstSkipLink();
    var firstCta = document.querySelector("#buyButton");
    if (firstCta) {
        var skipLink = document.createElement("a");
        skipLink.textContent = "I want to skip this one-time offer";
        skipLink.href = href;
        skipLink.style.color = "#818997";
        skipLink.style.fontSize = "1rem";
        skipLink.style.lineHeight = "1.3";
        skipLink.className = "codegen-skip-link";
        skipLink.id = (0, $13c7326b49cbd18b$export$504c889bcc104ed7)(1) ? "downsellOpenButton" : "skipLink";
        firstCta.insertAdjacentElement("afterend", skipLink);
    }
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.removeFirstSkipLink = function() {
    var _document$querySelect;
    var firstCta = (_document$querySelect = document.querySelector("#buyButton")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.parentElement;
    var skipLinks = firstCta === null || firstCta === void 0 ? void 0 : firstCta.querySelectorAll('#downsellOpenButton, [data-translation="skipLink"]');
    if (skipLinks) skipLinks.forEach(function(link) {
        link.remove();
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.changeLayout = function(href) {
    var utmSource = (0, $5afc064d4f10b824$export$49b9065228a93aae)("utm_source", "").toLowerCase();
    if (utmSource !== "test" && window.GEO.country === "US") {
        var aggressiveSources = {
            mobile: [
                "outbrain",
                "facebook",
                "tiktok",
                "email",
                "sms",
                "google",
                "bing"
            ],
            desktop: [
                "email",
                "sms"
            ]
        };
        var aggressive = (0, $50a3061aa036fb76$export$d0a8044dce8ff2fc)() ? aggressiveSources.mobile.includes(utmSource) : aggressiveSources.desktop.includes(utmSource);
        if (aggressive) {
            $13f670394c23e173$export$7bcc3fa3b490ab9e.removeFirstSkipLink();
            (0, $5afc064d4f10b824$export$4f2e34905c9fb7fa)({
                utm_skip: "off"
            });
        } else {
            $13f670394c23e173$export$7bcc3fa3b490ab9e.softenCtas();
            $13f670394c23e173$export$7bcc3fa3b490ab9e.addSkipAfterFirstCta(href);
            (0, $5afc064d4f10b824$export$4f2e34905c9fb7fa)({
                utm_skip: "on"
            });
        }
    } else (0, $5afc064d4f10b824$export$4f9c066ec897736f)("utm_skip");
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.populateOneClickProductCard = function(product) {
    var images = document.querySelectorAll("#productImg");
    if (images.length > 0) images.forEach(function(img) {
        img.src = product.image;
    });
    if (window["productName"]) window["productName"].textContent = product.name;
    if (window["fullPrice"]) window["fullPrice"].textContent = product.fullPrice.toFixed(2);
    if (window["finalPrice"]) window["finalPrice"].textContent = product.finalPrice.toFixed(2);
    if (window["discount"]) window["discount"].textContent = product.discount;
    if (window["discountAmount"]) window["discountAmount"].textContent = parseFloat(product.discountAmount).toFixed(2);
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.removeInvisibleElements = function() {
    document.querySelectorAll("[data-remove-on-visibility]").forEach(function(e) {
        if ((0, $5743262db8c9d9ed$export$1caa22d7c21a2ee3)(e)) e.remove();
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.injectLeadName = function(selectorId, firstName) {
    var span = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)(selectorId);
    if (span) span.textContent = (0, $86f961742fd27aa4$export$9a00dee1beb8f576)(firstName);
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.appendOnsiteLinksWithParams = function(params) {
    document.querySelectorAll("a").forEach(function(link) {
        if (link.id !== "buyButton") {
            var linkHref = link.getAttribute("href");
            if (linkHref && !linkHref.startsWith("mailto:") && !linkHref.startsWith("tel:")) {
                // Check if link already has parameters
                var separator = linkHref.includes("?") ? "&" : "?";
                link.setAttribute("href", "".concat(linkHref).concat(separator).concat(params));
            }
        }
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.handleExpressPaymentButtons = function(showApplePay, showGooglePay) {
    if (showApplePay) {
        var appleButton = document.querySelector("#apple-pay-container");
        if (appleButton) {
            appleButton.style.display = "flex";
            appleButton.style.width = "100%";
        }
    }
    if (showGooglePay) {
        var googleButton = document.querySelector("#google-pay-container");
        if (googleButton) {
            googleButton.style.display = "flex";
            googleButton.style.width = "100%";
        }
    }
    if (showApplePay && showGooglePay) {
        var expressContainer = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("express-payment-container");
        if (expressContainer) expressContainer.style.display = "block";
    }
    var appleGoogleContainer = document.querySelector("#google-apple-pay-container");
    if (appleGoogleContainer) appleGoogleContainer.style.display = "flex";
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.getCountriesArray = function() {
    var countries = (0, $a0ee6d2d3db760af$export$2e2bcd8739ae039).getAllCountries();
    var brand = window.BRAND;
    var allowedCodes = (0, $efc8a778940d2b1e$export$703f3c34cd041799)[brand] || (0, $efc8a778940d2b1e$export$703f3c34cd041799)["default"];
    var mapped = countries.map(function(c) {
        return {
            name: c.name,
            code: c.isoCode
        };
    }).filter(function(c) {
        return allowedCodes.includes(c.code);
    });
    // Add Deutschland if DE is in the allowed list and not already included
    if (allowedCodes.includes("DE") && !mapped.some(function(c) {
        return c.code === "DE";
    })) mapped.push({
        name: "Deutschland",
        code: "DE"
    });
    return mapped;
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.getCountryStates = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(code) {
        var states;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).fetchStates(code)
                    ];
                case 1:
                    states = _state.sent();
                    return [
                        2,
                        states.map(function(s) {
                            return {
                                name: s.name,
                                code: s.isoCode
                            };
                        })
                    ];
            }
        });
    });
    return function(code) {
        return _ref.apply(this, arguments);
    };
}();
$13f670394c23e173$export$7bcc3fa3b490ab9e.getCountryPhoneCode = function(code) {
    var country = (0, $a0ee6d2d3db760af$export$2e2bcd8739ae039).getCountryByCode(code);
    return "+".concat(country === null || country === void 0 ? void 0 : country.phonecode);
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.initOfferCardSelector = function(props) {
    var selectedIdx = props.selectedIdx || 0;
    var offerCards = document.querySelectorAll("[".concat(props.indexAttribute, "]"));
    // Apply initial selection style
    offerCards.forEach(function(card) {
        var productIndex = card.getAttribute(props.indexAttribute);
        if (productIndex && parseInt(productIndex, 10) === selectedIdx) // Apply selected style
        props.onStyleSelected(card);
    });
    offerCards.forEach(function(card) {
        card.addEventListener("click", function(e) {
            var _e$target;
            // On click iterate all card and remove stying
            offerCards.forEach(function(c) {
                return props.onRemoveSelected(c);
            });
            var selectedCard = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.closest("[".concat(props.indexAttribute, "]"));
            if (selectedCard) {
                var selectedProductIdx = selectedCard.getAttribute(props.indexAttribute);
                // Find all elements with this product index
                var selectedCards = document.querySelectorAll('[productIdx="'.concat(selectedProductIdx, '"]'));
                // Apply selected style
                selectedCards.forEach(function(c) {
                    return props.onStyleSelected(c);
                });
            }
        });
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.startTimer = function(timerEl) {
    var defaultTime = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "30", minutesElementId = arguments.length > 2 ? arguments[2] : void 0, secondsElemnentId = arguments.length > 3 ? arguments[3] : void 0;
    var currentSeconds = parseInt(defaultTime, 10);
    var interval = setInterval(function() {
        currentSeconds--;
        if (currentSeconds < 0) {
            clearInterval(interval);
            currentSeconds = parseInt(defaultTime, 10);
        }
        var minutes = Math.floor(currentSeconds / 60);
        var seconds = currentSeconds - minutes * 60;
        var minutesStr = minutes > 9 ? minutes.toString() : "0".concat(minutes);
        var secondsStr = seconds > 9 ? seconds.toString() : "0".concat(seconds);
        if (minutesElementId) {
            var minutesEl = timerEl.querySelector("#".concat(minutesElementId));
            if (minutesEl) minutesEl.textContent = minutesStr;
        }
        if (secondsElemnentId) {
            var secondsEl = timerEl.querySelector("#".concat(secondsElemnentId));
            if (secondsEl) secondsEl.textContent = secondsStr;
        } else timerEl.textContent = "".concat(minutesStr, ":").concat(secondsStr);
    }, 1000);
    timerEl.dataset.intervalId = interval.toString();
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.initTimer = function(defaultTime, minutesElementId, secondsElemnentId, timerElementSelector) {
    var timers = document.querySelectorAll(timerElementSelector || "[timer-initial]");
    timers.forEach(function(el) {
        return $13f670394c23e173$export$7bcc3fa3b490ab9e.startTimer(el, defaultTime, minutesElementId, secondsElemnentId);
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.showErrorModal = function(message) {
    var modal = document.getElementById("errorModal");
    var messageText = document.getElementById("errorMessage");
    var errorCloseButton = document.getElementById("errorModalButton");
    if (!modal) {
        var error = new Error("FunnelError: ErrorModal Component not found - unable to show user errors");
        Errors.report(error, undefined, false, false);
    }
    if (modal && messageText && errorCloseButton) {
        messageText.innerHTML = message;
        modal.style.display = "block";
        modal.addEventListener("click", function() {
            modal.style.display = "none";
            messageText.innerHTML = "None";
        });
        errorCloseButton.addEventListener("click", function() {
            modal.style.display = "none";
            messageText.innerHTML = "None";
        });
    }
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.showPpLoaderModal = function(show) {
    var modal = document.getElementById("ppModal");
    if (modal) modal.style.display = show ? "block" : "none";
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.showModalLoader = function(loading) {
    var modalLoader = document.getElementById("modalLoader");
    if (modalLoader) {
        if (loading) modalLoader.style.display = "flex";
        else modalLoader.style.display = "none";
    }
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.setButtonLoading = function(buttonId, loading) {
    var btn = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)(buttonId);
    if (btn) {
        btn.disabled = loading;
        btn.style.opacity = loading ? "0.6" : "1";
        var loader = btn.querySelector("#loader");
        if (loader) loader.style.display = loading ? "block" : "none";
    }
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.setButtonDisabled = function(buttonId, disabled) {
    var btn = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)(buttonId);
    if (btn) {
        btn.disabled = disabled;
        btn.style.opacity = disabled ? "0.6" : "1";
    }
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.setUpsellButtonLoading = function(loading) {
    var buttons = document.querySelectorAll("#buyButton");
    buttons.forEach(function(b) {
        b.style.opacity = loading ? "0.6" : "1";
        b.style.pointerEvents = loading ? "none" : "auto";
        var loader = b.querySelector("#loader");
        if (loader) loader.style.display = loading ? "block" : "none";
        var buttonContent = b.querySelectorAll("#buttonContent");
        if (buttonContent.length > 0) buttonContent.forEach(function(el) {
            el.style.display = loading ? "none" : "block";
        });
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.setElementLoading = function(id, loading, log) {
    var elements = document.querySelectorAll("#".concat(id));
    if (log) console.log("log: ", log);
    elements.forEach(function(element) {
        element.style.opacity = loading ? "0.6" : "1";
        element.style.pointerEvents = loading ? "none" : "auto";
        var loader = element.querySelector("#loader");
        if (loader) loader.style.display = loading ? "block" : "none";
        var buttonContent = element.querySelectorAll("#buttonContent");
        if (buttonContent.length > 0) buttonContent.forEach(function(el) {
            el.style.display = loading ? "none" : "block";
        });
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.showAvailablePaymentMethods = function(paymentMethods) {
    var paymentMethodsContainer = document.querySelector("#availablePayments");
    if (!paymentMethodsContainer) {
        console.error("No element found");
        return;
    }
    var dynamicMethods = paymentMethodsContainer.querySelectorAll(".dynamic-method");
    dynamicMethods.forEach(function(method) {
        return method.remove();
    });
    paymentMethods.forEach(function(method) {
        var methodContainer = document.createElement("div");
        methodContainer.className = "available-payment-block dynamic-method";
        var img = document.createElement("img");
        img.src = method.asset_urls.standard;
        img.alt = method.name;
        var span = document.createElement("span");
        span.innerText = method.name;
        span.className = "payment-method-name";
        span.style.marginLeft = "8px";
        methodContainer.appendChild(img);
        methodContainer.appendChild(span);
        paymentMethodsContainer.appendChild(methodContainer);
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.createOption = function(value, text, initialValue) {
    var option = document.createElement("option");
    option.text = text;
    option.value = value;
    if (value === initialValue) option.selected = true;
    return option;
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.removeNonDefaultOptions = function(selectEl) {
    if (selectEl && selectEl.options.length > 1) for(var i = selectEl.options.length - 1; i >= 1; i--)selectEl.remove(i);
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.populateDropdown = function(el, values, textKey, valueKey, initialValue) {
    values.forEach(function(v) {
        var text = textKey ? v[textKey] : v;
        var value = valueKey ? v[valueKey] : v;
        var option = $13f670394c23e173$export$7bcc3fa3b490ab9e.createOption(value, text, initialValue);
        el.add(option);
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.showDownsell = function(show, productIdx, downsellModalId) {
    var modalId = downsellModalId || "downsellModal";
    var modal = document.getElementById(modalId);
    if (modal) {
        modal.style.display = show ? "flex" : "none";
        var prevValue = window["productIdx"].value;
        window["productIdx"].value = productIdx;
        if (show) modal.addEventListener("click", function(e) {
            if (e.target === modal) {
                modal.style.display = "none";
                window["productIdx"].value = prevValue;
            }
        });
    }
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.initDownsellSelectors = function(buttonId, upsellKey, trackingName, productIdx, downsellModalId) {
    var downsellOpenButtons = document.querySelectorAll(buttonId);
    if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(1) && downsellOpenButtons.length === 0) Errors.report(new Error("No downsell buttons found with id: ".concat(buttonId)), undefined, false, false);
    downsellOpenButtons.forEach(function(btn) {
        btn.addEventListener("click", function(e) {
            e.preventDefault();
            $13f670394c23e173$export$7bcc3fa3b490ab9e.showDownsell(true, productIdx, downsellModalId);
            (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackPageView("Downsell".concat(upsellKey), trackingName);
        });
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.showNotification = function(show, info) {
    var notifElement = window["fomoNotif"];
    if (show && info) {
        window["fomoImage"].src = info.fomoImage;
        window["fomoName"].textContent = info.fomoName;
        window["fomoLocation"].textContent = info.fomoLocation;
        window["fomoProduct"].textContent = info.fomoProduct;
        window["fomoMinutes"].textContent = info.fomoMinutes;
        // Remove any fade-out class, add fade-in, and set display to flex
        notifElement.classList.remove("fomo-fade-out");
        notifElement.classList.add("fomo-fade-in");
        notifElement.style.display = "flex";
    } else {
        // Start the fade-out animation
        notifElement.classList.remove("fomo-fade-in");
        notifElement.classList.add("fomo-fade-out");
        // Set display to none after the animation duration (1s in this example)
        setTimeout(function() {
            notifElement.style.display = "none";
        }, 1000);
    }
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.initFomoNotification = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(productName, images) {
        var disabledCountries, i, notif;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    disabledCountries = [
                        "LT"
                    ];
                    if (!!disabledCountries.includes(window.GEO.country)) return [
                        3,
                        5
                    ];
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < 6)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        sleep(8000)
                    ];
                case 2:
                    _state.sent();
                    notif = (0, $8524f178d775a6bd$export$8c60f3bd53dde2c2)(productName, images);
                    $13f670394c23e173$export$7bcc3fa3b490ab9e.showNotification(true, notif);
                    // Adjust this sleep to account for the fade-in animation
                    return [
                        4,
                        sleep(7000)
                    ];
                case 3:
                    _state.sent(); // 6s + 1s for fade-out
                    $13f670394c23e173$export$7bcc3fa3b490ab9e.showNotification(false);
                    _state.label = 4;
                case 4:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function(productName, images) {
        return _ref.apply(this, arguments);
    };
}();
$13f670394c23e173$export$7bcc3fa3b490ab9e.initProductsFomoNotification = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(productName, products) {
        var disabledCountries, i, notif;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    disabledCountries = [
                        "LT"
                    ];
                    if (!!disabledCountries.includes(window.GEO.country)) return [
                        3,
                        5
                    ];
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < 6)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        sleep(8000)
                    ];
                case 2:
                    _state.sent();
                    notif = (0, $8524f178d775a6bd$export$17dc7d01743566bc)(products, productName);
                    $13f670394c23e173$export$7bcc3fa3b490ab9e.showNotification(true, notif);
                    // Adjust this sleep to account for the fade-in animation
                    return [
                        4,
                        sleep(7000)
                    ];
                case 3:
                    _state.sent(); // 6s + 1s for fade-out
                    $13f670394c23e173$export$7bcc3fa3b490ab9e.showNotification(false);
                    _state.label = 4;
                case 4:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function(productName, products) {
        return _ref.apply(this, arguments);
    };
}();
$13f670394c23e173$export$7bcc3fa3b490ab9e.setFreeShipping = function() {
    var freeShipping = document.querySelectorAll("#freeShipping");
    freeShipping.forEach(function(el) {
        el.style.display = "flex";
    });
    var standardShipping = document.querySelectorAll("#standardShipping");
    standardShipping.forEach(function(el) {
        el.style.display = "none";
    });
};
$13f670394c23e173$export$7bcc3fa3b490ab9e.initCheckboxAddons = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(props) {
        var _window, _addonIdxs, cookieAddonIdxs, _, addonCheckboxIds, selectedCallback, unselectedCallback, preSelected;
        return (0, $33z5g.__generator)(this, function(_state) {
            try {
                ;
                cookieAddonIdxs = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("addonIdxs") || "[]";
                ;
                (_ = (_window = window)[_addonIdxs = "addonIdxs"]) !== null && _ !== void 0 ? _ : _window[_addonIdxs] = JSON.parse(cookieAddonIdxs);
                addonCheckboxIds = props.addonCheckboxIds, selectedCallback = props.selectedCallback, unselectedCallback = props.unselectedCallback, preSelected = props.preSelected;
                // Ensure window.pageAddons is initialized
                if (!window.pageAddons || !Array.isArray(window.pageAddons)) {
                    console.warn("window.pageAddons is not defined or not an array.");
                    return [
                        2
                    ];
                }
                // Handle checkboxes
                if (Array.isArray(addonCheckboxIds)) addonCheckboxIds.forEach(function(addonId) {
                    var addonCheckboxes = document.querySelectorAll("#".concat(addonId));
                    addonCheckboxes.forEach(function(checkbox) {
                        var addonIdx = checkbox.getAttribute("data-addon-idx");
                        if (!addonIdx) return;
                        var selectedAddon = window.pageAddons[parseInt(addonIdx, 10)];
                        var addonIdxNumber = parseInt(addonIdx, 10);
                        var storedValue = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("addon-".concat(addonIdx));
                        var isSelected = storedValue === "true" || preSelected && storedValue === null;
                        if (isSelected) {
                            checkbox.checked = true;
                            (0, $5743262db8c9d9ed$export$ecf43e4c55e727c6)(addonCheckboxIds, selectedAddon);
                            if (!window["addonIdxs"].some(function(item) {
                                return (item === null || item === void 0 ? void 0 : item.value) === addonIdxNumber;
                            })) {
                                window["addonIdxs"].push({
                                    value: addonIdxNumber,
                                    quantity: "1"
                                });
                                (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addonIdxs", JSON.stringify(window["addonIdxs"]), 15);
                            }
                        }
                        checkbox.addEventListener("click", function(e) {
                            var selected = e.target.checked;
                            (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addon-".concat(addonIdx), selected.toString(), 15);
                            (0, $5743262db8c9d9ed$export$ecf43e4c55e727c6)(addonCheckboxIds, selectedAddon);
                            if (selected) {
                                window["addonIdxs"].push({
                                    value: addonIdxNumber,
                                    quantity: "1"
                                });
                                (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addonIdxs", JSON.stringify(window["addonIdxs"]), 15);
                                selectedCallback === null || selectedCallback === void 0 || selectedCallback(addonIdxNumber);
                            } else {
                                var indexToRemove = window["addonIdxs"].findIndex(function(item) {
                                    return (item === null || item === void 0 ? void 0 : item.value) === addonIdxNumber;
                                });
                                if (indexToRemove !== -1) {
                                    window["addonIdxs"].splice(indexToRemove, 1);
                                    (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addonIdxs", JSON.stringify(window["addonIdxs"]), 15);
                                }
                                unselectedCallback === null || unselectedCallback === void 0 || unselectedCallback(addonIdxNumber);
                            }
                            if (window.DEBUG) console.log("Addon selected: ".concat(selected, ", AddonIdx: ").concat(addonIdxNumber, ", Current AddonIdxs:"), window["addonIdxs"]);
                        });
                    });
                });
            } catch (e) {
                console.error("Error in initCheckboxAddons:", e);
                Errors.report(e);
            }
            return [
                2
            ];
        });
    });
    return function(props) {
        return _ref.apply(this, arguments);
    };
}();
$13f670394c23e173$export$7bcc3fa3b490ab9e.initIncrementalAddons = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(props) {
        var _window, _addonIdxs, cookieAddonIdxs, _, addonIncreaseButtonIds, addonDecreaseButtonIds, selectedCallback, unselectedCallback;
        return (0, $33z5g.__generator)(this, function(_state) {
            try {
                ;
                cookieAddonIdxs = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("addonIdxs") || "[]";
                ;
                (_ = (_window = window)[_addonIdxs = "addonIdxs"]) !== null && _ !== void 0 ? _ : _window[_addonIdxs] = JSON.parse(cookieAddonIdxs);
                addonIncreaseButtonIds = props.addonIncreaseButtonIds, addonDecreaseButtonIds = props.addonDecreaseButtonIds, selectedCallback = props.selectedCallback, unselectedCallback = props.unselectedCallback;
                // Ensure window.pageAddons is initialized
                if (!window.pageAddons || !Array.isArray(window.pageAddons)) {
                    console.warn("window.pageAddons is not defined or not an array.");
                    return [
                        2
                    ];
                }
                // Handle increase buttons
                if (Array.isArray(addonIncreaseButtonIds)) addonIncreaseButtonIds.forEach(function(buttonId) {
                    var increaseButtons = document.querySelectorAll("#".concat(buttonId));
                    increaseButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            var hasRange = button.hasAttribute("data-addon-min-idx") && button.hasAttribute("data-addon-max-idx");
                            var callbackValue = 0;
                            var selectedAddon = window.pageAddons[callbackValue];
                            if (hasRange) {
                                var minIdx = parseInt(button.getAttribute("data-addon-min-idx") || "0", 10);
                                var maxIdx = parseInt(button.getAttribute("data-addon-max-idx") || "0", 10);
                                // Filter items in window['addonIdxs'] that are within the range
                                var validItems = window["addonIdxs"].filter(function(item) {
                                    return item && item.value >= minIdx && item.value <= maxIdx;
                                });
                                if (validItems.length > 0) {
                                    var _Math;
                                    var highestValue = (_Math = Math).max.apply(_Math, (0, $8xYJx._)(validItems.map(function(item) {
                                        return item.value;
                                    })));
                                    if (highestValue < maxIdx) {
                                        // Try to find an item with value (highestValue + 1)
                                        var existingNext = window["addonIdxs"].find(function(item) {
                                            return item.value === highestValue + 1;
                                        });
                                        if (existingNext) {
                                            // Increase its quantity
                                            existingNext.quantity += 1;
                                            callbackValue = existingNext.value;
                                            selectedAddon = window.pageAddons[callbackValue];
                                        } else {
                                            // "Move" the item with highestValue: update its value and increase its quantity by 1
                                            var indexToUpdate = window["addonIdxs"].findIndex(function(item) {
                                                return item.value === highestValue;
                                            });
                                            window["addonIdxs"][indexToUpdate].value = highestValue + 1;
                                            window["addonIdxs"][indexToUpdate].quantity += 1;
                                            callbackValue = highestValue + 1;
                                            selectedAddon = window.pageAddons[callbackValue];
                                        }
                                    } else {
                                        // Already at max: just increase the quantity of the item with maxIdx
                                        var index = window["addonIdxs"].findIndex(function(item) {
                                            return item.value === maxIdx;
                                        });
                                        if (index >= 0) {
                                            window["addonIdxs"][index].quantity += 1;
                                            callbackValue = maxIdx;
                                            selectedAddon = window.pageAddons[callbackValue];
                                        }
                                    }
                                } else {
                                    // No item in range: add a new one starting at the minimum value
                                    window["addonIdxs"].push({
                                        value: minIdx,
                                        quantity: 1
                                    });
                                    callbackValue = minIdx;
                                    selectedAddon = window.pageAddons[callbackValue];
                                }
                                (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addonIdxs", JSON.stringify(window["addonIdxs"]), 15);
                            } else {
                                // Non-range: update based on unique identifier
                                var addonIdx = parseInt(button.getAttribute("data-addon-idx") || "0", 10);
                                var index1 = window["addonIdxs"].findIndex(function(item) {
                                    return item && item.id === addonIdx;
                                });
                                if (index1 >= 0) {
                                    window["addonIdxs"][index1].quantity += 1;
                                    callbackValue = addonIdx;
                                    selectedAddon = window.pageAddons[callbackValue];
                                } else {
                                    window["addonIdxs"].push({
                                        id: addonIdx,
                                        value: addonIdx,
                                        quantity: 1
                                    });
                                    callbackValue = addonIdx;
                                    selectedAddon = window.pageAddons[callbackValue];
                                }
                                (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addonIdxs", JSON.stringify(window["addonIdxs"]), 15);
                            }
                            (0, $5743262db8c9d9ed$export$ecf43e4c55e727c6)(addonIncreaseButtonIds, selectedAddon);
                            (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addon-count", window["addonIdxs"].length.toString(), 15);
                            selectedCallback === null || selectedCallback === void 0 || selectedCallback(callbackValue);
                        });
                    });
                });
                // Handle decrease buttons
                if (Array.isArray(addonDecreaseButtonIds)) addonDecreaseButtonIds.forEach(function(buttonId) {
                    var decreaseButtons = document.querySelectorAll("#".concat(buttonId));
                    decreaseButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            var hasRange = button.hasAttribute("data-addon-min-idx") && button.hasAttribute("data-addon-max-idx");
                            var callbackValue = 0;
                            var selectedAddon = window.pageAddons[callbackValue];
                            if (hasRange) {
                                var minIdx = parseInt(button.getAttribute("data-addon-min-idx") || "0", 10);
                                var maxIdx = parseInt(button.getAttribute("data-addon-max-idx") || "0", 10);
                                // Filter items in window['addonIdxs'] that are within the range
                                var validItems = window["addonIdxs"].filter(function(item) {
                                    return item && item.value >= minIdx && item.value <= maxIdx;
                                });
                                if (validItems.length > 0) {
                                    var _Math;
                                    var lowestValue = (_Math = Math).min.apply(_Math, (0, $8xYJx._)(validItems.map(function(item) {
                                        return item.value;
                                    })));
                                    var indexToUpdate = window["addonIdxs"].findIndex(function(item) {
                                        return item.value === lowestValue;
                                    });
                                    if (lowestValue > minIdx) {
                                        // Instead of resetting quantity to 1, we decrease the quantity by 1
                                        if (window["addonIdxs"][indexToUpdate].quantity > 1) {
                                            window["addonIdxs"][indexToUpdate].quantity -= 1;
                                            // "Move" the item down one level:
                                            window["addonIdxs"][indexToUpdate].value = lowestValue - 1;
                                        } else // If quantity is 1, update its value to min (or remove it if desired)
                                        window["addonIdxs"][indexToUpdate].value = lowestValue - 1;
                                        callbackValue = lowestValue - 1;
                                        selectedAddon = window.pageAddons[callbackValue];
                                    } else {
                                        // At minimum level: remove the item entirely.
                                        callbackValue = minIdx;
                                        selectedAddon = window.pageAddons[callbackValue];
                                        window["addonIdxs"].splice(indexToUpdate, 1);
                                    }
                                }
                                (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addonIdxs", JSON.stringify(window["addonIdxs"]), 15);
                            } else {
                                // For non-range buttons, remove the object based on its unique identifier.
                                var addonIdx = parseInt(button.getAttribute("data-addon-idx") || "0", 10);
                                var indexToRemove = window["addonIdxs"].findIndex(function(item) {
                                    return item && item.id === addonIdx;
                                });
                                if (indexToRemove !== -1) {
                                    window["addonIdxs"].splice(indexToRemove, 1);
                                    callbackValue = addonIdx;
                                    selectedAddon = window.pageAddons[callbackValue];
                                }
                                (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addonIdxs", JSON.stringify(window["addonIdxs"]), 15);
                            }
                            (0, $5743262db8c9d9ed$export$ecf43e4c55e727c6)(addonDecreaseButtonIds, selectedAddon);
                            (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("addon-count", window["addonIdxs"].length.toString(), 15);
                            unselectedCallback === null || unselectedCallback === void 0 || unselectedCallback(callbackValue);
                        });
                    });
                });
            } catch (e) {
                console.error("Error in initIncrementalAddons:", e);
                Errors.report(e);
            }
            return [
                2
            ];
        });
    });
    return function(props) {
        return _ref.apply(this, arguments);
    };
}();


var $cbec8c04d0200356$export$821ec1715007eb78 = function LeadController(config, lead, purchased) {
    "use strict";
    var _this = this;
    (0, $fvacx._)(this, LeadController);
    this.purchased = [];
    this.appendUrlParams = function() {
        var params = (0, $13c7326b49cbd18b$export$154e6e3e573edb4e)(_this.lead);
        if (params) (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).appendOnsiteLinksWithParams(params);
    };
    this.reportPurchase = function() {
        var _this$lead2;
        var orderId = (_this$lead2 = _this.lead) === null || _this$lead2 === void 0 ? void 0 : _this$lead2.orderId;
        var shouldReport = (0, $13c7326b49cbd18b$export$504c889bcc104ed7)() || (0, $13c7326b49cbd18b$export$200a98ceebf95bbb)();
        var isFirstUpsell = parseInt("".concat(_this.config.pageType.match(/\d+/g)), 10) === 1;
        var _$purchased = (0, $bb523a3383634612$export$e8a7701893998d4e)();
        var lastProduct = _this.getLastPurchased();
        if (isFirstUpsell) {
            var products = _this.getPurchased();
            if (Array.isArray(products)) {
                products.forEach(function(el) {
                    var _purchased$el$id, _purchased$el$id2;
                    el.isDownsell = _$purchased === null || _$purchased === void 0 ? void 0 : (_purchased$el$id = _$purchased[el.id]) === null || _purchased$el$id === void 0 ? void 0 : _purchased$el$id.isDownsell;
                    el.upsellKey = typeof el.upsellKey === "number" ? el.upsellKey : _$purchased === null || _$purchased === void 0 ? void 0 : (_purchased$el$id2 = _$purchased[el.id]) === null || _purchased$el$id2 === void 0 ? void 0 : _purchased$el$id2.upsellKey;
                });
                (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackTransaction(_this.lead, lastProduct, undefined, products);
                (0, $4e431077f9691399$export$3672a9a17fd672c4).trackTransaction(_this.lead, lastProduct, undefined, products);
                (0, $bb523a3383634612$export$6b835e0e2980707e)(lastProduct, true);
            }
        } else if (shouldReport && orderId && lastProduct) {
            var _purchased$lastProduc, _purchased$lastProduc2, _purchased$idToReport, _this$lead3, _purchased$idToReport2, _purchased$idToReport3, _this$lead4;
            var idToReport = lastProduct.id;
            lastProduct.isDownsell = _$purchased === null || _$purchased === void 0 ? void 0 : (_purchased$lastProduc = _$purchased[lastProduct.id]) === null || _purchased$lastProduc === void 0 ? void 0 : _purchased$lastProduc.isDownsell;
            lastProduct.upsellKey = typeof lastProduct.upsellKey === "number" ? lastProduct.upsellKey : _$purchased === null || _$purchased === void 0 ? void 0 : (_purchased$lastProduc2 = _$purchased[lastProduct.id]) === null || _purchased$lastProduc2 === void 0 ? void 0 : _purchased$lastProduc2.upsellKey;
            if (!_$purchased || !(_$purchased !== null && _$purchased !== void 0 && (_purchased$idToReport = _$purchased[idToReport]) !== null && _purchased$idToReport !== void 0 && _purchased$idToReport.isPurchased) && ((_this$lead3 = _this.lead) === null || _this$lead3 === void 0 ? void 0 : _this$lead3.orderId) == (_$purchased === null || _$purchased === void 0 ? void 0 : (_purchased$idToReport2 = _$purchased[idToReport]) === null || _purchased$idToReport2 === void 0 ? void 0 : _purchased$idToReport2.orderId) || (_$purchased === null || _$purchased === void 0 ? void 0 : (_purchased$idToReport3 = _$purchased[idToReport]) === null || _purchased$idToReport3 === void 0 ? void 0 : _purchased$idToReport3.orderId) !== ((_this$lead4 = _this.lead) === null || _this$lead4 === void 0 ? void 0 : _this$lead4.orderId)) {
                (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackTransaction(_this.lead, lastProduct, lastProduct.upsellKey);
                (0, $4e431077f9691399$export$3672a9a17fd672c4).trackTransaction(_this.lead, lastProduct, lastProduct.upsellKey);
                (0, $bb523a3383634612$export$6b835e0e2980707e)(lastProduct, true);
            }
        }
    };
    this.getCheckoutLead = function() {
        var _phoneInput$value, _getVisibleElementByI, _this$lead5, _this$config, _this$lead6, _this$lead7, _this$lead8, _getVisibleElementByI2, _getVisibleElementByI3, _getVisibleElementByI4, _getVisibleElementByI5, _getVisibleElementByI6, _getVisibleElementByI7, _getVisibleElementByI8, _this$lead9;
        var phoneInput = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("phoneNumber");
        var optinCheckboxes = (0, $5743262db8c9d9ed$export$3b7aa821f91b0b75)("optinCheckbox");
        var optinCheckbox = (optinCheckboxes === null || optinCheckboxes === void 0 ? void 0 : optinCheckboxes.filter(function(el) {
            return el === null || el === void 0 ? void 0 : el.checked;
        })[0]) || optinCheckboxes[0];
        var vipCheckbox = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("vipCheckbox");
        var phoneNumerIntl = (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).getPhoneNumber("phoneNumber");
        var phoneNumber = _this.config.klarnaEnabled || _this.config.stripeKlarnaEnabled ? phoneInput === null || phoneInput === void 0 ? void 0 : (_phoneInput$value = phoneInput.value) === null || _phoneInput$value === void 0 ? void 0 : _phoneInput$value.replace(/\D/g, "") : phoneNumerIntl;
        var state = (0, $7754e9c9dfeff508$export$dea3cb4e0caec01a)() ? ((_getVisibleElementByI = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("state")) === null || _getVisibleElementByI === void 0 ? void 0 : _getVisibleElementByI.value) || undefined : "";
        var urlQueryParameters = (0, $27fc5057b004f1e0$export$fa3c4e23308a0d5b)();
        // If subscribtion product selected
        var campaignId = window.subSelected ? _this.config.subscriptionCampaignId : _this.config.campaignId;
        return (0, $e2Ogy._)({
            client: window.BRAND,
            orderId: ((_this$lead5 = _this.lead) === null || _this$lead5 === void 0 ? void 0 : _this$lead5.orderId) || undefined,
            sessionId: ((_this$config = _this.config) === null || _this$config === void 0 ? void 0 : _this$config.sessionId) || ((_this$lead6 = _this.lead) === null || _this$lead6 === void 0 ? void 0 : _this$lead6.sessionId),
            campaignId: campaignId,
            paySource: ((_this$lead7 = _this.lead) === null || _this$lead7 === void 0 ? void 0 : _this$lead7.paySource) || undefined,
            customerId: ((_this$lead8 = _this.lead) === null || _this$lead8 === void 0 ? void 0 : _this$lead8.customerId) || undefined,
            firstName: ((_getVisibleElementByI2 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("firstName")) === null || _getVisibleElementByI2 === void 0 ? void 0 : _getVisibleElementByI2.value) || undefined,
            lastName: ((_getVisibleElementByI3 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("lastName")) === null || _getVisibleElementByI3 === void 0 ? void 0 : _getVisibleElementByI3.value) || undefined,
            phoneNumber: phoneNumber,
            emailAddress: ((_getVisibleElementByI4 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("emailAddress")) === null || _getVisibleElementByI4 === void 0 ? void 0 : _getVisibleElementByI4.value) || undefined,
            ipAddress: window.GEO.ip || "::1",
            state: state,
            city: ((_getVisibleElementByI5 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("city")) === null || _getVisibleElementByI5 === void 0 ? void 0 : _getVisibleElementByI5.value) || undefined,
            country: ((_getVisibleElementByI6 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("country")) === null || _getVisibleElementByI6 === void 0 ? void 0 : _getVisibleElementByI6.value) || undefined,
            address1: ((_getVisibleElementByI7 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("address1")) === null || _getVisibleElementByI7 === void 0 ? void 0 : _getVisibleElementByI7.value) || undefined,
            postalCode: ((_getVisibleElementByI8 = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("postalCode")) === null || _getVisibleElementByI8 === void 0 ? void 0 : _getVisibleElementByI8.value) || undefined,
            shipPostalCode: ((_this$lead9 = _this.lead) === null || _this$lead9 === void 0 ? void 0 : _this$lead9.shipPostalCode) || undefined,
            billShipSame: true,
            custom_order_language: _this.config.locale,
            custom_order_marketing_opt_in: optinCheckbox ? optinCheckbox.checked : undefined,
            custom_order_10_off_vip: vipCheckbox ? vipCheckbox.checked : undefined,
            custom_user_agent: navigator.userAgent,
            custom_http_referer: window.location.href
        }, (0, $50a3061aa036fb76$export$a5202107d3e3cdb0)(), urlQueryParameters, (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)());
    };
    var _this1 = this;
    this.prefillForm = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var _$lead;
        return (0, $33z5g.__generator)(this, function(_state) {
            _$lead = _this1.lead;
            (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("emailAddress", _$lead === null || _$lead === void 0 ? void 0 : _$lead.emailAddress);
            (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("firstName", _$lead === null || _$lead === void 0 ? void 0 : _$lead.firstName);
            (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("lastName", _$lead === null || _$lead === void 0 ? void 0 : _$lead.lastName);
            (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("city", _$lead === null || _$lead === void 0 ? void 0 : _$lead.city);
            (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("address1", _$lead === null || _$lead === void 0 ? void 0 : _$lead.address1);
            (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("postalCode", _$lead === null || _$lead === void 0 ? void 0 : _$lead.postalCode);
            (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("country", _$lead === null || _$lead === void 0 ? void 0 : _$lead.country);
            (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("state", _$lead === null || _$lead === void 0 ? void 0 : _$lead.state);
            if (_this1.config.klarnaEnabled || _this1.config.stripeKlarnaEnabled) (0, $5743262db8c9d9ed$export$d395e3b20a2c5108)("phoneNumber", (_$lead === null || _$lead === void 0 ? void 0 : _$lead.phoneNumber) || "");
            else waitFor("intlTelInputUtils", function() {
                var phoneInput = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("phoneNumber");
                if (phoneInput) window.intlTelInputGlobals.getInstance(phoneInput).setNumber((_$lead === null || _$lead === void 0 ? void 0 : _$lead.phoneNumber) || "");
            });
            return [
                2
            ];
        });
    });
    var _this2 = this;
    this.createLead = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(paymentType) {
            var validate, _this$lead$firstName, _this$lead$lastName, shipPostalCode, payload, res, e;
            var _arguments = arguments;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        validate = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                        _this2.lead = _this2.getCheckoutLead();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (validate) (0, $48bbe448a6f79255$export$ea94ad0a55726449)(_this2.lead);
                        return [
                            4,
                            (0, $48bbe448a6f79255$export$3a96efd44caaf481)(_this2.lead.postalCode, _this2.lead.state, _this2.lead.country)
                        ];
                    case 2:
                        shipPostalCode = _state.sent();
                        payload = (0, $ioWVw._)((0, $e2Ogy._)({}, _this2.lead), {
                            orderId: undefined,
                            customerId: undefined,
                            paySource: undefined,
                            shipPostalCode: undefined,
                            postalCode: shipPostalCode,
                            firstName: (_this$lead$firstName = _this2.lead.firstName) === null || _this$lead$firstName === void 0 ? void 0 : _this$lead$firstName.replace(/\d/g, ""),
                            lastName: (_this$lead$lastName = _this2.lead.lastName) === null || _this$lead$lastName === void 0 ? void 0 : _this$lead$lastName.replace(/\d/g, ""),
                            custom3: "".concat(window.location.origin + window.location.pathname)
                        });
                        if (paymentType == "klarna") payload.custom2 = paymentType;
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importLead(payload)
                        ];
                    case 3:
                        res = _state.sent();
                        _this2.lead = (0, $ioWVw._)((0, $e2Ogy._)({}, _this2.lead), {
                            orderId: res.orderId,
                            customerId: res.customerId,
                            shipPostalCode: shipPostalCode
                        });
                        Errors.setUserContext(_this2.lead);
                        (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("order_id", res.orderId, 5);
                        return [
                            2,
                            _this2.lead
                        ];
                    case 4:
                        e = _state.sent();
                        Errors.report(e, {
                            lead: _this2.lead,
                            config: _this2.config
                        });
                        return [
                            2,
                            null
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(paymentType) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getLastPurchased = function() {
        var purchasedExcludingAddons = _this.purchased.filter(function(el) {
            return (el === null || el === void 0 ? void 0 : el.finalPrice) > 0;
        });
        var lastIdx = purchasedExcludingAddons.length - 1;
        return purchasedExcludingAddons[lastIdx];
    };
    this.getPurchased = function() {
        return _this.purchased;
    };
    this.setLeadInfo = function(firstName, lastName, postalCode, city, country, emailAddress, phoneNumber, address1) {
        if (firstName) _this.lead.firstName = firstName;
        if (lastName) _this.lead.lastName = lastName;
        if (postalCode) _this.lead.postalCode = postalCode;
        if (city) _this.lead.city = city;
        if (country) _this.lead.country = country;
        if (emailAddress) _this.lead.emailAddress = emailAddress;
        if (phoneNumber) _this.lead.phoneNumber = phoneNumber;
        if (address1) _this.lead.address1 = address1;
        if (window.DEBUG) console.log("lead: ", _this.lead);
        return _this.lead;
    };
    var _this$lead;
    this.lead = lead;
    this.config = config;
    this.purchased = purchased;
    this.appendUrlParams();
    this.reportPurchase();
    if ((_this$lead = this.lead) !== null && _this$lead !== void 0 && _this$lead.orderId) (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("order_id", this.lead.orderId, 10);
    if (window.DEBUG) console.log("LeadController:", this);
};
$cbec8c04d0200356$export$821ec1715007eb78.init = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(config) {
        var campaignId, _ref, lead, purchased;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    campaignId = config.campaignId;
                    return [
                        4,
                        (0, $7754e9c9dfeff508$export$97850e2d25587c0d)(campaignId)
                    ];
                case 1:
                    _ref = _state.sent(), lead = _ref.lead, purchased = _ref.purchased;
                    return [
                        2,
                        new $cbec8c04d0200356$export$821ec1715007eb78(config, lead, purchased)
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}();




var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $33z5g = parcelRequire("33z5g");
var $3b85c87cc8cc38ae$exports = {};

var $iHOCm = parcelRequire("iHOCm");
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    $3b85c87cc8cc38ae$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var _$n = t[o][1][e];
                    return s(_$n ? _$n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode("");
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function scheduleDrain() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== "undefined") {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function scheduleDrain() {
                            channel.port2.postMessage(0);
                        };
                    } else if ("document" in global1 && "onreadystatechange" in global1.document.createElement("script")) scheduleDrain = function scheduleDrain() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement("script");
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function scheduleDrain() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    "REJECTED"
                ];
                var FULFILLED = [
                    "FULFILLED"
                ];
                var PENDING = [
                    "PENDING"
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === "function") {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === "function") {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === "error") return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === "error") onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = "success";
                    } catch (e) {
                        out.status = "error";
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    if (typeof global1.Promise !== "function") global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof = typeof Symbol === "function" && (0, $iHOCm._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
                    return typeof obj === "undefined" ? "undefined" : (0, $iHOCm._)(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $iHOCm._)(obj);
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== "undefined") return indexedDB;
                        if (typeof webkitIndexedDB !== "undefined") return webkitIndexedDB;
                        if (typeof mozIndexedDB !== "undefined") return mozIndexedDB;
                        if (typeof OIndexedDB !== "undefined") return OIndexedDB;
                        if (typeof msIndexedDB !== "undefined") return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== "undefined";
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== "TypeError") throw e;
                        var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === "undefined") // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === "function") promise.then(callback);
                    if (typeof errorCallback === "function") promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== "string") {
                        console.warn(key + " used as a key, but it is not a string.");
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === "function") return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = "readonly";
                var READ_WRITE = "readwrite";
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var _$length = bin.length;
                    var buf = new ArrayBuffer(_$length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < _$length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ""
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === "boolean") return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === "ConstraintError") console.warn('The database "' + dbInfo.name + '"' + " has been upgraded from version " + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + " to version " + dbInfo.version + ".");
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || "");
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === "[object Blob]") return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var _$err = req.error ? req.error : req.transaction.error;
                                        reject(_$err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var _$err = req.error ? req.error : req.transaction.error;
                                        reject(_$err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var _$err = req.error ? req.error : req.transaction.error;
                                        reject(_$err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var _$keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(_$keys);
                                            return;
                                        }
                                        _$keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var _$db = req.result;
                                    if (_$db) _$db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var _$db = req.result;
                                    if (_$db) _$db.close();
                                    resolve(_$db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var _$db = req.result;
                                    _$db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var _$db = req.result;
                                    _$db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var _$db = req.result;
                                    _$db.close();
                                    resolve(_$db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: "asyncStorage",
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === "function";
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                var BLOB_TYPE_PREFIX = "~~local_forage_type~";
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = "__lfsc__:";
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = "arbf";
                var TYPE_BLOB = "blob";
                var TYPE_INT8ARRAY = "si08";
                var TYPE_UINT8ARRAY = "ui08";
                var TYPE_UINT8CLAMPEDARRAY = "uic8";
                var TYPE_INT16ARRAY = "si16";
                var TYPE_INT32ARRAY = "si32";
                var TYPE_UINT16ARRAY = "ur16";
                var TYPE_UINT32ARRAY = "ui32";
                var TYPE_FLOAT32ARRAY = "fl32";
                var TYPE_FLOAT64ARRAY = "fl64";
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === "=") {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === "=") bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = "";
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + "=";
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + "==";
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = "";
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === "[object Int8Array]") marker += TYPE_INT8ARRAY;
                            else if (valueType === "[object Uint8Array]") marker += TYPE_UINT8ARRAY;
                            else if (valueType === "[object Uint8ClampedArray]") marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === "[object Int16Array]") marker += TYPE_INT16ARRAY;
                            else if (valueType === "[object Uint16Array]") marker += TYPE_UINT16ARRAY;
                            else if (valueType === "[object Int32Array]") marker += TYPE_INT32ARRAY;
                            else if (valueType === "[object Uint32Array]") marker += TYPE_UINT32ARRAY;
                            else if (valueType === "[object Float32Array]") marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === "[object Float64Array]") marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error("Failed to get type for BinaryArray"));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === "[object Blob]") {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error("Unkown type: " + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " " + "(id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var _$length = rows.length;
                                    for(var i = 0; i < _$length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " " + "(key, value) VALUES (?, ?)", [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t, results) {
                                    var _$keys = [];
                                    for(var i = 0; i < results.rows.length; i++)_$keys.push(results.rows.item(i).key);
                                    resolve(_$keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, "", "", 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: "webSQLStorage",
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + "/";
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + "/";
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = "_localforage_support_test";
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var _$key = localStorage.key(i);
                            if (_$key.indexOf(keyPrefix) === 0) localStorage.removeItem(_$key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var _$length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < _$length; i++){
                            var _$key = localStorage.key(i);
                            if (_$key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(_$key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, _$key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var _$length = localStorage.length;
                        var _$keys = [];
                        for(var i = 0; i < _$length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) _$keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return _$keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + "/");
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var _$key = localStorage.key(i);
                            if (_$key.indexOf(keyPrefix) === 0) localStorage.removeItem(_$key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: "localStorageWrapper",
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === "[object Array]";
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    "dropInstance"
                ];
                var LibraryMethods = [
                    "clear",
                    "getItem",
                    "iterate",
                    "key",
                    "keys",
                    "length",
                    "removeItem",
                    "setItem"
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: "",
                    driver: DefaultDriverOrder.slice(),
                    name: "localforage",
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: "keyvaluepairs",
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === "storeName") options[i] = options[i].replace(/\W/g, "_");
                                if (i === "version" && typeof options[i] !== "number") return new Error("Database version must be a number.");
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ("driver" in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === "string") return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat("_initStorage");
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error("Method " + methodName + " is not implemented by the current driver");
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info("Redefining LocalForage driver: " + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ("_support" in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === "function") driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error("No available storage method found.");
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error("No available storage method found.");
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});



var $f7052bb2eb427bc1$export$4395c3ac0493290e = /*#__PURE__*/ function() {
    "use strict";
    function ForageService() {
        (0, $fvacx._)(this, ForageService);
        this.initDbStorage();
    }
    (0, $3D4gQ._)(ForageService, [
        {
            key: "initDbStorage",
            value: function initDbStorage() {
                var storeName = window.DEBUG ? "staging" : "production";
                (0, (/*@__PURE__*/$parcel$interopDefault($3b85c87cc8cc38ae$exports))).config({
                    storeName: storeName,
                    name: window.BRAND,
                    driver: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($3b85c87cc8cc38ae$exports))).INDEXEDDB,
                        (0, (/*@__PURE__*/$parcel$interopDefault($3b85c87cc8cc38ae$exports))).WEBSQL,
                        (0, (/*@__PURE__*/$parcel$interopDefault($3b85c87cc8cc38ae$exports))).LOCALSTORAGE
                    ]
                });
            }
        },
        {
            key: "getValue",
            value: function getValue(key) {
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var item, e;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($3b85c87cc8cc38ae$exports))).getItem(key)
                                ];
                            case 1:
                                item = _state.sent();
                                if ((0, $4b0c2be39d3732e4$export$a6cdc56e425d0d0a)(item)) {
                                    if ((0, $4b0c2be39d3732e4$export$94df19ecb868bc1a)(item, "dbExpiry")) {
                                        if (new Date().getTime() > item.dbExpiry) {
                                            _this.deleteValue(key);
                                            return [
                                                2,
                                                null
                                            ];
                                        } else return [
                                            2,
                                            item.value
                                        ];
                                    }
                                }
                                return [
                                    2,
                                    item
                                ];
                            case 2:
                                e = _state.sent();
                                Errors.report(e);
                                return [
                                    2,
                                    null
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteValue",
            value: function deleteValue(key) {
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($3b85c87cc8cc38ae$exports))).removeItem(key)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                Errors.report(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setValue",
            value: function setValue(key, value) {
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($3b85c87cc8cc38ae$exports))).setItem(key, value)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                Errors.report(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setValueWithExpiry",
            value: function setValueWithExpiry(key, value) {
                var expiryMin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 60;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var dbExpiry, valueWithExpiry, e;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                dbExpiry = new Date().getTime() + expiryMin * 60000; // Expiry time in milliseconds
                                valueWithExpiry = {
                                    value: value,
                                    dbExpiry: dbExpiry
                                };
                                return [
                                    4,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($3b85c87cc8cc38ae$exports))).setItem(key, valueWithExpiry)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                Errors.report(e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (!ForageService.instance) ForageService.instance = new ForageService();
                return ForageService.instance;
            }
        }
    ]);
    return ForageService;
}();






var $33z5g = parcelRequire("33z5g");

var $9b533d68ba0137ef$export$12151e9ef3722552 = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(param) {
        var ip, client, pageType, sessionId, leadEmail, campaignId, _param_isCheckout, isCheckout;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ip = param.ip, client = param.client, pageType = param.pageType, sessionId = param.sessionId, leadEmail = param.leadEmail, campaignId = param.campaignId, _param_isCheckout = param.isCheckout, isCheckout = _param_isCheckout === void 0 ? false : _param_isCheckout;
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importClick({
                            client: client,
                            pageType: pageType,
                            campaignId: campaignId,
                            acceptHeader: "*/*",
                            ipAddress: ip || "::1",
                            requestUri: location.href,
                            httpReferer: location.href,
                            emailAddress: leadEmail || "",
                            userAgent: navigator.userAgent,
                            sessionId: isCheckout ? undefined : sessionId
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getSession(_) {
        return _ref.apply(this, arguments);
    };
}();







var $fvacx = parcelRequire("fvacx");

var $33z5g = parcelRequire("33z5g");

var $fvacx = parcelRequire("fvacx");

var $8a100cb0ee4f7284$export$2055d41ab3fe06fa = function Eveflow() {
    "use strict";
    (0, $fvacx._)(this, Eveflow);
};
$8a100cb0ee4f7284$export$2055d41ab3fe06fa.trackAddToCart = function(client, transaction_id) {
    (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).sendEveflowAddToCart({
        client: client,
        transaction_id: transaction_id
    });
};




var $fvacx = parcelRequire("fvacx");

var $0d2dbb712d561fc5$export$b2b7e2b234995bfd = function Klaviyo() {
    "use strict";
    (0, $fvacx._)(this, Klaviyo);
};
$0d2dbb712d561fc5$export$b2b7e2b234995bfd.push = function(params) {
    var _window$_learnq;
    if (!window._learnq) window._learnq = [];
    (_window$_learnq = window._learnq) === null || _window$_learnq === void 0 || _window$_learnq.push(params);
};
$0d2dbb712d561fc5$export$b2b7e2b234995bfd.trackActiveOnSite = function(lead) {
    var _String, _String$replace;
    if (lead !== null && lead !== void 0 && lead.emailAddress && lead.emailAddress.startsWith("qa+")) return;
    $0d2dbb712d561fc5$export$b2b7e2b234995bfd.push([
        "identify",
        {
            $first_name: (lead === null || lead === void 0 ? void 0 : lead.firstName) || "",
            $last_name: (lead === null || lead === void 0 ? void 0 : lead.lastName) || "",
            $email: lead === null || lead === void 0 ? void 0 : lead.emailAddress,
            $phone_number: ((_String = String(lead === null || lead === void 0 ? void 0 : lead.phoneNumber)) === null || _String === void 0 ? void 0 : (_String$replace = _String.replace("+", "")) === null || _String$replace === void 0 ? void 0 : _String$replace.trim()) || ""
        }
    ]);
};
$0d2dbb712d561fc5$export$b2b7e2b234995bfd.trackViewedProduct = function(product) {
    $0d2dbb712d561fc5$export$b2b7e2b234995bfd.push([
        "track",
        "Viewed Product",
        {
            id: Number(product === null || product === void 0 ? void 0 : product.id),
            name: product === null || product === void 0 ? void 0 : product.name,
            imageURL: product.image,
            url: window.location.href,
            price: String(product.finalPrice),
            checkoutURL: window.location.href
        }
    ]);
    $0d2dbb712d561fc5$export$b2b7e2b234995bfd.push([
        "trackViewedItem",
        {
            ItemId: product.id,
            Title: product.name,
            Price: String(product.finalPrice)
        }
    ]);
};
$0d2dbb712d561fc5$export$b2b7e2b234995bfd.trackStartedCheckout = function(email, firstName, lastName, product, locale) {
    (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).sendStartedCheckoutEvent({
        email: email,
        first_name: firstName,
        last_name: lastName,
        locale: locale,
        client: window.BRAND,
        value: product.finalPrice,
        Items: JSON.stringify([
            {
                Quantity: 1,
                ProductID: product.id,
                imageURL: product.image,
                ProductName: product.name,
                RowTotal: product.finalPrice,
                ItemPrice: product.finalPrice,
                ProductURL: window.location.href,
                checkoutURL: window.location.href
            }
        ])
    });
};
$0d2dbb712d561fc5$export$b2b7e2b234995bfd.trackStartedCheckoutV2 = function(email, firstName, lastName, product, locale, phone_number) {
    if (!window.IS_1_CLICK) {
        var metaElement = document.querySelector('meta[name="product-subcategory"]') || document.getElementById("productSubCategory");
        var metaContent = metaElement === null || metaElement === void 0 ? void 0 : metaElement.content;
        var payload = {
            email: email,
            first_name: firstName,
            last_name: lastName,
            locale: locale,
            client: window.BRAND,
            country: window.GEO.country,
            city: window.GEO.city,
            timezone: window.GEO.timezone,
            region: window.GEO.region,
            ipAddress: window.GEO.ip,
            zipCode: window.GEO.postalCode,
            value: product.finalPrice,
            phone_number: phone_number,
            Items: JSON.stringify([
                {
                    Quantity: 1,
                    ProductID: product.id,
                    imageURL: product.image,
                    ProductName: product.name,
                    RowTotal: product.finalPrice,
                    ItemPrice: product.finalPrice,
                    ProductURL: window.location.href,
                    checkoutURL: window.location.href
                }
            ])
        };
        if (metaContent) payload.productSubCategory = metaContent;
        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).sendStartedCheckoutEventV2(payload);
    }
};
$0d2dbb712d561fc5$export$b2b7e2b234995bfd.trackAddToCart = function(lead, product) {
    if (lead !== null && lead !== void 0 && lead.emailAddress && lead.emailAddress.startsWith("qa+")) return;
    $0d2dbb712d561fc5$export$b2b7e2b234995bfd.trackActiveOnSite(lead);
    $0d2dbb712d561fc5$export$b2b7e2b234995bfd.push([
        "track",
        "Added to Cart",
        {
            $value: product.finalPrice,
            AddedItemProductName: product.name,
            AddedItem_Quantity: 1,
            Items: [
                {
                    ProductID: product.id,
                    ProductName: product.name,
                    Quantity: 1,
                    ItemPrice: product.finalPrice,
                    imageURL: product.image,
                    ProductURL: window.location.href,
                    checkoutURL: window.location.href
                }
            ]
        }
    ]);
};




var $fvacx = parcelRequire("fvacx");

var $8xYJx = parcelRequire("8xYJx");
var $4023b026e0fd237b$exports = {};
"use strict";
var $4023b026e0fd237b$var$__createBinding = $4023b026e0fd237b$exports && $4023b026e0fd237b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4023b026e0fd237b$var$__setModuleDefault = $4023b026e0fd237b$exports && $4023b026e0fd237b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4023b026e0fd237b$var$__importStar = $4023b026e0fd237b$exports && $4023b026e0fd237b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4023b026e0fd237b$var$__createBinding(result, mod, k);
    }
    $4023b026e0fd237b$var$__setModuleDefault(result, mod);
    return result;
};

var $4023b026e0fd237b$var$creditCardType = $4023b026e0fd237b$var$__importStar((parcelRequire("cuHyt")));
var $2e05e12945042189$exports = {};
"use strict";
Object.defineProperty($2e05e12945042189$exports, "__esModule", {
    value: true
});
$2e05e12945042189$exports.cardholderName = void 0;
var $2e05e12945042189$var$CARD_NUMBER_REGEX = /^[\d\s-]*$/;
var $2e05e12945042189$var$MAX_LENGTH = 255;
function $2e05e12945042189$var$verification(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function $2e05e12945042189$var$cardholderName(value) {
    if (typeof value !== "string") return $2e05e12945042189$var$verification(false, false);
    if (value.length === 0) return $2e05e12945042189$var$verification(false, true);
    if (value.length > $2e05e12945042189$var$MAX_LENGTH) return $2e05e12945042189$var$verification(false, false);
    if ($2e05e12945042189$var$CARD_NUMBER_REGEX.test(value)) return $2e05e12945042189$var$verification(false, true);
    return $2e05e12945042189$var$verification(true, true);
}
$2e05e12945042189$exports.cardholderName = $2e05e12945042189$var$cardholderName;


var $d300c5b9b41961a0$exports = {};
"use strict";
Object.defineProperty($d300c5b9b41961a0$exports, "__esModule", {
    value: true
});
$d300c5b9b41961a0$exports.cardNumber = void 0;
var $2ad75d0dafe2c2f7$exports = {};
/* eslint-disable */ /*
 * Luhn algorithm implementation in JavaScript
 * Copyright (c) 2009 Nicholas C. Zakas
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ "use strict";
function $2ad75d0dafe2c2f7$var$luhn10(identifier) {
    var sum = 0;
    var alt = false;
    var i = identifier.length - 1;
    var num;
    while(i >= 0){
        num = parseInt(identifier.charAt(i), 10);
        if (alt) {
            num *= 2;
            if (num > 9) num = num % 10 + 1; // eslint-disable-line no-extra-parens
        }
        alt = !alt;
        sum += num;
        i--;
    }
    return sum % 10 === 0;
}
$2ad75d0dafe2c2f7$exports = $2ad75d0dafe2c2f7$var$luhn10;



var $cuHyt = parcelRequire("cuHyt");
function $d300c5b9b41961a0$var$verification(card, isPotentiallyValid, isValid) {
    return {
        card: card,
        isPotentiallyValid: isPotentiallyValid,
        isValid: isValid
    };
}
function $d300c5b9b41961a0$var$cardNumber(value, options) {
    if (options === void 0) options = {};
    var isPotentiallyValid, isValid, maxLength;
    if (typeof value !== "string" && typeof value !== "number") return $d300c5b9b41961a0$var$verification(null, false, false);
    var testCardValue = String(value).replace(/-|\s/g, "");
    if (!/^\d*$/.test(testCardValue)) return $d300c5b9b41961a0$var$verification(null, false, false);
    var potentialTypes = $cuHyt(testCardValue);
    if (potentialTypes.length === 0) return $d300c5b9b41961a0$var$verification(null, false, false);
    else if (potentialTypes.length !== 1) return $d300c5b9b41961a0$var$verification(null, true, false);
    var cardType = potentialTypes[0];
    if (options.maxLength && testCardValue.length > options.maxLength) return $d300c5b9b41961a0$var$verification(cardType, false, false);
    if (options.skipLuhnValidation === true || cardType.type === $cuHyt.types.UNIONPAY && options.luhnValidateUnionPay !== true) isValid = true;
    else isValid = $2ad75d0dafe2c2f7$exports(testCardValue);
    maxLength = Math.max.apply(null, cardType.lengths);
    if (options.maxLength) maxLength = Math.min(options.maxLength, maxLength);
    for(var i = 0; i < cardType.lengths.length; i++)if (cardType.lengths[i] === testCardValue.length) {
        isPotentiallyValid = testCardValue.length < maxLength || isValid;
        return $d300c5b9b41961a0$var$verification(cardType, isPotentiallyValid, isValid);
    }
    return $d300c5b9b41961a0$var$verification(cardType, testCardValue.length < maxLength, false);
}
$d300c5b9b41961a0$exports.cardNumber = $d300c5b9b41961a0$var$cardNumber;


var $ecfbbf161e620db4$exports = {};
"use strict";
var $ecfbbf161e620db4$var$__assign = $ecfbbf161e620db4$exports && $ecfbbf161e620db4$exports.__assign || function() {
    $ecfbbf161e620db4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ecfbbf161e620db4$var$__assign.apply(this, arguments);
};
Object.defineProperty($ecfbbf161e620db4$exports, "__esModule", {
    value: true
});
$ecfbbf161e620db4$exports.expirationDate = void 0;
var $9a53dbdf677b174f$exports = {};
"use strict";
Object.defineProperty($9a53dbdf677b174f$exports, "__esModule", {
    value: true
});
$9a53dbdf677b174f$exports.parseDate = void 0;
var $9f9cb73549be28eb$exports = {};
"use strict";
Object.defineProperty($9f9cb73549be28eb$exports, "__esModule", {
    value: true
});
$9f9cb73549be28eb$exports.expirationYear = void 0;
var $9f9cb73549be28eb$var$DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;
function $9f9cb73549be28eb$var$verification(isValid, isPotentiallyValid, isCurrentYear) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        isCurrentYear: isCurrentYear || false
    };
}
function $9f9cb73549be28eb$var$expirationYear(value, maxElapsedYear) {
    if (maxElapsedYear === void 0) maxElapsedYear = $9f9cb73549be28eb$var$DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE;
    var isCurrentYear;
    if (typeof value !== "string") return $9f9cb73549be28eb$var$verification(false, false);
    if (value.replace(/\s/g, "") === "") return $9f9cb73549be28eb$var$verification(false, true);
    if (!/^\d*$/.test(value)) return $9f9cb73549be28eb$var$verification(false, false);
    var len = value.length;
    if (len < 2) return $9f9cb73549be28eb$var$verification(false, true);
    var currentYear = new Date().getFullYear();
    if (len === 3) {
        // 20x === 20x
        var firstTwo = value.slice(0, 2);
        var currentFirstTwo = String(currentYear).slice(0, 2);
        return $9f9cb73549be28eb$var$verification(false, firstTwo === currentFirstTwo);
    }
    if (len > 4) return $9f9cb73549be28eb$var$verification(false, false);
    var numericValue = parseInt(value, 10);
    var twoDigitYear = Number(String(currentYear).substr(2, 2));
    var valid = false;
    if (len === 2) {
        if (String(currentYear).substr(0, 2) === value) return $9f9cb73549be28eb$var$verification(false, true);
        isCurrentYear = twoDigitYear === numericValue;
        valid = numericValue >= twoDigitYear && numericValue <= twoDigitYear + maxElapsedYear;
    } else if (len === 4) {
        isCurrentYear = currentYear === numericValue;
        valid = numericValue >= currentYear && numericValue <= currentYear + maxElapsedYear;
    }
    return $9f9cb73549be28eb$var$verification(valid, valid, isCurrentYear);
}
$9f9cb73549be28eb$exports.expirationYear = $9f9cb73549be28eb$var$expirationYear;


var $eaaaee1647ae9dc1$exports = {};
"use strict";
// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.
Object.defineProperty($eaaaee1647ae9dc1$exports, "__esModule", {
    value: true
});
$eaaaee1647ae9dc1$exports.isArray = void 0;
$eaaaee1647ae9dc1$exports.isArray = Array.isArray || function(arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
};


function $9a53dbdf677b174f$var$getNumberOfMonthDigitsInDateString(dateString) {
    var firstCharacter = Number(dateString[0]);
    var assumedYear;
    /*
      if the first character in the string starts with `0`,
      we know that the month will be 2 digits.
  
      '0122' => {month: '01', year: '22'}
    */ if (firstCharacter === 0) return 2;
    /*
      if the first character in the string starts with
      number greater than 1, it must be a 1 digit month
  
      '322' => {month: '3', year: '22'}
    */ if (firstCharacter > 1) return 1;
    /*
      if the first 2 characters make up a number between
      13-19, we know that the month portion must be 1
  
      '139' => {month: '1', year: '39'}
    */ if (firstCharacter === 1 && Number(dateString[1]) > 2) return 1;
    /*
      if the first 2 characters make up a number between
      10-12, we check if the year portion would be considered
      valid if we assumed that the month was 1. If it is
      not potentially valid, we assume the month must have
      2 digits.
  
      '109' => {month: '10', year: '9'}
      '120' => {month: '1', year: '20'} // when checked in the year 2019
      '120' => {month: '12', year: '0'} // when checked in the year 2021
    */ if (firstCharacter === 1) {
        assumedYear = dateString.substr(1);
        return (0, $9f9cb73549be28eb$exports.expirationYear)(assumedYear).isPotentiallyValid ? 1 : 2;
    }
    /*
      If the length of the value is exactly 5 characters,
      we assume a full year was passed in, meaning the remaining
      single leading digit must be the month value.
  
      '12202' => {month: '1', year: '2202'}
    */ if (dateString.length === 5) return 1;
    /*
      If the length of the value is more than five characters,
      we assume a full year was passed in addition to the month
      and therefore the month portion must be 2 digits.
  
      '112020' => {month: '11', year: '2020'}
    */ if (dateString.length > 5) return 2;
    /*
      By default, the month value is the first value
    */ return 1;
}
function $9a53dbdf677b174f$var$parseDate(datestring) {
    var date;
    if (/^\d{4}-\d{1,2}$/.test(datestring)) date = datestring.split("-").reverse();
    else if (/\//.test(datestring)) date = datestring.split(/\s*\/\s*/g);
    else if (/\s/.test(datestring)) date = datestring.split(/ +/g);
    if ((0, $eaaaee1647ae9dc1$exports.isArray)(date)) return {
        month: date[0] || "",
        year: date.slice(1).join()
    };
    var numberOfDigitsInMonth = $9a53dbdf677b174f$var$getNumberOfMonthDigitsInDateString(datestring);
    var month = datestring.substr(0, numberOfDigitsInMonth);
    return {
        month: month,
        year: datestring.substr(month.length)
    };
}
$9a53dbdf677b174f$exports.parseDate = $9a53dbdf677b174f$var$parseDate;


var $ed13f75a8db728f3$exports = {};
"use strict";
Object.defineProperty($ed13f75a8db728f3$exports, "__esModule", {
    value: true
});
$ed13f75a8db728f3$exports.expirationMonth = void 0;
function $ed13f75a8db728f3$var$verification(isValid, isPotentiallyValid, isValidForThisYear) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        isValidForThisYear: isValidForThisYear || false
    };
}
function $ed13f75a8db728f3$var$expirationMonth(value) {
    var currentMonth = new Date().getMonth() + 1;
    if (typeof value !== "string") return $ed13f75a8db728f3$var$verification(false, false);
    if (value.replace(/\s/g, "") === "" || value === "0") return $ed13f75a8db728f3$var$verification(false, true);
    if (!/^\d*$/.test(value)) return $ed13f75a8db728f3$var$verification(false, false);
    var month = parseInt(value, 10);
    if (isNaN(Number(value))) return $ed13f75a8db728f3$var$verification(false, false);
    var result = month > 0 && month < 13;
    return $ed13f75a8db728f3$var$verification(result, result, result && month >= currentMonth);
}
$ed13f75a8db728f3$exports.expirationMonth = $ed13f75a8db728f3$var$expirationMonth;



function $ecfbbf161e620db4$var$verification(isValid, isPotentiallyValid, month, year) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        month: month,
        year: year
    };
}
function $ecfbbf161e620db4$var$expirationDate(value, maxElapsedYear) {
    var date;
    if (typeof value === "string") {
        value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, "$1/$2");
        date = (0, $9a53dbdf677b174f$exports.parseDate)(String(value));
    } else if (value !== null && typeof value === "object") {
        var fullDate = $ecfbbf161e620db4$var$__assign({}, value);
        date = {
            month: String(fullDate.month),
            year: String(fullDate.year)
        };
    } else return $ecfbbf161e620db4$var$verification(false, false, null, null);
    var monthValid = (0, $ed13f75a8db728f3$exports.expirationMonth)(date.month);
    var yearValid = (0, $9f9cb73549be28eb$exports.expirationYear)(date.year, maxElapsedYear);
    if (monthValid.isValid) {
        if (yearValid.isCurrentYear) {
            var isValidForThisYear = monthValid.isValidForThisYear;
            return $ecfbbf161e620db4$var$verification(isValidForThisYear, isValidForThisYear, date.month, date.year);
        }
        if (yearValid.isValid) return $ecfbbf161e620db4$var$verification(true, true, date.month, date.year);
    }
    if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) return $ecfbbf161e620db4$var$verification(false, true, null, null);
    return $ecfbbf161e620db4$var$verification(false, false, null, null);
}
$ecfbbf161e620db4$exports.expirationDate = $ecfbbf161e620db4$var$expirationDate;




var $1285db8094e769c0$exports = {};
"use strict";
Object.defineProperty($1285db8094e769c0$exports, "__esModule", {
    value: true
});
$1285db8094e769c0$exports.cvv = void 0;
var $1285db8094e769c0$var$DEFAULT_LENGTH = 3;
function $1285db8094e769c0$var$includes(array, thing) {
    for(var i = 0; i < array.length; i++){
        if (thing === array[i]) return true;
    }
    return false;
}
function $1285db8094e769c0$var$max(array) {
    var maximum = $1285db8094e769c0$var$DEFAULT_LENGTH;
    var i = 0;
    for(; i < array.length; i++)maximum = array[i] > maximum ? array[i] : maximum;
    return maximum;
}
function $1285db8094e769c0$var$verification(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function $1285db8094e769c0$var$cvv(value, maxLength) {
    if (maxLength === void 0) maxLength = $1285db8094e769c0$var$DEFAULT_LENGTH;
    maxLength = maxLength instanceof Array ? maxLength : [
        maxLength
    ];
    if (typeof value !== "string") return $1285db8094e769c0$var$verification(false, false);
    if (!/^\d*$/.test(value)) return $1285db8094e769c0$var$verification(false, false);
    if ($1285db8094e769c0$var$includes(maxLength, value.length)) return $1285db8094e769c0$var$verification(true, true);
    if (value.length < Math.min.apply(null, maxLength)) return $1285db8094e769c0$var$verification(false, true);
    if (value.length > $1285db8094e769c0$var$max(maxLength)) return $1285db8094e769c0$var$verification(false, false);
    return $1285db8094e769c0$var$verification(true, true);
}
$1285db8094e769c0$exports.cvv = $1285db8094e769c0$var$cvv;


var $3e7f71a619c835ef$exports = {};
"use strict";
Object.defineProperty($3e7f71a619c835ef$exports, "__esModule", {
    value: true
});
$3e7f71a619c835ef$exports.postalCode = void 0;
var $3e7f71a619c835ef$var$DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;
var $3e7f71a619c835ef$var$ALPHANUM = new RegExp(/^[a-z0-9]+$/i);
function $3e7f71a619c835ef$var$verification(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function $3e7f71a619c835ef$var$postalCode(value, options) {
    if (options === void 0) options = {};
    var minLength = options.minLength || $3e7f71a619c835ef$var$DEFAULT_MIN_POSTAL_CODE_LENGTH;
    if (typeof value !== "string") return $3e7f71a619c835ef$var$verification(false, false);
    else if (value.length < minLength) return $3e7f71a619c835ef$var$verification(false, true);
    else if (!$3e7f71a619c835ef$var$ALPHANUM.test(value.trim().slice(0, minLength))) return $3e7f71a619c835ef$var$verification(false, true);
    return $3e7f71a619c835ef$var$verification(true, true);
}
$3e7f71a619c835ef$exports.postalCode = $3e7f71a619c835ef$var$postalCode;


var $4023b026e0fd237b$var$cardValidator = {
    creditCardType: $4023b026e0fd237b$var$creditCardType,
    cardholderName: $2e05e12945042189$exports.cardholderName,
    number: $d300c5b9b41961a0$exports.cardNumber,
    expirationDate: $ecfbbf161e620db4$exports.expirationDate,
    expirationMonth: $ed13f75a8db728f3$exports.expirationMonth,
    expirationYear: $9f9cb73549be28eb$exports.expirationYear,
    cvv: $1285db8094e769c0$exports.cvv,
    postalCode: $3e7f71a619c835ef$exports.postalCode
};
$4023b026e0fd237b$exports = $4023b026e0fd237b$var$cardValidator;




var $3b6c46c9a3b69876$export$1926ec33ea263be2 = function CardService() {
    "use strict";
    var _this = this;
    (0, $fvacx._)(this, CardService);
    this.cardFormData = {
        cvv: "",
        number: "",
        cardType: "",
        expirationYear: "",
        expirationMonth: ""
    };
    this.prettyCardNumber = function(cardNumber, card) {
        var cardParams = card || (0, $48bbe448a6f79255$export$a7644059e2dddcf);
        var components = [];
        var offsets = [
            0
        ].concat((0, $8xYJx._)(cardParams.gaps), [
            cardNumber.length
        ]);
        for(var i = 0; offsets[i] < cardNumber.length; i++){
            var start = offsets[i];
            var end = Math.min(offsets[i + 1], cardNumber.length);
            components.push(cardNumber.substring(start, end));
        }
        return components.join(" ");
    };
    this.prettyExpiryDate = function(newValue, oldValue) {
        var regex = /^[2-9]$/;
        if (oldValue && oldValue.length > newValue.length) return newValue;
        if (String(newValue).length === 1 && regex.test(newValue)) // eslint-disable-next-line no-param-reassign
        newValue = "0".concat(newValue);
        return newValue.replace(/\D/g, "").replace(/\W/gi, "").replace(/(.{2})/g, "$1/").replace("00", "01").substring(0, 5);
    };
    this.initCardNumberFormatter = function(id, cvvId, validate) {
        var input = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)(id);
        var cvv = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)(cvvId);
        input.addEventListener("input", function() {
            var _card$code;
            _this.cardFormData.number = input.value.replace(/\D/g, "");
            var _cardValidator_number = (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).number(_this.cardFormData.number), card = _cardValidator_number.card, isPotentiallyValid = _cardValidator_number.isPotentiallyValid;
            input.value = _this.prettyCardNumber(_this.cardFormData.number, card);
            _this.cardFormData.cardType = (card === null || card === void 0 ? void 0 : card.type) || "";
            // Setting cvv maxlength
            if (cvv && card !== null && card !== void 0 && (_card$code = card.code) !== null && _card$code !== void 0 && _card$code.size) {
                var maxlength = card.code.size.toString();
                cvv.setAttribute("maxlength", maxlength);
            }
            // With validation
            if (validate) {
                if (!isPotentiallyValid) input.classList.add("error");
                else input.classList.remove("error");
                if (window.DEBUG) console.log("initCardNumberFormatter", (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).number(_this.cardFormData.number));
            }
        });
        if (validate) input.addEventListener("blur", function() {
            var isValid = (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).number(_this.cardFormData.number).isValid;
            if (!isValid) input.classList.add("error");
            else input.classList.remove("error");
        });
    };
    this.initCvvFormatter = function(id, validate) {
        var input = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)(id);
        input.addEventListener("input", function() {
            _this.cardFormData.cvv = input.value;
            if (validate) {
                var isPotentiallyValid = (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).cvv(input.value).isPotentiallyValid;
                if (!isPotentiallyValid) input.classList.add("error");
                else input.classList.remove("error");
                if (window.DEBUG) console.log("initCvvFormatter", (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).cvv(input.value));
            }
        });
        if (validate) input.addEventListener("blur", function() {
            var isValid = (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).cvv(input.value).isValid;
            if (!isValid) input.classList.add("error");
            else input.classList.remove("error");
        });
    };
    this.initExpiryFormatter = function(id, validate) {
        var input = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)(id);
        var oldValue = input.value;
        input.addEventListener("input", function() {
            var newValue = _this.prettyExpiryDate(input.value, oldValue);
            input.value = newValue;
            oldValue = newValue;
            var _cardValidator_expirationDate = (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).expirationDate(input.value), month = _cardValidator_expirationDate.month, year = _cardValidator_expirationDate.year, isPotentiallyValid = _cardValidator_expirationDate.isPotentiallyValid;
            _this.cardFormData.expirationMonth = month || "";
            _this.cardFormData.expirationYear = year || "";
            if (validate) {
                if (!isPotentiallyValid) input.classList.add("error");
                else input.classList.remove("error");
                if (window.DEBUG) console.log("initExpiryFormatter", (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).expirationDate(input.value));
            }
        });
        if (validate) input.addEventListener("blur", function() {
            var isValid = (0, (/*@__PURE__*/$parcel$interopDefault($4023b026e0fd237b$exports))).expirationDate(input.value).isValid;
            if (!isValid) input.classList.add("error");
            else input.classList.remove("error");
        });
    };
};


var $40f39750c70064ca$export$182b944a26ee501a = function(components, type) {
    var name = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "short_name";
    var foundComponent = components === null || components === void 0 ? void 0 : components.find(function(component) {
        var cType = component.types[0];
        if (cType === type) return component;
    });
    return foundComponent ? foundComponent[name] : "";
};



var $a4f38dd92754f534$export$61fc7d43ac8f84b0 = function(func, delay) {
    var inDebounce;
    return function debounce() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(inDebounce);
        inDebounce = setTimeout(function() {
            return func.apply(_this, args);
        }, delay);
    };
};








var $a0037ed5cf274a1f$export$85b4408868ed49d0 = function CheckoutFormController(fc, checkout, buyButtonIds, validateFields) {
    "use strict";
    var _this = this;
    (0, $fvacx._)(this, CheckoutFormController);
    this.validateFields = false;
    this.cardService = new (0, $3b6c46c9a3b69876$export$1926ec33ea263be2)();
    this.reportToAnalytics = function() {
        var lead = _this.fc.lead.lead;
        (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackEmail(lead.emailAddress);
        (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackActiveOnSite(lead);
    };
    this.initKlavyioEmailEvent = function() {
        var emailField = document.getElementById("emailAddress");
        var handleBlur = function() {
            if (emailField && (0, $48bbe448a6f79255$export$18148d12c805c5b0)(emailField.value)) {
                var _this$fc$lead, _this$fc$lead$lead, _this$fc$lead2, _this$fc$lead2$lead, _this$fc$config;
                var email = emailField.value;
                var firstName = ((_this$fc$lead = _this.fc.lead) === null || _this$fc$lead === void 0 ? void 0 : (_this$fc$lead$lead = _this$fc$lead.lead) === null || _this$fc$lead$lead === void 0 ? void 0 : _this$fc$lead$lead.firstName) || "";
                var lastName = ((_this$fc$lead2 = _this.fc.lead) === null || _this$fc$lead2 === void 0 ? void 0 : (_this$fc$lead2$lead = _this$fc$lead2.lead) === null || _this$fc$lead2$lead === void 0 ? void 0 : _this$fc$lead2$lead.lastName) || "";
                var locale = ((_this$fc$config = _this.fc.config) === null || _this$fc$config === void 0 ? void 0 : _this$fc$config.locale) || "";
                (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackActiveOnSite({
                    emailAddress: email,
                    firstName: firstName,
                    lastName: lastName
                });
                var product = _this.fc.getSelectedProduct();
                if (sessionStorage.getItem("ev_click_id")) (0, $8a100cb0ee4f7284$export$2055d41ab3fe06fa).trackAddToCart(window.BRAND, sessionStorage.getItem("ev_click_id").split(",")[0]);
                (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackStartedCheckoutV2(email, firstName, lastName, product, locale);
            }
        };
        if (emailField) emailField.addEventListener("blur", handleBlur);
    };
    this.initImportLeadEvents = function() {
        var fields = document.querySelectorAll("#postalCode, #phoneNumber, #lastName");
        var _this1 = _this;
        var debouncedEventHandler = (0, $a4f38dd92754f534$export$61fc7d43ac8f84b0)(/*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(0, $48bbe448a6f79255$export$d45f86db23af717)()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this1.fc.lead.createLead()
                        ];
                    case 1:
                        _state.sent();
                        _this1.reportToAnalytics();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        }), 300);
        fields.forEach(function(field) {
            field.addEventListener("blur", debouncedEventHandler);
        });
    };
    this.initCardInputFormatters = function() {
        _this.cardService.initCardNumberFormatter("cardNumber", "cardCvv", _this.validateFields);
        _this.cardService.initExpiryFormatter("cardExpiry", _this.validateFields);
        _this.cardService.initCvvFormatter("cardCvv", _this.validateFields);
    };
    var _this1 = this;
    this.initPhoneInput = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var componentId, numberInput, intlTelInput, intlTelUtils, _tmp, _this$fc$lead$lead2, iti, countryDropdown;
        var _arguments = arguments;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    componentId = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "phoneNumber";
                    numberInput = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)(componentId);
                    return [
                        4,
                        (parcelRequire("i3sxR"))
                    ];
                case 1:
                    intlTelInput = _state.sent();
                    if (!(_this1.fc.config.klarnaEnabled || _this1.fc.config.stripeKlarnaEnabled)) return [
                        3,
                        2
                    ];
                    _tmp = undefined;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        (parcelRequire("b8Qo5"))
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    intlTelUtils = _tmp;
                    if (numberInput) {
                        ;
                        iti = intlTelInput(numberInput, {
                            separateDialCode: !_this1.fc.config.klarnaEnabled,
                            utilsScript: intlTelUtils,
                            initialCountry: ((_this$fc$lead$lead2 = _this1.fc.lead.lead) === null || _this$fc$lead$lead2 === void 0 ? void 0 : _this$fc$lead$lead2.country) || window.GEO.country,
                            allowDropdown: false,
                            excludeCountries: [
                                "RU",
                                "AF",
                                "KP",
                                "IR",
                                "SO",
                                "XK"
                            ]
                        });
                        countryDropdown = document.querySelector(".iti__flag-container");
                        // if (
                        //   (countryDropdown && this.fc.config.klarnaEnabled) ||
                        //   (countryDropdown && this.fc.config.stripeKlarnaEnabled) ||
                        //   (countryDropdown && showFlags == 'false')
                        // ) {
                        //   countryDropdown.style.display = 'none';
                        //   numberInput.style.paddingLeft = '12px';
                        // }
                        if (countryDropdown) countryDropdown.style.display = "none";
                        numberInput.addEventListener("input", function() {
                            iti.setNumber(numberInput.value);
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    });
    var _this2 = this;
    this.initCountrySelector = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var countryInput, _this$fc$lead$lead3, countries, stateInput, _this$fc$lead$lead4, initialStates;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    countryInput = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("country");
                    if (!countryInput) return [
                        3,
                        2
                    ];
                    countries = (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).getCountriesArray();
                    (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).populateDropdown(countryInput, countries, "name", "code", ((_this$fc$lead$lead3 = _this2.fc.lead.lead) === null || _this$fc$lead$lead3 === void 0 ? void 0 : _this$fc$lead$lead3.country) || window.GEO.country);
                    stateInput = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("state");
                    countryInput.addEventListener("change", /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                        var states;
                        return (0, $33z5g.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).getCountryStates(countryInput.value)
                                    ];
                                case 1:
                                    states = _state.sent();
                                    // Reinitialize Klarna after country change
                                    _this2.checkout.maybeInitKlarna(countryInput.value);
                                    if (stateInput) {
                                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).removeNonDefaultOptions(stateInput);
                                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).populateDropdown(stateInput, states, "name", "code");
                                        stateInput.value = "";
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                    if (!stateInput) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).getCountryStates(countryInput.value)
                    ];
                case 1:
                    initialStates = _state.sent();
                    (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).populateDropdown(stateInput, initialStates, "name", "code", (_this$fc$lead$lead4 = _this2.fc.lead.lead) === null || _this$fc$lead$lead4 === void 0 ? void 0 : _this$fc$lead$lead4.state);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    this.setLoading = function(pressedButtonId, loading, loadFor) {
        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showModalLoader(loading);
        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setButtonLoading(pressedButtonId, loading);
        var otherButtons = Object.values(_this.buyButtonIds);
        otherButtons.forEach(function(btnId) {
            (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setButtonDisabled(btnId, loading);
        });
        if (loadFor) setTimeout(function() {
            return _this.setLoading(pressedButtonId, false);
        }, loadFor);
    };
    var _this3 = this;
    this.paymentPrerequisites = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(paymentType) {
            var validate, mid, _getAppUtms, _this$fc$lead$lead5, _this$fc$lead$lead5$c, _this$fc$lead$lead6, auid, sessionId, lead, product;
            var _arguments = arguments;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        validate = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, mid = _arguments.length > 2 ? _arguments[2] : void 0;
                        auid = (_getAppUtms = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)()) === null || _getAppUtms === void 0 ? void 0 : _getAppUtms.custom_order_auid;
                        sessionId = new URLSearchParams(window.location.search).get("session_id") || "";
                        (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackBuyButtonClick(((_this$fc$lead$lead5 = _this3.fc.lead.lead) === null || _this$fc$lead$lead5 === void 0 ? void 0 : (_this$fc$lead$lead5$c = _this$fc$lead$lead5.customerId) === null || _this$fc$lead$lead5$c === void 0 ? void 0 : _this$fc$lead$lead5$c.toString()) || "", ((_this$fc$lead$lead6 = _this3.fc.lead.lead) === null || _this$fc$lead$lead6 === void 0 ? void 0 : _this$fc$lead$lead6.orderId) || "", paymentType, auid, sessionId, mid);
                        return [
                            4,
                            _this3.fc.lead.createLead(paymentType, validate)
                        ];
                    case 1:
                        lead = _state.sent();
                        if (lead !== null) {
                            product = _this3.fc.getSelectedProduct();
                            (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackAddToCart(lead, product);
                            (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackStartedCheckoutV2(lead.emailAddress, lead.firstName, lead.lastName, product, _this3.fc.config.locale || "en");
                        }
                        return [
                            2,
                            lead
                        ];
                }
            });
        });
        return function(paymentType) {
            return _ref.apply(this, arguments);
        };
    }();
    this.initCreditCard = function() {
        _this.initCardInputFormatters();
        var cardButtonId = _this.buyButtonIds.cardButtonId;
        var cardButton = document.getElementById(cardButtonId);
        if (!cardButton) throw new Error("Credit card button undefined");
        var _this1 = _this;
        cardButton.addEventListener("click", function() {
            var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                var lead;
                return (0, $33z5g.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ev.preventDefault();
                            _this1.setLoading(cardButtonId, true);
                            return [
                                4,
                                _this1.paymentPrerequisites("credit_card", true)
                            ];
                        case 1:
                            lead = _state.sent();
                            if (!lead) {
                                _this1.setLoading(cardButtonId, false);
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                _this1.checkout.createCreditCardOrder(_this1.cardService.cardFormData)
                            ];
                        case 2:
                            _state.sent();
                            setTimeout(function() {
                                _this1.setLoading(cardButtonId, false);
                            }, 3000);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(ev) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    this.initPayPal = function() {
        var ppButtonId = _this.buyButtonIds.payPalButtonId;
        var ppButton = document.getElementById(ppButtonId);
        if (!ppButton) throw new Error("PayPal button undefined");
        var _this1 = _this;
        ppButton.addEventListener("click", function() {
            var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                var _this_checkout_getParams, paypalMid, paypalType, paymentType, lead, _this$fc$lead$lead7, _this$fc$lead$lead8, _this$fc$lead$lead8$c, _this$fc$lead$lead9, auid, sessionId;
                return (0, $33z5g.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ev.preventDefault();
                            _this1.setLoading(ppButtonId, true);
                            _this_checkout_getParams = _this1.checkout.getParams(), paypalMid = _this_checkout_getParams.paypalMid, paypalType = _this_checkout_getParams.paypalType;
                            paymentType = paypalType === "default" ? "paypal" : "paypal_".concat(paypalType);
                            if (!!_this1.fc.config.expressPaypal) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.paymentPrerequisites(paymentType, true, paypalMid)
                            ];
                        case 1:
                            lead = _state.sent();
                            if (!lead) {
                                _this1.setLoading(ppButtonId, false);
                                return [
                                    2
                                ];
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            auid = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_auid;
                            sessionId = new URLSearchParams(window.location.search).get("session_id") || ((_this$fc$lead$lead7 = _this1.fc.lead.lead) === null || _this$fc$lead$lead7 === void 0 ? void 0 : _this$fc$lead$lead7.sessionId);
                            (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackBuyButtonClick(((_this$fc$lead$lead8 = _this1.fc.lead.lead) === null || _this$fc$lead$lead8 === void 0 ? void 0 : (_this$fc$lead$lead8$c = _this$fc$lead$lead8.customerId) === null || _this$fc$lead$lead8$c === void 0 ? void 0 : _this$fc$lead$lead8$c.toString()) || "", ((_this$fc$lead$lead9 = _this1.fc.lead.lead) === null || _this$fc$lead$lead9 === void 0 ? void 0 : _this$fc$lead$lead9.orderId) || "", paymentType, auid, sessionId, paypalMid);
                            if (sessionStorage.getItem("ev_click_id")) (0, $8a100cb0ee4f7284$export$2055d41ab3fe06fa).trackAddToCart(window.BRAND, sessionStorage.getItem("ev_click_id").split(",")[0]);
                            _state.label = 3;
                        case 3:
                            return [
                                4,
                                _this1.checkout.createPayPalOrder()
                            ];
                        case 4:
                            _state.sent();
                            if (paypalType === "reach") setTimeout(function() {
                                return _this1.setLoading(ppButtonId, false);
                            }, 5000);
                            else _this1.setLoading(ppButtonId, false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(ev) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    this.maybeInitKlarna = function() {
        var klarnaEnabled = _this.fc.config.klarnaEnabled;
        if (klarnaEnabled) {
            var klarnaButtonId = _this.buyButtonIds.klarnaButtonId;
            var klarnaButton = document.getElementById(klarnaButtonId);
            if (!klarnaButton) throw new Error("Klarna button undefined");
            var _this1 = _this;
            klarnaButton.addEventListener("click", function() {
                var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                    var lead;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ev.preventDefault();
                                _this1.setLoading(klarnaButtonId, true);
                                return [
                                    4,
                                    _this1.paymentPrerequisites("klarna", true)
                                ];
                            case 1:
                                lead = _state.sent();
                                if (!lead) {
                                    _this1.setLoading(klarnaButtonId, false);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this1.checkout.createKlarnaOrder()
                                ];
                            case 2:
                                _state.sent();
                                setTimeout(function() {
                                    _this1.setLoading(klarnaButtonId, false);
                                }, 3000);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(ev) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    };
    this.maybieInitStripeKlarna = function() {
        var stripeKlarnaEnabled = _this.fc.config.stripeKlarnaEnabled;
        if (stripeKlarnaEnabled) {
            var stripeKlarnaButtonId = _this.buyButtonIds.klarnaStripeButtonId;
            var stripeKlarnaButton = document.getElementById(stripeKlarnaButtonId);
            if (!stripeKlarnaButton) throw new Error("Stripe Klarna button undefined");
            var _this1 = _this;
            stripeKlarnaButton.addEventListener("click", function() {
                var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                    var lead;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ev.preventDefault();
                                _this1.setLoading(stripeKlarnaButtonId, true);
                                return [
                                    4,
                                    _this1.paymentPrerequisites("klarna_stripe", true)
                                ];
                            case 1:
                                lead = _state.sent();
                                if (!lead) {
                                    _this1.setLoading(stripeKlarnaButtonId, false);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this1.checkout.createKlarnaStripeOrder()
                                ];
                            case 2:
                                _state.sent();
                                _this1.setLoading(stripeKlarnaButtonId, false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(ev) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    };
    this.maybeInitExpressKlarna = function() {
        var _this_fc_config = _this.fc.config, klarnaClientId = _this_fc_config.klarnaClientId, expressKlarnaEnabled = _this_fc_config.expressKlarnaEnabled;
        if (expressKlarnaEnabled && klarnaClientId) {
            window.Klarna.Payments.Buttons.init({
                client_id: klarnaClientId
            });
            window.Klarna.Payments.Buttons.load({
                container: "#klarna-express-container",
                theme: "default",
                shape: "rect",
                locale: _this.fc.config.locale,
                on_click: function(authorize) {
                    (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setElementLoading("klarna-express-container", true, "start");
                    _this.checkout.createExpressKlarnaOrder(authorize, function() {
                        return (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setElementLoading("klarna-express-container", false, "end");
                    });
                }
            }, function load_callback(loadResult) {
                if (window.DEBUG) console.log("loadResult: ", loadResult);
            });
        }
    };
    this.maybeInitGooglePay = function() {
        var googlePayEnabled = _this.fc.config.googlePayEnabled;
        if (googlePayEnabled) {
            var gpayButtonId = _this.buyButtonIds.googlePayButtonId;
            var gpayButton = document.getElementById(gpayButtonId);
            if (!gpayButton) throw new Error("GPay button undefined");
            var _this1 = _this;
            gpayButton.addEventListener("click", function() {
                var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                    var mid, lead;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ev.preventDefault();
                                _this1.setLoading(gpayButtonId, true, 5000);
                                mid = _this1.fc.config.braintreeAppleGooglePayMerchantId ? _this1.fc.config.braintreeAppleGooglePayMerchantId : _this1.fc.config.appleGooglePayMerchantId;
                                return [
                                    4,
                                    _this1.paymentPrerequisites("google_pay_".concat(mid), true, mid)
                                ];
                            case 1:
                                lead = _state.sent();
                                if (!lead) {
                                    _this1.setLoading(gpayButtonId, false);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this1.checkout.createGooglePayOrder()
                                ];
                            case 2:
                                _state.sent();
                                _this1.setLoading(gpayButtonId, false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(ev) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    };
    this.maybeInitApplePay = function() {
        var applePayEnabled = _this.fc.config.applePayEnabled;
        if (applePayEnabled) {
            var appleButtonId = _this.buyButtonIds.applePayButtonId;
            var appleButton = document.getElementById(appleButtonId);
            if (!appleButton) throw new Error("Apple button undefined");
            var _this1 = _this;
            appleButton.addEventListener("click", function() {
                var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ev.preventDefault();
                                _this1.setLoading(appleButtonId, true);
                                return [
                                    4,
                                    _this1.checkout.initAppleSession(_this1.paymentPrerequisites, _this1.fc.config.expressApplePay)
                                ];
                            case 1:
                                _state.sent();
                                _this1.setLoading(appleButtonId, false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(ev) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    };
    this.maybieInitSaveParamsToCookie = function() {
        var urlParams = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("urlParams");
        if (!urlParams) {
            var urlQueryParams = new URLSearchParams(window.location.search);
            var paramsObject = {};
            urlQueryParams.forEach(function(value, key) {
                paramsObject[key] = value;
            });
            paramsObject["http_referer"] = window.location.href;
            var serializedParams = JSON.stringify(paramsObject);
            (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("urlParams", serializedParams, 15);
        }
    };
    this.maybeInitStreetAutocomplete = function() {
        var shouldLoad = _this.fc.config.streetAutocomplete;
        if (shouldLoad) {
            var srcUrl = "https://maps.googleapis.com/maps/api/js?key=".concat((0, $42a1df290c3667d2$export$e506a1d27d1eaa20).PLACES_API, "&libraries=places");
            loadScript(srcUrl, true, {
                type: "text/javascript"
            });
            waitForCondition(function() {
                var _google, _google$maps;
                return typeof google !== "undefined" && typeof ((_google = google) === null || _google === void 0 ? void 0 : (_google$maps = _google.maps) === null || _google$maps === void 0 ? void 0 : _google$maps.places) !== "undefined";
            }, function() {
                var addressFieldId = _this.fc.config.addressFieldId || "address1";
                var cityFieldId = _this.fc.config.cityFieldId || "city";
                var countryFieldId = _this.fc.config.countryFieldId || "country";
                var stateFieldId = _this.fc.config.stateFieldId || "state";
                var postalCodeFieldId = _this.fc.config.postalCodeFieldId || "postalCode";
                var addressInputs = Array.from(document.querySelectorAll("#".concat(addressFieldId)));
                var cityInputs = Array.from(document.querySelectorAll("#".concat(cityFieldId)));
                var stateInputs = Array.from(document.querySelectorAll("#".concat(stateFieldId)));
                var countryInputs = Array.from(document.querySelectorAll("#".concat(countryFieldId)));
                var postalCodeInputs = Array.from(document.querySelectorAll("#".concat(postalCodeFieldId)));
                addressInputs.forEach(function(input) {
                    var autocomplete = new google.maps.places.Autocomplete(input, {
                        fields: [
                            "address_components",
                            "formatted_address"
                        ],
                        types: [
                            "street_address",
                            "street_number",
                            "premise"
                        ]
                    });
                    if (autocomplete) autocomplete.addListener("place_changed", function() {
                        var place = autocomplete.getPlace();
                        if (window.DEBUG) console.log("place: ", {
                            place: place
                        });
                        var formattedAddress = (place === null || place === void 0 ? void 0 : place.formatted_address) || "";
                        var addressFromFormattedAddress = formattedAddress ? formattedAddress.split(",")[0] : "";
                        input.value = addressFromFormattedAddress;
                        var postalCode = (0, $40f39750c70064ca$export$182b944a26ee501a)(place.address_components, "postal_code", "long_name");
                        var postalCodeSuffix = (0, $40f39750c70064ca$export$182b944a26ee501a)(place.address_components, "postal_code_suffix", "long_name");
                        postalCodeInputs.forEach(function(postCodeElement) {
                            postCodeElement.value = "".concat(postalCode).concat(postalCodeSuffix ? "-" + postalCodeSuffix : "");
                        });
                        var locality = (0, $40f39750c70064ca$export$182b944a26ee501a)(place.address_components, "locality", "long_name") || (0, $40f39750c70064ca$export$182b944a26ee501a)(place.address_components, "postal_town", "long_name");
                        cityInputs.forEach(function(cityElement) {
                            cityElement.value = locality;
                        });
                        var country = (0, $40f39750c70064ca$export$182b944a26ee501a)(place.address_components, "country");
                        var state = (0, $40f39750c70064ca$export$182b944a26ee501a)(place.address_components, "administrative_area_level_1");
                        if (state.length > 3) state = "";
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).getCountryStates(country).then(function(states) {
                            stateInputs.forEach(function(stateInput) {
                                (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).removeNonDefaultOptions(stateInput);
                                (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).populateDropdown(stateInput, states, "name", "code");
                                stateInput.value = state;
                            });
                        });
                        countryInputs.forEach(function(countryElement) {
                            countryElement.value = country;
                        });
                    });
                });
            }, function() {
                return Errors.report(new Error("AutocompleteSrc: Google Places API failed to load in 5s"), undefined, false, false);
            });
        }
    };
    var _this4 = this;
    this.initCheckoutForm = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Form
                    _this4.initKlavyioEmailEvent();
                    _this4.initImportLeadEvents();
                    _this4.initPhoneInput();
                    return [
                        4,
                        _this4.initCountrySelector()
                    ];
                case 1:
                    _state.sent();
                    _this4.maybeInitStreetAutocomplete();
                    if (window["country"].children.length === 0) {
                        _this4.initCountrySelector();
                        Errors.report(new Error("AddressFormError: Country selector fallback was used"), {}, false, false);
                    }
                    //Other
                    _this4.maybieInitSaveParamsToCookie();
                    // Payments
                    _this4.initPayPal();
                    _this4.initCreditCard();
                    _this4.maybieInitStripeKlarna();
                    _this4.maybeInitKlarna();
                    _this4.maybeInitApplePay();
                    _this4.maybeInitGooglePay();
                    _this4.maybeInitExpressKlarna();
                    return [
                        2
                    ];
            }
        });
    });
    this.fc = fc;
    this.checkout = checkout;
    this.buyButtonIds = buyButtonIds;
    this.validateFields = validateFields || false;
    this.fc.lead.prefillForm();
};




var $fvacx = parcelRequire("fvacx");

var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $33z5g = parcelRequire("33z5g");



var $fvacx = parcelRequire("fvacx");

var $33z5g = parcelRequire("33z5g");
var $64dadbec5cdd6994$var$V3_URL = "https://js.stripe.com/v3";
var $64dadbec5cdd6994$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $64dadbec5cdd6994$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $64dadbec5cdd6994$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($64dadbec5cdd6994$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$64dadbec5cdd6994$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $64dadbec5cdd6994$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($64dadbec5cdd6994$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $64dadbec5cdd6994$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "4.7.0",
        startTime: startTime
    });
};
var $64dadbec5cdd6994$var$stripePromise = null;
var $64dadbec5cdd6994$var$onErrorListener = null;
var $64dadbec5cdd6994$var$onLoadListener = null;
var $64dadbec5cdd6994$var$onError = function onError(reject) {
    return function() {
        reject(new Error("Failed to load Stripe.js"));
    };
};
var $64dadbec5cdd6994$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error("Stripe.js not available"));
    };
};
var $64dadbec5cdd6994$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($64dadbec5cdd6994$var$stripePromise !== null) return $64dadbec5cdd6994$var$stripePromise;
    $64dadbec5cdd6994$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($64dadbec5cdd6994$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $64dadbec5cdd6994$var$findScript();
            if (script && params) console.warn($64dadbec5cdd6994$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $64dadbec5cdd6994$var$injectScript(params);
            else if (script && $64dadbec5cdd6994$var$onLoadListener !== null && $64dadbec5cdd6994$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener("load", $64dadbec5cdd6994$var$onLoadListener);
                script.removeEventListener("error", $64dadbec5cdd6994$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $64dadbec5cdd6994$var$injectScript(params);
            }
            $64dadbec5cdd6994$var$onLoadListener = $64dadbec5cdd6994$var$onLoad(resolve, reject);
            $64dadbec5cdd6994$var$onErrorListener = $64dadbec5cdd6994$var$onError(reject);
            script.addEventListener("load", $64dadbec5cdd6994$var$onLoadListener);
            script.addEventListener("error", $64dadbec5cdd6994$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $64dadbec5cdd6994$var$stripePromise["catch"](function(error) {
        $64dadbec5cdd6994$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $64dadbec5cdd6994$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $64dadbec5cdd6994$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $64dadbec5cdd6994$var$stripePromise$1;
var $64dadbec5cdd6994$var$loadCalled = false;
var $64dadbec5cdd6994$var$getStripePromise = function getStripePromise() {
    if ($64dadbec5cdd6994$var$stripePromise$1) return $64dadbec5cdd6994$var$stripePromise$1;
    $64dadbec5cdd6994$var$stripePromise$1 = $64dadbec5cdd6994$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $64dadbec5cdd6994$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
    return $64dadbec5cdd6994$var$stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $64dadbec5cdd6994$var$getStripePromise();
})["catch"](function(error) {
    if (!$64dadbec5cdd6994$var$loadCalled) console.warn(error);
});
var $64dadbec5cdd6994$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $64dadbec5cdd6994$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $64dadbec5cdd6994$var$getStripePromise().then(function(maybeStripe) {
        return $64dadbec5cdd6994$var$initStripe(maybeStripe, args, startTime);
    });
};






var $b7b0e6aa61a021b0$export$976c4951f137bc87 = function StripeApplePayService(fc) {
    "use strict";
    var _this = this;
    (0, $fvacx._)(this, StripeApplePayService);
    this.createPaymentRequest = function() {
        var _this$fc$lead, _StripeApplePayServic;
        var country = ((_this$fc$lead = _this.fc.lead) === null || _this$fc$lead === void 0 ? void 0 : _this$fc$lead.lead.country) || window.GEO.country;
        var product = _this.fc.getSelectedProduct();
        var addons = _this.fc.getSelectedAddons();
        var totalAmount = Math.round((product.finalPrice + product.shippingPrice) * 100);
        if (addons && Array.isArray(addons)) addons.forEach(function(addon) {
            totalAmount += Math.round(addon.finalPrice * 100);
        });
        var subTotalAmount = Math.round(product.finalPrice * 100);
        if (addons && Array.isArray(addons)) addons.forEach(function(addon) {
            subTotalAmount += Math.round(addon.finalPrice * 100);
        });
        var shippingPrice = Math.round(product.shippingPrice * 100);
        return (_StripeApplePayServic = StripeApplePayService.instance) === null || _StripeApplePayServic === void 0 ? void 0 : _StripeApplePayServic.paymentRequest({
            disableWallets: [
                "googlePay",
                "browserCard",
                "link"
            ],
            country: country,
            currency: product.currencyCode.toLowerCase(),
            total: {
                label: "Total",
                amount: totalAmount
            },
            displayItems: [
                {
                    label: "Subtotal",
                    amount: subTotalAmount
                },
                {
                    label: "Shipping",
                    amount: shippingPrice
                }
            ],
            requestPayerName: true,
            requestPayerEmail: true,
            requestShipping: true,
            shippingOptions: [
                {
                    id: "basic",
                    label: "Regular shipping",
                    detail: "Regular shipping",
                    amount: shippingPrice
                }
            ]
        });
    };
    this.maybeRenderButtons = function() {
        var stripeApplePayEnabled = _this.fc.config.stripeApplePayEnabled;
        var appleButtonCont = document.getElementById("stripe-apple-pay-container");
        if (appleButtonCont && stripeApplePayEnabled) appleButtonCont.style.display = StripeApplePayService.appleAvailable ? "block" : "none";
        else if (stripeApplePayEnabled && !appleButtonCont) Errors.report(new Error("StripeApayError: Apple button container not found"), undefined, false, false);
    };
    var _this1 = this;
    this.createApplePayment = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(checkout) {
            var expressButton, _StripeApplePayServic2, elements, pr, appleButtonCont, canMakePayment, container, e;
            var _arguments = arguments;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        expressButton = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                        if (window.DEBUG) console.log(expressButton);
                        elements = (_StripeApplePayServic2 = StripeApplePayService.instance) === null || _StripeApplePayServic2 === void 0 ? void 0 : _StripeApplePayServic2.elements();
                        if (!elements) return [
                            3,
                            4
                        ];
                        pr = _this1.createPaymentRequest();
                        appleButtonCont = document.getElementById("stripe-apple-pay-container");
                        if (appleButtonCont && pr) appleButtonCont.addEventListener("click", function() {
                            var _this$fc$lead$lead, _this$fc$lead$lead2, _this$fc$lead$lead2$c, _this$fc$lead$lead3;
                            var auid = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_auid;
                            var sessionId = new URLSearchParams(window.location.search).get("session_id") || ((_this$fc$lead$lead = _this1.fc.lead.lead) === null || _this$fc$lead$lead === void 0 ? void 0 : _this$fc$lead$lead.sessionId);
                            var mid = _this1.fc.config.appleGooglePayMerchantId;
                            (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackBuyButtonClick(((_this$fc$lead$lead2 = _this1.fc.lead.lead) === null || _this$fc$lead$lead2 === void 0 ? void 0 : (_this$fc$lead$lead2$c = _this$fc$lead$lead2.customerId) === null || _this$fc$lead$lead2$c === void 0 ? void 0 : _this$fc$lead$lead2$c.toString()) || "", ((_this$fc$lead$lead3 = _this1.fc.lead.lead) === null || _this$fc$lead$lead3 === void 0 ? void 0 : _this$fc$lead$lead3.orderId) || "", "apple_pay_express", auid, sessionId, mid);
                            var product = _this1.fc.getSelectedProduct();
                            var addons = _this1.fc.getSelectedAddons();
                            var productDiscountPrice = (product === null || product === void 0 ? void 0 : product.discountPrice) || 0;
                            var totalAmount = Math.round((product.finalPrice + product.shippingPrice - productDiscountPrice) * 100);
                            if (addons && Array.isArray(addons)) addons.forEach(function(addon) {
                                var addonDiscountPrice = (addon === null || addon === void 0 ? void 0 : addon.discountPrice) || 0;
                                totalAmount += Math.round((addon.finalPrice - addonDiscountPrice) * 100);
                            });
                            var subTotalAmount = Math.round((product.finalPrice - productDiscountPrice) * 100);
                            if (addons && Array.isArray(addons)) addons.forEach(function(addon) {
                                var addonDiscountPrice = (addon === null || addon === void 0 ? void 0 : addon.discountPrice) || 0;
                                subTotalAmount += Math.round((addon.finalPrice - addonDiscountPrice) * 100);
                            });
                            var shippingPrice = Math.round(product.shippingPrice * 100);
                            var shippingOption = shippingPrice <= 0 ? {
                                id: "free",
                                label: "Free shipping",
                                detail: "",
                                amount: shippingPrice
                            } : {
                                id: "basic",
                                label: "Regular shipping",
                                detail: "",
                                amount: shippingPrice
                            };
                            pr.update({
                                total: {
                                    label: "Total",
                                    amount: totalAmount
                                },
                                displayItems: [
                                    {
                                        label: "Subtotal",
                                        amount: subTotalAmount
                                    },
                                    {
                                        label: "Shipping",
                                        amount: shippingPrice
                                    }
                                ],
                                shippingOptions: [
                                    shippingOption
                                ]
                            });
                            pr === null || pr === void 0 || pr.show();
                        });
                        if (!pr) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            pr.canMakePayment()
                        ];
                    case 2:
                        canMakePayment = _state.sent();
                        if (canMakePayment && canMakePayment !== null && canMakePayment !== void 0 && canMakePayment.applePay) pr.on("token", function() {
                            var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(e) {
                                var _e$shippingAddress, tokenData, shippingAddress, addressLine, _e_payerName, fullName, nameParts, _e_payerEmail, _nameParts_, _ref, _ref1, _ref2, _ref3, _e_payerPhone;
                                return (0, $33z5g.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            tokenData = {
                                                id: e.token.id
                                            };
                                            shippingAddress = e.shippingAddress;
                                            addressLine = (_e$shippingAddress = e.shippingAddress) === null || _e$shippingAddress === void 0 ? void 0 : _e$shippingAddress.addressLine;
                                            fullName = (_e_payerName = e.payerName) !== null && _e_payerName !== void 0 ? _e_payerName : "";
                                            nameParts = fullName.trim().split(" ");
                                            return [
                                                4,
                                                checkout.createStripeApplePayOrder(JSON.stringify(tokenData), e, {
                                                    emailAddress: (_e_payerEmail = e.payerEmail) !== null && _e_payerEmail !== void 0 ? _e_payerEmail : "",
                                                    familyName: nameParts[nameParts.length - 1],
                                                    givenName: (_nameParts_ = nameParts[0]) !== null && _nameParts_ !== void 0 ? _nameParts_ : "",
                                                    addressLines: addressLine,
                                                    locality: (_ref = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.city) !== null && _ref !== void 0 ? _ref : "",
                                                    administrativeArea: (_ref1 = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.region) !== null && _ref1 !== void 0 ? _ref1 : "",
                                                    postalCode: (_ref2 = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postalCode) !== null && _ref2 !== void 0 ? _ref2 : "",
                                                    countryCode: (_ref3 = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.country) !== null && _ref3 !== void 0 ? _ref3 : "",
                                                    phoneNumber: (_e_payerPhone = e.payerPhone) !== null && _e_payerPhone !== void 0 ? _e_payerPhone : ""
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(e) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        else {
                            container = document.getElementById("stripe-apple-pay-container");
                            if (container) container.style.display = "none";
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        Errors.report(e, {
                            geo: window.GEO,
                            config: _this1.fc.config || "undefined",
                            lead: _this1.fc.lead.lead || "undefined",
                            productIdx: window["productIdx"].value || "undefined"
                        }, false, false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(checkout) {
            return _ref.apply(this, arguments);
        };
    }();
    this.fc = fc;
};
$b7b0e6aa61a021b0$export$976c4951f137bc87.appleAvailable = false;
$b7b0e6aa61a021b0$export$976c4951f137bc87.checkAvailability = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
    return (0, $33z5g.__generator)(this, function(_state) {
        try {
            $b7b0e6aa61a021b0$export$976c4951f137bc87.appleAvailable = true;
        } catch (e) {
            Errors.report(e, undefined, false, false);
        }
        return [
            2
        ];
    });
});
$b7b0e6aa61a021b0$export$976c4951f137bc87.init = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(fc) {
        var e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($b7b0e6aa61a021b0$export$976c4951f137bc87.instance) return [
                        2,
                        new $b7b0e6aa61a021b0$export$976c4951f137bc87(fc)
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $64dadbec5cdd6994$export$de80f7562c3fd6b1)(window.FLAGS.pk_stripe)
                    ];
                case 2:
                    $b7b0e6aa61a021b0$export$976c4951f137bc87.instance = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    Errors.report(e, undefined, false, false);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        4,
                        $b7b0e6aa61a021b0$export$976c4951f137bc87.checkAvailability()
                    ];
                case 5:
                    _state.sent();
                    return [
                        2,
                        new $b7b0e6aa61a021b0$export$976c4951f137bc87(fc)
                    ];
            }
        });
    });
    return function(fc) {
        return _ref.apply(this, arguments);
    };
}();





/* eslint-disable @typescript-eslint/no-unused-vars */ 

var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $33z5g = parcelRequire("33z5g");




var $fvacx = parcelRequire("fvacx");

var $3D4gQ = parcelRequire("3D4gQ");

var $33z5g = parcelRequire("33z5g");

var $667c018edd1009c7$export$9f3545331fac7df5 = /*#__PURE__*/ function() {
    "use strict";
    function GatewayService() {
        (0, $fvacx._)(this, GatewayService);
    }
    (0, $3D4gQ._)(GatewayService, [
        {
            key: "fetchGateways",
            value: function fetchGateways(merchantId, orderId) {
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var data, error;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).getMerchants({
                                        billerId: "".concat(merchantId),
                                        orderId: orderId
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    data
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("[Gateway Service] Error fetching gateways:", error);
                                return [
                                    2,
                                    []
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getGatewayInfo",
            value: function getGatewayInfo(merchantId, orderId) {
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var gateways, gateway, error;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!merchantId) return [
                                    2,
                                    null
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetchGateways(merchantId, orderId)
                                ];
                            case 2:
                                gateways = _state.sent();
                                gateway = gateways.find(function(g) {
                                    return String(g.billerId).trim() === String(merchantId).trim();
                                });
                                if (!gateway && gateways.length > 0) gateway = gateways[0];
                                return [
                                    2,
                                    gateway
                                ];
                            case 3:
                                error = _state.sent();
                                console.error("[Gateway Service] Error getting gateway for merchant ID ".concat(merchantId, ":"), error);
                                return [
                                    2,
                                    null
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (!GatewayService.instance) GatewayService.instance = new GatewayService();
                return GatewayService.instance;
            }
        }
    ]);
    return GatewayService;
}();




var $d51a064fdf16ba1e$require$Buffer = $8fd3fe1a1a12d4b2$export$a143d493d941bafc;
var $d51a064fdf16ba1e$export$a3905c512d58c56d = /*#__PURE__*/ function() {
    "use strict";
    function SiftEvents() {
        (0, $fvacx._)(this, SiftEvents);
    }
    (0, $3D4gQ._)(SiftEvents, null, [
        {
            key: "encodeUserId",
            value: function encodeUserId(userId) {
                if (!userId) return "";
                // If it looks like an email, encode it
                if (userId.includes("@") && userId.includes(".")) return $d51a064fdf16ba1e$require$Buffer.from(userId).toString("base64");
                return userId;
            }
        },
        {
            key: "addCustomParams",
            value: function addCustomParams(eventData, orderData) {
                if (eventData && orderData) {
                    var _orderData$customFiel;
                    var auid = orderData.custom_order_auid;
                    auid && (eventData.crm_auid = auid);
                    var paySource = orderData.paySource;
                    paySource && (eventData.crm_paySource = paySource);
                    var merchantId = orderData.merchantId || (orderData === null || orderData === void 0 ? void 0 : orderData.forceMerchantId);
                    merchantId && (eventData.crm_merchantId = merchantId);
                    var fullUrl = orderData.fullUrl || (orderData === null || orderData === void 0 ? void 0 : (_orderData$customFiel = orderData.customFields) === null || _orderData$customFiel === void 0 ? void 0 : _orderData$customFiel.http_referer) || (orderData === null || orderData === void 0 ? void 0 : orderData.custom3);
                    fullUrl && (eventData.crm_fullUrl = fullUrl);
                    var sessionId = orderData.sessionId || orderData.custom_order_sid;
                    sessionId && (eventData.crm_session_id_no_ML = sessionId);
                }
            }
        },
        {
            key: "addAddressDetails",
            value: function addAddressDetails(eventData, responseData, orderData) {
                if (eventData && orderData || eventData && responseData) {
                    eventData.$billing_address = {};
                    var name = responseData === null || responseData === void 0 ? void 0 : responseData.name;
                    name && (eventData.$billing_address.$name = name);
                    var address1 = (responseData === null || responseData === void 0 ? void 0 : responseData.address1) || (orderData === null || orderData === void 0 ? void 0 : orderData.address1);
                    address1 && (eventData.$billing_address.$address_1 = address1);
                    var address2 = (responseData === null || responseData === void 0 ? void 0 : responseData.address2) || (orderData === null || orderData === void 0 ? void 0 : orderData.address2);
                    address2 && (eventData.$billing_address.$address_2 = address2);
                    var city = (responseData === null || responseData === void 0 ? void 0 : responseData.city) || (orderData === null || orderData === void 0 ? void 0 : orderData.city);
                    city && (eventData.$billing_address.$city = city);
                    var state = (responseData === null || responseData === void 0 ? void 0 : responseData.state) || (orderData === null || orderData === void 0 ? void 0 : orderData.state);
                    state && (eventData.$billing_address.$region = state);
                    var country = (responseData === null || responseData === void 0 ? void 0 : responseData.country) || (orderData === null || orderData === void 0 ? void 0 : orderData.country);
                    country && (eventData.$billing_address.$country = country);
                    var postalCode = (responseData === null || responseData === void 0 ? void 0 : responseData.postalCode) || (orderData === null || orderData === void 0 ? void 0 : orderData.postalCode);
                    postalCode && (eventData.$billing_address.$zipcode = postalCode);
                    var phoneNumber = (responseData === null || responseData === void 0 ? void 0 : responseData.phoneNumber) || (orderData === null || orderData === void 0 ? void 0 : orderData.phoneNumber);
                    phoneNumber && (eventData.$billing_address.$phone = phoneNumber);
                    eventData.$shipping_address = {};
                    name && (eventData.$shipping_address.$name = name);
                    address1 && (eventData.$shipping_address.$address_1 = address1);
                    address2 && (eventData.$shipping_address.$address_2 = address2);
                    city && (eventData.$shipping_address.$city = city);
                    state && (eventData.$shipping_address.$region = state);
                    country && (eventData.$shipping_address.$country = country);
                    postalCode && (eventData.$shipping_address.$zipcode = postalCode);
                    phoneNumber && (eventData.$shipping_address.$phone = phoneNumber);
                }
            }
        },
        {
            key: "getGatewayFromMerchantId",
            value: // private static async getGatewayFromMerchantId(merchantId: string | number, orderId?: string): Promise<string> {
            //   if (!merchantId) return `1. merchantId - ${merchantId}, not_found`;
            //   try {
            //     const gatewayInfo = await GatewayService.getInstance().getGatewayInfo(merchantId, orderId);
            //     if (gatewayInfo) {
            //       return this.mapGatewayNameToSift(gatewayInfo.gatewayName);
            //     }
            //     return `2. merchantId - ${merchantId}, not_found (API returned: ${JSON.stringify(gatewayInfo)})`;
            //   } catch (error) {
            //     return `3. merchantId - ${merchantId}, not_found`;
            //   }
            // }
            function getGatewayFromMerchantId(merchantId, orderId) {
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var knownGateways, merchantIdStr, gatewayInfo, error;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!merchantId) return [
                                    2,
                                    "1. merchantId - ".concat(merchantId, ", not_found")
                                ];
                                // Hardcoded fallback mapping for all known merchant IDs
                                knownGateways = {
                                    "1": "$stripe",
                                    "2": "$paypal",
                                    "3": "$paypal",
                                    "4": "$paypal",
                                    "5": "$reach",
                                    "6": "$stripe",
                                    "7": "$stripe",
                                    "8": "$fluidpay",
                                    "9": "$other",
                                    "10": "$paypal",
                                    "11": "$stripe",
                                    "12": "$paypal",
                                    "13": "$paypal",
                                    "14": "$paypal",
                                    "15": "$paypal",
                                    "16": "$stripe",
                                    "17": "$stripe",
                                    "18": "$stripe",
                                    "19": "$stripe",
                                    "20": "$paypal",
                                    "21": "$stripe",
                                    "22": "$stripe",
                                    "23": "$paypal",
                                    "24": "$stripe",
                                    "25": "$stripe",
                                    "26": "$stripe",
                                    "27": "$stripe",
                                    "28": "$paypal",
                                    "29": "$other",
                                    "30": "$other",
                                    "31": "$nmi",
                                    "32": "$stripe",
                                    "33": "$nmi",
                                    "34": "$nmi",
                                    "35": "$nmi",
                                    "36": "$nmi",
                                    "37": "$nmi",
                                    "38": "$nmi",
                                    "39": "$nmi",
                                    "40": "$stripe",
                                    "41": "$nmi",
                                    "42": "$nmi",
                                    "43": "$nmi",
                                    "44": "$nmi",
                                    "45": "$paypal",
                                    "46": "$nmi",
                                    "47": "$nmi",
                                    "48": "$nmi",
                                    "49": "$paypal",
                                    "50": "$nmi",
                                    "51": "$nmi",
                                    "52": "$nmi",
                                    "53": "$nmi",
                                    "54": "$nmi",
                                    "55": "$nmi",
                                    "56": "$nmi",
                                    "57": "$nmi",
                                    "58": "$paypal",
                                    "59": "$nmi",
                                    "60": "$other",
                                    "61": "$other",
                                    "62": "$stripe",
                                    "63": "$paypal",
                                    "64": "$paypal",
                                    "65": "$paypal",
                                    "66": "$paypal",
                                    "67": "$paypal",
                                    "68": "$paypal",
                                    "69": "$paypal",
                                    "70": "$nmi",
                                    "71": "$nmi",
                                    "72": "$paypal",
                                    "73": "$paypal",
                                    "74": "$paypal",
                                    "75": "$nmi",
                                    "76": "$nmi",
                                    "77": "$nmi",
                                    "78": "$nmi",
                                    "79": "$nmi",
                                    "80": "$nmi",
                                    "81": "$nmi",
                                    "82": "$nmi",
                                    "83": "$nmi",
                                    "84": "$other",
                                    "85": "$braintree",
                                    "86": "$braintree",
                                    "87": "$nmi",
                                    "88": "$nmi",
                                    "89": "$nmi",
                                    "90": "$nmi",
                                    "91": "$nmi",
                                    "92": "$nmi",
                                    "93": "$nmi",
                                    "94": "$nmi",
                                    "95": "$nmi",
                                    "96": "$nmi",
                                    "97": "$nmi",
                                    "98": "$nmi",
                                    "99": "$nmi",
                                    "100": "$nmi",
                                    "101": "$nmi",
                                    "102": "$nmi",
                                    "103": "$nmi",
                                    "104": "$nmi",
                                    "105": "$nmi",
                                    "106": "$paypal",
                                    "107": "$stripe",
                                    "108": "$braintree",
                                    "109": "$paypal",
                                    "110": "$nmi",
                                    "111": "$nmi",
                                    "112": "$braintree",
                                    "113": "$braintree",
                                    "114": "$nmi",
                                    "115": "$nmi",
                                    "116": "$nmi",
                                    "117": "$stripe",
                                    "118": "$braintree",
                                    "119": "$braintree",
                                    "120": "$paypal",
                                    "121": "$paypal",
                                    "122": "$paypal",
                                    "123": "$nmi",
                                    "124": "$other",
                                    "125": "$nmi",
                                    "126": "$other",
                                    "127": "$nmi",
                                    "128": "$nmi",
                                    "129": "$nmi",
                                    "130": "$nmi",
                                    "131": "$other",
                                    "132": "$other",
                                    "133": "$other",
                                    "134": "$reach",
                                    "135": "$reach",
                                    "136": "$reach",
                                    "137": "$reach",
                                    "138": "$reach",
                                    "139": "$nmi",
                                    "140": "$nmi",
                                    "141": "$braintree",
                                    "142": "$braintree",
                                    "143": "$braintree",
                                    "144": "$braintree",
                                    "145": "$nmi",
                                    "146": "$nmi",
                                    "147": "$stripe",
                                    "148": "$other",
                                    "149": "$nmi",
                                    "150": "$stripe",
                                    "151": "$stripe",
                                    "152": "$stripe",
                                    "153": "$stripe",
                                    "154": "$stripe",
                                    "155": "$stripe",
                                    "156": "$stripe",
                                    "157": "$stripe",
                                    "158": "$stripe",
                                    "159": "$stripe",
                                    "160": "$stripe",
                                    "161": "$stripe",
                                    "162": "$stripe",
                                    "163": "$stripe",
                                    "164": "$stripe",
                                    "165": "$stripe",
                                    "166": "$stripe",
                                    "167": "$stripe",
                                    "168": "$stripe",
                                    "169": "$braintree",
                                    "170": "$braintree",
                                    "171": "$braintree",
                                    "172": "$stripe",
                                    "173": "$stripe",
                                    "174": "$stripe",
                                    "175": "$stripe",
                                    "176": "$stripe",
                                    "177": "$stripe",
                                    "178": "$checkoutcom",
                                    "179": "$checkoutcom",
                                    "180": "$checkoutcom",
                                    "181": "$checkoutcom",
                                    "182": "$checkoutcom",
                                    "183": "$checkoutcom",
                                    "184": "$checkoutcom",
                                    "185": "$checkoutcom",
                                    "186": "$checkoutcom",
                                    "187": "$checkoutcom",
                                    "188": "$checkoutcom",
                                    "189": "$checkoutcom",
                                    "190": "$checkoutcom",
                                    "191": "$checkoutcom",
                                    "192": "$braintree",
                                    "193": "$braintree",
                                    "194": "$checkoutcom",
                                    "195": "$checkoutcom",
                                    "196": "$stripe",
                                    "197": "$fluidpay",
                                    "198": "$fluidpay",
                                    "199": "$stripe",
                                    "200": "$stripe",
                                    "201": "$stripe",
                                    "202": "$fluidpay",
                                    "203": "$paypal",
                                    "204": "$stripe",
                                    "205": "$stripe",
                                    "206": "$stripe",
                                    "207": "$paypal",
                                    "208": "$nmi",
                                    "209": "$nmi",
                                    "210": "$stripe",
                                    "211": "$braintree",
                                    "212": "$stripe",
                                    "213": "$reach",
                                    "214": "$reach",
                                    "215": "$braintree",
                                    "216": "$paypal",
                                    "217": "$paypal",
                                    "218": "$stripe",
                                    "219": "$paypal",
                                    "220": "$paypal",
                                    "221": "$other",
                                    "222": "$stripe",
                                    "223": "$stripe",
                                    "224": "$stripe",
                                    "225": "$stripe",
                                    "226": "$stripe",
                                    "227": "$braintree",
                                    "228": "$braintree",
                                    "232": "$stripe",
                                    "233": "$braintree",
                                    "234": "$nmi",
                                    "235": "$stripe",
                                    "236": "$braintree",
                                    "237": "$stripe",
                                    "238": "$stripe",
                                    "239": "$stripe",
                                    "240": "$stripe",
                                    "241": "$stripe",
                                    "242": "$braintree",
                                    "243": "$checkoutcom",
                                    "244": "$checkoutcom",
                                    "245": "$checkoutcom",
                                    "246": "$checkoutcom",
                                    "247": "$checkoutcom",
                                    "248": "$checkoutcom",
                                    "249": "$checkoutcom",
                                    "250": "$checkoutcom"
                                };
                                // Convert merchantId to string for consistent comparison
                                merchantIdStr = String(merchantId).trim();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $667c018edd1009c7$export$9f3545331fac7df5).getInstance().getGatewayInfo(merchantId, orderId)
                                ];
                            case 2:
                                gatewayInfo = _state.sent();
                                if (gatewayInfo !== null && gatewayInfo !== void 0 && gatewayInfo.gatewayName) return [
                                    2,
                                    _this.mapGatewayNameToSift(gatewayInfo.gatewayName)
                                ];
                                // If API flow fails, use hardcoded mapping
                                if (knownGateways[merchantIdStr]) {
                                    if (window.DEBUG) console.warn("[SIFT FALLBACK] Using hardcoded gateway mapping for merchantId ".concat(merchantId, ": ").concat(knownGateways[merchantIdStr]));
                                    return [
                                        2,
                                        knownGateways[merchantIdStr]
                                    ];
                                }
                                return [
                                    2,
                                    "2. merchantId - ".concat(merchantId, ", not_found")
                                ];
                            case 3:
                                error = _state.sent();
                                // Even in error case, try the hardcoded mapping
                                if (knownGateways[merchantIdStr]) {
                                    if (window.DEBUG) console.warn("[SIFT FALLBACK] Using hardcoded gateway mapping after error for merchantId ".concat(merchantId, ": ").concat(knownGateways[merchantIdStr]));
                                    return [
                                        2,
                                        knownGateways[merchantIdStr]
                                    ];
                                }
                                return [
                                    2,
                                    "3. merchantId - ".concat(merchantId, ", not_found")
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mapGatewayNameToSift",
            value: function mapGatewayNameToSift(gatewayName) {
                if (!gatewayName) return "1. gatewayName - ".concat(gatewayName, ", not_found");
                var name = gatewayName.toLowerCase();
                var gatewayKeywords = [
                    {
                        keywords: [
                            "stripe"
                        ],
                        siftName: "$stripe"
                    },
                    {
                        keywords: [
                            "paypal",
                            "pay pal"
                        ],
                        siftName: "$paypal"
                    },
                    {
                        keywords: [
                            "braintree",
                            "brain tree"
                        ],
                        siftName: "$braintree"
                    },
                    {
                        keywords: [
                            "checkout.com",
                            "checkout"
                        ],
                        siftName: "$checkoutcom"
                    },
                    {
                        keywords: [
                            "fluid",
                            "fluidpay"
                        ],
                        siftName: "$fluidpay"
                    },
                    {
                        keywords: [
                            "nmi"
                        ],
                        siftName: "$nmi"
                    },
                    {
                        keywords: [
                            "reach"
                        ],
                        siftName: "$reach"
                    },
                    {
                        keywords: [
                            "ccbill"
                        ],
                        siftName: "$reach"
                    }
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Find the first matching keyword
                    for(var _iterator = gatewayKeywords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var gateway = _step.value;
                        if (gateway.keywords.some(function(keyword) {
                            return name.includes(keyword);
                        })) {
                            if (window.DEBUG) console.log("[Sift Debug] Mapped gateway name '".concat(gatewayName, "' to '").concat(gateway.siftName, "' via keyword matching"));
                            return gateway.siftName;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Default fallback
                if (window.DEBUG) console.log("[Sift Debug] Could not map gateway name '".concat(gatewayName, "' to a known Sift gateway"));
                return "2. gatewayName - ".concat(gatewayName, ", not_found");
            }
        },
        {
            key: "mapPaymentType",
            value: function mapPaymentType(paySource) {
                if (!paySource) return "$digital_wallet";
                // If it's already in Sift format (starts with $), return it as is
                if (paySource.startsWith("$")) return paySource;
                // Convert to uppercase for case-insensitive matching
                var source = paySource.toUpperCase();
                // Map payment types according to Sift's documentation
                var paymentMap = {
                    CREDITCARD: "$credit_card",
                    CREDIT_CARD: "$credit_card",
                    PAYPAL: "$electronic_fund_transfer",
                    KLARNA: "$digital_wallet",
                    APPLEPAY: "$digital_wallet",
                    APPLE_PAY: "$digital_wallet",
                    GOOGLEPAY: "$digital_wallet",
                    GOOGLE_PAY: "$digital_wallet",
                    PREPAID: "$digital_wallet"
                };
                return paymentMap[source] || "$digital_wallet";
            }
        },
        {
            key: "convertToIntegerMicros",
            value: function convertToIntegerMicros(price) {
                // Convert to number if it's a string
                var numericPrice = typeof price === "string" ? Number(price) : price;
                // Ensure it's a valid number
                if (isNaN(numericPrice)) return 0;
                // Convert to micros and ensure it's an integer
                return Math.round(numericPrice * 1000000);
            }
        },
        {
            key: "getBrowserInfo",
            value: function getBrowserInfo() {
                // Check if we're running in a browser environment
                if (typeof window === "undefined" || !window.navigator) return {};
                return {
                    $user_agent: window.navigator.userAgent || "",
                    $accept_language: window.navigator.language || "",
                    $content_language: window.navigator.language || ""
                };
            }
        },
        {
            key: "safelyTrackEvent",
            value: function safelyTrackEvent(eventType, contextName, createEventFn, debugData) {
                var returnScore = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var _window, _window$FLAGS, _window$GEO, event, _window$GEO2, _debugData$lead, _debugData$customFiel, _ref, emailAddress, error;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                // Log attempt to create event
                                if (window.DEBUG) console.log("[Sift Debug] Attempting to create ".concat(eventType, " event"));
                                return [
                                    4,
                                    Promise.resolve(createEventFn())
                                ];
                            case 1:
                                event = _state.sent();
                                event.$time = Date.now();
                                event.crm_version_no_ML = (_window = window) === null || _window === void 0 ? void 0 : (_window$FLAGS = _window.FLAGS) === null || _window$FLAGS === void 0 ? void 0 : _window$FLAGS.controller_v;
                                if ((_window$GEO = window.GEO) !== null && _window$GEO !== void 0 && _window$GEO.ip && event) {
                                    ;
                                    event.$ip = (_window$GEO2 = window.GEO) === null || _window$GEO2 === void 0 ? void 0 : _window$GEO2.ip;
                                }
                                // Log event creation result
                                if (window.DEBUG) {
                                    if (!event) console.log("[Sift Debug] No event created for ".concat(eventType, " - returned null"));
                                    else console.log("[Sift Debug] Successfully created ".concat(eventType, " event: ") + JSON.stringify(event, null, 2));
                                }
                                // Only proceed if we have a valid event
                                if (event) {
                                    ;
                                    emailAddress = (debugData === null || debugData === void 0 ? void 0 : (_debugData$lead = debugData.lead) === null || _debugData$lead === void 0 ? void 0 : _debugData$lead.emailAddress) || (debugData === null || debugData === void 0 ? void 0 : debugData.emailAddress) || (debugData === null || debugData === void 0 ? void 0 : debugData.custom_order_auid) || (debugData === null || debugData === void 0 ? void 0 : (_debugData$customFiel = debugData.customFields) === null || _debugData$customFiel === void 0 ? void 0 : _debugData$customFiel.auid);
                                    if (!event.$user_id && emailAddress) event.$user_id = emailAddress;
                                    // Always encode the user_id if it's present (handles email addresses)
                                    if (event.$user_id) event.$user_id = _this.encodeUserId(event.$user_id);
                                    // Add browser information to all events
                                    if (!"".concat(eventType).toLocaleLowerCase().includes("link_session_to_user")) {
                                        event.$brand_name = window.BRAND;
                                        event.$browser = _this.getBrowserInfo();
                                    }
                                    // Add debug logging for the return_score flag
                                    if (returnScore && window.DEBUG) {
                                        console.log("[Sift Debug] Requesting score for ".concat(event.$type, " event"));
                                        returnScore = false;
                                    }
                                    if (returnScore && "".concat(emailAddress).toLocaleLowerCase().includes("qa+")) returnScore = false;
                                    if (returnScore && ((_ref = "".concat((0, $5afc064d4f10b824$export$49b9065228a93aae)("utm_source")), _ref === void 0) ? void 0 : _ref.toLocaleLowerCase()) === "test") returnScore = false;
                                    // Use the existing TrackingService infrastructure
                                    (0, $b1366c713aafa52b$export$2e2bcd8739ae039).trackEvent("sift", event.$type, {
                                        siftEvent: event,
                                        // Nest the Sift event in a dedicated field
                                        return_score: returnScore // Add the return_score flag if requested
                                    });
                                    if (window.DEBUG) console.log("[Sift Debug] ".concat(contextName, " event sent"), (0, $ioWVw._)((0, $e2Ogy._)({}, debugData || {}), {
                                        user_id: event.$user_id,
                                        event_type: event.$type
                                    }));
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                // Use console.error instead of Errors.report for debugging
                                console.error("[Sift Error] Error in ".concat(contextName, " event:"), error, (0, $e2Ogy._)({
                                    eventType: "sift_".concat(contextName)
                                }, debugData));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createOrder",
            value: function createOrder(orderData, options) {
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safelyTrackEvent("$create_order", "create_order", /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                                        var _products$, _siftEvent$$payment_m, orderId, sessionId, userId, products, i, totalAmount, siftEvent, rawPaymentType, paymentType, merchantId, paymentGateway, paymentMethod, _options$cardInfo, cardNumber, cardBin, cardLast4;
                                        return (0, $33z5g.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!orderData) return [
                                                        2,
                                                        null
                                                    ];
                                                    orderId = orderData.orderId;
                                                    sessionId = orderData.custom_order_auid || orderData.sessionId || orderData.custom_order_sid;
                                                    userId = orderData.emailAddress;
                                                    // Skip orderId check for express payments, but still require user/session ID
                                                    if (!orderId && !(options !== null && options !== void 0 && options.isExpressPayment) || !(userId || sessionId)) {
                                                        if (window.DEBUG) console.log("[Sift Debug] Order validation failed:", {
                                                            hasOrderId: !!orderId,
                                                            isExpress: !!(options !== null && options !== void 0 && options.isExpressPayment),
                                                            hasUserOrSessionId: !!(userId || sessionId)
                                                        });
                                                        return [
                                                            2,
                                                            null
                                                        ];
                                                    }
                                                    // Extract products from orderData
                                                    products = [];
                                                    i = 1;
                                                    while(orderData["product".concat(i, "_id")]){
                                                        products.push({
                                                            id: orderData["product".concat(i, "_id")],
                                                            name: orderData["product".concat(i, "_name")] || "Product ".concat(i),
                                                            price: _this.convertToIntegerMicros(orderData["product".concat(i, "_price")]),
                                                            quantity: 1,
                                                            currency_code: orderData.currency_code || "USD"
                                                        });
                                                        i++;
                                                    }
                                                    if (products.length === 0) return [
                                                        2,
                                                        null
                                                    ];
                                                    // Calculate total amount
                                                    totalAmount = products.reduce(function(sum, product) {
                                                        return sum + product.price;
                                                    }, 0);
                                                    // Build the Sift event
                                                    siftEvent = (0, $ioWVw._)((0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)({
                                                        $type: "$create_order",
                                                        $session_id: sessionId
                                                    }, orderId ? {
                                                        $order_id: orderId
                                                    } : {}), {
                                                        $amount: totalAmount,
                                                        $currency_code: (products === null || products === void 0 ? void 0 : (_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.currency_code) || "USD"
                                                    }), options !== null && options !== void 0 && options.isExpressPayment ? {
                                                        is_express_no_ML: true
                                                    } : {}), {
                                                        $items: products.map(function(p) {
                                                            return {
                                                                $item_id: String(p.id),
                                                                $product_title: p.name,
                                                                $price: p.price,
                                                                $quantity: 1,
                                                                $currency_code: p.currency_code
                                                            };
                                                        }),
                                                        $payment_methods: []
                                                    });
                                                    if (orderData !== null && orderData !== void 0 && orderData.address1) _this.addAddressDetails(siftEvent, null, orderData);
                                                    if (orderData !== null && orderData !== void 0 && orderData.emailAddress) siftEvent.$user_email = orderData.emailAddress;
                                                    if (userId) siftEvent.$user_id = userId;
                                                    _this.addCustomParams(siftEvent, orderData);
                                                    // Always apply the mapping - don't use raw value even if provided in options
                                                    rawPaymentType = orderData.paySource || orderData.custom_order_paymentMethod || (options === null || options === void 0 ? void 0 : options.paymentType);
                                                    // Map the payment type regardless of source to ensure consistent formatting
                                                    paymentType = _this.mapPaymentType(rawPaymentType);
                                                    if (window.DEBUG) console.log("[Sift Debug] Payment type mapping: ".concat(rawPaymentType || "unknown", " \u2192 ").concat(paymentType));
                                                    merchantId = (orderData === null || orderData === void 0 ? void 0 : orderData.forceMerchantId) || (orderData === null || orderData === void 0 ? void 0 : orderData.merchantId);
                                                    // Use provided gateway option first, or look up from merchant ID
                                                    paymentGateway = options === null || options === void 0 ? void 0 : options.paymentGateway;
                                                    if (!(!paymentGateway && merchantId)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this.getGatewayFromMerchantId(merchantId, orderId)
                                                    ];
                                                case 1:
                                                    paymentGateway = _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    if (window.DEBUG) console.log("[Sift Debug] Payment gateway: ".concat(options !== null && options !== void 0 && options.paymentGateway ? '"'.concat(paymentGateway, '" (provided in options)') : '"'.concat(paymentGateway, '" from merchantId ').concat(merchantId || "not provided")));
                                                    paymentMethod = {
                                                        $payment_type: paymentType,
                                                        $payment_gateway: paymentGateway
                                                    };
                                                    // Add card details if this is a credit card payment
                                                    if (paymentType === "$credit_card") {
                                                        ;
                                                        cardNumber = "".concat(options === null || options === void 0 ? void 0 : (_options$cardInfo = options.cardInfo) === null || _options$cardInfo === void 0 ? void 0 : _options$cardInfo.number);
                                                        cardBin = cardNumber.substring(0, 8);
                                                        cardLast4 = cardNumber.substring(cardNumber.length - 4, cardNumber.length);
                                                        if (window.DEBUG) console.log('[Sift Debug] Card: "'.concat(cardBin, '", "').concat(cardLast4, '"'));
                                                        if (cardBin) paymentMethod.$card_bin = cardBin;
                                                        if (cardLast4) paymentMethod.$card_last4 = cardLast4;
                                                    }
                                                    (_siftEvent$$payment_m = siftEvent.$payment_methods) === null || _siftEvent$$payment_m === void 0 || _siftEvent$$payment_m.push(paymentMethod);
                                                    if (window.DEBUG) console.log("[Sift Debug] Create order payment info:", {
                                                        rawPaymentType: rawPaymentType,
                                                        mappedPaymentType: paymentType,
                                                        merchantId: merchantId,
                                                        paymentGateway: paymentGateway
                                                    });
                                                    return [
                                                        2,
                                                        siftEvent
                                                    ];
                                            }
                                        });
                                    }), {
                                        orderData: orderData
                                    }, options === null || options === void 0 ? void 0 : options.returnScore)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "trackTransaction",
            value: function trackTransaction(orderData, responseData, options) {
                var skipSessionLink = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    var _orderData11, _orderData12, _orderData13, _orderData14, sessionId, userId;
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (window.DEBUG) console.log("[Sift Debug] trackTransaction called with: " + JSON.stringify({
                                    orderData: orderData,
                                    responseData: responseData,
                                    options: options
                                }, null, 2));
                                return [
                                    4,
                                    _this.safelyTrackEvent("$transaction", "transaction", /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                                        var _orderData, _orderData2, _orderData3, _orderData4, _orderData5, _orderData6, _responseData$items, _responseData$items$, _orderData7, _orderData8, orderId, queryOrderData, sessionId, products, totalAmount, i, price, rawPaymentType, paymentType, merchantId, paymentGateway, siftEvent, _options$cardInfo2, _orderData9, cardBin, cardLast4, _orderData10;
                                        return (0, $33z5g.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!orderData && !responseData) {
                                                        if (window.DEBUG) console.log("[Sift Debug] trackTransaction aborted - missing orderData and responseData");
                                                        return [
                                                            2,
                                                            null
                                                        ];
                                                    }
                                                    // Use either the response orderId or the original one
                                                    orderId = (responseData === null || responseData === void 0 ? void 0 : responseData.orderId) || ((_orderData = orderData) === null || _orderData === void 0 ? void 0 : _orderData.orderId);
                                                    if (window.DEBUG) console.log("[Sift Debug] orderId: ", orderId);
                                                    if (!(orderId && !(responseData !== null && responseData !== void 0 && responseData.orderId))) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).queryOrder(orderId)
                                                    ];
                                                case 1:
                                                    queryOrderData = _state.sent();
                                                    if (window.DEBUG) console.log("[Sift Debug] queryOrderData: ", {
                                                        queryOrderData: JSON.stringify(queryOrderData, null, 2)
                                                    });
                                                    orderData = queryOrderData;
                                                    _state.label = 2;
                                                case 2:
                                                    sessionId = ((_orderData2 = orderData) === null || _orderData2 === void 0 ? void 0 : _orderData2.custom_order_auid) || ((_orderData3 = orderData) === null || _orderData3 === void 0 ? void 0 : _orderData3.sessionId) || ((_orderData4 = orderData) === null || _orderData4 === void 0 ? void 0 : _orderData4.custom_order_sid);
                                                    // Extract products and calculate total amount
                                                    products = [];
                                                    totalAmount = 0;
                                                    i = 1;
                                                    while(orderData["product".concat(i, "_id")]){
                                                        price = parseFloat("".concat(orderData["product".concat(i, "_price")])) || 0;
                                                        // const qty = parseInt(`${orderData[`product${i}_qty`]}`, 10) || 1;
                                                        products.push({
                                                            id: orderData["product".concat(i, "_id")],
                                                            price: _this.convertToIntegerMicros(price),
                                                            quantity: 1
                                                        });
                                                        totalAmount += price;
                                                        i++;
                                                    }
                                                    if (window.DEBUG) console.log("[Sift Debug] products: " + JSON.stringify({
                                                        products: products
                                                    }, null, 2));
                                                    // if (products.length === 0) return null;
                                                    // Always apply the mapping - don't use raw value even if provided in options
                                                    rawPaymentType = ((_orderData5 = orderData) === null || _orderData5 === void 0 ? void 0 : _orderData5.paySource) || ((_orderData6 = orderData) === null || _orderData6 === void 0 ? void 0 : _orderData6.custom_order_paymentMethod) || (options === null || options === void 0 ? void 0 : options.paymentType);
                                                    // Map the payment type regardless of source to ensure consistent formatting
                                                    paymentType = _this.mapPaymentType(rawPaymentType);
                                                    if (window.DEBUG) console.log("[Sift Debug] Payment type mapping: ".concat(rawPaymentType || "unknown", " \u2192 ").concat(paymentType));
                                                    // Get merchant ID from order data or response
                                                    merchantId = responseData === null || responseData === void 0 ? void 0 : (_responseData$items = responseData.items) === null || _responseData$items === void 0 ? void 0 : (_responseData$items$ = _responseData$items[0]) === null || _responseData$items$ === void 0 ? void 0 : _responseData$items$.merchantId;
                                                    // Use provided gateway option first, or look up from merchant ID
                                                    paymentGateway = options === null || options === void 0 ? void 0 : options.paymentGateway;
                                                    if (!(!paymentGateway && merchantId)) return [
                                                        3,
                                                        4
                                                    ];
                                                    return [
                                                        4,
                                                        _this.getGatewayFromMerchantId(merchantId, orderId)
                                                    ];
                                                case 3:
                                                    paymentGateway = _state.sent();
                                                    _state.label = 4;
                                                case 4:
                                                    if (window.DEBUG) console.log("[Sift Debug] Payment gateway: ".concat(options !== null && options !== void 0 && options.paymentGateway ? '"'.concat(paymentGateway, '" (provided in options)') : '"'.concat(paymentGateway, '" from merchantId ').concat(merchantId || "not provided")));
                                                    // Construct the transaction event
                                                    siftEvent = (0, $ioWVw._)((0, $e2Ogy._)({
                                                        $type: "$transaction",
                                                        $user_id: (responseData === null || responseData === void 0 ? void 0 : responseData.emailAddress) || ((_orderData7 = orderData) === null || _orderData7 === void 0 ? void 0 : _orderData7.emailAddress),
                                                        $session_id: sessionId,
                                                        $transaction_id: (responseData === null || responseData === void 0 ? void 0 : responseData.merchantTxnId) || orderId,
                                                        $order_id: orderId,
                                                        $user_email: (responseData === null || responseData === void 0 ? void 0 : responseData.emailAddress) || orderData.emailAddress,
                                                        $amount: _this.convertToIntegerMicros(totalAmount),
                                                        // Convert to integer micros
                                                        $currency_code: (responseData === null || responseData === void 0 ? void 0 : responseData.currency_code) || "USD",
                                                        $transaction_type: "$sale",
                                                        $transaction_status: "$success"
                                                    }, options !== null && options !== void 0 && options.isExpressPayment ? {
                                                        is_express_no_ML: true
                                                    } : {}), {
                                                        $payment_method: {
                                                            $payment_type: paymentType,
                                                            $payment_gateway: paymentGateway
                                                        }
                                                    });
                                                    if ((_orderData8 = orderData) !== null && _orderData8 !== void 0 && _orderData8.address1) _this.addAddressDetails(siftEvent, responseData, orderData);
                                                    // Add card details if this is a credit card payment
                                                    if (paymentType === "$credit_card") {
                                                        ;
                                                        cardBin = "".concat(options === null || options === void 0 ? void 0 : (_options$cardInfo2 = options.cardInfo) === null || _options$cardInfo2 === void 0 ? void 0 : _options$cardInfo2.number).substring(0, 8);
                                                        cardLast4 = (responseData === null || responseData === void 0 ? void 0 : responseData.cardLast4) || ((_orderData9 = orderData) === null || _orderData9 === void 0 ? void 0 : _orderData9.cardLast4);
                                                        if (window.DEBUG) console.log('[Sift Debug] Card: "'.concat(cardBin, '", "').concat(cardLast4, '"'));
                                                        if (cardBin) siftEvent.$payment_method.$card_bin = cardBin;
                                                        if (cardLast4) siftEvent.$payment_method.$card_last4 = cardLast4;
                                                    }
                                                    if ("".concat(paymentGateway).toLocaleLowerCase().includes("paypal")) {
                                                        ;
                                                        siftEvent.$payment_method.$paypal_payer_id = (_orderData10 = orderData) === null || _orderData10 === void 0 ? void 0 : _orderData10.payerId;
                                                    }
                                                    _this.addCustomParams(siftEvent, (0, $e2Ogy._)({}, orderData, responseData));
                                                    return [
                                                        2,
                                                        siftEvent
                                                    ];
                                            }
                                        });
                                    }), {
                                        orderData: orderData,
                                        responseData: responseData
                                    }, options === null || options === void 0 ? void 0 : options.returnScore)
                                ];
                            case 1:
                                _state.sent();
                                // After creating the order, link the session to the user if we have both IDsAdd commentMore actions
                                sessionId = ((_orderData11 = orderData) === null || _orderData11 === void 0 ? void 0 : _orderData11.custom_order_auid) || ((_orderData12 = orderData) === null || _orderData12 === void 0 ? void 0 : _orderData12.sessionId) || ((_orderData13 = orderData) === null || _orderData13 === void 0 ? void 0 : _orderData13.custom_order_sid);
                                userId = ((_orderData14 = orderData) === null || _orderData14 === void 0 ? void 0 : _orderData14.emailAddress) || (responseData === null || responseData === void 0 ? void 0 : responseData.emailAddress);
                                if (window.DEBUG) console.log("[Sift Debug] Trying to Linking session for order - ".concat(responseData.orderId || orderData.orderId), {
                                    sessionId: sessionId,
                                    userId: userId
                                });
                                if (!(userId && sessionId && !skipSessionLink && options !== null && options !== void 0 && options.isExpressPayment)) return [
                                    3,
                                    3
                                ];
                                if (window.DEBUG) console.log("[Sift Debug] Linking session ".concat(sessionId, " to user ").concat(userId));
                                return [
                                    4,
                                    _this.linkSessionToUser(userId, sessionId)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateOrder",
            value: function updateOrder(originalOrderData, upsellData, responseData, options) {
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safelyTrackEvent("$update_order", "update_order", /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                                        var _responseData$customF, _responseData$items$2, _responseData$items2, orderId, sessionId, userId, product, rawPaymentType, paymentType, merchantId, paymentGateway, items, siftEvent;
                                        return (0, $33z5g.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!originalOrderData || !upsellData || !responseData) {
                                                        if (window.DEBUG) console.log("[Sift Debug] updateOrder aborted - missing required data");
                                                        return [
                                                            2,
                                                            null
                                                        ];
                                                    }
                                                    // Verify we have the original order ID
                                                    orderId = originalOrderData.orderId;
                                                    if (!orderId) return [
                                                        2,
                                                        null
                                                    ];
                                                    sessionId = (responseData === null || responseData === void 0 ? void 0 : (_responseData$customF = responseData.customFields) === null || _responseData$customF === void 0 ? void 0 : _responseData$customF.auid) || originalOrderData.sessionId || originalOrderData.custom_order_sid;
                                                    userId = originalOrderData.emailAddress;
                                                    // Extract the upsell product
                                                    product = {
                                                        id: upsellData.product1_id,
                                                        name: upsellData.product1_name || "Upsell Product",
                                                        price: _this.convertToIntegerMicros(upsellData.product1_price),
                                                        quantity: 1,
                                                        currency_code: upsellData.currency_code || "USD"
                                                    };
                                                    // Always apply the mapping for payment type
                                                    rawPaymentType = upsellData.paySource;
                                                    // Map the payment type regardless of source
                                                    paymentType = _this.mapPaymentType(rawPaymentType);
                                                    // Get merchant ID from order data or response
                                                    merchantId = upsellData.forceMerchantId || responseData.merchantId || originalOrderData.merchantId || (responseData === null || responseData === void 0 ? void 0 : (_responseData$items$2 = responseData.items[0]) === null || _responseData$items$2 === void 0 ? void 0 : _responseData$items$2.merchantId);
                                                    // Use provided gateway or look up from merchant ID
                                                    paymentGateway = options === null || options === void 0 ? void 0 : options.paymentGateway;
                                                    if (!(!paymentGateway && merchantId)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this.getGatewayFromMerchantId(merchantId, orderId)
                                                    ];
                                                case 1:
                                                    paymentGateway = _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    if (window.DEBUG) console.log("[Sift Debug] Update order payment info:", {
                                                        rawPaymentType: rawPaymentType,
                                                        mappedPaymentType: paymentType,
                                                        merchantId: merchantId,
                                                        paymentGateway: paymentGateway
                                                    });
                                                    items = Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.items) ? responseData === null || responseData === void 0 ? void 0 : (_responseData$items2 = responseData.items) === null || _responseData$items2 === void 0 ? void 0 : _responseData$items2.map(function(item) {
                                                        return {
                                                            $item_id: String(item.productId),
                                                            $product_title: item.name,
                                                            $price: _this.convertToIntegerMicros(item.price),
                                                            $quantity: 1,
                                                            $currency_code: responseData === null || responseData === void 0 ? void 0 : responseData.currencyCode
                                                        };
                                                    }) : [
                                                        {
                                                            $item_id: String(product.id),
                                                            $product_title: product.name,
                                                            $price: product.price,
                                                            $quantity: 1,
                                                            $currency_code: product.currency_code
                                                        }
                                                    ];
                                                    // Construct the update order event
                                                    siftEvent = {
                                                        $type: "$update_order",
                                                        $user_email: responseData === null || responseData === void 0 ? void 0 : responseData.emailAddress,
                                                        $user_id: userId || sessionId,
                                                        $session_id: sessionId,
                                                        $order_id: orderId,
                                                        $amount: _this.convertToIntegerMicros(responseData.totalAmount),
                                                        $currency_code: product.currency_code,
                                                        $items: items,
                                                        crm_is_upsell_no_ML: true,
                                                        $payment_methods: [
                                                            {
                                                                $payment_type: paymentType,
                                                                $payment_gateway: paymentGateway
                                                            }
                                                        ]
                                                    };
                                                    _this.addAddressDetails(siftEvent, null, (0, $e2Ogy._)({}, originalOrderData, upsellData, responseData));
                                                    _this.addCustomParams(siftEvent, (0, $e2Ogy._)({}, originalOrderData, upsellData, responseData));
                                                    return [
                                                        2,
                                                        siftEvent
                                                    ];
                                            }
                                        });
                                    }), {
                                        originalOrderData: originalOrderData,
                                        upsellData: upsellData,
                                        responseData: responseData
                                    }, options === null || options === void 0 ? void 0 : options.returnScore)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "trackUpsellTransaction",
            value: function trackUpsellTransaction(orderData, responseData, options) {
                var skipSessionLink = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safelyTrackEvent("$transaction", "transaction", /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                                        var _responseData$items3, _responseData$items3$, orderId, sessionId, userId, products, totalAmount, i, price, rawPaymentType, paymentType, merchantId, paymentGateway, siftEvent, cardBin, cardLast4;
                                        return (0, $33z5g.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!orderData || !responseData) {
                                                        if (window.DEBUG) console.log("[Sift Debug] trackTransaction aborted - missing orderData or responseData");
                                                        return [
                                                            2,
                                                            null
                                                        ];
                                                    }
                                                    // Use either the response orderId or the original one
                                                    orderId = responseData.orderId || orderData.orderId;
                                                    if (!orderId) return [
                                                        2,
                                                        null
                                                    ];
                                                    sessionId = orderData.custom_order_auid || orderData.sessionId || orderData.custom_order_sid;
                                                    userId = (orderData === null || orderData === void 0 ? void 0 : orderData.emailAddress) || (responseData === null || responseData === void 0 ? void 0 : responseData.emailAddress);
                                                    // Extract products and calculate total amount
                                                    products = [];
                                                    totalAmount = 0;
                                                    i = 1;
                                                    while(orderData["product".concat(i, "_id")]){
                                                        price = parseFloat("".concat(orderData["product".concat(i, "_price")])) || 0;
                                                        // const qty = parseInt(`${orderData[`product${i}_qty`]}`, 10) || 1;
                                                        products.push({
                                                            id: orderData["product".concat(i, "_id")],
                                                            price: _this.convertToIntegerMicros(price),
                                                            quantity: 1
                                                        });
                                                        totalAmount += price;
                                                        i++;
                                                    }
                                                    if (products.length === 0) return [
                                                        2,
                                                        null
                                                    ];
                                                    // Always apply the mapping - don't use raw value even if provided in options
                                                    rawPaymentType = orderData.paySource || orderData.custom_order_paymentMethod || (options === null || options === void 0 ? void 0 : options.paymentType);
                                                    // Map the payment type regardless of source to ensure consistent formatting
                                                    paymentType = _this.mapPaymentType(rawPaymentType);
                                                    if (window.DEBUG) console.log("[Sift Debug] Payment type mapping: ".concat(rawPaymentType || "unknown", " \u2192 ").concat(paymentType));
                                                    // Get merchant ID from order data or response
                                                    merchantId = responseData === null || responseData === void 0 ? void 0 : (_responseData$items3 = responseData.items) === null || _responseData$items3 === void 0 ? void 0 : (_responseData$items3$ = _responseData$items3[0]) === null || _responseData$items3$ === void 0 ? void 0 : _responseData$items3$.merchantId;
                                                    // Use provided gateway option first, or look up from merchant ID
                                                    paymentGateway = options === null || options === void 0 ? void 0 : options.paymentGateway;
                                                    if (!(!paymentGateway && merchantId)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this.getGatewayFromMerchantId(merchantId, orderId)
                                                    ];
                                                case 1:
                                                    paymentGateway = _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    if (window.DEBUG) console.log("[Sift Debug] Payment gateway: ".concat(options !== null && options !== void 0 && options.paymentGateway ? '"'.concat(paymentGateway, '" (provided in options)') : '"'.concat(paymentGateway, '" from merchantId ').concat(merchantId || "not provided")));
                                                    // Construct the transaction event
                                                    siftEvent = (0, $ioWVw._)((0, $e2Ogy._)({
                                                        $type: "$transaction",
                                                        $user_id: userId,
                                                        $session_id: sessionId,
                                                        $transaction_id: (responseData === null || responseData === void 0 ? void 0 : responseData.merchantTxnId) || orderId,
                                                        $order_id: orderId,
                                                        $user_email: orderData.emailAddress,
                                                        $amount: _this.convertToIntegerMicros(totalAmount),
                                                        // Convert to integer micros
                                                        $currency_code: orderData.currency_code || "USD",
                                                        $transaction_type: "$sale",
                                                        $transaction_status: "$success"
                                                    }, options !== null && options !== void 0 && options.isExpressPayment ? {
                                                        is_express_no_ML: true
                                                    } : {}), {
                                                        $payment_method: {
                                                            $payment_type: paymentType,
                                                            $payment_gateway: paymentGateway
                                                        }
                                                    });
                                                    if (orderData !== null && orderData !== void 0 && orderData.address1) _this.addAddressDetails(siftEvent, responseData, orderData);
                                                    // Add card details if this is a credit card payment
                                                    if (paymentType === "$credit_card") {
                                                        cardBin = (orderData === null || orderData === void 0 ? void 0 : orderData.cardBin) || (responseData === null || responseData === void 0 ? void 0 : responseData.cardBin);
                                                        cardLast4 = (orderData === null || orderData === void 0 ? void 0 : orderData.cardLast4) || (responseData === null || responseData === void 0 ? void 0 : responseData.last4) || (orderData === null || orderData === void 0 ? void 0 : orderData.last4);
                                                        if (cardBin) siftEvent.$payment_method.$card_bin = cardBin;
                                                        if (cardLast4) siftEvent.$payment_method.$card_last4 = cardLast4;
                                                    }
                                                    if ("".concat(paymentGateway).toLocaleLowerCase().includes("paypal")) siftEvent.$payment_method.$paypal_payer_id = orderData === null || orderData === void 0 ? void 0 : orderData.payerId;
                                                    _this.addCustomParams(siftEvent, (0, $e2Ogy._)({}, orderData, responseData));
                                                    return [
                                                        2,
                                                        siftEvent
                                                    ];
                                            }
                                        });
                                    }), {
                                        orderData: orderData,
                                        responseData: responseData
                                    }, options === null || options === void 0 ? void 0 : options.returnScore)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                // After creating the order, link the session to the user if we have both IDsAdd commentMore actions
                // const sessionId = orderData?.custom_order_auid || orderData?.sessionId || orderData?.custom_order_sid;
                // const userId = orderData?.emailAddress || responseData?.emailAddress;
                // if (window.DEBUG) {
                //   console.log(`[Sift Debug] Trying to Linking session for order - ${responseData?.orderId || orderData?.orderId}`, { sessionId, userId });
                // }
                // if (userId && sessionId && !skipSessionLink) {
                //   if (window.DEBUG) {
                //     console.log(`[Sift Debug] Linking session ${sessionId} to user ${userId}`);
                //   }
                //   await this.linkSessionToUser(userId, sessionId);
                // }
                })();
            }
        },
        {
            key: "trackFailedTransaction",
            value: function trackFailedTransaction(orderId, orderData, options) {
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (window.DEBUG) console.log("[Sift Debug] trackFailedTransaction called with: " + JSON.stringify({
                                    orderData: orderData,
                                    options: options
                                }, null, 2));
                                return [
                                    4,
                                    _this.safelyTrackEvent("$transaction", "transaction", /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                                        var _orderData15, _orderData16, _orderData16$customFi, _orderData17, _orderData18, _orderData18$customFi, _orderData19, _orderData20, _orderData25, _orderData26, _orderData27, _orderData28, _orderData29, _orderData29$products, _orderData29$products2, _orderData30, sessionId, userId, products, totalAmount, i, _orderData21, _orderData21$products, _orderData22, _orderData22$products, _orderData22$products2, _orderData23, _orderData23$products, _orderData23$products2, _orderData24, _orderData24$products, _orderData24$products2, price, qty, priceMicros, rawPaymentType, paymentType, merchantId, paymentGateway, siftEvent, _options$cardInfo3, cardNumber, cardBin, cardLast4, _orderData31;
                                        return (0, $33z5g.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!orderId) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).queryOrder(orderId)
                                                    ];
                                                case 1:
                                                    orderData = _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    sessionId = ((_orderData15 = orderData) === null || _orderData15 === void 0 ? void 0 : _orderData15.custom_order_auid) || ((_orderData16 = orderData) === null || _orderData16 === void 0 ? void 0 : (_orderData16$customFi = _orderData16.customFields) === null || _orderData16$customFi === void 0 ? void 0 : _orderData16$customFi.auid) || ((_orderData17 = orderData) === null || _orderData17 === void 0 ? void 0 : _orderData17.sessionId) || ((_orderData18 = orderData) === null || _orderData18 === void 0 ? void 0 : (_orderData18$customFi = _orderData18.customFields) === null || _orderData18$customFi === void 0 ? void 0 : _orderData18$customFi.sid);
                                                    userId = (_orderData19 = orderData) === null || _orderData19 === void 0 ? void 0 : _orderData19.emailAddress;
                                                    if (!sessionId) return [
                                                        2,
                                                        null
                                                    ];
                                                    // Extract products and calculate total amount
                                                    products = [];
                                                    totalAmount = 0;
                                                    i = 1;
                                                    if ((_orderData20 = orderData) !== null && _orderData20 !== void 0 && _orderData20.products) while((_orderData21 = orderData) !== null && _orderData21 !== void 0 && (_orderData21$products = _orderData21.products[i]) !== null && _orderData21$products !== void 0 && _orderData21$products.productId){
                                                        ;
                                                        price = parseFloat("".concat((_orderData22 = orderData) === null || _orderData22 === void 0 ? void 0 : (_orderData22$products = _orderData22.products) === null || _orderData22$products === void 0 ? void 0 : (_orderData22$products2 = _orderData22$products[0]) === null || _orderData22$products2 === void 0 ? void 0 : _orderData22$products2.price)) || 0;
                                                        qty = parseInt("".concat((_orderData23 = orderData) === null || _orderData23 === void 0 ? void 0 : (_orderData23$products = _orderData23.products) === null || _orderData23$products === void 0 ? void 0 : (_orderData23$products2 = _orderData23$products[0]) === null || _orderData23$products2 === void 0 ? void 0 : _orderData23$products2.qty), 10) || 1;
                                                        priceMicros = _this.convertToIntegerMicros(price);
                                                        products.push({
                                                            id: (_orderData24 = orderData) === null || _orderData24 === void 0 ? void 0 : (_orderData24$products = _orderData24.products) === null || _orderData24$products === void 0 ? void 0 : (_orderData24$products2 = _orderData24$products[0]) === null || _orderData24$products2 === void 0 ? void 0 : _orderData24$products2.productId,
                                                            price: priceMicros,
                                                            quantity: 1
                                                        });
                                                        totalAmount += price * qty;
                                                        i++;
                                                    }
                                                    rawPaymentType = (options === null || options === void 0 ? void 0 : options.paymentType) || ((_orderData25 = orderData) === null || _orderData25 === void 0 ? void 0 : _orderData25.paySource);
                                                    paymentType = _this.mapPaymentType(rawPaymentType);
                                                    if (window.DEBUG) console.log("[Sift Debug] Payment type mapping: ".concat(rawPaymentType || "unknown", " \u2192 ").concat(paymentType));
                                                    merchantId = ((_orderData26 = orderData) === null || _orderData26 === void 0 ? void 0 : _orderData26.forceMerchantId) || ((_orderData27 = orderData) === null || _orderData27 === void 0 ? void 0 : _orderData27.merchantId) || ((_orderData28 = orderData) === null || _orderData28 === void 0 ? void 0 : _orderData28.paypalBillerId) || ((_orderData29 = orderData) === null || _orderData29 === void 0 ? void 0 : (_orderData29$products = _orderData29.products) === null || _orderData29$products === void 0 ? void 0 : (_orderData29$products2 = _orderData29$products[0]) === null || _orderData29$products2 === void 0 ? void 0 : _orderData29$products2.merchantId);
                                                    paymentGateway = options === null || options === void 0 ? void 0 : options.paymentGateway;
                                                    if (!(!paymentGateway && merchantId)) return [
                                                        3,
                                                        4
                                                    ];
                                                    return [
                                                        4,
                                                        _this.getGatewayFromMerchantId(merchantId, orderId)
                                                    ];
                                                case 3:
                                                    paymentGateway = _state.sent();
                                                    _state.label = 4;
                                                case 4:
                                                    if (window.DEBUG) console.log("[Sift Debug] Payment gateway: ".concat(options !== null && options !== void 0 && options.paymentGateway ? '"'.concat(paymentGateway, '" (provided in options)') : '"'.concat(paymentGateway, '" from merchantId ').concat(merchantId || "not provided")));
                                                    // Construct the transaction event
                                                    siftEvent = (0, $ioWVw._)((0, $e2Ogy._)({
                                                        $type: "$transaction",
                                                        $user_id: userId || sessionId,
                                                        $session_id: sessionId,
                                                        $transaction_id: orderId,
                                                        $order_id: orderId,
                                                        $amount: _this.convertToIntegerMicros(totalAmount),
                                                        $currency_code: orderData.currency_code || "USD",
                                                        $transaction_type: "$sale",
                                                        $transaction_status: "$failure"
                                                    }, options !== null && options !== void 0 && options.isExpressPayment ? {
                                                        is_express_no_ML: true
                                                    } : {}), {
                                                        $decline_category: "$other",
                                                        $payment_method: {
                                                            $payment_type: paymentType,
                                                            $payment_gateway: paymentGateway
                                                        },
                                                        crm_decline_message: options === null || options === void 0 ? void 0 : options.errorMessage
                                                    });
                                                    if (orderData.emailAddress) siftEvent.$user_email = orderData.emailAddress;
                                                    if ((_orderData30 = orderData) !== null && _orderData30 !== void 0 && _orderData30.address1) _this.addAddressDetails(siftEvent, null, orderData);
                                                    // Add card details if this is a credit card payment
                                                    if (paymentType === "$credit_card") {
                                                        ;
                                                        cardNumber = "".concat(options === null || options === void 0 ? void 0 : (_options$cardInfo3 = options.cardInfo) === null || _options$cardInfo3 === void 0 ? void 0 : _options$cardInfo3.number);
                                                        cardBin = cardNumber.substring(0, 8);
                                                        cardLast4 = cardNumber.substring(cardNumber.length - 4, cardNumber.length);
                                                        if (window.DEBUG) console.log('[Sift Debug] Card: "'.concat(cardBin, '", "').concat(cardLast4, '"'));
                                                        if (cardBin) siftEvent.$payment_method.$card_bin = cardBin;
                                                        if (cardLast4) siftEvent.$payment_method.$card_last4 = cardLast4;
                                                    }
                                                    if ("".concat(paymentGateway).toLocaleLowerCase().includes("paypal")) {
                                                        ;
                                                        siftEvent.$payment_method.$paypal_payer_id = (_orderData31 = orderData) === null || _orderData31 === void 0 ? void 0 : _orderData31.payerId;
                                                    }
                                                    _this.addCustomParams(siftEvent, orderData);
                                                    return [
                                                        2,
                                                        siftEvent
                                                    ];
                                            }
                                        });
                                    }), {}, options === null || options === void 0 ? void 0 : options.returnScore)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "linkSessionToUser",
            value: function linkSessionToUser(userId, sessionId) {
                var _this = this;
                return (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
                    return (0, $33z5g.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.safelyTrackEvent("$link_session_to_user", "link_session_to_user", function() {
                                        if (!userId || !sessionId) return null;
                                        return {
                                            $type: "$link_session_to_user",
                                            $user_id: _this.encodeUserId(userId),
                                            $session_id: sessionId
                                        };
                                    }, {
                                        userId: userId,
                                        sessionId: sessionId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SiftEvents;
}();




var $8930f014d14fb0b6$export$105adf7faeb879c1 = [
    "de",
    "fr",
    "se",
    "no",
    "dk",
    "nl"
];




var $fvacx = parcelRequire("fvacx");

var $33z5g = parcelRequire("33z5g");
var $a3012b76ed9b4143$exports = {};

var $iHOCm = parcelRequire("iHOCm");
(function(f) {
    var g;
    $a3012b76ed9b4143$exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var _$n = e[i][1][r];
                        return o(_$n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                var scriptPromiseCache = {};
                function loadScript(options) {
                    var scriptLoadPromise;
                    var stringifiedOptions = JSON.stringify(options);
                    if (!options.forceScriptReload) {
                        scriptLoadPromise = scriptPromiseCache[stringifiedOptions];
                        if (scriptLoadPromise) return scriptLoadPromise;
                    }
                    var script = document.createElement("script");
                    var attrs = options.dataAttributes || {};
                    var container = options.container || document.head;
                    script.src = options.src;
                    script.id = options.id || "";
                    script.async = true;
                    if (options.type) script.setAttribute("type", "".concat(options.type));
                    if (options.crossorigin) script.setAttribute("crossorigin", "".concat(options.crossorigin));
                    Object.keys(attrs).forEach(function(key) {
                        script.setAttribute("data-".concat(key), "".concat(attrs[key]));
                    });
                    scriptLoadPromise = new Promise(function(resolve, reject) {
                        script.addEventListener("load", function() {
                            resolve(script);
                        });
                        script.addEventListener("error", function() {
                            reject(new Error("".concat(options.src, " failed to load.")));
                        });
                        script.addEventListener("abort", function() {
                            reject(new Error("".concat(options.src, " has aborted.")));
                        });
                        container.appendChild(script);
                    });
                    scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
                    return scriptLoadPromise;
                }
                loadScript.clearCache = function() {
                    scriptPromiseCache = {};
                };
                module1.exports = loadScript;
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/load-script");
            },
            {
                "./dist/load-script": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isAndroid(ua) {
                    ua = ua || window.navigator.userAgent;
                    return /Android/i.test(ua);
                };
            },
            {}
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isChromeOS(ua) {
                    ua = ua || window.navigator.userAgent;
                    return /CrOS/i.test(ua);
                };
            },
            {}
        ],
        5: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isEdge = _dereq_("./is-edge");
                var isSamsung = _dereq_("./is-samsung");
                var isDuckDuckGo = _dereq_("./is-duckduckgo");
                var isOpera = _dereq_("./is-opera");
                var isSilk = _dereq_("./is-silk");
                module1.exports = function isChrome(ua) {
                    ua = ua || window.navigator.userAgent;
                    return (ua.indexOf("Chrome") !== -1 || ua.indexOf("CriOS") !== -1) && !isEdge(ua) && !isSamsung(ua) && !isDuckDuckGo(ua) && !isOpera(ua) && !isSilk(ua);
                };
            },
            {
                "./is-duckduckgo": 6,
                "./is-edge": 7,
                "./is-opera": 16,
                "./is-samsung": 17,
                "./is-silk": 18
            }
        ],
        6: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isDuckDuckGo(ua) {
                    ua = ua || window.navigator.userAgent;
                    return ua.indexOf("DuckDuckGo/") !== -1;
                };
            },
            {}
        ],
        7: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isEdge(ua) {
                    ua = ua || window.navigator.userAgent;
                    return ua.indexOf("Edge/") !== -1 || ua.indexOf("Edg/") !== -1;
                };
            },
            {}
        ],
        8: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isFirefox(ua) {
                    ua = ua || window.navigator.userAgent;
                    return /Firefox/i.test(ua);
                };
            },
            {}
        ],
        9: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isIosFirefox(ua) {
                    ua = ua || window.navigator.userAgent;
                    return /FxiOS/i.test(ua);
                };
            },
            {}
        ],
        10: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isIos = _dereq_("./is-ios");
                function isGoogleSearchApp(ua) {
                    return /\bGSA\b/.test(ua);
                }
                module1.exports = function isIosGoogleSearchApp(ua) {
                    ua = ua || window.navigator.userAgent;
                    return isIos(ua) && isGoogleSearchApp(ua);
                };
            },
            {
                "./is-ios": 14
            }
        ],
        11: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isIos = _dereq_("./is-ios");
                var isIosFirefox = _dereq_("./is-ios-firefox");
                var webkitRegexp = /webkit/i;
                function isWebkit(ua) {
                    return webkitRegexp.test(ua);
                }
                function isIosChrome(ua) {
                    return ua.indexOf("CriOS") > -1;
                }
                function isFacebook(ua) {
                    return ua.indexOf("FBAN") > -1;
                }
                module1.exports = function isIosSafari(ua) {
                    ua = ua || window.navigator.userAgent;
                    return isIos(ua) && isWebkit(ua) && !isIosChrome(ua) && !isIosFirefox(ua) && !isFacebook(ua);
                };
            },
            {
                "./is-ios": 14,
                "./is-ios-firefox": 9
            }
        ],
        12: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isIos = _dereq_("./is-ios");
                var isIosGoogleSearchApp = _dereq_("./is-ios-google-search-app");
                module1.exports = function isIosWebview(ua) {
                    ua = ua || window.navigator.userAgent;
                    if (isIos(ua)) {
                        // The Google Search iOS app is technically a webview and doesn't support popups.
                        if (isIosGoogleSearchApp(ua)) return true;
                        // Historically, a webview could be identified by the presence of AppleWebKit and _no_ presence of Safari after.
                        return /.+AppleWebKit(?!.*Safari)/i.test(ua);
                    }
                    return false;
                };
            },
            {
                "./is-ios": 14,
                "./is-ios-google-search-app": 10
            }
        ],
        13: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isIosWebview = _dereq_("./is-ios-webview");
                module1.exports = function isIosWKWebview(ua, statusBarVisible) {
                    statusBarVisible = typeof statusBarVisible !== "undefined" ? statusBarVisible : window.statusbar.visible;
                    return isIosWebview(ua) && statusBarVisible;
                };
            },
            {
                "./is-ios-webview": 12
            }
        ],
        14: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isIpadOS = _dereq_("./is-ipados");
                module1.exports = function isIos(ua, checkIpadOS, document1) {
                    if (checkIpadOS === void 0) checkIpadOS = true;
                    ua = ua || window.navigator.userAgent;
                    var iOsTest = /iPhone|iPod|iPad/i.test(ua);
                    return checkIpadOS ? iOsTest || isIpadOS(ua, document1) : iOsTest;
                };
            },
            {
                "./is-ipados": 15
            }
        ],
        15: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isIpadOS(ua, document1) {
                    ua = ua || window.navigator.userAgent;
                    document1 = document1 || window.document;
                    // "ontouchend" is used to determine if a browser is on an iPad, otherwise
                    // user-agents for iPadOS behave/identify as a desktop browser
                    return /Mac|iPad/i.test(ua) && "ontouchend" in document1;
                };
            },
            {}
        ],
        16: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isOpera(ua) {
                    ua = ua || window.navigator.userAgent;
                    return ua.indexOf("OPR/") !== -1 || ua.indexOf("Opera/") !== -1 || ua.indexOf("OPT/") !== -1;
                };
            },
            {}
        ],
        17: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isSamsungBrowser(ua) {
                    ua = ua || window.navigator.userAgent;
                    return /SamsungBrowser/i.test(ua);
                };
            },
            {}
        ],
        18: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isSilk(ua) {
                    ua = ua || window.navigator.userAgent;
                    return ua.indexOf("Silk/") !== -1;
                };
            },
            {}
        ],
        19: [
            function(_dereq_, module1, exports) {
                "use strict";
                var MINIMUM_SUPPORTED_CHROME_IOS_VERSION = 48;
                var isAndroid = _dereq_("./is-android");
                var isIosFirefox = _dereq_("./is-ios-firefox");
                var isIosWebview = _dereq_("./is-ios-webview");
                var isChrome = _dereq_("./is-chrome");
                var isSamsungBrowser = _dereq_("./is-samsung");
                var isDuckDuckGo = _dereq_("./is-duckduckgo");
                function isUnsupportedIosChrome(ua) {
                    ua = ua || window.navigator.userAgent;
                    var match = ua.match(/CriOS\/(\d+)\./);
                    if (!match) return false;
                    var version = parseInt(match[1], 10);
                    return version < MINIMUM_SUPPORTED_CHROME_IOS_VERSION;
                }
                function isOperaMini(ua) {
                    ua = ua || window.navigator.userAgent;
                    return ua.indexOf("Opera Mini") > -1;
                }
                function isAndroidWebview(ua) {
                    var androidWebviewRegExp = /Version\/[\d.]+/i;
                    ua = ua || window.navigator.userAgent;
                    if (isAndroid(ua)) return androidWebviewRegExp.test(ua) && !isOperaMini(ua) && !isDuckDuckGo(ua);
                    return false;
                }
                function isOldSamsungBrowserOrSamsungWebview(ua) {
                    return !isChrome(ua) && !isSamsungBrowser(ua) && /samsung/i.test(ua);
                }
                module1.exports = function supportsPopups(ua) {
                    ua = ua || window.navigator.userAgent;
                    return !(isIosWebview(ua) || isIosFirefox(ua) || isAndroidWebview(ua) || isOperaMini(ua) || isUnsupportedIosChrome(ua) || isOldSamsungBrowserOrSamsungWebview(ua));
                };
            },
            {
                "./is-android": 3,
                "./is-chrome": 5,
                "./is-duckduckgo": 6,
                "./is-ios-firefox": 9,
                "./is-ios-webview": 12,
                "./is-samsung": 17
            }
        ],
        20: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-android");
            },
            {
                "./dist/is-android": 3
            }
        ],
        21: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-chrome-os");
            },
            {
                "./dist/is-chrome-os": 4
            }
        ],
        22: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-chrome");
            },
            {
                "./dist/is-chrome": 5
            }
        ],
        23: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-firefox");
            },
            {
                "./dist/is-firefox": 8
            }
        ],
        24: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-ios-safari");
            },
            {
                "./dist/is-ios-safari": 11
            }
        ],
        25: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-ios-webview");
            },
            {
                "./dist/is-ios-webview": 12
            }
        ],
        26: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-ios-wkwebview");
            },
            {
                "./dist/is-ios-wkwebview": 13
            }
        ],
        27: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-ios");
            },
            {
                "./dist/is-ios": 14
            }
        ],
        28: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-samsung");
            },
            {
                "./dist/is-samsung": 17
            }
        ],
        29: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/supports-popups");
            },
            {
                "./dist/supports-popups": 19
            }
        ],
        30: [
            function(_dereq_, module1, exports) {
                "use strict";
                var EventEmitter = /** @class */ function() {
                    function EventEmitter() {
                        this._events = {};
                    }
                    EventEmitter.prototype.on = function(event, callback) {
                        if (this._events[event]) this._events[event].push(callback);
                        else this._events[event] = [
                            callback
                        ];
                    };
                    EventEmitter.prototype.off = function(event, callback) {
                        var eventCallbacks = this._events[event];
                        if (!eventCallbacks) return;
                        var indexOfCallback = eventCallbacks.indexOf(callback);
                        eventCallbacks.splice(indexOfCallback, 1);
                    };
                    EventEmitter.prototype._emit = function(event) {
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        var eventCallbacks = this._events[event];
                        if (!eventCallbacks) return;
                        eventCallbacks.forEach(function(callback) {
                            callback.apply(void 0, args);
                        });
                    };
                    EventEmitter.prototype.hasListener = function(event) {
                        var eventCallbacks = this._events[event];
                        if (!eventCallbacks) return false;
                        return eventCallbacks.length > 0;
                    };
                    EventEmitter.createChild = function(ChildObject) {
                        ChildObject.prototype = Object.create(EventEmitter.prototype, {
                            constructor: ChildObject
                        });
                    };
                    return EventEmitter;
                }();
                module1.exports = EventEmitter;
            },
            {}
        ],
        31: [
            function(_dereq_, module1, exports) {
                "use strict";
                var GlobalPromise = typeof Promise !== "undefined" ? Promise // eslint-disable-line no-undef
                 : null;
                var ExtendedPromise = /** @class */ function() {
                    function ExtendedPromise(options) {
                        var _this = this;
                        if (typeof options === "function") {
                            this._promise = new ExtendedPromise.Promise(options);
                            return;
                        }
                        this._promise = new ExtendedPromise.Promise(function(resolve, reject) {
                            _this._resolveFunction = resolve;
                            _this._rejectFunction = reject;
                        });
                        options = options || {};
                        this._onResolve = options.onResolve || ExtendedPromise.defaultOnResolve;
                        this._onReject = options.onReject || ExtendedPromise.defaultOnReject;
                        if (ExtendedPromise.shouldCatchExceptions(options)) this._promise["catch"](function() {
                        // prevents unhandled promise rejection warning
                        // in the console for extended promises that
                        // that catch the error in an asynchronous manner
                        });
                        this._resetState();
                    }
                    ExtendedPromise.defaultOnResolve = function(result) {
                        return ExtendedPromise.Promise.resolve(result);
                    };
                    ExtendedPromise.defaultOnReject = function(err) {
                        return ExtendedPromise.Promise.reject(err);
                    };
                    ExtendedPromise.setPromise = function(PromiseClass) {
                        ExtendedPromise.Promise = PromiseClass;
                    };
                    ExtendedPromise.shouldCatchExceptions = function(options) {
                        if (options.hasOwnProperty("suppressUnhandledPromiseMessage")) return Boolean(options.suppressUnhandledPromiseMessage);
                        return Boolean(ExtendedPromise.suppressUnhandledPromiseMessage);
                    };
                    // start Promise methods documented in:
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise#Methods
                    ExtendedPromise.all = function(args) {
                        return ExtendedPromise.Promise.all(args);
                    };
                    ExtendedPromise.allSettled = function(args) {
                        return ExtendedPromise.Promise.allSettled(args);
                    };
                    ExtendedPromise.race = function(args) {
                        return ExtendedPromise.Promise.race(args);
                    };
                    ExtendedPromise.reject = function(arg) {
                        return ExtendedPromise.Promise.reject(arg);
                    };
                    ExtendedPromise.resolve = function(arg) {
                        return ExtendedPromise.Promise.resolve(arg);
                    };
                    ExtendedPromise.prototype.then = function() {
                        var _a;
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        return (_a = this._promise).then.apply(_a, args);
                    };
                    ExtendedPromise.prototype["catch"] = function() {
                        var _a;
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        return (_a = this._promise)["catch"].apply(_a, args);
                    };
                    ExtendedPromise.prototype.resolve = function(arg) {
                        var _this = this;
                        if (this.isFulfilled) return this;
                        this._setResolved();
                        ExtendedPromise.Promise.resolve().then(function() {
                            return _this._onResolve(arg);
                        }).then(function(argForResolveFunction) {
                            _this._resolveFunction(argForResolveFunction);
                        })["catch"](function(err) {
                            _this._resetState();
                            _this.reject(err);
                        });
                        return this;
                    };
                    ExtendedPromise.prototype.reject = function(arg) {
                        var _this = this;
                        if (this.isFulfilled) return this;
                        this._setRejected();
                        ExtendedPromise.Promise.resolve().then(function() {
                            return _this._onReject(arg);
                        }).then(function(result) {
                            _this._setResolved();
                            _this._resolveFunction(result);
                        })["catch"](function(err) {
                            return _this._rejectFunction(err);
                        });
                        return this;
                    };
                    ExtendedPromise.prototype._resetState = function() {
                        this.isFulfilled = false;
                        this.isResolved = false;
                        this.isRejected = false;
                    };
                    ExtendedPromise.prototype._setResolved = function() {
                        this.isFulfilled = true;
                        this.isResolved = true;
                        this.isRejected = false;
                    };
                    ExtendedPromise.prototype._setRejected = function() {
                        this.isFulfilled = true;
                        this.isResolved = false;
                        this.isRejected = true;
                    };
                    ExtendedPromise.Promise = GlobalPromise;
                    return ExtendedPromise;
                }();
                module1.exports = ExtendedPromise;
            },
            {}
        ],
        32: [
            function(_dereq_, module1, exports) {
                "use strict";
                var set_attributes_1 = _dereq_("./lib/set-attributes");
                var default_attributes_1 = _dereq_("./lib/default-attributes");
                var assign_1 = _dereq_("./lib/assign");
                module1.exports = function createFrame(options) {
                    if (options === void 0) options = {};
                    var iframe = document.createElement("iframe");
                    var config = (0, assign_1.assign)({}, default_attributes_1.defaultAttributes, options);
                    if (config.style && typeof config.style !== "string") {
                        (0, assign_1.assign)(iframe.style, config.style);
                        delete config.style;
                    }
                    (0, set_attributes_1.setAttributes)(iframe, config);
                    if (!iframe.getAttribute("id")) iframe.id = iframe.name;
                    return iframe;
                };
            },
            {
                "./lib/assign": 33,
                "./lib/default-attributes": 34,
                "./lib/set-attributes": 35
            }
        ],
        33: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.assign = void 0;
                function assign(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                target) {
                    var objs = [];
                    for(var _i = 1; _i < arguments.length; _i++)objs[_i - 1] = arguments[_i];
                    objs.forEach(function(obj) {
                        if (typeof obj !== "object") return;
                        Object.keys(obj).forEach(function(key) {
                            target[key] = obj[key];
                        });
                    });
                    return target;
                }
                exports.assign = assign;
            },
            {}
        ],
        34: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultAttributes = void 0;
                exports.defaultAttributes = {
                    src: "about:blank",
                    frameBorder: 0,
                    allowtransparency: true,
                    scrolling: "no"
                };
            },
            {}
        ],
        35: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setAttributes = void 0;
                function setAttributes(element, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                attributes) {
                    for(var key in attributes)if (attributes.hasOwnProperty(key)) {
                        var value = attributes[key];
                        if (value == null) element.removeAttribute(key);
                        else element.setAttribute(key, value);
                    }
                }
                exports.setAttributes = setAttributes;
            },
            {}
        ],
        36: [
            function(_dereq_, module1, exports) {
                "use strict";
                function uuid() {
                    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                        var r = Math.random() * 16 | 0;
                        var v = c === "x" ? r : r & 0x3 | 0x8;
                        return v.toString(16);
                    });
                }
                module1.exports = uuid;
            },
            {}
        ],
        37: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                function deferred(fn) {
                    return function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        setTimeout(function() {
                            try {
                                fn.apply(void 0, args);
                            } catch (err) {
                                /* eslint-disable no-console */ console.log("Error in callback function");
                                console.log(err);
                            /* eslint-enable no-console */ }
                        }, 1);
                    };
                }
                exports.deferred = deferred;
            },
            {}
        ],
        38: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                function once(fn) {
                    var called = false;
                    return function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        if (!called) {
                            called = true;
                            fn.apply(void 0, args);
                        }
                    };
                }
                exports.once = once;
            },
            {}
        ],
        39: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable consistent-return */ function promiseOrCallback(promise, callback) {
                    if (!callback) return promise;
                    promise.then(function(data) {
                        return callback(null, data);
                    })["catch"](function(err) {
                        return callback(err);
                    });
                }
                exports.promiseOrCallback = promiseOrCallback;
            },
            {}
        ],
        40: [
            function(_dereq_, module1, exports) {
                "use strict";
                var deferred_1 = _dereq_("./lib/deferred");
                var once_1 = _dereq_("./lib/once");
                var promise_or_callback_1 = _dereq_("./lib/promise-or-callback");
                function wrapPromise(fn) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    return function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        var callback;
                        var lastArg = args[args.length - 1];
                        if (typeof lastArg === "function") {
                            callback = args.pop();
                            callback = once_1.once(deferred_1.deferred(callback));
                        }
                        // I know, I know, this looks bad. But it's a quirk of the library that
                        // we need to allow passing the this context to the original function
                        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                        // @ts-ignore: this has an implicit any
                        return promise_or_callback_1.promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
                    };
                }
                wrapPromise.wrapPrototype = function(target, options) {
                    if (options === void 0) options = {};
                    var ignoreMethods = options.ignoreMethods || [];
                    var includePrivateMethods = options.transformPrivateMethods === true;
                    var methods = Object.getOwnPropertyNames(target.prototype).filter(function(method) {
                        var isNotPrivateMethod;
                        var isNonConstructorFunction = method !== "constructor" && typeof target.prototype[method] === "function";
                        var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;
                        if (includePrivateMethods) isNotPrivateMethod = true;
                        else isNotPrivateMethod = method.charAt(0) !== "_";
                        return isNonConstructorFunction && isNotPrivateMethod && isNotAnIgnoredMethod;
                    });
                    methods.forEach(function(method) {
                        var original = target.prototype[method];
                        target.prototype[method] = wrapPromise(original);
                    });
                    return target;
                };
                module1.exports = wrapPromise;
            },
            {
                "./lib/deferred": 37,
                "./lib/once": 38,
                "./lib/promise-or-callback": 39
            }
        ],
        41: [
            function(_dereq_, module1, exports) {
                (function(global, factory) {
                    typeof exports === "object" && typeof module1 !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define([
                        "exports"
                    ], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global.loadAxo = {}));
                })(this, function(exports) {
                    "use strict";
                    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ function __awaiter(thisArg, _arguments, P, generator) {
                        function adopt(value) {
                            return value instanceof P ? value : new P(function(resolve) {
                                resolve(value);
                            });
                        }
                        return new (P || (P = Promise))(function(resolve, reject) {
                            function fulfilled(value) {
                                try {
                                    step(generator.next(value));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                            function rejected(value) {
                                try {
                                    step(generator["throw"](value));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                            function step(result) {
                                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                            }
                            step((generator = generator.apply(thisArg, _arguments || [])).next());
                        });
                    }
                    function __generator(thisArg, body) {
                        var _ = {
                            label: 0,
                            sent: function sent() {
                                if (t[0] & 1) throw t[1];
                                return t[1];
                            },
                            trys: [],
                            ops: []
                        }, f, y, t, g;
                        return g = {
                            next: verb(0),
                            "throw": verb(1),
                            "return": verb(2)
                        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                            return this;
                        }), g;
                        function verb(n) {
                            return function(v) {
                                return step([
                                    n,
                                    v
                                ]);
                            };
                        }
                        function step(op) {
                            if (f) throw new TypeError("Generator is already executing.");
                            while(_)try {
                                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                                if (y = 0, t) op = [
                                    op[0] & 2,
                                    t.value
                                ];
                                switch(op[0]){
                                    case 0:
                                    case 1:
                                        t = op;
                                        break;
                                    case 4:
                                        _.label++;
                                        return {
                                            value: op[1],
                                            done: false
                                        };
                                    case 5:
                                        _.label++;
                                        y = op[1];
                                        op = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        op = _.ops.pop();
                                        _.trys.pop();
                                        continue;
                                    default:
                                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                            _ = 0;
                                            continue;
                                        }
                                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                            _.label = op[1];
                                            break;
                                        }
                                        if (op[0] === 6 && _.label < t[1]) {
                                            _.label = t[1];
                                            t = op;
                                            break;
                                        }
                                        if (t && _.label < t[2]) {
                                            _.label = t[2];
                                            _.ops.push(op);
                                            break;
                                        }
                                        if (t[2]) _.ops.pop();
                                        _.trys.pop();
                                        continue;
                                }
                                op = body.call(thisArg, _);
                            } catch (e) {
                                op = [
                                    6,
                                    e
                                ];
                                y = 0;
                            } finally{
                                f = t = 0;
                            }
                            if (op[0] & 5) throw op[1];
                            return {
                                value: op[0] ? op[1] : void 0,
                                done: true
                            };
                        }
                    }
                    var dist = {};
                    var scriptPromiseCache = {};
                    function loadScript$1(options) {
                        var scriptLoadPromise;
                        var stringifiedOptions = JSON.stringify(options);
                        if (!options.forceScriptReload) {
                            scriptLoadPromise = scriptPromiseCache[stringifiedOptions];
                            if (scriptLoadPromise) return scriptLoadPromise;
                        }
                        var script = document.createElement("script");
                        var attrs = options.dataAttributes || {};
                        var container = options.container || document.head;
                        script.src = options.src;
                        script.id = options.id || "";
                        script.async = true;
                        if (options.type) script.setAttribute("type", "".concat(options.type));
                        if (options.crossorigin) script.setAttribute("crossorigin", "".concat(options.crossorigin));
                        Object.keys(attrs).forEach(function(key) {
                            script.setAttribute("data-".concat(key), "".concat(attrs[key]));
                        });
                        scriptLoadPromise = new Promise(function(resolve, reject) {
                            script.addEventListener("load", function() {
                                resolve(script);
                            });
                            script.addEventListener("error", function() {
                                reject(new Error("".concat(options.src, " failed to load.")));
                            });
                            script.addEventListener("abort", function() {
                                reject(new Error("".concat(options.src, " has aborted.")));
                            });
                            container.appendChild(script);
                        });
                        scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
                        return scriptLoadPromise;
                    }
                    loadScript$1.clearCache = function() {
                        scriptPromiseCache = {};
                    };
                    var loadScript_1$1 = loadScript$1;
                    var loadStylesheet$1 = function loadStylesheet(options) {
                        var stylesheet = document.querySelector('link[href="'.concat(options.href, '"]'));
                        if (stylesheet) return Promise.resolve(stylesheet);
                        stylesheet = document.createElement("link");
                        var container = options.container || document.head;
                        stylesheet.setAttribute("rel", "stylesheet");
                        stylesheet.setAttribute("type", "text/css");
                        stylesheet.setAttribute("href", options.href);
                        stylesheet.setAttribute("id", options.id);
                        if (container.firstChild) container.insertBefore(stylesheet, container.firstChild);
                        else container.appendChild(stylesheet);
                        return Promise.resolve(stylesheet);
                    };
                    Object.defineProperty(dist, "__esModule", {
                        value: true
                    });
                    dist.loadStylesheet = loadScript_1 = dist.loadScript = void 0;
                    var loadScript = loadScript_1$1;
                    var loadScript_1 = dist.loadScript = loadScript;
                    var loadStylesheet = loadStylesheet$1;
                    dist.loadStylesheet = loadStylesheet;
                    var CDNX_PROD = "https://www.paypalobjects.com";
                    var ASSET_NAME = {
                        minified: "axo.min",
                        unminified: "axo"
                    };
                    var FL_NAMESPACE = "fastlane";
                    var ASSET_PATH = "connect-boba";
                    var LOCALE_PATH = "".concat(ASSET_PATH, "/locales/");
                    var constants = {
                        AXO_ASSET_NAME: ASSET_NAME,
                        AXO_ASSET_PATH: ASSET_PATH,
                        LOCALE_PATH: LOCALE_PATH,
                        CDNX_PROD: CDNX_PROD
                    };
                    var AxoSupportedPlatforms = {
                        BT: "BT",
                        PPCP: "PPCP"
                    };
                    /**
     * Checks if the current environment is an AMD environment.
     *
     * @returns {boolean} True if the environment is AMD, false otherwise.
     */ function isAmdEnv() {
                        return typeof window.define === "function" && !!window.define.amd;
                    }
                    /**
     * Checks if the current environment is a RequireJS environment.
     *
     * @returns {boolean} True if the environment is RequireJS, false otherwise.
     */ function isRequireJsEnv() {
                        return isAmdEnv() && typeof window.requirejs === "function" && typeof window.requirejs.config === "function";
                    }
                    /**
     * Safely loads BT modules by checking if the module already exists and verifying if versions mismatch
     *
     * @param loadConfig <BtModuleLoadConfig> Configuration of BT Module to load
     * @param version <string> version that should be passed from the client getVersion
     * @returns Promise<HTMLScriptElement>
     * @returns Promise<true> when BT module with same version already exists
     * @returns Promise.reject(err) when BT module already exists but versions mismatch or empty version passed in
     */ function safeLoadBtModule(loadConfig, version, minified) {
                        var _a, _b;
                        if (minified === void 0) minified = true;
                        return __awaiter(this, void 0, void 0, function() {
                            var bt, existingVersion;
                            return __generator(this, function(_c) {
                                bt = getBraintree();
                                if (bt && bt[loadConfig.module]) {
                                    if (version && ((_a = bt[loadConfig.module]) === null || _a === void 0 ? void 0 : _a.VERSION) !== version) {
                                        existingVersion = (_b = bt[loadConfig.module]) === null || _b === void 0 ? void 0 : _b.VERSION;
                                        throw new Error("".concat(loadConfig.module, " already loaded with version ").concat(existingVersion, " cannot load version ").concat(version));
                                    } else return [
                                        2 /*return*/ ,
                                        true
                                    ];
                                }
                                if (!version) throw new Error("Attempted to load ".concat(loadConfig.module, " without specifying version"));
                                return [
                                    2 /*return*/ ,
                                    loadBtModule(loadConfig, version, minified)
                                ];
                            });
                        });
                    }
                    /**
     * Reads the version and to load the correct version of Bt module
     *
     * @param loadConfig <BtModuleLoadConfig> Configuration of BT Module to load
     * @param version <string> Bt module version
     * @returns Promise<HTMLScriptElement> or
     */ function loadBtModule(loadConfig, version, minified) {
                        if (minified === void 0) minified = true;
                        if (isAmdEnv()) {
                            var module_1 = minified ? loadConfig.amdModule.minified : loadConfig.amdModule.unminified;
                            return new Promise(function(resolve, reject) {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                window.require([
                                    module_1
                                ], resolve, reject);
                            });
                        }
                        var script = minified ? loadConfig.script.minified : loadConfig.script.unminified;
                        return loadScript_1({
                            id: "".concat(loadConfig.id, "-").concat(version),
                            src: "https://js.braintreegateway.com/web/".concat(version, "/js/").concat(script)
                        });
                    }
                    /**
     * Looks for the Braintree web sdk on the window object
     *
     * @returns Braintree web sdk
     */ function getBraintree() {
                        return window === null || window === void 0 ? void 0 : window.braintree;
                    }
                    var _a, _b;
                    /**
     * Maps to the BT module namespace created on the window.braintree object
     */ var BtModule = {
                        Client: "client",
                        HostedCardFields: "hostedFields"
                    };
                    var BT_NAMESPACE = "braintree";
                    var BT_ASSET_NAME = (_a = {}, _a[BtModule.Client] = "client", _a[BtModule.HostedCardFields] = "hosted-fields", _a);
                    var btModulesLoadConfig = (_b = {}, _b[BtModule.Client] = {
                        id: "client",
                        module: BtModule.Client,
                        amdModule: {
                            unminified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.Client]),
                            minified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.Client], ".min")
                        },
                        script: {
                            unminified: "".concat(BT_ASSET_NAME[BtModule.Client], ".js"),
                            minified: "".concat(BT_ASSET_NAME[BtModule.Client], ".min.js")
                        }
                    }, _b[BtModule.HostedCardFields] = {
                        id: "hcf",
                        module: BtModule.HostedCardFields,
                        amdModule: {
                            unminified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.HostedCardFields]),
                            minified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".min")
                        },
                        script: {
                            unminified: "".concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".js"),
                            minified: "".concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".min.js")
                        }
                    }, _b);
                    /**
     * Loads accelerated checkout components.
     * @param options object with a minified parameter to determine if the script that is loaded should be minified or not (defaults to true if)
     * @returns an object with metadata with a localeUrl parameter to be read by AXO SDK
     */ function loadAxo(options) {
                        return __awaiter(this, void 0, void 0, function() {
                            var btSdkVersion, minified, assetUrl, localeUrl;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        performance.mark("pp_axo_sdk_init_invoked");
                                        btSdkVersion = options.btSdkVersion, minified = options.minified;
                                        assetUrl = getAssetsUrl(options);
                                        localeUrl = getLocaleUrl(options);
                                        if (!(options.platform === AxoSupportedPlatforms.BT)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            Promise.all([
                                                safeLoadBtModule(btModulesLoadConfig.hostedFields, btSdkVersion, minified),
                                                loadAXOScript(assetUrl, minified)
                                            ])
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                    case 2:
                                        if (!(options.platform === AxoSupportedPlatforms.PPCP)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            Promise.all([
                                                safeLoadBtModule(btModulesLoadConfig.client, btSdkVersion, minified),
                                                safeLoadBtModule(btModulesLoadConfig.hostedFields, btSdkVersion, minified),
                                                loadAXOScript(assetUrl, minified)
                                            ])
                                        ];
                                    case 3:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                    case 4:
                                        throw new Error("unsupported axo platform");
                                    case 5:
                                        return [
                                            2 /*return*/ ,
                                            {
                                                metadata: {
                                                    localeUrl: localeUrl
                                                }
                                            }
                                        ];
                                }
                            });
                        });
                    }
                    /**
     * Reads the url and to load the axo bundle script
     * @param url (Required) string url for the correct axo asset
     * @returns Promise<HTMLScriptElement>
     */ function loadAXOScript(url, minified) {
                        var _a;
                        if (minified === void 0) minified = true;
                        if (isAmdEnv()) {
                            // AMD environment
                            if (isRequireJsEnv()) // Let's configure RequireJS
                            requirejs.config({
                                paths: (_a = {}, _a[FL_NAMESPACE] = url, _a)
                            });
                            var moduleName_1 = "".concat(FL_NAMESPACE, "/").concat(minified ? constants.AXO_ASSET_NAME.minified : constants.AXO_ASSET_NAME.unminified);
                            return new Promise(function(resolve, reject) {
                                window.require([
                                    moduleName_1
                                ], resolve, reject);
                            });
                        }
                        // Not an AMD environment
                        return loadScript_1({
                            id: "axo-id",
                            src: url,
                            forceScriptReload: true
                        });
                    }
                    /**
     * Prepends the domain to the asset url
     * @param options object with assetUrl and bundleid parameters to determine which URL to return
     * @returns full domain and assets URL as string
     */ function generateAssetUrl(_a) {
                        var assetUrl = _a.assetUrl, bundleId = _a.bundleId;
                        return bundleId ? "https://cdn-".concat(bundleId, ".static.engineering.dev.paypalinc.com/").concat(assetUrl) : "".concat(constants.CDNX_PROD, "/").concat(assetUrl);
                    }
                    /**
     * Retrieves either the minified or unminified assets URL as specified
     * @param options (Optional) object with a minified and metadata with bundleIdOverride parameters to determine which URL to return
     * @returns assets URL as string
     */ function getAssetsUrl(options) {
                        var _a;
                        var assetName = (options === null || options === void 0 ? void 0 : options.minified) !== false ? constants.AXO_ASSET_NAME.minified : constants.AXO_ASSET_NAME.unminified;
                        var assetUrl = isAmdEnv() ? constants.AXO_ASSET_PATH : "".concat(constants.AXO_ASSET_PATH, "/").concat(assetName, ".js");
                        return generateAssetUrl({
                            assetUrl: assetUrl,
                            bundleId: (_a = options === null || options === void 0 ? void 0 : options.metadata) === null || _a === void 0 ? void 0 : _a.bundleIdOverride
                        });
                    }
                    /**
     * Retrieves the Locales URL, the path to our language files
     * @param options (Optional) object with a minified and metadata with bundleIdOverride parameters to determine which URL to return
     * @returns locale URL as string
     */ function getLocaleUrl(options) {
                        var _a;
                        return generateAssetUrl({
                            assetUrl: constants.LOCALE_PATH,
                            bundleId: (_a = options === null || options === void 0 ? void 0 : options.metadata) === null || _a === void 0 ? void 0 : _a.bundleIdOverride
                        });
                    }
                    exports.constants = constants;
                    exports.loadAxo = loadAxo;
                });
            },
            {}
        ],
        42: [
            function(_dereq_, module1, exports) {
                "use strict";
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var cardTypes = _dereq_("./lib/card-types");
                var add_matching_cards_to_results_1 = _dereq_("./lib/add-matching-cards-to-results");
                var is_valid_input_type_1 = _dereq_("./lib/is-valid-input-type");
                var find_best_match_1 = _dereq_("./lib/find-best-match");
                var clone_1 = _dereq_("./lib/clone");
                var customCards = {};
                var cardNames = {
                    VISA: "visa",
                    MASTERCARD: "mastercard",
                    AMERICAN_EXPRESS: "american-express",
                    DINERS_CLUB: "diners-club",
                    DISCOVER: "discover",
                    JCB: "jcb",
                    UNIONPAY: "unionpay",
                    MAESTRO: "maestro",
                    ELO: "elo",
                    MIR: "mir",
                    HIPER: "hiper",
                    HIPERCARD: "hipercard"
                };
                var ORIGINAL_TEST_ORDER = [
                    cardNames.VISA,
                    cardNames.MASTERCARD,
                    cardNames.AMERICAN_EXPRESS,
                    cardNames.DINERS_CLUB,
                    cardNames.DISCOVER,
                    cardNames.JCB,
                    cardNames.UNIONPAY,
                    cardNames.MAESTRO,
                    cardNames.ELO,
                    cardNames.MIR,
                    cardNames.HIPER,
                    cardNames.HIPERCARD
                ];
                var testOrder = (0, clone_1.clone)(ORIGINAL_TEST_ORDER);
                function findType(cardType) {
                    return customCards[cardType] || cardTypes[cardType];
                }
                function getAllCardTypes() {
                    return testOrder.map(function(cardType) {
                        return (0, clone_1.clone)(findType(cardType));
                    });
                }
                function getCardPosition(name, ignoreErrorForNotExisting) {
                    if (ignoreErrorForNotExisting === void 0) ignoreErrorForNotExisting = false;
                    var position = testOrder.indexOf(name);
                    if (!ignoreErrorForNotExisting && position === -1) throw new Error('"' + name + '" is not a supported card type.');
                    return position;
                }
                function creditCardType(cardNumber) {
                    var results = [];
                    if (!(0, is_valid_input_type_1.isValidInputType)(cardNumber)) return results;
                    if (cardNumber.length === 0) return getAllCardTypes();
                    testOrder.forEach(function(cardType) {
                        var cardConfiguration = findType(cardType);
                        (0, add_matching_cards_to_results_1.addMatchingCardsToResults)(cardNumber, cardConfiguration, results);
                    });
                    var bestMatch = (0, find_best_match_1.findBestMatch)(results);
                    if (bestMatch) return [
                        bestMatch
                    ];
                    return results;
                }
                creditCardType.getTypeInfo = function(cardType) {
                    return (0, clone_1.clone)(findType(cardType));
                };
                creditCardType.removeCard = function(name) {
                    var position = getCardPosition(name);
                    testOrder.splice(position, 1);
                };
                creditCardType.addCard = function(config) {
                    var existingCardPosition = getCardPosition(config.type, true);
                    customCards[config.type] = config;
                    if (existingCardPosition === -1) testOrder.push(config.type);
                };
                creditCardType.updateCard = function(cardType, updates) {
                    var originalObject = customCards[cardType] || cardTypes[cardType];
                    if (!originalObject) throw new Error('"'.concat(cardType, "\" is not a recognized type. Use `addCard` instead.'"));
                    if (updates.type && originalObject.type !== updates.type) throw new Error("Cannot overwrite type parameter.");
                    var clonedCard = (0, clone_1.clone)(originalObject);
                    clonedCard = __assign(__assign({}, clonedCard), updates);
                    customCards[clonedCard.type] = clonedCard;
                };
                creditCardType.changeOrder = function(name, position) {
                    var currentPosition = getCardPosition(name);
                    testOrder.splice(currentPosition, 1);
                    testOrder.splice(position, 0, name);
                };
                creditCardType.resetModifications = function() {
                    testOrder = (0, clone_1.clone)(ORIGINAL_TEST_ORDER);
                    customCards = {};
                };
                creditCardType.types = cardNames;
                module1.exports = creditCardType;
            },
            {
                "./lib/add-matching-cards-to-results": 43,
                "./lib/card-types": 44,
                "./lib/clone": 45,
                "./lib/find-best-match": 46,
                "./lib/is-valid-input-type": 47
            }
        ],
        43: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addMatchingCardsToResults = void 0;
                var clone_1 = _dereq_("./clone");
                var matches_1 = _dereq_("./matches");
                function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
                    var i, patternLength;
                    for(i = 0; i < cardConfiguration.patterns.length; i++){
                        var pattern = cardConfiguration.patterns[i];
                        if (!(0, matches_1.matches)(cardNumber, pattern)) continue;
                        var clonedCardConfiguration = (0, clone_1.clone)(cardConfiguration);
                        if (Array.isArray(pattern)) patternLength = String(pattern[0]).length;
                        else patternLength = String(pattern).length;
                        if (cardNumber.length >= patternLength) clonedCardConfiguration.matchStrength = patternLength;
                        results.push(clonedCardConfiguration);
                        break;
                    }
                }
                exports.addMatchingCardsToResults = addMatchingCardsToResults;
            },
            {
                "./clone": 45,
                "./matches": 48
            }
        ],
        44: [
            function(_dereq_, module1, exports) {
                "use strict";
                var cardTypes = {
                    visa: {
                        niceType: "Visa",
                        type: "visa",
                        patterns: [
                            4
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            16,
                            18,
                            19
                        ],
                        code: {
                            name: "CVV",
                            size: 3
                        }
                    },
                    mastercard: {
                        niceType: "Mastercard",
                        type: "mastercard",
                        patterns: [
                            [
                                51,
                                55
                            ],
                            [
                                2221,
                                2229
                            ],
                            [
                                223,
                                229
                            ],
                            [
                                23,
                                26
                            ],
                            [
                                270,
                                271
                            ],
                            2720
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            16
                        ],
                        code: {
                            name: "CVC",
                            size: 3
                        }
                    },
                    "american-express": {
                        niceType: "American Express",
                        type: "american-express",
                        patterns: [
                            34,
                            37
                        ],
                        gaps: [
                            4,
                            10
                        ],
                        lengths: [
                            15
                        ],
                        code: {
                            name: "CID",
                            size: 4
                        }
                    },
                    "diners-club": {
                        niceType: "Diners Club",
                        type: "diners-club",
                        patterns: [
                            [
                                300,
                                305
                            ],
                            36,
                            38,
                            39
                        ],
                        gaps: [
                            4,
                            10
                        ],
                        lengths: [
                            14,
                            16,
                            19
                        ],
                        code: {
                            name: "CVV",
                            size: 3
                        }
                    },
                    discover: {
                        niceType: "Discover",
                        type: "discover",
                        patterns: [
                            6011,
                            [
                                644,
                                649
                            ],
                            65
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            16,
                            19
                        ],
                        code: {
                            name: "CID",
                            size: 3
                        }
                    },
                    jcb: {
                        niceType: "JCB",
                        type: "jcb",
                        patterns: [
                            2131,
                            1800,
                            [
                                3528,
                                3589
                            ]
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            16,
                            17,
                            18,
                            19
                        ],
                        code: {
                            name: "CVV",
                            size: 3
                        }
                    },
                    unionpay: {
                        niceType: "UnionPay",
                        type: "unionpay",
                        patterns: [
                            620,
                            [
                                62100,
                                62182
                            ],
                            [
                                62184,
                                62187
                            ],
                            [
                                62185,
                                62197
                            ],
                            [
                                62200,
                                62205
                            ],
                            [
                                622010,
                                622999
                            ],
                            622018,
                            [
                                62207,
                                62209
                            ],
                            [
                                623,
                                626
                            ],
                            6270,
                            6272,
                            6276,
                            [
                                627700,
                                627779
                            ],
                            [
                                627781,
                                627799
                            ],
                            [
                                6282,
                                6289
                            ],
                            6291,
                            6292,
                            810,
                            [
                                8110,
                                8131
                            ],
                            [
                                8132,
                                8151
                            ],
                            [
                                8152,
                                8163
                            ],
                            [
                                8164,
                                8171
                            ]
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            14,
                            15,
                            16,
                            17,
                            18,
                            19
                        ],
                        code: {
                            name: "CVN",
                            size: 3
                        }
                    },
                    maestro: {
                        niceType: "Maestro",
                        type: "maestro",
                        patterns: [
                            493698,
                            [
                                500000,
                                504174
                            ],
                            [
                                504176,
                                506698
                            ],
                            [
                                506779,
                                508999
                            ],
                            [
                                56,
                                59
                            ],
                            63,
                            67,
                            6
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            12,
                            13,
                            14,
                            15,
                            16,
                            17,
                            18,
                            19
                        ],
                        code: {
                            name: "CVC",
                            size: 3
                        }
                    },
                    elo: {
                        niceType: "Elo",
                        type: "elo",
                        patterns: [
                            401178,
                            401179,
                            438935,
                            457631,
                            457632,
                            431274,
                            451416,
                            457393,
                            504175,
                            [
                                506699,
                                506778
                            ],
                            [
                                509000,
                                509999
                            ],
                            627780,
                            636297,
                            636368,
                            [
                                650031,
                                650033
                            ],
                            [
                                650035,
                                650051
                            ],
                            [
                                650405,
                                650439
                            ],
                            [
                                650485,
                                650538
                            ],
                            [
                                650541,
                                650598
                            ],
                            [
                                650700,
                                650718
                            ],
                            [
                                650720,
                                650727
                            ],
                            [
                                650901,
                                650978
                            ],
                            [
                                651652,
                                651679
                            ],
                            [
                                655000,
                                655019
                            ],
                            [
                                655021,
                                655058
                            ]
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            16
                        ],
                        code: {
                            name: "CVE",
                            size: 3
                        }
                    },
                    mir: {
                        niceType: "Mir",
                        type: "mir",
                        patterns: [
                            [
                                2200,
                                2204
                            ]
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            16,
                            17,
                            18,
                            19
                        ],
                        code: {
                            name: "CVP2",
                            size: 3
                        }
                    },
                    hiper: {
                        niceType: "Hiper",
                        type: "hiper",
                        patterns: [
                            637095,
                            63737423,
                            63743358,
                            637568,
                            637599,
                            637609,
                            637612
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            16
                        ],
                        code: {
                            name: "CVC",
                            size: 3
                        }
                    },
                    hipercard: {
                        niceType: "Hipercard",
                        type: "hipercard",
                        patterns: [
                            606282
                        ],
                        gaps: [
                            4,
                            8,
                            12
                        ],
                        lengths: [
                            16
                        ],
                        code: {
                            name: "CVC",
                            size: 3
                        }
                    }
                };
                module1.exports = cardTypes;
            },
            {}
        ],
        45: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clone = void 0;
                function clone(originalObject) {
                    if (!originalObject) return null;
                    return JSON.parse(JSON.stringify(originalObject));
                }
                exports.clone = clone;
            },
            {}
        ],
        46: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.findBestMatch = void 0;
                function hasEnoughResultsToDetermineBestMatch(results) {
                    var numberOfResultsWithMaxStrengthProperty = results.filter(function(result) {
                        return result.matchStrength;
                    }).length;
                    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */ return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
                }
                function findBestMatch(results) {
                    if (!hasEnoughResultsToDetermineBestMatch(results)) return null;
                    return results.reduce(function(bestMatch, result) {
                        if (!bestMatch) return result;
                        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */ if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) return result;
                        return bestMatch;
                    });
                }
                exports.findBestMatch = findBestMatch;
            },
            {}
        ],
        47: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.isValidInputType = void 0;
                function isValidInputType(cardNumber) {
                    return typeof cardNumber === "string" || cardNumber instanceof String;
                }
                exports.isValidInputType = isValidInputType;
            },
            {}
        ],
        48: [
            function(_dereq_, module1, exports) {
                "use strict";
                /*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.matches = void 0;
                function matchesRange(cardNumber, min, max) {
                    var maxLengthToCheck = String(min).length;
                    var substr = cardNumber.substr(0, maxLengthToCheck);
                    var integerRepresentationOfCardNumber = parseInt(substr, 10);
                    min = parseInt(String(min).substr(0, substr.length), 10);
                    max = parseInt(String(max).substr(0, substr.length), 10);
                    return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
                }
                function matchesPattern(cardNumber, pattern) {
                    pattern = String(pattern);
                    return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
                }
                function matches(cardNumber, pattern) {
                    if (Array.isArray(pattern)) return matchesRange(cardNumber, pattern[0], pattern[1]);
                    return matchesPattern(cardNumber, pattern);
                }
                exports.matches = matches;
            },
            {}
        ],
        49: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Framebus = void 0;
                var lib_1 = _dereq_("./lib");
                var DefaultPromise = typeof window !== "undefined" && window.Promise;
                var Framebus = /** @class */ function() {
                    function Framebus(options) {
                        if (options === void 0) options = {};
                        this.origin = options.origin || "*";
                        this.channel = options.channel || "";
                        this.verifyDomain = options.verifyDomain;
                        // if a targetFrames configuration is not passed in,
                        // the default behavior is to broadcast the payload
                        // to the top level window or to the frame itself.
                        // By default, the broadcast function will loop through
                        // all the known siblings and children of the window.
                        // If a targetFrames array is passed, it will instead
                        // only broadcast to those specified targetFrames
                        this.targetFrames = options.targetFrames || [];
                        this.limitBroadcastToFramesArray = Boolean(options.targetFrames);
                        this.isDestroyed = false;
                        this.listeners = [];
                        this.hasAdditionalChecksForOnListeners = Boolean(this.verifyDomain || this.limitBroadcastToFramesArray);
                    }
                    Framebus.setPromise = function(PromiseGlobal) {
                        Framebus.Promise = PromiseGlobal;
                    };
                    Framebus.target = function(options) {
                        return new Framebus(options);
                    };
                    Framebus.prototype.addTargetFrame = function(frame) {
                        if (!this.limitBroadcastToFramesArray) return;
                        this.targetFrames.push(frame);
                    };
                    Framebus.prototype.include = function(childWindow) {
                        if (childWindow == null) return false;
                        if (childWindow.Window == null) return false;
                        if (childWindow.constructor !== childWindow.Window) return false;
                        lib_1.childWindows.push(childWindow);
                        return true;
                    };
                    Framebus.prototype.target = function(options) {
                        return Framebus.target(options);
                    };
                    Framebus.prototype.emit = function(eventName, data, reply) {
                        if (this.isDestroyed) return false;
                        var origin = this.origin;
                        eventName = this.namespaceEvent(eventName);
                        if ((0, lib_1.isntString)(eventName)) return false;
                        if ((0, lib_1.isntString)(origin)) return false;
                        if (typeof data === "function") {
                            reply = data;
                            data = undefined; // eslint-disable-line no-undefined
                        }
                        var payload = (0, lib_1.packagePayload)(eventName, origin, data, reply);
                        if (!payload) return false;
                        if (this.limitBroadcastToFramesArray) this.targetFramesAsWindows().forEach(function(frame) {
                            (0, lib_1.sendMessage)(frame, payload, origin);
                        });
                        else (0, lib_1.broadcast)(payload, {
                            origin: origin,
                            frame: window.top || window.self
                        });
                        return true;
                    };
                    Framebus.prototype.emitAsPromise = function(eventName, data) {
                        var _this = this;
                        return new Framebus.Promise(function(resolve, reject) {
                            var didAttachListener = _this.emit(eventName, data, function(payload) {
                                resolve(payload);
                            });
                            if (!didAttachListener) reject(new Error('Listener not added for "'.concat(eventName, '"')));
                        });
                    };
                    Framebus.prototype.on = function(eventName, originalHandler) {
                        if (this.isDestroyed) return false;
                        // eslint-disable-next-line @typescript-eslint/no-this-alias
                        var self1 = this;
                        var origin = this.origin;
                        var handler = originalHandler;
                        eventName = this.namespaceEvent(eventName);
                        if ((0, lib_1.subscriptionArgsInvalid)(eventName, handler, origin)) return false;
                        if (this.hasAdditionalChecksForOnListeners) /* eslint-disable no-invalid-this, @typescript-eslint/ban-ts-comment */ handler = function handler() {
                            var args = [];
                            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                            // @ts-ignore
                            if (!self1.passesVerifyDomainCheck(this && this.origin)) return;
                            // @ts-ignore
                            if (!self1.hasMatchingTargetFrame(this && this.source)) return;
                            originalHandler.apply(void 0, args);
                        };
                        this.listeners.push({
                            eventName: eventName,
                            handler: handler,
                            originalHandler: originalHandler
                        });
                        lib_1.subscribers[origin] = lib_1.subscribers[origin] || {};
                        lib_1.subscribers[origin][eventName] = lib_1.subscribers[origin][eventName] || [];
                        lib_1.subscribers[origin][eventName].push(handler);
                        return true;
                    };
                    Framebus.prototype.off = function(eventName, originalHandler) {
                        var handler = originalHandler;
                        if (this.isDestroyed) return false;
                        if (this.verifyDomain) for(var i = 0; i < this.listeners.length; i++){
                            var listener = this.listeners[i];
                            if (listener.originalHandler === originalHandler) handler = listener.handler;
                        }
                        eventName = this.namespaceEvent(eventName);
                        var origin = this.origin;
                        if ((0, lib_1.subscriptionArgsInvalid)(eventName, handler, origin)) return false;
                        var subscriberList = lib_1.subscribers[origin] && lib_1.subscribers[origin][eventName];
                        if (!subscriberList) return false;
                        for(var i = 0; i < subscriberList.length; i++)if (subscriberList[i] === handler) {
                            subscriberList.splice(i, 1);
                            return true;
                        }
                        return false;
                    };
                    Framebus.prototype.teardown = function() {
                        if (this.isDestroyed) return;
                        this.isDestroyed = true;
                        for(var i = 0; i < this.listeners.length; i++){
                            var listener = this.listeners[i];
                            this.off(listener.eventName, listener.handler);
                        }
                        this.listeners.length = 0;
                    };
                    Framebus.prototype.passesVerifyDomainCheck = function(origin) {
                        if (!this.verifyDomain) // always pass this check if no verifyDomain option was set
                        return true;
                        return this.checkOrigin(origin);
                    };
                    Framebus.prototype.targetFramesAsWindows = function() {
                        if (!this.limitBroadcastToFramesArray) return [];
                        return this.targetFrames.map(function(frame) {
                            // we can't pull off the contentWindow
                            // when the iframe is originally added
                            // to the array, because if it is not
                            // in the DOM at that time, it will have
                            // a contentWindow of `null`
                            if (frame instanceof HTMLIFrameElement) return frame.contentWindow;
                            return frame;
                        }).filter(function(win) {
                            // just in case an iframe element
                            // was removed from the DOM
                            // and the contentWindow property
                            // is null
                            return win;
                        });
                    };
                    Framebus.prototype.hasMatchingTargetFrame = function(source) {
                        if (!this.limitBroadcastToFramesArray) // always pass this check if we aren't limiting to the target frames
                        return true;
                        var matchingFrame = this.targetFramesAsWindows().find(function(frame) {
                            return frame === source;
                        });
                        return Boolean(matchingFrame);
                    };
                    Framebus.prototype.checkOrigin = function(postMessageOrigin) {
                        var merchantHost;
                        var a = document.createElement("a");
                        a.href = location.href;
                        if (a.protocol === "https:") merchantHost = a.host.replace(/:443$/, "");
                        else if (a.protocol === "http:") merchantHost = a.host.replace(/:80$/, "");
                        else merchantHost = a.host;
                        var merchantOrigin = a.protocol + "//" + merchantHost;
                        if (merchantOrigin === postMessageOrigin) return true;
                        if (this.verifyDomain) return this.verifyDomain(postMessageOrigin);
                        return true;
                    };
                    Framebus.prototype.namespaceEvent = function(eventName) {
                        if (!this.channel) return eventName;
                        return "".concat(this.channel, ":").concat(eventName);
                    };
                    Framebus.Promise = DefaultPromise;
                    return Framebus;
                }();
                exports.Framebus = Framebus;
            },
            {
                "./lib": 57
            }
        ],
        50: [
            function(_dereq_, module1, exports) {
                "use strict";
                var lib_1 = _dereq_("./lib");
                var framebus_1 = _dereq_("./framebus");
                (0, lib_1.attach)();
                module1.exports = framebus_1.Framebus;
            },
            {
                "./framebus": 49,
                "./lib": 57
            }
        ],
        51: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.detach = exports.attach = void 0;
                var _1 = _dereq_("./");
                var isAttached = false;
                function attach() {
                    if (isAttached || typeof window === "undefined") return;
                    isAttached = true;
                    window.addEventListener("message", _1.onMessage, false);
                }
                exports.attach = attach;
                // removeIf(production)
                function detach() {
                    isAttached = false;
                    window.removeEventListener("message", _1.onMessage, false);
                }
                exports.detach = detach;
            // endRemoveIf(production)
            },
            {
                "./": 57
            }
        ],
        52: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.broadcastToChildWindows = void 0;
                var _1 = _dereq_("./");
                function broadcastToChildWindows(payload, origin, source) {
                    for(var i = _1.childWindows.length - 1; i >= 0; i--){
                        var childWindow = _1.childWindows[i];
                        if (childWindow.closed) _1.childWindows.splice(i, 1);
                        else if (source !== childWindow) (0, _1.broadcast)(payload, {
                            origin: origin,
                            frame: childWindow.top
                        });
                    }
                }
                exports.broadcastToChildWindows = broadcastToChildWindows;
            },
            {
                "./": 57
            }
        ],
        53: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.broadcast = void 0;
                var _1 = _dereq_("./");
                function broadcast(payload, options) {
                    var i = 0;
                    var frameToBroadcastTo;
                    var origin = options.origin, frame = options.frame;
                    try {
                        frame.postMessage(payload, origin);
                        if ((0, _1.hasOpener)(frame) && frame.opener.top !== window.top) broadcast(payload, {
                            origin: origin,
                            frame: frame.opener.top
                        });
                        // previously, our max value was frame.frames.length
                        // but frames.length inherits from window.length
                        // which can be overwritten if a developer does
                        // `var length = value;` outside of a function
                        // scope, it'll prevent us from looping through
                        // all the frames. With this, we loop through
                        // until there are no longer any frames
                        // eslint-disable-next-line no-cond-assign
                        while(frameToBroadcastTo = frame.frames[i]){
                            broadcast(payload, {
                                origin: origin,
                                frame: frameToBroadcastTo
                            });
                            i++;
                        }
                    } catch (_) {
                    /* ignored */ }
                }
                exports.broadcast = broadcast;
            },
            {
                "./": 57
            }
        ],
        54: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.subscribers = exports.childWindows = exports.prefix = void 0;
                exports.prefix = "/*framebus*/";
                exports.childWindows = [];
                exports.subscribers = {};
            },
            {}
        ],
        55: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.dispatch = void 0;
                var _1 = _dereq_("./");
                function dispatch(origin, event, data, reply, e) {
                    if (!_1.subscribers[origin]) return;
                    if (!_1.subscribers[origin][event]) return;
                    var args = [];
                    if (data) args.push(data);
                    if (reply) args.push(reply);
                    for(var i = 0; i < _1.subscribers[origin][event].length; i++)_1.subscribers[origin][event][i].apply(e, args);
                }
                exports.dispatch = dispatch;
            },
            {
                "./": 57
            }
        ],
        56: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.hasOpener = void 0;
                function hasOpener(frame) {
                    if (frame.top !== frame) return false;
                    if (frame.opener == null) return false;
                    if (frame.opener === frame) return false;
                    if (frame.opener.closed === true) return false;
                    return true;
                }
                exports.hasOpener = hasOpener;
            },
            {}
        ],
        57: [
            function(_dereq_, module1, exports) {
                "use strict";
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function get() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(_dereq_("./attach"), exports);
                __exportStar(_dereq_("./broadcast-to-child-windows"), exports);
                __exportStar(_dereq_("./broadcast"), exports);
                __exportStar(_dereq_("./constants"), exports);
                __exportStar(_dereq_("./dispatch"), exports);
                __exportStar(_dereq_("./has-opener"), exports);
                __exportStar(_dereq_("./is-not-string"), exports);
                __exportStar(_dereq_("./message"), exports);
                __exportStar(_dereq_("./package-payload"), exports);
                __exportStar(_dereq_("./send-message"), exports);
                __exportStar(_dereq_("./subscribe-replier"), exports);
                __exportStar(_dereq_("./subscription-args-invalid"), exports);
                __exportStar(_dereq_("./types"), exports);
                __exportStar(_dereq_("./unpack-payload"), exports);
            },
            {
                "./attach": 51,
                "./broadcast": 53,
                "./broadcast-to-child-windows": 52,
                "./constants": 54,
                "./dispatch": 55,
                "./has-opener": 56,
                "./is-not-string": 58,
                "./message": 59,
                "./package-payload": 60,
                "./send-message": 61,
                "./subscribe-replier": 62,
                "./subscription-args-invalid": 63,
                "./types": 64,
                "./unpack-payload": 65
            }
        ],
        58: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.isntString = void 0;
                function isntString(str) {
                    return typeof str !== "string";
                }
                exports.isntString = isntString;
            },
            {}
        ],
        59: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.onMessage = void 0;
                var _1 = _dereq_("./");
                function onMessage(e) {
                    if ((0, _1.isntString)(e.data)) return;
                    var payload = (0, _1.unpackPayload)(e);
                    if (!payload) return;
                    var data = payload.eventData;
                    var reply = payload.reply;
                    (0, _1.dispatch)("*", payload.event, data, reply, e);
                    (0, _1.dispatch)(e.origin, payload.event, data, reply, e);
                    (0, _1.broadcastToChildWindows)(e.data, payload.origin, e.source);
                }
                exports.onMessage = onMessage;
            },
            {
                "./": 57
            }
        ],
        60: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.packagePayload = void 0;
                var _1 = _dereq_("./");
                function packagePayload(event, origin, data, reply) {
                    var packaged;
                    var payload = {
                        event: event,
                        origin: origin
                    };
                    if (typeof reply === "function") payload.reply = (0, _1.subscribeReplier)(reply, origin);
                    payload.eventData = data;
                    try {
                        packaged = _1.prefix + JSON.stringify(payload);
                    } catch (e) {
                        throw new Error("Could not stringify event: ".concat(e.message));
                    }
                    return packaged;
                }
                exports.packagePayload = packagePayload;
            },
            {
                "./": 57
            }
        ],
        61: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.sendMessage = void 0;
                /**
 * A basic function for wrapping the sending of postMessages to frames.
 */ function sendMessage(frame, payload, origin) {
                    try {
                        frame.postMessage(payload, origin);
                    } catch (error) {
                    /* ignored */ }
                }
                exports.sendMessage = sendMessage;
            },
            {}
        ],
        62: [
            function(_dereq_, module1, exports) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.subscribeReplier = void 0;
                var framebus_1 = _dereq_("../framebus");
                var uuid_1 = __importDefault(_dereq_("@braintree/uuid"));
                function subscribeReplier(fn, origin) {
                    var uuid = (0, uuid_1["default"])();
                    function replier(data, replyOriginHandler) {
                        fn(data, replyOriginHandler);
                        framebus_1.Framebus.target({
                            origin: origin
                        }).off(uuid, replier);
                    }
                    framebus_1.Framebus.target({
                        origin: origin
                    }).on(uuid, replier);
                    return uuid;
                }
                exports.subscribeReplier = subscribeReplier;
            },
            {
                "../framebus": 49,
                "@braintree/uuid": 66
            }
        ],
        63: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.subscriptionArgsInvalid = void 0;
                var _1 = _dereq_("./");
                function subscriptionArgsInvalid(event, fn, origin) {
                    if ((0, _1.isntString)(event)) return true;
                    if (typeof fn !== "function") return true;
                    return (0, _1.isntString)(origin);
                }
                exports.subscriptionArgsInvalid = subscriptionArgsInvalid;
            },
            {
                "./": 57
            }
        ],
        64: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            },
            {}
        ],
        65: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.unpackPayload = void 0;
                var _1 = _dereq_("./");
                function unpackPayload(e) {
                    var payload;
                    if (e.data.slice(0, _1.prefix.length) !== _1.prefix) return false;
                    try {
                        payload = JSON.parse(e.data.slice(_1.prefix.length));
                    } catch (err) {
                        return false;
                    }
                    if (payload.reply) {
                        var replyOrigin_1 = e.origin;
                        var replySource_1 = e.source;
                        var replyEvent_1 = payload.reply;
                        payload.reply = function reply(replyData) {
                            if (!replySource_1) return;
                            var replyPayload = (0, _1.packagePayload)(replyEvent_1, replyOrigin_1, replyData);
                            if (!replyPayload) return;
                            replySource_1.postMessage(replyPayload, replyOrigin_1);
                        };
                    }
                    return payload;
                }
                exports.unpackPayload = unpackPayload;
            },
            {
                "./": 57
            }
        ],
        66: [
            function(_dereq_, module1, exports) {
                "use strict";
                function uuid() {
                    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                        var r = Math.random() * 16 | 0;
                        var v = c === "x" ? r : r & 0x3 | 0x8;
                        return v.toString(16);
                    });
                }
                module1.exports = uuid;
            },
            {}
        ],
        67: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.isIos = exports.isIE9 = exports.isSamsungBrowser = exports.isAndroidChrome = exports.isKitKatWebview = void 0;
                // server side rendering check
                var UA = typeof window !== "undefined" && window.navigator && window.navigator.userAgent;
                // TODO remove this when browser detection is converted to typescript
                /* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-ignore
                var isAndroid = _dereq_("@braintree/browser-detection/is-android");
                // @ts-ignore
                var isChromeOs = _dereq_("@braintree/browser-detection/is-chrome-os");
                // @ts-ignore
                var isChrome = _dereq_("@braintree/browser-detection/is-chrome");
                // @ts-ignore
                var isIos = _dereq_("@braintree/browser-detection/is-ios");
                exports.isIos = isIos;
                // @ts-ignore
                var isIE9 = _dereq_("@braintree/browser-detection/is-ie9");
                exports.isIE9 = isIE9;
                /* eslint-enable @typescript-eslint/ban-ts-comment */ // Old Android Webviews used specific versions of Chrome with 0.0.0 as their version suffix
                // https://developer.chrome.com/multidevice/user-agent#webview_user_agent
                var KITKAT_WEBVIEW_REGEX = /Version\/\d\.\d* Chrome\/\d*\.0\.0\.0/;
                function isOldSamsungBrowserOrSamsungWebview(ua) {
                    return !isChrome(ua) && ua.indexOf("Samsung") > -1;
                }
                function isKitKatWebview(ua) {
                    if (ua === void 0) ua = UA;
                    return isAndroid(ua) && KITKAT_WEBVIEW_REGEX.test(ua);
                }
                exports.isKitKatWebview = isKitKatWebview;
                function isAndroidChrome(ua) {
                    if (ua === void 0) ua = UA;
                    return (isAndroid(ua) || isChromeOs(ua)) && isChrome(ua);
                }
                exports.isAndroidChrome = isAndroidChrome;
                function isSamsungBrowser(ua) {
                    if (ua === void 0) ua = UA;
                    return /SamsungBrowser/.test(ua) || isOldSamsungBrowserOrSamsungWebview(ua);
                }
                exports.isSamsungBrowser = isSamsungBrowser;
            },
            {
                "@braintree/browser-detection/is-android": 80,
                "@braintree/browser-detection/is-chrome": 82,
                "@braintree/browser-detection/is-chrome-os": 81,
                "@braintree/browser-detection/is-ie9": 83,
                "@braintree/browser-detection/is-ios": 84
            }
        ],
        68: [
            function(_dereq_, module1, exports) {
                "use strict";
                var device_1 = _dereq_("./lib/device");
                module1.exports = function supportsInputFormatting() {
                    // Digits get dropped in samsung browser
                    return !(0, device_1.isSamsungBrowser)();
                };
            },
            {
                "./lib/device": 67
            }
        ],
        69: [
            function(_dereq_, module1, exports) {
                arguments[4][3][0].apply(exports, arguments);
            },
            {
                dup: 3
            }
        ],
        70: [
            function(_dereq_, module1, exports) {
                arguments[4][4][0].apply(exports, arguments);
            },
            {
                dup: 4
            }
        ],
        71: [
            function(_dereq_, module1, exports) {
                arguments[4][5][0].apply(exports, arguments);
            },
            {
                "./is-duckduckgo": 72,
                "./is-edge": 73,
                "./is-opera": 77,
                "./is-samsung": 78,
                "./is-silk": 79,
                dup: 5
            }
        ],
        72: [
            function(_dereq_, module1, exports) {
                arguments[4][6][0].apply(exports, arguments);
            },
            {
                dup: 6
            }
        ],
        73: [
            function(_dereq_, module1, exports) {
                arguments[4][7][0].apply(exports, arguments);
            },
            {
                dup: 7
            }
        ],
        74: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function isIe9(ua) {
                    ua = ua || window.navigator.userAgent;
                    return ua.indexOf("MSIE 9") !== -1;
                };
            },
            {}
        ],
        75: [
            function(_dereq_, module1, exports) {
                arguments[4][14][0].apply(exports, arguments);
            },
            {
                "./is-ipados": 76,
                dup: 14
            }
        ],
        76: [
            function(_dereq_, module1, exports) {
                arguments[4][15][0].apply(exports, arguments);
            },
            {
                dup: 15
            }
        ],
        77: [
            function(_dereq_, module1, exports) {
                arguments[4][16][0].apply(exports, arguments);
            },
            {
                dup: 16
            }
        ],
        78: [
            function(_dereq_, module1, exports) {
                arguments[4][17][0].apply(exports, arguments);
            },
            {
                dup: 17
            }
        ],
        79: [
            function(_dereq_, module1, exports) {
                arguments[4][18][0].apply(exports, arguments);
            },
            {
                dup: 18
            }
        ],
        80: [
            function(_dereq_, module1, exports) {
                arguments[4][20][0].apply(exports, arguments);
            },
            {
                "./dist/is-android": 69,
                dup: 20
            }
        ],
        81: [
            function(_dereq_, module1, exports) {
                arguments[4][21][0].apply(exports, arguments);
            },
            {
                "./dist/is-chrome-os": 70,
                dup: 21
            }
        ],
        82: [
            function(_dereq_, module1, exports) {
                arguments[4][22][0].apply(exports, arguments);
            },
            {
                "./dist/is-chrome": 71,
                dup: 22
            }
        ],
        83: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/is-ie9");
            },
            {
                "./dist/is-ie9": 74
            }
        ],
        84: [
            function(_dereq_, module1, exports) {
                arguments[4][27][0].apply(exports, arguments);
            },
            {
                "./dist/is-ios": 75,
                dup: 27
            }
        ],
        85: [
            function(_dereq_, module1, exports) {
                module1.exports = _dereq_("./dist/supports-input-formatting");
            },
            {
                "./dist/supports-input-formatting": 68
            }
        ],
        86: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../lib/braintree-error");
                var errors = _dereq_("./errors");
                var assign = _dereq_("../lib/assign").assign;
                var methods = _dereq_("../lib/methods");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @class
 * @param {object} options Options
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/american-express.create|braintree.american-express.create} instead.</strong>
 * @classdesc This class allows you use a nonce to interact with American Express Checkout. To accept American Express cards, use Hosted Fields.
 */ function AmericanExpress(options) {
                    this._client = options.client;
                }
                /**
 * Gets the rewards balance associated with a Braintree nonce.
 * @public
 * @param {object} options Request options
 * @param {string} options.nonce An existing Braintree nonce.
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data. If no callback is provided, `getRewardsBalance` returns a promise that resolves with the server data.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var americanExpress = require('braintree-web/american-express');
 *
 * americanExpress.create({client: clientInstance}, function (createErr, americanExpressInstance) {
 *   var options = {nonce: existingBraintreeNonce};
 *   americanExpressInstance.getRewardsBalance(options, function (getErr, payload) {
 *     if (getErr || payload.error) {
 *       // Handle error
 *       return;
 *     }
 *
 *     console.log('Rewards amount: ' + payload.rewardsAmount);
 *   });
 * });
 */ AmericanExpress.prototype.getRewardsBalance = function(options) {
                    var nonce = options.nonce;
                    var data;
                    if (!nonce) return Promise.reject(new BraintreeError({
                        type: errors.AMEX_NONCE_REQUIRED.type,
                        code: errors.AMEX_NONCE_REQUIRED.code,
                        message: "getRewardsBalance must be called with a nonce."
                    }));
                    data = assign({
                        _meta: {
                            source: "american-express"
                        },
                        paymentMethodNonce: nonce
                    }, options);
                    delete data.nonce;
                    return this._client.request({
                        method: "get",
                        endpoint: "payment_methods/amex_rewards_balance",
                        data: data
                    })["catch"](function(err) {
                        return Promise.reject(new BraintreeError({
                            type: errors.AMEX_NETWORK_ERROR.type,
                            code: errors.AMEX_NETWORK_ERROR.code,
                            message: "A network error occurred when getting the American Express rewards balance.",
                            details: {
                                originalError: err
                            }
                        }));
                    });
                };
                /**
 * Gets the Express Checkout nonce profile given a nonce from American Express.
 * @public
 * @param {object} options Request options
 * @param {string} options.nonce An existing nonce from American Express (note that this is <em>not</em> a nonce from Braintree).
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data. If no callback is provided, `getExpressCheckoutProfile` returns a promise that resolves with the server data.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var americanExpress = require('braintree-web/american-express');
 *
 * americanExpress.create({client: clientInstance}, function (createErr, americanExpressInstance) {
 *   var options = {nonce: existingAmericanExpressNonce};
 *   americanExpressInstance.getExpressCheckoutProfile(options, function (getErr, payload) {
 *     if (getErr) {
 *       // Handle error
 *       return;
 *     }
 *
 *     console.log('Number of cards: ' + payload.amexExpressCheckoutCards.length);
 *   });
 * });
 */ AmericanExpress.prototype.getExpressCheckoutProfile = function(options) {
                    if (!options.nonce) return Promise.reject(new BraintreeError({
                        type: errors.AMEX_NONCE_REQUIRED.type,
                        code: errors.AMEX_NONCE_REQUIRED.code,
                        message: "getExpressCheckoutProfile must be called with a nonce."
                    }));
                    return this._client.request({
                        method: "get",
                        endpoint: "payment_methods/amex_express_checkout_cards/" + options.nonce,
                        data: {
                            _meta: {
                                source: "american-express"
                            },
                            paymentMethodNonce: options.nonce
                        }
                    })["catch"](function(err) {
                        return Promise.reject(new BraintreeError({
                            type: errors.AMEX_NETWORK_ERROR.type,
                            code: errors.AMEX_NETWORK_ERROR.code,
                            message: "A network error occurred when getting the American Express Checkout nonce profile.",
                            details: {
                                originalError: err
                            }
                        }));
                    });
                };
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/american-express.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * americanExpressInstance.teardown();
 * @example <caption>With callback</caption>
 * americanExpressInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ AmericanExpress.prototype.teardown = function() {
                    convertMethodsToError(this, methods(AmericanExpress.prototype));
                    return Promise.resolve();
                };
                module1.exports = wrapPromise.wrapPrototype(AmericanExpress);
            },
            {
                "../lib/assign": 140,
                "../lib/braintree-error": 143,
                "../lib/convert-methods-to-error": 146,
                "../lib/methods": 175,
                "./errors": 87,
                "@braintree/wrap-promise": 40
            }
        ],
        87: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.American Express - getRewardsBalance Error Codes
 * @description Errors that occur when creating components.
 * @property {MERCHANT} AMEX_NONCE_REQUIRED Occurs when a nonce is not provided to method.
 * @property {NETWORK} AMEX_NETWORK_ERROR Occurs when there is an error communicating with the Braintree gateway.
 */ /**
 * @name BraintreeError.American Express - getExpressCheckoutProfile Error Codes
 * @description Errors that occur when creating components.
 * @property {MERCHANT} AMEX_NONCE_REQUIRED Occurs when a nonce is not provided to method.
 * @property {NETWORK} AMEX_NETWORK_ERROR Occurs when there is an error communicating with the Braintree gateway.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    AMEX_NONCE_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "AMEX_NONCE_REQUIRED"
                    },
                    AMEX_NETWORK_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "AMEX_NETWORK_ERROR"
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        88: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/american-express
 * @description This module is for use with Amex Express Checkout. To accept American Express cards, use Hosted Fields.
 */ var AmericanExpress = _dereq_("./american-express");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link AmericanExpress} instance. If no callback is provided, `create` returns a promise that resolves with the {@link AmericanExpress} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "American Express";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        options.client = client;
                        return new AmericanExpress(options);
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./american-express": 86,
                "@braintree/wrap-promise": 40
            }
        ],
        89: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../lib/braintree-error");
                var analytics = _dereq_("../lib/analytics");
                var errors = _dereq_("./errors");
                var methods = _dereq_("../lib/methods");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @typedef {object} ApplePay~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.cardHolderName The name of the card holder.
 * @property {string} details.dpanLastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `ApplePayCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */ /**
 * An Apple Pay Payment Authorization Event object.
 * @typedef {object} ApplePayPaymentAuthorizedEvent
 * @external ApplePayPaymentAuthorizedEvent
 * @see {@link https://developer.apple.com/reference/applepayjs/applepaypaymentauthorizedevent ApplePayPaymentAuthorizedEvent}
 */ /**
 * An Apple Pay Payment Request object.
 * @typedef {object} ApplePayPaymentRequest
 * @external ApplePayPaymentRequest
 * @see {@link https://developer.apple.com/reference/applepayjs/1916082-applepay_js_data_types/paymentrequest PaymentRequest}
 */ /**
 * @class
 * @param {object} options Options
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/apple-pay.create|braintree.applePay.create} instead.</strong>
 * @classdesc This class represents an Apple Pay component. Instances of this class have methods for validating the merchant server and tokenizing payments.
 */ function ApplePay(options) {
                    this._instantiatedWithClient = Boolean(!options.useDeferredClient);
                    this._client = options.client;
                    this._createPromise = options.createPromise;
                    if (this._client) this._setMerchantIdentifier();
                }
                ApplePay.prototype._waitForClient = function() {
                    if (this._client) return Promise.resolve();
                    return this._createPromise.then((function(client) {
                        this._client = client;
                        this._setMerchantIdentifier();
                    }).bind(this));
                };
                ApplePay.prototype._setMerchantIdentifier = function() {
                    var applePayConfig = this._client.getConfiguration().gatewayConfiguration.applePayWeb;
                    if (!applePayConfig) return;
                    /**
   * @name ApplePay#merchantIdentifier
   * @description A special merchant ID which represents the merchant association with Braintree. Required when using `ApplePaySession.canMakePaymentsWithActiveCard`.
   * @example
   * var promise = ApplePaySession.canMakePaymentsWithActiveCard(applePayInstance.merchantIdentifier);
   * promise.then(function (canMakePaymentsWithActiveCard) {
   *   if (canMakePaymentsWithActiveCard) {
   *     // Set up Apple Pay buttons
   *   }
   * });
   */ Object.defineProperty(this, "merchantIdentifier", {
                        value: applePayConfig.merchantIdentifier,
                        configurable: false,
                        writable: false
                    });
                };
                /**
 * Merges a payment request with Braintree defaults to return an {external:ApplePayPaymentRequest}.
 *
 * The following properties are assigned to `paymentRequest` if not already defined. Their default values come from the Braintree gateway.
 * - `countryCode`
 * - `currencyCode`
 * - `merchantCapabilities`
 * - `supportedNetworks`
 * @public
 * @param {external:ApplePayPaymentRequest} paymentRequest The payment request details to apply on top of those from Braintree.
 * @returns {external:ApplePayPaymentRequest|Promise} The decorated `paymentRequest` object. If `useDeferredClient` is used along with an `authorization`, this method will return a promise that resolves with the `paymentRequest` object.
 * @example
 * var applePay = require('braintree-web/apple-pay');
 *
 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
 *   if (applePayErr) {
 *     // Handle error here
 *     return;
 *   }
 *
 *   var paymentRequest = applePayInstance.createPaymentRequest({
 *     total: {
 *       label: 'My Company',
 *       amount: '19.99'
 *     }
 *   });
 *
 *   var session = new ApplePaySession(3, paymentRequest);
 *
 *   // ...
 * @example <caption>With deferred client</caption>
 * var applePay = require('braintree-web/apple-pay');
 *
 * applePay.create({
 *   authorization: 'client-token-or-tokenization-key',
 *   useDeferredClient: true
 * }, function (applePayErr, applePayInstance) {
 *   if (applePayErr) {
 *     // Handle error here
 *     return;
 *   }
 *
 *   applePayInstance.createPaymentRequest({
 *     total: {
 *       label: 'My Company',
 *       amount: '19.99'
 *     }
 *   }).then(function (paymentRequest) {
 *     var session = new ApplePaySession(3, paymentRequest);
 *
 *     // ...
 *   });
 */ ApplePay.prototype.createPaymentRequest = function(paymentRequest) {
                    if (this._instantiatedWithClient) return this._createPaymentRequestSynchronously(paymentRequest);
                    return this._waitForClient().then((function() {
                        return this._createPaymentRequestSynchronously(paymentRequest);
                    }).bind(this));
                };
                ApplePay.prototype._createPaymentRequestSynchronously = function(paymentRequest) {
                    var applePay = this._client.getConfiguration().gatewayConfiguration.applePayWeb;
                    var defaults = {
                        countryCode: applePay.countryCode,
                        currencyCode: applePay.currencyCode,
                        merchantCapabilities: applePay.merchantCapabilities || [
                            "supports3DS"
                        ],
                        supportedNetworks: applePay.supportedNetworks.map(function(network) {
                            return network === "mastercard" ? "masterCard" : network;
                        })
                    };
                    return Object.assign({}, defaults, paymentRequest);
                };
                /**
 * Validates your merchant website, as required by `ApplePaySession` before payment can be authorized.
 * @public
 * @param {object} options Options
 * @param {string} options.validationURL The validationURL from an `ApplePayValidateMerchantEvent`.
 * @param {string} options.displayName The canonical name for your store. Use a non-localized name. This parameter should be a UTF-8 string that is a maximum of 64 characters. The system may display this name to the user.
 * @param {callback} [callback] The second argument, <code>data</code>, is the Apple Pay merchant session object. If no callback is provided, `performValidation` returns a promise.
 * Pass the merchant session to your Apple Pay session's `completeMerchantValidation` method.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var applePay = require('braintree-web/apple-pay');
 *
 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
 *   if (applePayErr) {
 *     // Handle error here
 *     return;
 *   }
 *
 *   var paymentRequest = applePayInstance.createPaymentRequest({
 *     total: {
 *       label: 'My Company',
 *       amount: '19.99'
 *     }
 *   });
 *   var session = new ApplePaySession(3, paymentRequest);
 *
 *   session.onvalidatemerchant = function (event) {
 *     applePayInstance.performValidation({
 *       validationURL: event.validationURL,
 *       displayName: 'My Great Store'
 *     }, function (validationErr, validationData) {
 *       if (validationErr) {
 *         console.error(validationErr);
 *         session.abort();
 *         return;
 *       }
 *
 *       session.completeMerchantValidation(validationData);
 *     });
 *   };
 * });
 */ ApplePay.prototype.performValidation = function(options) {
                    var self1 = this;
                    if (!options || !options.validationURL) return Promise.reject(new BraintreeError(errors.APPLE_PAY_VALIDATION_URL_REQUIRED));
                    return this._waitForClient().then(function() {
                        var applePayWebSession = {
                            validationUrl: options.validationURL,
                            domainName: options.domainName || window.location.hostname,
                            merchantIdentifier: options.merchantIdentifier || self1.merchantIdentifier
                        };
                        if (options.displayName != null) applePayWebSession.displayName = options.displayName;
                        return self1._client.request({
                            method: "post",
                            endpoint: "apple_pay_web/sessions",
                            data: {
                                _meta: {
                                    source: "apple-pay"
                                },
                                applePayWebSession: applePayWebSession
                            }
                        });
                    }).then(function(response) {
                        analytics.sendEvent(self1._client, "applepay.performValidation.succeeded");
                        return Promise.resolve(response);
                    })["catch"](function(err) {
                        analytics.sendEvent(self1._client, "applepay.performValidation.failed");
                        if (err.code === "CLIENT_REQUEST_ERROR") return Promise.reject(new BraintreeError({
                            type: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.type,
                            code: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.code,
                            message: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.message,
                            details: {
                                originalError: err.details.originalError
                            }
                        }));
                        return Promise.reject(new BraintreeError({
                            type: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.type,
                            code: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.code,
                            message: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.message,
                            details: {
                                originalError: err
                            }
                        }));
                    });
                };
                /**
 * Tokenizes an Apple Pay payment. This will likely be called in your `ApplePaySession`'s `onpaymentauthorized` callback.
 * @public
 * @param {object} options Options
 * @param {object} options.token The `payment.token` property of an {@link external:ApplePayPaymentAuthorizedEvent}.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ApplePay~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with a {@link ApplePay~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var applePay = require('braintree-web/apple-pay');
 *
 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
 *   if (applePayErr) {
 *     // Handle error here
 *     return;
 *   }
 *
 *   var paymentRequest = applePayInstance.createPaymentRequest({
 *     total: {
 *       label: 'My Company',
 *       amount: '19.99'
 *     }
 *   });
 *   var session = new ApplePaySession(3, paymentRequest);
 *
 *   session.onpaymentauthorized = function (event) {
 *     applePayInstance.tokenize({
 *       token: event.payment.token
 *     }, function (tokenizeErr, tokenizedPayload) {
 *       if (tokenizeErr) {
 *         session.completePayment(ApplePaySession.STATUS_FAILURE);
 *         return;
 *       }
 *       // Send the tokenizedPayload to your server here!
 *
 *       // Once the transaction is complete, call completePayment
 *       // to close the Apple Pay sheet
 *       session.completePayment(ApplePaySession.STATUS_SUCCESS);
 *     });
 *   };
 *
 *   // ...
 * });
 */ ApplePay.prototype.tokenize = function(options) {
                    var self1 = this;
                    if (!options.token) return Promise.reject(new BraintreeError(errors.APPLE_PAY_PAYMENT_TOKEN_REQUIRED));
                    return this._waitForClient().then(function() {
                        return self1._client.request({
                            method: "post",
                            endpoint: "payment_methods/apple_payment_tokens",
                            data: {
                                _meta: {
                                    source: "apple-pay"
                                },
                                applePaymentToken: Object.assign({}, options.token, {
                                    // The gateway requires this key to be base64-encoded.
                                    paymentData: btoa(JSON.stringify(options.token.paymentData))
                                })
                            }
                        });
                    }).then(function(response) {
                        analytics.sendEvent(self1._client, "applepay.tokenize.succeeded");
                        return Promise.resolve(response.applePayCards[0]);
                    })["catch"](function(err) {
                        analytics.sendEvent(self1._client, "applepay.tokenize.failed");
                        return Promise.reject(new BraintreeError({
                            type: errors.APPLE_PAY_TOKENIZATION.type,
                            code: errors.APPLE_PAY_TOKENIZATION.code,
                            message: errors.APPLE_PAY_TOKENIZATION.message,
                            details: {
                                originalError: err
                            }
                        }));
                    });
                };
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/apple-pay.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * applePayInstance.teardown();
 * @example <caption>With callback</caption>
 * applePayInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ ApplePay.prototype.teardown = function() {
                    convertMethodsToError(this, methods(ApplePay.prototype));
                    return Promise.resolve();
                };
                module1.exports = wrapPromise.wrapPrototype(ApplePay);
            },
            {
                "../lib/analytics": 138,
                "../lib/braintree-error": 143,
                "../lib/convert-methods-to-error": 146,
                "../lib/methods": 175,
                "./errors": 90,
                "@braintree/wrap-promise": 40
            }
        ],
        90: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Apple Pay - Creation Error Codes
 * @description Errors that occur when [creating the Apple Pay component](./module-braintree-web_apple-pay.html#.create).
 * @property {MERCHANT} APPLE_PAY_NOT_ENABLED Occurs when the authorization used is not authorized to process Apple Pay.
 */ /**
 * @name BraintreeError.Apple Pay - performValidation Error Codes
 * @description Errors that occur when [validating](./ApplePay.html#performValidation).
 * @property {MERCHANT} APPLE_PAY_VALIDATION_URL_REQUIRED Occurs when the `validationURL` option is not passed in.
 * @property {MERCHANT} APPLE_PAY_MERCHANT_VALIDATION_FAILED Occurs when the website domain has not been registered in the Braintree control panel.
 * @property {NETWORK} APPLE_PAY_MERCHANT_VALIDATION_NETWORK Occurs when an unknown network error occurs.
 */ /**
 * @name BraintreeError.Apple Pay - tokenize Error Codes
 * @description Errors that occur when [tokenizing](./ApplePay.html#tokenize).
 * @property {MERCHANT} APPLE_PAY_PAYMENT_TOKEN_REQUIRED Occurs when the `token` option is not passed in.
 * @property {NETWORK} APPLE_PAY_TOKENIZATION Occurs when an unknown network error occurs.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    APPLE_PAY_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "APPLE_PAY_NOT_ENABLED",
                        message: "Apple Pay is not enabled for this merchant."
                    },
                    APPLE_PAY_VALIDATION_URL_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "APPLE_PAY_VALIDATION_URL_REQUIRED",
                        message: "performValidation must be called with a validationURL."
                    },
                    APPLE_PAY_MERCHANT_VALIDATION_NETWORK: {
                        type: BraintreeError.types.NETWORK,
                        code: "APPLE_PAY_MERCHANT_VALIDATION_NETWORK",
                        message: "A network error occurred when validating the Apple Pay merchant."
                    },
                    APPLE_PAY_MERCHANT_VALIDATION_FAILED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "APPLE_PAY_MERCHANT_VALIDATION_FAILED",
                        message: "Make sure you have registered your domain name in the Braintree Control Panel."
                    },
                    APPLE_PAY_PAYMENT_TOKEN_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "APPLE_PAY_PAYMENT_TOKEN_REQUIRED",
                        message: "tokenize must be called with a payment token."
                    },
                    APPLE_PAY_TOKENIZATION: {
                        type: BraintreeError.types.NETWORK,
                        code: "APPLE_PAY_TOKENIZATION",
                        message: "A network error occurred when processing the Apple Pay payment."
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        91: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/apple-pay
 * @description Accept Apple Pay on the Web. *This component is currently in beta and is subject to change.*
 */ var ApplePay = _dereq_("./apple-pay");
                var analytics = _dereq_("../lib/analytics");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var errors = _dereq_("./errors");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Apple Pay instance to be available right away by fetching the client configuration in the background. When this option is used, {@link ApplePay#createPaymentRequest} will return a promise that resolves with the configuration instead of returning synchronously.
 * @param {callback} [callback] The second argument, `data`, is the {@link ApplePay} instance. If no callback is provided, `create` returns a promise that resolves with the {@link ApplePay} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "Apple Pay";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        var applePayInstance;
                        var createPromise = createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        }).then(function(client) {
                            if (!client.getConfiguration().gatewayConfiguration.applePayWeb) return Promise.reject(new BraintreeError(errors.APPLE_PAY_NOT_ENABLED));
                            analytics.sendEvent(client, "applepay.initialized");
                            return client;
                        });
                        options.createPromise = createPromise;
                        applePayInstance = new ApplePay(options);
                        if (!options.useDeferredClient) return createPromise.then(function(client) {
                            applePayInstance._client = client;
                            return applePayInstance;
                        });
                        return applePayInstance;
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/analytics": 138,
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./apple-pay": 89,
                "./errors": 90,
                "@braintree/wrap-promise": 40
            }
        ],
        92: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BRAINTREE_VERSION = _dereq_("./constants").BRAINTREE_VERSION;
                var GraphQL = _dereq_("./request/graphql");
                var request = _dereq_("./request");
                var isVerifiedDomain = _dereq_("../lib/is-verified-domain");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var convertToBraintreeError = _dereq_("../lib/convert-to-braintree-error");
                var getGatewayConfiguration = _dereq_("./get-configuration").getConfiguration;
                var createAuthorizationData = _dereq_("../lib/create-authorization-data");
                var metadata = _dereq_("../lib/add-metadata");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var once = _dereq_("../lib/once");
                var deferred = _dereq_("../lib/deferred");
                var assign = _dereq_("../lib/assign").assign;
                var analytics = _dereq_("../lib/analytics");
                var errors = _dereq_("./errors");
                var VERSION = _dereq_("../lib/constants").VERSION;
                var GRAPHQL_URLS = _dereq_("../lib/constants").GRAPHQL_URLS;
                var methods = _dereq_("../lib/methods");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var assets = _dereq_("../lib/assets");
                var FRAUDNET_FNCLS = _dereq_("../lib/constants").FRAUDNET_FNCLS;
                var FRAUDNET_SOURCE = _dereq_("../lib/constants").FRAUDNET_SOURCE;
                var FRAUDNET_URL = _dereq_("../lib/constants").FRAUDNET_URL;
                var cachedClients = {};
                /**
 * This object is returned by {@link Client#getConfiguration|getConfiguration}. This information is used extensively by other Braintree modules to properly configure themselves.
 * @typedef {object} Client~configuration
 * @property {object} client The braintree-web/client parameters.
 * @property {string} client.authorization A tokenizationKey or clientToken.
 * @property {object} gatewayConfiguration Gateway-supplied configuration.
 * @property {object} analyticsMetadata Analytics-specific data.
 * @property {string} analyticsMetadata.sessionId Uniquely identifies a browsing session.
 * @property {string} analyticsMetadata.sdkVersion The braintree.js version.
 * @property {string} analyticsMetadata.merchantAppId Identifies the merchant's web app.
 */ /**
 * @class
 * @param {Client~configuration} configuration Options
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/client.create|braintree.client.create} instead.</strong>
 * @classdesc This class is required by many other Braintree components. It serves as the base API layer that communicates with our servers. It is also capable of being used to formulate direct calls to our servers, such as direct credit card tokenization. See {@link Client#request}.
 */ function Client(configuration) {
                    var configurationJSON, gatewayConfiguration;
                    configuration = configuration || {};
                    configurationJSON = JSON.stringify(configuration);
                    gatewayConfiguration = configuration.gatewayConfiguration;
                    if (!gatewayConfiguration) throw new BraintreeError(errors.CLIENT_MISSING_GATEWAY_CONFIGURATION);
                    [
                        "assetsUrl",
                        "clientApiUrl",
                        "configUrl"
                    ].forEach(function(property) {
                        if (property in gatewayConfiguration && !isVerifiedDomain(gatewayConfiguration[property])) throw new BraintreeError({
                            type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
                            code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
                            message: property + " property is on an invalid domain."
                        });
                    });
                    /**
   * Returns a copy of the configuration values.
   * @public
   * @returns {Client~configuration} configuration
   */ this.getConfiguration = function() {
                        return JSON.parse(configurationJSON);
                    };
                    this._request = request;
                    this._configuration = this.getConfiguration();
                    this._clientApiBaseUrl = gatewayConfiguration.clientApiUrl + "/v1/";
                    if (gatewayConfiguration.graphQL) {
                        if (!isVerifiedDomain(gatewayConfiguration.graphQL.url)) throw new BraintreeError({
                            type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
                            code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
                            message: "graphQL.url property is on an invalid domain."
                        });
                        this._graphQL = new GraphQL({
                            graphQL: gatewayConfiguration.graphQL
                        });
                    }
                }
                Client.initialize = function(options) {
                    var clientInstance, authData;
                    var promise = cachedClients[options.authorization];
                    if (promise) {
                        analytics.sendEvent(promise, "custom.client.load.cached");
                        return promise;
                    }
                    try {
                        authData = createAuthorizationData(options.authorization);
                    } catch (err) {
                        return Promise.reject(new BraintreeError(errors.CLIENT_INVALID_AUTHORIZATION));
                    }
                    promise = getGatewayConfiguration(authData, options.sessionId).then(function(configuration) {
                        if (options.debug) configuration.isDebug = true;
                        configuration.authorization = options.authorization;
                        clientInstance = new Client(configuration);
                        return clientInstance;
                    });
                    cachedClients[options.authorization] = promise;
                    analytics.sendEvent(promise, "custom.client.load.initialized");
                    return promise.then(function(client) {
                        analytics.sendEvent(clientInstance, "custom.client.load.succeeded");
                        return client;
                    })["catch"](function(err) {
                        delete cachedClients[options.authorization];
                        return Promise.reject(err);
                    });
                };
                // Primarily used for testing the client initalization call
                Client.clearCache = function() {
                    cachedClients = {};
                };
                Client.prototype._findOrCreateFraudnetJSON = function(clientMetadataId) {
                    var el = document.querySelector('script[fncls="' + FRAUDNET_FNCLS + '"]');
                    var config, additionalData, authorizationFingerprint, parameters;
                    if (!el) {
                        el = document.body.appendChild(document.createElement("script"));
                        el.type = "application/json";
                        el.setAttribute("fncls", FRAUDNET_FNCLS);
                    }
                    config = this.getConfiguration();
                    additionalData = {
                        rda_tenant: "bt_card",
                        mid: config.gatewayConfiguration.merchantId
                    };
                    authorizationFingerprint = config.authorizationFingerprint;
                    if (authorizationFingerprint) authorizationFingerprint.split("&").forEach(function(pieces) {
                        var component = pieces.split("=");
                        if (component[0] === "customer_id" && component.length > 1) additionalData.cid = component[1];
                    });
                    parameters = {
                        f: clientMetadataId.substr(0, 32),
                        fp: additionalData,
                        bu: false,
                        s: FRAUDNET_SOURCE
                    };
                    el.text = JSON.stringify(parameters);
                };
                /**
 * Used by other modules to formulate all network requests to the Braintree gateway. It is also capable of being used directly from your own form to tokenize credit card information. However, be sure to satisfy PCI compliance if you use direct card tokenization.
 * @public
 * @param {object} options Request options:
 * @param {string} options.method HTTP method, e.g. "get" or "post".
 * @param {string} options.endpoint Endpoint path, e.g. "payment_methods".
 * @param {object} options.data Data to send with the request.
 * @param {number} [options.timeout=60000] Set a timeout (in milliseconds) for the request.
 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data.
 * @example
 * <caption>Direct Credit Card Tokenization</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-expiration-date'].value,
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @example
 * <caption>Tokenizing Fields for AVS Checks</caption>
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   var form = document.getElementById('my-form-id');
 *   var data = {
 *     creditCard: {
 *       number: form['cc-number'].value,
 *       cvv: form['cc-cvv'].value,
 *       expirationDate: form['cc-date'].value,
 *       // The billing address can be checked with AVS rules.
 *       // See: https://articles.braintreepayments.com/support/guides/fraud-tools/basic/avs-cvv-rules
 *       billingAddress: {
 *         postalCode: form['cc-postal-code'].value,
 *         streetAddress: form['cc-street-address'].value,
 *         countryName: form['cc-country-name'].value,
 *         countryCodeAlpha2: form['cc-country-alpha2'].value,
 *         countryCodeAlpha3: form['cc-country-alpha3'].value,
 *         countryCodeNumeric: form['cc-country-numeric'].value
 *       },
 *       options: {
 *         validate: false
 *       }
 *     }
 *   };
 *
 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
 *   // payment fields cannot be hosted on your checkout page.
 *   // For an alternative to the following, use Hosted Fields.
 *   clientInstance.request({
 *     endpoint: 'payment_methods/credit_cards',
 *     method: 'post',
 *     data: data
 *   }, function (requestErr, response) {
 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
 *     if (requestErr) { throw new Error(requestErr); }
 *
 *     console.log('Got nonce:', response.creditCards[0].nonce);
 *   });
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ Client.prototype.request = function(options, callback) {
                    var self1 = this; // eslint-disable-line no-invalid-this
                    var requestPromise = new Promise(function(resolve, reject) {
                        var optionName, api, baseUrl, requestOptions;
                        var shouldCollectData = Boolean(options.endpoint === "payment_methods/credit_cards" && self1.getConfiguration().gatewayConfiguration.creditCards.collectDeviceData);
                        if (options.api !== "graphQLApi") {
                            if (!options.method) optionName = "options.method";
                            else if (!options.endpoint) optionName = "options.endpoint";
                        }
                        if (optionName) throw new BraintreeError({
                            type: errors.CLIENT_OPTION_REQUIRED.type,
                            code: errors.CLIENT_OPTION_REQUIRED.code,
                            message: optionName + " is required when making a request."
                        });
                        if ("api" in options) api = options.api;
                        else api = "clientApi";
                        requestOptions = {
                            method: options.method,
                            graphQL: self1._graphQL,
                            timeout: options.timeout,
                            metadata: self1._configuration.analyticsMetadata
                        };
                        if (api === "clientApi") {
                            baseUrl = self1._clientApiBaseUrl;
                            requestOptions.data = metadata.addMetadata(self1._configuration, options.data);
                        } else if (api === "graphQLApi") {
                            baseUrl = GRAPHQL_URLS[self1._configuration.gatewayConfiguration.environment];
                            options.endpoint = "";
                            requestOptions.method = "post";
                            requestOptions.data = assign({
                                clientSdkMetadata: {
                                    platform: self1._configuration.analyticsMetadata.platform,
                                    source: self1._configuration.analyticsMetadata.source,
                                    integration: self1._configuration.analyticsMetadata.integration,
                                    sessionId: self1._configuration.analyticsMetadata.sessionId,
                                    version: VERSION
                                }
                            }, options.data);
                            requestOptions.headers = getAuthorizationHeadersForGraphQL(self1._configuration);
                        } else throw new BraintreeError({
                            type: errors.CLIENT_OPTION_INVALID.type,
                            code: errors.CLIENT_OPTION_INVALID.code,
                            message: "options.api is invalid."
                        });
                        requestOptions.url = baseUrl + options.endpoint;
                        requestOptions.sendAnalyticsEvent = function(kind) {
                            analytics.sendEvent(self1, kind);
                        };
                        self1._request(requestOptions, function(err, data, status) {
                            var resolvedData, requestError;
                            requestError = formatRequestError(status, err);
                            if (requestError) {
                                reject(requestError);
                                return;
                            }
                            if (api === "graphQLApi" && data.errors) {
                                reject(convertToBraintreeError(data.errors, {
                                    type: errors.CLIENT_GRAPHQL_REQUEST_ERROR.type,
                                    code: errors.CLIENT_GRAPHQL_REQUEST_ERROR.code,
                                    message: errors.CLIENT_GRAPHQL_REQUEST_ERROR.message
                                }));
                                return;
                            }
                            resolvedData = assign({
                                _httpStatus: status
                            }, data);
                            if (shouldCollectData && resolvedData.creditCards && resolvedData.creditCards.length > 0) {
                                self1._findOrCreateFraudnetJSON(resolvedData.creditCards[0].nonce);
                                assets.loadScript({
                                    src: FRAUDNET_URL,
                                    forceScriptReload: true
                                });
                            }
                            resolve(resolvedData);
                        });
                    });
                    if (typeof callback === "function") {
                        callback = once(deferred(callback));
                        requestPromise.then(function(response) {
                            callback(null, response, response._httpStatus);
                        })["catch"](function(err) {
                            var status = err && err.details && err.details.httpStatus;
                            callback(err, null, status);
                        });
                        return;
                    }
                    return requestPromise; // eslint-disable-line consistent-return
                };
                // eslint-disable-next-line consistent-return
                function formatRequestError(status, err) {
                    var requestError;
                    if (status === -1) requestError = new BraintreeError(errors.CLIENT_REQUEST_TIMEOUT);
                    else if (status === 401) requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INVALID);
                    else if (status === 403) requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INSUFFICIENT);
                    else if (status === 429) requestError = new BraintreeError(errors.CLIENT_RATE_LIMITED);
                    else if (status >= 500) requestError = new BraintreeError(errors.CLIENT_GATEWAY_NETWORK);
                    else if (status < 200 || status >= 400) requestError = convertToBraintreeError(err, {
                        type: errors.CLIENT_REQUEST_ERROR.type,
                        code: errors.CLIENT_REQUEST_ERROR.code,
                        message: errors.CLIENT_REQUEST_ERROR.message
                    });
                    if (requestError) {
                        requestError.details = requestError.details || {};
                        requestError.details.httpStatus = status;
                        return requestError;
                    }
                }
                Client.prototype.toJSON = function() {
                    return this.getConfiguration();
                };
                /**
 * Returns the Client version.
 * @public
 * @returns {String} The created client's version.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   console.log(clientInstance.getVersion()); // Ex: 1.0.0
 * });
 * @returns {void}
 */ Client.prototype.getVersion = function() {
                    return VERSION;
                };
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/client.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * clientInstance.teardown();
 * @example <caption>With callback</caption>
 * clientInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ Client.prototype.teardown = wrapPromise(function() {
                    var self1 = this; // eslint-disable-line no-invalid-this
                    delete cachedClients[self1.getConfiguration().authorization];
                    convertMethodsToError(self1, methods(Client.prototype));
                    return Promise.resolve();
                });
                function getAuthorizationHeadersForGraphQL(configuration) {
                    var token = configuration.authorizationFingerprint || configuration.authorization;
                    return {
                        Authorization: "Bearer " + token,
                        "Braintree-Version": BRAINTREE_VERSION
                    };
                }
                module1.exports = Client;
            },
            {
                "../lib/add-metadata": 137,
                "../lib/analytics": 138,
                "../lib/assets": 139,
                "../lib/assign": 140,
                "../lib/braintree-error": 143,
                "../lib/constants": 145,
                "../lib/convert-methods-to-error": 146,
                "../lib/convert-to-braintree-error": 147,
                "../lib/create-authorization-data": 149,
                "../lib/deferred": 151,
                "../lib/is-verified-domain": 173,
                "../lib/methods": 175,
                "../lib/once": 176,
                "./constants": 93,
                "./errors": 94,
                "./get-configuration": 95,
                "./request": 108,
                "./request/graphql": 106,
                "@braintree/wrap-promise": 40
            }
        ],
        93: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    BRAINTREE_VERSION: "2018-05-10"
                };
            },
            {}
        ],
        94: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Client - Internal Error Codes
 * @ignore
 * @description These codes should never be experienced by the merchant directly.
 * @property {MERCHANT} CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN An error to prevent client creation for domains that are not allowed in the JS.
 * @property {INTERNAL} CLIENT_MISSING_GATEWAY_CONFIGURATION Occurs when the client is created without a gateway configuration. Should never happen.
 */ /**
 * @name BraintreeError.Client - Create Error Codes
 * @description Errors that may occur when [creating the client](./module-braintree-web_client.html#.create)
 * @property {MERCHANT} CLIENT_INVALID_AUTHORIZATION Occurs when client token cannot be parsed.
 */ /**
 * @name BraintreeError.Client - Request Error Codes
 * @description Errors that may occur when [using the request method](./Client.html#request)
 * @property {MERCHANT} CLIENT_OPTION_REQUIRED An option required in the request method was not provided. Usually `options.method` or `options.endpoint`
 * @property {MERCHANT} CLIENT_OPTION_INVALID The request option provided is invalid.
 * @property {MERCHANT} CLIENT_GATEWAY_NETWORK The Braintree gateway could not be contacted.
 * @property {NETWORK} CLIENT_REQUEST_TIMEOUT The request took too long to complete and timed out.
 * @property {NETWORK} CLIENT_REQUEST_ERROR The response from a request had status 400 or greater.
 * @property {NETWORK} CLIENT_GRAPHQL_REQUEST_ERROR The response from a request to GraphQL contained an error.
 * @property {MERCHANT} CLIENT_RATE_LIMITED The response from a request had a status of 429, indicating rate limiting.
 * @property {MERCHANT} CLIENT_AUTHORIZATION_INSUFFICIENT The user associated with the client token or tokenization key does not have permissions to make the request.
 * @property {MERCHANT} CLIENT_AUTHORIZATION_INVALID The provided authorization could not be found. Either the client token has expired and a new client token must be generated or the tokenization key used is set to be inactive or has been deleted.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN: {
                        type: BraintreeError.types.MERCHANT,
                        code: "CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN"
                    },
                    CLIENT_OPTION_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "CLIENT_OPTION_REQUIRED"
                    },
                    CLIENT_OPTION_INVALID: {
                        type: BraintreeError.types.MERCHANT,
                        code: "CLIENT_OPTION_INVALID"
                    },
                    CLIENT_MISSING_GATEWAY_CONFIGURATION: {
                        type: BraintreeError.types.INTERNAL,
                        code: "CLIENT_MISSING_GATEWAY_CONFIGURATION",
                        message: "Missing gatewayConfiguration."
                    },
                    CLIENT_INVALID_AUTHORIZATION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "CLIENT_INVALID_AUTHORIZATION",
                        message: "Authorization is invalid. Make sure your client token or tokenization key is valid."
                    },
                    CLIENT_GATEWAY_NETWORK: {
                        type: BraintreeError.types.NETWORK,
                        code: "CLIENT_GATEWAY_NETWORK",
                        message: "Cannot contact the gateway at this time."
                    },
                    CLIENT_REQUEST_TIMEOUT: {
                        type: BraintreeError.types.NETWORK,
                        code: "CLIENT_REQUEST_TIMEOUT",
                        message: "Request timed out waiting for a reply."
                    },
                    CLIENT_REQUEST_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "CLIENT_REQUEST_ERROR",
                        message: "There was a problem with your request."
                    },
                    CLIENT_GRAPHQL_REQUEST_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "CLIENT_GRAPHQL_REQUEST_ERROR",
                        message: "There was a problem with your request."
                    },
                    CLIENT_RATE_LIMITED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "CLIENT_RATE_LIMITED",
                        message: "You are being rate-limited; please try again in a few minutes."
                    },
                    CLIENT_AUTHORIZATION_INSUFFICIENT: {
                        type: BraintreeError.types.MERCHANT,
                        code: "CLIENT_AUTHORIZATION_INSUFFICIENT",
                        message: "The authorization used has insufficient privileges."
                    },
                    CLIENT_AUTHORIZATION_INVALID: {
                        type: BraintreeError.types.MERCHANT,
                        code: "CLIENT_AUTHORIZATION_INVALID",
                        message: "Either the client token has expired and a new one should be generated or the tokenization key has been deactivated or deleted."
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        95: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../lib/braintree-error");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var request = _dereq_("./request");
                var uuid = _dereq_("@braintree/uuid");
                var constants = _dereq_("../lib/constants");
                var errors = _dereq_("./errors");
                var GraphQL = _dereq_("./request/graphql");
                var GRAPHQL_URLS = _dereq_("../lib/constants").GRAPHQL_URLS;
                var isDateStringBeforeOrOn = _dereq_("../lib/is-date-string-before-or-on");
                var BRAINTREE_VERSION = _dereq_("./constants").BRAINTREE_VERSION;
                function getConfiguration(authData, inputSessionId) {
                    return new Promise(function(resolve, reject) {
                        var configuration, attrs, configUrl, reqOptions;
                        var sessionId = inputSessionId || uuid();
                        var analyticsMetadata = {
                            merchantAppId: window.location.host,
                            platform: constants.PLATFORM,
                            sdkVersion: constants.VERSION,
                            source: constants.SOURCE,
                            // NEXT_MAJOR_VERSION remove one of these to not duplicate data. Target parity with mobile platforms approach.
                            integration: constants.INTEGRATION,
                            integrationType: constants.INTEGRATION,
                            sessionId: sessionId
                        };
                        attrs = authData.attrs;
                        configUrl = authData.configUrl;
                        attrs._meta = analyticsMetadata;
                        attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
                        attrs.configVersion = "3";
                        reqOptions = {
                            url: configUrl,
                            method: "GET",
                            data: attrs
                        };
                        if (attrs.authorizationFingerprint && authData.graphQL) {
                            if (isDateStringBeforeOrOn(authData.graphQL.date, BRAINTREE_VERSION)) reqOptions.graphQL = new GraphQL({
                                graphQL: {
                                    url: authData.graphQL.url,
                                    features: [
                                        "configuration"
                                    ]
                                }
                            });
                            reqOptions.metadata = analyticsMetadata;
                        } else if (attrs.tokenizationKey) {
                            reqOptions.graphQL = new GraphQL({
                                graphQL: {
                                    url: GRAPHQL_URLS[authData.environment],
                                    features: [
                                        "configuration"
                                    ]
                                }
                            });
                            reqOptions.metadata = analyticsMetadata;
                        }
                        // NEXT_MAJOR_VERSION
                        // there are various issues with the config endpoint where the values returned
                        // do not match the values from the merchant account id passed into a client token
                        // we need to update the configuration request endpoint to be able to pass the
                        // correct values. The following ones are incorrect
                        // * applePayWeb - definitely supportedNetworks, which compiles all the card
                        //    networks from all the merchant accounts instead of providing just the
                        //    ones from the specified one. The same is probably true for ios apple pay
                        //    Also the merchantidentifier
                        // NEXT_MAJOR_VERSION Allow passing in merchant account id when creating the component
                        // to fetch the config for that merchant account id (particularly helpful when using
                        // a tokenization key for authorization)
                        request(reqOptions, function(err, response, status) {
                            var errorTemplate;
                            if (err) {
                                if (status === 403) errorTemplate = errors.CLIENT_AUTHORIZATION_INSUFFICIENT;
                                else if (status === 401) errorTemplate = errors.CLIENT_AUTHORIZATION_INVALID;
                                else errorTemplate = errors.CLIENT_GATEWAY_NETWORK;
                                reject(new BraintreeError({
                                    type: errorTemplate.type,
                                    code: errorTemplate.code,
                                    message: errorTemplate.message,
                                    details: {
                                        originalError: err
                                    }
                                }));
                                return;
                            }
                            configuration = {
                                authorizationType: attrs.tokenizationKey ? "TOKENIZATION_KEY" : "CLIENT_TOKEN",
                                authorizationFingerprint: attrs.authorizationFingerprint,
                                analyticsMetadata: analyticsMetadata,
                                gatewayConfiguration: response
                            };
                            resolve(configuration);
                        });
                    });
                }
                module1.exports = {
                    getConfiguration: wrapPromise(getConfiguration)
                };
            },
            {
                "../lib/braintree-error": 143,
                "../lib/constants": 145,
                "../lib/is-date-string-before-or-on": 170,
                "./constants": 93,
                "./errors": 94,
                "./request": 108,
                "./request/graphql": 106,
                "@braintree/uuid": 36,
                "@braintree/wrap-promise": 40
            }
        ],
        96: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../lib/braintree-error");
                var Client = _dereq_("./client");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var sharedErrors = _dereq_("../lib/errors");
                /** @module braintree-web/client */ /**
 * @function create
 * @description This function is the entry point for the <code>braintree.client</code> module. It is used for creating {@link Client} instances that service communication to Braintree servers.
 * @param {object} options Object containing all {@link Client} options:
 * @param {string} options.authorization A tokenizationKey or clientToken.
 * @param {callback} [callback] The second argument, <code>data</code>, is the {@link Client} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * var createClient = require('braintree-web/client').create;
 *
 * createClient({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (createErr, clientInstance) {
 *   if (createErr) {
 *     if (createErr.code === 'CLIENT_AUTHORIZATION_INVALID') {
 *       // either the client token has expired, and a new one should be generated
 *       // or the tokenization key was deactivated or deleted
 *     } else {
 *       console.log('something went wrong creating the client instance', createErr);
 *     }
 *     return;
 *   }
 *
 *  // set up other components
 * });
 * @static
 */ function create(options) {
                    if (!options.authorization) return Promise.reject(new BraintreeError({
                        type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
                        code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
                        message: "options.authorization is required when instantiating a client."
                    }));
                    return Client.initialize(options);
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/braintree-error": 143,
                "../lib/errors": 154,
                "./client": 92,
                "@braintree/wrap-promise": 40
            }
        ],
        97: [
            function(_dereq_, module1, exports) {
                "use strict";
                var querystring = _dereq_("../../lib/querystring");
                var assign = _dereq_("../../lib/assign").assign;
                var prepBody = _dereq_("./prep-body");
                var parseBody = _dereq_("./parse-body");
                var xhr = _dereq_("./xhr");
                var isXHRAvailable = xhr.isAvailable;
                var GraphQLRequest = _dereq_("./graphql/request");
                var DefaultRequest = _dereq_("./default-request");
                var MAX_TCP_RETRYCOUNT = 1;
                var TCP_PRECONNECT_BUG_STATUS_CODE = 408;
                function requestShouldRetry(status) {
                    return !status || status === TCP_PRECONNECT_BUG_STATUS_CODE;
                }
                function graphQLRequestShouldRetryWithClientApi(body) {
                    var errorClass = !body.data && body.errors && body.errors[0] && body.errors[0].extensions && body.errors[0].extensions.errorClass;
                    return errorClass === "UNKNOWN" || errorClass === "INTERNAL";
                }
                function _requestWithRetry(options, tcpRetryCount, cb) {
                    var status, resBody, ajaxRequest, body, method, headers, parsedBody;
                    var url = options.url;
                    var graphQL = options.graphQL;
                    var timeout = options.timeout;
                    var req = xhr.getRequestObject();
                    var callback = cb;
                    var isGraphQLRequest = Boolean(graphQL && graphQL.isGraphQLRequest(url, options.data));
                    options.headers = assign({
                        "Content-Type": "application/json"
                    }, options.headers);
                    if (isGraphQLRequest) ajaxRequest = new GraphQLRequest(options);
                    else ajaxRequest = new DefaultRequest(options);
                    url = ajaxRequest.getUrl();
                    body = ajaxRequest.getBody();
                    method = ajaxRequest.getMethod();
                    headers = ajaxRequest.getHeaders();
                    if (method === "GET") {
                        url = querystring.queryify(url, body);
                        body = null;
                    }
                    if (isXHRAvailable) req.onreadystatechange = function() {
                        if (req.readyState !== 4) return;
                        if (req.status === 0 && isGraphQLRequest) {
                            // If a merchant experiences a connection
                            // issue to the GraphQL endpoint (possibly
                            // due to a Content Security Policy), retry
                            // the request against the old client API.
                            delete options.graphQL;
                            _requestWithRetry(options, tcpRetryCount, cb);
                            return;
                        }
                        parsedBody = parseBody(req.responseText);
                        resBody = ajaxRequest.adaptResponseBody(parsedBody);
                        status = ajaxRequest.determineStatus(req.status, parsedBody);
                        if (status >= 400 || status < 200) {
                            if (isGraphQLRequest && graphQLRequestShouldRetryWithClientApi(parsedBody)) {
                                delete options.graphQL;
                                _requestWithRetry(options, tcpRetryCount, cb);
                                return;
                            }
                            if (tcpRetryCount < MAX_TCP_RETRYCOUNT && requestShouldRetry(status)) {
                                tcpRetryCount++;
                                _requestWithRetry(options, tcpRetryCount, cb);
                                return;
                            }
                            callback(resBody || "error", null, status || 500);
                        } else callback(null, resBody, status);
                    };
                    else {
                        if (options.headers) url = querystring.queryify(url, headers);
                        req.onload = function() {
                            callback(null, parseBody(req.responseText), req.status);
                        };
                        req.onerror = function() {
                            // XDomainRequest does not report a body or status for errors, so
                            // hardcode to 'error' and 500, respectively
                            callback("error", null, 500);
                        };
                        // This must remain for IE9 to work
                        req.onprogress = function() {};
                        req.ontimeout = function() {
                            callback("timeout", null, -1);
                        };
                    }
                    try {
                        req.open(method, url, true);
                    } catch (requestOpenError) {
                        // If a merchant has a Content Security Policy and they have
                        // not allowed our endpoints, some browsers may
                        // synchronously throw an error. If it is not a GraphQL
                        // request, we throw the error. If it is a GraphQL request
                        // we remove the GraphQL option and try the request against
                        // the old client API.
                        if (!isGraphQLRequest) throw requestOpenError;
                        delete options.graphQL;
                        _requestWithRetry(options, tcpRetryCount, cb);
                        return;
                    }
                    req.timeout = timeout;
                    if (isXHRAvailable) Object.keys(headers).forEach(function(headerKey) {
                        req.setRequestHeader(headerKey, headers[headerKey]);
                    });
                    try {
                        req.send(prepBody(method, body));
                    } catch (e) {
                    /* ignored */ }
                }
                function request(options, cb) {
                    _requestWithRetry(options, 0, cb);
                }
                module1.exports = {
                    request: request
                };
            },
            {
                "../../lib/assign": 140,
                "../../lib/querystring": 177,
                "./default-request": 98,
                "./graphql/request": 107,
                "./parse-body": 109,
                "./prep-body": 110,
                "./xhr": 111
            }
        ],
        98: [
            function(_dereq_, module1, exports) {
                "use strict";
                function DefaultRequest(options) {
                    this._url = options.url;
                    this._data = options.data;
                    this._method = options.method;
                    this._headers = options.headers;
                }
                DefaultRequest.prototype.getUrl = function() {
                    return this._url;
                };
                DefaultRequest.prototype.getBody = function() {
                    return this._data;
                };
                DefaultRequest.prototype.getMethod = function() {
                    return this._method;
                };
                DefaultRequest.prototype.getHeaders = function() {
                    return this._headers;
                };
                DefaultRequest.prototype.adaptResponseBody = function(parsedBody) {
                    return parsedBody;
                };
                DefaultRequest.prototype.determineStatus = function(status) {
                    return status;
                };
                module1.exports = DefaultRequest;
            },
            {}
        ],
        99: [
            function(_dereq_, module1, exports) {
                "use strict";
                var errorResponseAdapter = _dereq_("./error");
                var assign = _dereq_("../../../../lib/assign").assign;
                /* eslint-disable camelcase */ var cardTypeTransforms = {
                    creditCard: {
                        AMERICAN_EXPRESS: "American Express",
                        DISCOVER: "Discover",
                        INTERNATIONAL_MAESTRO: "Maestro",
                        JCB: "JCB",
                        MASTERCARD: "MasterCard",
                        SOLO: "Solo",
                        UK_MAESTRO: "UK Maestro",
                        UNION_PAY: "UnionPay",
                        VISA: "Visa",
                        ELO: "Elo",
                        HIPER: "Hiper",
                        HIPERCARD: "Hipercard"
                    },
                    applePayWeb: {
                        VISA: "visa",
                        MASTERCARD: "mastercard",
                        DISCOVER: "discover",
                        AMERICAN_EXPRESS: "amex",
                        INTERNATIONAL_MAESTRO: "maestro",
                        ELO: "elo"
                    },
                    visaCheckout: {
                        VISA: "Visa",
                        MASTERCARD: "MasterCard",
                        DISCOVER: "Discover",
                        AMERICAN_EXPRESS: "American Express"
                    },
                    googlePay: {
                        VISA: "visa",
                        MASTERCARD: "mastercard",
                        DISCOVER: "discover",
                        AMERICAN_EXPRESS: "amex",
                        INTERNATIONAL_MAESTRO: "maestro",
                        ELO: "elo"
                    },
                    masterpass: {
                        VISA: "visa",
                        MASTERCARD: "master",
                        DISCOVER: "discover",
                        AMERICAN_EXPRESS: "amex",
                        DINERS: "diners",
                        INTERNATIONAL_MAESTRO: "maestro",
                        JCB: "jcb"
                    }
                };
                /* eslint-enable camelcase */ function configurationResponseAdapter(responseBody, ctx) {
                    var adaptedResponse;
                    if (responseBody.data && !responseBody.errors) adaptedResponse = adaptConfigurationResponseBody(responseBody, ctx);
                    else adaptedResponse = errorResponseAdapter(responseBody);
                    return adaptedResponse;
                }
                function adaptConfigurationResponseBody(body, ctx) {
                    var configuration = body.data.clientConfiguration;
                    var response;
                    response = {
                        environment: configuration.environment.toLowerCase(),
                        clientApiUrl: configuration.clientApiUrl,
                        assetsUrl: configuration.assetsUrl,
                        analytics: {
                            url: configuration.analyticsUrl
                        },
                        merchantId: configuration.merchantId,
                        venmo: "off"
                    };
                    if (configuration.supportedFeatures) response.graphQL = {
                        url: ctx._graphQL._config.url,
                        features: configuration.supportedFeatures.map(function(feature) {
                            return feature.toLowerCase();
                        })
                    };
                    if (configuration.braintreeApi) response.braintreeApi = configuration.braintreeApi;
                    if (configuration.applePayWeb) {
                        response.applePayWeb = configuration.applePayWeb;
                        response.applePayWeb.supportedNetworks = mapCardTypes(configuration.applePayWeb.supportedCardBrands, cardTypeTransforms.applePayWeb);
                        delete response.applePayWeb.supportedCardBrands;
                    }
                    if (configuration.fastlane) response.fastlane = configuration.fastlane;
                    if (configuration.ideal) response.ideal = configuration.ideal;
                    if (configuration.kount) response.kount = {
                        kountMerchantId: configuration.kount.merchantId
                    };
                    if (configuration.creditCard) {
                        response.challenges = configuration.creditCard.challenges.map(function(challenge) {
                            return challenge.toLowerCase();
                        });
                        response.creditCards = {
                            supportedCardTypes: mapCardTypes(configuration.creditCard.supportedCardBrands, cardTypeTransforms.creditCard)
                        };
                        response.threeDSecureEnabled = configuration.creditCard.threeDSecureEnabled;
                        response.threeDSecure = configuration.creditCard.threeDSecure;
                    } else {
                        response.challenges = [];
                        response.creditCards = {
                            supportedCardTypes: []
                        };
                        response.threeDSecureEnabled = false;
                    }
                    if (configuration.googlePay) response.androidPay = {
                        displayName: configuration.googlePay.displayName,
                        enabled: true,
                        environment: configuration.googlePay.environment.toLowerCase(),
                        googleAuthorizationFingerprint: configuration.googlePay.googleAuthorization,
                        paypalClientId: configuration.googlePay.paypalClientId,
                        supportedNetworks: mapCardTypes(configuration.googlePay.supportedCardBrands, cardTypeTransforms.googlePay)
                    };
                    if (configuration.venmo) response.payWithVenmo = {
                        merchantId: configuration.venmo.merchantId,
                        accessToken: configuration.venmo.accessToken,
                        environment: configuration.venmo.environment.toLowerCase(),
                        enrichedCustomerDataEnabled: configuration.venmo.enrichedCustomerDataEnabled
                    };
                    if (configuration.paypal) {
                        response.paypalEnabled = true;
                        response.paypal = assign({}, configuration.paypal);
                        response.paypal.currencyIsoCode = response.paypal.currencyCode;
                        response.paypal.environment = response.paypal.environment.toLowerCase();
                        delete response.paypal.currencyCode;
                    } else response.paypalEnabled = false;
                    if (configuration.unionPay) response.unionPay = {
                        enabled: true,
                        merchantAccountId: configuration.unionPay.merchantAccountId
                    };
                    if (configuration.visaCheckout) response.visaCheckout = {
                        apikey: configuration.visaCheckout.apiKey,
                        encryptionKey: configuration.visaCheckout.encryptionKey,
                        externalClientId: configuration.visaCheckout.externalClientId,
                        supportedCardTypes: mapCardTypes(configuration.visaCheckout.supportedCardBrands, cardTypeTransforms.visaCheckout)
                    };
                    if (configuration.masterpass) response.masterpass = {
                        merchantCheckoutId: configuration.masterpass.merchantCheckoutId,
                        supportedNetworks: mapCardTypes(configuration.masterpass.supportedCardBrands, cardTypeTransforms.masterpass)
                    };
                    if (configuration.usBankAccount) response.usBankAccount = {
                        routeId: configuration.usBankAccount.routeId,
                        plaid: {
                            publicKey: configuration.usBankAccount.plaidPublicKey
                        }
                    };
                    return response;
                }
                function mapCardTypes(cardTypes, cardTypeTransformMap) {
                    return cardTypes.reduce(function(acc, type) {
                        if (cardTypeTransformMap.hasOwnProperty(type)) return acc.concat(cardTypeTransformMap[type]);
                        return acc;
                    }, []);
                }
                module1.exports = configurationResponseAdapter;
            },
            {
                "../../../../lib/assign": 140,
                "./error": 102
            }
        ],
        100: [
            function(_dereq_, module1, exports) {
                "use strict";
                var errorResponseAdapter = _dereq_("./error");
                var CARD_BRAND_MAP = {
                    /* eslint-disable camelcase */ AMERICAN_EXPRESS: "American Express",
                    DINERS: "Discover",
                    DISCOVER: "Discover",
                    ELO: "Elo",
                    HIPER: "Hiper",
                    HIPERCARD: "Hipercard",
                    INTERNATIONAL_MAESTRO: "Maestro",
                    JCB: "JCB",
                    MASTERCARD: "MasterCard",
                    UK_MAESTRO: "Maestro",
                    UNION_PAY: "UnionPay",
                    VISA: "Visa"
                };
                var BIN_DATA_MAP = {
                    YES: "Yes",
                    NO: "No",
                    UNKNOWN: "Unknown"
                };
                var AUTHENTICATION_INSIGHT_MAP = {
                    PSDTWO: "psd2"
                };
                function creditCardTokenizationFastlaneResponseAdapter(responseBody) {
                    var adaptedResponse;
                    if (responseBody.data && !responseBody.errors) adaptedResponse = adaptTokenizeCreditCardForFastlaneResponseBody(responseBody);
                    else adaptedResponse = errorResponseAdapter(responseBody);
                    return adaptedResponse;
                }
                function adaptTokenizeCreditCardForFastlaneResponseBody(body) {
                    var data = body.data.tokenizeCreditCardForPayPalConnect;
                    var creditCard = data.paymentMethod.details;
                    var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : "";
                    var binData = creditCard.binData;
                    var response, regulationEnvironment;
                    if (binData) {
                        [
                            "commercial",
                            "debit",
                            "durbinRegulated",
                            "healthcare",
                            "payroll",
                            "prepaid"
                        ].forEach(function(key) {
                            if (binData[key]) binData[key] = BIN_DATA_MAP[binData[key]];
                            else binData[key] = "Unknown";
                        });
                        [
                            "issuingBank",
                            "countryOfIssuance",
                            "productId"
                        ].forEach(function(key) {
                            if (!binData[key]) binData[key] = "Unknown";
                        });
                    }
                    response = {
                        creditCards: [
                            {
                                binData: binData,
                                consumed: false,
                                description: lastTwo ? "ending in " + lastTwo : "",
                                nonce: data.paymentMethod.id,
                                details: {
                                    cardholderName: creditCard.cardholderName,
                                    expirationMonth: creditCard.expirationMonth,
                                    expirationYear: creditCard.expirationYear,
                                    bin: creditCard.bin || "",
                                    cardType: CARD_BRAND_MAP[creditCard.brandCode] || "Unknown",
                                    lastFour: creditCard.last4 || "",
                                    lastTwo: lastTwo
                                },
                                type: "CreditCard",
                                threeDSecureInfo: null
                            }
                        ]
                    };
                    if (data.authenticationInsight) {
                        regulationEnvironment = data.authenticationInsight.customerAuthenticationRegulationEnvironment;
                        response.creditCards[0].authenticationInsight = {
                            regulationEnvironment: AUTHENTICATION_INSIGHT_MAP[regulationEnvironment] || regulationEnvironment.toLowerCase()
                        };
                    }
                    return response;
                }
                module1.exports = creditCardTokenizationFastlaneResponseAdapter;
            },
            {
                "./error": 102
            }
        ],
        101: [
            function(_dereq_, module1, exports) {
                "use strict";
                var errorResponseAdapter = _dereq_("./error");
                var CARD_BRAND_MAP = {
                    /* eslint-disable camelcase */ AMERICAN_EXPRESS: "American Express",
                    DINERS: "Discover",
                    DISCOVER: "Discover",
                    ELO: "Elo",
                    HIPER: "Hiper",
                    HIPERCARD: "Hipercard",
                    INTERNATIONAL_MAESTRO: "Maestro",
                    JCB: "JCB",
                    MASTERCARD: "MasterCard",
                    UK_MAESTRO: "Maestro",
                    UNION_PAY: "UnionPay",
                    VISA: "Visa"
                };
                var BIN_DATA_MAP = {
                    YES: "Yes",
                    NO: "No",
                    UNKNOWN: "Unknown"
                };
                var AUTHENTICATION_INSIGHT_MAP = {
                    PSDTWO: "psd2"
                };
                function creditCardTokenizationResponseAdapter(responseBody) {
                    var adaptedResponse;
                    if (responseBody.data && !responseBody.errors) adaptedResponse = adaptTokenizeCreditCardResponseBody(responseBody);
                    else adaptedResponse = errorResponseAdapter(responseBody);
                    return adaptedResponse;
                }
                function adaptTokenizeCreditCardResponseBody(body) {
                    var data = body.data.tokenizeCreditCard;
                    var creditCard = data.creditCard;
                    var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : "";
                    var binData = creditCard.binData;
                    var response, regulationEnvironment;
                    if (binData) {
                        [
                            "commercial",
                            "debit",
                            "durbinRegulated",
                            "healthcare",
                            "payroll",
                            "prepaid"
                        ].forEach(function(key) {
                            if (binData[key]) binData[key] = BIN_DATA_MAP[binData[key]];
                            else binData[key] = "Unknown";
                        });
                        [
                            "issuingBank",
                            "countryOfIssuance",
                            "productId"
                        ].forEach(function(key) {
                            if (!binData[key]) binData[key] = "Unknown";
                        });
                    }
                    response = {
                        creditCards: [
                            {
                                binData: binData,
                                consumed: false,
                                description: lastTwo ? "ending in " + lastTwo : "",
                                nonce: data.token,
                                details: {
                                    cardholderName: creditCard.cardholderName,
                                    expirationMonth: creditCard.expirationMonth,
                                    expirationYear: creditCard.expirationYear,
                                    bin: creditCard.bin || "",
                                    cardType: CARD_BRAND_MAP[creditCard.brandCode] || "Unknown",
                                    lastFour: creditCard.last4 || "",
                                    lastTwo: lastTwo
                                },
                                type: "CreditCard",
                                threeDSecureInfo: null
                            }
                        ]
                    };
                    if (data.authenticationInsight) {
                        regulationEnvironment = data.authenticationInsight.customerAuthenticationRegulationEnvironment;
                        response.creditCards[0].authenticationInsight = {
                            regulationEnvironment: AUTHENTICATION_INSIGHT_MAP[regulationEnvironment] || regulationEnvironment.toLowerCase()
                        };
                    }
                    return response;
                }
                module1.exports = creditCardTokenizationResponseAdapter;
            },
            {
                "./error": 102
            }
        ],
        102: [
            function(_dereq_, module1, exports) {
                "use strict";
                function errorResponseAdapter(responseBody) {
                    var response;
                    var errorClass = responseBody.errors && responseBody.errors[0] && responseBody.errors[0].extensions && responseBody.errors[0].extensions.errorClass;
                    if (errorClass === "VALIDATION") response = userErrorResponseAdapter(responseBody);
                    else if (errorClass) response = errorWithClassResponseAdapter(responseBody);
                    else response = {
                        error: {
                            message: "There was a problem serving your request"
                        },
                        fieldErrors: []
                    };
                    return response;
                }
                function errorWithClassResponseAdapter(responseBody) {
                    return {
                        error: {
                            message: responseBody.errors[0].message
                        },
                        fieldErrors: []
                    };
                }
                function userErrorResponseAdapter(responseBody) {
                    var fieldErrors = buildFieldErrors(responseBody.errors);
                    if (fieldErrors.length === 0) return {
                        error: {
                            message: responseBody.errors[0].message
                        }
                    };
                    return {
                        error: {
                            message: getLegacyMessage(fieldErrors)
                        },
                        fieldErrors: fieldErrors
                    };
                }
                function buildFieldErrors(errors) {
                    var fieldErrors = [];
                    errors.forEach(function(error) {
                        if (!(error.extensions && error.extensions.inputPath)) return;
                        addFieldError(error.extensions.inputPath.slice(1), error, fieldErrors);
                    });
                    return fieldErrors;
                }
                function addFieldError(inputPath, errorDetail, fieldErrors) {
                    var fieldError;
                    var legacyCode = errorDetail.extensions.legacyCode;
                    var inputField = inputPath[0];
                    if (inputPath.length === 1) {
                        fieldErrors.push({
                            code: legacyCode,
                            field: inputField,
                            message: errorDetail.message
                        });
                        return;
                    }
                    fieldErrors.forEach(function(candidate) {
                        if (candidate.field === inputField) fieldError = candidate;
                    });
                    if (!fieldError) {
                        fieldError = {
                            field: inputField,
                            fieldErrors: []
                        };
                        fieldErrors.push(fieldError);
                    }
                    addFieldError(inputPath.slice(1), errorDetail, fieldError.fieldErrors);
                }
                function getLegacyMessage(errors) {
                    var legacyMessages = {
                        creditCard: "Credit card is invalid"
                    };
                    var field = errors[0].field;
                    return legacyMessages[field];
                }
                module1.exports = errorResponseAdapter;
            },
            {}
        ],
        103: [
            function(_dereq_, module1, exports) {
                "use strict";
                var CONFIGURATION_QUERY = "query ClientConfiguration {   clientConfiguration {     analyticsUrl     environment     merchantId     assetsUrl     clientApiUrl     creditCard {       supportedCardBrands       challenges       threeDSecureEnabled       threeDSecure {         cardinalAuthenticationJWT       }     }     applePayWeb {       countryCode       currencyCode       merchantIdentifier       supportedCardBrands     }     fastlane {       enabled     }     googlePay {       displayName       supportedCardBrands       environment       googleAuthorization       paypalClientId     }     ideal {       routeId       assetsUrl     }     kount {       merchantId     }     masterpass {       merchantCheckoutId       supportedCardBrands     }     paypal {       displayName       clientId       assetsUrl       environment       environmentNoNetwork       unvettedMerchant       braintreeClientId       billingAgreementsEnabled       merchantAccountId       currencyCode       payeeEmail     }     unionPay {       merchantAccountId     }     usBankAccount {       routeId       plaidPublicKey     }     venmo {       merchantId       accessToken       environment       enrichedCustomerDataEnabled    }     visaCheckout {       apiKey       externalClientId       supportedCardBrands     }     braintreeApi {       accessToken       url     }     supportedFeatures   } }";
                function configuration() {
                    return {
                        query: CONFIGURATION_QUERY,
                        operationName: "ClientConfiguration"
                    };
                }
                module1.exports = configuration;
            },
            {}
        ],
        104: [
            function(_dereq_, module1, exports) {
                "use strict";
                var assign = _dereq_("../../../../lib/assign").assign;
                function createMutation(config) {
                    var hasAuthenticationInsight = config.hasAuthenticationInsight;
                    var mutation = "mutation TokenizeCreditCardForPayPalConnect($input: TokenizeCreditCardForPayPalConnectInput!";
                    if (hasAuthenticationInsight) mutation += ", $authenticationInsightInput: AuthenticationInsightInput!";
                    mutation += ") {   tokenizeCreditCardForPayPalConnect(input: $input) {     clientMutationId     paymentMethod {       id       details {         ... on CreditCardDetails {       bin       brandCode       last4       cardholderName       expirationMonth      expirationYear      binData {         prepaid         healthcare         debit         durbinRegulated         commercial         payroll         issuingBank         countryOfIssuance         productId       }         }       }     }";
                    if (hasAuthenticationInsight) mutation += "    authenticationInsight(input: $authenticationInsightInput) {      customerAuthenticationRegulationEnvironment    }";
                    mutation += "  } }";
                    return mutation;
                }
                function createCreditCardForFastlaneTokenizationBody(body, options) {
                    var creditCard = body.creditCard;
                    var fastlane = creditCard.fastlane || {};
                    var termsAndConditionsVersion = "fastlane" in creditCard && "termsAndConditionsVersion" in creditCard.fastlane && creditCard.fastlane.termsAndConditionsVersion;
                    var email = creditCard.email;
                    var optIn = "hasBuyerConsent" in fastlane && fastlane.hasBuyerConsent;
                    var shippingAddress = creditCard.shippingAddress;
                    var variables = createCreditCardTokenizationBody(body, options);
                    var ccpcVariables = assign({}, variables.input, {
                        email: email,
                        optIn: optIn,
                        phone: creditCard.phone,
                        termsAndConditionsVersion: termsAndConditionsVersion
                    });
                    if ("authAssertion" in fastlane) ccpcVariables.authAssertion = fastlane.authAssertion;
                    if (shippingAddress) ccpcVariables.shippingAddress = shippingAddress;
                    return {
                        input: ccpcVariables
                    };
                }
                function createCreditCardTokenizationBody(body, options) {
                    var cc = body.creditCard;
                    var billingAddress = cc && cc.billingAddress;
                    var expDate = cc && cc.expirationDate;
                    var expirationMonth = cc && (cc.expirationMonth || expDate && expDate.split("/")[0].trim());
                    var expirationYear = cc && (cc.expirationYear || expDate && expDate.split("/")[1].trim());
                    var variables = {
                        input: {
                            creditCard: {
                                number: cc && cc.number,
                                expirationMonth: expirationMonth,
                                expirationYear: expirationYear,
                                cvv: cc && cc.cvv,
                                cardholderName: cc && cc.cardholderName
                            },
                            options: {}
                        }
                    };
                    if (options.hasAuthenticationInsight) variables.authenticationInsightInput = {
                        merchantAccountId: body.merchantAccountId
                    };
                    if (billingAddress) variables.input.creditCard.billingAddress = billingAddress;
                    variables.input = addValidationRule(body, variables.input);
                    return variables;
                }
                function addValidationRule(body, input) {
                    var validate;
                    if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === "boolean") validate = body.creditCard.options.validate;
                    else if (body.authorizationFingerprint && body.tokenizationKey || body.authorizationFingerprint) validate = true;
                    else if (body.tokenizationKey) validate = false;
                    if (typeof validate === "boolean") input.options = assign({
                        validate: validate
                    }, input.options);
                    return input;
                }
                function creditCardForFastlaneTokenization(body) {
                    var options = {
                        hasAuthenticationInsight: Boolean(body.authenticationInsight && body.merchantAccountId)
                    };
                    return {
                        query: createMutation(options),
                        variables: createCreditCardForFastlaneTokenizationBody(body, options),
                        operationName: "TokenizeCreditCardForPayPalConnect"
                    };
                }
                module1.exports = creditCardForFastlaneTokenization;
            },
            {
                "../../../../lib/assign": 140
            }
        ],
        105: [
            function(_dereq_, module1, exports) {
                "use strict";
                var assign = _dereq_("../../../../lib/assign").assign;
                function createMutation(config) {
                    var hasAuthenticationInsight = config.hasAuthenticationInsight;
                    var mutation = "mutation TokenizeCreditCard($input: TokenizeCreditCardInput!";
                    if (hasAuthenticationInsight) mutation += ", $authenticationInsightInput: AuthenticationInsightInput!";
                    mutation += ") {   tokenizeCreditCard(input: $input) {     token     creditCard {       bin       brandCode       last4       cardholderName       expirationMonth      expirationYear      binData {         prepaid         healthcare         debit         durbinRegulated         commercial         payroll         issuingBank         countryOfIssuance         productId       }     } ";
                    if (hasAuthenticationInsight) mutation += "    authenticationInsight(input: $authenticationInsightInput) {      customerAuthenticationRegulationEnvironment    }";
                    mutation += "  } }";
                    return mutation;
                }
                function createCreditCardTokenizationBody(body, options) {
                    var cc = body.creditCard;
                    var billingAddress = cc && cc.billingAddress;
                    var expDate = cc && cc.expirationDate;
                    var expirationMonth = cc && (cc.expirationMonth || expDate && expDate.split("/")[0].trim());
                    var expirationYear = cc && (cc.expirationYear || expDate && expDate.split("/")[1].trim());
                    var variables = {
                        input: {
                            creditCard: {
                                number: cc && cc.number,
                                expirationMonth: expirationMonth,
                                expirationYear: expirationYear,
                                cvv: cc && cc.cvv,
                                cardholderName: cc && cc.cardholderName
                            },
                            options: {}
                        }
                    };
                    if (options.hasAuthenticationInsight) variables.authenticationInsightInput = {
                        merchantAccountId: body.merchantAccountId
                    };
                    if (billingAddress) variables.input.creditCard.billingAddress = billingAddress;
                    variables.input = addValidationRule(body, variables.input);
                    return variables;
                }
                function addValidationRule(body, input) {
                    var validate;
                    if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === "boolean") validate = body.creditCard.options.validate;
                    else if (body.authorizationFingerprint && body.tokenizationKey || body.authorizationFingerprint) validate = true;
                    else if (body.tokenizationKey) validate = false;
                    if (typeof validate === "boolean") input.options = assign({
                        validate: validate
                    }, input.options);
                    return input;
                }
                function creditCardTokenization(body) {
                    var options = {
                        hasAuthenticationInsight: Boolean(body.authenticationInsight && body.merchantAccountId)
                    };
                    return {
                        query: createMutation(options),
                        variables: createCreditCardTokenizationBody(body, options),
                        operationName: "TokenizeCreditCard"
                    };
                }
                module1.exports = creditCardTokenization;
            },
            {
                "../../../../lib/assign": 140
            }
        ],
        106: [
            function(_dereq_, module1, exports) {
                "use strict";
                var features = {
                    tokenize_credit_cards: "payment_methods/credit_cards",
                    configuration: "configuration"
                };
                var disallowedInputPaths = [
                    "creditCard.options.unionPayEnrollment"
                ];
                function GraphQL(config) {
                    this._config = config.graphQL;
                }
                GraphQL.prototype.getGraphQLEndpoint = function() {
                    return this._config.url;
                };
                GraphQL.prototype.isGraphQLRequest = function(url, body) {
                    var featureEnabled;
                    var path = this.getClientApiPath(url);
                    if (!this._isGraphQLEnabled() || !path) return false;
                    featureEnabled = this._config.features.some(function(feature) {
                        return features[feature] === path;
                    });
                    if (containsDisallowedlistedKeys(body)) return false;
                    return featureEnabled;
                };
                GraphQL.prototype.getClientApiPath = function(url) {
                    var path;
                    var clientApiPrefix = "/client_api/v1/";
                    var pathParts = url.split(clientApiPrefix);
                    if (pathParts.length > 1) path = pathParts[1].split("?")[0];
                    return path;
                };
                GraphQL.prototype._isGraphQLEnabled = function() {
                    return Boolean(this._config);
                };
                function containsDisallowedlistedKeys(body) {
                    return disallowedInputPaths.some(function(keys) {
                        var value = keys.split(".").reduce(function(accumulator, key) {
                            return accumulator && accumulator[key];
                        }, body);
                        return value !== undefined; // eslint-disable-line no-undefined
                    });
                }
                module1.exports = GraphQL;
            },
            {}
        ],
        107: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BRAINTREE_VERSION = _dereq_("../../constants").BRAINTREE_VERSION;
                var assign = _dereq_("../../../lib/assign").assign;
                var snakeCaseToCamelCase = _dereq_("../../../lib/snake-case-to-camel-case");
                var isFastlaneCheckout = _dereq_("../../../lib/is-fastlane-checkout");
                var creditCardTokenizationBodyGenerator = _dereq_("./generators/credit-card-tokenization");
                var creditCardTokenizationResponseAdapter = _dereq_("./adapters/credit-card-tokenization");
                var creditCardTokenizationFastlaneResponseAdapter = _dereq_("./adapters/credit-card-tokenization-fastlane");
                var creditCardForFastlaneTokenizationBodyGenerator = _dereq_("./generators/credit-card-for-fastlane-tokenization");
                var configurationBodyGenerator = _dereq_("./generators/configuration");
                var configurationResponseAdapter = _dereq_("./adapters/configuration");
                var generators = {
                    "payment_methods/credit_cards": function(data, isFastlane) {
                        if (isFastlane) // Only want to use this generator when using the Fastlane flow
                        return creditCardForFastlaneTokenizationBodyGenerator(data);
                        return creditCardTokenizationBodyGenerator(data);
                    },
                    configuration: configurationBodyGenerator
                };
                var adapters = {
                    "payment_methods/credit_cards": function(parsedBody, context, isFastlane) {
                        if (isFastlane) // Only want to use this adapter when using the Fastlane flow
                        return creditCardTokenizationFastlaneResponseAdapter(parsedBody, context);
                        return creditCardTokenizationResponseAdapter(parsedBody, context);
                    },
                    configuration: configurationResponseAdapter
                };
                function GraphQLRequest(options) {
                    var clientApiPath = options.graphQL.getClientApiPath(options.url);
                    this._graphQL = options.graphQL;
                    this._data = options.data;
                    this._method = options.method;
                    this._headers = options.headers;
                    this._clientSdkMetadata = {
                        source: options.metadata.source,
                        integration: options.metadata.integration,
                        sessionId: options.metadata.sessionId
                    };
                    this._sendAnalyticsEvent = options.sendAnalyticsEvent || Function.prototype;
                    this._generator = generators[clientApiPath];
                    this._adapter = adapters[clientApiPath];
                    this._sendAnalyticsEvent("graphql.init");
                }
                GraphQLRequest.prototype.getUrl = function() {
                    return this._graphQL.getGraphQLEndpoint();
                };
                GraphQLRequest.prototype.getBody = function() {
                    var formattedBody = formatBodyKeys(this._data);
                    var generatedBody = this._generator(formattedBody, // Since this is used for all GQL requests, we only want this if it's a Fastlane Tokenization request
                    isFastlaneCheckout(this._data.creditCard));
                    var body = assign({
                        clientSdkMetadata: this._clientSdkMetadata
                    }, generatedBody);
                    return JSON.stringify(body);
                };
                GraphQLRequest.prototype.getMethod = function() {
                    return "POST";
                };
                GraphQLRequest.prototype.getHeaders = function() {
                    var authorization, headers;
                    if (this._data.authorizationFingerprint) {
                        this._sendAnalyticsEvent("graphql.authorization-fingerprint");
                        authorization = this._data.authorizationFingerprint;
                    } else {
                        this._sendAnalyticsEvent("graphql.tokenization-key");
                        authorization = this._data.tokenizationKey;
                    }
                    headers = {
                        Authorization: "Bearer " + authorization,
                        "Braintree-Version": BRAINTREE_VERSION
                    };
                    return assign({}, this._headers, headers);
                };
                GraphQLRequest.prototype.adaptResponseBody = function(parsedBody) {
                    return this._adapter(parsedBody, this, // Since this is used for all GQL requests, we only want this if it's a Fastlane Checkout Tokenization request
                    "creditCard" in this._data && isFastlaneCheckout(this._data.creditCard));
                };
                GraphQLRequest.prototype.determineStatus = function(httpStatus, parsedResponse) {
                    var status, errorClass;
                    if (httpStatus === 200) {
                        errorClass = parsedResponse.errors && parsedResponse.errors[0] && parsedResponse.errors[0].extensions && parsedResponse.errors[0].extensions.errorClass;
                        if (parsedResponse.data && !parsedResponse.errors) status = 200;
                        else if (errorClass === "VALIDATION") status = 422;
                        else if (errorClass === "AUTHORIZATION") status = 403;
                        else if (errorClass === "AUTHENTICATION") status = 401;
                        else if (isGraphQLError(errorClass, parsedResponse)) status = 403;
                        else status = 500;
                    } else if (!httpStatus) status = 500;
                    else status = httpStatus;
                    this._sendAnalyticsEvent("graphql.status." + httpStatus);
                    this._sendAnalyticsEvent("graphql.determinedStatus." + status);
                    return status;
                };
                function isGraphQLError(errorClass, parsedResponse) {
                    return !errorClass && parsedResponse.errors[0].message;
                }
                /**
 * @ignore
 * This function formats the body consistently so _everything_ is camelCase.
 * @param {object} originalBody the body to format
 * @returns {object} The formatted object
 */ function formatBodyKeys(originalBody) {
                    var body = {};
                    Object.keys(originalBody).forEach(function(key) {
                        var camelCaseKey = snakeCaseToCamelCase(key);
                        if (typeof originalBody[key] === "object") body[camelCaseKey] = formatBodyKeys(originalBody[key]);
                        else if (typeof originalBody[key] === "number") body[camelCaseKey] = String(originalBody[key]);
                        else body[camelCaseKey] = originalBody[key];
                    });
                    return body;
                }
                module1.exports = GraphQLRequest;
            },
            {
                "../../../lib/assign": 140,
                "../../../lib/is-fastlane-checkout": 171,
                "../../../lib/snake-case-to-camel-case": 179,
                "../../constants": 93,
                "./adapters/configuration": 99,
                "./adapters/credit-card-tokenization": 101,
                "./adapters/credit-card-tokenization-fastlane": 100,
                "./generators/configuration": 103,
                "./generators/credit-card-for-fastlane-tokenization": 104,
                "./generators/credit-card-tokenization": 105
            }
        ],
        108: [
            function(_dereq_, module1, exports) {
                "use strict";
                var once = _dereq_("../../lib/once");
                var AJAXDriver = _dereq_("./ajax-driver");
                module1.exports = function(options, cb) {
                    cb = once(cb || Function.prototype);
                    options.method = (options.method || "GET").toUpperCase();
                    options.timeout = options.timeout == null ? 60000 : options.timeout;
                    options.data = options.data || {};
                    AJAXDriver.request(options, cb);
                };
            },
            {
                "../../lib/once": 176,
                "./ajax-driver": 97
            }
        ],
        109: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function(body) {
                    try {
                        body = JSON.parse(body);
                    } catch (e) {
                    /* ignored */ }
                    return body;
                };
            },
            {}
        ],
        110: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function(method, body) {
                    if (typeof method !== "string") throw new Error("Method must be a string");
                    if (method.toLowerCase() !== "get" && body != null) body = typeof body === "string" ? body : JSON.stringify(body);
                    return body;
                };
            },
            {}
        ],
        111: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isXHRAvailable = typeof window !== "undefined" && window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest();
                function getRequestObject() {
                    return isXHRAvailable ? new window.XMLHttpRequest() : new window.XDomainRequest();
                }
                module1.exports = {
                    isAvailable: isXHRAvailable,
                    getRequestObject: getRequestObject
                };
            },
            {}
        ],
        112: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Data Collector - Creation Error Codes
 * @description Errors that occur when [creating the Data Collector component](./module-braintree-web_data-collector.html#.create).
 * @property {MERCHANT} DATA_COLLECTOR_KOUNT_NOT_ENABLED Occurs when Kount is enabled in creation options but is not enabled on the Braintree control panel.
 * @property {MERCHANT} DATA_COLLECTOR_KOUNT_ERROR Occurs when Kount errors while setting up.
 * @property {MERCHANT} DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS Occurs when Kount or PayPal Fraudnet could not be enabled.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    DATA_COLLECTOR_KOUNT_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "DATA_COLLECTOR_KOUNT_NOT_ENABLED",
                        message: "Kount is not enabled for this merchant."
                    },
                    DATA_COLLECTOR_KOUNT_ERROR: {
                        type: BraintreeError.types.MERCHANT,
                        code: "DATA_COLLECTOR_KOUNT_ERROR"
                    },
                    DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS",
                        message: "Data Collector must be created with Kount and/or PayPal."
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        113: [
            function(_dereq_, module1, exports) {
                "use strict";
                var FRAUDNET_FNCLS = _dereq_("../lib/constants").FRAUDNET_FNCLS;
                var FRAUDNET_SOURCE = _dereq_("../lib/constants").FRAUDNET_SOURCE;
                var FRAUDNET_URL = _dereq_("../lib/constants").FRAUDNET_URL;
                var loadScript = _dereq_("../lib/assets").loadScript;
                var TRUNCATION_LENGTH = 32;
                var cachedSessionId;
                function setup(options) {
                    var fraudNet = new Fraudnet();
                    options = options || {};
                    if (!options.sessionId && cachedSessionId) {
                        fraudNet.sessionId = cachedSessionId;
                        return Promise.resolve(fraudNet);
                    }
                    return fraudNet.initialize(options);
                }
                function clearSessionIdCache() {
                    cachedSessionId = null;
                }
                function Fraudnet() {}
                Fraudnet.prototype.initialize = function(options) {
                    var environment = options.environment;
                    var self1 = this;
                    this.sessionId = options.sessionId || options.clientSessionId;
                    if (this.sessionId) this.sessionId = this.sessionId.substring(0, TRUNCATION_LENGTH);
                    if (!options.sessionId) cachedSessionId = this.sessionId;
                    this._beaconId = _generateBeaconId(this.sessionId);
                    this._parameterBlock = _createParameterBlock(this.sessionId, this._beaconId, environment);
                    return loadScript({
                        src: FRAUDNET_URL
                    }).then(function(block) {
                        self1._thirdPartyBlock = block;
                        return self1;
                    })["catch"](function() {
                        // if the fraudnet script fails to load
                        // we just resolve with nothing
                        // and data collector ignores it
                        return null;
                    });
                };
                Fraudnet.prototype.teardown = function() {
                    removeElementIfOnPage(document.querySelector('iframe[title="ppfniframe"]'));
                    removeElementIfOnPage(document.querySelector('iframe[title="pbf"]'));
                    removeElementIfOnPage(this._parameterBlock);
                    removeElementIfOnPage(this._thirdPartyBlock);
                };
                function removeElementIfOnPage(element) {
                    if (element && element.parentNode) element.parentNode.removeChild(element);
                }
                function _generateBeaconId(sessionId) {
                    var timestamp = new Date().getTime() / 1000;
                    return "https://b.stats.paypal.com/counter.cgi?i=127.0.0.1&p=" + sessionId + "&t=" + timestamp + "&a=14";
                }
                function _createParameterBlock(sessionId, beaconId, environment) {
                    var el = document.body.appendChild(document.createElement("script"));
                    var config = {
                        f: sessionId,
                        s: FRAUDNET_SOURCE,
                        b: beaconId
                    };
                    // for some reason, the presence of the sandbox
                    // attribute in a production environment causes
                    // some weird behavior with what url paths are
                    // hit, so instead, we only apply this attribute
                    // when it is not a production environment
                    if (environment !== "production") config.sandbox = true;
                    el.type = "application/json";
                    el.setAttribute("fncls", FRAUDNET_FNCLS);
                    el.text = JSON.stringify(config);
                    return el;
                }
                module1.exports = {
                    setup: setup,
                    clearSessionIdCache: clearSessionIdCache
                };
            },
            {
                "../lib/assets": 139,
                "../lib/constants": 145
            }
        ],
        114: [
            function(_dereq_, module1, exports) {
                "use strict";
                /** @module braintree-web/data-collector */ var kount = _dereq_("./kount");
                var fraudnet = _dereq_("./fraudnet");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var methods = _dereq_("../lib/methods");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var errors = _dereq_("./errors");
                /**
 * @class
 * @global
 * @name DataCollector
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/data-collector.create|braintree-web.data-collector.create} instead.</strong>
 * @classdesc This class is used for fraud integration with PayPal and Kount. Instances of this class have {@link DataCollector#deviceData|deviceData} which is used to correlate user sessions with server transactions.
 */ /**
 * @memberof DataCollector
 * @name deviceData
 * @type string
 * @description JSON string to pass with server transactions.
 * @instance
 */ /**
 * @memberof DataCollector
 * @name rawDeviceData
 * @type object
 * @description The device data as an object instead of a string.
 * @instance
 */ /**
 * @memberof DataCollector
 * @name teardown
 * @function
 * @description Cleanly remove anything set up by {@link module:braintree-web/data-collector.create|create}.
 * @param {callback} [callback] Called on completion. If no callback is provided, `teardown` returns a promise.
 * @instance
 * @example
 * dataCollectorInstance.teardown();
 * @example <caption>With callback</caption>
 * dataCollectorInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ /**
 * @memberof DataCollector
 * @name getDeviceData
 * @function
 * @description Resolves with device data once it is ready.
 * @param {object} [options] Options for how device data is resolved.
 * @param {boolean} [options.raw=false] When set to true, the device data will resolve as an object instead of a JSON string.
 * @param {callback} [callback] Called on completion. If no callback is provided, `getDeviceData` returns a promise.
 * @instance
 * @example
 * dataCollectorInstance.getDeviceData();
 * @example <caption>Without options</caption>
 * dataCollectorInstance.getDeviceData().then(function (deviceData) {
 *   // typeof deviceData === 'string'
 *   // pass onto your server with the payment method nonce
 * });
 * @example <caption>With options</caption>
 * dataCollectorInstance.getDeviceData({
 *   raw: true
 * }).then(function (deviceData) {
 *   // typeof deviceData === 'object'
 *   // for if you'd like to parse the data before sending it to your server
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ /**
 * @static
 * @function create
 * @description Creates a DataCollector instance and collects device data based on your merchant configuration. We recommend that you call this method as early as possible, e.g. as soon as your website loads. If that's too early, call it at the beginning of customer checkout.
 * **Note:** To use your own Kount ID, contact our support team ([support@braintreepayments.com](mailto:support@braintreepayments.com) or [877.434.2894](tel:877.434.2894)).
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Data Collector instance to be available right away by fetching the client configuration in the background. When this option is used, {@link GooglePayment#getDeviceData} must be used to collect the device data.
 * @param {boolean} [options.kount] Kount fraud data collection will occur if the merchant configuration has it enabled.
 * **Note:** the data sent to Kount is asynchronous and may not have completed by the time the data collector create call is complete. In most cases, this will not matter, but if you create the data collector instance and immediately navigate away from the page, the device information may fail to be sent to Kount.
 * @param {boolean} [options.paypal] *Deprecated:* PayPal fraud data collection will occur when the DataCollector instance is created.
 * @param {string} [options.riskCorrelationId] Pass a custom risk correlation id when creating the data collector.
 * @param {string} [options.clientMetadataId] Deprecated. Use `options.riskCorrelationId` instead.
 * @param {string} [options.correlationId] Deprecated. Use `options.riskCorrelationId` instead.
 * @param {callback} [callback] The second argument, `data`, is the {@link DataCollector} instance.
 * @returns {(Promise|void)} Returns a promise that resolves the {@link DataCollector} instance if no callback is provided.
 */ function create(options) {
                    var name = "Data Collector";
                    var result = {
                        _instances: []
                    };
                    var data;
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        result._instantiatedWithAClient = !options.useDeferredClient;
                        result._createPromise = createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        }).then(function(client) {
                            var kountInstance;
                            var config = client.getConfiguration();
                            if (options.kount === true && config.gatewayConfiguration.kount) {
                                try {
                                    kountInstance = kount.setup({
                                        environment: config.gatewayConfiguration.environment,
                                        merchantId: config.gatewayConfiguration.kount.kountMerchantId
                                    });
                                } catch (err) {
                                    return Promise.reject(new BraintreeError({
                                        type: errors.DATA_COLLECTOR_KOUNT_ERROR.type,
                                        code: errors.DATA_COLLECTOR_KOUNT_ERROR.code,
                                        message: err.message
                                    }));
                                }
                                data = kountInstance.deviceData;
                                result._instances.push(kountInstance);
                            } else data = {};
                            return Promise.resolve(client);
                        }).then(function(client) {
                            var clientConfiguration = client.getConfiguration();
                            return fraudnet.setup({
                                sessionId: options.riskCorrelationId || options.clientMetadataId || options.correlationId,
                                clientSessionId: clientConfiguration.analyticsMetadata.sessionId,
                                environment: clientConfiguration.gatewayConfiguration.environment
                            }).then(function(fraudnetInstance) {
                                if (fraudnetInstance) {
                                    data.correlation_id = fraudnetInstance.sessionId; // eslint-disable-line camelcase
                                    result._instances.push(fraudnetInstance);
                                }
                            });
                        }).then(function() {
                            if (result._instances.length === 0) // NEXT_MAJOR_VERSION either this should error with a specific error that
                            // no data collector instances could be set up, or we should just swallow
                            // the error and document that no device data will be returned if
                            // data collector cannot be instantiated. We can't change the error code here
                            // without possibly breaking merchant integrations relying on this inccorrect
                            // behavior.
                            return Promise.reject(new BraintreeError(errors.DATA_COLLECTOR_REQUIRES_CREATE_OPTIONS));
                            result.deviceData = JSON.stringify(data);
                            result.rawDeviceData = data;
                            return result;
                        });
                        result.teardown = createTeardownMethod(result);
                        result.getDeviceData = createGetDeviceDataMethod(result);
                        if (result._instantiatedWithAClient) return result._createPromise;
                        return result;
                    });
                }
                function createTeardownMethod(result) {
                    return wrapPromise(function teardown() {
                        return result._createPromise.then(function() {
                            result._instances.forEach(function(instance) {
                                if (instance) instance.teardown();
                            });
                            convertMethodsToError(result, methods(result));
                        });
                    });
                }
                function createGetDeviceDataMethod(result) {
                    return wrapPromise(function getDeviceData(options) {
                        options = options || {};
                        return result._createPromise.then(function() {
                            if (options.raw) return Promise.resolve(result.rawDeviceData);
                            return Promise.resolve(result.deviceData);
                        });
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/convert-methods-to-error": 146,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "../lib/methods": 175,
                "./errors": 112,
                "./fraudnet": 113,
                "./kount": 115,
                "@braintree/wrap-promise": 40
            }
        ],
        115: [
            function(_dereq_, module1, exports) {
                "use strict";
                var sjcl = _dereq_("./vendor/sjcl");
                var camelCaseToSnakeCase = _dereq_("../lib/camel-case-to-snake-case");
                var QA_URL = "https://assets.qa.braintreepayments.com/data";
                var IFRAME_ID_PREFIX = "braintreeDataFrame-";
                var environmentUrls = {
                    development: QA_URL,
                    qa: QA_URL,
                    sandbox: "https://assets.braintreegateway.com/sandbox/data",
                    production: "https://assets.braintreegateway.com/data"
                };
                var cachedDeviceData = {};
                function setup(o) {
                    var options = o != null ? o : {};
                    return new Kount(options);
                }
                function Kount(options) {
                    var previouslyInitializedDeviceData = Kount.getCachedDeviceData(options.merchantId);
                    if (previouslyInitializedDeviceData) {
                        this.deviceData = previouslyInitializedDeviceData;
                        this._isCached = true;
                        return;
                    }
                    this._currentEnvironment = this._initializeEnvironment(options);
                    sjcl.random.startCollectors();
                    this._deviceSessionId = this._generateDeviceSessionId();
                    this.deviceData = this._getDeviceData();
                    Kount.setCachedDeviceData(options.merchantId, this.deviceData);
                    this._iframe = this._setupIFrame();
                }
                Kount.getCachedDeviceData = function(merchantId) {
                    return cachedDeviceData[merchantId];
                };
                Kount.setCachedDeviceData = function(merchantId, data) {
                    cachedDeviceData[merchantId] = data;
                };
                Kount.prototype.teardown = function() {
                    if (!this._isCached) {
                        sjcl.random.stopCollectors();
                        this._removeIframe();
                    }
                };
                Kount.prototype._removeIframe = function() {
                    this._iframe.parentNode.removeChild(this._iframe);
                };
                Kount.prototype._getDeviceData = function() {
                    return camelCaseToSnakeCase({
                        deviceSessionId: this._deviceSessionId,
                        fraudMerchantId: this._currentEnvironment.id
                    });
                };
                Kount.prototype._generateDeviceSessionId = function() {
                    var bits, hexString;
                    bits = sjcl.random.randomWords(4, 0);
                    hexString = sjcl.codec.hex.fromBits(bits);
                    return hexString;
                };
                Kount.prototype._setupIFrame = function() {
                    var params, iframe;
                    var self1 = this;
                    params = "?m=" + this._currentEnvironment.id + "&s=" + this._deviceSessionId;
                    iframe = document.createElement("iframe");
                    iframe.width = 1;
                    iframe.id = IFRAME_ID_PREFIX + this._deviceSessionId;
                    iframe.height = 1;
                    iframe.frameBorder = 0;
                    iframe.scrolling = "no";
                    iframe.style.position = "fixed";
                    iframe.style.left = "-999999px";
                    iframe.style.top = "-999999px";
                    iframe.title = "Braintree-Kount-iframe";
                    iframe.setAttribute("aria-hidden", "true");
                    document.body.appendChild(iframe);
                    setTimeout(function() {
                        iframe.src = self1._currentEnvironment.url + "/logo.htm" + params;
                        iframe.innerHTML = '<img src="' + self1._currentEnvironment.url + "/logo.gif" + params + '" alt="" />';
                    }, 10);
                    return iframe;
                };
                Kount.prototype._initializeEnvironment = function(options) {
                    var url = environmentUrls[options.environment];
                    if (url == null) throw new Error(options.environment + " is not a valid environment for kount.environment");
                    return {
                        url: url,
                        name: options.environment,
                        id: options.merchantId
                    };
                };
                module1.exports = {
                    setup: setup,
                    Kount: Kount,
                    environmentUrls: environmentUrls
                };
            },
            {
                "../lib/camel-case-to-snake-case": 144,
                "./vendor/sjcl": 116
            }
        ],
        116: [
            function(_dereq_, module1, exports) {
                "use strict";
                var sjcl = {
                    cipher: {},
                    hash: {},
                    keyexchange: {},
                    mode: {},
                    misc: {},
                    codec: {},
                    exception: {
                        corrupt: function corrupt(a) {
                            this.toString = function() {
                                return "CORRUPT: " + this.message;
                            };
                            this.message = a;
                        },
                        invalid: function invalid(a) {
                            this.toString = function() {
                                return "INVALID: " + this.message;
                            };
                            this.message = a;
                        },
                        bug: function bug(a) {
                            this.toString = function() {
                                return "BUG: " + this.message;
                            };
                            this.message = a;
                        },
                        notReady: function notReady(a) {
                            this.toString = function() {
                                return "NOT READY: " + this.message;
                            };
                            this.message = a;
                        }
                    }
                };
                sjcl.cipher.aes = function(a) {
                    this.l[0][0][0] || this.G();
                    var b, c, d, e, f = this.l[0][4], g = this.l[1];
                    b = a.length;
                    var k = 1;
                    if (4 !== b && 6 !== b && 8 !== b) throw new sjcl.exception.invalid("invalid aes key size");
                    this.b = [
                        d = a.slice(0),
                        e = []
                    ];
                    for(a = b; a < 4 * b + 28; a++){
                        c = d[a - 1];
                        if (0 === a % b || 8 === b && 4 === a % b) c = f[c >>> 24] << 24 ^ f[c >> 16 & 255] << 16 ^ f[c >> 8 & 255] << 8 ^ f[c & 255], 0 === a % b && (c = c << 8 ^ c >>> 24 ^ k << 24, k = k << 1 ^ 283 * (k >> 7));
                        d[a] = d[a - b] ^ c;
                    }
                    for(b = 0; a; b++, a--)c = d[b & 3 ? a : a - 4], e[b] = 4 >= a || 4 > b ? c : g[0][f[c >>> 24]] ^ g[1][f[c >> 16 & 255]] ^ g[2][f[c >> 8 & 255]] ^ g[3][f[c & 255]];
                };
                sjcl.cipher.aes.prototype = {
                    encrypt: function encrypt(a) {
                        return t(this, a, 0);
                    },
                    decrypt: function decrypt(a) {
                        return t(this, a, 1);
                    },
                    l: [
                        [
                            [],
                            [],
                            [],
                            [],
                            []
                        ],
                        [
                            [],
                            [],
                            [],
                            [],
                            []
                        ]
                    ],
                    G: function G() {
                        var _$a = this.l[0], b = this.l[1], c = _$a[4], d = b[4], e, f, g, k = [], l = [], p, n, h, m;
                        for(e = 0; 0x100 > e; e++)l[(k[e] = e << 1 ^ 283 * (e >> 7)) ^ e] = e;
                        for(f = g = 0; !c[f]; f ^= p || 1, g = l[g] || 1)for(h = g ^ g << 1 ^ g << 2 ^ g << 3 ^ g << 4, h = h >> 8 ^ h & 255 ^ 99, c[f] = h, d[h] = f, n = k[e = k[p = k[f]]], m = 0x1010101 * n ^ 0x10001 * e ^ 0x101 * p ^ 0x1010100 * f, n = 0x101 * k[h] ^ 0x1010100 * h, e = 0; 4 > e; e++)_$a[e][f] = n = n << 24 ^ n >>> 8, b[e][h] = m = m << 24 ^ m >>> 8;
                        for(e = 0; 5 > e; e++)_$a[e] = _$a[e].slice(0), b[e] = b[e].slice(0);
                    }
                };
                function t(a, b, c) {
                    if (4 !== b.length) throw new sjcl.exception.invalid("invalid aes block size");
                    var d = a.b[c], e = b[0] ^ d[0], f = b[c ? 3 : 1] ^ d[1], g = b[2] ^ d[2];
                    b = b[c ? 1 : 3] ^ d[3];
                    var k, l, p, n = d.length / 4 - 2, h, m = 4, q = [
                        0,
                        0,
                        0,
                        0
                    ];
                    k = a.l[c];
                    a = k[0];
                    var r = k[1], v = k[2], w = k[3], x = k[4];
                    for(h = 0; h < n; h++)k = a[e >>> 24] ^ r[f >> 16 & 255] ^ v[g >> 8 & 255] ^ w[b & 255] ^ d[m], l = a[f >>> 24] ^ r[g >> 16 & 255] ^ v[b >> 8 & 255] ^ w[e & 255] ^ d[m + 1], p = a[g >>> 24] ^ r[b >> 16 & 255] ^ v[e >> 8 & 255] ^ w[f & 255] ^ d[m + 2], b = a[b >>> 24] ^ r[e >> 16 & 255] ^ v[f >> 8 & 255] ^ w[g & 255] ^ d[m + 3], m += 4, e = k, f = l, g = p;
                    for(h = 0; 4 > h; h++)q[c ? 3 & -h : h] = x[e >>> 24] << 24 ^ x[f >> 16 & 255] << 16 ^ x[g >> 8 & 255] << 8 ^ x[b & 255] ^ d[m++], k = e, e = f, f = g, g = b, b = k;
                    return q;
                }
                sjcl.bitArray = {
                    bitSlice: function bitSlice(a, b, c) {
                        a = sjcl.bitArray.M(a.slice(b / 32), 32 - (b & 31)).slice(1);
                        return void 0 === c ? a : sjcl.bitArray.clamp(a, c - b);
                    },
                    extract: function extract(a, b, c) {
                        var d = Math.floor(-b - c & 31);
                        return ((b + c - 1 ^ b) & -32 ? a[b / 32 | 0] << 32 - d ^ a[b / 32 + 1 | 0] >>> d : a[b / 32 | 0] >>> d) & (1 << c) - 1;
                    },
                    concat: function concat(a, b) {
                        if (0 === a.length || 0 === b.length) return a.concat(b);
                        var c = a[a.length - 1], d = sjcl.bitArray.getPartial(c);
                        return 32 === d ? a.concat(b) : sjcl.bitArray.M(b, d, c | 0, a.slice(0, a.length - 1));
                    },
                    bitLength: function bitLength(a) {
                        var b = a.length;
                        return 0 === b ? 0 : 32 * (b - 1) + sjcl.bitArray.getPartial(a[b - 1]);
                    },
                    clamp: function clamp(a, b) {
                        if (32 * a.length < b) return a;
                        a = a.slice(0, Math.ceil(b / 32));
                        var c = a.length;
                        b = b & 31;
                        0 < c && b && (a[c - 1] = sjcl.bitArray.partial(b, a[c - 1] & 2147483648 >> b - 1, 1));
                        return a;
                    },
                    partial: function partial(a, b, c) {
                        return 32 === a ? b : (c ? b | 0 : b << 32 - a) + 0x10000000000 * a;
                    },
                    getPartial: function getPartial(a) {
                        return Math.round(a / 0x10000000000) || 32;
                    },
                    equal: function equal(a, b) {
                        if (sjcl.bitArray.bitLength(a) !== sjcl.bitArray.bitLength(b)) return !1;
                        var c = 0, d;
                        for(d = 0; d < a.length; d++)c |= a[d] ^ b[d];
                        return 0 === c;
                    },
                    M: function M(a, b, c, d) {
                        var e;
                        e = 0;
                        for(void 0 === d && (d = []); 32 <= b; b -= 32)d.push(c), c = 0;
                        if (0 === b) return d.concat(a);
                        for(e = 0; e < a.length; e++)d.push(c | a[e] >>> b), c = a[e] << 32 - b;
                        e = a.length ? a[a.length - 1] : 0;
                        a = sjcl.bitArray.getPartial(e);
                        d.push(sjcl.bitArray.partial(b + a & 31, 32 < b + a ? c : d.pop(), 1));
                        return d;
                    },
                    Y: function Y(a, b) {
                        return [
                            a[0] ^ b[0],
                            a[1] ^ b[1],
                            a[2] ^ b[2],
                            a[3] ^ b[3]
                        ];
                    },
                    byteswapM: function byteswapM(a) {
                        var b, c;
                        for(b = 0; b < a.length; ++b)c = a[b], a[b] = c >>> 24 | c >>> 8 & 0xff00 | (c & 0xff00) << 8 | c << 24;
                        return a;
                    }
                };
                sjcl.codec.utf8String = {
                    fromBits: function fromBits(a) {
                        var b = "", c = sjcl.bitArray.bitLength(a), d, e;
                        for(d = 0; d < c / 8; d++)0 === (d & 3) && (e = a[d / 4]), b += String.fromCharCode(e >>> 8 >>> 8 >>> 8), e <<= 8;
                        return decodeURIComponent(escape(b));
                    },
                    toBits: function toBits(a) {
                        a = unescape(encodeURIComponent(a));
                        var b = [], c, d = 0;
                        for(c = 0; c < a.length; c++)d = d << 8 | a.charCodeAt(c), 3 === (c & 3) && (b.push(d), d = 0);
                        c & 3 && b.push(sjcl.bitArray.partial(8 * (c & 3), d));
                        return b;
                    }
                };
                sjcl.codec.hex = {
                    fromBits: function fromBits(a) {
                        var b = "", c;
                        for(c = 0; c < a.length; c++)b += ((a[c] | 0) + 0xf00000000000).toString(16).substr(4);
                        return b.substr(0, sjcl.bitArray.bitLength(a) / 4);
                    },
                    toBits: function toBits(a) {
                        var b, c = [], d;
                        a = a.replace(/\s|0x/g, "");
                        d = a.length;
                        a = a + "00000000";
                        for(b = 0; b < a.length; b += 8)c.push(parseInt(a.substr(b, 8), 16) ^ 0);
                        return sjcl.bitArray.clamp(c, 4 * d);
                    }
                };
                sjcl.hash.sha256 = function(a) {
                    this.b[0] || this.G();
                    a ? (this.u = a.u.slice(0), this.o = a.o.slice(0), this.h = a.h) : this.reset();
                };
                sjcl.hash.sha256.hash = function(a) {
                    return new sjcl.hash.sha256().update(a).finalize();
                };
                sjcl.hash.sha256.prototype = {
                    blockSize: 512,
                    reset: function reset() {
                        this.u = this.K.slice(0);
                        this.o = [];
                        this.h = 0;
                        return this;
                    },
                    update: function update(a) {
                        "string" === typeof a && (a = sjcl.codec.utf8String.toBits(a));
                        var b, c = this.o = sjcl.bitArray.concat(this.o, a);
                        b = this.h;
                        a = this.h = b + sjcl.bitArray.bitLength(a);
                        if (0x1fffffffffffff < a) throw new sjcl.exception.invalid("Cannot hash more than 2^53 - 1 bits");
                        if ("undefined" !== typeof Uint32Array) {
                            var d = new Uint32Array(c), e = 0;
                            for(b = 512 + b - (512 + b & 0x1ff); b <= a; b += 512)u(this, d.subarray(16 * e, 16 * (e + 1))), e += 1;
                            c.splice(0, 16 * e);
                        } else for(b = 512 + b - (512 + b & 0x1ff); b <= a; b += 512)u(this, c.splice(0, 16));
                        return this;
                    },
                    finalize: function finalize() {
                        var _$a, b = this.o, c = this.u, b = sjcl.bitArray.concat(b, [
                            sjcl.bitArray.partial(1, 1)
                        ]);
                        for(_$a = b.length + 2; _$a & 15; _$a++)b.push(0);
                        b.push(Math.floor(this.h / 0x100000000));
                        for(b.push(this.h | 0); b.length;)u(this, b.splice(0, 16));
                        this.reset();
                        return c;
                    },
                    K: [],
                    b: [],
                    G: function G() {
                        function a(a) {
                            return 0x100000000 * (a - Math.floor(a)) | 0;
                        }
                        for(var b = 0, c = 2, d, e; 64 > b; c++){
                            e = !0;
                            for(d = 2; d * d <= c; d++)if (0 === c % d) {
                                e = !1;
                                break;
                            }
                            e && (8 > b && (this.K[b] = a(Math.pow(c, 0.5))), this.b[b] = a(Math.pow(c, 1 / 3)), b++);
                        }
                    }
                };
                function u(a, b) {
                    var c, d, e, f = a.u, g = a.b, k = f[0], l = f[1], p = f[2], n = f[3], h = f[4], m = f[5], q = f[6], r = f[7];
                    for(c = 0; 64 > c; c++)16 > c ? d = b[c] : (d = b[c + 1 & 15], e = b[c + 14 & 15], d = b[c & 15] = (d >>> 7 ^ d >>> 18 ^ d >>> 3 ^ d << 25 ^ d << 14) + (e >>> 17 ^ e >>> 19 ^ e >>> 10 ^ e << 15 ^ e << 13) + b[c & 15] + b[c + 9 & 15] | 0), d = d + r + (h >>> 6 ^ h >>> 11 ^ h >>> 25 ^ h << 26 ^ h << 21 ^ h << 7) + (q ^ h & (m ^ q)) + g[c], r = q, q = m, m = h, h = n + d | 0, n = p, p = l, l = k, k = d + (l & p ^ n & (l ^ p)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0;
                    f[0] = f[0] + k | 0;
                    f[1] = f[1] + l | 0;
                    f[2] = f[2] + p | 0;
                    f[3] = f[3] + n | 0;
                    f[4] = f[4] + h | 0;
                    f[5] = f[5] + m | 0;
                    f[6] = f[6] + q | 0;
                    f[7] = f[7] + r | 0;
                }
                sjcl.prng = function(a) {
                    this.c = [
                        new sjcl.hash.sha256()
                    ];
                    this.i = [
                        0
                    ];
                    this.H = 0;
                    this.v = {};
                    this.F = 0;
                    this.J = {};
                    this.L = this.f = this.j = this.T = 0;
                    this.b = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    this.g = [
                        0,
                        0,
                        0,
                        0
                    ];
                    this.C = void 0;
                    this.D = a;
                    this.s = !1;
                    this.B = {
                        progress: {},
                        seeded: {}
                    };
                    this.m = this.S = 0;
                    this.w = 1;
                    this.A = 2;
                    this.O = 0x10000;
                    this.I = [
                        0,
                        48,
                        64,
                        96,
                        128,
                        192,
                        0x100,
                        384,
                        512,
                        768,
                        1024
                    ];
                    this.P = 3e4;
                    this.N = 80;
                };
                sjcl.prng.prototype = {
                    randomWords: function randomWords(a, b) {
                        var c = [], d;
                        d = this.isReady(b);
                        var e;
                        if (d === this.m) throw new sjcl.exception.notReady("generator isn't seeded");
                        if (d & this.A) {
                            d = !(d & this.w);
                            e = [];
                            var f = 0, g;
                            this.L = e[0] = new Date().valueOf() + this.P;
                            for(g = 0; 16 > g; g++)e.push(0x100000000 * Math.random() | 0);
                            for(g = 0; g < this.c.length && (e = e.concat(this.c[g].finalize()), f += this.i[g], this.i[g] = 0, d || !(this.H & 1 << g)); g++);
                            this.H >= 1 << this.c.length && (this.c.push(new sjcl.hash.sha256()), this.i.push(0));
                            this.f -= f;
                            f > this.j && (this.j = f);
                            this.H++;
                            this.b = sjcl.hash.sha256.hash(this.b.concat(e));
                            this.C = new sjcl.cipher.aes(this.b);
                            for(d = 0; 4 > d && (this.g[d] = this.g[d] + 1 | 0, !this.g[d]); d++);
                        }
                        for(d = 0; d < a; d += 4)0 === (d + 1) % this.O && y(this), e = z(this), c.push(e[0], e[1], e[2], e[3]);
                        y(this);
                        return c.slice(0, a);
                    },
                    setDefaultParanoia: function setDefaultParanoia(a, b) {
                        if (0 === a && "Setting paranoia=0 will ruin your security; use it only for testing" !== b) throw new sjcl.exception.invalid("Setting paranoia=0 will ruin your security; use it only for testing");
                        this.D = a;
                    },
                    addEntropy: function addEntropy(a, b, c) {
                        c = c || "user";
                        var d, e, f = new Date().valueOf(), g = this.v[c], k = this.isReady(), l = 0;
                        d = this.J[c];
                        void 0 === d && (d = this.J[c] = this.T++);
                        void 0 === g && (g = this.v[c] = 0);
                        this.v[c] = (this.v[c] + 1) % this.c.length;
                        switch(typeof a === "undefined" ? "undefined" : (0, $iHOCm._)(a)){
                            case "number":
                                void 0 === b && (b = 1);
                                this.c[g].update([
                                    d,
                                    this.F++,
                                    1,
                                    b,
                                    f,
                                    1,
                                    a | 0
                                ]);
                                break;
                            case "object":
                                c = Object.prototype.toString.call(a);
                                if ("[object Uint32Array]" === c) {
                                    e = [];
                                    for(c = 0; c < a.length; c++)e.push(a[c]);
                                    a = e;
                                } else for("[object Array]" !== c && (l = 1), c = 0; c < a.length && !l; c++)"number" !== typeof a[c] && (l = 1);
                                if (!l) {
                                    if (void 0 === b) for(c = b = 0; c < a.length; c++)for(e = a[c]; 0 < e;)b++, e = e >>> 1;
                                    this.c[g].update([
                                        d,
                                        this.F++,
                                        2,
                                        b,
                                        f,
                                        a.length
                                    ].concat(a));
                                }
                                break;
                            case "string":
                                void 0 === b && (b = a.length);
                                this.c[g].update([
                                    d,
                                    this.F++,
                                    3,
                                    b,
                                    f,
                                    a.length
                                ]);
                                this.c[g].update(a);
                                break;
                            default:
                                l = 1;
                        }
                        if (l) throw new sjcl.exception.bug("random: addEntropy only supports number, array of numbers or string");
                        this.i[g] += b;
                        this.f += b;
                        k === this.m && (this.isReady() !== this.m && A("seeded", Math.max(this.j, this.f)), A("progress", this.getProgress()));
                    },
                    isReady: function isReady(a) {
                        a = this.I[void 0 !== a ? a : this.D];
                        return this.j && this.j >= a ? this.i[0] > this.N && new Date().valueOf() > this.L ? this.A | this.w : this.w : this.f >= a ? this.A | this.m : this.m;
                    },
                    getProgress: function getProgress(a) {
                        a = this.I[a ? a : this.D];
                        return this.j >= a ? 1 : this.f > a ? 1 : this.f / a;
                    },
                    startCollectors: function startCollectors() {
                        if (!this.s) {
                            this.a = {
                                loadTimeCollector: B(this, this.V),
                                mouseCollector: B(this, this.W),
                                keyboardCollector: B(this, this.U),
                                accelerometerCollector: B(this, this.R),
                                touchCollector: B(this, this.X)
                            };
                            if (window.addEventListener) window.addEventListener("load", this.a.loadTimeCollector, !1), window.addEventListener("mousemove", this.a.mouseCollector, !1), window.addEventListener("keypress", this.a.keyboardCollector, !1), window.addEventListener("devicemotion", this.a.accelerometerCollector, !1), window.addEventListener("touchmove", this.a.touchCollector, !1);
                            else if (document.attachEvent) document.attachEvent("onload", this.a.loadTimeCollector), document.attachEvent("onmousemove", this.a.mouseCollector), document.attachEvent("keypress", this.a.keyboardCollector);
                            else throw new sjcl.exception.bug("can't attach event");
                            this.s = !0;
                        }
                    },
                    stopCollectors: function stopCollectors() {
                        this.s && (window.removeEventListener ? (window.removeEventListener("load", this.a.loadTimeCollector, !1), window.removeEventListener("mousemove", this.a.mouseCollector, !1), window.removeEventListener("keypress", this.a.keyboardCollector, !1), window.removeEventListener("devicemotion", this.a.accelerometerCollector, !1), window.removeEventListener("touchmove", this.a.touchCollector, !1)) : document.detachEvent && (document.detachEvent("onload", this.a.loadTimeCollector), document.detachEvent("onmousemove", this.a.mouseCollector), document.detachEvent("keypress", this.a.keyboardCollector)), this.s = !1);
                    },
                    addEventListener: function addEventListener(a, b) {
                        this.B[a][this.S++] = b;
                    },
                    removeEventListener: function removeEventListener(a, b) {
                        var c, d, e = this.B[a], f = [];
                        for(d in e)e.hasOwnProperty(d) && e[d] === b && f.push(d);
                        for(c = 0; c < f.length; c++)d = f[c], delete e[d];
                    },
                    U: function U() {
                        C(this, 1);
                    },
                    W: function W(a) {
                        var b, c;
                        try {
                            b = a.x || a.clientX || a.offsetX || 0, c = a.y || a.clientY || a.offsetY || 0;
                        } catch (d) {
                            c = b = 0;
                        }
                        0 != b && 0 != c && this.addEntropy([
                            b,
                            c
                        ], 2, "mouse");
                        C(this, 0);
                    },
                    X: function X(a) {
                        a = a.touches[0] || a.changedTouches[0];
                        this.addEntropy([
                            a.pageX || a.clientX,
                            a.pageY || a.clientY
                        ], 1, "touch");
                        C(this, 0);
                    },
                    V: function V() {
                        C(this, 2);
                    },
                    R: function R(a) {
                        a = a.accelerationIncludingGravity.x || a.accelerationIncludingGravity.y || a.accelerationIncludingGravity.z;
                        if (window.orientation) {
                            var b = window.orientation;
                            "number" === typeof b && this.addEntropy(b, 1, "accelerometer");
                        }
                        a && this.addEntropy(a, 2, "accelerometer");
                        C(this, 0);
                    }
                };
                function A(a, b) {
                    var c, d = sjcl.random.B[a], e = [];
                    for(c in d)d.hasOwnProperty(c) && e.push(d[c]);
                    for(c = 0; c < e.length; c++)e[c](b);
                }
                function C(a, b) {
                    "undefined" !== typeof window && window.performance && "function" === typeof window.performance.now ? a.addEntropy(window.performance.now(), b, "loadtime") : a.addEntropy(new Date().valueOf(), b, "loadtime");
                }
                function y(a) {
                    a.b = z(a).concat(z(a));
                    a.C = new sjcl.cipher.aes(a.b);
                }
                function z(a) {
                    for(var b = 0; 4 > b && (a.g[b] = a.g[b] + 1 | 0, !a.g[b]); b++);
                    return a.C.encrypt(a.g);
                }
                function B(a, b) {
                    return function() {
                        b.apply(a, arguments);
                    };
                }
                sjcl.random = new sjcl.prng(6);
                a: try {
                    var D, E, F, G;
                    if (G = "undefined" !== typeof module1 && module1.exports) {
                        var H;
                        try {
                            H = _dereq_("crypto");
                        } catch (a) {
                            H = null;
                        }
                        G = E = H;
                    }
                    if (G && E.randomBytes) D = E.randomBytes(128), D = new Uint32Array(new Uint8Array(D).buffer), sjcl.random.addEntropy(D, 1024, "crypto['randomBytes']");
                    else if ("undefined" !== typeof window && "undefined" !== typeof Uint32Array) {
                        F = new Uint32Array(32);
                        if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(F);
                        else if (window.msCrypto && window.msCrypto.getRandomValues) window.msCrypto.getRandomValues(F);
                        else break a;
                        sjcl.random.addEntropy(F, 1024, "crypto['getRandomValues']");
                    }
                } catch (a) {
                    "undefined" !== typeof window && window.console && (console.log("There was an error collecting entropy from the browser:"), console.log(a));
                }
                "undefined" !== typeof module1 && module1.exports && (module1.exports = sjcl);
                "function" === typeof define && define([], function() {
                    return sjcl;
                });
            },
            {
                crypto: undefined
            }
        ],
        117: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    FASTLANE_SDK_LOAD_ERROR: {
                        type: BraintreeError.types.MERCHANT,
                        code: "FASTLANE_SDK_LOAD_ERROR"
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        118: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../lib/braintree-error");
                var errors = _dereq_("./errors");
                var loadFastlane = _dereq_("../lib/assets").loadFastlane;
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var assign = _dereq_("../lib/assign").assign;
                function fastlane(options) {
                    var config = options.client.getConfiguration();
                    var sdkVersion = options.client.getVersion();
                    var environment = config.gatewayConfiguration.environment;
                    var minified = true;
                    if (environment !== "production") minified = false;
                    return loadFastlane(assign({
                        platform: "BT",
                        btSdkVersion: sdkVersion,
                        minified: minified
                    }, options)).then(function(result) {
                        var platformOptions = {
                            platform: "BT",
                            authorization: options.authorization,
                            client: options.client,
                            deviceData: options.deviceData
                        };
                        // We need the following options to be nested inside platformOptions rather than
                        // top level
                        delete options.authorization;
                        delete options.client;
                        delete options.deviceData;
                        // The following are options that we know are needed for the Fastlane Loader, but which
                        // we know are not needed for initializing the fastlane sdk.
                        delete options.minified;
                        delete options.btSdkVersion;
                        return window.braintree.fastlane.create(assign({
                            platformOptions: platformOptions
                        }, options, result.metadata));
                    })["catch"](function(err) {
                        return Promise.reject(new BraintreeError({
                            type: errors.FASTLANE_SDK_LOAD_ERROR.type,
                            code: errors.FASTLANE_SDK_LOAD_ERROR.code,
                            message: err.message
                        }));
                    });
                }
                module1.exports = wrapPromise(fastlane);
            },
            {
                "../lib/assets": 139,
                "../lib/assign": 140,
                "../lib/braintree-error": 143,
                "./errors": 117,
                "@braintree/wrap-promise": 40
            }
        ],
        119: [
            function(_dereq_, module1, exports) {
                "use strict";
                /** @module braintree-web/fastlane */ var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var fastlane = _dereq_("./fastlane");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var VERSION = "3.110.0";
                var assign = _dereq_("../lib/assign").assign;
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {string} [options.deviceData] A {@link DataCollector} instance.
 * @example
 * braintree.fastlane.create({
 *   client: clientInstance,
 *   deviceData: dataCollectorInstance
 * }).then(function (fastlaneInstance) {
 *   // fastlaneInstance is ready to create an identity instance.
 *     identity = fastlaneInstance.identity
 * }).catch(function (createErr) {
 *   console.error('Error creating fastlane instance', createErr);
 * });
 * @example <caption>Creating a fastlane component</caption>
 * braintree.fastlane.create({
 *   client: clientInstance,
 *   deviceData: dataCollectorInstance
 * }).then(function (fastlaneInstance) {
 *   // fastlaneInstance is ready to create an identity instance.
 *     identity = fastlaneInstance.identity
 * }).catch(function (createErr) {
 *   console.error('Error creating fastlane instance', createErr);
 * });
 * @returns {(Promise|void)} Returns the fastlane instance.
 */ function create(options) {
                    var name = "fastlane";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        return fastlane(assign({
                            client: client,
                            deviceData: options.deviceData
                        }, options));
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/assign": 140,
                "../lib/basic-component-verification": 141,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./fastlane": 118,
                "@braintree/wrap-promise": 40
            }
        ],
        120: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Google Payment - Creation Error Codes
 * @description Errors that occur when [creating the Google Payment component](./module-braintree-web_google-payment.html#.create).
 * @property {MERCHANT} GOOGLE_PAYMENT_NOT_ENABLED Occurs when Google Pay is not enabled on the Braintree control panel.
 * @property {MERCHANT} GOOGLE_PAYMENT_UNSUPPORTED_VERSION Occurs when a Google Pay version is used that is not supported by the Braintree SDK.
 */ /**
 * @name BraintreeError.Google Payment - parseResponse Error Codes
 * @description Errors that occur when [parsing the response from Google](./GooglePayment.html#parseResponse).
 * @property {UNKNOWN} GOOGLE_PAYMENT_GATEWAY_ERROR Occurs when Google Pay could not be tokenized.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    GOOGLE_PAYMENT_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "GOOGLE_PAYMENT_NOT_ENABLED",
                        message: "Google Pay is not enabled for this merchant."
                    },
                    GOOGLE_PAYMENT_GATEWAY_ERROR: {
                        code: "GOOGLE_PAYMENT_GATEWAY_ERROR",
                        message: "There was an error when tokenizing the Google Pay payment method.",
                        type: BraintreeError.types.UNKNOWN
                    },
                    GOOGLE_PAYMENT_UNSUPPORTED_VERSION: {
                        code: "GOOGLE_PAYMENT_UNSUPPORTED_VERSION",
                        type: BraintreeError.types.MERCHANT
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        121: [
            function(_dereq_, module1, exports) {
                "use strict";
                var analytics = _dereq_("../lib/analytics");
                var assign = _dereq_("../lib/assign").assign;
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var find = _dereq_("../lib/find");
                var generateGooglePayConfiguration = _dereq_("../lib/generate-google-pay-configuration");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var errors = _dereq_("./errors");
                var methods = _dereq_("../lib/methods");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var CREATE_PAYMENT_DATA_REQUEST_METHODS = {
                    1: "_createV1PaymentDataRequest",
                    2: "_createV2PaymentDataRequest"
                };
                /**
 * @typedef {object} GooglePayment~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {boolean} details.isNetworkTokenized True if the card is network tokenized.
 * @property {string} details.bin First six digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, `CreditCard` or `AndroidPayCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */ /**
 * @class GooglePayment
 * @param {object} options Google Payment {@link module:braintree-web/google-payment.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/google-payment.create|braintree-web.google-payment.create} instead.</strong>
 * @classdesc This class represents a Google Payment component produced by {@link module:braintree-web/google-payment.create|braintree-web/google-payment.create}. Instances of this class have methods for initializing the Google Pay flow.
 */ function GooglePayment(options) {
                    this._createPromise = options.createPromise;
                    this._client = options.client;
                    this._useDeferredClient = options.useDeferredClient;
                    // NEXT_MAJOR_VERSION this should be updated to 2 (or whatever the current latest version is)
                    this._googlePayVersion = options.googlePayVersion || 1;
                    this._googleMerchantId = options.googleMerchantId;
                    if (this._isUnsupportedGooglePayAPIVersion()) throw new BraintreeError({
                        code: errors.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.code,
                        message: "The Braintree SDK does not support Google Pay version " + this._googlePayVersion + ". Please upgrade the version of your Braintree SDK and contact support if this error persists.",
                        type: errors.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.type
                    });
                }
                GooglePayment.prototype._waitForClient = function() {
                    if (this._client) return Promise.resolve();
                    return this._createPromise.then((function(client) {
                        this._client = client;
                    }).bind(this));
                };
                GooglePayment.prototype._isUnsupportedGooglePayAPIVersion = function() {
                    // if we don't have createPaymentDatqRequest method for the specific
                    // API version, then the version is not supported
                    return !(this._googlePayVersion in CREATE_PAYMENT_DATA_REQUEST_METHODS);
                };
                GooglePayment.prototype._getDefaultConfig = function() {
                    if (!this._defaultConfig) this._defaultConfig = generateGooglePayConfiguration(this._client.getConfiguration(), this._googlePayVersion, this._googleMerchantId);
                    return this._defaultConfig;
                };
                GooglePayment.prototype._createV1PaymentDataRequest = function(paymentDataRequest) {
                    var defaultConfig = this._getDefaultConfig();
                    var overrideCardNetworks = paymentDataRequest.cardRequirements && paymentDataRequest.cardRequirements.allowedCardNetworks;
                    var defaultConfigCardNetworks = defaultConfig.cardRequirements.allowedCardNetworks;
                    var allowedCardNetworks = overrideCardNetworks || defaultConfigCardNetworks;
                    paymentDataRequest = assign({}, defaultConfig, paymentDataRequest);
                    // this way we can preserve allowedCardNetworks from default integration
                    // if merchant did not pass any in `cardRequirements`
                    paymentDataRequest.cardRequirements.allowedCardNetworks = allowedCardNetworks;
                    return paymentDataRequest;
                };
                GooglePayment.prototype._createV2PaymentDataRequest = function(paymentDataRequest) {
                    var defaultConfig = this._getDefaultConfig();
                    if (paymentDataRequest.allowedPaymentMethods) paymentDataRequest.allowedPaymentMethods.forEach(function(paymentMethod) {
                        var defaultPaymentMethod = find(defaultConfig.allowedPaymentMethods, "type", paymentMethod.type);
                        if (defaultPaymentMethod) applyDefaultsToPaymentMethodConfiguration(paymentMethod, defaultPaymentMethod);
                    });
                    paymentDataRequest = assign({}, defaultConfig, paymentDataRequest);
                    return paymentDataRequest;
                };
                /**
 * Create a configuration object for use in the `loadPaymentData` method.
 *
 * **Note**: Version 1 of the Google Pay Api is deprecated and will become unsupported in a future version. Until then, version 1 will continue to be used by default, and version 1 schema parameters and overrides will remain functional on existing integrations. However, new integrations and all following examples will be presented in the GooglePay version 2 schema. See [Google Pay's upgrade guide](https://developers.google.com/pay/api/web/guides/resources/update-to-latest-version) to see how to update your integration.
 *
 * If `options.googlePayVersion === 2` was set during the initial {@link module:braintree-web/google-payment.create|create} call, overrides must match the Google Pay v2 schema to be valid.
 *
 * @public
 * @param {object} overrides The supplied parameters for creating the PaymentDataRequest object. Required parameters are:
 *  @param {object} overrides.transactionInfo Object according to the [Google Pay Transaction Info](https://developers.google.com/pay/api/web/reference/object#TransactionInfo) spec.
 *  Optionally, any of the parameters in the [PaymentDataRequest](https://developers.google.com/pay/api/web/reference/object#PaymentDataRequest) parameters can be overridden, but note that it is recommended only to override top level parameters to avoid squashing deeply nested configuration objects. An example can be found below showing how to safely edit these deeply nested objects.
 * @example
 * var paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
 *   merchantInfo: {
 *     merchantId: 'my-merchant-id-from-google'
 *   },
 *   transactionInfo: {
 *     currencyCode: 'USD',
 *     totalPriceStatus: 'FINAL',
 *     totalPrice: '100.00'
 *   }
 * });
 *
 * // Update card payment methods to require billing address
 * var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods;
 * cardPaymentMethod.parameters.billingAddressRequired = true;
 * cardPaymentMethod.parameters.billingAddressParameters = {
 *   format: 'FULL',
 *   phoneNumberRequired: true
 * };
 *
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * })
 *
 * paymentsClient.loadPaymentData(paymentDataRequest).then(function (response) {
 *   // handle response with googlePaymentInstance.parseResponse
 *   // (see below)
 * });
 * @example <caption>With deferred client</caption>
 * googlePaymentInstance.createPaymentDataRequest({
 *   merchantInfo: {
 *     merchantId: 'my-merchant-id-from-google'
 *   },
 *   transactionInfo: {
 *     currencyCode: 'USD',
 *     totalPriceStatus: 'FINAL',
 *     totalPrice: '100.00'
 *   }
 * }).then(function (paymentDataRequest) {
 *   // Update card payment methods to require billing address
 *   var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods;
 *   cardPaymentMethod.parameters.billingAddressRequired = true;
 *   cardPaymentMethod.parameters.billingAddressParameters = {
 *     format: 'FULL',
 *     phoneNumberRequired: true
 *   };
 *
 *   var paymentsClient = new google.payments.api.PaymentsClient({
 *     environment: 'TEST' // or 'PRODUCTION'
 *   })
 *
 *   return paymentsClient.loadPaymentData(paymentDataRequest);
 * }).then(function (response) {
 *   // handle response with googlePaymentInstance.parseResponse
 *   // (see below)
 * });
 * @returns {object|Promise} Returns a configuration object for Google PaymentDataRequest. If instantiated with `useDeferredClient` and an `authorization` it will return a promise that resolves with the configuration.
 */ GooglePayment.prototype.createPaymentDataRequest = function(overrides) {
                    if (!this._useDeferredClient) return this._createPaymentDataRequestSyncronously(overrides);
                    return this._waitForClient().then((function() {
                        return this._createPaymentDataRequestSyncronously(overrides);
                    }).bind(this));
                };
                GooglePayment.prototype._createPaymentDataRequestSyncronously = function(overrides) {
                    var paymentDataRequest = assign({}, overrides);
                    var version = this._googlePayVersion;
                    var createPaymentDataRequestMethod = CREATE_PAYMENT_DATA_REQUEST_METHODS[version];
                    if (paymentDataRequest.transactionInfo && paymentDataRequest.transactionInfo.totalPrice) paymentDataRequest.transactionInfo.totalPrice = paymentDataRequest.transactionInfo.totalPrice.toString();
                    analytics.sendEvent(this._createPromise, "google-payment.v" + version + ".createPaymentDataRequest");
                    return this[createPaymentDataRequestMethod](paymentDataRequest);
                };
                /**
 * Parse the response from the tokenization.
 * @public
 * @param {object} response The response back from the Google Pay tokenization.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link GooglePay~tokenizePayload|tokenizePayload}. If no callback is provided, `parseResponse` returns a promise that resolves with a {@link GooglePayment~tokenizePayload|tokenizePayload}.
 * @example with callback
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * })
 *
 * paymentsClient.loadPaymentData(paymentDataRequestFromCreatePaymentDataRequest).then(function (response) {
 *   googlePaymentInstance.parseResponse(response, function (err, data) {
 *     if (err) {
 *       // handle errors
 *     }
 *     // send parsedResponse.nonce to your server
 *   });
 * });
 * @example with promise
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * })
 *
 * paymentsClient.loadPaymentData(paymentDataRequestFromCreatePaymentDataRequest).then(function (response) {
 *   return googlePaymentInstance.parseResponse(response);
 * }).then(function (parsedResponse) {
 *   // send parsedResponse.nonce to your server
 * }).catch(function (err) {
 *   // handle errors
 * });
 * @returns {(Promise|void)} Returns a promise that resolves the parsed response if no callback is provided.
 */ GooglePayment.prototype.parseResponse = function(response) {
                    var self1 = this;
                    return Promise.resolve().then(function() {
                        var payload;
                        var rawResponse = response.apiVersion === 2 ? response.paymentMethodData.tokenizationData.token : response.paymentMethodToken.token;
                        var parsedResponse = JSON.parse(rawResponse);
                        var error = parsedResponse.error;
                        if (error) return Promise.reject(error);
                        analytics.sendEvent(self1._createPromise, "google-payment.parseResponse.succeeded");
                        if (parsedResponse.paypalAccounts) {
                            payload = parsedResponse.paypalAccounts[0];
                            analytics.sendEvent(self1._createPromise, "google-payment.parseResponse.succeeded.paypal");
                            return Promise.resolve({
                                nonce: payload.nonce,
                                type: payload.type,
                                description: payload.description
                            });
                        }
                        payload = parsedResponse.androidPayCards[0];
                        analytics.sendEvent(self1._createPromise, "google-payment.parseResponse.succeeded.google-payment");
                        return Promise.resolve({
                            nonce: payload.nonce,
                            type: payload.type,
                            description: payload.description,
                            details: {
                                cardType: payload.details.cardType,
                                lastFour: payload.details.lastFour,
                                lastTwo: payload.details.lastTwo,
                                isNetworkTokenized: payload.details.isNetworkTokenized,
                                bin: payload.details.bin
                            },
                            binData: payload.binData
                        });
                    })["catch"](function(error) {
                        analytics.sendEvent(self1._createPromise, "google-payment.parseResponse.failed");
                        return Promise.reject(new BraintreeError({
                            code: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.code,
                            message: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.message,
                            type: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.type,
                            details: {
                                originalError: error
                            }
                        }));
                    });
                };
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/google-payment.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * googlePaymentInstance.teardown();
 * @example <caption>With callback</caption>
 * googlePaymentInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ GooglePayment.prototype.teardown = function() {
                    convertMethodsToError(this, methods(GooglePayment.prototype));
                    return Promise.resolve();
                };
                function applyDefaultsToPaymentMethodConfiguration(merchantSubmittedPaymentMethod, defaultPaymentMethod) {
                    Object.keys(defaultPaymentMethod).forEach(function(parameter) {
                        if (typeof defaultPaymentMethod[parameter] === "object") merchantSubmittedPaymentMethod[parameter] = assign({}, defaultPaymentMethod[parameter], merchantSubmittedPaymentMethod[parameter]);
                        else merchantSubmittedPaymentMethod[parameter] = merchantSubmittedPaymentMethod[parameter] || defaultPaymentMethod[parameter];
                    });
                }
                module1.exports = wrapPromise.wrapPrototype(GooglePayment);
            },
            {
                "../lib/analytics": 138,
                "../lib/assign": 140,
                "../lib/braintree-error": 143,
                "../lib/convert-methods-to-error": 146,
                "../lib/find": 156,
                "../lib/generate-google-pay-configuration": 168,
                "../lib/methods": 175,
                "./errors": 120,
                "@braintree/wrap-promise": 40
            }
        ],
        122: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/google-payment
 * @description A component to integrate with Google Pay. The majority of the integration uses [Google's pay.js JavaScript file](https://pay.google.com/gp/p/js/pay.js). The Braintree component generates the configuration object necessary for Google Pay to initiate the Payment Request and parse the returned data to retrieve the payment method nonce which is used to process the transaction on the server.
 */ var GooglePayment = _dereq_("./google-payment");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var VERSION = "3.110.0";
                var errors = _dereq_("./errors");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.useDeferredClient] Used in conjunction with `authorization`, allows the Google Payment instance to be available right away by fetching the client configuration in the background. When this option is used, {@link GooglePayment#createPaymentDataRequest} will return a promise that resolves with the configuration instead of returning synchronously.
 * @param {number} [options.googlePayVersion] The version of the Google Pay API to use. Value of 2 is required to accept parameters documented [by Google](https://developers.google.com/pay/api/web/reference/object). Omit this parameter to use the deprecated Google Pay Version 1.
 * @param {string} [options.googleMerchantId] A Google merchant identifier issued after your website is approved by Google. Required when PaymentsClient is initialized with an environment property of PRODUCTION, but may be omitted in TEST environment.
 * @param {callback} [callback] The second argument, `data`, is the {@link GooglePayment} instance. If no callback is provided, `create` returns a promise that resolves with the {@link GooglePayment} instance.
 * @example <caption>Simple Example</caption>
 * // include https://pay.google.com/gp/p/js/pay.js in a script tag
 * // on your page to load the `google.payments.api.PaymentsClient` global object.
 *
 * var paymentButton = document.querySelector('#google-pay-button');
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * });
 *
 * braintree.client.create({
 *   authorization: 'tokenization-key-or-client-token'
 * }).then(function (clientInstance) {
 *   return braintree.googlePayment.create({
 *     client: clientInstance,
 *      googlePayVersion: 2,
 *      googleMerchantId: 'your-merchant-id-from-google'
 *   });
 * }).then(function (googlePaymentInstance) {
 *   paymentButton.addEventListener('click', function (event) {
 *     var paymentDataRequest;
 *
 *     event.preventDefault();
 *
 *     paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
 *       transactionInfo: {
 *         currencyCode: 'USD',
 *         totalPriceStatus: 'FINAL',
 *         totalPrice: '100.00'
 *       }
 *     });
 *
 *     paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
 *       return googlePaymentInstance.parseResponse(paymentData);
 *     }).then(function (result) {
 *       // send result.nonce to your server
 *     }).catch(function (err) {
 *       // handle err
 *     });
 *   });
 * });
 * @example <caption>Check Browser and Customer Compatibility</caption>
 * var paymentsClient = new google.payments.api.PaymentsClient({
 *   environment: 'TEST' // or 'PRODUCTION'
 * });
 *
 * function setupGooglePayButton(googlePaymentInstance) {
 *   var button = document.createElement('button');
 *
 *   button.id = 'google-pay';
 *   button.appendChild(document.createTextNode('Google Pay'));
 *   button.addEventListener('click', function (event) {
 *     var paymentRequestData;
 *
 *     event.preventDefault();
 *
 *     paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
 *       transactionInfo: {
 *         currencyCode: 'USD',
 *         totalPriceStatus: 'FINAL',
 *         totalPrice: '100.00' // your amount
 *       }
 *     });
 *
 *     paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
 *       return googlePaymentInstance.parseResponse(paymentData);
 *       }).then(function (result) {
 *       // send result.nonce to your server
 *     }).catch(function (err) {
 *       // handle errors
 *     });
 *   });
 *
 *   document.getElementById('container').appendChild(button);
 * }
 *
 * braintree.client.create({
 *   authorization: 'tokenization-key-or-client-token'
 * }).then(function (clientInstance) {
 *   return braintree.googlePayment.create({
 *     client: clientInstance,
 *     googlePayVersion: 2,
 *     googleMerchantId: 'your-merchant-id-from-google'
 *   });
 * }).then(function (googlePaymentInstance) {
 *
 *   return paymentsClient.isReadyToPay({
 *     // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest for all options
 *     apiVersion: 2,
 *     apiVersionMinor: 0,
 *     allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
 *     existingPaymentMethodRequired: true
 *   });
 * }).then(function (response) {
 *   if (response.result) {
 *     setupGooglePayButton(googlePaymentInstance);
 *   }
 * }).catch(function (err) {
 *   // handle setup errors
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "Google Pay";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        var createPromise, instance;
                        createPromise = createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        }).then(function(client) {
                            var configuration = client.getConfiguration();
                            options.client = client;
                            if (!configuration.gatewayConfiguration.androidPay) return Promise.reject(new BraintreeError(errors.GOOGLE_PAYMENT_NOT_ENABLED));
                            return client;
                        });
                        options.createPromise = createPromise;
                        instance = new GooglePayment(options);
                        if (!options.useDeferredClient) return createPromise.then(function(client) {
                            instance._client = client;
                            return instance;
                        });
                        return instance;
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./errors": 120,
                "./google-payment": 121,
                "@braintree/wrap-promise": 40
            }
        ],
        123: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var errors = _dereq_("../shared/errors");
                var allowedAttributes = _dereq_("../shared/constants").allowedAttributes;
                function attributeValidationError(attribute, value) {
                    var err;
                    if (!allowedAttributes.hasOwnProperty(attribute)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.type,
                        code: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.code,
                        message: 'The "' + attribute + '" attribute is not supported in Hosted Fields.'
                    });
                    else if (value != null && !_isValid(attribute, value)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.type,
                        code: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.code,
                        message: 'Value "' + value + '" is not allowed for "' + attribute + '" attribute.'
                    });
                    return err;
                }
                function _isValid(attribute, value) {
                    if (allowedAttributes[attribute] === "string") return typeof value === "string" || typeof value === "number";
                    else if (allowedAttributes[attribute] === "boolean") return String(value) === "true" || String(value) === "false";
                    return false;
                }
                module1.exports = attributeValidationError;
            },
            {
                "../../lib/braintree-error": 143,
                "../shared/constants": 131,
                "../shared/errors": 132
            }
        ],
        124: [
            function(_dereq_, module1, exports) {
                "use strict";
                var constants = _dereq_("../shared/constants");
                var useMin = _dereq_("../../lib/use-min");
                module1.exports = function composeUrl(assetsUrl, componentId, isDebug) {
                    return assetsUrl + "/web/" + constants.VERSION + "/html/hosted-fields-frame" + useMin(isDebug) + ".html#" + componentId;
                };
            },
            {
                "../../lib/use-min": 180,
                "../shared/constants": 131
            }
        ],
        125: [
            function(_dereq_, module1, exports) {
                "use strict";
                var directions = _dereq_("../shared/constants").navigationDirections;
                var browserDetection = _dereq_("../shared/browser-detection");
                var focusIntercept = _dereq_("../shared/focus-intercept");
                var findParentTags = _dereq_("../shared/find-parent-tags");
                var userFocusableTagNames = [
                    "INPUT",
                    "SELECT",
                    "TEXTAREA"
                ];
                // Devices with software keyboards do not or cannot focus on input types
                // that do not require keyboard-based interaction.
                var unfocusedInputTypes = [
                    "hidden",
                    "button",
                    "reset",
                    "submit",
                    "checkbox",
                    "radio",
                    "file"
                ];
                function _isUserFocusableElement(element) {
                    if (!browserDetection.hasSoftwareKeyboard()) // on desktop browsers, the only input type that isn't focusable
                    // is the hidden input
                    return element.type !== "hidden";
                    return userFocusableTagNames.indexOf(element.tagName) > -1 && unfocusedInputTypes.indexOf(element.type) < 0;
                }
                function _createNavigationHelper(direction, numberOfElementsInForm) {
                    switch(direction){
                        case directions.BACK:
                            return {
                                checkIndexBounds: function checkIndexBounds(index) {
                                    return index < 0;
                                },
                                indexChange: -1
                            };
                        case directions.FORWARD:
                            return {
                                checkIndexBounds: function checkIndexBounds(index) {
                                    return index > numberOfElementsInForm - 1;
                                },
                                indexChange: 1
                            };
                        default:
                    }
                    return {};
                }
                function _findFirstFocusableElement(elementsInForm) {
                    var elementsIndex, element;
                    for(elementsIndex = 0; elementsIndex < elementsInForm.length; elementsIndex++){
                        element = elementsInForm[elementsIndex];
                        if (_isUserFocusableElement(element)) return element;
                    }
                    return null;
                }
                module1.exports = {
                    removeExtraFocusElements: function removeExtraFocusElements(checkoutForm, onRemoveFocusIntercepts) {
                        var elements = Array.prototype.slice.call(checkoutForm.elements);
                        var firstFocusableInput = _findFirstFocusableElement(elements);
                        var lastFocusableInput = _findFirstFocusableElement(elements.reverse());
                        // these should never be identical, because there will at least be the
                        // before and the after input
                        [
                            firstFocusableInput,
                            lastFocusableInput
                        ].forEach(function(input) {
                            if (!input) return;
                            if (focusIntercept.matchFocusElement(input.getAttribute("id"))) onRemoveFocusIntercepts(input.getAttribute("id"));
                        });
                    },
                    createFocusChangeHandler: function createFocusChangeHandler(hostedFieldsId, callbacks) {
                        return function(data) {
                            var currentIndex, targetElement, checkoutForm, navHelper;
                            var sourceElement = document.getElementById("bt-" + data.field + "-" + data.direction + "-" + hostedFieldsId);
                            if (!sourceElement) return;
                            checkoutForm = findParentTags(sourceElement, "form")[0];
                            if (document.forms.length < 1 || !checkoutForm) {
                                callbacks.onRemoveFocusIntercepts();
                                return;
                            }
                            checkoutForm = [].slice.call(checkoutForm.elements);
                            currentIndex = checkoutForm.indexOf(sourceElement);
                            navHelper = _createNavigationHelper(data.direction, checkoutForm.length);
                            do {
                                currentIndex += navHelper.indexChange;
                                if (navHelper.checkIndexBounds(currentIndex)) return;
                                targetElement = checkoutForm[currentIndex];
                            }while (!_isUserFocusableElement(targetElement));
                            if (focusIntercept.matchFocusElement(targetElement.getAttribute("id"))) callbacks.onTriggerInputFocus(targetElement.getAttribute("data-braintree-type"));
                            else targetElement.focus();
                        };
                    }
                };
            },
            {
                "../shared/browser-detection": 130,
                "../shared/constants": 131,
                "../shared/find-parent-tags": 133,
                "../shared/focus-intercept": 134
            }
        ],
        126: [
            function(_dereq_, module1, exports) {
                "use strict";
                var allowedStyles = _dereq_("../shared/constants").allowedStyles;
                module1.exports = function getStylesFromClass(cssClass) {
                    var element = document.createElement("input");
                    var styles = {};
                    var computedStyles;
                    if (cssClass[0] === ".") cssClass = cssClass.substring(1);
                    element.className = cssClass;
                    element.style.display = "none !important";
                    element.style.position = "fixed !important";
                    element.style.left = "-99999px !important";
                    element.style.top = "-99999px !important";
                    document.body.appendChild(element);
                    computedStyles = window.getComputedStyle(element);
                    allowedStyles.forEach(function(style) {
                        var value = computedStyles[style];
                        if (value) styles[style] = value;
                    });
                    document.body.removeChild(element);
                    return styles;
                };
            },
            {
                "../shared/constants": 131
            }
        ],
        127: [
            function(_dereq_, module1, exports) {
                "use strict";
                var assign = _dereq_("../../lib/assign").assign;
                var createAssetsUrl = _dereq_("../../lib/create-assets-url");
                var isVerifiedDomain = _dereq_("../../lib/is-verified-domain");
                var Destructor = _dereq_("../../lib/destructor");
                var iFramer = _dereq_("@braintree/iframer");
                var Bus = _dereq_("framebus");
                var createDeferredClient = _dereq_("../../lib/create-deferred-client");
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var composeUrl = _dereq_("./compose-url");
                var getStylesFromClass = _dereq_("./get-styles-from-class");
                var constants = _dereq_("../shared/constants");
                var errors = _dereq_("../shared/errors");
                var INTEGRATION_TIMEOUT_MS = _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
                var uuid = _dereq_("@braintree/uuid");
                var findParentTags = _dereq_("../shared/find-parent-tags");
                var browserDetection = _dereq_("../shared/browser-detection");
                var events = constants.events;
                var EventEmitter = _dereq_("@braintree/event-emitter");
                var injectFrame = _dereq_("./inject-frame");
                var analytics = _dereq_("../../lib/analytics");
                var allowedFields = constants.allowedFields;
                var methods = _dereq_("../../lib/methods");
                var shadow = _dereq_("../../lib/shadow");
                var findRootNode = _dereq_("../../lib/find-root-node");
                var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
                var sharedErrors = _dereq_("../../lib/errors");
                var getCardTypes = _dereq_("../shared/get-card-types");
                var attributeValidationError = _dereq_("./attribute-validation-error");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var focusChange = _dereq_("./focus-change");
                var destroyFocusIntercept = _dereq_("../shared/focus-intercept").destroy;
                var SAFARI_FOCUS_TIMEOUT = 5;
                /**
 * @typedef {object} HostedFields~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} authenticationInsight Info about the [regulatory environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) of the tokenized card. Only available if `authenticationInsight.merchantAccountId` is passed in the `tokenize` method options.
 * @property {string} authenticationInsight.regulationEnvironment The [regulation environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) for the tokenized card.
 * @property {object} details Additional account details.
 * @property {string} details.bin The BIN number of the card.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.expirationMonth The expiration month of the card.
 * @property {string} details.expirationYear The expiration year of the card.
 * @property {string} details.cardholderName The cardholder name tokenized with the card.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `CreditCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */ /**
 * @typedef {object} HostedFields~stateObject
 * @description The event payload sent from {@link HostedFields#on|on} or {@link HostedFields#getState|getState}.
 * @property {HostedFields~hostedFieldsCard[]} cards
 * This will return an array of potential {@link HostedFields~hostedFieldsCard|cards}. If the card type has been determined, the array will contain only one card.
 * Internally, Hosted Fields uses <a href="https://github.com/braintree/credit-card-type">credit-card-type</a>,
 * an open-source card detection library.
 * @property {string} emittedBy
 * The name of the field associated with an event. This will not be included if returned by {@link HostedFields#getState|getState}. It will be one of the following strings:<br>
 * - `"number"`
 * - `"cvv"`
 * - `"expirationDate"`
 * - `"expirationMonth"`
 * - `"expirationYear"`
 * - `"postalCode"`
 * - `"cardholderName"`
 * @property {object} fields
 * @property {?HostedFields~hostedFieldsFieldData} fields.number {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the number field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.cvv {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the CVV field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationDate {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration date field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationMonth {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration month field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationYear {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration year field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.postalCode {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the postal code field, if it is present.
 * @property {?HostedFields~hostedFieldsFieldData} fields.cardholderName {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the cardholder name field, if it is present.
 */ /**
 * @typedef {object} HostedFields~binPayload
 * @description The event payload sent from {@link HostedFields#on|on} when the {@link HostedFields#event:binAvailable|binAvailable} event is emitted.
 * @property {string} bin The first 6 digits of the card number.
 */ /**
 * @typedef {object} HostedFields~hostedFieldsFieldData
 * @description Data about Hosted Fields fields, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {HTMLElement} container Reference to the container DOM element on your page associated with the current event.
 * @property {boolean} isFocused Whether or not the input is currently focused.
 * @property {boolean} isEmpty Whether or not the user has entered a value in the input.
 * @property {boolean} isPotentiallyValid
 * A determination based on the future validity of the input value.
 * This is helpful when a user is entering a card number and types <code>"41"</code>.
 * While that value is not valid for submission, it is still possible for
 * it to become a fully qualified entry. However, if the user enters <code>"4x"</code>
 * it is clear that the card number can never become valid and isPotentiallyValid will
 * return false.
 * @property {boolean} isValid Whether or not the value of the associated input is <i>fully</i> qualified for submission.
 */ /**
 * @typedef {object} HostedFields~hostedFieldsCard
 * @description Information about the card type, sent in {@link HostedFields~stateObject|stateObjects}.
 * @property {string} type The code-friendly representation of the card type. It will be one of the following strings:
 * - `american-express`
 * - `diners-club`
 * - `discover`
 * - `jcb`
 * - `maestro`
 * - `master-card`
 * - `unionpay`
 * - `visa`
 * @property {string} niceType The pretty-printed card type. It will be one of the following strings:
 * - `American Express`
 * - `Diners Club`
 * - `Discover`
 * - `JCB`
 * - `Maestro`
 * - `MasterCard`
 * - `UnionPay`
 * - `Visa`
 * @property {object} code
 * This object contains data relevant to the security code requirements of the card brand.
 * For example, on a Visa card there will be a <code>CVV</code> of 3 digits, whereas an
 * American Express card requires a 4-digit <code>CID</code>.
 * @property {string} code.name <code>"CVV"</code> <code>"CID"</code> <code>"CVC"</code>
 * @property {number} code.size The expected length of the security code. Typically, this is 3 or 4.
 */ /**
 * @name HostedFields#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event.
 *
 * **Events that emit a {@link HostedFields~stateObject|stateObject}.**
 * * {@link HostedFields#event:blur|blur}
 * * {@link HostedFields#event:focus|focus}
 * * {@link HostedFields#event:empty|empty}
 * * {@link HostedFields#event:notEmpty|notEmpty}
 * * {@link HostedFields#event:cardTypeChange|cardTypeChange}
 * * {@link HostedFields#event:validityChange|validityChange}
 * * {@link HostedFields#event:inputSubmitRequest|inputSubmitRequest}
 *
 * **Other Events**
 * * {@link HostedFields#event:binAvailable|binAvailable} - emits a {@link HostedFields~binPayload|bin payload}. Note: If you are using a [Referrer-Policy](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referrer-Policy) header that prevents the origin from being sent, this event will not fire.
 * @example
 * <caption>Listening to a Hosted Field event, in this case 'focus'</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'has been focused');
 *   });
 * });
 * @returns {void}
 */ /**
 * @name HostedFields#off
 * @function
 * @param {string} event The name of the event to which you are unsubscribing.
 * @param {function} handler The callback for the event you are unsubscribing from.
 * @description Unsubscribes the handler function to a named event.
 * @example
 * <caption>Subscribing and then unsubscribing from a Hosted Field event, in this case 'focus'</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   var callback = function (event) {
 *     console.log(event.emittedBy, 'has been focused');
 *   };
 *   hostedFieldsInstance.on('focus', callback);
 *
 *   // later on
 *   hostedFieldsInstance.off('focus', callback);
 * });
 * @returns {void}
 */ /**
 * This event is emitted when the user requests submission of an input field, such as by pressing the Enter or Return key on their keyboard, or mobile equivalent.
 * @event HostedFields#inputSubmitRequest
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Clicking a submit button upon hitting Enter (or equivalent) within a Hosted Field</caption>
 * var hostedFields = require('braintree-web/hosted-fields');
 * var submitButton = document.querySelector('input[type="submit"]');
 *
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('inputSubmitRequest', function () {
 *     // User requested submission, e.g. by pressing Enter or equivalent
 *     submitButton.click();
 *   });
 * });
 */ /**
 * This event is emitted when a field transitions from having data to being empty.
 * @event HostedFields#empty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an empty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('empty', function (event) {
 *     console.log(event.emittedBy, 'is now empty');
 *   });
 * });
 */ /**
 * This event is emitted when a field transitions from being empty to having data.
 * @event HostedFields#notEmpty
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to an notEmpty event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('notEmpty', function (event) {
 *     console.log(event.emittedBy, 'is now not empty');
 *   });
 * });
 */ /**
 * This event is emitted when a field loses focus.
 * @event HostedFields#blur
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a blur event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('blur', function (event) {
 *     console.log(event.emittedBy, 'lost focus');
 *   });
 * });
 */ /**
 * This event is emitted when a field gains focus.
 * @event HostedFields#focus
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a focus event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('focus', function (event) {
 *     console.log(event.emittedBy, 'gained focus');
 *   });
 * });
 */ /**
 * This event is emitted when activity within the number field has changed such that the possible card type has changed.
 * @event HostedFields#cardTypeChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a cardTypeChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('cardTypeChange', function (event) {
 *     if (event.cards.length === 1) {
 *       console.log(event.cards[0].type);
 *     } else {
 *       console.log('Type of card not yet known');
 *     }
 *   });
 * });
 */ /**
 * This event is emitted when the validity of a field has changed. Validity is represented in the {@link HostedFields~stateObject|stateObject} as two booleans: `isValid` and `isPotentiallyValid`.
 * @event HostedFields#validityChange
 * @type {HostedFields~stateObject}
 * @example
 * <caption>Listening to a validityChange event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('validityChange', function (event) {
 *     var field = event.fields[event.emittedBy];
 *
 *     if (field.isValid) {
 *       console.log(event.emittedBy, 'is fully valid');
 *     } else if (field.isPotentiallyValid) {
 *       console.log(event.emittedBy, 'is potentially valid');
 *     } else {
 *       console.log(event.emittedBy, 'is not valid');
 *     }
 *   });
 * });
 */ /**
 * This event is emitted when the first 6 digits of the card number have been entered by the customer.
 * @event HostedFields#binAvailable
 * @type {string}
 * @example
 * <caption>Listening to a `binAvailable` event</caption>
 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
 *   hostedFieldsInstance.on('binAvailable', function (event) {
 *     event.bin // send bin to 3rd party bin service
 *   });
 * });
 */ function createInputEventHandler(fields) {
                    return function(eventData) {
                        var field;
                        var merchantPayload = eventData.merchantPayload;
                        var emittedBy = merchantPayload.emittedBy;
                        var container = fields[emittedBy].containerElement;
                        Object.keys(merchantPayload.fields).forEach(function(key) {
                            merchantPayload.fields[key].container = fields[key].containerElement;
                        });
                        field = merchantPayload.fields[emittedBy];
                        container.classList.toggle(constants.externalClasses.FOCUSED, field.isFocused);
                        container.classList.toggle(constants.externalClasses.VALID, field.isValid);
                        container.classList.toggle(constants.externalClasses.INVALID, !field.isPotentiallyValid);
                        // eslint-disable-next-line no-invalid-this
                        this._state = {
                            cards: merchantPayload.cards,
                            fields: merchantPayload.fields
                        };
                        this._emit(eventData.type, merchantPayload); // eslint-disable-line no-invalid-this
                    };
                }
                function isVisibleEnough(node) {
                    var boundingBox = node.getBoundingClientRect();
                    var verticalMidpoint = Math.floor(boundingBox.height / 2);
                    var horizontalMidpoint = Math.floor(boundingBox.width / 2);
                    return boundingBox.top < (window.innerHeight - verticalMidpoint || document.documentElement.clientHeight - verticalMidpoint) && boundingBox.right > horizontalMidpoint && boundingBox.bottom > verticalMidpoint && boundingBox.left < (window.innerWidth - horizontalMidpoint || document.documentElement.clientWidth - horizontalMidpoint);
                }
                /**
 * @class HostedFields
 * @param {object} options The Hosted Fields {@link module:braintree-web/hosted-fields.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/hosted-fields.create|braintree-web.hosted-fields.create} instead.</strong>
 * @classdesc This class represents a Hosted Fields component produced by {@link module:braintree-web/hosted-fields.create|braintree-web/hosted-fields.create}. Instances of this class have methods for interacting with the input fields within Hosted Fields' iframes.
 */ function HostedFields(options) {
                    var failureTimeout, clientConfig, assetsUrl, isDebug, hostedFieldsUrl;
                    var self1 = this;
                    var fields = {};
                    var frameReadyPromiseResolveFunctions = {};
                    var frameReadyPromises = [];
                    var componentId = uuid();
                    var sessionId = options.sessionId;
                    this._merchantConfigurationOptions = assign({}, options);
                    if (options.client) {
                        clientConfig = options.client.getConfiguration(undefined, sessionId); // eslint-disable-line no-undefined
                        assetsUrl = clientConfig.gatewayConfiguration.assetsUrl;
                        isDebug = clientConfig.isDebug;
                    } else {
                        assetsUrl = createAssetsUrl.create(options.authorization);
                        isDebug = Boolean(options.isDebug);
                    }
                    this._clientPromise = createDeferredClient.create({
                        client: options.client,
                        authorization: options.authorization,
                        debug: isDebug,
                        assetsUrl: assetsUrl,
                        name: "Hosted Fields",
                        sessionId: sessionId
                    });
                    hostedFieldsUrl = composeUrl(assetsUrl, componentId, isDebug);
                    if (!options.fields || Object.keys(options.fields).length === 0) throw new BraintreeError({
                        type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
                        code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
                        message: "options.fields is required when instantiating Hosted Fields."
                    });
                    EventEmitter.call(this);
                    this._injectedNodes = [];
                    this._destructor = new Destructor();
                    this._fields = fields;
                    this._state = {
                        fields: {},
                        cards: getCardTypes("")
                    };
                    this._bus = new Bus({
                        channel: componentId,
                        verifyDomain: isVerifiedDomain,
                        targetFrames: [
                            window
                        ]
                    });
                    this._destructor.registerFunctionForTeardown(function() {
                        self1._bus.teardown();
                    });
                    // NEXT_MAJOR_VERSION analytics events should have present tense verbs
                    if (!options.client) analytics.sendEvent(this._clientPromise, "custom.hosted-fields.initialized.deferred-client");
                    else analytics.sendEvent(this._clientPromise, "custom.hosted-fields.initialized");
                    Object.keys(options.fields).forEach((function(key) {
                        var field, externalContainer, internalContainer, frame, frameReadyPromise;
                        if (!constants.allowedFields.hasOwnProperty(key)) throw new BraintreeError({
                            type: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.type,
                            code: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.code,
                            message: '"' + key + '" is not a valid field.'
                        });
                        field = options.fields[key];
                        // NEXT_MAJOR_VERSION remove selector as an option
                        // and simply make the API take a container
                        externalContainer = field.container || field.selector;
                        if (typeof externalContainer === "string") externalContainer = document.querySelector(externalContainer);
                        if (!externalContainer || externalContainer.nodeType !== 1) throw new BraintreeError({
                            type: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.type,
                            code: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.code,
                            message: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.message,
                            details: {
                                fieldSelector: field.selector,
                                fieldContainer: field.container,
                                fieldKey: key
                            }
                        });
                        else if (externalContainer.querySelector('iframe[name^="braintree-"]')) throw new BraintreeError({
                            type: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.type,
                            code: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.code,
                            message: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.message,
                            details: {
                                fieldSelector: field.selector,
                                fieldContainer: field.container,
                                fieldKey: key
                            }
                        });
                        internalContainer = externalContainer;
                        if (shadow.isShadowElement(internalContainer)) internalContainer = shadow.transformToSlot(internalContainer, "height: 100%");
                        if (field.maxlength && typeof field.maxlength !== "number") throw new BraintreeError({
                            type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
                            code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
                            message: "The value for maxlength must be a number.",
                            details: {
                                fieldKey: key
                            }
                        });
                        if (field.minlength && typeof field.minlength !== "number") throw new BraintreeError({
                            type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
                            code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
                            message: "The value for minlength must be a number.",
                            details: {
                                fieldKey: key
                            }
                        });
                        frame = iFramer({
                            type: key,
                            name: "braintree-hosted-field-" + key,
                            style: constants.defaultIFrameStyle,
                            title: field.iframeTitle || "Secure Credit Card Frame - " + constants.allowedFields[key].label
                        });
                        this._bus.addTargetFrame(frame);
                        this._injectedNodes.push.apply(this._injectedNodes, injectFrame(componentId, frame, internalContainer, function() {
                            self1.focus(key);
                        }));
                        this._setupLabelFocus(key, externalContainer);
                        fields[key] = {
                            frameElement: frame,
                            containerElement: externalContainer
                        };
                        frameReadyPromise = new Promise(function(resolve) {
                            frameReadyPromiseResolveFunctions[key] = resolve;
                        });
                        frameReadyPromises.push(frameReadyPromise);
                        this._state.fields[key] = {
                            isEmpty: true,
                            isValid: false,
                            isPotentiallyValid: true,
                            isFocused: false,
                            container: externalContainer
                        };
                        // prevents loading the iframe from blocking the code
                        setTimeout(function() {
                            frame.src = hostedFieldsUrl;
                        }, 0);
                    }).bind(this));
                    if (this._merchantConfigurationOptions.styles) Object.keys(this._merchantConfigurationOptions.styles).forEach(function(selector) {
                        var className = self1._merchantConfigurationOptions.styles[selector];
                        if (typeof className === "string") self1._merchantConfigurationOptions.styles[selector] = getStylesFromClass(className);
                    });
                    this._bus.on(events.REMOVE_FOCUS_INTERCEPTS, function(data) {
                        destroyFocusIntercept(data && data.id);
                    });
                    this._bus.on(events.TRIGGER_FOCUS_CHANGE, focusChange.createFocusChangeHandler(componentId, {
                        onRemoveFocusIntercepts: function onRemoveFocusIntercepts(element) {
                            self1._bus.emit(events.REMOVE_FOCUS_INTERCEPTS, {
                                id: element
                            });
                        },
                        onTriggerInputFocus: function onTriggerInputFocus(targetType) {
                            self1.focus(targetType);
                        }
                    }));
                    this._bus.on(events.READY_FOR_CLIENT, function(reply) {
                        self1._clientPromise.then(function(client) {
                            reply(client);
                        });
                    });
                    this._bus.on(events.CARD_FORM_ENTRY_HAS_BEGUN, function() {
                        analytics.sendEvent(self1._clientPromise, "hosted-fields.input.started");
                    });
                    this._bus.on(events.BIN_AVAILABLE, function(bin) {
                        self1._emit("binAvailable", {
                            bin: bin
                        });
                    });
                    failureTimeout = setTimeout(function() {
                        analytics.sendEvent(self1._clientPromise, "custom.hosted-fields.load.timed-out");
                        self1._emit("timeout");
                    }, INTEGRATION_TIMEOUT_MS);
                    Promise.all(frameReadyPromises).then(function(results) {
                        var reply = results[0];
                        clearTimeout(failureTimeout);
                        reply(formatMerchantConfigurationForIframes(self1._merchantConfigurationOptions));
                        self1._cleanUpFocusIntercepts();
                        self1._emit("ready");
                    });
                    this._bus.on(events.FRAME_READY, function(data, reply) {
                        frameReadyPromiseResolveFunctions[data.field](reply);
                    });
                    this._bus.on(events.INPUT_EVENT, createInputEventHandler(fields).bind(this));
                    this._destructor.registerFunctionForTeardown(function() {
                        var j, node, parent;
                        for(j = 0; j < self1._injectedNodes.length; j++){
                            node = self1._injectedNodes[j];
                            parent = node.parentNode;
                            parent.removeChild(node);
                            parent.classList.remove(constants.externalClasses.FOCUSED, constants.externalClasses.INVALID, constants.externalClasses.VALID);
                        }
                    });
                    this._destructor.registerFunctionForTeardown(function() {
                        destroyFocusIntercept();
                    });
                    this._destructor.registerFunctionForTeardown(function() {
                        var methodNames = methods(HostedFields.prototype).concat(methods(EventEmitter.prototype));
                        convertMethodsToError(self1, methodNames);
                    });
                }
                EventEmitter.createChild(HostedFields);
                HostedFields.prototype._setupLabelFocus = function(type, container) {
                    var labels, i;
                    var self1 = this;
                    var rootNode = findRootNode(container);
                    if (container.id == null) return;
                    function triggerFocus() {
                        self1.focus(type);
                    }
                    // find any labels in the normal DOM
                    labels = Array.prototype.slice.call(document.querySelectorAll('label[for="' + container.id + '"]'));
                    if (rootNode !== document) // find any labels within the shadow dom
                    labels = labels.concat(Array.prototype.slice.call(rootNode.querySelectorAll('label[for="' + container.id + '"]')));
                    // find any labels surrounding the container that don't also have the `for` attribute
                    labels = labels.concat(findParentTags(container, "label"));
                    // filter out any accidental duplicates
                    labels = labels.filter(function(label, index, arr) {
                        return arr.indexOf(label) === index;
                    });
                    for(i = 0; i < labels.length; i++)labels[i].addEventListener("click", triggerFocus, false);
                    this._destructor.registerFunctionForTeardown(function() {
                        for(i = 0; i < labels.length; i++)labels[i].removeEventListener("click", triggerFocus, false);
                    });
                };
                HostedFields.prototype._getAnyFieldContainer = function() {
                    var self1 = this;
                    return Object.keys(this._fields).reduce(function(found, field) {
                        return found || self1._fields[field].containerElement;
                    }, null);
                };
                HostedFields.prototype._cleanUpFocusIntercepts = function() {
                    var iframeContainer, checkoutForm;
                    if (document.forms.length < 1) this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS);
                    else {
                        iframeContainer = this._getAnyFieldContainer();
                        checkoutForm = findParentTags(iframeContainer, "form")[0];
                        if (checkoutForm) focusChange.removeExtraFocusElements(checkoutForm, (function(id) {
                            this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS, {
                                id: id
                            });
                        }).bind(this));
                        else this._bus.emit(events.REMOVE_FOCUS_INTERCEPTS);
                    }
                };
                HostedFields.prototype._attachInvalidFieldContainersToError = function(err) {
                    if (!(err.details && err.details.invalidFieldKeys && err.details.invalidFieldKeys.length > 0)) return;
                    err.details.invalidFields = {};
                    err.details.invalidFieldKeys.forEach((function(field) {
                        err.details.invalidFields[field] = this._fields[field].containerElement;
                    }).bind(this));
                };
                /**
 * Get card verification challenges, such as requirements for cvv and postal code.
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. If no callback is provided, `getChallenges` returns a promise.
 * @example
 * hostedFieldsInstance.getChallenges().then(function (challenges) {
 *   challenges // ['cvv', 'postal_code']
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.getChallenges = function() {
                    return this._clientPromise.then(function(client) {
                        return client.getConfiguration().gatewayConfiguration.challenges;
                    });
                };
                /**
 * Get supported card types configured in the Braintree Control Panel
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. If no callback is provided, `getSupportedCardTypes` returns a promise.
 * @example
 * hostedFieldsInstance.getSupportedCardTypes().then(function (cardTypes) {
 *   cardTypes // ['Visa', 'American Express', 'Mastercard']
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.getSupportedCardTypes = function() {
                    return this._clientPromise.then(function(client) {
                        var cards = client.getConfiguration().gatewayConfiguration.creditCards.supportedCardTypes.map(function(cardType) {
                            if (cardType === "MasterCard") // Mastercard changed their branding. We can't update our
                            // config without creating a breaking change, so we just
                            // hard code the change here
                            return "Mastercard";
                            return cardType;
                        });
                        return cards;
                    });
                };
                /**
 * Cleanly remove anything set up by {@link module:braintree-web/hosted-fields.create|create}.
 * @public
 * @param {callback} [callback] Called on completion, containing an error if one occurred. No data is returned if teardown completes successfully. If no callback is provided, `teardown` returns a promise.
 * @example
 * hostedFieldsInstance.teardown(function (teardownErr) {
 *   if (teardownErr) {
 *     console.error('Could not tear down Hosted Fields!');
 *   } else {
 *     console.info('Hosted Fields has been torn down!');
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.teardown = function() {
                    var self1 = this;
                    return new Promise(function(resolve, reject) {
                        self1._destructor.teardown(function(err) {
                            analytics.sendEvent(self1._clientPromise, "custom.hosted-fields.teardown-completed");
                            if (err) reject(err);
                            else resolve();
                        });
                    });
                };
                /**
 * Tokenizes fields and returns a nonce payload.
 * @public
 * @param {object} [options] All tokenization options for the Hosted Fields component.
 * @param {boolean} [options.vault=false] When true, will vault the tokenized card. Cards will only be vaulted when using a client created with a client token that includes a customer ID. Note: merchants using Advanced Fraud Tools should not use this option, as device data will not be included.
 * @param {object} [options.authenticationInsight] Options for checking authentication insight - the [regulatory environment](https://developer.paypal.com/braintree/docs/guides/3d-secure/advanced-options/javascript/v3#authentication-insight) of the tokenized card.
 * @param {string} options.authenticationInsight.merchantAccountId The Braintree merchant account id to use to look up the authentication insight information.
 * @param {array} [options.fieldsToTokenize] By default, all fields will be tokenized. You may specify which fields specifically you wish to tokenize with this property. Valid options are `'number'`, `'cvv'`, `'expirationDate'`, `'expirationMonth'`, `'expirationYear'`, `'postalCode'`, `'cardholderName'`.
 * @param {string} [options.cardholderName] When supplied, the cardholder name to be tokenized with the contents of the fields.
 * @param {string} [options.billingAddress.postalCode] When supplied, this postal code will be tokenized along with the contents of the fields. If a postal code is provided as part of the Hosted Fields configuration, the value of the field will be tokenized and this value will be ignored.
 * @param {string} [options.billingAddress.firstName] When supplied, this customer first name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.lastName] When supplied, this customer last name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.company] When supplied, this company name will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.streetAddress] When supplied, this street address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.extendedAddress] When supplied, this extended address will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.locality] When supplied, this locality (the city) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.region] When supplied, this region (the state) will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeNumeric] When supplied, this numeric country code will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha2] When supplied, this alpha 2 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryCodeAlpha3] When supplied, this alpha 3 representation of a country will be tokenized along with the contents of the fields.
 * @param {string} [options.billingAddress.countryName] When supplied, this country name will be tokenized along with the contents of the fields.
 *
 * @param {callback} [callback] May be used as the only parameter of the function if no options are passed in. The second argument, <code>data</code>, is a {@link HostedFields~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link HostedFields~tokenizePayload|tokenizePayload}.
 * @example <caption>Tokenize a card</caption>
 * hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     switch (tokenizeErr.code) {
 *       case 'HOSTED_FIELDS_FIELDS_EMPTY':
 *         // occurs when none of the fields are filled in
 *         console.error('All fields are empty! Please fill out the form.');
 *         break;
 *       case 'HOSTED_FIELDS_FIELDS_INVALID':
 *         // occurs when certain fields do not pass client side validation
 *         console.error('Some fields are invalid:', tokenizeErr.details.invalidFieldKeys);
 *
 *         // you can also programmatically access the field containers for the invalid fields
 *         tokenizeErr.details.invalidFields.forEach(function (fieldContainer) {
 *           fieldContainer.className = 'invalid';
 *         });
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the fail on duplicate payment method
 *         //     option is set to true
 *         //   * the card being tokenized has previously been vaulted (with any customer)
 *         // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.fail_on_duplicate_payment_method
 *         console.error('This payment method already exists in your vault.');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
 *         // occurs when:
 *         //   * the client token used for client authorization was generated
 *         //     with a customer ID and the verify card option is set to true
 *         //     and you have credit card verification turned on in the Braintree
 *         //     control panel
 *         //   * the cvv does not pass verification (https://developer.paypal.com/braintree/docs/reference/general/testing#avs-and-cvv/cid-responses)
 *         // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.verify_card
 *         console.error('CVV did not pass verification');
 *         break;
 *       case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
 *         // occurs for any other tokenization error on the server
 *         console.error('Tokenization failed server side. Is the card valid?');
 *         break;
 *       case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
 *         // occurs when the Braintree gateway cannot be contacted
 *         console.error('Network error occurred when tokenizing.');
 *         break;
 *       default:
 *         console.error('Something bad happened!', tokenizeErr);
 *     }
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize and vault a card</caption>
 * hostedFieldsInstance.tokenize({
 *   vault: true
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with non-Hosted Fields cardholder name</caption>
 * hostedFieldsInstance.tokenize({
 *   cardholderName: 'First Last'
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with non-Hosted Fields postal code option</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     postalCode: '11111'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Tokenize a card with additional billing address options</caption>
 * hostedFieldsInstance.tokenize({
 *   billingAddress: {
 *     firstName: 'First',
 *     lastName: 'Last',
 *     company: 'Company',
 *     streetAddress: '123 Street',
 *     extendedAddress: 'Unit 1',
 *     // passing just one of the country options is sufficient to
 *     // associate the card details with a particular country
 *     // valid country names and codes can be found here:
 *     // https://developer.paypal.com/braintree/docs/reference/general/countries/ruby#list-of-countries
 *     countryName: 'United States',
 *     countryCodeAlpha2: 'US',
 *     countryCodeAlpha3: 'USA',
 *     countryCodeNumeric: '840'
 *   }
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @example <caption>Allow tokenization with empty cardholder name field</caption>
 * var state = hostedFieldsInstance.getState();
 * var fields = Object.keys(state.fields);
 *
 * // normally, if you tried to tokenize an empty cardholder name field
 * // you would get an error, to allow making this field optional,
 * // tokenize all the fields except for the cardholder name field
 * // when the cardholder name field is empty. Otherwise, tokenize
 * // all the fields
 * if (state.fields.cardholderName.isEmpty) {
 *  fields = fields.filter(function (field) {
 *    return field !== 'cardholderName';
 *  });
 * }
 *
 * hostedFieldsInstance.tokenize({
 *  fieldsToTokenize: fields
 * }, function (tokenizeErr, payload) {
 *   if (tokenizeErr) {
 *     console.error(tokenizeErr);
 *   } else {
 *     console.log('Got nonce:', payload.nonce);
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.tokenize = function(options) {
                    var self1 = this;
                    if (!options) options = {};
                    return new Promise(function(resolve, reject) {
                        self1._bus.emit(events.TOKENIZATION_REQUEST, options, function(response) {
                            var err = response[0];
                            var payload = response[1];
                            if (err) {
                                self1._attachInvalidFieldContainersToError(err);
                                reject(new BraintreeError(err));
                            } else resolve(payload);
                        });
                    });
                };
                /**
 * Add a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to add a class to. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be added.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is added successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.addClass = function(field, classname) {
                    var err;
                    if (!allowedFields.hasOwnProperty(field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
                        code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
                        message: '"' + field + '" is not a valid field. You must use a valid field option when adding a class.'
                    });
                    else if (!this._fields.hasOwnProperty(field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
                        code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
                        message: 'Cannot add class to "' + field + '" field because it is not part of the current Hosted Fields options.'
                    });
                    else this._bus.emit(events.ADD_CLASS, {
                        field: field,
                        classname: classname
                    });
                    if (err) return Promise.reject(err);
                    return Promise.resolve();
                };
                /**
 * Removes a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
 * @public
 * @param {string} field The field you wish to remove a class from. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} classname The class to be removed.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is removed successfully.
 *
 * @example
 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
 *   if (addClassErr) {
 *     console.error(addClassErr);
 *     return;
 *   }
 *
 *   // some time later...
 *   hostedFieldsInstance.removeClass('number', 'custom-class');
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.removeClass = function(field, classname) {
                    var err;
                    if (!allowedFields.hasOwnProperty(field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
                        code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
                        message: '"' + field + '" is not a valid field. You must use a valid field option when removing a class.'
                    });
                    else if (!this._fields.hasOwnProperty(field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
                        code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
                        message: 'Cannot remove class from "' + field + '" field because it is not part of the current Hosted Fields options.'
                    });
                    else this._bus.emit(events.REMOVE_CLASS, {
                        field: field,
                        classname: classname
                    });
                    if (err) return Promise.reject(err);
                    return Promise.resolve();
                };
                /**
 * Sets an attribute of a {@link module:braintree-web/hosted-fields~field field}.
 * Supported attributes are `aria-invalid`, `aria-required`, `disabled`, and `placeholder`.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to add to the field.
 * @param {string} options.value The value for the attribute.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is set successfully.
 *
 * @example <caption>Set the placeholder attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'placeholder',
 *   value: '1111 1111 1111 1111'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @example <caption>Set the aria-required attribute of a field</caption>
 * hostedFieldsInstance.setAttribute({
 *   field: 'number',
 *   attribute: 'aria-required',
 *   value: true
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.setAttribute = function(options) {
                    var attributeErr, err;
                    if (!allowedFields.hasOwnProperty(options.field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
                        code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
                        message: '"' + options.field + '" is not a valid field. You must use a valid field option when setting an attribute.'
                    });
                    else if (!this._fields.hasOwnProperty(options.field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
                        code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
                        message: 'Cannot set attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
                    });
                    else {
                        attributeErr = attributeValidationError(options.attribute, options.value);
                        if (attributeErr) err = attributeErr;
                        else this._bus.emit(events.SET_ATTRIBUTE, {
                            field: options.field,
                            attribute: options.attribute,
                            value: options.value
                        });
                    }
                    if (err) return Promise.reject(err);
                    return Promise.resolve();
                };
                /**
 * Sets the month options for the expiration month field when presented as a select element.
 *
 * @public
 * @param {array} options An array of 12 entries corresponding to the 12 months.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the options are updated successfully. Errors if expirationMonth is not configured on the Hosted Fields instance or if the expirationMonth field is not configured to be a select input.
 *
 * @example <caption>Update the month options to spanish</caption>
 * hostedFieldsInstance.setMonthOptions([
 *   '01 - enero',
 *   '02 - febrero',
 *   '03 - marzo',
 *   '04 - abril',
 *   '05 - mayo',
 *   '06 - junio',
 *   '07 - julio',
 *   '08 - agosto',
 *   '09 - septiembre',
 *   '10 - octubre',
 *   '11 - noviembre',
 *   '12 - diciembre'
 * ]);
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.setMonthOptions = function(options) {
                    var self1 = this;
                    var merchantOptions = this._merchantConfigurationOptions.fields;
                    var errorMessage;
                    if (!merchantOptions.expirationMonth) errorMessage = "Expiration month field must exist to use setMonthOptions.";
                    else if (!merchantOptions.expirationMonth.select) errorMessage = "Expiration month field must be a select element.";
                    if (errorMessage) return Promise.reject(new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
                        code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
                        message: errorMessage
                    }));
                    return new Promise(function(resolve) {
                        self1._bus.emit(events.SET_MONTH_OPTIONS, options, resolve);
                    });
                };
                /**
 * Sets a visually hidden message (for screen readers) on a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to set.
 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~field field}.
 * @param {string} options.message The message to set.
 *
 * @example <caption>Set an error message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: 'Invalid card number'
 * });
 *
 * @example <caption>Remove the message on a field</caption>
 * hostedFieldsInstance.setMessage({
 *   field: 'number',
 *   message: ''
 * });
 *
 * @returns {void}
 */ HostedFields.prototype.setMessage = function(options) {
                    this._bus.emit(events.SET_MESSAGE, {
                        field: options.field,
                        message: options.message
                    });
                };
                /**
 * Removes a supported attribute from a {@link module:braintree-web/hosted-fields~field field}.
 *
 * @public
 * @param {object} options The options for the attribute you wish to remove.
 * @param {string} options.field The field from which you wish to remove an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} options.attribute The name of the attribute you wish to remove from the field.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is removed successfully.
 *
 * @example <caption>Remove the placeholder attribute of a field</caption>
 * hostedFieldsInstance.removeAttribute({
 *   field: 'number',
 *   attribute: 'placeholder'
 * }, function (attributeErr) {
 *   if (attributeErr) {
 *     console.error(attributeErr);
 *   }
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.removeAttribute = function(options) {
                    var attributeErr, err;
                    if (!allowedFields.hasOwnProperty(options.field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
                        code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
                        message: '"' + options.field + '" is not a valid field. You must use a valid field option when removing an attribute.'
                    });
                    else if (!this._fields.hasOwnProperty(options.field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
                        code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
                        message: 'Cannot remove attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
                    });
                    else {
                        attributeErr = attributeValidationError(options.attribute);
                        if (attributeErr) err = attributeErr;
                        else this._bus.emit(events.REMOVE_ATTRIBUTE, {
                            field: options.field,
                            attribute: options.attribute
                        });
                    }
                    if (err) return Promise.reject(err);
                    return Promise.resolve();
                };
                /**
 * @deprecated since version 3.8.0. Use {@link HostedFields#setAttribute|setAttribute} instead.
 *
 * @public
 * @param {string} field The field whose placeholder you wish to change. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {string} placeholder Will be used as the `placeholder` attribute of the input.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the placeholder updated successfully.
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ HostedFields.prototype.setPlaceholder = function(field, placeholder) {
                    return this.setAttribute({
                        field: field,
                        attribute: "placeholder",
                        value: placeholder
                    });
                };
                /**
 * Clear the value of a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you wish to clear. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field cleared successfully.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * hostedFieldsInstance.clear('number', function (clearErr) {
 *   if (clearErr) {
 *     console.error(clearErr);
 *   }
 * });
 *
 * @example <caption>Clear several fields</caption>
 * hostedFieldsInstance.clear('number');
 * hostedFieldsInstance.clear('cvv');
 * hostedFieldsInstance.clear('expirationDate');
 */ HostedFields.prototype.clear = function(field) {
                    var err;
                    if (!allowedFields.hasOwnProperty(field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
                        code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
                        message: '"' + field + '" is not a valid field. You must use a valid field option when clearing a field.'
                    });
                    else if (!this._fields.hasOwnProperty(field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
                        code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
                        message: 'Cannot clear "' + field + '" field because it is not part of the current Hosted Fields options.'
                    });
                    else this._bus.emit(events.CLEAR_FIELD, {
                        field: field
                    });
                    if (err) return Promise.reject(err);
                    return Promise.resolve();
                };
                /**
 * Programmatically focus a {@link module:braintree-web/hosted-fields~field field}.
 * @public
 * @param {string} field The field you want to focus. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field focused successfully.
 * @returns {void}
 * @example
 * hostedFieldsInstance.focus('number', function (focusErr) {
 *   if (focusErr) {
 *     console.error(focusErr);
 *   }
 * });
 * @example <caption>Using an event listener</caption>
 * myElement.addEventListener('click', function (e) {
 *   // In Firefox, the focus method can be suppressed
 *   //   if the element has a tabindex property or the element
 *   //   is an anchor link with an href property.
 *   e.preventDefault();
 *   hostedFieldsInstance.focus('number');
 * });
 */ HostedFields.prototype.focus = function(field) {
                    var err;
                    var fieldConfig = this._fields[field];
                    if (!allowedFields.hasOwnProperty(field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
                        code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
                        message: '"' + field + '" is not a valid field. You must use a valid field option when focusing a field.'
                    });
                    else if (!this._fields.hasOwnProperty(field)) err = new BraintreeError({
                        type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
                        code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
                        message: 'Cannot focus "' + field + '" field because it is not part of the current Hosted Fields options.'
                    });
                    else {
                        fieldConfig.frameElement.focus();
                        this._bus.emit(events.TRIGGER_INPUT_FOCUS, {
                            field: field
                        });
                        if (browserDetection.isIos()) // Inputs outside of the viewport don't always scroll into view on
                        // focus in iOS Safari. 5ms timeout gives the browser a chance to
                        // do the right thing and prevents stuttering.
                        setTimeout(function() {
                            if (!isVisibleEnough(fieldConfig.containerElement)) fieldConfig.containerElement.scrollIntoView();
                        }, SAFARI_FOCUS_TIMEOUT);
                    }
                    if (err) return Promise.reject(err);
                    return Promise.resolve();
                };
                /**
 * Returns an {@link HostedFields~stateObject|object} that includes the state of all fields and possible card types.
 * @public
 * @returns {object} {@link HostedFields~stateObject|stateObject}
 * @example <caption>Check if all fields are valid</caption>
 * var state = hostedFieldsInstance.getState();
 *
 * var formValid = Object.keys(state.fields).every(function (key) {
 *   return state.fields[key].isValid;
 * });
 */ HostedFields.prototype.getState = function() {
                    return this._state;
                };
                // React adds decorations to DOM nodes that cause
                // circular dependencies, so we remove them from the
                // config before sending it to the iframes. However,
                // we don't want to mutate the original object that
                // was passed in, so we create fresh objects via assign
                function formatMerchantConfigurationForIframes(config) {
                    var formattedConfig = assign({}, config);
                    formattedConfig.fields = assign({}, formattedConfig.fields);
                    Object.keys(formattedConfig.fields).forEach(function(field) {
                        formattedConfig.fields[field] = assign({}, formattedConfig.fields[field]);
                        delete formattedConfig.fields[field].container;
                    });
                    return formattedConfig;
                }
                module1.exports = wrapPromise.wrapPrototype(HostedFields);
            },
            {
                "../../lib/analytics": 138,
                "../../lib/assign": 140,
                "../../lib/braintree-error": 143,
                "../../lib/constants": 145,
                "../../lib/convert-methods-to-error": 146,
                "../../lib/create-assets-url": 148,
                "../../lib/create-deferred-client": 150,
                "../../lib/destructor": 152,
                "../../lib/errors": 154,
                "../../lib/find-root-node": 155,
                "../../lib/is-verified-domain": 173,
                "../../lib/methods": 175,
                "../../lib/shadow": 178,
                "../shared/browser-detection": 130,
                "../shared/constants": 131,
                "../shared/errors": 132,
                "../shared/find-parent-tags": 133,
                "../shared/focus-intercept": 134,
                "../shared/get-card-types": 135,
                "./attribute-validation-error": 123,
                "./compose-url": 124,
                "./focus-change": 125,
                "./get-styles-from-class": 126,
                "./inject-frame": 128,
                "@braintree/event-emitter": 30,
                "@braintree/iframer": 32,
                "@braintree/uuid": 36,
                "@braintree/wrap-promise": 40,
                framebus: 50
            }
        ],
        128: [
            function(_dereq_, module1, exports) {
                "use strict";
                var focusIntercept = _dereq_("../shared/focus-intercept");
                var directions = _dereq_("../shared/constants").navigationDirections;
                module1.exports = function injectFrame(id, frame, container, focusHandler) {
                    var frameType = frame.getAttribute("type");
                    var clearboth = document.createElement("div");
                    var fragment = document.createDocumentFragment();
                    var focusInterceptBefore = focusIntercept.generate(id, frameType, directions.BACK, focusHandler);
                    var focusInterceptAfter = focusIntercept.generate(id, frameType, directions.FORWARD, focusHandler);
                    clearboth.style.clear = "both";
                    fragment.appendChild(focusInterceptBefore);
                    fragment.appendChild(frame);
                    fragment.appendChild(focusInterceptAfter);
                    fragment.appendChild(clearboth);
                    container.appendChild(fragment);
                    return [
                        frame,
                        clearboth
                    ];
                };
            },
            {
                "../shared/constants": 131,
                "../shared/focus-intercept": 134
            }
        ],
        129: [
            function(_dereq_, module1, exports) {
                "use strict";
                /** @module braintree-web/hosted-fields */ var HostedFields = _dereq_("./external/hosted-fields");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var errors = _dereq_("./shared/errors");
                var supportsInputFormatting = _dereq_("restricted-input/supports-input-formatting");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var VERSION = "3.110.0";
                /**
 * Fields used in {@link module:braintree-web/hosted-fields~fieldOptions fields options}
 * @typedef {object} field
 * @property {string} selector Deprecated: Now an alias for `options.container`.
 * @property {(string|HTMLElement)} container A DOM node or CSS selector to find the container where the hosted field will be inserted.
 * @property {string} [placeholder] Will be used as the `placeholder` attribute of the input. If `placeholder` is not natively supported by the browser, it will be polyfilled.
 * @property {string} [type] Will be used as the `type` attribute of the input. To mask `cvv` input, for instance, `type: "password"` can be used.
 * @property {string} [iframeTitle] The title used for the iframe containing the credit card input. By default, this will be `Secure Credit Card Frame - <the name of the specific field>`.
 * @property {string} [internalLabel] Each Hosted Field iframe has a hidden label that is used by screen readers to identify the input. The `internalLabel` property can be used to customize the field for localization purposes. The default values are:
 * * number: Credit Card Number
 * * cvv: CVV
 * * expirationDate: Expiration Date
 * * expirationMonth: Expiration Month
 * * expirationYear: Expiration Year
 * * postalCode: Postal Code
 * * cardholderName: Cardholder Name
 * @property {boolean} [formatInput=true] Enable or disable automatic formatting on this field.
 * @property {(object|boolean)} [maskInput=false] Enable or disable input masking when input is not focused. If set to `true` instead of an object, the defaults for the `maskInput` parameters will be used.
 * @property {string} [maskInput.character=•] The character to use when masking the input. The default character ('•') uses a unicode symbol, so the webpage must support UTF-8 characters when using the default.
 * @property {Boolean} [maskInput.showLastFour=false] Only applicable for the credit card field. Whether or not to show the last 4 digits of the card when masking.
 * @property {(object|boolean)} [select] If truthy, this field becomes a `<select>` dropdown list. This can only be used for `expirationMonth` and `expirationYear` fields. If you do not use a `placeholder` property for the field, the current month/year will be the default selected value.
 * @property {string[]} [select.options] An array of 12 strings, one per month. This can only be used for the `expirationMonth` field. For example, the array can look like `['01 - January', '02 - February', ...]`.
 * @property {number} [maxCardLength] This option applies only to the number field. Allows a limit to the length of the card number, even if the card brand may support numbers of a greater length. If the value passed is greater than the max length for a card brand, the smaller number of the 2 values will be used. For example, is `maxCardLength` is set to 16, but an American Express card is entered (which has a max card length of 15), a max card length of 15 will be used.
 * @property {number} [maxlength] This option applies only to the CVV and postal code fields. Will be used as the `maxlength` attribute of the input. The primary use cases for the `maxlength` option are: limiting the length of the CVV input for CVV-only verifications when the card type is known and setting the length of the postal code input when cards are coming from a known region. The default `maxlength` for the postal code input is `10`.
 * @property {number} [minlength=3] This option applies only to the cvv and postal code fields. Will be used as the `minlength` attribute of the input.
 * For postal code fields, the default value is 3, representing the Icelandic postal code length. This option's primary use case is to increase the `minlength`, e.g. for US customers, the postal code `minlength` can be set to 5.
 * For cvv fields, the default value is 3. The `minlength` attribute only applies to integrations capturing a cvv without a number field.
 * @property {string} [prefill] A value to prefill the field with. For example, when creating an update card form, you can prefill the expiration date fields with the old expiration date data.
 * @property {boolean} [rejectUnsupportedCards=false] Deprecated since version 3.46.0, use `supportedCardBrands` instead. Only allow card types that your merchant account is able to process. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering a American Express card would get an invalid card field. This can only be used for the `number` field.
 * @property {object} [supportedCardBrands] Override card brands that are supported by the card form. Pass `'card-brand-id': true` to override the default in the merchant configuration and enable a card brand. Pass `'card-brand-id': false` to disable a card brand. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering an American Express card would get an invalid card field. This can only be used for the  `number` field. (Note: only allow card types that your merchant account is actually able to process.)
 *
 * Valid card brand ids are:
 * * visa
 * * mastercard
 * * american-express
 * * diners-club
 * * discover
 * * jcb
 * * union-pay
 * * maestro
 * * elo
 * * mir
 * * hiper
 * * hipercard
 */ /**
 * An object that has {@link module:braintree-web/hosted-fields~field field objects} for each field. Used in {@link module:braintree-web/hosted-fields~create create}.
 * @typedef {object} fieldOptions
 * @property {field} [number] A field for card number.
 * @property {field} [expirationDate] A field for expiration date in `MM/YYYY` or `MM/YY` format. This should not be used with the `expirationMonth` and `expirationYear` properties.
 * @property {field} [expirationMonth] A field for expiration month in `MM` format. This should be used with the `expirationYear` property.
 * @property {field} [expirationYear] A field for expiration year in `YYYY` or `YY` format. This should be used with the `expirationMonth` property.
 * @property {field} [cvv] A field for 3 or 4 digit card verification code (like CVV or CID). If you wish to create a CVV-only payment method nonce to verify a card already stored in your Vault, omit all other fields to only collect CVV.
 * @property {field} [postalCode] A field for postal or region code.
 * @property {field} [cardholderName] A field for the cardholder name on the customer's credit card.
 */ /**
 * An object that represents CSS that will be applied in each hosted field. This object looks similar to CSS. Typically, these styles involve fonts (such as `font-family` or `color`).
 *
 * You may also pass the name of a class on your site that contains the styles you would like to apply. The style properties will be automatically pulled off the class and applied to the Hosted Fields inputs. Note: this is recommended for `input` elements only. If using a `select` for the expiration date, unexpected styling may occur.
 *
 * These are the CSS properties that Hosted Fields supports. Any other CSS should be specified on your page and outside of any Braintree configuration. Trying to set unsupported properties will fail and put a warning in the console.
 *
 * Supported CSS properties are:
 * `appearance`
 * `box-shadow`
 * `color`
 * `direction`
 * `font-family`
 * `font-size-adjust`
 * `font-size`
 * `font-stretch`
 * `font-style`
 * `font-variant-alternates`
 * `font-variant-caps`
 * `font-variant-east-asian`
 * `font-variant-ligatures`
 * `font-variant-numeric`
 * `font-variant`
 * `font-weight`
 * `font`
 * `letter-spacing`
 * `line-height`
 * `opacity`
 * `outline`
 * `margin`
 * `margin-top`
 * `margin-right`
 * `margin-bottom`
 * `margin-left`
 * `padding`
 * `padding-top`
 * `padding-right`
 * `padding-bottom`
 * `padding-left`
 * `text-align`
 * `text-shadow`
 * `transition`
 * `-moz-appearance`
 * `-moz-box-shadow`
 * `-moz-osx-font-smoothing`
 * `-moz-tap-highlight-color`
 * `-moz-transition`
 * `-webkit-appearance`
 * `-webkit-box-shadow`
 * `-webkit-font-smoothing`
 * `-webkit-tap-highlight-color`
 * `-webkit-transition`
 * @typedef {object} styleOptions
 */ /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {fieldOptions} options.fields A {@link module:braintree-web/hosted-fields~fieldOptions set of options for each field}.
 * @param {styleOptions} [options.styles] {@link module:braintree-web/hosted-fields~styleOptions Styles} applied to each field.
 * @param {boolean} [options.preventAutofill=false] When true, browsers will not try to prompt the customer to autofill their credit card information.
 * @param {string} [options.sessionId] Used in specific cases where associating SDK events with a specific external id is required.
 * @param {callback} [callback] The second argument, `data`, is the {@link HostedFields} instance. If no callback is provided, `create` returns a promise that resolves with the {@link HostedFields} instance.
 * @returns {void}
 * @example
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       'font-size': '16pt',
 *       'color': '#3A3A3A'
 *     },
 *     '.number': {
 *       'font-family': 'monospace'
 *     },
 *     '.valid': {
 *       'color': 'green'
 *     }
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date'
 *     }
 *   }
 * }, callback);
 * @example <caption>With cardholder name</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     cardholderName: {
 *       container: '#cardholder-name'
 *     },
 *     cvv: {
 *       container: '#cvv',
 *     },
 *     expirationDate: {
 *       container: '#expiration-date'
 *     }
 *   }
 * }, callback);
 * @example <caption>Applying styles with a class name</caption>
 * // in document head
 * <style>
 *   .braintree-input-class {
 *     color: black;
 *   }
 *   .braintree-valid-class {
 *     color: green;
 *   }
 *   .braintree-invalid-class {
 *     color: red;
 *   }
 * </style>
 * // in a script tag
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': 'braintree-input-class',
 *     '.invalid': 'braintree-invalid-class',
 *     '.valid': {
 *       // you can also use the object syntax alongside
 *       // the class name syntax
 *       color: green;
 *     }
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number'
 *     },
 *     // etc...
 *   }
 * }, callback);
 * @example <caption>Right to Left Language Support</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   styles: {
 *     'input': {
 *       // other styles
 *       direction: 'rtl'
 *     },
 *   },
 *   fields: {
 *     number: {
 *       container: '#card-number',
 *       // Credit card formatting is not currently supported
 *       // with RTL languages, so we need to turn it off for the number input
 *       formatInput: false
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date',
 *       type: 'month'
 *     }
 *   }
 * }, callback);
 * @example <caption>Setting up Hosted Fields to tokenize CVV only</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     // Only add the `cvv` option.
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     }
 *   }
 * }, callback);
 * @example <caption>Creating an expiration date update form with prefilled data</caption>
 * var storedCreditCardInformation = {
 *   // get this info from your server
 *   // with a payment method lookup
 *   month: '09',
 *   year: '2017'
 * };
 *
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     expirationMonth: {
 *       container: '#expiration-month',
 *       prefill: storedCreditCardInformation.month
 *     },
 *     expirationYear: {
 *       container: '#expiration-year',
 *       prefill: storedCreditCardInformation.year
 *     }
 *   }
 * }, callback);
 * @example <caption>Validate the card form for supported card types</caption>
 * braintree.hostedFields.create({
 *   client: clientInstance,
 *   fields: {
 *     number: {
 *       container: '#card-number',
 *       supportedCardBrands: {
 *         visa: false, // prevents Visas from showing up as valid even when the Braintree control panel is configured to allow them
 *         'diners-club': true // allow Diners Club cards to be valid (processed as Discover cards on the Braintree backend)
 *       }
 *     },
 *     cvv: {
 *       container: '#cvv',
 *       placeholder: '•••'
 *     },
 *     expirationDate: {
 *       container: '#expiration-date',
 *       type: 'month'
 *     }
 *   },
 * }, callback);
 */ function create(options) {
                    return basicComponentVerification.verify({
                        name: "Hosted Fields",
                        authorization: options.authorization,
                        client: options.client
                    }).then(function() {
                        var integration = new HostedFields(options);
                        return new Promise(function(resolve, reject) {
                            integration.on("ready", function() {
                                resolve(integration);
                            });
                            integration.on("timeout", function() {
                                reject(new BraintreeError(errors.HOSTED_FIELDS_TIMEOUT));
                            });
                        });
                    });
                }
                module1.exports = {
                    /**
   * @static
   * @function supportsInputFormatting
   * @description Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true. For a list of unsupported browsers, [go here](https://github.com/braintree/restricted-input/blob/main/README.md#browsers-where-formatting-is-turned-off-automatically).
   * @returns {Boolean} Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true.
   * @example
   * <caption>Conditionally choosing split expiration date inputs if formatting is unavailable</caption>
   * var canFormat = braintree.hostedFields.supportsInputFormatting();
   * var fields = {
   *   number: {
   *     container: '#card-number'
   *   },
   *   cvv: {
   *     container: '#cvv'
   *   }
   * };
   *
   * if (canFormat) {
   *   fields.expirationDate = {
   *     selection: '#expiration-date'
   *   };
   *   functionToCreateAndInsertExpirationDateDivToForm();
   * } else {
   *   fields.expirationMonth = {
   *     selection: '#expiration-month'
   *   };
   *   fields.expirationYear = {
   *     selection: '#expiration-year'
   *   };
   *   functionToCreateAndInsertExpirationMonthAndYearDivsToForm();
   * }
   *
   * braintree.hostedFields.create({
   *   client: clientInstance,
   *   styles: {
   *     // Styles
   *   },
   *   fields: fields
   * }, callback);
   */ supportsInputFormatting: supportsInputFormatting,
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "./external/hosted-fields": 127,
                "./shared/errors": 132,
                "@braintree/wrap-promise": 40,
                "restricted-input/supports-input-formatting": 85
            }
        ],
        130: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isAndroid = _dereq_("@braintree/browser-detection/is-android");
                var isChromeOS = _dereq_("@braintree/browser-detection/is-chrome-os");
                var isIos = _dereq_("@braintree/browser-detection/is-ios");
                var isChrome = _dereq_("@braintree/browser-detection/is-chrome");
                function hasSoftwareKeyboard() {
                    return isAndroid() || isChromeOS() || isIos();
                }
                function isChromeIos() {
                    return isChrome() && isIos();
                }
                module1.exports = {
                    isAndroid: isAndroid,
                    isChromeOS: isChromeOS,
                    isChromeIos: isChromeIos,
                    isFirefox: _dereq_("@braintree/browser-detection/is-firefox"),
                    isIos: isIos,
                    isIosWebview: _dereq_("@braintree/browser-detection/is-ios-webview"),
                    hasSoftwareKeyboard: hasSoftwareKeyboard
                };
            },
            {
                "@braintree/browser-detection/is-android": 20,
                "@braintree/browser-detection/is-chrome": 22,
                "@braintree/browser-detection/is-chrome-os": 21,
                "@braintree/browser-detection/is-firefox": 23,
                "@braintree/browser-detection/is-ios": 27,
                "@braintree/browser-detection/is-ios-webview": 25
            }
        ],
        131: [
            function(_dereq_, module1, exports) {
                "use strict";
                var enumerate = _dereq_("../../lib/enumerate");
                var errors = _dereq_("./errors");
                var VERSION = "3.110.0";
                var constants = {
                    VERSION: VERSION,
                    maxExpirationYearAge: 19,
                    externalEvents: {
                        FOCUS: "focus",
                        BLUR: "blur",
                        EMPTY: "empty",
                        NOT_EMPTY: "notEmpty",
                        VALIDITY_CHANGE: "validityChange",
                        CARD_TYPE_CHANGE: "cardTypeChange"
                    },
                    defaultMaxLengths: {
                        number: 19,
                        postalCode: 8,
                        expirationDate: 7,
                        expirationMonth: 2,
                        expirationYear: 4,
                        cvv: 3
                    },
                    externalClasses: {
                        FOCUSED: "braintree-hosted-fields-focused",
                        INVALID: "braintree-hosted-fields-invalid",
                        VALID: "braintree-hosted-fields-valid"
                    },
                    navigationDirections: {
                        BACK: "before",
                        FORWARD: "after"
                    },
                    defaultIFrameStyle: {
                        border: "none",
                        width: "100%",
                        height: "100%",
                        float: "left"
                    },
                    tokenizationErrorCodes: {
                        81724: errors.HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE,
                        // NEXT_MAJOR_VERSION this error triggers for both AVS and CVV errors
                        // but the code name implies that it would only trigger for CVV verification
                        // failures
                        81736: errors.HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED
                    },
                    allowedStyles: [
                        "-moz-appearance",
                        "-moz-box-shadow",
                        "-moz-osx-font-smoothing",
                        "-moz-tap-highlight-color",
                        "-moz-transition",
                        "-webkit-appearance",
                        "-webkit-box-shadow",
                        "-webkit-font-smoothing",
                        "-webkit-tap-highlight-color",
                        "-webkit-transition",
                        "appearance",
                        "box-shadow",
                        "color",
                        "direction",
                        "font",
                        "font-family",
                        "font-size",
                        "font-size-adjust",
                        "font-stretch",
                        "font-style",
                        "font-variant",
                        "font-variant-alternates",
                        "font-variant-caps",
                        "font-variant-east-asian",
                        "font-variant-ligatures",
                        "font-variant-numeric",
                        "font-weight",
                        "letter-spacing",
                        "line-height",
                        "margin",
                        "margin-top",
                        "margin-right",
                        "margin-bottom",
                        "margin-left",
                        "opacity",
                        "outline",
                        "padding",
                        "padding-top",
                        "padding-right",
                        "padding-bottom",
                        "padding-left",
                        "text-align",
                        "text-shadow",
                        "transition"
                    ],
                    allowedFields: {
                        cardholderName: {
                            name: "cardholder-name",
                            label: "Cardholder Name"
                        },
                        number: {
                            name: "credit-card-number",
                            label: "Credit Card Number"
                        },
                        cvv: {
                            name: "cvv",
                            label: "CVV"
                        },
                        expirationDate: {
                            name: "expiration",
                            label: "Expiration Date"
                        },
                        expirationMonth: {
                            name: "expiration-month",
                            label: "Expiration Month"
                        },
                        expirationYear: {
                            name: "expiration-year",
                            label: "Expiration Year"
                        },
                        postalCode: {
                            name: "postal-code",
                            label: "Postal Code"
                        }
                    },
                    allowedAttributes: {
                        "aria-invalid": "boolean",
                        "aria-required": "boolean",
                        disabled: "boolean",
                        placeholder: "string"
                    },
                    allowedBillingAddressFields: [
                        "company",
                        "countryCodeNumeric",
                        "countryCodeAlpha2",
                        "countryCodeAlpha3",
                        "countryName",
                        "extendedAddress",
                        "locality",
                        "region",
                        "firstName",
                        "lastName",
                        "postalCode",
                        "streetAddress"
                    ],
                    allowedShippingAddressFields: [
                        "company",
                        "countryCodeNumeric",
                        "countryCodeAlpha2",
                        "countryCodeAlpha3",
                        "countryName",
                        "extendedAddress",
                        "locality",
                        "region",
                        "firstName",
                        "lastName",
                        "postalCode",
                        "streetAddress"
                    ],
                    autocompleteMappings: {
                        "cardholder-name": "cc-name",
                        "credit-card-number": "cc-number",
                        expiration: "cc-exp",
                        "expiration-month": "cc-exp-month",
                        "expiration-year": "cc-exp-year",
                        cvv: "cc-csc",
                        "postal-code": "billing postal-code"
                    }
                };
                constants.events = enumerate([
                    "ADD_CLASS",
                    "AUTOFILL_DATA_AVAILABLE",
                    "BIN_AVAILABLE",
                    "CARD_FORM_ENTRY_HAS_BEGUN",
                    "CLEAR_FIELD",
                    "CONFIGURATION",
                    "FRAME_READY",
                    "INPUT_EVENT",
                    "READY_FOR_CLIENT",
                    "REMOVE_ATTRIBUTE",
                    "REMOVE_CLASS",
                    "REMOVE_FOCUS_INTERCEPTS",
                    "SET_ATTRIBUTE",
                    "SET_MESSAGE",
                    "SET_MONTH_OPTIONS",
                    "TOKENIZATION_REQUEST",
                    "TRIGGER_FOCUS_CHANGE",
                    "TRIGGER_INPUT_FOCUS",
                    "VALIDATE_STRICT"
                ], "hosted-fields:");
                module1.exports = constants;
            },
            {
                "../../lib/enumerate": 153,
                "./errors": 132
            }
        ],
        132: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Hosted Fields - Creation Error Codes
 * @description Errors that occur when [creating the Hosted Fields component](./module-braintree-web_hosted-fields.html#.create).
 * @property {UNKNOWN} HOSTED_FIELDS_TIMEOUT Occurs when Hosted Fields does not finish setting up within 60 seconds.
 * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_KEY Occurs when Hosted Fields is instantiated with an invalid Field option.
 * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_SELECTOR Occurs when Hosted Fields given a field selector that is not valid.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME Occurs when Hosted Fields given a field selector that already contains an iframe.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
 */ /**
 * @name BraintreeError.Hosted Fields - Field Manipulation Error Codes
 * @description Errors that occur when modifying fields through [`addClass`](./HostedFields.html#addClass), [`removeClass`](./HostedFields.html#removeClass), [`setAttribute`](./HostedFields.html#setAttribute), [`removeAttribute`](./HostedFields.html#removeAttribute), [`clear`](./HostedFields.html#clear), [`focus`](./HostedFields.html#focus), and [`setMonthOptions`](./HostedFields.html#setMonthOptions).
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_INVALID Occurs when attempting to modify a field that is not a valid Hosted Fields option.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_NOT_PRESENT Occurs when attempting to modify a field that is not configured with Hosted Fields.
 * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
 */ /**
 * @name BraintreeError.Hosted Fields - Set Attribute Error Codes
 * @description Errors that occur when using the [`setAttribute` method](./HostedFields.html#setAttribute)
 * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED Occurs when trying to set an attribute that is not supported to be set.
 * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED Occurs when the type of value for an attribute is not allowed to be set.
 */ /**
 * @name BraintreeError.Hosted Fields - Tokenize Error Codes
 * @description Errors that occur when [tokenizing the card details with Hosted Fields](./HostedFields.html#tokenize).
 * @property {NETWORK} HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR Occurs when the Braintree gateway cannot be contacted.
 * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE Occurs when attempting to vault a card, but the client token being used is configured to fail if the card already exists in the vault.
 * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED Occurs when cvv verification is turned on in the Braintree control panel.
 * @property {CUSTOMER} HOSTED_FIELDS_FAILED_TOKENIZATION Occurs when the credit card details were sent to Braintree, but failed to tokenize.
 * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_EMPTY Occurs when all the Hosted Fields inputs are empty.
 * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_INVALID Occurs when one ore more fields are invalid.
 */ var BraintreeError = _dereq_("../../lib/braintree-error");
                module1.exports = {
                    HOSTED_FIELDS_TIMEOUT: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "HOSTED_FIELDS_TIMEOUT",
                        message: "Hosted Fields timed out when attempting to set up."
                    },
                    HOSTED_FIELDS_INVALID_FIELD_KEY: {
                        type: BraintreeError.types.MERCHANT,
                        code: "HOSTED_FIELDS_INVALID_FIELD_KEY"
                    },
                    HOSTED_FIELDS_INVALID_FIELD_SELECTOR: {
                        type: BraintreeError.types.MERCHANT,
                        code: "HOSTED_FIELDS_INVALID_FIELD_SELECTOR",
                        message: "Selector does not reference a valid DOM node."
                    },
                    HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME: {
                        type: BraintreeError.types.MERCHANT,
                        code: "HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME",
                        message: "Element already contains a Braintree iframe."
                    },
                    HOSTED_FIELDS_FIELD_INVALID: {
                        type: BraintreeError.types.MERCHANT,
                        code: "HOSTED_FIELDS_FIELD_INVALID"
                    },
                    HOSTED_FIELDS_FIELD_NOT_PRESENT: {
                        type: BraintreeError.types.MERCHANT,
                        code: "HOSTED_FIELDS_FIELD_NOT_PRESENT"
                    },
                    HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR",
                        message: "A tokenization network error occurred."
                    },
                    HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE",
                        message: "This credit card already exists in the merchant's vault."
                    },
                    HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED",
                        message: "CVV verification failed during tokenization."
                    },
                    HOSTED_FIELDS_FAILED_TOKENIZATION: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "HOSTED_FIELDS_FAILED_TOKENIZATION",
                        message: "The supplied card data failed tokenization."
                    },
                    HOSTED_FIELDS_FIELDS_EMPTY: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "HOSTED_FIELDS_FIELDS_EMPTY",
                        message: "All fields are empty. Cannot tokenize empty card fields."
                    },
                    HOSTED_FIELDS_FIELDS_INVALID: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "HOSTED_FIELDS_FIELDS_INVALID",
                        message: "Some payment input fields are invalid. Cannot tokenize invalid card fields."
                    },
                    HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED"
                    },
                    HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED"
                    },
                    HOSTED_FIELDS_FIELD_PROPERTY_INVALID: {
                        type: BraintreeError.types.MERCHANT,
                        code: "HOSTED_FIELDS_FIELD_PROPERTY_INVALID"
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        133: [
            function(_dereq_, module1, exports) {
                "use strict";
                function findParentTags(element, tag) {
                    var parent = element.parentNode;
                    var parents = [];
                    while(parent != null){
                        if (parent.tagName != null && parent.tagName.toLowerCase() === tag) parents.push(parent);
                        parent = parent.parentNode;
                    }
                    return parents;
                }
                module1.exports = findParentTags;
            },
            {}
        ],
        134: [
            function(_dereq_, module1, exports) {
                "use strict";
                var browserDetection = _dereq_("./browser-detection");
                var constants = _dereq_("./constants");
                var allowedFields = Object.keys(constants.allowedFields);
                var directions = constants.navigationDirections;
                var focusIntercept = {
                    generate: function generate(hostedFieldsId, type, direction, handler) {
                        var input = document.createElement("input");
                        var focusInterceptStyles = {
                            border: "none !important",
                            display: "block !important",
                            height: "1px !important",
                            left: "-1px !important",
                            opacity: "0 !important",
                            position: "absolute !important",
                            top: "-1px !important",
                            width: "1px !important"
                        };
                        var shouldCreateFocusIntercept = browserDetection.hasSoftwareKeyboard() || browserDetection.isFirefox();
                        if (!shouldCreateFocusIntercept) return document.createDocumentFragment();
                        input.setAttribute("aria-hidden", "true");
                        input.setAttribute("autocomplete", "off");
                        input.setAttribute("data-braintree-direction", direction);
                        input.setAttribute("data-braintree-type", type);
                        input.setAttribute("id", "bt-" + type + "-" + direction + "-" + hostedFieldsId);
                        input.setAttribute("style", JSON.stringify(focusInterceptStyles).replace(/[{}"]/g, "").replace(/,/g, ";"));
                        input.classList.add("focus-intercept");
                        input.addEventListener("focus", function(event) {
                            handler(event);
                            /*
        Certain browsers without software keyboards (Firefox, Internet
        Explorer) need the focus intercept inputs that get inserted
        around the actual input to blur themselves, otherwise the
        browser gets confused about what should have focus. Can't
        apply this to browsers with software keyboards however,
        because it blurs everything, and focus on the actual input is
        also lost.
      */ if (!browserDetection.hasSoftwareKeyboard()) input.blur();
                        });
                        return input;
                    },
                    destroy: function destroy(idString) {
                        var focusInputs;
                        if (!idString) {
                            focusInputs = document.querySelectorAll("[data-braintree-direction]");
                            focusInputs = [].slice.call(focusInputs);
                        } else focusInputs = [
                            document.getElementById(idString)
                        ];
                        focusInputs.forEach(function(node) {
                            if (node && node.nodeType === 1 && focusIntercept.matchFocusElement(node.getAttribute("id"))) node.parentNode.removeChild(node);
                        });
                    },
                    matchFocusElement: function matchFocusElement(idString) {
                        var idComponents, hasBTPrefix, isAllowedType, isValidDirection;
                        if (!idString) return false;
                        idComponents = idString.split("-");
                        if (idComponents.length < 4) return false;
                        hasBTPrefix = idComponents[0] === "bt";
                        isAllowedType = allowedFields.indexOf(idComponents[1]) > -1;
                        isValidDirection = idComponents[2] === directions.BACK || idComponents[2] === directions.FORWARD;
                        return Boolean(hasBTPrefix && isAllowedType && isValidDirection);
                    }
                };
                module1.exports = focusIntercept;
            },
            {
                "./browser-detection": 130,
                "./constants": 131
            }
        ],
        135: [
            function(_dereq_, module1, exports) {
                "use strict";
                var creditCardType = _dereq_("credit-card-type");
                module1.exports = function(number) {
                    var results = creditCardType(number);
                    results.forEach(function(card) {
                        // NEXT_MAJOR_VERSION credit-card-type fixed the mastercard enum
                        // but we still pass master-card in the braintree API
                        // in a major version bump, we can remove this and
                        // this will be mastercard instead of master-card
                        if (card.type === "mastercard") card.type = "master-card";
                    });
                    return results;
                };
            },
            {
                "credit-card-type": 42
            }
        ],
        136: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web
 * @description This is the top-level module exported by the Braintree JavaScript SDK. In a browser environment, this will be the global <code>braintree</code> object. In a CommonJS environment (like Browserify or Webpack), it will be the default export of the <code>braintree-web</code> package. In AMD environments (like RequireJS), it can be `require`d like other modules.
 * @example
 * <caption>CommonJS</caption>
 * var braintree = require('braintree-web');
 *
 * braintree.client.create(...);
 * @example
 * <caption>In the browser</caption>
 * <script src="https://js.braintreegateway.com/web/{@pkg version}/js/client.min.js"></script>
 * <script>
 *   window.braintree.client.create(...);
 * </script>
 * @example
 * <caption>AMD</caption>
 * // main.js
 * require.config({
 *   paths: {
 *     braintreeClient: 'https://js.braintreegateway.com/web/{@pkg version}/js/client.min'
 *   }
 * });
 *
 * require(['braintreeClient'], function (braintreeClient) {
 *   braintreeClient.create(...);
 * });
 */ /**
 * @global
 * @callback callback
 * @param {?BraintreeError} [err] `null` or `undefined` if there was no error.
 * @param {?any} [data] The successful result of the asynchronous function call (if data exists).
 * @description The Node.js-style callback pattern used throughout the SDK.
 * @returns {void}
 */ var americanExpress = _dereq_("./american-express");
                var applePay = _dereq_("./apple-pay");
                var client = _dereq_("./client");
                var fastlane = _dereq_("./fastlane");
                var dataCollector = _dereq_("./data-collector");
                var hostedFields = _dereq_("./hosted-fields");
                var localPayment = _dereq_("./local-payment");
                var masterpass = _dereq_("./masterpass");
                var paymentRequest = _dereq_("./payment-request");
                var paypal = _dereq_("./paypal");
                var paypalCheckout = _dereq_("./paypal-checkout");
                var googlePayment = _dereq_("./google-payment");
                var sepa = _dereq_("./sepa");
                var threeDSecure = _dereq_("./three-d-secure");
                var unionpay = _dereq_("./unionpay");
                var usBankAccount = _dereq_("./us-bank-account");
                var vaultManager = _dereq_("./vault-manager");
                var venmo = _dereq_("./venmo");
                var visaCheckout = _dereq_("./visa-checkout");
                var preferredPaymentMethods = _dereq_("./preferred-payment-methods");
                var VERSION = "3.110.0";
                module1.exports = {
                    /** @type {module:braintree-web/fastlane} */ fastlane: fastlane,
                    /** @type {module:braintree-web/american-express} */ americanExpress: americanExpress,
                    /** @type {module:braintree-web/apple-pay} */ applePay: applePay,
                    /** @type {module:braintree-web/client} */ client: client,
                    /** @type {module:braintree-web/data-collector} */ dataCollector: dataCollector,
                    /** @type {module:braintree-web/hosted-fields} */ hostedFields: hostedFields,
                    /** @type {module:braintree-web/local-payment} */ localPayment: localPayment,
                    /** @type {module:braintree-web/masterpass} */ masterpass: masterpass,
                    /** @type {module:braintree-web/google-payment} */ googlePayment: googlePayment,
                    /** @type {module:braintree-web/payment-request} */ paymentRequest: paymentRequest,
                    /** @type {module:braintree-web/paypal} */ paypal: paypal,
                    /** @type {module:braintree-web/paypal-checkout} */ paypalCheckout: paypalCheckout,
                    /** @type {module:braintree-web/three-d-secure} */ threeDSecure: threeDSecure,
                    /** @type {module:braintree-web/unionpay} */ unionpay: unionpay,
                    /** @type {module:braintree-web/us-bank-account} */ usBankAccount: usBankAccount,
                    /** @type {module:braintree-web/vault-manager} */ vaultManager: vaultManager,
                    /** @type {module:braintree-web/venmo} */ venmo: venmo,
                    /** @type {module:braintree-web/visa-checkout} */ visaCheckout: visaCheckout,
                    /** @type {module:braintree-web/sepa} */ sepa: sepa,
                    /** @type {module:braintree-web/preferred-payment-methods} */ preferredPaymentMethods: preferredPaymentMethods,
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "./american-express": 88,
                "./apple-pay": 91,
                "./client": 96,
                "./data-collector": 114,
                "./fastlane": 119,
                "./google-payment": 122,
                "./hosted-fields": 129,
                "./local-payment": 184,
                "./masterpass": 187,
                "./payment-request": 192,
                "./paypal": 199,
                "./paypal-checkout": 196,
                "./preferred-payment-methods": 202,
                "./sepa": 206,
                "./three-d-secure": 218,
                "./unionpay": 222,
                "./us-bank-account": 228,
                "./vault-manager": 231,
                "./venmo": 236,
                "./visa-checkout": 246
            }
        ],
        137: [
            function(_dereq_, module1, exports) {
                "use strict";
                var createAuthorizationData = _dereq_("./create-authorization-data");
                var jsonClone = _dereq_("./json-clone");
                var constants = _dereq_("./constants");
                function addMetadata(configuration, data) {
                    var key;
                    var attrs = data ? jsonClone(data) : {};
                    var authAttrs = createAuthorizationData(configuration.authorization).attrs;
                    var _meta = jsonClone(configuration.analyticsMetadata);
                    attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
                    for(key in attrs._meta)if (attrs._meta.hasOwnProperty(key)) _meta[key] = attrs._meta[key];
                    attrs._meta = _meta;
                    if (authAttrs.tokenizationKey) attrs.tokenizationKey = authAttrs.tokenizationKey;
                    else attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
                    return attrs;
                }
                function addEventMetadata(clientInstanceOrPromise) {
                    var configuration = clientInstanceOrPromise.getConfiguration();
                    var authAttrs = createAuthorizationData(configuration.authorization).attrs;
                    var isProd = configuration.gatewayConfiguration.environment === "production";
                    /* eslint-disable camelcase */ var metadata = {
                        api_integration_type: configuration.analyticsMetadata.integrationType,
                        app_id: window.location.host,
                        c_sdk_ver: constants.VERSION,
                        component: "braintreeclientsdk",
                        merchant_sdk_env: isProd ? "production" : "sandbox",
                        merchant_id: configuration.gatewayConfiguration.merchantId,
                        event_source: "web",
                        platform: constants.PLATFORM,
                        platform_version: window.navigator.userAgent,
                        session_id: configuration.analyticsMetadata.sessionId,
                        client_session_id: configuration.analyticsMetadata.sessionId,
                        tenant_name: "braintree"
                    };
                    if (authAttrs.tokenizationKey) metadata.tokenization_key = authAttrs.tokenizationKey;
                    else metadata.auth_fingerprint = authAttrs.authorizationFingerprint;
                    /* eslint-enable camelcase */ return metadata;
                }
                module1.exports = {
                    addMetadata: addMetadata,
                    addEventMetadata: addEventMetadata
                };
            },
            {
                "./constants": 145,
                "./create-authorization-data": 149,
                "./json-clone": 174
            }
        ],
        138: [
            function(_dereq_, module1, exports) {
                "use strict";
                var constants = _dereq_("./constants");
                var metadata = _dereq_("./add-metadata");
                function sendPaypalEvent(clientInstanceOrPromise, eventName, callback) {
                    var timestamp = Date.now();
                    return Promise.resolve(clientInstanceOrPromise).then(function(client) {
                        var request = client._request;
                        var url = constants.ANALYTICS_URL;
                        var qualifiedEvent = constants.ANALYTICS_PREFIX + eventName;
                        var configuration = client.getConfiguration();
                        var isProd = configuration.gatewayConfiguration.environment === "production";
                        var data = {
                            events: [],
                            tracking: []
                        };
                        var trackingMeta = metadata.addEventMetadata(client, data);
                        trackingMeta.event_name = qualifiedEvent; // eslint-disable-line camelcase
                        trackingMeta.t = timestamp; // eslint-disable-line camelcase
                        data.events = [
                            {
                                level: "info",
                                event: qualifiedEvent,
                                payload: {
                                    env: isProd ? "production" : "sandbox",
                                    timestamp: timestamp
                                }
                            }
                        ];
                        data.tracking = [
                            trackingMeta
                        ];
                        return request({
                            url: url,
                            method: "post",
                            data: data,
                            timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS
                        }, callback);
                    })["catch"](function(err) {
                        if (callback) callback(err);
                    });
                }
                module1.exports = {
                    sendEvent: sendPaypalEvent
                };
            },
            {
                "./add-metadata": 137,
                "./constants": 145
            }
        ],
        139: [
            function(_dereq_, module1, exports) {
                "use strict";
                var loadScript = _dereq_("@braintree/asset-loader/load-script");
                var loadConnectScript = _dereq_("@paypal/accelerated-checkout-loader");
                module1.exports = {
                    loadScript: loadScript,
                    loadFastlane: loadConnectScript.loadAxo
                };
            },
            {
                "@braintree/asset-loader/load-script": 2,
                "@paypal/accelerated-checkout-loader": 41
            }
        ],
        140: [
            function(_dereq_, module1, exports) {
                "use strict";
                var assignNormalized = typeof Object.assign === "function" ? Object.assign : assignPolyfill;
                function assignPolyfill(destination) {
                    var i, source, key;
                    for(i = 1; i < arguments.length; i++){
                        source = arguments[i];
                        for(key in source)if (source.hasOwnProperty(key)) destination[key] = source[key];
                    }
                    return destination;
                }
                module1.exports = {
                    assign: assignNormalized,
                    _assign: assignPolyfill
                };
            },
            {}
        ],
        141: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("./braintree-error");
                var sharedErrors = _dereq_("./errors");
                var VERSION = "3.110.0";
                function basicComponentVerification(options) {
                    var client, authorization, name;
                    if (!options) return Promise.reject(new BraintreeError({
                        type: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.type,
                        code: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.code,
                        message: "Options must be passed to basicComponentVerification function."
                    }));
                    name = options.name;
                    client = options.client;
                    authorization = options.authorization;
                    if (!client && !authorization) return Promise.reject(new BraintreeError({
                        type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
                        code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
                        // NEXT_MAJOR_VERSION in major version, we expose passing in authorization for all components
                        // instead of passing in a client instance. Leave this a silent feature for now.
                        message: "options.client is required when instantiating " + name + "."
                    }));
                    if (!authorization && client.getVersion() !== VERSION) return Promise.reject(new BraintreeError({
                        type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
                        code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
                        message: "Client (version " + client.getVersion() + ") and " + name + " (version " + VERSION + ") components must be from the same SDK version."
                    }));
                    return Promise.resolve();
                }
                module1.exports = {
                    verify: basicComponentVerification
                };
            },
            {
                "./braintree-error": 143,
                "./errors": 154
            }
        ],
        142: [
            function(_dereq_, module1, exports) {
                "use strict";
                var once = _dereq_("./once");
                function call(fn, callback) {
                    var isSync = fn.length === 0;
                    if (isSync) {
                        fn();
                        callback(null);
                    } else fn(callback);
                }
                module1.exports = function(functions, cb) {
                    var i;
                    var length = functions.length;
                    var remaining = length;
                    var callback = once(cb);
                    if (length === 0) {
                        callback(null);
                        return;
                    }
                    function finish(err) {
                        if (err) {
                            callback(err);
                            return;
                        }
                        remaining -= 1;
                        if (remaining === 0) callback(null);
                    }
                    for(i = 0; i < length; i++)call(functions[i], finish);
                };
            },
            {
                "./once": 176
            }
        ],
        143: [
            function(_dereq_, module1, exports) {
                "use strict";
                var enumerate = _dereq_("./enumerate");
                /**
 * @class
 * @global
 * @param {object} options Construction options
 * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
 * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
 */ function BraintreeError(options) {
                    if (!BraintreeError.types.hasOwnProperty(options.type)) throw new Error(options.type + " is not a valid type.");
                    if (!options.code) throw new Error("Error code required.");
                    if (!options.message) throw new Error("Error message required.");
                    this.name = "BraintreeError";
                    /**
   * @type {string}
   * @description A code that corresponds to specific errors.
   */ this.code = options.code;
                    /**
   * @type {string}
   * @description A short description of the error.
   */ this.message = options.message;
                    /**
   * @type {BraintreeError.types}
   * @description The type of error.
   */ this.type = options.type;
                    /**
   * @type {object=}
   * @description Additional information about the error, such as an underlying network error response.
   */ this.details = options.details;
                }
                BraintreeError.prototype = Object.create(Error.prototype);
                BraintreeError.prototype.constructor = BraintreeError;
                /**
 * Enum for {@link BraintreeError} types.
 * @name BraintreeError.types
 * @enum
 * @readonly
 * @memberof BraintreeError
 * @property {string} CUSTOMER An error caused by the customer.
 * @property {string} MERCHANT An error that is actionable by the merchant.
 * @property {string} NETWORK An error due to a network problem.
 * @property {string} INTERNAL An error caused by Braintree code.
 * @property {string} UNKNOWN An error where the origin is unknown.
 */ BraintreeError.types = enumerate([
                    "CUSTOMER",
                    "MERCHANT",
                    "NETWORK",
                    "INTERNAL",
                    "UNKNOWN"
                ]);
                BraintreeError.findRootError = function(err) {
                    if (err instanceof BraintreeError && err.details && err.details.originalError) return BraintreeError.findRootError(err.details.originalError);
                    return err;
                };
                module1.exports = BraintreeError;
            },
            {
                "./enumerate": 153
            }
        ],
        144: [
            function(_dereq_, module1, exports) {
                "use strict";
                // Taken from https://github.com/sindresorhus/decamelize/blob/95980ab6fb44c40eaca7792bdf93aff7c210c805/index.js
                function transformKey(key) {
                    return key.replace(/([a-z\d])([A-Z])/g, "$1_$2").replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1_$2").toLowerCase();
                }
                function camelCaseToSnakeCase(input) {
                    var converted;
                    if (Array.isArray(input)) {
                        converted = [];
                        input.forEach(function(x) {
                            converted.push(camelCaseToSnakeCase(x));
                        });
                    } else if (typeof input === "object") converted = Object.keys(input).reduce(function(newObj, key) {
                        var transformedKey = transformKey(key);
                        if (typeof input[key] === "object") newObj[transformedKey] = camelCaseToSnakeCase(input[key]);
                        else newObj[transformedKey] = input[key];
                        return newObj;
                    }, {});
                    else converted = input;
                    return converted;
                }
                module1.exports = camelCaseToSnakeCase;
            },
            {}
        ],
        145: [
            function(_dereq_, module1, exports) {
                "use strict";
                var VERSION = "3.110.0";
                var PLATFORM = "web";
                var CLIENT_API_URLS = {
                    production: "https://api.braintreegateway.com:443",
                    sandbox: "https://api.sandbox.braintreegateway.com:443"
                };
                var ASSETS_URLS = {
                    production: "https://assets.braintreegateway.com",
                    sandbox: "https://assets.braintreegateway.com"
                };
                var GRAPHQL_URLS = {
                    production: "https://payments.braintree-api.com/graphql",
                    sandbox: "https://payments.sandbox.braintree-api.com/graphql"
                };
                // endRemoveIf(production)
                module1.exports = {
                    ANALYTICS_PREFIX: PLATFORM + ".",
                    ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
                    ANALYTICS_URL: "https://www.paypal.com/xoplatform/logger/api/logger",
                    ASSETS_URLS: ASSETS_URLS,
                    CLIENT_API_URLS: CLIENT_API_URLS,
                    FRAUDNET_SOURCE: "BRAINTREE_SIGNIN",
                    FRAUDNET_FNCLS: "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99",
                    FRAUDNET_URL: "https://c.paypal.com/da/r/fb.js",
                    BUS_CONFIGURATION_REQUEST_EVENT: "BUS_CONFIGURATION_REQUEST",
                    GRAPHQL_URLS: GRAPHQL_URLS,
                    INTEGRATION_TIMEOUT_MS: 60000,
                    VERSION: VERSION,
                    INTEGRATION: "custom",
                    SOURCE: "client",
                    PLATFORM: PLATFORM,
                    BRAINTREE_LIBRARY_VERSION: "braintree/" + PLATFORM + "/" + VERSION
                };
            },
            {}
        ],
        146: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("./braintree-error");
                var sharedErrors = _dereq_("./errors");
                module1.exports = function(instance, methodNames) {
                    methodNames.forEach(function(methodName) {
                        instance[methodName] = function() {
                            throw new BraintreeError({
                                type: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.type,
                                code: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.code,
                                message: methodName + " cannot be called after teardown."
                            });
                        };
                    });
                };
            },
            {
                "./braintree-error": 143,
                "./errors": 154
            }
        ],
        147: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("./braintree-error");
                function convertToBraintreeError(originalErr, btErrorObject) {
                    if (originalErr instanceof BraintreeError) return originalErr;
                    return new BraintreeError({
                        type: btErrorObject.type,
                        code: btErrorObject.code,
                        message: btErrorObject.message,
                        details: {
                            originalError: originalErr
                        }
                    });
                }
                module1.exports = convertToBraintreeError;
            },
            {
                "./braintree-error": 143
            }
        ],
        148: [
            function(_dereq_, module1, exports) {
                "use strict";
                // endRemoveIf(production)
                var ASSETS_URLS = _dereq_("./constants").ASSETS_URLS;
                function createAssetsUrl(authorization) {
                    // endRemoveIf(production)
                    return ASSETS_URLS.production;
                }
                /* eslint-enable */ module1.exports = {
                    create: createAssetsUrl
                };
            },
            {
                "./constants": 145
            }
        ],
        149: [
            function(_dereq_, module1, exports) {
                "use strict";
                var atob1 = _dereq_("../lib/vendor/polyfill").atob;
                var CLIENT_API_URLS = _dereq_("../lib/constants").CLIENT_API_URLS;
                function _isTokenizationKey(str) {
                    return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
                }
                function _parseTokenizationKey(tokenizationKey) {
                    var tokens = tokenizationKey.split("_");
                    var environment = tokens[0];
                    var merchantId = tokens.slice(2).join("_");
                    return {
                        merchantId: merchantId,
                        environment: environment
                    };
                }
                function createAuthorizationData(authorization) {
                    var parsedClientToken, parsedTokenizationKey;
                    var data = {
                        attrs: {},
                        configUrl: ""
                    };
                    if (_isTokenizationKey(authorization)) {
                        parsedTokenizationKey = _parseTokenizationKey(authorization);
                        data.environment = parsedTokenizationKey.environment;
                        data.attrs.tokenizationKey = authorization;
                        data.configUrl = CLIENT_API_URLS[parsedTokenizationKey.environment] + "/merchants/" + parsedTokenizationKey.merchantId + "/client_api/v1/configuration";
                    } else {
                        parsedClientToken = JSON.parse(atob1(authorization));
                        data.environment = parsedClientToken.environment;
                        data.attrs.authorizationFingerprint = parsedClientToken.authorizationFingerprint;
                        data.configUrl = parsedClientToken.configUrl;
                        data.graphQL = parsedClientToken.graphQL;
                    }
                    return data;
                }
                module1.exports = createAuthorizationData;
            },
            {
                "../lib/constants": 145,
                "../lib/vendor/polyfill": 181
            }
        ],
        150: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("./braintree-error");
                var assets = _dereq_("./assets");
                var sharedErrors = _dereq_("./errors");
                var VERSION = "3.110.0";
                function createDeferredClient(options) {
                    var promise = Promise.resolve();
                    if (options.client) return Promise.resolve(options.client);
                    if (!(window.braintree && window.braintree.client)) promise = assets.loadScript({
                        src: options.assetsUrl + "/web/" + VERSION + "/js/client.min.js"
                    })["catch"](function(err) {
                        return Promise.reject(new BraintreeError({
                            type: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.type,
                            code: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.code,
                            message: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.message,
                            details: {
                                originalError: err
                            }
                        }));
                    });
                    return promise.then(function() {
                        if (window.braintree.client.VERSION !== VERSION) return Promise.reject(new BraintreeError({
                            type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
                            code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
                            message: "Client (version " + window.braintree.client.VERSION + ") and " + options.name + " (version " + VERSION + ") components must be from the same SDK version."
                        }));
                        return window.braintree.client.create({
                            authorization: options.authorization,
                            debug: options.debug
                        });
                    });
                }
                module1.exports = {
                    create: createDeferredClient
                };
            },
            {
                "./assets": 139,
                "./braintree-error": 143,
                "./errors": 154
            }
        ],
        151: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function(fn) {
                    return function() {
                        // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
                        var args = arguments;
                        setTimeout(function() {
                            fn.apply(null, args);
                        }, 1);
                    };
                };
            },
            {}
        ],
        152: [
            function(_dereq_, module1, exports) {
                "use strict";
                var batchExecuteFunctions = _dereq_("./batch-execute-functions");
                function Destructor() {
                    this._teardownRegistry = [];
                    this._isTearingDown = false;
                }
                Destructor.prototype.registerFunctionForTeardown = function(fn) {
                    if (typeof fn === "function") this._teardownRegistry.push(fn);
                };
                Destructor.prototype.teardown = function(callback) {
                    if (this._isTearingDown) {
                        callback(new Error("Destructor is already tearing down"));
                        return;
                    }
                    this._isTearingDown = true;
                    batchExecuteFunctions(this._teardownRegistry, (function(err) {
                        this._teardownRegistry = [];
                        this._isTearingDown = false;
                        if (typeof callback === "function") callback(err);
                    }).bind(this));
                };
                module1.exports = Destructor;
            },
            {
                "./batch-execute-functions": 142
            }
        ],
        153: [
            function(_dereq_, module1, exports) {
                "use strict";
                function enumerate(values, prefix) {
                    prefix = prefix == null ? "" : prefix;
                    return values.reduce(function(enumeration, value) {
                        enumeration[value] = prefix + value;
                        return enumeration;
                    }, {});
                }
                module1.exports = enumerate;
            },
            {}
        ],
        154: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Shared Internal Error Codes
 * @ignore
 * @description These codes should never be experienced by the merchant directly.
 * @property {INTERNAL} INVALID_USE_OF_INTERNAL_FUNCTION Occurs when the client is created without a gateway configuration. Should never happen.
 */ /**
 * @name BraintreeError.Shared Errors - Component Creation Error Codes
 * @description Errors that occur when creating components.
 * @property {MERCHANT} INSTANTIATION_OPTION_REQUIRED Occurs when a component is created that is missing a required option.
 * @property {MERCHANT} INCOMPATIBLE_VERSIONS Occurs when a component is created with a client with a different version than the component.
 * @property {NETWORK} CLIENT_SCRIPT_FAILED_TO_LOAD Occurs when a component attempts to load the Braintree client script, but the request fails.
 */ /**
 * @name BraintreeError.Shared Errors - Component Instance Error Codes
 * @description Errors that occur when using instances of components.
 * @property {MERCHANT} METHOD_CALLED_AFTER_TEARDOWN Occurs when a method is called on a component instance after it has been torn down.
 */ var BraintreeError = _dereq_("./braintree-error");
                module1.exports = {
                    INVALID_USE_OF_INTERNAL_FUNCTION: {
                        type: BraintreeError.types.INTERNAL,
                        code: "INVALID_USE_OF_INTERNAL_FUNCTION"
                    },
                    INSTANTIATION_OPTION_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "INSTANTIATION_OPTION_REQUIRED"
                    },
                    INCOMPATIBLE_VERSIONS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "INCOMPATIBLE_VERSIONS"
                    },
                    CLIENT_SCRIPT_FAILED_TO_LOAD: {
                        type: BraintreeError.types.NETWORK,
                        code: "CLIENT_SCRIPT_FAILED_TO_LOAD",
                        message: "Braintree client script could not be loaded."
                    },
                    METHOD_CALLED_AFTER_TEARDOWN: {
                        type: BraintreeError.types.MERCHANT,
                        code: "METHOD_CALLED_AFTER_TEARDOWN"
                    }
                };
            },
            {
                "./braintree-error": 143
            }
        ],
        155: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function findRootNode(element) {
                    while(element.parentNode)element = element.parentNode;
                    return element;
                };
            },
            {}
        ],
        156: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function(array, key, value) {
                    var i;
                    for(i = 0; i < array.length; i++){
                        if (array[i].hasOwnProperty(key) && array[i][key] === value) return array[i];
                    }
                    return null;
                };
            },
            {}
        ],
        157: [
            function(_dereq_, module1, exports) {
                "use strict";
                var Popup = _dereq_("./strategies/popup");
                var PopupBridge = _dereq_("./strategies/popup-bridge");
                var Modal = _dereq_("./strategies/modal");
                var Bus = _dereq_("framebus");
                var events = _dereq_("../shared/events");
                var errors = _dereq_("../shared/errors");
                var constants = _dereq_("../shared/constants");
                var uuid = _dereq_("@braintree/uuid");
                var iFramer = _dereq_("@braintree/iframer");
                var BraintreeError = _dereq_("../../braintree-error");
                var browserDetection = _dereq_("../shared/browser-detection");
                var assign = _dereq_("./../../assign").assign;
                var BUS_CONFIGURATION_REQUEST_EVENT = _dereq_("../../constants").BUS_CONFIGURATION_REQUEST_EVENT;
                var REQUIRED_CONFIG_KEYS = [
                    "name",
                    "dispatchFrameUrl",
                    "openFrameUrl"
                ];
                function noop() {}
                function _validateFrameConfiguration(options) {
                    if (!options) throw new Error("Valid configuration is required");
                    REQUIRED_CONFIG_KEYS.forEach(function(key) {
                        if (!options.hasOwnProperty(key)) throw new Error("A valid frame " + key + " must be provided");
                    });
                    if (!/^[\w_]+$/.test(options.name)) throw new Error("A valid frame name must be provided");
                }
                function FrameService(options) {
                    _validateFrameConfiguration(options);
                    this._serviceId = uuid().replace(/-/g, "");
                    this._options = {
                        name: options.name + "_" + this._serviceId,
                        dispatchFrameUrl: options.dispatchFrameUrl,
                        openFrameUrl: options.openFrameUrl,
                        height: options.height,
                        width: options.width,
                        top: options.top,
                        left: options.left
                    };
                    this.state = options.state || {};
                    this._bus = new Bus({
                        channel: this._serviceId
                    });
                    this._setBusEvents();
                }
                FrameService.prototype.initialize = function(callback) {
                    var dispatchFrameReadyHandler = (function() {
                        callback();
                        this._bus.off(events.DISPATCH_FRAME_READY, dispatchFrameReadyHandler);
                    }).bind(this);
                    this._bus.on(events.DISPATCH_FRAME_READY, dispatchFrameReadyHandler);
                    this._writeDispatchFrame();
                };
                FrameService.prototype._writeDispatchFrame = function() {
                    var frameName = constants.DISPATCH_FRAME_NAME + "_" + this._serviceId;
                    var frameSrc = this._options.dispatchFrameUrl;
                    this._dispatchFrame = iFramer({
                        "aria-hidden": true,
                        name: frameName,
                        title: frameName,
                        src: frameSrc,
                        "class": constants.DISPATCH_FRAME_CLASS,
                        height: 0,
                        width: 0,
                        style: {
                            position: "absolute",
                            left: "-9999px"
                        }
                    });
                    document.body.appendChild(this._dispatchFrame);
                };
                FrameService.prototype._setBusEvents = function() {
                    this._bus.on(events.DISPATCH_FRAME_REPORT, (function(res, reply) {
                        if (this._onCompleteCallback) this._onCompleteCallback.call(null, res.err, res.payload);
                        this._frame.close();
                        this._onCompleteCallback = null;
                        if (reply) reply();
                    }).bind(this));
                    this._bus.on(BUS_CONFIGURATION_REQUEST_EVENT, (function(reply) {
                        reply(this.state);
                    }).bind(this));
                };
                FrameService.prototype.open = function(options, callback) {
                    options = options || {};
                    this._frame = this._getFrameForEnvironment(options);
                    this._frame.initialize(callback);
                    if (this._frame instanceof PopupBridge) // Frameservice loads a spinner then redirects to the final destination url.
                    // For Popupbridge it doesn't have the same rules around popups since it's deferred to the mobile side
                    // therefore, skips the regular open path and instead uses `#redirect` to handle things
                    return;
                    assign(this.state, options.state);
                    this._onCompleteCallback = callback;
                    this._frame.open();
                    if (this.isFrameClosed()) {
                        this._cleanupFrame();
                        if (callback) callback(new BraintreeError(errors.FRAME_SERVICE_FRAME_OPEN_FAILED));
                        return;
                    }
                    this._pollForPopupClose();
                };
                FrameService.prototype.redirect = function(url) {
                    if (this._frame && !this.isFrameClosed()) this._frame.redirect(url);
                };
                FrameService.prototype.close = function() {
                    if (!this.isFrameClosed()) this._frame.close();
                };
                FrameService.prototype.focus = function() {
                    if (!this.isFrameClosed()) this._frame.focus();
                };
                FrameService.prototype.createHandler = function(options) {
                    options = options || {};
                    return {
                        close: (function() {
                            if (options.beforeClose) options.beforeClose();
                            this.close();
                        }).bind(this),
                        focus: (function() {
                            if (options.beforeFocus) options.beforeFocus();
                            this.focus();
                        }).bind(this)
                    };
                };
                FrameService.prototype.createNoopHandler = function() {
                    return {
                        close: noop,
                        focus: noop
                    };
                };
                FrameService.prototype.teardown = function() {
                    this.close();
                    this._dispatchFrame.parentNode.removeChild(this._dispatchFrame);
                    this._dispatchFrame = null;
                    this._cleanupFrame();
                };
                FrameService.prototype.isFrameClosed = function() {
                    return this._frame == null || this._frame.isClosed();
                };
                FrameService.prototype._cleanupFrame = function() {
                    this._frame = null;
                    clearInterval(this._popupInterval);
                    this._popupInterval = null;
                };
                FrameService.prototype._pollForPopupClose = function() {
                    this._popupInterval = setInterval((function() {
                        if (this.isFrameClosed()) {
                            this._cleanupFrame();
                            if (this._onCompleteCallback) this._onCompleteCallback(new BraintreeError(errors.FRAME_SERVICE_FRAME_CLOSED));
                        }
                    }).bind(this), constants.POPUP_POLL_INTERVAL);
                    return this._popupInterval;
                };
                FrameService.prototype._getFrameForEnvironment = function(options) {
                    var usePopup = browserDetection.supportsPopups();
                    var popupBridgeExists = Boolean(window.popupBridge);
                    var initOptions = assign({}, this._options, options);
                    if (popupBridgeExists) return new PopupBridge(initOptions);
                    else if (usePopup) return new Popup(initOptions);
                    return new Modal(initOptions);
                };
                module1.exports = FrameService;
            },
            {
                "../../braintree-error": 143,
                "../../constants": 145,
                "../shared/browser-detection": 164,
                "../shared/constants": 165,
                "../shared/errors": 166,
                "../shared/events": 167,
                "./../../assign": 140,
                "./strategies/modal": 159,
                "./strategies/popup": 162,
                "./strategies/popup-bridge": 160,
                "@braintree/iframer": 32,
                "@braintree/uuid": 36,
                framebus: 50
            }
        ],
        158: [
            function(_dereq_, module1, exports) {
                "use strict";
                var FrameService = _dereq_("./frame-service");
                /**
 * @ignore
 * @function create
 * Initializing FrameService should be done at the point when the component is created, so it is ready whenever a component needs to open a popup window.
 * Browsers have varying rules around what constitutes and async action worth blocking a popup for, but the likes of Safari
 * will block the popup if `frameService#create` is invoked during any asynchronous process (such as an API request to tokenize payment details).
 *
 * The process of setting up the dispatch frame and subsequent framebus communications via event listeners are considered async by Safari's standards.
 *
 * @param {object} options The options provided to frameservice
 * @param {string} options.name The name to use for identifying the various pieces associated with frameservice.
 * @param {string} options.dispatchFrameUrl The static asset to load for use as the dispatch frame. This allows for secure communication between the iframe and the popup, since they are on the same asset domain (usually checkout.paypal.com or assets.braintreegateway.com)
 * @param {string} options.openFrameUrl The url to load in the popup. Sometimes it is the case that you'll need info that comes _after_ the popup loads in which case we load the `landing-frame` that's a loading spinner then redirect to the proper/final destination. See the PayPal component for an example.
 * Otherwise if all the info needed is ready up-front, then you can forego a landing frame and go straight to the final destination.
 * @param {string} [options.height] The desired popup height.
 * @param {string} [options.width] The desired popup width.
 * @param {string} [options.top] The desired top value of the popup for positioning.
 * @param {string} [options.left] The desired left value of the popup for positioning.
 * @param {object} [options.state] Seems to be dead code, but allows for injecting data in to popup. NEXT_MAJOR_VERSION remove this param if no usage exists.
 * @param {function} callback The function to invoke once the frameservice is created and ready to use. FrameService instance is returned.
 */ module1.exports = {
                    create: function createFrameService(options, callback) {
                        var frameService = new FrameService(options);
                        frameService.initialize(function() {
                            callback(frameService);
                        });
                    }
                };
            },
            {
                "./frame-service": 157
            }
        ],
        159: [
            function(_dereq_, module1, exports) {
                "use strict";
                var iFramer = _dereq_("@braintree/iframer");
                var assign = _dereq_("../../../assign").assign;
                var browserDetection = _dereq_("../../shared/browser-detection");
                var ELEMENT_STYLES = {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    padding: 0,
                    margin: 0,
                    border: 0,
                    outline: "none",
                    zIndex: 20001,
                    background: "#FFFFFF"
                };
                function noop() {}
                /**
 *
 * We should not ever really use the Modal. Modals are _like_  popups, but the key difference is that the customer can't actually verify it's app domain and thus secure/valid. Old PP sdk (./src/paypal) uses this
 * to get info from webviews (e.g. facebook).
 */ function Modal(options) {
                    this._closed = null;
                    this._frame = null;
                    this._options = options || {};
                    this._container = this._options.container || document.body;
                }
                Modal.prototype.initialize = noop;
                Modal.prototype.open = function() {
                    var iframerConfig = {
                        src: this._options.openFrameUrl,
                        name: this._options.name,
                        scrolling: "yes",
                        height: "100%",
                        width: "100%",
                        style: assign({}, ELEMENT_STYLES),
                        title: "Lightbox Frame"
                    };
                    if (browserDetection.isIos()) {
                        // WKWebView has buggy behavior when scrolling a fixed position modal. The workaround is to lock scrolling in
                        // the background. When modal is closed, we restore scrolling and return to the previous scroll position.
                        if (browserDetection.isIosWKWebview()) {
                            this._lockScrolling();
                            // Allows WKWebView to scroll all the way down to bottom
                            iframerConfig.style = {};
                        }
                        this._el = document.createElement("div");
                        assign(this._el.style, ELEMENT_STYLES, {
                            height: "100%",
                            width: "100%",
                            overflow: "auto",
                            "-webkit-overflow-scrolling": "touch"
                        });
                        this._frame = iFramer(iframerConfig);
                        this._el.appendChild(this._frame);
                    } else this._el = this._frame = iFramer(iframerConfig);
                    this._closed = false;
                    this._container.appendChild(this._el);
                };
                Modal.prototype.focus = noop;
                Modal.prototype.close = function() {
                    this._container.removeChild(this._el);
                    this._frame = null;
                    this._closed = true;
                    if (browserDetection.isIosWKWebview()) this._unlockScrolling();
                };
                Modal.prototype.isClosed = function() {
                    return Boolean(this._closed);
                };
                Modal.prototype.redirect = function(redirectUrl) {
                    this._frame.src = redirectUrl;
                };
                Modal.prototype._unlockScrolling = function() {
                    document.body.style.overflow = this._savedBodyProperties.overflowStyle;
                    document.body.style.position = this._savedBodyProperties.positionStyle;
                    window.scrollTo(this._savedBodyProperties.left, this._savedBodyProperties.top);
                    delete this._savedBodyProperties;
                };
                Modal.prototype._lockScrolling = function() {
                    var doc = document.documentElement;
                    // From https://stackoverflow.com/questions/9538868/prevent-body-from-scrolling-when-a-modal-is-opened#comment65626743_24727206
                    this._savedBodyProperties = {
                        left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
                        top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
                        overflowStyle: document.body.style.overflow,
                        positionStyle: document.body.style.position
                    };
                    document.body.style.overflow = "hidden";
                    document.body.style.position = "fixed";
                    window.scrollTo(0, 0);
                };
                module1.exports = Modal;
            },
            {
                "../../../assign": 140,
                "../../shared/browser-detection": 164,
                "@braintree/iframer": 32
            }
        ],
        160: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../../../braintree-error");
                var errors = _dereq_("../../shared/errors");
                function noop() {}
                function PopupBridge(options) {
                    this._closed = null;
                    this._options = options;
                }
                PopupBridge.prototype.initialize = function(callback) {
                    var self1 = this;
                    window.popupBridge.onComplete = function(err, payload) {
                        var popupDismissed = !payload && !err;
                        self1._closed = true;
                        if (err || popupDismissed) {
                            // User clicked "Done" button of browser view
                            callback(new BraintreeError(errors.FRAME_SERVICE_FRAME_CLOSED));
                            return;
                        }
                        // User completed popup flow (includes success and cancel cases)
                        callback(null, payload);
                    };
                };
                PopupBridge.prototype.open = function(options) {
                    var url;
                    options = options || {};
                    url = options.openFrameUrl || this._options.openFrameUrl;
                    this._closed = false;
                    window.popupBridge.open(url);
                };
                PopupBridge.prototype.focus = noop;
                PopupBridge.prototype.close = noop;
                PopupBridge.prototype.isClosed = function() {
                    return Boolean(this._closed);
                };
                PopupBridge.prototype.redirect = function(redirectUrl) {
                    this.open({
                        openFrameUrl: redirectUrl
                    });
                };
                module1.exports = PopupBridge;
            },
            {
                "../../../braintree-error": 143,
                "../../shared/errors": 166
            }
        ],
        161: [
            function(_dereq_, module1, exports) {
                "use strict";
                var constants = _dereq_("../../../shared/constants");
                var position = _dereq_("./position");
                function calculatePosition(type, userDefinedPosition, size) {
                    if (typeof userDefinedPosition !== "undefined") return userDefinedPosition;
                    return position[type](size);
                }
                module1.exports = function composePopupOptions(options) {
                    var height = options.height || constants.DEFAULT_POPUP_HEIGHT;
                    var width = options.width || constants.DEFAULT_POPUP_WIDTH;
                    var top = calculatePosition("top", options.top, height);
                    var left = calculatePosition("left", options.left, width);
                    return [
                        constants.POPUP_BASE_OPTIONS,
                        "height=" + height,
                        "width=" + width,
                        "top=" + top,
                        "left=" + left
                    ].join(",");
                };
            },
            {
                "../../../shared/constants": 165,
                "./position": 163
            }
        ],
        162: [
            function(_dereq_, module1, exports) {
                "use strict";
                var composeOptions = _dereq_("./compose-options");
                function noop() {}
                function Popup(options) {
                    this._frame = null;
                    this._options = options || {};
                }
                Popup.prototype.initialize = noop;
                Popup.prototype.open = function() {
                    this._frame = window.open(this._options.openFrameUrl, this._options.name, composeOptions(this._options));
                };
                Popup.prototype.focus = function() {
                    this._frame.focus();
                };
                Popup.prototype.close = function() {
                    if (this._frame.closed) return;
                    this._frame.close();
                };
                Popup.prototype.isClosed = function() {
                    return !this._frame || Boolean(this._frame.closed);
                };
                Popup.prototype.redirect = function(redirectUrl) {
                    this._frame.location.href = redirectUrl;
                };
                module1.exports = Popup;
            },
            {
                "./compose-options": 161
            }
        ],
        163: [
            function(_dereq_, module1, exports) {
                "use strict";
                function top(height) {
                    var windowHeight = window.outerHeight || document.documentElement.clientHeight;
                    var windowTop = window.screenY == null ? window.screenTop : window.screenY;
                    return center(windowHeight, height, windowTop);
                }
                function left(width) {
                    var windowWidth = window.outerWidth || document.documentElement.clientWidth;
                    var windowLeft = window.screenX == null ? window.screenLeft : window.screenX;
                    return center(windowWidth, width, windowLeft);
                }
                function center(windowMetric, popupMetric, offset) {
                    return (windowMetric - popupMetric) / 2 + offset;
                }
                module1.exports = {
                    top: top,
                    left: left,
                    center: center
                };
            },
            {}
        ],
        164: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    isIos: _dereq_("@braintree/browser-detection/is-ios"),
                    isIosWKWebview: _dereq_("@braintree/browser-detection/is-ios-wkwebview"),
                    supportsPopups: _dereq_("@braintree/browser-detection/supports-popups")
                };
            },
            {
                "@braintree/browser-detection/is-ios": 27,
                "@braintree/browser-detection/is-ios-wkwebview": 26,
                "@braintree/browser-detection/supports-popups": 29
            }
        ],
        165: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    DISPATCH_FRAME_NAME: "dispatch",
                    DISPATCH_FRAME_CLASS: "braintree-dispatch-frame",
                    POPUP_BASE_OPTIONS: "resizable,scrollbars",
                    DEFAULT_POPUP_WIDTH: 450,
                    DEFAULT_POPUP_HEIGHT: 535,
                    POPUP_POLL_INTERVAL: 100,
                    POPUP_CLOSE_TIMEOUT: 100
                };
            },
            {}
        ],
        166: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Popup Related Error Codes
 * @ignore
 * @description Errors that occur when using a component that opens a popup window.
 * @property {INTERNAL} FRAME_SERVICE_FRAME_CLOSED - Occurs when the frame is closed before tokenization can occur.
 * @property {INTERNAL} FRAME_SERVICE_FRAME_OPEN_FAILED - Occurs when the popup could not be opened.
 */ var BraintreeError = _dereq_("../../braintree-error");
                module1.exports = {
                    FRAME_SERVICE_FRAME_CLOSED: {
                        type: BraintreeError.types.INTERNAL,
                        code: "FRAME_SERVICE_FRAME_CLOSED",
                        message: "Frame closed before tokenization could occur."
                    },
                    FRAME_SERVICE_FRAME_OPEN_FAILED: {
                        type: BraintreeError.types.INTERNAL,
                        code: "FRAME_SERVICE_FRAME_OPEN_FAILED",
                        message: "Frame failed to open."
                    }
                };
            },
            {
                "../../braintree-error": 143
            }
        ],
        167: [
            function(_dereq_, module1, exports) {
                "use strict";
                var enumerate = _dereq_("../../enumerate");
                module1.exports = enumerate([
                    "DISPATCH_FRAME_READY",
                    "DISPATCH_FRAME_REPORT"
                ], "frameService:");
            },
            {
                "../../enumerate": 153
            }
        ],
        168: [
            function(_dereq_, module1, exports) {
                "use strict";
                var VERSION = "3.110.0";
                var assign = _dereq_("./assign").assign;
                function generateTokenizationParameters(configuration, overrides) {
                    var metadata = configuration.analyticsMetadata;
                    var basicTokenizationParameters = {
                        gateway: "braintree",
                        "braintree:merchantId": configuration.gatewayConfiguration.merchantId,
                        "braintree:apiVersion": "v1",
                        "braintree:sdkVersion": VERSION,
                        "braintree:metadata": JSON.stringify({
                            source: metadata.source,
                            integration: metadata.integration,
                            sessionId: metadata.sessionId,
                            version: VERSION,
                            platform: metadata.platform
                        })
                    };
                    return assign({}, basicTokenizationParameters, overrides);
                }
                module1.exports = function(configuration, googlePayVersion, googleMerchantId) {
                    var data, paypalPaymentMethod;
                    var androidPayConfiguration = configuration.gatewayConfiguration.androidPay;
                    var environment = configuration.gatewayConfiguration.environment === "production" ? "PRODUCTION" : "TEST";
                    if (googlePayVersion === 2) {
                        data = {
                            apiVersion: 2,
                            apiVersionMinor: 0,
                            environment: environment,
                            allowedPaymentMethods: [
                                {
                                    type: "CARD",
                                    parameters: {
                                        allowedAuthMethods: [
                                            "PAN_ONLY",
                                            "CRYPTOGRAM_3DS"
                                        ],
                                        allowedCardNetworks: androidPayConfiguration.supportedNetworks.map(function(card) {
                                            return card.toUpperCase();
                                        })
                                    },
                                    tokenizationSpecification: {
                                        type: "PAYMENT_GATEWAY",
                                        parameters: generateTokenizationParameters(configuration, {
                                            "braintree:authorizationFingerprint": androidPayConfiguration.googleAuthorizationFingerprint
                                        })
                                    }
                                }
                            ]
                        };
                        if (googleMerchantId) data.merchantInfo = {
                            merchantId: googleMerchantId
                        };
                        if (androidPayConfiguration.paypalClientId) {
                            paypalPaymentMethod = {
                                type: "PAYPAL",
                                parameters: {
                                    /* eslint-disable camelcase */ purchase_context: {
                                        purchase_units: [
                                            {
                                                payee: {
                                                    client_id: androidPayConfiguration.paypalClientId
                                                },
                                                recurring_payment: true
                                            }
                                        ]
                                    }
                                },
                                tokenizationSpecification: {
                                    type: "PAYMENT_GATEWAY",
                                    parameters: generateTokenizationParameters(configuration, {
                                        "braintree:paypalClientId": androidPayConfiguration.paypalClientId
                                    })
                                }
                            };
                            data.allowedPaymentMethods.push(paypalPaymentMethod);
                        }
                    } else {
                        data = {
                            environment: environment,
                            allowedPaymentMethods: [
                                "CARD",
                                "TOKENIZED_CARD"
                            ],
                            paymentMethodTokenizationParameters: {
                                tokenizationType: "PAYMENT_GATEWAY",
                                parameters: generateTokenizationParameters(configuration, {
                                    "braintree:authorizationFingerprint": androidPayConfiguration.googleAuthorizationFingerprint
                                })
                            },
                            cardRequirements: {
                                allowedCardNetworks: androidPayConfiguration.supportedNetworks.map(function(card) {
                                    return card.toUpperCase();
                                })
                            }
                        };
                        if (configuration.authorizationType === "TOKENIZATION_KEY") data.paymentMethodTokenizationParameters.parameters["braintree:clientKey"] = configuration.authorization;
                        if (googleMerchantId) data.merchantId = googleMerchantId;
                        if (googlePayVersion) data.apiVersion = googlePayVersion;
                    }
                    return data;
                };
            },
            {
                "./assign": 140
            }
        ],
        169: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function inIframe(win) {
                    win = win || window;
                    try {
                        return win.self !== win.top;
                    } catch (e) {
                        return true;
                    }
                };
            },
            {}
        ],
        170: [
            function(_dereq_, module1, exports) {
                "use strict";
                function convertDateStringToDate(dateString) {
                    var splitDate = dateString.split("-");
                    return new Date(splitDate[0], splitDate[1], splitDate[2]);
                }
                function isDateStringBeforeOrOn(firstDate, secondDate) {
                    return convertDateStringToDate(firstDate) <= convertDateStringToDate(secondDate);
                }
                module1.exports = isDateStringBeforeOrOn;
            },
            {}
        ],
        171: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function(creditCardDetails) {
                    return creditCardDetails && creditCardDetails.hasOwnProperty("fastlane") && creditCardDetails.fastlane;
                };
            },
            {}
        ],
        172: [
            function(_dereq_, module1, exports) {
                "use strict";
                function isHTTPS(protocol) {
                    protocol = protocol || window.location.protocol;
                    return protocol === "https:";
                }
                module1.exports = {
                    isHTTPS: isHTTPS
                };
            },
            {}
        ],
        173: [
            function(_dereq_, module1, exports) {
                "use strict";
                var parser;
                var legalHosts = {
                    "paypal.com": 1,
                    "braintreepayments.com": 1,
                    "braintreegateway.com": 1,
                    "braintree-api.com": 1
                };
                // endRemoveIf(production)
                function stripSubdomains(domain) {
                    return domain.split(".").slice(-2).join(".");
                }
                function isVerifiedDomain(url) {
                    var mainDomain;
                    url = url.toLowerCase();
                    if (!/^https:/.test(url)) return false;
                    parser = parser || document.createElement("a");
                    parser.href = url;
                    mainDomain = stripSubdomains(parser.hostname);
                    return legalHosts.hasOwnProperty(mainDomain);
                }
                module1.exports = isVerifiedDomain;
            },
            {}
        ],
        174: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function(value) {
                    return JSON.parse(JSON.stringify(value));
                };
            },
            {}
        ],
        175: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function(obj) {
                    return Object.keys(obj).filter(function(key) {
                        return typeof obj[key] === "function";
                    });
                };
            },
            {}
        ],
        176: [
            function(_dereq_, module1, exports) {
                "use strict";
                function once(fn) {
                    var called = false;
                    return function() {
                        if (!called) {
                            called = true;
                            fn.apply(null, arguments);
                        }
                    };
                }
                module1.exports = once;
            },
            {}
        ],
        177: [
            function(_dereq_, module1, exports) {
                "use strict";
                function _notEmpty(obj) {
                    var key;
                    for(key in obj){
                        if (obj.hasOwnProperty(key)) return true;
                    }
                    return false;
                }
                /* eslint-disable no-mixed-operators */ function _isArray(value) {
                    return value && typeof value === "object" && typeof value.length === "number" && Object.prototype.toString.call(value) === "[object Array]" || false;
                }
                /* eslint-enable no-mixed-operators */ function hasQueryParams(url) {
                    url = url || window.location.href;
                    return /\?/.test(url);
                }
                function parse(url) {
                    var query, params;
                    url = url || window.location.href;
                    if (!hasQueryParams(url)) return {};
                    query = url.split("?")[1] || "";
                    query = query.replace(/#.*$/, "").split("&");
                    params = query.reduce(function(toReturn, keyValue) {
                        var parts = keyValue.split("=");
                        var key = decodeURIComponent(parts[0]);
                        var value = decodeURIComponent(parts[1]);
                        toReturn[key] = value;
                        return toReturn;
                    }, {});
                    return params;
                }
                function stringify(params, namespace) {
                    var k, v, p;
                    var query = [];
                    for(p in params){
                        if (!params.hasOwnProperty(p)) continue;
                        v = params[p];
                        if (namespace) {
                            if (_isArray(params)) k = namespace + "[]";
                            else k = namespace + "[" + p + "]";
                        } else k = p;
                        if (typeof v === "object") query.push(stringify(v, k));
                        else query.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
                    }
                    return query.join("&");
                }
                function queryify(url, params) {
                    url = url || "";
                    if (params != null && typeof params === "object" && _notEmpty(params)) {
                        url += url.indexOf("?") === -1 ? "?" : "";
                        url += url.indexOf("=") !== -1 ? "&" : "";
                        url += stringify(params);
                    }
                    return url;
                }
                module1.exports = {
                    parse: parse,
                    stringify: stringify,
                    queryify: queryify,
                    hasQueryParams: hasQueryParams
                };
            },
            {}
        ],
        178: [
            function(_dereq_, module1, exports) {
                "use strict";
                var uuid = _dereq_("@braintree/uuid");
                var findRootNode = _dereq_("./find-root-node");
                // based on https://github.com/krakenjs/belter/blob/cdddc4f8ddb172d29db9e7e1ad1eeeacfb93e215/src/dom.js#L981-L1031
                // thanks @bluepnume
                function isShadowElement(element) {
                    element = findRootNode(element);
                    return element.toString() === "[object ShadowRoot]";
                }
                function getShadowHost(element) {
                    element = findRootNode(element);
                    if (!isShadowElement(element)) return null;
                    return element.host;
                }
                function transformToSlot(element, styles) {
                    var styleNode = findRootNode(element).querySelector("style");
                    var shadowHost = getShadowHost(element);
                    var slotName = "shadow-slot-" + uuid();
                    var slot = document.createElement("slot");
                    var slotProvider = document.createElement("div");
                    slot.setAttribute("name", slotName);
                    element.appendChild(slot);
                    slotProvider.setAttribute("slot", slotName);
                    shadowHost.appendChild(slotProvider);
                    if (styles) {
                        if (!styleNode) {
                            styleNode = document.createElement("style");
                            element.appendChild(styleNode);
                        }
                        styleNode.sheet.insertRule('::slotted([slot="' + slotName + '"]) { ' + styles + " }");
                    }
                    if (isShadowElement(shadowHost)) return transformToSlot(slotProvider, styles);
                    return slotProvider;
                }
                module1.exports = {
                    isShadowElement: isShadowElement,
                    getShadowHost: getShadowHost,
                    transformToSlot: transformToSlot
                };
            },
            {
                "./find-root-node": 155,
                "@braintree/uuid": 36
            }
        ],
        179: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = function(snakeString) {
                    if (snakeString.indexOf("_") === -1) return snakeString;
                    return snakeString.toLowerCase().replace(/(\_\w)/g, function(match) {
                        return match[1].toUpperCase();
                    });
                };
            },
            {}
        ],
        180: [
            function(_dereq_, module1, exports) {
                "use strict";
                function useMin(isDebug) {
                    return isDebug ? "" : ".min";
                }
                module1.exports = useMin;
            },
            {}
        ],
        181: [
            function(_dereq_, module1, exports) {
                "use strict";
                // NEXT_MAJOR_VERSION old versions of IE don't have atob, in the
                // next major version, we're dropping support for those versions
                // so we can eliminate the need to have this atob polyfill
                var atobNormalized = typeof atob === "function" ? atob : atobPolyfill;
                function atobPolyfill(base64String) {
                    var a, b, c, b1, b2, b3, b4, i;
                    var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$");
                    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var result = "";
                    if (!base64Matcher.test(base64String)) throw new Error("Non base64 encoded input passed to window.atob polyfill");
                    i = 0;
                    do {
                        b1 = characters.indexOf(base64String.charAt(i++));
                        b2 = characters.indexOf(base64String.charAt(i++));
                        b3 = characters.indexOf(base64String.charAt(i++));
                        b4 = characters.indexOf(base64String.charAt(i++));
                        a = (b1 & 0x3f) << 2 | b2 >> 4 & 0x3;
                        b = (b2 & 0xf) << 4 | b3 >> 2 & 0xf;
                        c = (b3 & 0x3) << 6 | b4 & 0x3f;
                        result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : "") + (c ? String.fromCharCode(c) : "");
                    }while (i < base64String.length);
                    return result;
                }
                module1.exports = {
                    atob: function atob1(base64String) {
                        return atobNormalized.call(window, base64String);
                    },
                    _atob: atobPolyfill
                };
            },
            {}
        ],
        182: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    REQUIRED_OPTIONS_FOR_START_PAYMENT: [
                        "givenName",
                        "surname",
                        "currencyCode",
                        "onPaymentStart",
                        "paymentType",
                        "amount",
                        "fallback"
                    ],
                    REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE: [
                        "givenName",
                        "surname",
                        "currencyCode",
                        "onPaymentStart",
                        "paymentType",
                        "amount",
                        "address",
                        "billingAddress",
                        "birthDate",
                        "email",
                        "locale",
                        "customerServiceInstructions",
                        "correlationId",
                        "phone",
                        "phoneCountryCode",
                        "lineItems"
                    ],
                    REQUIRED_OPTIONS_FOR_ADDRESS: [
                        "streetAddress",
                        "locality",
                        "postalCode",
                        "countryCode"
                    ],
                    REQUIRED_OPTIONS_FOR_LINE_ITEMS: [
                        "category",
                        "name",
                        "quantity",
                        "unitAmount",
                        "unitTaxAmount"
                    ],
                    REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE: [
                        "givenName",
                        "surname",
                        "currencyCode",
                        "onPaymentStart",
                        "paymentType",
                        "amount"
                    ],
                    REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0: [
                        "authCode"
                    ],
                    REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST: [
                        "authCode",
                        "consumerReference",
                        "aliasLabel"
                    ],
                    REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT: [
                        "consumerReference",
                        "aliasKey"
                    ]
                };
            },
            {}
        ],
        183: [
            function(_dereq_, module1, exports) {
                "use strict";
                var frameService = _dereq_("../../lib/frame-service/external");
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var useMin = _dereq_("../../lib/use-min");
                var VERSION = "3.110.0";
                var INTEGRATION_TIMEOUT_MS = _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
                var analytics = _dereq_("../../lib/analytics");
                var methods = _dereq_("../../lib/methods");
                var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
                var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
                var ExtendedPromise = _dereq_("@braintree/extended-promise");
                var querystring = _dereq_("../../lib/querystring");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var constants = _dereq_("./constants");
                var errors = _dereq_("../shared/errors");
                var DEFAULT_WINDOW_WIDTH = 1282;
                var DEFAULT_WINDOW_HEIGHT = 720;
                ExtendedPromise.suppressUnhandledPromiseMessage = true;
                /**
 * @class
 * @param {object} options see {@link module:braintree-web/local-payment.create|local-payment.create}
 * @classdesc This class represents a LocalPayment component. Instances of this class can open a LocalPayment window for paying with alternate payments local to a specific country. Any additional UI, such as disabling the page while authentication is taking place, is up to the developer.
 *
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/local-payment.create|braintree-web.local-payment.create} instead.</strong>
 */ function LocalPayment(options) {
                    this._client = options.client;
                    this._assetsUrl = options.client.getConfiguration().gatewayConfiguration.assetsUrl + "/web/" + VERSION;
                    this._isDebug = options.client.getConfiguration().isDebug;
                    this._loadingFrameUrl = this._assetsUrl + "/html/local-payment-landing-frame" + useMin(this._isDebug) + ".html";
                    this._authorizationInProgress = false;
                    this._paymentType = "unknown";
                    this._merchantAccountId = options.merchantAccountId;
                }
                LocalPayment.prototype._initialize = function() {
                    var self1 = this;
                    var client = this._client;
                    var failureTimeout = setTimeout(function() {
                        analytics.sendEvent(client, "local-payment.load.timed-out");
                    }, INTEGRATION_TIMEOUT_MS);
                    return new Promise(function(resolve) {
                        frameService.create({
                            name: "localpaymentlandingpage",
                            dispatchFrameUrl: self1._assetsUrl + "/html/dispatch-frame" + useMin(self1._isDebug) + ".html",
                            openFrameUrl: self1._loadingFrameUrl
                        }, function(service) {
                            self1._frameService = service;
                            clearTimeout(failureTimeout);
                            analytics.sendEvent(client, "local-payment.load.succeeded");
                            resolve(self1);
                        });
                    });
                };
                /**
 * Options used for most local payment types.
 * @typedef {object} LocalPayment~StartPaymentOptions
 * @property {object} fallback Configuration for what to do when app switching back from a Bank app on a mobile device.
 * @property {string} fallback.buttonText The text to display in a button to redirect back to the merchant page.
 * @property {string} fallback.url The url to redirect to when the redirect button is pressed. Query params will be added to the url to process the data returned from the bank.
 * @property {string} fallback.cancelButtonText The text to display in a button to redirect back to the merchant page when the customer cancels. If no `cancelButtonText` is provided, `buttonText` will be used.
 * @property {string} fallback.cancelUrl The url to redirect to when the redirect button is pressed when the customer cancels. Query params will be added to the url to check the state of the payment. If no `cancelUrl` is provided, `url` will be used.
 * @property {object} [windowOptions] The options for configuring the window that is opened when starting the payment.
 * @property {number} [windowOptions.width=1282] The width in pixels of the window opened when starting the payment. The default width size is this large to allow various banking partner landing pages to display the QR Code to be scanned by the bank's mobile app. Many will not display the QR code when the window size is smaller than a standard desktop screen.
 * @property {number} [windowOptions.height=720] The height in pixels of the window opened when starting the payment.
 * @property {string} amount The amount to authorize for the transaction.
 * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
 * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
 * @property {string} paymentType The type of local payment. See https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom
 * @property {string} paymentTypeCountryCode The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
 * @property {string} email Payer email of the customer.
 * @property {string} givenName First name of the customer.
 * @property {string} surname Last name of the customer.
 * @property {string} phone Phone number of the customer.
 * @property {string} bic Bank Identification Code of the customer (specific to iDEAL transactions).
 * @property {boolean} recurrent Enable recurrent payment.
 * @property {string} customerId The customer's id in merchant's system (required for recurrent payments).
 * @property {boolean} shippingAddressRequired Indicates whether or not the payment needs to be shipped. For digital goods, this should be false. Defaults to false.
 * @property {object} address The shipping address.
 * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @property {string} address.extendedAddress Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @property {string} address.locality Customer's city.
 * @property {string} address.region Customer's region or state.
 * @property {string} address.postalCode Customer's postal code.
 * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
 * @property {function} onPaymentStart A function that will be called with two parameters: an object containing the  `paymentId` and a `continueCallback` that must be called to launch the flow. You can use method to do any preprocessing on your server before the flow begins..
 */ /**
 * Options used for the Pay Upon Invoice local payment type.
 * @typedef {object} LocalPayment~StartPaymentPayUponInvoiceOptions
 * @property {string} amount The amount to authorize for the transaction.
 * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
 * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
 * @property {string} paymentType The type of local payment. Must be `pay_upon_invoice`.
 * @property {string} [paymentTypeCountryCode] The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
 * @property {string} email Payer email of the customer.
 * @property {string} givenName First name of the customer.
 * @property {string} surname Last name of the customer.
 * @property {string} phone Phone number of the customer.
 * @property {string} phoneCountryCode The country calling code.
 * @property {string} birthDate The birth date of the customer in `YYYY-MM-DD` format.
 * @property {object} address The shipping address.
 * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @property {string} [address.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @property {string} address.locality Customer's city.
 * @property {string} [address.region] Customer's region or state.
 * @property {string} address.postalCode Customer's postal code.
 * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
 * @property {string} [shippingAmount] The shipping fee for all items. This value can not be a negative number.
 * @property {string} [discountAmount] The discount for all items. This value can not be a negative number.
 * @property {object} billingAddress The billing address.
 * @property {string} billingAddress.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @property {string} [billingAddress.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @property {string} billingAddress.locality Customer's city.
 * @property {string} [billingAddress.region] Customer's region or state.
 * @property {string} billingAddress.postalCode Customer's postal code.
 * @property {string} billingAddress.countryCode Customer's country code (two-character ISO 3166-1 code).
 * @property {object[]} lineItems List of line items.
 * @property {string} lineItems.category The item category type: `'DIGITAL_GOODS'`, `'PHYSICAL_GOODS'`, or `'DONATION'`.
 * @property {string} lineItems.name Item name. Maximum 127 characters.
 * @property {string} lineItems.quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
 * @property {string} lineItems.unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {string} lineItems.unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative.
 * @property {string} locale The BCP 47-formatted locale. PayPal supports a five-character code. For example, `en-DE`, `da-DK`, `he-IL`, `id-ID`, `ja-JP`, `no-NO`, `pt-BR`, `ru-RU`, `sv-SE`, `th-TH`, `zh-CN`, `zh-HK`, or `zh-TW`.
 * @property {string} customerServiceInstructions Instructions for how to contact the merchant's customer service. Maximum 4,000 characters.
 * @property {string} correlationId Used to correlate user sessions with server transactions.
 * @property {function} onPaymentStart A function that will be called with an object containing the `paymentId`. The `continueCallback` is not provided as it is not needed for this use case.
 */ /**
 * Options used for the seamless/oneclick BLIK local payment type.
 * @typedef {object} LocalPayment~StartPaymentOptions
 * @property {string} amount The amount to authorize for the transaction.
 * @property {string} currencyCode The currency to process the payment (three-character ISO-4217).
 * @property {string} [displayName] The merchant name displayed inside of the window that is opened when starting the payment.
 * @property {string} paymentType The type of local payment. Must be `blik`.
 * @property {string} paymentTypeCountryCode The country code of the local payment. This value must be one of the supported country codes for a given local payment type listed {@link https://developer.paypal.com/braintree/docs/guides/local-payment-methods/client-side-custom/javascript/v3#render-local-payment-method-buttons|here}. For local payments supported in multiple countries, this value may determine which banks are presented to the customer.
 * @property {string} email Payer email of the customer.
 * @property {string} givenName First name of the customer.
 * @property {string} surname Last name of the customer.
 * @property {string} phone Phone number of the customer.
 * @property {boolean} shippingAddressRequired Indicates whether or not the payment needs to be shipped. For digital goods, this should be false. Defaults to false.
 * @property {object} address The shipping address.
 * @property {string} address.streetAddress Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @property {string} address.extendedAddress Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @property {string} address.locality Customer's city.
 * @property {string} address.region Customer's region or state.
 * @property {string} address.postalCode Customer's postal code.
 * @property {string} address.countryCode Customer's country code (two-character ISO 3166-1 code).
 * @property {object} blikOptions Blik seamless/oneclick specific options. Should contain only one object: `level_0` or `oneClick`.
 * @property {object} blikOptions.level_0 Blik seamless specific options.
 * @property {string} blikOptions.level_0.authCode 6-digit code used to authenticate a consumer within BLIK.
 * @property {object} blikOptions.oneClick Blik oneclick specific options.
 * @property {string} blikOptions.oneClick.authCode 6-digit code used to authenticate a consumer within BLIK.
 * @property {string} blikOptions.oneClick.consumerReference The merchant generated, unique reference serving as a primary identifier for accounts connected between Blik and a merchant.
 * @property {string} blikOptions.oneClick.aliasLabel A bank defined identifier used as a display name to allow the payer to differentiate between multiple registered bank accounts.
 * @property {string} blikOptions.oneClick.aliasKey A Blik-defined identifier for a specific Blik-enabled bank account that is associated with a given merchant. Used only in conjunction with a Consumer Reference.
 * @property {function} onPaymentStart A function that will be called with an object containing the `paymentId`. The `continueCallback` is not provided as it is not needed for this use case.
 */ /**
 * Launches the local payment flow and returns a nonce payload. Only one local payment flow should be active at a time. One way to achieve this is to disable your local payment button while the flow is open.
 * @public
 * @function
 * @param {LocalPayment~StartPaymentOptions|LocalPayment~StartPaymentPayUponInvoiceOptions} options Options for initiating the local payment payment flow.
 * @param {callback} callback The second argument, <code>data</code>, is a {@link LocalPayment~startPaymentPayload|startPaymentPayload}. If no callback is provided, the method will return a Promise that resolves with a {@link LocalPayment~startPaymentPayload|startPaymentPayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * localPaymentInstance.startPayment({
 *   paymentType: 'ideal',
 *   paymentTypeCountryCode: 'NL',
 *   fallback: {
 *     buttonText: 'Return to Merchant',
 *     url: 'https://example.com/my-checkout-page'
 *   },
 *   amount: '10.00',
 *   currencyCode: 'EUR',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   address: {
 *     countryCode: 'NL'
 *   },
 *   onPaymentStart: function (data, continueCallback) {
 *     // Do any preprocessing before starting the flow
 *     // data.paymentId is the ID of the localPayment
 *     continueCallback();
 *   }
 * }).then(function (payload) {
 *   // Submit payload.nonce to your server
 * }).catch(function (startPaymentError) {
 *   // Handle flow errors or premature flow closure
 *   console.error('Error!', startPaymentError);
 * });
 * @example <caption>Pay Upon Invoice</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'pay_upon_invoice',
 *   amount: '100.00',
 *   currencyCode: 'EUR',
 *   givenName: 'Max',
 *   surname: 'Mustermann',
 *   address: { // This is used as the shipping address.
 *     streetAddress: 'Taunusanlage 12',
 *     locality: 'Frankfurt',
 *     postalCode: '60325',
 *     countryCode: 'DE',
 *   },
 *   billingAddress: {
 *     streetAddress: 'Schönhauser Allee 84',
 *     locality: 'Berlin',
 *     postalCode: '10439',
 *     countryCode: 'DE'
 *   },
 *   birthDate: '1990-01-01',
 *   email: 'buyer@example.com',
 *   locale: 'en-DE',
 *   customerServiceInstructions: 'Customer service phone is +49 6912345678.',
 *   lineItems: [{
 *     category: 'PHYSICAL_GOODS',
 *     name: 'Basketball Shoes',
 *     quantity: '1',
 *     unitAmount: '81.00',
 *     unitTaxAmount: '19.00',
 *   }],
 *   phone: '6912345678',
 *   phoneCountryCode: '49',
 *   correlationId: correlationId,
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 * @example <caption>BLIK seamless</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'blik',
 *   paymentTypeCountryCode: 'PL',
 *   amount: '10.00',
 *   currencyCode: 'PLN',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   phone: '1234566789',
 *   address: {
 *     streetAddress: 'Mokotowska 1234',
 *     locality: 'Warsaw',
 *     postalCode: '02-697',
 *     countryCode: 'PL',
 *   },
 *   blikOptions: {
 *     level_0: {
 *       authCode: "123456",
 *     },
 *   },
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 * @example <caption>BLIK oneclick first payment</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'blik',
 *   paymentTypeCountryCode: 'PL',
 *   amount: '10.00',
 *   currencyCode: 'PLN',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   phone: '1234566789',
 *   address: {
 *     streetAddress: 'Mokotowska 1234',
 *     locality: 'Warsaw',
 *     postalCode: '02-697',
 *     countryCode: 'PL',
 *   },
 *   blikOptions: {
 *     oneClick: {
 *       authCode: "123456",
 *       consumerReference: "ABCde123",
 *       aliasLabel: "my uniq alias",
 *     },
 *   },
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 * @example <caption>BLIK oneclick subsequent payment</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'blik',
 *   paymentTypeCountryCode: 'PL',
 *   amount: '10.00',
 *   currencyCode: 'PLN',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   phone: '1234566789',
 *   address: {
 *     streetAddress: 'Mokotowska 1234',
 *     locality: 'Warsaw',
 *     postalCode: '02-697',
 *     countryCode: 'PL',
 *   },
 *   blikOptions: {
 *     oneClick: {
 *       consumerReference: "ABCde123",
 *       aliasKey: "123456789",
 *     },
 *   },
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 * @example <caption>MB WAY</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'mbway',
 *   amount: '10.00',
 *   currencyCode: 'EUR',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   phone: '1234566789',
 *   phoneCountryCode: '351'
 *   address: {
 *     streetAddress: 'Rua Escura 12',
 *     locality: 'Porto',
 *     postalCode: '4465-283',
 *     countryCode: 'PT',
 *   },
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 * @example <caption>BANCOMAT PAY</caption>
 * localPaymentInstance.startPayment({
 *   paymentType: 'bancomatpay',
 *   amount: '10.00',
 *   currencyCode: 'EUR',
 *   givenName: 'Joe',
 *   surname: 'Doe',
 *   phone: '1234566789',
 *   phoneCountryCode: '49'
 *   address: {
 *     streetAddress: 'Via del Corso 12',
 *     locality: 'Roma',
 *     postalCode: '00100',
 *     countryCode: 'IT',
 *   },
 *   onPaymentStart: function (data) {
 *     // NOTE: It is critical here to store data.paymentId on your server
 *     //       so it can be mapped to a webhook sent by Braintree once the
 *     //       buyer completes their payment.
 *     console.log('Payment ID:', data.paymentId);
 *   },
 * }).catch(function (err) {
 *   // Handle any error calling startPayment.
 *   console.error(err);
 * });
 */ LocalPayment.prototype.startPayment = function(options) {
                    var missingOption, missingError, address, fallback, params, promise, billingAddress, windowOptions, onPaymentStartPromise;
                    var self1 = this; // eslint-disable-line no-invalid-this
                    var serviceId = this._frameService._serviceId; // eslint-disable-line no-invalid-this
                    // In order to provide the merchant with appropriate error messaging,
                    // more robust validation is being done on the client-side, since some
                    // option names are mapped to legacy names for the sake of the API.
                    // For example, if `billingAddress.streetAddress` was missing, then
                    // the API error response would say that `billing_address.line1` was
                    // missing. This client-side validation will correctly tell the
                    // merchant that `billingAddress.streetAddress` was missing.
                    missingOption = hasMissingOption(options);
                    if (missingOption) {
                        missingError = new BraintreeError(errors.LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION);
                        if (typeof missingOption === "string") missingError.details = "Missing required '" + missingOption + "' option.";
                        return Promise.reject(missingError);
                    }
                    windowOptions = options.windowOptions || {};
                    address = options.address || {};
                    fallback = options.fallback || {};
                    billingAddress = options.billingAddress || {};
                    params = {
                        amount: options.amount,
                        bic: options.bic,
                        billingAddress: {
                            line1: billingAddress.streetAddress,
                            line2: billingAddress.extendedAddress,
                            city: billingAddress.locality,
                            state: billingAddress.region,
                            postalCode: billingAddress.postalCode,
                            countryCode: billingAddress.countryCode
                        },
                        birthDate: options.birthDate,
                        blikOptions: options.blikOptions,
                        cancelUrl: querystring.queryify(self1._assetsUrl + "/html/local-payment-redirect-frame" + useMin(self1._isDebug) + ".html", {
                            channel: serviceId,
                            r: fallback.cancelUrl || fallback.url,
                            t: fallback.cancelButtonText || fallback.buttonText,
                            c: 1
                        }),
                        city: address.locality,
                        correlationId: options.correlationId,
                        countryCode: address.countryCode,
                        currencyIsoCode: options.currencyCode,
                        discountAmount: options.discountAmount,
                        experienceProfile: {
                            brandName: options.displayName,
                            customerServiceInstructions: options.customerServiceInstructions,
                            locale: options.locale,
                            noShipping: !options.shippingAddressRequired
                        },
                        firstName: options.givenName,
                        fundingSource: options.paymentType,
                        intent: "sale",
                        lastName: options.surname,
                        line1: address.streetAddress,
                        line2: address.extendedAddress,
                        lineItems: options.lineItems,
                        merchantAccountId: self1._merchantAccountId,
                        merchantOrPartnerCustomerId: options.customerId,
                        payerEmail: options.email,
                        paymentTypeCountryCode: options.paymentTypeCountryCode,
                        phone: options.phone,
                        phoneCountryCode: options.phoneCountryCode,
                        postalCode: address.postalCode,
                        recurrent: options.recurrent,
                        returnUrl: querystring.queryify(self1._assetsUrl + "/html/local-payment-redirect-frame" + useMin(self1._isDebug) + ".html", {
                            channel: serviceId,
                            r: fallback.url,
                            t: fallback.buttonText
                        }),
                        shippingAmount: options.shippingAmount,
                        state: address.region
                    };
                    self1._paymentType = options.paymentType.toLowerCase();
                    if (self1._authorizationInProgress) {
                        analytics.sendEvent(self1._client, self1._paymentType + ".local-payment.start-payment.error.already-opened");
                        return Promise.reject(new BraintreeError(errors.LOCAL_PAYMENT_ALREADY_IN_PROGRESS));
                    }
                    self1._authorizationInProgress = true;
                    promise = new ExtendedPromise();
                    // For deferred payment types, the popup window should not be opened,
                    // since the actual payment will be done outside of this session.
                    if (!isDeferredPaymentTypeOptions(options)) {
                        self1._startPaymentCallback = self1._createStartPaymentCallback(function(val) {
                            promise.resolve(val);
                        }, function(err) {
                            promise.reject(err);
                        });
                        self1._frameService.open({
                            width: windowOptions.width || DEFAULT_WINDOW_WIDTH,
                            height: windowOptions.height || DEFAULT_WINDOW_HEIGHT
                        }, self1._startPaymentCallback);
                    }
                    self1._client.request({
                        method: "post",
                        endpoint: "local_payments/create",
                        data: params
                    }).then(function(response) {
                        var redirectUrl = response.paymentResource.redirectUrl;
                        analytics.sendEvent(self1._client, self1._paymentType + ".local-payment.start-payment.opened");
                        self1._startPaymentOptions = options;
                        if (isDeferredPaymentTypeOptions(options)) {
                            self1._authorizationInProgress = false;
                            if (typeof redirectUrl === "string" && redirectUrl.length) promise.reject(new BraintreeError(errors.LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED));
                            else {
                                onPaymentStartPromise = options.onPaymentStart({
                                    paymentId: response.paymentResource.paymentToken
                                });
                                if (onPaymentStartPromise instanceof Promise) onPaymentStartPromise.then(function() {
                                    promise.resolve();
                                });
                                else promise.resolve();
                            }
                        } else options.onPaymentStart({
                            paymentId: response.paymentResource.paymentToken
                        }, function() {
                            self1._frameService.redirect(response.paymentResource.redirectUrl);
                        });
                    })["catch"](function(err) {
                        var status = err.details && err.details.httpStatus;
                        self1._frameService.close();
                        self1._authorizationInProgress = false;
                        if (status === 422) {
                            promise.reject(new BraintreeError({
                                type: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.type,
                                code: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.code,
                                message: errors.LOCAL_PAYMENT_INVALID_PAYMENT_OPTION.message,
                                details: {
                                    originalError: err
                                }
                            }));
                            return;
                        }
                        promise.reject(convertToBraintreeError(err, {
                            type: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.type,
                            code: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.code,
                            message: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.message
                        }));
                    });
                    return promise;
                };
                /**
 * Manually tokenizes params for a local payment received from PayPal.When app switching back from a mobile application (such as a bank application for an iDEAL payment), the window may lose context with the parent page. In that case, a fallback url is used, and this method can be used to finish the flow.
 * @public
 * @function
 * @param {object} [params] All options for tokenizing local payment parameters. If no params are passed in, the params will be pulled off of the query string of the page.
 * @param {string} params.btLpToken The token representing the local payment. Aliased to `token` if `btLpToken` is not present.
 * @param {string} params.btLpPaymentId The payment id for the local payment. Aliased to `paymentId` if `btLpPaymentId` is not present.
 * @param {string} params.btLpPayerId The payer id for the local payment. Aliased to `PayerID` if `btLpPayerId` is not present.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link LocalPayment~startPaymentPayload|startPaymentPayload}. If no callback is provided, the method will return a Promise that resolves with a {@link LocalPayment~startPaymentPayload|startPaymentPayload}.
 * @example
 * localPaymentInstance.tokenize().then(function (payload) {
 *   // send payload.nonce to your server
 * }).catch(function (err) {
 *   // handle tokenization error
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ LocalPayment.prototype.tokenize = function(params) {
                    var self1 = this;
                    var client = this._client;
                    params = params || querystring.parse();
                    // iOS Safari parses query params by adding the params inside an object called: queryItems
                    if (params.queryItems) params = params.queryItems;
                    if (params.c || params.wasCanceled) return Promise.reject(new BraintreeError({
                        type: errors.LOCAL_PAYMENT_CANCELED.type,
                        code: errors.LOCAL_PAYMENT_CANCELED.code,
                        message: errors.LOCAL_PAYMENT_CANCELED.message,
                        details: {
                            originalError: {
                                errorcode: params.errorcode,
                                token: params.btLpToken
                            }
                        }
                    }));
                    else if (params.errorcode) return Promise.reject(new BraintreeError({
                        type: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.type,
                        code: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.code,
                        message: errors.LOCAL_PAYMENT_START_PAYMENT_FAILED.message,
                        details: {
                            originalError: {
                                errorcode: params.errorcode,
                                token: params.btLpToken
                            }
                        }
                    }));
                    return client.request({
                        endpoint: "payment_methods/paypal_accounts",
                        method: "post",
                        data: this._formatTokenizeData(params)
                    }).then(function(response) {
                        var payload = self1._formatTokenizePayload(response);
                        if (window.popupBridge) analytics.sendEvent(client, self1._paymentType + ".local-payment.tokenization.success-popupbridge");
                        else analytics.sendEvent(client, self1._paymentType + ".local-payment.tokenization.success");
                        return payload;
                    })["catch"](function(err) {
                        analytics.sendEvent(client, self1._paymentType + ".local-payment.tokenization.failed");
                        return Promise.reject(convertToBraintreeError(err, {
                            type: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.type,
                            code: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.code,
                            message: errors.LOCAL_PAYMENT_TOKENIZATION_FAILED.message
                        }));
                    });
                };
                /**
 * Closes the LocalPayment window if it is open.
 * @public
 * @example
 * localPaymentInstance.closeWindow();
 * @returns {void}
 */ LocalPayment.prototype.closeWindow = function() {
                    if (this._authoriztionInProgress) analytics.sendEvent(this._client, this._paymentType + ".local-payment.start-payment.closed.by-merchant");
                    this._frameService.close();
                };
                /**
 * Focuses the LocalPayment window if it is open.
 * @public
 * @example
 * localPaymentInstance.focusWindow();
 * @returns {void}
 */ LocalPayment.prototype.focusWindow = function() {
                    this._frameService.focus();
                };
                LocalPayment.prototype._createStartPaymentCallback = function(resolve, reject) {
                    var self1 = this;
                    var client = this._client;
                    return function(err, params) {
                        self1._authorizationInProgress = false;
                        if (err) {
                            if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
                                if (params && params.errorcode === "processing_error") {
                                    // something failed within the payment window (rather than when
                                    // tokenizing with Braintree)
                                    analytics.sendEvent(client, self1._paymentType + ".local-payment.failed-in-window");
                                    reject(new BraintreeError(errors.LOCAL_PAYMENT_START_PAYMENT_FAILED));
                                    return;
                                }
                                // its possible to have a query param with errorcode=payment_error, which
                                // indicates that the customer cancelled the flow from within the UI,
                                // but as there's no meaningful difference to the merchant whether the
                                // customer closes via the UI or by manually closing the window, we
                                // don't differentiate these
                                analytics.sendEvent(client, self1._paymentType + ".local-payment.tokenization.closed.by-user");
                                reject(new BraintreeError(errors.LOCAL_PAYMENT_WINDOW_CLOSED));
                            } else if (err.code && err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) reject(new BraintreeError({
                                code: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.code,
                                type: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.type,
                                message: errors.LOCAL_PAYMENT_WINDOW_OPEN_FAILED.message,
                                details: {
                                    originalError: err
                                }
                            }));
                        } else if (params) {
                            if (!window.popupBridge) self1._frameService.redirect(self1._loadingFrameUrl);
                            self1.tokenize(params).then(resolve)["catch"](reject).then(function() {
                                self1._frameService.close();
                            });
                        }
                    };
                };
                LocalPayment.prototype._formatTokenizePayload = function(response) {
                    var payload;
                    var account = {};
                    if (response.paypalAccounts) account = response.paypalAccounts[0];
                    payload = {
                        nonce: account.nonce,
                        details: {},
                        type: account.type
                    };
                    if (account.details) {
                        if (account.details.payerInfo) payload.details = account.details.payerInfo;
                        if (account.details.correlationId) payload.correlationId = account.details.correlationId;
                    }
                    return payload;
                };
                /**
 * Checks if required tokenization parameters are available in querystring for manual tokenization requests.
 * @public
 * @function
 * @example
 * // if query string contains
 * // ?btLpToken=token&btLpPaymentId=payment-id&btLpPayerId=payer-id
 * localPaymentInstance.hasTokenizationParams(); // true
 *
 * // if query string is missing required params
 * localPaymentInstance.hasTokenizationParams(); // false
 *
 * if (localPaymentInstance.hasTokenizationParams()) {
 *   localPaymentInstance.tokenize();
 * }
 * @returns {Boolean} Returns a Boolean value for the state of the query string.
 */ LocalPayment.prototype.hasTokenizationParams = function() {
                    var params = querystring.parse();
                    if (params.errorcode) return true;
                    return Boolean(params.btLpToken && params.btLpPaymentId && params.btLpPayerId);
                };
                LocalPayment.prototype._formatTokenizeData = function(params) {
                    var clientConfiguration = this._client.getConfiguration();
                    var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
                    var data = {
                        merchantAccountId: this._merchantAccountId,
                        paypalAccount: {
                            correlationId: params.btLpToken || params.token,
                            paymentToken: params.btLpPaymentId || params.paymentId,
                            payerId: params.btLpPayerId || params.PayerID,
                            unilateral: gatewayConfiguration.paypal.unvettedMerchant,
                            intent: "sale"
                        }
                    };
                    return data;
                };
                // Some payment types are deferred. Meaning, the actual payment will
                // occur at a later time outside of this session. For example, with
                // Pay Upon Invoice, the customer will later receive an email that will
                // be used to make the actual payment through RatePay. This function
                // will return `true` if the given options contain `paymentType` of
                // a deferred payment type; and/or some payments, like blik, may have
                // specific extra options to be treated as deferred. Otherwise, it
                // will return `false`.
                function isDeferredPaymentTypeOptions(options) {
                    var blikOptions = options.blikOptions || {};
                    var paymentType = typeof options.paymentType === "string" ? options.paymentType.toLowerCase() : options.paymentType;
                    if (paymentType === "blik") return blikOptions.hasOwnProperty("level_0") || blikOptions.hasOwnProperty("oneClick");
                    return [
                        "pay_upon_invoice",
                        "mbway",
                        "bancomatpay"
                    ].includes(paymentType);
                }
                function hasMissingAddressOption(options) {
                    var i, option;
                    for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_ADDRESS.length; i++){
                        option = constants.REQUIRED_OPTIONS_FOR_ADDRESS[i];
                        if (!options.hasOwnProperty(option)) return option;
                    }
                    return false;
                }
                function hasMissingLineItemsOption(items) {
                    var i, j, item, option;
                    for(j = 0; j < items.length; j++){
                        item = items[j];
                        for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_LINE_ITEMS.length; i++){
                            option = constants.REQUIRED_OPTIONS_FOR_LINE_ITEMS[i];
                            if (!item.hasOwnProperty(option)) return option;
                        }
                    }
                    return false;
                }
                function hasMissingBlikOptions(options) {
                    var i, option, oneClick;
                    var blikOptions = options.blikOptions || {};
                    for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE.length; i++){
                        option = constants.REQUIRED_OPTIONS_FOR_BLIK_SEAMLESS_PAYMENT_TYPE[i];
                        if (!options.hasOwnProperty(option)) return option;
                    }
                    if (blikOptions.hasOwnProperty("level_0")) for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0.length; i++){
                        option = constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_LEVEL_0[i];
                        // eslint-disable-next-line camelcase
                        if (!blikOptions.level_0.hasOwnProperty(option)) return "blikOptions.level_0." + option;
                    }
                    else if (blikOptions.hasOwnProperty("oneClick")) {
                        oneClick = blikOptions.oneClick || {};
                        if (oneClick.hasOwnProperty("aliasKey")) for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT.length; i++){
                            option = constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_SUBSEQUENT[i];
                            if (!oneClick.hasOwnProperty(option)) return "blikOptions.oneClick." + option;
                        }
                        else for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST.length; i++){
                            option = constants.REQUIRED_OPTIONS_FOR_BLIK_OPTIONS_ONE_CLICK_FIRST[i];
                            if (!oneClick.hasOwnProperty(option)) return "blikOptions.oneClick." + option;
                        }
                    }
                    return false;
                }
                // This will return the name of the first missing required option that
                // is found or `true` if `options` itself is not defined. Otherwise, it
                // will return `false`.
                function hasMissingOption(options) {
                    var i, option, missingAddressOption, missingLineItemOption, paymentType;
                    if (!options) return true;
                    if (isDeferredPaymentTypeOptions(options)) {
                        paymentType = options.paymentType || "";
                        if (paymentType.toLowerCase() === "pay_upon_invoice") for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE.length; i++){
                            option = constants.REQUIRED_OPTIONS_FOR_PAY_UPON_INVOICE_PAYMENT_TYPE[i];
                            if (!options.hasOwnProperty(option)) return option;
                            if (option === "address" || option === "billingAddress") {
                                missingAddressOption = hasMissingAddressOption(options[option]);
                                if (missingAddressOption) return option + "." + missingAddressOption;
                            } else if (option === "lineItems") {
                                missingLineItemOption = hasMissingLineItemsOption(options[option]);
                                if (missingLineItemOption) return option + "." + missingLineItemOption;
                            }
                        }
                        else if (paymentType.toLowerCase() === "blik") return hasMissingBlikOptions(options);
                    } else {
                        for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_START_PAYMENT.length; i++){
                            option = constants.REQUIRED_OPTIONS_FOR_START_PAYMENT[i];
                            if (!options.hasOwnProperty(option)) return option;
                        }
                        if (!options.fallback.url) return "fallback.url";
                        if (!options.fallback.buttonText) return "fallback.buttonText";
                        if (options.recurrent === true && !options.customerId) return "customerId";
                    }
                    return false;
                }
                /**
 * Cleanly remove anything set up by {@link module:braintree-web/local-payment.create|create}.
 * @public
 * @param {callback} [callback] Called on completion.
 * @example
 * localPaymentInstance.teardown();
 * @example <caption>With callback</caption>
 * localPaymentInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ LocalPayment.prototype.teardown = function() {
                    var self1 = this; // eslint-disable-line no-invalid-this
                    self1._frameService.teardown();
                    convertMethodsToError(self1, methods(LocalPayment.prototype));
                    analytics.sendEvent(self1._client, "local-payment.teardown-completed");
                    return Promise.resolve();
                };
                module1.exports = wrapPromise.wrapPrototype(LocalPayment);
            },
            {
                "../../lib/analytics": 138,
                "../../lib/braintree-error": 143,
                "../../lib/constants": 145,
                "../../lib/convert-methods-to-error": 146,
                "../../lib/convert-to-braintree-error": 147,
                "../../lib/frame-service/external": 158,
                "../../lib/methods": 175,
                "../../lib/querystring": 177,
                "../../lib/use-min": 180,
                "../shared/errors": 185,
                "./constants": 182,
                "@braintree/extended-promise": 31,
                "@braintree/wrap-promise": 40
            }
        ],
        184: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/local-payment
 * @description A component to integrate with local payment methods. *This component is currently in beta and is subject to change.*
 */ var analytics = _dereq_("../lib/analytics");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var LocalPayment = _dereq_("./external/local-payment");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var errors = _dereq_("./shared/errors");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {string} [options.merchantAccountId] A non-default merchant account ID to use for tokenization and creation of the authorizing transaction. Braintree strongly recommends specifying this parameter.
 * @param {callback} callback The second argument, `data`, is the {@link LocalPayment} instance.
 * @example <caption>Using the local payment component to set up an iDEAL button</caption>
 * var idealButton = document.querySelector('.ideal-button');
 *
 * braintree.client.create({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (clientErr, clientInstance) {
 *   if (clientErr) {
 *     console.error('Error creating client:', clientErr);
 *     return;
 *   }
 *
 *   braintree.localPayment.create({
 *     client: clientInstance,
 *     merchantAccountId: 'merchantAccountEUR',
 *   }, function (localPaymentErr, localPaymentInstance) {
 *     if (localPaymentErr) {
 *       console.error('Error creating local payment component:', localPaymentErr);
 *       return;
 *     }
 *
 *     idealButton.removeAttribute('disabled');
 *
 *     // When the button is clicked, attempt to start the payment flow.
 *     idealButton.addEventListener('click', function (event) {
 *       // Because this opens a popup, this has to be called as a result of
 *       // customer action, like clicking a button. You cannot call this at any time.
 *       localPaymentInstance.startPayment({
 *         paymentType: 'ideal',
 *         amount: '10.67',
 *         city: 'Den Haag',
 *         countryCode: 'NL',
 *         firstName: 'Test',
 *         lastName: 'McTester',
 *         line1: '123 of 456 Fake Lane',
 *         line2: 'Apartment 789',
 *         payerEmail: 'payer@example.com',
 *         phone: '123456789',
 *         postalCode: '1234 AA',
 *         currencyCode: 'EUR',
 *         onPaymentStart: function (data, continueCallback) {
 *           // Do any preprocessing to store the ID and setup webhook
 *           // Call start to initiate the popup
 *           continueCallback();
 *         }
 **       }, function (startPaymentErr, payload) {
 *         if (startPaymentErr) {
 *           if (startPaymentErr.type !== 'CUSTOMER') {
 *             console.error('Error starting payment:', startPaymentErr);
 *           }
 *           return;
 *         }
 *
 *         idealButton.setAttribute('disabled', true);
 *
 *         console.log(payload.paymentId);
 *       });
 *     }, false);
 *   });
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "Local Payment";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        var localPaymentInstance;
                        var config = client.getConfiguration();
                        options.client = client;
                        if (config.gatewayConfiguration.paypalEnabled !== true) return Promise.reject(new BraintreeError(errors.LOCAL_PAYMENT_NOT_ENABLED));
                        analytics.sendEvent(client, "local-payment.initialized");
                        localPaymentInstance = new LocalPayment(options);
                        return localPaymentInstance._initialize();
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/analytics": 138,
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./external/local-payment": 183,
                "./shared/errors": 185,
                "@braintree/wrap-promise": 40
            }
        ],
        185: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.LocalPayment - Creation Error Codes
 * @description Errors that occur when [creating the Local Payment component](./module-braintree-web_local-payment.html#.create).
 * @property {MERCHANT} LOCAL_PAYMENT_NOT_ENABLED Occurs when Local Payment is not enabled on the Braintree control panel.
 */ /**
 * @name BraintreeError.LocalPayment - startPayment Error Codes
 * @description Errors that occur when using the [`startPayment` method](./LocalPayment.html#startPayment).
 * @property {MERCHANT} LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION Occurs when a startPayment is missing a required option.
 * @property {MERCHANT} LOCAL_PAYMENT_ALREADY_IN_PROGRESS Occurs when a startPayment call is already in progress.
 * @property {MERCHANT} LOCAL_PAYMENT_INVALID_PAYMENT_OPTION Occurs when a startPayment call has an invalid option.
 * @property {NETWORK} LOCAL_PAYMENT_START_PAYMENT_FAILED Occurs when a startPayment call fails.
 * @property {NETWORK} LOCAL_PAYMENT_TOKENIZATION_FAILED Occurs when a startPayment call fails to tokenize the result from authorization.
 * @property {CUSTOMER} LOCAL_PAYMENT_CANCELED Occurs when the customer cancels the Local Payment.
 * @property {CUSTOMER} LOCAL_PAYMENT_WINDOW_CLOSED Occurs when the customer closes the Local Payment window.
 * @property {MERCHANT} LOCAL_PAYMENT_WINDOW_OPEN_FAILED Occurs when the Local Payment window fails to open. Usually because `startPayment` was not called as a direct result of a user action.
 */ var BraintreeError = _dereq_("../../lib/braintree-error");
                module1.exports = {
                    LOCAL_PAYMENT_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "LOCAL_PAYMENT_NOT_ENABLED",
                        message: "LocalPayment is not enabled for this merchant."
                    },
                    LOCAL_PAYMENT_ALREADY_IN_PROGRESS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "LOCAL_PAYMENT_ALREADY_IN_PROGRESS",
                        message: "LocalPayment payment is already in progress."
                    },
                    LOCAL_PAYMENT_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "LOCAL_PAYMENT_CANCELED",
                        message: "Customer canceled the LocalPayment before authorizing."
                    },
                    LOCAL_PAYMENT_WINDOW_CLOSED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "LOCAL_PAYMENT_WINDOW_CLOSED",
                        message: "Customer closed LocalPayment window before authorizing."
                    },
                    LOCAL_PAYMENT_WINDOW_OPEN_FAILED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "LOCAL_PAYMENT_WINDOW_OPEN_FAILED",
                        message: "LocalPayment window failed to open; make sure startPayment was called in response to a user action."
                    },
                    LOCAL_PAYMENT_START_PAYMENT_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "LOCAL_PAYMENT_START_PAYMENT_FAILED",
                        message: "LocalPayment startPayment failed."
                    },
                    LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "LOCAL_PAYMENT_START_PAYMENT_MISSING_REQUIRED_OPTION",
                        message: "Missing required option for startPayment."
                    },
                    LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "LOCAL_PAYMENT_START_PAYMENT_DEFERRED_PAYMENT_FAILED",
                        message: "LocalPayment startPayment deferred payment failed."
                    },
                    LOCAL_PAYMENT_TOKENIZATION_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "LOCAL_PAYMENT_TOKENIZATION_FAILED",
                        message: "Could not tokenize user's local payment method."
                    },
                    LOCAL_PAYMENT_INVALID_PAYMENT_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "LOCAL_PAYMENT_INVALID_PAYMENT_OPTION",
                        message: "Local payment options are invalid."
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        186: [
            function(_dereq_, module1, exports) {
                "use strict";
                var frameService = _dereq_("../../lib/frame-service/external");
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var errors = _dereq_("../shared/errors");
                var VERSION = "3.110.0";
                var methods = _dereq_("../../lib/methods");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var analytics = _dereq_("../../lib/analytics");
                var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
                var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
                var constants = _dereq_("../shared/constants");
                var INTEGRATION_TIMEOUT_MS = _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
                /**
 * Masterpass Address object.
 * @typedef {object} Masterpass~Address
 * @property {string} countryCodeAlpha2 The customer's country code.
 * @property {string} extendedAddress The customer's extended address.
 * @property {string} locality The customer's locality.
 * @property {string} postalCode The customer's postal code.
 * @property {string} region The customer's region.
 * @property {string} streetAddress The customer's street address.
 */ /**
 * @typedef {object} Masterpass~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} description The human readable description.
 * @property {string} type The payment method type, always `MasterpassCard`.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {object} contact The customer's contact information.
 * @property {string} contact.firstName The customer's first name.
 * @property {string} contact.lastName The customer's last name.
 * @property {string} contact.phoneNumber The customer's phone number.
 * @property {string} contact.emailAddress The customer's email address.
 * @property {Masterpass~Address} billingAddress The customer's billing address.
 * @property {Masterpass~Address} shippingAddress The customer's shipping address.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */ /**
 * @class
 * @param {object} options see {@link module:braintree-web/masterpass.create|masterpass.create}
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/masterpass.create|braintree.masterpass.create} instead.</strong>
 * @classdesc This class represents an Masterpass component. Instances of this class have methods for launching a new window to process a transaction with Masterpass.
 */ function Masterpass(options) {
                    var configuration = options.client.getConfiguration();
                    this._client = options.client;
                    this._assetsUrl = configuration.gatewayConfiguration.assetsUrl + "/web/" + VERSION;
                    this._isDebug = configuration.isDebug;
                    this._authInProgress = false;
                    if (window.popupBridge && typeof window.popupBridge.getReturnUrlPrefix === "function") this._callbackUrl = window.popupBridge.getReturnUrlPrefix() + "return";
                    else this._callbackUrl = this._assetsUrl + "/html/redirect-frame" + (this._isDebug ? "" : ".min") + ".html";
                }
                Masterpass.prototype._initialize = function() {
                    var self1 = this;
                    return new Promise(function(resolve) {
                        var failureTimeout = setTimeout(function() {
                            analytics.sendEvent(self1._client, "masterpass.load.timed-out");
                        }, INTEGRATION_TIMEOUT_MS);
                        frameService.create({
                            name: constants.LANDING_FRAME_NAME,
                            height: constants.POPUP_HEIGHT,
                            width: constants.POPUP_WIDTH,
                            dispatchFrameUrl: self1._assetsUrl + "/html/dispatch-frame" + (self1._isDebug ? "" : ".min") + ".html",
                            openFrameUrl: self1._assetsUrl + "/html/masterpass-landing-frame" + (self1._isDebug ? "" : ".min") + ".html"
                        }, function(service) {
                            self1._frameService = service;
                            clearTimeout(failureTimeout);
                            analytics.sendEvent(self1._client, "masterpass.load.succeeded");
                            resolve(self1);
                        });
                    });
                };
                /**
 * Launches the Masterpass flow and returns a nonce payload. Only one Masterpass flow should be active at a time. One way to achieve this is to disable your Masterpass button while the flow is open.
 *
 * Braintree will apply these properties in `options.config`. Merchants should not override these values, except for advanced usage.
 *  - `environment`
 *  - `requestToken`
 *  - `callbackUrl`
 *  - `merchantCheckoutId`
 *  - `allowedCardTypes`
 *  - `version`
 *
 * @public
 * @param {object} options All options for initiating the Masterpass payment flow.
 * @param {string} options.currencyCode The currency code to process the payment.
 * @param {string} options.subtotal The amount to authorize for the transaction.
 * @param {object} [options.config] All configuration parameters accepted by Masterpass lightbox, except `function` data type. These options will override the values set by Braintree server. Please see {@link Masterpass Lightbox Parameters|https://developer.mastercard.com/page/masterpass-lightbox-parameters} for more information.
 * @param {object} [options.frameOptions] Used to configure the window that contains the Masterpass login.
 * @param {number} [options.frameOptions.width] Popup width to be used instead of default value (450px).
 * @param {number} [options.frameOptions.height] Popup height to be used instead of default value (660px).
 * @param {number} [options.frameOptions.top] The top position of the popup window to be used instead of default value, that is calculated based on provided height, and parent window size.
 * @param {number} [options.frameOptions.left] The left position to the popup window to be used instead of default value, that is calculated based on provided width, and parent window size.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link Masterpass~tokenizePayload|tokenizePayload}. If no callback is provided, the method will return a Promise that resolves with a {@link Masterpass~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * button.addEventListener('click', function () {
 *   // Disable the button so that we don't attempt to open multiple popups.
 *   button.setAttribute('disabled', 'disabled');
 *
 *   // Because tokenize opens a new window, this must be called
 *   // as a result of a user action, such as a button click.
 *   masterpassInstance.tokenize({
 *     currencyCode: 'USD',
 *     subtotal: '10.00'
 *   }).then(function (payload) {
 *     button.removeAttribute('disabled');
 *     // Submit payload.nonce to your server
 *   }).catch(function (tokenizeError) {
 *     button.removeAttribute('disabled');
 *     // Handle flow errors or premature flow closure
 *
 *     switch (tokenizeErr.code) {
 *       case 'MASTERPASS_POPUP_CLOSED':
 *         console.error('Customer closed Masterpass popup.');
 *         break;
 *       case 'MASTERPASS_ACCOUNT_TOKENIZATION_FAILED':
 *         console.error('Masterpass tokenization failed. See details:', tokenizeErr.details);
 *         break;
 *       case 'MASTERPASS_FLOW_FAILED':
 *         console.error('Unable to initialize Masterpass flow. Are your options correct?', tokenizeErr.details);
 *         break;
 *       default:
 *         console.error('Error!', tokenizeErr);
 *     }
 *   });
 * });
 */ Masterpass.prototype.tokenize = function(options) {
                    var self1 = this;
                    if (!options || hasMissingOption(options)) return Promise.reject(new BraintreeError(errors.MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION));
                    if (self1._authInProgress) return Promise.reject(new BraintreeError(errors.MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS));
                    return new Promise(function(resolve, reject) {
                        self1._navigateFrameToLoadingPage(options)["catch"](reject);
                        // This MUST happen after _navigateFrameToLoadingPage for Metro browsers to work.
                        self1._frameService.open(options.frameOptions, self1._createFrameOpenHandler(resolve, reject));
                    });
                };
                Masterpass.prototype._navigateFrameToLoadingPage = function(options) {
                    var self1 = this;
                    this._authInProgress = true;
                    return this._client.request({
                        method: "post",
                        endpoint: "masterpass/request_token",
                        data: {
                            requestToken: {
                                originUrl: window.location.protocol + "//" + window.location.hostname,
                                subtotal: options.subtotal,
                                currencyCode: options.currencyCode,
                                callbackUrl: this._callbackUrl
                            }
                        }
                    }).then(function(response) {
                        var redirectUrl = self1._assetsUrl + "/html/masterpass-loading-frame" + (self1._isDebug ? "" : ".min") + ".html?";
                        var gatewayConfiguration = self1._client.getConfiguration().gatewayConfiguration;
                        var config = options.config || {};
                        var queryParams;
                        queryParams = {
                            environment: gatewayConfiguration.environment,
                            requestToken: response.requestToken,
                            callbackUrl: self1._callbackUrl,
                            merchantCheckoutId: gatewayConfiguration.masterpass.merchantCheckoutId,
                            allowedCardTypes: gatewayConfiguration.masterpass.supportedNetworks,
                            version: constants.MASTERPASS_VERSION
                        };
                        Object.keys(config).forEach(function(key) {
                            if (typeof config[key] !== "function") queryParams[key] = config[key];
                        });
                        redirectUrl += Object.keys(queryParams).map(function(key) {
                            return key + "=" + queryParams[key];
                        }).join("&");
                        self1._frameService.redirect(redirectUrl);
                    })["catch"](function(err) {
                        var status = err.details && err.details.httpStatus;
                        self1._closeWindow();
                        if (status === 422) return Promise.reject(convertToBraintreeError(err, errors.MASTERPASS_INVALID_PAYMENT_OPTION));
                        return Promise.reject(convertToBraintreeError(err, errors.MASTERPASS_FLOW_FAILED));
                    });
                };
                Masterpass.prototype._createFrameOpenHandler = function(resolve, reject) {
                    var self1 = this;
                    if (window.popupBridge) return function(popupBridgeErr, payload) {
                        self1._authInProgress = false;
                        if (popupBridgeErr) {
                            analytics.sendEvent(self1._client, "masterpass.tokenization.closed-popupbridge.by-user");
                            reject(convertToBraintreeError(popupBridgeErr, errors.MASTERPASS_POPUP_CLOSED));
                            return;
                        } else if (!payload.queryItems) {
                            analytics.sendEvent(self1._client, "masterpass.tokenization.failed-popupbridge");
                            reject(new BraintreeError(errors.MASTERPASS_FLOW_FAILED));
                            return;
                        }
                        self1._tokenizeMasterpass(payload.queryItems).then(resolve)["catch"](reject);
                    };
                    return function(frameServiceErr, payload) {
                        if (frameServiceErr) {
                            self1._authInProgress = false;
                            if (frameServiceErr.code === "FRAME_SERVICE_FRAME_CLOSED") {
                                analytics.sendEvent(self1._client, "masterpass.tokenization.closed.by-user");
                                reject(new BraintreeError(errors.MASTERPASS_POPUP_CLOSED));
                                return;
                            }
                            if (frameServiceErr.code && frameServiceErr.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) {
                                analytics.sendEvent(self1._client, "masterpass.tokenization.failed.to-open");
                                reject(new BraintreeError({
                                    code: errors.MASTERPASS_POPUP_OPEN_FAILED.code,
                                    type: errors.MASTERPASS_POPUP_OPEN_FAILED.type,
                                    message: errors.MASTERPASS_POPUP_OPEN_FAILED.message,
                                    details: {
                                        originalError: frameServiceErr
                                    }
                                }));
                                return;
                            }
                            analytics.sendEvent(self1._client, "masterpass.tokenization.failed");
                            self1._closeWindow();
                            reject(convertToBraintreeError(frameServiceErr, errors.MASTERPASS_FLOW_FAILED));
                            return;
                        }
                        self1._tokenizeMasterpass(payload).then(resolve)["catch"](reject);
                    };
                };
                Masterpass.prototype._tokenizeMasterpass = function(payload) {
                    var self1 = this;
                    if (payload.mpstatus !== "success") {
                        analytics.sendEvent(self1._client, "masterpass.tokenization.closed.by-user");
                        self1._closeWindow();
                        return Promise.reject(new BraintreeError(errors.MASTERPASS_POPUP_CLOSED));
                    }
                    if (isMissingRequiredPayload(payload)) {
                        analytics.sendEvent(self1._client, "masterpass.tokenization.closed.missing-payload");
                        self1._closeWindow();
                        return Promise.reject(new BraintreeError(errors.MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS));
                    }
                    return self1._client.request({
                        endpoint: "payment_methods/masterpass_cards",
                        method: "post",
                        data: {
                            masterpassCard: {
                                checkoutResourceUrl: payload.checkout_resource_url,
                                requestToken: payload.oauth_token,
                                verifierToken: payload.oauth_verifier
                            }
                        }
                    }).then(function(response) {
                        self1._closeWindow();
                        if (window.popupBridge) analytics.sendEvent(self1._client, "masterpass.tokenization.success-popupbridge");
                        else analytics.sendEvent(self1._client, "masterpass.tokenization.success");
                        return response.masterpassCards[0];
                    })["catch"](function(tokenizeErr) {
                        self1._closeWindow();
                        if (window.popupBridge) analytics.sendEvent(self1._client, "masterpass.tokenization.failed-popupbridge");
                        else analytics.sendEvent(self1._client, "masterpass.tokenization.failed");
                        return Promise.reject(convertToBraintreeError(tokenizeErr, errors.MASTERPASS_ACCOUNT_TOKENIZATION_FAILED));
                    });
                };
                function isMissingRequiredPayload(payload) {
                    return [
                        payload.oauth_verifier,
                        payload.oauth_token,
                        payload.checkout_resource_url
                    ].some(function(element) {
                        return element == null || element === "null";
                    });
                }
                Masterpass.prototype._closeWindow = function() {
                    this._authInProgress = false;
                    this._frameService.close();
                };
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/masterpass.create|create}.
 * @public
 * @param {callback} [callback] Called on completion. If no callback is provided, `teardown` returns a promise.
 * @example
 * masterpassInstance.teardown();
 * @example <caption>With callback</caption>
 * masterpassInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ Masterpass.prototype.teardown = function() {
                    var self1 = this;
                    return new Promise(function(resolve) {
                        self1._frameService.teardown();
                        convertMethodsToError(self1, methods(Masterpass.prototype));
                        analytics.sendEvent(self1._client, "masterpass.teardown-completed");
                        resolve();
                    });
                };
                function hasMissingOption(options) {
                    var i, option;
                    for(i = 0; i < constants.REQUIRED_OPTIONS_FOR_TOKENIZE.length; i++){
                        option = constants.REQUIRED_OPTIONS_FOR_TOKENIZE[i];
                        if (!options.hasOwnProperty(option)) return true;
                    }
                    return false;
                }
                module1.exports = wrapPromise.wrapPrototype(Masterpass);
            },
            {
                "../../lib/analytics": 138,
                "../../lib/braintree-error": 143,
                "../../lib/constants": 145,
                "../../lib/convert-methods-to-error": 146,
                "../../lib/convert-to-braintree-error": 147,
                "../../lib/frame-service/external": 158,
                "../../lib/methods": 175,
                "../shared/constants": 189,
                "../shared/errors": 190,
                "@braintree/wrap-promise": 40
            }
        ],
        187: [
            function(_dereq_, module1, exports) {
                "use strict";
                /** @module braintree-web/masterpass
 * @description Processes Masterpass. *This component is currently in beta and is subject to change.*
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var browserDetection = _dereq_("./shared/browser-detection");
                var Masterpass = _dereq_("./external/masterpass");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var VERSION = "3.110.0";
                var errors = _dereq_("./shared/errors");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link Masterpass} instance. If no callback is passed in, the create function returns a promise that resolves the {@link Masterpass} instance.
 * @example
 * braintree.masterpass.create({
 *   client: clientInstance
 * }, function (createErr, masterpassInstance) {
 *   if (createErr) {
 *     if (createErr.code === 'MASTERPASS_BROWSER_NOT_SUPPORTED') {
 *       console.error('This browser is not supported.');
 *     } else {
 *       console.error('Error!', createErr);
 *     }
 *     return;
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "Masterpass";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        if (!isSupported()) return Promise.reject(new BraintreeError(errors.MASTERPASS_BROWSER_NOT_SUPPORTED));
                        return Promise.resolve();
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        var masterpassInstance, configuration;
                        options.client = client;
                        configuration = options.client.getConfiguration().gatewayConfiguration;
                        if (!configuration.masterpass) return Promise.reject(new BraintreeError(errors.MASTERPASS_NOT_ENABLED));
                        masterpassInstance = new Masterpass(options);
                        return masterpassInstance._initialize();
                    });
                }
                /**
 * @static
 * @function isSupported
 * @description Returns true if Masterpass supports this browser.
 * @example
 * if (braintree.masterpass.isSupported()) {
 *   // Add Masterpass button to the page
 * } else {
 *   // Hide Masterpass payment option
 * }
 * @returns {Boolean} Returns true if Masterpass supports this browser.
 */ function isSupported() {
                    return Boolean(window.popupBridge || browserDetection.supportsPopups());
                }
                module1.exports = {
                    create: wrapPromise(create),
                    isSupported: isSupported,
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./external/masterpass": 186,
                "./shared/browser-detection": 188,
                "./shared/errors": 190,
                "@braintree/wrap-promise": 40
            }
        ],
        188: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    supportsPopups: _dereq_("@braintree/browser-detection/supports-popups")
                };
            },
            {
                "@braintree/browser-detection/supports-popups": 29
            }
        ],
        189: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    LANDING_FRAME_NAME: "braintreemasterpasslanding",
                    POPUP_WIDTH: 450,
                    POPUP_HEIGHT: 660,
                    MASTERPASS_VERSION: "v6",
                    REQUIRED_OPTIONS_FOR_TOKENIZE: [
                        "subtotal",
                        "currencyCode"
                    ]
                };
            },
            {}
        ],
        190: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Masterpass - Creation Error Codes
 * @description Errors that occur when [creating the Masterpass component](./module-braintree-web_masterpass#.create).
 * @property {CUSTOMER} MASTERPASS_BROWSER_NOT_SUPPORTED Occurs when browser is not a supported browser for Masterpass.
 * @property {MERCHANT} MASTERPASS_NOT_ENABLED Occurs when Masterpass is not enabled in the Braintree control panel.
 */ /**
 * @name BraintreeError.Masterpass - Tokenize Error Codes
 * @description Errors that occur when [tokenizing](./Masterpass.html#tokenize).
 * @property {MERCHANT} MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION Occurs when tokenize is called without a required option.
 * @property {MERCHANT} MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS Occurs if tokenization flow is initialized while another flow is already in progress.
 * @property {NETWORK} MASTERPASS_ACCOUNT_TOKENIZATION_FAILED Occurs when tokenization of Masterpass details fails.
 * @property {MERCHANT} MASTERPASS_POPUP_OPEN_FAILED Occurs when the popup fails to open.
 * @property {MERCHANT} MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS Occurs when Masterpass is missing required parameters for tokenization.
 * @property {CUSTOMER} MASTERPASS_POPUP_CLOSED Occurs when the popup is closed by the customer.
 * @property {MERCHANT} MASTERPASS_INVALID_PAYMENT_OPTION Occurs when an invalid payment option is used to tokenize Masterpass.
 * @property {NETWORK} MASTERPASS_FLOW_FAILED Occurs when an error is returned from request to tokenize.
 */ var BraintreeError = _dereq_("../../lib/braintree-error");
                module1.exports = {
                    MASTERPASS_BROWSER_NOT_SUPPORTED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "MASTERPASS_BROWSER_NOT_SUPPORTED",
                        message: "Browser is not supported."
                    },
                    MASTERPASS_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "MASTERPASS_NOT_ENABLED",
                        message: "Masterpass is not enabled for this merchant."
                    },
                    MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "MASTERPASS_TOKENIZE_MISSING_REQUIRED_OPTION",
                        message: "Missing required option for tokenize."
                    },
                    MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "MASTERPASS_TOKENIZATION_ALREADY_IN_PROGRESS",
                        message: "Masterpass tokenization is already in progress."
                    },
                    MASTERPASS_ACCOUNT_TOKENIZATION_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "MASTERPASS_ACCOUNT_TOKENIZATION_FAILED",
                        message: "Could not tokenize user's Masterpass account."
                    },
                    MASTERPASS_POPUP_OPEN_FAILED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "MASTERPASS_POPUP_OPEN_FAILED",
                        message: "Masterpass popup failed to open. Make sure to tokenize in response to a user action, such as a click."
                    },
                    MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "MASTERPASS_POPUP_MISSING_REQUIRED_PARAMETERS",
                        message: "Masterpass popup failed to return all required parameters needed to continue tokenization."
                    },
                    MASTERPASS_POPUP_CLOSED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "MASTERPASS_POPUP_CLOSED",
                        message: "Customer closed Masterpass popup before authorizing."
                    },
                    MASTERPASS_INVALID_PAYMENT_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "MASTERPASS_INVALID_PAYMENT_OPTION",
                        message: "Masterpass payment options are invalid."
                    },
                    MASTERPASS_FLOW_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "MASTERPASS_FLOW_FAILED",
                        message: "Could not initialize Masterpass flow."
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        191: [
            function(_dereq_, module1, exports) {
                "use strict";
                var analytics = _dereq_("../../lib/analytics");
                var assign = _dereq_("../../lib/assign").assign;
                var Bus = _dereq_("framebus");
                var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
                var generateGooglePayConfiguration = _dereq_("../../lib/generate-google-pay-configuration");
                var iFramer = _dereq_("@braintree/iframer");
                var uuid = _dereq_("@braintree/uuid");
                var useMin = _dereq_("../../lib/use-min");
                var methods = _dereq_("../../lib/methods");
                var EventEmitter = _dereq_("@braintree/event-emitter");
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var VERSION = "3.110.0";
                var constants = _dereq_("../shared/constants");
                var events = constants.events;
                var errors = constants.errors;
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @typedef {object} PaymentRequestComponent~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional account details.
 * @property {string} details.bin The BIN number of the card..
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {object} details.rawPaymentResponse The raw payment response from the payment request, with sensitive card details removed.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, `CreditCard` or `AndroidPayCard`.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */ /**
 * @typedef {object} PaymentRequestComponent~paymentRequestConfiguration
 * @property {object} configuration.details The payment details. For details on this object, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_payment_details).
 * @property {array} [configuration.supportedPaymentMethods] The supported payment methods. If not passed in, the supported payment methods from the merchant account that generated the authorization for the client will be used. For details on this array, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_supported_payment_methods).
 * @property {object} [configuration.options] Additional payment request options. For details on this object, see [Google's PaymentRequest API documentation](https://developers.google.com/web/fundamentals/discovery-and-monetization/payment-request/deep-dive-into-payment-request#defining_options_optional).
 */ /**
 * @typedef {object} PaymentRequestComponent~shippingEventObject
 * @description The event payload sent from {@link PaymentRequestComponent#on|on}.
 * @property {object} target An object which contains data about the event.
 * @property {function} updateWith A method to call with the updated Payment Request details.
 */ /**
 * @name PaymentRequestComponent#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event. `event` should be {@link PaymentRequestComponent#event:shippingAddressChange|shippingAddressChange} or {@link PaymentRequestComponent#event:shippingOptionChange|shippingOptionChange}. For convenience, you can also listen on `shippingaddresschange` or `shippingoptionchange` to match the event listeners in the [Payment Request API documentation](https://developers.google.com/web/fundamentals/payments/deep-dive-into-payment-request#shipping_in_payment_request_api). Events will emit a {@link PaymentRequestComponent~shippingEventObject|shippingEventObject}.
 * @example
 * <caption>Listening to a Payment Request event, in this case 'shippingAddressChange'</caption>
 * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
 *   paymentRequestInstance.on('shippingAddressChange', function (event) {
 *     console.log(event.target.shippingAddress);
 *   });
 * });
 * @returns {void}
 */ /**
 * @name PaymentRequestComponent#off
 * @function
 * @param {string} event The name of the event to which you are unsubscribing.
 * @param {function} handler The callback for the event you are unsubscribing from.
 * @description Unsubscribes the handler function to a named event.
 * @example
 * <caption>Subscribing and then unsubscribing from a Payment Request event, in this case 'shippingAddressChange'</caption>
 * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
 *   var callback = function (event) {
 *     console.log(event.target.shippingAddress);
 *   };
 *   paymentRequestInstance.on('shippingAddressChange', callback);
 *
 *   // later on
 *   paymentRequestInstance.off('shippingAddressChange', callback);
 * });
 * @returns {void}
 */ /**
 * This event is emitted when the customer selects a shipping address.
 * @event PaymentRequestComponent#shippingAddressChange
 * @type {PaymentRequestComponent~shippingEventObject}
 * @example
 * <caption>Listening to a shipping address change event</caption>
 * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
 *   paymentRequestInstance.on('shippingAddressChange', function (event) {
 *     // validate event.target.shippingAddress if needed
 *
 *     event.updateWith(paymentRequestDetails);
 *   });
 * });
 */ /**
 * This event is emitted when the customer selects a shipping option.
 * @event PaymentRequestComponent#shippingOptionChange
 * @type {PaymentRequestComponent~shippingEventObject}
 * @example
 * <caption>Listening to a shipping option change event</caption>
 * braintree.paymentRequest.create({ ... }, function (createErr, paymentRequestInstance) {
 *   paymentRequestInstance.on('shippingOptionChange', function (event) {
 *     // validate event.target.shippingOption if needed
 *
 *     paymentRequestDetails.shippingOptions.forEach(function (option) {
 *       option.selected = option.id === event.target.shippingOption;
 *     });
 *
 *     event.updateWith(paymentRequestDetails);
 *   });
 * });
 */ var CARD_TYPE_MAPPINGS = {
                    Visa: "visa",
                    MasterCard: "mastercard",
                    "American Express": "amex",
                    "Diners Club": "diners",
                    Discover: "discover",
                    JCB: "jcb",
                    UnionPay: "unionpay",
                    Maestro: "maestro"
                };
                var BRAINTREE_GOOGLE_PAY_MERCHANT_ID = "18278000977346790994";
                function composeUrl(assetsUrl, componentId, isDebug) {
                    var baseUrl = assetsUrl;
                    // endRemoveIf(production)
                    return baseUrl + "/web/" + VERSION + "/html/payment-request-frame" + useMin(isDebug) + ".html#" + componentId;
                }
                /**
 * @class PaymentRequestComponent
 * @param {object} options The Payment Request Component {@link module:braintree-web/payment-request.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/payment-request.create|braintree-web.payment-request.create} instead.</strong>
 *
 * @classdesc This class represents a Payment Request component produced by {@link module:braintree-web/payment-request.create|braintree-web/payment-request.create}. Instances of this class have methods for initializing a Payment Request.
 *
 * **Note:** This component is currently in beta and the API may include breaking changes when upgrading. Please review the [Changelog](https://github.com/braintree/braintree-web/blob/main/CHANGELOG.md) for upgrade steps whenever you upgrade the version of braintree-web.
 */ function PaymentRequestComponent(options) {
                    var enabledPaymentMethods = options.enabledPaymentMethods || {};
                    EventEmitter.call(this);
                    this._componentId = uuid();
                    this._client = options.client;
                    this._enabledPaymentMethods = {
                        basicCard: enabledPaymentMethods.basicCard !== false,
                        googlePay: enabledPaymentMethods.googlePay !== false
                    };
                    this._googlePayVersion = options.googlePayVersion === 2 ? 2 : 1;
                    this._googleMerchantId = BRAINTREE_GOOGLE_PAY_MERCHANT_ID;
                    this._supportedPaymentMethods = this._constructDefaultSupportedPaymentMethods();
                    this._defaultSupportedPaymentMethods = Object.keys(this._supportedPaymentMethods).map((function(key) {
                        return this._supportedPaymentMethods[key];
                    }).bind(this));
                    this._bus = new Bus({
                        channel: this._componentId
                    });
                }
                EventEmitter.createChild(PaymentRequestComponent);
                PaymentRequestComponent.prototype._constructDefaultSupportedPaymentMethods = function() {
                    var configuration = this._client.getConfiguration();
                    var androidPayConfiguration = configuration.gatewayConfiguration.androidPay;
                    var cardConfiguration = configuration.gatewayConfiguration.creditCards;
                    var supportedPaymentMethods = {};
                    if (this._enabledPaymentMethods.basicCard && cardConfiguration && cardConfiguration.supportedCardTypes.length > 0) supportedPaymentMethods.basicCard = {
                        supportedMethods: "basic-card",
                        data: {
                            supportedNetworks: cardConfiguration.supportedCardTypes.reduce(function(types, cardType) {
                                if (cardType in CARD_TYPE_MAPPINGS) types.push(CARD_TYPE_MAPPINGS[cardType]);
                                return types;
                            }, [])
                        }
                    };
                    if (this._enabledPaymentMethods.googlePay && androidPayConfiguration && androidPayConfiguration.enabled) supportedPaymentMethods.googlePay = {
                        supportedMethods: "https://google.com/pay",
                        data: generateGooglePayConfiguration(configuration, this._googlePayVersion, this._googleMerchantId)
                    };
                    return supportedPaymentMethods;
                };
                PaymentRequestComponent.prototype.initialize = function() {
                    var clientConfiguration = this._client.getConfiguration();
                    var self1 = this;
                    this._frame = iFramer({
                        allowPaymentRequest: true,
                        name: "braintree-payment-request-frame",
                        "class": "braintree-payment-request-frame",
                        height: 0,
                        width: 0,
                        style: {
                            position: "absolute",
                            left: "-9999px"
                        },
                        title: "Secure Payment Frame"
                    });
                    if (this._defaultSupportedPaymentMethods.length === 0) return Promise.reject(new BraintreeError(errors.PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS));
                    return new Promise(function(resolve) {
                        self1._bus.on(events.FRAME_READY, function(reply) {
                            reply(self1._client);
                        });
                        self1._bus.on(events.FRAME_CAN_MAKE_REQUESTS, function() {
                            analytics.sendEvent(self1._client, "payment-request.initialized");
                            self1._bus.on(events.SHIPPING_ADDRESS_CHANGE, function(shippingAddress) {
                                var shippingAddressChangeEvent = {
                                    target: {
                                        shippingAddress: shippingAddress
                                    },
                                    updateWith: function updateWith(paymentDetails) {
                                        self1._bus.emit(events.UPDATE_SHIPPING_ADDRESS, paymentDetails);
                                    }
                                };
                                self1._emit("shippingAddressChange", shippingAddressChangeEvent);
                                self1._emit("shippingaddresschange", shippingAddressChangeEvent);
                            });
                            self1._bus.on(events.SHIPPING_OPTION_CHANGE, function(shippingOption) {
                                var shippingOptionChangeEvent = {
                                    target: {
                                        shippingOption: shippingOption
                                    },
                                    updateWith: function updateWith(paymentDetails) {
                                        self1._bus.emit(events.UPDATE_SHIPPING_OPTION, paymentDetails);
                                    }
                                };
                                self1._emit("shippingOptionChange", shippingOptionChangeEvent);
                                self1._emit("shippingoptionchange", shippingOptionChangeEvent);
                            });
                            resolve(self1);
                        });
                        // TODO - We may need to apply the same setTimeout hack that Hosted Fields
                        // uses for iframes to load correctly in Edge. See:
                        // https://github.com/braintree/braintree-web/blob/0c951e5f9859c606652485de14188b6bd6656677/src/hosted-fields/external/hosted-fields.js#L449-L469
                        self1._frame.src = composeUrl(clientConfiguration.gatewayConfiguration.assetsUrl, self1._componentId, clientConfiguration.isDebug);
                        document.body.appendChild(self1._frame);
                    });
                };
                /**
 * Create an object to pass into tokenize to specify a custom configuration. If no overrides are provided, the default configuration will be provided.
 * @public
 * @param {string} type The supported payment method type. Possible values are `basicCard` and `googlePay`.
 * If no type is provided, the function will throw an error. If the type provided is not an enabled payment method for the merchant account , the function will throw an error.
 * @param {object} [overrides] The configuration overrides for the [data property on the supported payment methods objects](https://developers.google.com/web/fundamentals/payments/deep-dive-into-payment-request). If not passed in, the default configuration for the specified type will be provided. If a property is not provided, the value from the default configuration will be used.
 * @example <caption>Getting the default configuration for a specified type</caption>
 * var configuration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard');
 *
 * configuration.supportedMethods; // 'basic-card'
 * configuration.data.supportedNetworks; // ['visa', 'mastercard', 'amex'] <- whatever the supported card networks for the merchant account are
 * @example <caption>Specifying overrides</caption>
 * var configuration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard', {
 *   supportedNetworks: ['visa'],
 *   supportedTypes: ['credit', 'debit']
 * });
 *
 * configuration.supportedMethods; // 'basic-card'
 * configuration.data.supportedNetworks; // ['visa']
 * configuration.data.supportedTypes; // ['credit', 'debit']
 * @returns {object} Returns a configuration object for use in the tokenize function.
 */ PaymentRequestComponent.prototype.createSupportedPaymentMethodsConfiguration = function(type, overrides) {
                    var configuration;
                    if (!type) throw new BraintreeError(errors.PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE);
                    if (!this._enabledPaymentMethods[type]) throw new BraintreeError(errors.PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED);
                    configuration = assign({}, this._supportedPaymentMethods[type]);
                    configuration.data = assign({}, configuration.data, overrides);
                    return configuration;
                };
                /**
 * Tokenizes a Payment Request
 * @public
 * @param {object} configuration A {@link PaymentRequestComponent~paymentRequestConfiguration|paymentRequestConfiguration}.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link PaymentRequest~paymentPayload|paymentPayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link PaymentRequestComponent~tokenizePayload|tokenizePayload}.
 * @example
 * paymentRequestInstance.tokenize({
 *   details: {
 *     total: {
 *       label: 'Price',
 *       amount: {
 *         currency: 'USD',
 *         value: '100.00'
 *       }
 *     }
 *   }
 * }).then(function (payload) {
 *   // send payload.nonce to server
 *
 *   // examine the raw response (with card details removed for security) from the payment request
 *   console.log(payload.details.rawPaymentResponse);
 * }).catch(function (err) {
 *   if (err.code === 'PAYMENT_REQUEST_CANCELED') {
 *     // payment request was canceled by user
 *   } else {
 *     // an error occurred while processing
 *   }
 * });
 * @example <caption>Tokenize only Visa cards</caption>
 * var basicCardConfiguration = paymentRequestInstance.createSupportedPaymentMethodsConfiguration('basicCard', {
 *   supportedNetworks: ['visa']
 * };
 *
 * paymentRequestInstance.tokenize({
 *   supportedPaymentMethods: [basicCardConfiguration],
 *   details: {
 *     total: {
 *       label: 'Price',
 *       amount: {
 *         currency: 'USD',
 *         value: '100.00'
 *       }
 *     }
 *   }
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 * });
 * @example <caption>Include payment request options</caption>
 * paymentRequestInstance.tokenize({
 *   details: {
 *     total: {
 *       label: 'Price',
 *       amount: {
 *         currency: 'USD',
 *         value: '100.00'
 *       }
 *     }
 *   },
 *   options: {
 *     requestPayerName: true,
 *     requestPayerPhone: true,
 *     requestPayerEmail: true
 *   }
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 *   // collect additional info from the raw response
 *   console.log(payload.details.rawPaymentResponse);
 * });
 * @example <caption>Request Shipping Information</caption>
 * var shippingOptions = [
 *   {
 *     id: 'economy',
 *     label: 'Economy Shipping (5-7 Days)',
 *     amount: {
 *       currency: 'USD',
 *       value: '0',
 *     },
 *   }, {
 *     id: 'express',
 *     label: 'Express Shipping (2-3 Days)',
 *     amount: {
 *       currency: 'USD',
 *       value: '5',
 *     },
 *   }, {
 *     id: 'next-day',
 *     label: 'Next Day Delivery',
 *     amount: {
 *       currency: 'USD',
 *       value: '12',
 *     },
 *   },
 * ];
 * var paymentDetails = {
 * 	 total: {
 *     label: 'Total',
 *     amount: {
 *       currency: 'USD',
 *       value: '10.00',
 *     }
 *   },
 *   shippingOptions: shippingOptions
 * };
 *
 * paymentRequestInstance.on('shippingAddressChange', function (event) {
 *   // validate shipping address on event.target.shippingAddress
 *   // make changes to the paymentDetails or shippingOptions if necessary
 *
 *   event.updateWith(paymentDetails)
 * });
 *
 * paymentRequestInstance.on('shippingOptionChange', function (event) {
 *   shippingOptions.forEach(function (option) {
 *     option.selected = option.id === event.target.shippingOption;
 *   });
 *
 *   event.updateWith(paymentDetails)
 * });
 *
 * paymentRequestInstance.tokenize({
 *   details: paymentDetails,
 *   options: {
 *     requestShipping: true
 *   }
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 *   // collect shipping information from payload
 *   console.log(payload.details.rawPaymentResponse.shippingAddress);
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PaymentRequestComponent.prototype.tokenize = function(configuration) {
                    var self1 = this;
                    // NEXT_MAJOR_VERSION fail early if a payment method is passed in
                    // that the component does not support
                    return new Promise(function(resolve, reject) {
                        self1._bus.emit(events.PAYMENT_REQUEST_INITIALIZED, {
                            supportedPaymentMethods: configuration.supportedPaymentMethods || self1._defaultSupportedPaymentMethods,
                            details: configuration.details,
                            options: configuration.options
                        }, function(response) {
                            var rawError = response[0];
                            var payload = response[1];
                            if (rawError) {
                                reject(self1._formatTokenizationError(rawError));
                                return;
                            }
                            analytics.sendEvent(self1._client, "payment-request.tokenize.succeeded");
                            resolve({
                                nonce: payload.nonce,
                                type: payload.type,
                                description: payload.description,
                                details: {
                                    rawPaymentResponse: payload.details.rawPaymentResponse,
                                    cardType: payload.details.cardType,
                                    lastFour: payload.details.lastFour,
                                    lastTwo: payload.details.lastTwo
                                },
                                binData: payload.binData
                            });
                        });
                    });
                };
                /**
 * Check if the customer can make payments.
 * @public
 * @param {object} configuration A {@link PaymentRequestComponent~paymentRequestConfiguration|paymentRequestConfiguration}.
 * @param {callback} [callback] Called on completion.
 * @example
 * var paymentDetails = {
 * 	 total: {
 *     label: 'Total',
 *     amount: {
 *       currency: 'USD',
 *       value: '10.00',
 *     }
 *   }
 * };
 *
 * paymentRequestInstance.canMakePayment({
 *   details: paymentDetails
 * }).then(function (result) {
 *   if (result) {
 *     // set up payment request button
 *   }
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PaymentRequestComponent.prototype.canMakePayment = function(configuration) {
                    var self1 = this;
                    var unsupportedPaymentMethod;
                    // NEXT_MAJOR_VERSION Move this check to component creation
                    if (!window.PaymentRequest) {
                        analytics.sendEvent(self1._client, "payment-request.can-make-payment.not-available");
                        return Promise.resolve(false);
                    }
                    if (configuration.supportedPaymentMethods) {
                        configuration.supportedPaymentMethods.forEach(function(config) {
                            var supportedMethods = config.supportedMethods;
                            if (!(supportedMethods in constants.SUPPORTED_METHODS)) unsupportedPaymentMethod = supportedMethods;
                        });
                        if (unsupportedPaymentMethod) return Promise.reject(new BraintreeError({
                            type: errors.PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD.type,
                            code: errors.PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD.code,
                            message: unsupportedPaymentMethod + " is not a supported payment method."
                        }));
                    }
                    return new Promise(function(resolve, reject) {
                        self1._bus.emit(events.CAN_MAKE_PAYMENT, {
                            supportedPaymentMethods: configuration.supportedPaymentMethods || self1._defaultSupportedPaymentMethods,
                            details: configuration.details,
                            options: configuration.options
                        }, function(response) {
                            var error = response[0];
                            var payload = response[1];
                            if (error) {
                                reject(self1._formatCanMakePaymentError(error));
                                return;
                            }
                            analytics.sendEvent(self1._client, "payment-request.can-make-payment." + payload);
                            resolve(payload);
                        });
                    });
                };
                /**
 * Cleanly remove anything set up by {@link module:braintree-web/payment-request.create|create}.
 * @public
 * @param {callback} [callback] Called on completion.
 * @example
 * paymentRequestInstance.teardown();
 * @example <caption>With callback</caption>
 * paymentRequestInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PaymentRequestComponent.prototype.teardown = function() {
                    this._bus.teardown();
                    this._frame.parentNode.removeChild(this._frame);
                    convertMethodsToError(this, methods(PaymentRequestComponent.prototype));
                    analytics.sendEvent(this._client, "payment-request.teardown-completed");
                    return Promise.resolve();
                };
                PaymentRequestComponent.prototype._formatTokenizationError = function(error) {
                    var formattedError;
                    switch(error.name){
                        case "AbortError":
                            formattedError = new BraintreeError({
                                type: errors.PAYMENT_REQUEST_CANCELED.type,
                                code: errors.PAYMENT_REQUEST_CANCELED.code,
                                message: errors.PAYMENT_REQUEST_CANCELED.message,
                                details: {
                                    originalError: error
                                }
                            });
                            analytics.sendEvent(this._client, "payment-request.tokenize.canceled");
                            return formattedError;
                        case "PAYMENT_REQUEST_INITIALIZATION_FAILED":
                            formattedError = new BraintreeError({
                                type: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.type,
                                code: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.code,
                                message: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.message,
                                details: {
                                    originalError: error
                                }
                            });
                            break;
                        case "BRAINTREE_GATEWAY_GOOGLE_PAYMENT_TOKENIZATION_ERROR":
                            formattedError = new BraintreeError({
                                type: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.type,
                                code: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.code,
                                message: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE.message,
                                details: {
                                    originalError: error
                                }
                            });
                            break;
                        case "BRAINTREE_GATEWAY_GOOGLE_PAYMENT_PARSING_ERROR":
                            formattedError = new BraintreeError({
                                type: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.type,
                                code: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.code,
                                message: errors.PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR.message,
                                details: {
                                    originalError: error
                                }
                            });
                            break;
                        default:
                            formattedError = new BraintreeError({
                                code: errors.PAYMENT_REQUEST_NOT_COMPLETED.code,
                                type: error.type || BraintreeError.types.CUSTOMER,
                                message: errors.PAYMENT_REQUEST_NOT_COMPLETED.message,
                                details: {
                                    originalError: error
                                }
                            });
                    }
                    analytics.sendEvent(this._client, "payment-request.tokenize.failed");
                    return formattedError;
                };
                PaymentRequestComponent.prototype._formatCanMakePaymentError = function(error) {
                    var formattedError;
                    switch(error.name){
                        case "PAYMENT_REQUEST_INITIALIZATION_FAILED":
                            formattedError = new BraintreeError({
                                type: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.type,
                                code: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.code,
                                message: errors.PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED.message,
                                details: {
                                    originalError: error
                                }
                            });
                            break;
                        case "NotAllowedError":
                            formattedError = new BraintreeError({
                                type: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.type,
                                code: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.code,
                                message: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED.message,
                                details: {
                                    originalError: error
                                }
                            });
                            break;
                        default:
                            formattedError = new BraintreeError({
                                code: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.code,
                                type: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.type,
                                message: errors.PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED.message,
                                details: {
                                    originalError: error
                                }
                            });
                    }
                    analytics.sendEvent(this._client, "payment-request.can-make-payment.failed");
                    return formattedError;
                };
                module1.exports = wrapPromise.wrapPrototype(PaymentRequestComponent);
            },
            {
                "../../lib/analytics": 138,
                "../../lib/assign": 140,
                "../../lib/braintree-error": 143,
                "../../lib/convert-methods-to-error": 146,
                "../../lib/generate-google-pay-configuration": 168,
                "../../lib/methods": 175,
                "../../lib/use-min": 180,
                "../shared/constants": 193,
                "@braintree/event-emitter": 30,
                "@braintree/iframer": 32,
                "@braintree/uuid": 36,
                "@braintree/wrap-promise": 40,
                framebus: 50
            }
        ],
        192: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/payment-request
 * @description A component to integrate with the Payment Request API.
 *
 * **Note:** This component is currently in beta and the API may include breaking changes when upgrading. Please review the [Changelog](https://github.com/braintree/braintree-web/blob/main/CHANGELOG.md) for upgrade steps whenever you upgrade the version of braintree-web.
 * */ var PaymentRequestComponent = _dereq_("./external/payment-request");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var VERSION = "3.110.0";
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {object} [options.enabledPaymentMethods] An object representing which payment methods to display.
 * @param {boolean} [options.enabledPaymentMethods.basicCard=true] Whether or not to display credit card as an option in the Payment Request dialog. If left blank or set to true, credit cards will be displayed in the dialog if the merchant account is set up to process credit cards.
 * @param {boolean} [options.enabledPaymentMethods.googlePay=true] Whether or not to display Google Pay as an option in the Payment Request dialog. If left blank or set to true, Google Pay will be displayed in the dialog if the merchant account is set up to process Google Pay.
 * @param {Number} [options.googlePayVersion=1] Ignored if `options.enabledPaymentMethods.googlePay = false`. If `true`, this option specifies the version of Google Pay to use. Choose either 1 (default) or 2.
 * @param {callback} [callback] The second argument, `data`, is the {@link PaymentRequestComponent} instance. If no callback is provided, `create` returns a promise that resolves with the {@link PaymentRequestComponent} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * if (window.PaymentRequest) {
 *   braintree.paymentRequest.create({
 *     client: clientInstance
 *   }, cb);
 * } else {
 *   // fall back to Hosted Fields if browser does not support Payment Request API
 *   braintree.hostedFields.create(hostedFieldsOptions, cb);
 * }
 * @example <caption>Explicitly turning off credit cards from Payment Request API dialog</caption>
 * braintree.paymentRequest.create({
 *   client: clientInstance,
 *   enabledPaymentMethods: {
 *     googlePay: true,
 *     basicCard: false
 *   }
 * }, cb);
 * @example <caption>Using Google Pay v2 or basic card</caption>
 * braintree.paymentRequest.create({
 *   client: clientInstance,
 *   enabledPaymentMethods: {
 *     basicCard: true,
 *     googlePay: true
 *   },
 *   googlePayVersion: 2
 * }, cb);
 *
 */ function create(options) {
                    var name = "Payment Request";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        var paymentRequestInstance;
                        options.client = client;
                        paymentRequestInstance = new PaymentRequestComponent(options);
                        return paymentRequestInstance.initialize();
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./external/payment-request": 191,
                "@braintree/wrap-promise": 40
            }
        ],
        193: [
            function(_dereq_, module1, exports) {
                "use strict";
                var enumerate = _dereq_("../../lib/enumerate");
                var errors = _dereq_("./errors");
                var constants = {};
                constants.events = enumerate([
                    "CAN_MAKE_PAYMENT",
                    "FRAME_READY",
                    "FRAME_CAN_MAKE_REQUESTS",
                    "PAYMENT_REQUEST_INITIALIZED",
                    "SHIPPING_ADDRESS_CHANGE",
                    "UPDATE_SHIPPING_ADDRESS",
                    "SHIPPING_OPTION_CHANGE",
                    "UPDATE_SHIPPING_OPTION"
                ], "payment-request:");
                constants.errors = errors;
                constants.SUPPORTED_METHODS = {
                    "basic-card": true,
                    "https://google.com/pay": true
                };
                module1.exports = constants;
            },
            {
                "../../lib/enumerate": 153,
                "./errors": 194
            }
        ],
        194: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Payment Request - Creation Error Codes
 * @description Errors that occur when [creating the Payment Request component](./module-braintree-web_payment-request.html#.create).
 * @property {MERCHANT} PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS Occurs when there are no valid payment methods configured.
 */ /**
 * @name BraintreeError.Payment Request - createSupportedPaymentMethodsConfiguration  Error Codes
 * @description Errors that occur when using the [`createSupportedPaymentMethodsConfiguration` method](./PaymentRequestComponent.html#createSupportedPaymentMethodsConfiguration)
 * @property {MERCHANT} PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE Occurs when no type is supplied for method.
 * @property {MERCHANT} PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED Occurs when configured type is not enabled.
 */ /**
 * @name BraintreeError.Payment Request - tokenize  Error Codes
 * @description Errors that occur when using the [`tokenize` method](./PaymentRequestComponent.html#tokenize)
 * @property {CUSTOMER} PAYMENT_REQUEST_CANCELED Occurs when customer cancels the Payment Request.
 * @property {MERCHANT} PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED Occurs when the Payment Request is closed do to the options being misconfigured.
 * @property {MERCHANT} PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE Occurs when a Google Payment payment method is unable to be tokenized.
 * @property {UNKNOWN} PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR Occurs when the result of tokenizing a Google Payment payment method could not be parsed.
 * @property {CUSTOMER} PAYMENT_REQUEST_NOT_COMPLETED Occurs when an error prevented the Payment Request from being completed.
 */ /**
 * @name BraintreeError.Payment Request - canMakePayment  Error Codes
 * @description Errors that occur when using the [`canMakePayment` method](./PaymentRequestComponent.html#canMakePayment)
 * @property {MERCHANT} PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED Occurs when the Payment Request is instantiated with misconfigured options.
 * @property {MERCHANT} PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED Occurs when `canMakePayment` results in a `DomException` with a `NotAllowedError`. This usually occurs when `canMakePayment` is called multiple times with different supported payment options.
 * @property {MERCHANT} PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD Occurs when `canMakePayment` is called with a `supportedPaymentMethods` array that contains a payment method that is not supported by the Braintree SDK.
 * @property {UNKNOWN} PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED Occurs when `canMakePayment` fails for any reason other than a misconfigured Payment Request object.
 */ var BraintreeError = _dereq_("../../lib/braintree-error");
                module1.exports = {
                    PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYMENT_REQUEST_NO_VALID_SUPPORTED_PAYMENT_METHODS",
                        message: "There are no supported payment methods associated with this account."
                    },
                    PAYMENT_REQUEST_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "PAYMENT_REQUEST_CANCELED",
                        message: "Payment request was canceled."
                    },
                    PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYMENT_REQUEST_INITIALIZATION_MISCONFIGURED",
                        message: "Something went wrong when configuring the payment request."
                    },
                    PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "PAYMENT_REQUEST_CAN_MAKE_PAYMENT_FAILED",
                        message: "Something went wrong when calling `canMakePayment`"
                    },
                    PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYMENT_REQUEST_CAN_MAKE_PAYMENT_NOT_ALLOWED",
                        message: "Something went wrong when calling `canMakePayment`. Most likely, `canMakePayment` was called multiple times with different supportedMethods configurations."
                    },
                    PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYMENT_REQUEST_UNSUPPORTED_PAYMENT_METHOD"
                    },
                    PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYMENT_REQUEST_GOOGLE_PAYMENT_FAILED_TO_TOKENIZE",
                        message: "Something went wrong when tokenizing the Google Pay card."
                    },
                    PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "PAYMENT_REQUEST_GOOGLE_PAYMENT_PARSING_ERROR",
                        message: "Something went wrong when tokenizing the Google Pay card."
                    },
                    PAYMENT_REQUEST_NOT_COMPLETED: {
                        code: "PAYMENT_REQUEST_NOT_COMPLETED",
                        message: "Payment request could not be completed."
                    },
                    PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_MUST_INCLUDE_TYPE",
                        message: "createSupportedPaymentMethodsConfiguration must include a type parameter."
                    },
                    PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYMENT_REQUEST_CREATE_SUPPORTED_PAYMENT_METHODS_CONFIGURATION_TYPE_NOT_ENABLED",
                        message: "createSupportedPaymentMethodsConfiguration type parameter must be valid or enabled."
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        195: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.PayPal Checkout - Creation Error Codes
 * @description Errors that occur when [creating the PayPal Checkout component](./module-braintree-web_paypal-checkout.html#.create).
 * @property {MERCHANT} PAYPAL_NOT_ENABLED Occurs when PayPal is not enabled on the Braintree control panel.
 * @property {MERCHANT} PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED Occurs only when testing in Sandbox, when a PayPal sandbox account is not linked to the merchant account in the Braintree control panel.
 */ /**
 * @name BraintreeError.PayPal Checkout - createPayment Error Codes
 * @description Errors that occur when using the [`createPayment` method](./PayPalCheckout.html#createPayment).
 * @property {MERCHANT} PAYPAL_FLOW_OPTION_REQUIRED Occurs when a required option is missing.
 * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an option contains an invalid value.
 * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when something goes wrong when initializing the flow.
 */ /**
 * @name BraintreeError.PayPal Checkout - startVaultInitiatedCheckout Error Codes
 * @description Errors that occur when using the [`startVaultInitiatedCheckout` method](./PayPalCheckout.html#startVaultInitiatedCheckout).
 * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED Occurs when a required param is missing when calling the method.
 * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED Occurs when PayPal window could not be opened. This often occurs because the call to start the vault initiated flow was not triggered from a click event.
 * @property {CUSTOMER} PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED Occurs when a customer closes the PayPal flow before completion.
 * @property {MERCHANT} PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS Occurs when the flow is initialized while an authorization is already in progress.
 * @property {NETWORK} PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED Occurs when something went wrong setting up the flow.
 */ /**
 * @name BraintreeError.PayPal Checkout - tokenizePayment Error Codes
 * @description Errors that occur when using the [`tokenizePayment` method](./PayPalCheckout.html#tokenizePayment).
 * @property {NETWORK} PAYPAL_ACCOUNT_TOKENIZATION_FAILED Occurs when PayPal account could not be tokenized.
 */ /**
 * @name BraintreeError.Paypal Checkout - updatePayment Error Codes
 * @description Errors that occur when using the [`updatePayment` method](./PayPalCheckout.html#updatePayment).
 * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an option contains an invalid value.
 * @property {MERCHANT} PAYPAL_MISSING_REQUIRED_OPTION Occurs when a required option is missing.
 * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when something goes wrong when initializing the flow or communicating with the server.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    PAYPAL_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_NOT_ENABLED",
                        message: "PayPal is not enabled for this merchant."
                    },
                    PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED",
                        message: "A linked PayPal Sandbox account is required to use PayPal Checkout in Sandbox. See https://developer.paypal.com/braintree/docs/guides/paypal/testing-go-live#linked-paypal-testing for details on linking your PayPal sandbox with Braintree."
                    },
                    PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "PAYPAL_ACCOUNT_TOKENIZATION_FAILED",
                        message: "Could not tokenize user's PayPal account."
                    },
                    PAYPAL_FLOW_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "PAYPAL_FLOW_FAILED",
                        message: "Could not initialize PayPal flow."
                    },
                    PAYPAL_FLOW_OPTION_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_FLOW_OPTION_REQUIRED",
                        message: "PayPal flow property is invalid or missing."
                    },
                    PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED"
                    },
                    PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED",
                        message: "Something went wrong when setting up the checkout workflow."
                    },
                    PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED",
                        message: "PayPal popup failed to open, make sure to initiate the vault checkout in response to a user action."
                    },
                    PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED",
                        message: "Customer closed PayPal popup before authorizing."
                    },
                    PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS",
                        message: "Vault initiated checkout already in progress."
                    },
                    PAYPAL_INVALID_PAYMENT_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_INVALID_PAYMENT_OPTION",
                        message: "PayPal payment options are invalid."
                    },
                    PAYPAL_MISSING_REQUIRED_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_MISSING_REQUIRED_OPTION",
                        message: "Missing required option."
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        196: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/paypal-checkout
 * @description A component to integrate with the [PayPal JS SDK](https://github.com/paypal/paypal-checkout-components).
 */ var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var PayPalCheckout = _dereq_("./paypal-checkout");
                var VERSION = "3.110.0";
                /**
 * @static
 * @function create
 * @description There are two ways to integrate the PayPal Checkout component. See the [PayPal Checkout constructor documentation](PayPalCheckout.html#PayPalCheckout) for more information and examples.
 *
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {string} [options.merchantAccountId] A non-default merchant account ID to use for tokenization.
 * @param {boolean} [options.autoSetDataUserIdToken=false] Whether or not to render the PayPal SDK button with a customer's vaulted PayPal account. Must be used in conjunction with a Client Token generated with a customer id.
 * @param {callback} [callback] The second argument, `data`, is the {@link PayPalCheckout} instance.
 * @example
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   // set up the PayPal JS SDK
 * }).catch(function (err) {
 *   console.error('Error!', err);
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "PayPal Checkout";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        var instance = new PayPalCheckout(options);
                        return instance._initialize(options);
                    });
                }
                /**
 * @static
 * @function isSupported
 * @description Returns true if PayPal Checkout [supports this browser](index.html#browser-support-webviews).
 * @deprecated Previously, this method checked for Popup support in the browser. The PayPal JS SDK now falls back to a modal if popups are not supported.
 * @returns {Boolean} Returns true if PayPal Checkout supports this browser.
 */ function isSupported() {
                    return true;
                }
                module1.exports = {
                    create: wrapPromise(create),
                    isSupported: isSupported,
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "./paypal-checkout": 197,
                "@braintree/wrap-promise": 40
            }
        ],
        197: [
            function(_dereq_, module1, exports) {
                "use strict";
                var analytics = _dereq_("../lib/analytics");
                var assign = _dereq_("../lib/assign").assign;
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var ExtendedPromise = _dereq_("@braintree/extended-promise");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var convertToBraintreeError = _dereq_("../lib/convert-to-braintree-error");
                var errors = _dereq_("./errors");
                var constants = _dereq_("../paypal/shared/constants");
                var frameService = _dereq_("../lib/frame-service/external");
                var createAuthorizationData = _dereq_("../lib/create-authorization-data");
                var methods = _dereq_("../lib/methods");
                var useMin = _dereq_("../lib/use-min");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var querystring = _dereq_("../lib/querystring");
                var camelCaseToSnakeCase = _dereq_("../lib/camel-case-to-snake-case");
                var VERSION = "3.110.0";
                var INTEGRATION_TIMEOUT_MS = _dereq_("../lib/constants").INTEGRATION_TIMEOUT_MS;
                var REQUIRED_PARAMS_FOR_START_VAULT_INITIATED_CHECKOUT = [
                    "amount",
                    "currency",
                    "vaultInitiatedCheckoutPaymentMethodToken"
                ];
                var PAYPAL_SDK_PRELOAD_URL = "https://www.{ENV}paypal.com/smart/buttons/preload";
                ExtendedPromise.suppressUnhandledPromiseMessage = true;
                /**
 * PayPal Checkout tokenized payload. Returned in {@link PayPalCheckout#tokenizePayment}'s callback as the second argument, `data`.
 * @typedef {object} PayPalCheckout~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `PayPalAccount`.
 * @property {object} details Additional PayPal account details.
 * @property {string} details.email User's email address.
 * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
 * @property {string} details.firstName User's given name.
 * @property {string} details.lastName User's surname.
 * @property {?string} details.countryCode User's 2 character country code.
 * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
 * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
 * @property {string} details.shippingAddress.recipientName Recipient of postage.
 * @property {string} details.shippingAddress.line1 Street number and name.
 * @property {string} details.shippingAddress.line2 Extended address.
 * @property {string} details.shippingAddress.city City or locality.
 * @property {string} details.shippingAddress.state State or region.
 * @property {string} details.shippingAddress.postalCode Postal code.
 * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} details.billingAddress User's billing address details.
 * Not available to all merchants; [contact support](https://developer.paypal.com/braintree/help) for details on eligibility and enabling this feature.
 * Alternatively, see `shippingAddress` above as an available client option.
 * @property {string} details.billingAddress.line1 Street number and name.
 * @property {string} details.billingAddress.line2 Extended address.
 * @property {string} details.billingAddress.city City or locality.
 * @property {string} details.billingAddress.state State or region.
 * @property {string} details.billingAddress.postalCode Postal code.
 * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
 * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {number} creditFinancingOffered.term Length of financing terms in months.
 * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
 * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
 * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
 */ /**
 * @class
 * @param {object} options see {@link module:braintree-web/paypal-checkout.create|paypal-checkout.create}
 * @classdesc This class represents a PayPal Checkout component that coordinates with the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. Instances of this class can generate payment data and tokenize authorized payments.
 *
 * All UI (such as preventing actions on the parent page while authentication is in progress) is managed by the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. You must provide your PayPal `client-id` as a query parameter. You can [retrieve this value from the PayPal Dashboard](https://developer.paypal.com/docs/checkout/integrate/#1-get-paypal-rest-api-credentials).
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal-checkout.create|braintree-web.paypal-checkout.create} instead.</strong>
 *
 * #### Integrate Checkout Flow with PayPal SDK
 *
 * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
 *
 * ```html
 * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id"></script>
 * <div id="paypal-button"></div>
 * ```
 *
 * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Buttons({
 *     createOrder: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'checkout',
 *         currency: 'USD',
 *         amount: '10.00',
 *         intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
 *         // your other createPayment options here
 *       });
 *     },
 *
 *     onApprove: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     },
 *
 *     onCancel: function () {
 *       // handle case where user cancels
 *     },
 *
 *     onError: function (err) {
 *       // handle case where error occurs
 *     }
 *   }).render('#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 *
 * #### Integrate Vault Flow with PayPal SDK
 *
 * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
 *
 * ```html
 * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id&vault=true"></script>
 * <div id="paypal-button"></div>
 * ```
 *
 * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Buttons({
 *     createBillingAgreement: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'vault'
 *         // your other createPayment options here
 *       });
 *     },
 *
 *     onApprove: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     },
 *
 *     onCancel: function () {
 *       // handle case where user cancels
 *     },
 *
 *     onError: function (err) {
 *       // handle case where error occurs
 *     }
 *   }).render('#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 *
 * #### Integrate with Checkout.js (deprecated PayPal SDK)
 *
 * If you are creating a new PayPal integration, please follow the previous integration guide to use the current version of the PayPal SDK. Use this integration guide only as a reference if you are already integrated with Checkout.js.
 *
 * You must have PayPal's Checkout.js script loaded on your page.
 *
 * ```html
 * <script src="https://www.paypalobjects.com/api/checkout.js" data-version-4 log-level="warn"></script>
 * ```
 *
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Button.render({
 *     env: 'production', // or 'sandbox'
 *
 *     payment: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         // your createPayment options here
 *       });
 *     },
 *
 *     onAuthorize: function (data, actions) {
 *       // some logic here before tokenization happens below
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     }
 *   }, '#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 * ```
 */ function PayPalCheckout(options) {
                    this._merchantAccountId = options.merchantAccountId;
                    // TODO remove this requirement for it to be opt in.
                    // This feature is not yet GA, so we're intentionally making
                    // it opt in and not publicly documenting it yet. Once it's
                    // GA, we can remove the requirement to opt in to it
                    this._autoSetDataUserIdToken = Boolean(options.autoSetDataUserIdToken);
                }
                PayPalCheckout.prototype._initialize = function(options) {
                    var config;
                    if (options.client) {
                        config = options.client.getConfiguration();
                        this._authorizationInformation = {
                            fingerprint: config.authorizationFingerprint,
                            environment: config.gatewayConfiguration.environment
                        };
                    } else {
                        config = createAuthorizationData(options.authorization);
                        this._authorizationInformation = {
                            fingerprint: config.attrs.authorizationFingerprint,
                            environment: config.environment
                        };
                    }
                    this._clientPromise = createDeferredClient.create({
                        authorization: options.authorization,
                        client: options.client,
                        debug: options.debug,
                        assetsUrl: createAssetsUrl.create(options.authorization),
                        name: "PayPal Checkout"
                    }).then((function(client) {
                        this._configuration = client.getConfiguration();
                        // we skip these checks if a merchant account id is
                        // passed in, because the default merchant account
                        // may not have paypal enabled
                        if (!this._merchantAccountId) {
                            if (!this._configuration.gatewayConfiguration.paypalEnabled) this._setupError = new BraintreeError(errors.PAYPAL_NOT_ENABLED);
                            else if (this._configuration.gatewayConfiguration.paypal.environmentNoNetwork === true) this._setupError = new BraintreeError(errors.PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED);
                        }
                        if (this._setupError) return Promise.reject(this._setupError);
                        analytics.sendEvent(client, "paypal-checkout.initialized");
                        this._frameServicePromise = this._setupFrameService(client);
                        return client;
                    }).bind(this));
                    // if client was passed in, let config checks happen before
                    // resolving the instance. Otherwise, just resolve the instance
                    if (options.client) return this._clientPromise.then((function() {
                        return this;
                    }).bind(this));
                    return Promise.resolve(this);
                };
                PayPalCheckout.prototype._setupFrameService = function(client) {
                    var frameServicePromise = new ExtendedPromise();
                    var config = client.getConfiguration();
                    var timeoutRef = setTimeout(function() {
                        analytics.sendEvent(client, "paypal-checkout.frame-service.timed-out");
                        frameServicePromise.reject(new BraintreeError(errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_SETUP_FAILED));
                    }, INTEGRATION_TIMEOUT_MS);
                    this._assetsUrl = config.gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION;
                    this._isDebug = config.isDebug;
                    // Note: this is using the static landing frame that the deprecated PayPal component builds and uses
                    this._loadingFrameUrl = this._assetsUrl + "/html/paypal-landing-frame" + useMin(this._isDebug) + ".html";
                    frameService.create({
                        name: "braintreepaypallanding",
                        dispatchFrameUrl: this._assetsUrl + "/html/dispatch-frame" + useMin(this._isDebug) + ".html",
                        openFrameUrl: this._loadingFrameUrl
                    }, (function(service) {
                        this._frameService = service;
                        clearTimeout(timeoutRef);
                        frameServicePromise.resolve();
                    }).bind(this));
                    return frameServicePromise;
                };
                /**
 * @typedef {object} PayPalCheckout~lineItem
 * @property {string} quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
 * @property {string} unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {string} name Item name. Maximum 127 characters.
 * @property {string} kind Indicates whether the line item is a debit (sale) or credit (refund) to the customer. Accepted values: `debit` and `credit`.
 * @property {?string} unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {?string} description Item description. Maximum 127 characters.
 * @property {?string} productCode Product or UPC code for the item. Maximum 127 characters.
 * @property {?string} url The URL to product information.
 */ /**
 * @typedef {object} PayPalCheckout~shippingOption
 * @property {string} id A unique ID that identifies a payer-selected shipping option.
 * @property {string} label A description that the payer sees, which helps them choose an appropriate shipping option. For example, `Free Shipping`, `USPS Priority Shipping`, `Expédition prioritaire USPS`, or `USPS yōuxiān fā huò`. Localize this description to the payer's locale.
 * @property {boolean} selected If `selected = true` is specified as part of the API request it represents the shipping option that the payee/merchant expects to be pre-selected for the payer when they first view the shipping options within the PayPal checkout experience. As part of the response if a shipping option has `selected = true` it represents the shipping option that the payer selected during the course of checkout with PayPal. Only 1 `shippingOption` can be set to `selected = true`.
 * @property {string} type The method by which the payer wants to get their items. The possible values are:
 * * `SHIPPING` - The payer intends to receive the items at a specified address.
 * * `PICKUP` - The payer intends to pick up the items at a specified address. For example, a store address.
 * @property {object} amount The shipping cost for the selected option.
 * @property {string} amount.currency The three-character ISO-4217 currency code. PayPal does not support all currencies.
 * @property {string} amount.value The amount the shipping option will cost. Includes the specified number of digits after decimal separator for the ISO-4217 currency code.
 */ /** @typedef {object} PayPalCheckout~pricingScheme
 * @property {string} pricingModel The pricing model. Options are `FIXED`, `VARIABLE`, or `AUTO_RELOAD`.
 * @property {string} price The price for the billing cycle.
 * @property {string} reloadThresholdAmount The amount at which to reload on auto_reload plans.
 */ /**
 * @typedef {Object} PayPalCheckout~billingCycles
 * @property {(string|number)} billingFrequency The frequency of billing.
 * @property {string} billingFrequencyUnit The unit of billing frequency. Options are `DAY`, `WEEK`, `MONTH`, or `YEAR`.
 * @property {(string|number)} numberOfExecutions The number of executions for the billing cycle.
 * @property {(string|number)} sequence The order in the upcoming billing cycles.
 * @property {string} startDate The start date in ISO 8601 format (`2024-04-06T00:00:00Z`). If populated and the intent is to charge the buyer for the billing cycle at the checkout, it should be populated as current time in ISO 8601 format.
 * @property {boolean} trial Indicates if the billing cycle is a trial.
 * @property {pricingScheme} pricingScheme The {@link PayPalCheckout~pricingScheme|pricing scheme object} for this billing cycle.
 */ /**
 * @typedef {Object} PayPalCheckout~planMetadata
 * @property {billingCycles[]} [billingCycles] An array of {@link PayPalCheckout~billingCycles|billing cyles} for this plan.
 * @property {string} currencyIsoCode The ISO code for the currency, for example `USD`.
 * @property {string} name The name of the plan.
 * @property {string} productDescription A description of the product. (Accepts only one element)
 * @property {(string|number)} productQuantity The quantity of the product. (Accepts only one element)
 * @property {(string|number)} oneTimeFeeAmount The one-time fee amount.
 * @property {(string|number)} shippingAmount The amount for shipping.
 * @property {(string|number)} productPrice The price of the product.
 * @property {(string|number)} taxAmount The amount of tax.
 */ /**
 * Creates a PayPal payment ID or billing token using the given options. This is meant to be passed to the PayPal JS SDK.
 * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the PayPal JS SDK. Otherwise, it returns a Promise that resolves with the id.
 * @public
 * @param {object} options All options for the PayPalCheckout component.
 * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer ID, the PayPal account will be added to that customer as a saved payment method.
 * @param {string} [options.intent=authorize]
 * * `authorize` - Submits the transaction for authorization but not settlement.
 * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
 * * `capture` - Payment will be immediately submitted for settlement upon creating a transaction. `sale` can be used as an alias for this value.
 * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
 * @param {(string|number)} [options.amount] The amount of the transaction. Required when using the Checkout flow. Should not include shipping cost.
 * * Supports up to 2 digits after the decimal point
 * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
 * @param {boolean} [options.requestBillingAgreement] If `true` and `flow = checkout`, the customer will be prompted to consent to a billing agreement during the checkout flow. This value is ignored when `flow = vault`.
 * @param {object} [options.billingAgreementDetails] When `requestBillingAgreement = true`, allows for details to be set for the billing agreement portion of the flow.
 * @param {string} [options.billingAgreementDetails.description] Description of the billing agreement to display to the customer.
 * @param {string} [options.vaultInitiatedCheckoutPaymentMethodToken] Use the payment method nonce representing a PayPal account with a Billing Agreement ID to create the payment and redirect the customer to select a new financial instrument. This option is only applicable to the `checkout` flow.
 * @param {shippingOption[]} [options.shippingOptions] List of shipping options offered by the payee or merchant to the payer to ship or pick up their items.
 * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
 * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
 * @param {string} options.shippingAddressOverride.line1 Street address.
 * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
 * @param {string} options.shippingAddressOverride.city City.
 * @param {string} options.shippingAddressOverride.state State.
 * @param {string} options.shippingAddressOverride.postalCode Postal code.
 * @param {string} options.shippingAddressOverride.countryCode Country.
 * @param {string} [options.shippingAddressOverride.phone] Phone number.
 * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
 * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
 * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
 * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
 * * `login` - A PayPal account login page is used.
 * * `billing` - A non-PayPal account landing page is used.
 * @param {lineItem[]} [options.lineItems] The {@link PayPalCheckout~lineItem|line items} for this transaction. It can include up to 249 line items.
 *
 * @param {string} [options.planType] Determines the charge pattern for the Recurring Billing Agreement. Can be 'RECURRING', 'SUBSCRIPTION', 'UNSCHEDULED', or 'INSTALLMENTS'.
 * @param {planMetadata} [options.planMetadata] When plan type is defined, allows for {@link PayPalCheckout~planMetadata|plan metadata} to be set for the Billing Agreement.
 * @param {string} [options.userAuthenticationEmail] Optional merchant-provided buyer email, used to streamline the sign-in process for both one-time checkout and vault flows.
 * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
 * @example
 * // this paypal object is created by the PayPal JS SDK
 * // see https://github.com/paypal/paypal-checkout-components
 * paypal.Buttons({
 *   createOrder: function () {
 *     // when createPayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.createPayment({
 *       flow: 'checkout',
 *       amount: '10.00',
 *       currency: 'USD',
 *       intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
 *     });
 *   },
 *   // Add other options, e.g. onApproved, onCancel, onError
 * }).render('#paypal-button');
 *
 * @example
 * // shippingOptions are passed to createPayment. You can review the result from onAuthorize to determine which shipping option id was selected.
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Button.render({
 *     env: 'production'
 *
 *     payment: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'checkout',
 *         amount: '10.00',
 *         currency: 'USD',
 *         shippingOptions: [
 *           {
 *             id: 'UUID-9',
 *             type: 'PICKUP',
 *             label: 'Store Location Five',
 *             selected: true,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-fast',
 *             type: 'SHIPPING',
 *             label: 'Fast Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-slow',
 *             type: 'SHIPPING',
 *             label: 'Slow Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           }
 *         ]
 *       });
 *     },
 *
 *     onAuthorize: function (data, actions) {
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     }
 *   }, '#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 *
 * ```
 *
 * @example <caption>use the new plan features</caption>
 * // Plan and plan metadata are passed to createPayment
 * ```javascript
 * braintree.client.create({
 *   authorization: 'authorization'
 * }).then(function (clientInstance) {
 *   return braintree.paypalCheckout.create({
 *     client: clientInstance
 *   });
 * }).then(function (paypalCheckoutInstance) {
 *   return paypal.Button.render({
 *     env: 'production'
 *
 *     payment: function () {
 *       return paypalCheckoutInstance.createPayment({
 *         flow: 'vault',
 *         planType: 'RECURRING',
 *         planMetadata: {
 *           billingCycles: [
 *             {
 *                billingFrequency: "1",
 *                billingFrequencyUnit: "MONTH",
 *                numberOfExecutions: "1",
 *                sequence: "1",
 *                startDate: "2024-04-06T00:00:00Z",
 *                trial: true,
 *                pricingScheme: {
 *                  pricingModel: "FIXED",
 *              },
 *            },
 *            ],
 *           currencyIsoCode: "USD",
 *           name: "Netflix with Ads",
 *           productDescription: "iPhone 13",
 *           productQuantity: "1.0",
 *           oneTimeFeeAmount: "10",
 *           shippingAmount: "3.0",
 *           productPrice: "200",
 *           taxAmount: "20",
 *        };
 *       });
 *     },
 *
 *     onAuthorize: function (data, actions) {
 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
 *         // Submit payload.nonce to your server
 *       });
 *     }
 *   }, '#paypal-button');
 * }).catch(function (err) {
 *  console.error('Error!', err);
 * });
 *
 * ```
 *
 * @returns {(promise|void)} returns a promise if no callback is provided.
 */ PayPalCheckout.prototype.createPayment = function(options) {
                    if (!options || !constants.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) return Promise.reject(new BraintreeError(errors.PAYPAL_FLOW_OPTION_REQUIRED));
                    analytics.sendEvent(this._clientPromise, "paypal-checkout.createPayment");
                    return this._createPaymentResource(options).then(function(response) {
                        var flowToken, urlParams;
                        if (options.flow === "checkout") {
                            urlParams = querystring.parse(response.paymentResource.redirectUrl);
                            flowToken = urlParams.token;
                        } else flowToken = response.agreementSetup.tokenId;
                        return flowToken;
                    });
                };
                PayPalCheckout.prototype._createPaymentResource = function(options, config) {
                    var self1 = this;
                    var endpoint = "paypal_hermes/" + constants.FLOW_ENDPOINTS[options.flow];
                    this._flow = options.flow;
                    delete this.intentFromCreatePayment;
                    config = config || {};
                    if (options.offerCredit === true) analytics.sendEvent(this._clientPromise, "paypal-checkout.credit.offered");
                    return this._clientPromise.then(function(client) {
                        return client.request({
                            endpoint: endpoint,
                            method: "post",
                            data: self1._formatPaymentResourceData(options, config)
                        }).then(function(data) {
                            self1.intentFromCreatePayment = options.intent;
                            return data;
                        });
                    })["catch"](function(err) {
                        var status;
                        if (self1._setupError) return Promise.reject(self1._setupError);
                        status = err.details && err.details.httpStatus;
                        if (status === 422) return Promise.reject(new BraintreeError({
                            type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
                            code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
                            message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
                            details: {
                                originalError: err
                            }
                        }));
                        return Promise.reject(convertToBraintreeError(err, {
                            type: errors.PAYPAL_FLOW_FAILED.type,
                            code: errors.PAYPAL_FLOW_FAILED.code,
                            message: errors.PAYPAL_FLOW_FAILED.message
                        }));
                    });
                };
                /**
 * Use this function to update {@link PayPalCheckout~lineItem|line items} and/or {@link PayPalCheckout~shippingOption|shipping options} associated with a PayPalCheckout flow (`paymentId`).
 * When a {@link callback} is defined, this function returns undefined and invokes the callback. The second callback argument, <code>data</code>, is the returned server data. If no callback is provided, `updatePayment` returns a promise that resolves with the server data.
 * @public
 * @param {object} options All options for the PayPalCheckout component.
 * @param {string} options.paymentId This should be PayPal `paymentId`.
 * @param {(string|number)} options.amount The amount of the transaction, including the amount of the selected shipping option, and all `line_items`.
 * * Supports up to 2 decimal digits.
 * @param {string} options.currency The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {shippingOption[]} [options.shippingOptions] List of {@link PayPalCheckout~shippingOption|shipping options} offered by the payee or merchant to the payer to ship or pick up their items.
 * @param {lineItem[]} [options.lineItems] The {@link PayPalCheckout~lineItem|line items} for this transaction. It can include up to 249 line items.
 * @param {object} [options.amountBreakdown] Optional collection of amounts that break down the total into individual pieces.
 * @param {string} [options.amountBreakdown.itemTotal] Optional, item amount
 * @param {string} [options.amountBreakdown.shipping] Optional, shipping amount
 * @param {string} [options.amountBreakdown.handling] Optional, handling amount
 * @param {string} [options.amountBreakdown.taxTotal] Optional, tax amount
 * @param {string} [options.amountBreakdown.insurance] Optional, insurance amount
 * @param {string} [options.amountBreakdown.shippingDiscount] Optional, shipping discount amount
 * @param {string} [options.amountBreakdown.discount] Optional, discount amount
 * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
 * @example
 * // this paypal object is created by the PayPal JS SDK
 * // see https://github.com/paypal/paypal-checkout-components
 * paypal.Buttons({
 *   createOrder: function () {
 *     // when createPayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.createPayment({
 *       //
 *     });
 *   },
 *   onShippingChange: function (data) {
 *     // Examine data and determine if the payment needs to be updated.
 *     // when updatePayment resolves, it is automatically passed to the PayPal JS SDK
 *     return paypalCheckoutInstance.updatePayment({
 *         paymentId: data.paymentId,
 *         amount: '15.00',
 *         currency: 'USD',
 *         shippingOptions: [
 *           {
 *             id: 'shipping-speed-fast',
 *             type: 'SHIPPING',
 *             label: 'Fast Shipping',
 *             selected: true,
 *             amount: {
 *               value: '5.00',
 *               currency: 'USD'
 *             }
 *           },
 *           {
 *             id: 'shipping-speed-slow',
 *             type: 'SHIPPING',
 *             label: 'Slow Shipping',
 *             selected: false,
 *             amount: {
 *               value: '1.00',
 *               currency: 'USD'
 *             }
 *           }
 *         ]
 *     });
 *   }
 *   // Add other options, e.g. onApproved, onCancel, onError
 * }).render('#paypal-button');
 *
 * ```
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PayPalCheckout.prototype.updatePayment = function(options) {
                    var self1 = this;
                    var endpoint = "paypal_hermes/patch_payment_resource";
                    if (!options || this._hasMissingOption(options, constants.REQUIRED_OPTIONS)) {
                        analytics.sendEvent(self1._clientPromise, "paypal-checkout.updatePayment.missing-options");
                        return Promise.reject(new BraintreeError(errors.PAYPAL_MISSING_REQUIRED_OPTION));
                    }
                    if (!this._verifyConsistentCurrency(options)) {
                        analytics.sendEvent(self1._clientPromise, "paypal-checkout.updatePayment.inconsistent-currencies");
                        return Promise.reject(new BraintreeError({
                            type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
                            code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
                            message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
                            details: {
                                originalError: new Error("One or more shipping option currencies differ from checkout currency.")
                            }
                        }));
                    }
                    analytics.sendEvent(this._clientPromise, "paypal-checkout.updatePayment");
                    return this._clientPromise.then(function(client) {
                        return client.request({
                            endpoint: endpoint,
                            method: "post",
                            data: self1._formatUpdatePaymentData(options)
                        });
                    })["catch"](function(err) {
                        var status = err.details && err.details.httpStatus;
                        if (status === 422) {
                            analytics.sendEvent(self1._clientPromise, "paypal-checkout.updatePayment.invalid");
                            return Promise.reject(new BraintreeError({
                                type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
                                code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
                                message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
                                details: {
                                    originalError: err
                                }
                            }));
                        }
                        analytics.sendEvent(self1._clientPromise, "paypal-checkout.updatePayment." + errors.PAYPAL_FLOW_FAILED.code);
                        return Promise.reject(convertToBraintreeError(err, {
                            type: errors.PAYPAL_FLOW_FAILED.type,
                            code: errors.PAYPAL_FLOW_FAILED.code,
                            message: errors.PAYPAL_FLOW_FAILED.message
                        }));
                    });
                };
                /**
 * Initializes the PayPal checkout flow with a payment method nonce that represents a vaulted PayPal account.
 * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the PayPal JS SDK. Otherwise, it returns a Promise that resolves with the id.
 * @public
 * @ignore
 * @param {object} options These options are identical to the {@link PayPalCheckout#createPayment|options for creating a payment resource}, except for the following:
 * * `flow` cannot be set (will always be `'checkout'`)
 * * `amount`, `currency`, and `vaultInitiatedCheckoutPaymentMethodToken` are required instead of optional
 * * Additional configuration is available (listed below)
 * @param {boolean} [options.optOutOfModalBackdrop=false] By default, the webpage will darken and become unusable while the PayPal window is open. For full control of the UI, pass `true` for this option.
 * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @example
 * paypalCheckoutInstance.startVaultInitiatedCheckout({
 *   vaultInitiatedCheckoutPaymentMethodToken: 'nonce-that-represents-a-vaulted-paypal-account',
 *   amount: '10.00',
 *   currency: 'USD'
 * }).then(function (payload) {
 *   // send payload.nonce to your server
 * }).catch(function (err) {
 *   if (err.code === 'PAYPAL_POPUP_CLOSED') {
 *     // indicates that customer canceled by
 *     // manually closing the PayPal popup
 *   }
 *
 *   // handle other errors
 * });
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PayPalCheckout.prototype.startVaultInitiatedCheckout = function(options) {
                    var missingRequiredParam;
                    var self1 = this;
                    if (this._vaultInitiatedCheckoutInProgress) {
                        analytics.sendEvent(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.error.already-in-progress");
                        return Promise.reject(new BraintreeError(errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_IN_PROGRESS));
                    }
                    REQUIRED_PARAMS_FOR_START_VAULT_INITIATED_CHECKOUT.forEach(function(param) {
                        if (!options.hasOwnProperty(param)) missingRequiredParam = param;
                    });
                    if (missingRequiredParam) return Promise.reject(new BraintreeError({
                        type: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.type,
                        code: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_PARAM_REQUIRED.code,
                        message: "Required param " + missingRequiredParam + " is missing."
                    }));
                    this._vaultInitiatedCheckoutInProgress = true;
                    this._addModalBackdrop(options);
                    options = assign({}, options, {
                        flow: "checkout"
                    });
                    analytics.sendEvent(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.started");
                    return this._waitForVaultInitiatedCheckoutDependencies().then(function() {
                        var frameCommunicationPromise = new ExtendedPromise();
                        var startVaultInitiatedCheckoutPromise = self1._createPaymentResource(options, {
                            returnUrl: self1._constructVaultCheckutUrl("redirect-frame"),
                            cancelUrl: self1._constructVaultCheckutUrl("cancel-frame")
                        }).then(function(response) {
                            var redirectUrl = response.paymentResource.redirectUrl;
                            self1._frameService.redirect(redirectUrl);
                            return frameCommunicationPromise;
                        });
                        self1._frameService.open({}, self1._createFrameServiceCallback(frameCommunicationPromise));
                        return startVaultInitiatedCheckoutPromise;
                    })["catch"](function(err) {
                        self1._vaultInitiatedCheckoutInProgress = false;
                        self1._removeModalBackdrop();
                        if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
                            analytics.sendEvent(self1._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.canceled.by-customer");
                            return Promise.reject(new BraintreeError(errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_CANCELED));
                        }
                        if (self1._frameService) self1._frameService.close();
                        if (err.code && err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) {
                            analytics.sendEvent(self1._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.failed.popup-not-opened");
                            return Promise.reject(new BraintreeError({
                                code: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.code,
                                type: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.type,
                                message: errors.PAYPAL_START_VAULT_INITIATED_CHECKOUT_POPUP_OPEN_FAILED.message,
                                details: {
                                    originalError: err
                                }
                            }));
                        }
                        return Promise.reject(err);
                    }).then(function(response) {
                        self1._frameService.close();
                        self1._vaultInitiatedCheckoutInProgress = false;
                        self1._removeModalBackdrop();
                        analytics.sendEvent(self1._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.succeeded");
                        return Promise.resolve(response);
                    });
                };
                PayPalCheckout.prototype._addModalBackdrop = function(options) {
                    if (options.optOutOfModalBackdrop) return;
                    if (!this._modalBackdrop) {
                        this._modalBackdrop = document.createElement("div");
                        this._modalBackdrop.setAttribute("data-braintree-paypal-vault-initiated-checkout-modal", true);
                        this._modalBackdrop.style.position = "fixed";
                        this._modalBackdrop.style.top = 0;
                        this._modalBackdrop.style.bottom = 0;
                        this._modalBackdrop.style.left = 0;
                        this._modalBackdrop.style.right = 0;
                        this._modalBackdrop.style.zIndex = 9999;
                        this._modalBackdrop.style.background = "black";
                        this._modalBackdrop.style.opacity = "0.7";
                        this._modalBackdrop.addEventListener("click", (function() {
                            this.focusVaultInitiatedCheckoutWindow();
                        }).bind(this));
                    }
                    document.body.appendChild(this._modalBackdrop);
                };
                PayPalCheckout.prototype._removeModalBackdrop = function() {
                    if (!(this._modalBackdrop && this._modalBackdrop.parentNode)) return;
                    this._modalBackdrop.parentNode.removeChild(this._modalBackdrop);
                };
                /**
 * Closes the PayPal window if it is opened via `startVaultInitiatedCheckout`.
 * @public
 * @ignore
 * @param {callback} [callback] Gets called when window is closed.
 * @example
 * paypalCheckoutInstance.closeVaultInitiatedCheckoutWindow();
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PayPalCheckout.prototype.closeVaultInitiatedCheckoutWindow = function() {
                    if (this._vaultInitiatedCheckoutInProgress) analytics.sendEvent(this._clientPromise, "paypal-checkout.startVaultInitiatedCheckout.canceled.by-merchant");
                    return this._waitForVaultInitiatedCheckoutDependencies().then((function() {
                        this._frameService.close();
                    }).bind(this));
                };
                /**
 * Focuses the PayPal window if it is opened via `startVaultInitiatedCheckout`.
 * @public
 * @ignore
 * @param {callback} [callback] Gets called when window is focused.
 * @example
 * paypalCheckoutInstance.focusVaultInitiatedCheckoutWindow();
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PayPalCheckout.prototype.focusVaultInitiatedCheckoutWindow = function() {
                    return this._waitForVaultInitiatedCheckoutDependencies().then((function() {
                        this._frameService.focus();
                    }).bind(this));
                };
                PayPalCheckout.prototype._createFrameServiceCallback = function(frameCommunicationPromise) {
                    var self1 = this;
                    // TODO when a merchant integrates an iOS or Android integration
                    // with a webview using the web SDK, we will have to add popupbridge
                    // support
                    return function(err, payload) {
                        if (err) frameCommunicationPromise.reject(err);
                        else if (payload) {
                            self1._frameService.redirect(self1._loadingFrameUrl);
                            self1.tokenizePayment({
                                paymentToken: payload.token,
                                payerID: payload.PayerID,
                                paymentID: payload.paymentId,
                                orderID: payload.orderId
                            }).then(function(res) {
                                frameCommunicationPromise.resolve(res);
                            })["catch"](function(tokenizationError) {
                                frameCommunicationPromise.reject(tokenizationError);
                            });
                        }
                    };
                };
                PayPalCheckout.prototype._waitForVaultInitiatedCheckoutDependencies = function() {
                    var self1 = this;
                    return this._clientPromise.then(function() {
                        return self1._frameServicePromise;
                    });
                };
                PayPalCheckout.prototype._constructVaultCheckutUrl = function(frameName) {
                    var serviceId = this._frameService._serviceId;
                    return this._assetsUrl + "/html/" + frameName + useMin(this._isDebug) + ".html?channel=" + serviceId;
                };
                /**
 * Tokenizes the authorize data from the PayPal JS SDK when completing a buyer approval flow.
 * When a {@link callback} is defined, invokes the callback with {@link PayPalCheckout~tokenizePayload|tokenizePayload} and returns undefined. Otherwise, returns a Promise that resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @public
 * @param {object} tokenizeOptions Tokens and IDs required to tokenize the payment.
 * @param {string} tokenizeOptions.payerId Payer ID returned by PayPal `onApproved` callback.
 * @param {string} [tokenizeOptions.paymentId] Payment ID returned by PayPal `onApproved` callback.
 * @param {string} [tokenizeOptions.billingToken] Billing Token returned by PayPal `onApproved` callback.
 * @param {boolean} [tokenizeOptions.vault=true] Whether or not to vault the resulting PayPal account (if using a client token generated with a customer id and the vault flow).
 * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
 * @example <caption>Opt out of auto-vaulting behavior</caption>
 * // create the paypalCheckoutInstance with a client token generated with a customer id
 * paypal.Buttons({
 *   createBillingAgreement: function () {
 *     return paypalCheckoutInstance.createPayment({
 *       flow: 'vault'
 *       // your other createPayment options here
 *     });
 *   },
 *   onApproved: function (data) {
 *     data.vault = false;
 *
 *     return paypalCheckoutInstance.tokenizePayment(data);
 *   },
 *   // Add other options, e.g. onCancel, onError
 * }).render('#paypal-button');
 *
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PayPalCheckout.prototype.tokenizePayment = function(tokenizeOptions) {
                    var self1 = this;
                    var shouldVault = true;
                    var payload;
                    var options = {
                        flow: this._flow,
                        intent: tokenizeOptions.intent || this.intentFromCreatePayment
                    };
                    var params = {
                        // The paymentToken provided by the PayPal JS SDK is the EC Token
                        ecToken: tokenizeOptions.paymentToken,
                        billingToken: tokenizeOptions.billingToken,
                        payerId: tokenizeOptions.payerID,
                        paymentId: tokenizeOptions.paymentID,
                        orderId: tokenizeOptions.orderID,
                        shippingOptionsId: tokenizeOptions.shippingOptionsId
                    };
                    if (tokenizeOptions.hasOwnProperty("vault")) shouldVault = tokenizeOptions.vault;
                    options.vault = shouldVault;
                    analytics.sendEvent(this._clientPromise, "paypal-checkout.tokenization.started");
                    return this._clientPromise.then(function(client) {
                        return client.request({
                            endpoint: "payment_methods/paypal_accounts",
                            method: "post",
                            data: self1._formatTokenizeData(options, params)
                        });
                    }).then(function(response) {
                        payload = self1._formatTokenizePayload(response);
                        analytics.sendEvent(self1._clientPromise, "paypal-checkout.tokenization.success");
                        if (payload.creditFinancingOffered) analytics.sendEvent(self1._clientPromise, "paypal-checkout.credit.accepted");
                        return payload;
                    })["catch"](function(err) {
                        if (self1._setupError) return Promise.reject(self1._setupError);
                        analytics.sendEvent(self1._clientPromise, "paypal-checkout.tokenization.failed");
                        return Promise.reject(convertToBraintreeError(err, {
                            type: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
                            code: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
                            message: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message
                        }));
                    });
                };
                /**
 * Resolves with the PayPal client id to be used when loading the PayPal SDK.
 * @public
 * @param {callback} [callback] The second argument, <code>id</code>, is a the PayPal client id. If no callback is provided, the promise resolves with the PayPal client id.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * paypalCheckoutInstance.getClientId().then(function (id) {
 *  var script = document.createElement('script');
 *
 *  script.src = 'https://www.paypal.com/sdk/js?client-id=' + id;
 *  script.onload = function () {
 *    // setup the PayPal SDK
 *  };
 *
 *  document.body.appendChild(script);
 * });
 */ PayPalCheckout.prototype.getClientId = function() {
                    return this._clientPromise.then(function(client) {
                        return client.getConfiguration().gatewayConfiguration.paypal.clientId;
                    });
                };
                /**
 * Resolves when the PayPal SDK has been successfully loaded onto the page.
 * @public
 * @param {object} [options] A configuration object to modify the query params and data-attributes on the PayPal SDK. A subset of the parameters are listed below. For a full list of query params, see the [PayPal docs](https://developer.paypal.com/docs/checkout/reference/customize-sdk/?mark=query#query-parameters).
 * @param {string} [options.client-id] By default, this will be the client id associated with the authorization used to create the Braintree component. When used in conjunction with passing `authorization` when creating the PayPal Checkout component, you can speed up the loading of the PayPal SDK.
 * @param {string} [options.intent="authorize"] By default, the PayPal SDK defaults to an intent of `capture`. Since the default intent when calling {@link PayPalCheckout#createPayment|`createPayment`} is `authorize`, the PayPal SDK will be loaded with `intent=authorize`. If you wish to use a different intent when calling {@link PayPalCheckout#createPayment|`createPayment`}, make sure it matches here. If `sale` is used, it will be converted to `capture` for the PayPal SDK. If the `vault: true` param is used, `tokenize` will be passed as the default intent.
 * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
 *
 * Supported locales are:
 * `da_DK`,
 * `de_DE`,
 * `en_AU`,
 * `en_GB`,
 * `en_US`,
 * `es_ES`,
 * `fr_CA`,
 * `fr_FR`,
 * `id_ID`,
 * `it_IT`,
 * `ja_JP`,
 * `ko_KR`,
 * `nl_NL`,
 * `no_NO`,
 * `pl_PL`,
 * `pt_BR`,
 * `pt_PT`,
 * `ru_RU`,
 * `sv_SE`,
 * `th_TH`,
 * `zh_CN`,
 * `zh_HK`,
 * and `zh_TW`.
 *
 * @param {string} [options.currency="USD"] If a currency is passed in {@link PayPalCheckout#createPayment|`createPayment`}, it must match the currency passed here.
 * @param {boolean} [options.vault] Must be `true` when using `flow: vault` in {@link PayPalCheckout#createPayment|`createPayment`}.
 * @param {string} [options.components=buttons] By default, the Braintree SDK will only load the PayPal smart buttons component. If you would like to load just the [messages component](https://developer.paypal.com/docs/business/checkout/add-capabilities/credit-messaging/), pass `messages`. If you would like to load both, pass `buttons,messages`
 * @param {object} [options.dataAttributes] The data attributes to apply to the script. Any data attribute can be passed. A subset of the parameters are listed below. For a full list of data attributes, see the [PayPal docs](https://developer.paypal.com/docs/checkout/reference/customize-sdk/#script-parameters).
 * @param {string} [options.dataAttributes.client-token] The client token to use in the script. (usually not needed)
 * @param {string} [options.dataAttributes.csp-nonce] See the [PayPal docs about content security nonces](https://developer.paypal.com/docs/checkout/reference/customize-sdk/#csp-nonce).
 * @param {callback} [callback] Called when the PayPal SDK has been loaded onto the page. The second argument is the PayPal Checkout instance. If no callback is provided, the promise resolves with the PayPal Checkout instance when the PayPal SDK has been loaded onto the page.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example <caption>Without options</caption>
 * paypalCheckoutInstance.loadPayPalSDK().then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 * @example <caption>With options</caption>
 * paypalCheckoutInstance.loadPayPalSDK({
 *   'client-id': 'PayPal Client Id', // Can speed up rendering time to hardcode this value
 *
 *   intent: 'capture', // Make sure this value matches the value in createPayment
 *   currency: 'USD', // Make sure this value matches the value in createPayment
 * }).then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 * @example <caption>With Vaulting</caption>
 * paypalCheckoutInstance.loadPayPalSDK({
 *   vault: true
 * }).then(function () {
 *   // window.paypal.Buttons is now available to use
 * });
 */ PayPalCheckout.prototype.loadPayPalSDK = function(options) {
                    var idPromise, src;
                    var loadPromise = new ExtendedPromise();
                    var dataAttributes = options && options.dataAttributes || {};
                    var userIdToken = dataAttributes["user-id-token"] || dataAttributes["data-user-id-token"];
                    if (this._configuration) dataAttributes["client-metadata-id"] = dataAttributes["client-metadata-id"] ? dataAttributes["client-metadata-id"] : this._configuration.analyticsMetadata.sessionId;
                    if (!userIdToken) userIdToken = this._authorizationInformation.fingerprint && this._authorizationInformation.fingerprint.split("?")[0];
                    this._paypalScript = document.createElement("script");
                    // NEXT_MAJOR_VERSION
                    // this options object should have 2 properties:
                    // * queryParams
                    // * dataAttributes
                    // should make organizing this better than squashing
                    // all the query params at the top level and extracting
                    // the data attributes
                    options = assign({}, {
                        components: "buttons"
                    }, options);
                    delete options.dataAttributes;
                    // NEXT_MAJOR_VERSION if merchant passes an explicit intent,
                    // currency, amount, etc, save those for use in createPayment
                    // if no explicit param of that type is passed in when calling
                    // createPayment to reduce the number of items that need to be
                    // duplicated here and in createPayment
                    if (options.vault) options.intent = options.intent || "tokenize";
                    else {
                        options.intent = options.intent || "authorize";
                        options.currency = options.currency || "USD";
                    }
                    src = "https://www.paypal.com/sdk/js?";
                    this._paypalScript.onload = function() {
                        loadPromise.resolve();
                    };
                    Object.keys(dataAttributes).forEach((function(attribute) {
                        this._paypalScript.setAttribute("data-" + attribute.replace(/^data\-/, ""), dataAttributes[attribute]);
                    }).bind(this));
                    if (options["client-id"]) idPromise = Promise.resolve(options["client-id"]);
                    else idPromise = this.getClientId();
                    idPromise.then((function(id) {
                        options["client-id"] = id;
                        if (this._autoSetDataUserIdToken && userIdToken) {
                            this._paypalScript.setAttribute("data-user-id-token", userIdToken);
                            // preloading improves the rendering time of the PayPal button
                            this._attachPreloadPixel({
                                id: id,
                                userIdToken: userIdToken,
                                amount: dataAttributes.amount,
                                currency: options.currency,
                                merchantId: options["merchant-id"]
                            });
                        }
                        this._paypalScript.src = querystring.queryify(src, options);
                        document.head.insertBefore(this._paypalScript, document.head.firstElementChild);
                    }).bind(this));
                    return loadPromise.then((function() {
                        return this;
                    }).bind(this));
                };
                PayPalCheckout.prototype._attachPreloadPixel = function(options) {
                    var request;
                    var id = options.id;
                    var userIdToken = options.userIdToken;
                    var env = this._authorizationInformation.environment;
                    var subdomain = env === "production" ? "" : "sandbox.";
                    var url = PAYPAL_SDK_PRELOAD_URL.replace("{ENV}", subdomain);
                    var preloadOptions = {
                        "client-id": id,
                        "user-id-token": userIdToken
                    };
                    if (options.amount) preloadOptions.amount = options.amount;
                    if (options.currency) preloadOptions.currency = options.currency;
                    if (options.merchantId) preloadOptions["merchant-id"] = options.merchantId;
                    request = new XMLHttpRequest();
                    request.open("GET", querystring.queryify(url, preloadOptions));
                    request.send();
                };
                PayPalCheckout.prototype._formatPaymentResourceData = function(options, config) {
                    var key;
                    var gatewayConfiguration = this._configuration.gatewayConfiguration;
                    // NEXT_MAJOR_VERSION default value for intent in PayPal SDK is capture
                    // but our integrations default value is authorize. Default this to capture
                    // in the next major version.
                    var intent = options.intent;
                    var paymentResource = {
                        // returnUrl and cancelUrl are required in hermes create_payment_resource route
                        // but are not used by the PayPal sdk, except to redirect to an error page
                        returnUrl: config.returnUrl || "https://www.paypal.com/checkoutnow/error",
                        cancelUrl: config.cancelUrl || "https://www.paypal.com/checkoutnow/error",
                        offerPaypalCredit: options.offerCredit === true,
                        merchantAccountId: this._merchantAccountId,
                        experienceProfile: {
                            brandName: options.displayName || gatewayConfiguration.paypal.displayName,
                            localeCode: options.locale,
                            noShipping: (!options.enableShippingAddress).toString(),
                            addressOverride: options.shippingAddressEditable === false,
                            landingPageType: options.landingPageType
                        },
                        shippingOptions: options.shippingOptions,
                        payer_email: options.userAuthenticationEmail
                    };
                    if (options.flow === "checkout") {
                        paymentResource.amount = options.amount;
                        paymentResource.currencyIsoCode = options.currency;
                        paymentResource.requestBillingAgreement = options.requestBillingAgreement;
                        if (intent) {
                            // 'sale' has been changed to 'capture' in PayPal's backend, but
                            // we use an old version with 'sale'. We provide capture as an alias
                            // to match the PayPal SDK
                            if (intent === "capture") intent = "sale";
                            paymentResource.intent = intent;
                        }
                        if (options.hasOwnProperty("lineItems")) paymentResource.lineItems = options.lineItems;
                        if (options.hasOwnProperty("vaultInitiatedCheckoutPaymentMethodToken")) paymentResource.vaultInitiatedCheckoutPaymentMethodToken = options.vaultInitiatedCheckoutPaymentMethodToken;
                        if (options.hasOwnProperty("shippingOptions")) paymentResource.shippingOptions = options.shippingOptions;
                        for(key in options.shippingAddressOverride)if (options.shippingAddressOverride.hasOwnProperty(key)) paymentResource[key] = options.shippingAddressOverride[key];
                        if (options.hasOwnProperty("billingAgreementDetails")) paymentResource.billingAgreementDetails = options.billingAgreementDetails;
                    } else {
                        // NOTE: This flow is "vault"
                        paymentResource.shippingAddress = options.shippingAddressOverride;
                        if (options.billingAgreementDescription) paymentResource.description = options.billingAgreementDescription;
                        if (options.planType) {
                            /* eslint-disable camelcase */ paymentResource.plan_type = options.planType;
                            if (options.planMetadata) paymentResource.plan_metadata = camelCaseToSnakeCase(options.planMetadata);
                        /* eslint-enable camelcase */ }
                    }
                    // this needs to be set outside of the block where add it to the
                    // payment request so that a follow up tokenization call can use it,
                    // but if a second create payment resource call is made without
                    // the correlation id, we want to reset it to undefined so that the
                    // tokenization call does not use a stale correlation id
                    this._riskCorrelationId = options.riskCorrelationId;
                    if (options.riskCorrelationId) paymentResource.correlationId = this._riskCorrelationId;
                    return paymentResource;
                };
                /**
 * @ignore
 * @static
 * @function _verifyConsistentCurrency
 * Verifies that `options.currency` and the currencies for each `shippingOption` the same.
 * @param {object} options `options` provided for `updatePayment`.
 * @returns {boolean} true is currencies match (or no shipping options); false if currencies do not match.
 */ PayPalCheckout.prototype._verifyConsistentCurrency = function(options) {
                    if (options.currency && options.hasOwnProperty("shippingOptions") && Array.isArray(options.shippingOptions)) return options.shippingOptions.every(function(item) {
                        return item.amount && item.amount.currency && options.currency.toLowerCase() === item.amount.currency.toLowerCase();
                    });
                    return true;
                };
                /**
 * @ignore
 * @static
 * @function _hasMissingOption
 * @param {object} options All options provided for intiating the PayPal flow.
 * @param {array} required A list of required inputs that must be include as part of the options.
 * @returns {boolean} Returns a boolean.
 */ PayPalCheckout.prototype._hasMissingOption = function(options, required) {
                    var i, option;
                    required = required || [];
                    if (!options.hasOwnProperty("amount") && !options.hasOwnProperty("lineItems")) return true;
                    for(i = 0; i < required.length; i++){
                        option = required[i];
                        if (!options.hasOwnProperty(option)) return true;
                    }
                    return false;
                };
                PayPalCheckout.prototype._formatUpdatePaymentData = function(options) {
                    var self1 = this;
                    var paymentResource = {
                        merchantAccountId: this._merchantAccountId,
                        paymentId: options.paymentId || options.orderId,
                        currencyIsoCode: options.currency
                    };
                    if (options.hasOwnProperty("amount")) paymentResource.amount = options.amount;
                    if (options.hasOwnProperty("lineItems")) paymentResource.lineItems = options.lineItems;
                    if (options.hasOwnProperty("shippingOptions")) paymentResource.shippingOptions = options.shippingOptions;
                    if (options.hasOwnProperty("amountBreakdown")) paymentResource.amountBreakdown = options.amountBreakdown;
                    /* shippingAddress not supported yet */ if (options.hasOwnProperty("shippingAddress")) {
                        analytics.sendEvent(self1._clientPromise, "paypal-checkout.updatePayment.shippingAddress.provided.by-the-merchant");
                        paymentResource.line1 = options.shippingAddress.line1;
                        if (options.shippingAddress.hasOwnProperty("line2")) paymentResource.line2 = options.shippingAddress.line2;
                        paymentResource.city = options.shippingAddress.city;
                        paymentResource.state = options.shippingAddress.state;
                        paymentResource.postalCode = options.shippingAddress.postalCode;
                        paymentResource.countryCode = options.shippingAddress.countryCode;
                        if (options.shippingAddress.hasOwnProperty("phone")) paymentResource.phone = options.shippingAddress.phone;
                        if (options.shippingAddress.hasOwnProperty("recipientName")) paymentResource.recipientName = options.shippingAddress.recipientName;
                    }
                    return paymentResource;
                };
                PayPalCheckout.prototype._formatTokenizeData = function(options, params) {
                    var clientConfiguration = this._configuration;
                    var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
                    var isTokenizationKey = clientConfiguration.authorizationType === "TOKENIZATION_KEY";
                    var isVaultFlow = options.flow === "vault";
                    var correlationId = this._riskCorrelationId || params.billingToken || params.ecToken;
                    var data = {
                        paypalAccount: {
                            correlationId: correlationId,
                            options: {
                                validate: isVaultFlow && !isTokenizationKey && options.vault
                            }
                        }
                    };
                    if (isVaultFlow) data.paypalAccount.billingAgreementToken = params.billingToken;
                    else {
                        data.paypalAccount.paymentToken = params.paymentId || params.orderId;
                        data.paypalAccount.payerId = params.payerId;
                        data.paypalAccount.unilateral = gatewayConfiguration.paypal.unvettedMerchant;
                        if (options.intent) data.paypalAccount.intent = options.intent;
                    }
                    if (this._merchantAccountId) data.merchantAccountId = this._merchantAccountId;
                    return data;
                };
                PayPalCheckout.prototype._formatTokenizePayload = function(response) {
                    var payload;
                    var account = {};
                    if (response.paypalAccounts) account = response.paypalAccounts[0];
                    payload = {
                        nonce: account.nonce,
                        details: {},
                        type: account.type
                    };
                    if (account.details && account.details.payerInfo) payload.details = account.details.payerInfo;
                    if (account.details && account.details.creditFinancingOffered) payload.creditFinancingOffered = account.details.creditFinancingOffered;
                    if (account.details && account.details.shippingOptionId) payload.shippingOptionId = account.details.shippingOptionId;
                    if (account.details && account.details.cobrandedCardLabel) payload.cobrandedCardLabel = account.details.cobrandedCardLabel;
                    return payload;
                };
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/paypal-checkout.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * paypalCheckoutInstance.teardown();
 * @example <caption>With callback</caption>
 * paypalCheckoutInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PayPalCheckout.prototype.teardown = function() {
                    var self1 = this;
                    convertMethodsToError(this, methods(PayPalCheckout.prototype));
                    if (this._paypalScript && this._paypalScript.parentNode) this._paypalScript.parentNode.removeChild(this._paypalScript);
                    return this._frameServicePromise["catch"](function() {
                    // no need to error in teardown for an error setting up the frame service
                    }).then(function() {
                        if (!self1._frameService) return Promise.resolve();
                        return self1._frameService.teardown();
                    });
                };
                module1.exports = wrapPromise.wrapPrototype(PayPalCheckout);
            },
            {
                "../lib/analytics": 138,
                "../lib/assign": 140,
                "../lib/braintree-error": 143,
                "../lib/camel-case-to-snake-case": 144,
                "../lib/constants": 145,
                "../lib/convert-methods-to-error": 146,
                "../lib/convert-to-braintree-error": 147,
                "../lib/create-assets-url": 148,
                "../lib/create-authorization-data": 149,
                "../lib/create-deferred-client": 150,
                "../lib/frame-service/external": 158,
                "../lib/methods": 175,
                "../lib/querystring": 177,
                "../lib/use-min": 180,
                "../paypal/shared/constants": 200,
                "./errors": 195,
                "@braintree/extended-promise": 31,
                "@braintree/wrap-promise": 40
            }
        ],
        198: [
            function(_dereq_, module1, exports) {
                "use strict";
                var frameService = _dereq_("../../lib/frame-service/external");
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var convertToBraintreeError = _dereq_("../../lib/convert-to-braintree-error");
                var useMin = _dereq_("../../lib/use-min");
                var once = _dereq_("../../lib/once");
                var VERSION = "3.110.0";
                var constants = _dereq_("../shared/constants");
                var INTEGRATION_TIMEOUT_MS = _dereq_("../../lib/constants").INTEGRATION_TIMEOUT_MS;
                var analytics = _dereq_("../../lib/analytics");
                var methods = _dereq_("../../lib/methods");
                var deferred = _dereq_("../../lib/deferred");
                var errors = _dereq_("../shared/errors");
                var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
                var querystring = _dereq_("../../lib/querystring");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @typedef {object} PayPal~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `PayPalAccount`.
 * @property {object} details Additional PayPal account details.
 * @property {string} details.email User's email address.
 * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
 * @property {string} details.firstName User's given name.
 * @property {string} details.lastName User's surname.
 * @property {?string} details.countryCode User's 2 character country code.
 * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
 * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
 * @property {string} details.shippingAddress.recipientName Recipient of postage.
 * @property {string} details.shippingAddress.line1 Street number and name.
 * @property {string} details.shippingAddress.line2 Extended address.
 * @property {string} details.shippingAddress.city City or locality.
 * @property {string} details.shippingAddress.state State or region.
 * @property {string} details.shippingAddress.postalCode Postal code.
 * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} details.billingAddress User's billing address details.
 * Not available to all merchants; [contact support](https://developer.paypal.com/braintree/help) for details on eligibility and enabling this feature.
 * Alternatively, see `shippingAddress` above as an available client option.
 * @property {string} details.billingAddress.line1 Street number and name.
 * @property {string} details.billingAddress.line2 Extended address.
 * @property {string} details.billingAddress.city City or locality.
 * @property {string} details.billingAddress.state State or region.
 * @property {string} details.billingAddress.postalCode Postal code.
 * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
 * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
 * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {number} creditFinancingOffered.term Length of financing terms in months.
 * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
 * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
 * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
 * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](https://www.iso.org/iso/home/standards/currency_codes.htm).
 * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
 * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
 *
 */ /**
 * @typedef {object} PayPal~tokenizeReturn
 * @property {Function} close A handle to close the PayPal checkout flow.
 * @property {Function} focus A handle to focus the PayPal checkout flow. Note that some browsers (notably iOS Safari) do not support focusing popups. Firefox requires the focus call to occur as the result of a user interaction, such as a button click.
 */ /**
 * @class
 * @param {object} options see {@link module:braintree-web/paypal.create|paypal.create}
 * @classdesc This class represents a PayPal component. Instances of this class can open a PayPal window for authenticating a PayPal account. Any additional UI, such as disabling the page while authentication is taking place, is up to the developer.
 *
 * This component has been deprecated in favor of the {@link PayPalCheckout|PayPal Checkout component}, which provides a fully managed UI. New features will not be added to this component.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal.create|braintree-web.paypal.create} instead.</strong>
 */ function PayPal(options) {
                    this._client = options.client;
                    this._assetsUrl = options.client.getConfiguration().gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION;
                    this._isDebug = options.client.getConfiguration().isDebug;
                    this._loadingFrameUrl = this._assetsUrl + "/html/paypal-landing-frame" + useMin(this._isDebug) + ".html";
                    this._authorizationInProgress = false;
                }
                PayPal.prototype._initialize = function() {
                    var self1 = this;
                    var client = this._client;
                    var failureTimeout = setTimeout(function() {
                        analytics.sendEvent(client, "paypal.load.timed-out");
                    }, INTEGRATION_TIMEOUT_MS);
                    return new Promise(function(resolve) {
                        frameService.create({
                            name: constants.LANDING_FRAME_NAME,
                            dispatchFrameUrl: self1._assetsUrl + "/html/dispatch-frame" + useMin(self1._isDebug) + ".html",
                            openFrameUrl: self1._loadingFrameUrl
                        }, function(service) {
                            self1._frameService = service;
                            clearTimeout(failureTimeout);
                            analytics.sendEvent(client, "paypal.load.succeeded");
                            resolve(self1);
                        });
                    });
                };
                /**
 * Launches the PayPal login flow and returns a nonce payload. Only one PayPal login flow should be active at a time. One way to achieve this is to disable your PayPal button while the flow is open.
 * @public
 * @param {object} options All tokenization options for the PayPal component.
 * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer id, the PayPal account will be added to that customer as a saved payment method.
 * @param {string} [options.intent=authorize]
 * * `authorize` - Submits the transaction for authorization but not settlement.
 * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
 * * `sale` - Payment will be immediately submitted for settlement upon creating a transaction.
 * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
 * @param {boolean} [options.offerPayLater=false] Offers PayPal Pay Later if the customer qualifies. Defaults to false. Only available with `flow: 'checkout'`.
 * @param {string} [options.useraction]
 * Changes the call-to-action in the PayPal flow. By default the final button will show the localized
 * word for "Continue" and implies that the final amount billed is not yet known.
 *
 * Setting this option to `commit` changes the button text to "Pay Now" and page text will convey to
 * the user that billing will take place immediately.
 * @param {(string|number)} [options.amount] The amount of the transaction. Required when using the Checkout flow.
 * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
 * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
 * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
 *
 * Supported locales are:
 * `da_DK`,
 * `de_DE`,
 * `en_AU`,
 * `en_GB`,
 * `en_US`,
 * `es_ES`,
 * `fr_CA`,
 * `fr_FR`,
 * `id_ID`,
 * `it_IT`,
 * `ja_JP`,
 * `ko_KR`,
 * `nl_NL`,
 * `no_NO`,
 * `pl_PL`,
 * `pt_BR`,
 * `pt_PT`,
 * `ru_RU`,
 * `sv_SE`,
 * `th_TH`,
 * `zh_CN`,
 * `zh_HK`,
 * and `zh_TW`.
 *
 * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
 * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
 * @param {string} options.shippingAddressOverride.line1 Street address.
 * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
 * @param {string} options.shippingAddressOverride.city City.
 * @param {string} options.shippingAddressOverride.state State.
 * @param {string} options.shippingAddressOverride.postalCode Postal code.
 * @param {string} options.shippingAddressOverride.countryCode Country.
 * @param {string} [options.shippingAddressOverride.phone] Phone number.
 * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
 * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
 * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
 * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
 * * `login` - A PayPal account login page is used.
 * * `billing` - A non-PayPal account landing page is used.
 * @param {callback} callback The second argument, <code>data</code>, is a {@link PayPal~tokenizePayload|tokenizePayload}.
 * @example
 * <caption>Tokenizing with the vault flow</caption>
 * button.addEventListener('click', function () {
 *   // Disable the button so that we don't attempt to open multiple popups.
 *   button.setAttribute('disabled', 'disabled');
 *
 *   // if there is any other part of the page that must be disabled
 *   // while authentication is in progress, do so now
 *
 *   // Because PayPal tokenization opens a popup, this must be called
 *   // as a result of a user action, such as a button click.
 *   paypalInstance.tokenize({
 *     flow: 'vault' // Required
 *     // Any other tokenization options
 *   }, function (tokenizeErr, payload) {
 *     button.removeAttribute('disabled');
 *
 *     // if any other part of the page was disabled, re-enable now
 *
 *     if (tokenizeErr) {
 *       // Handle tokenization errors or premature flow closure
 *
 *       switch (tokenizeErr.code) {
 *         case 'PAYPAL_POPUP_CLOSED':
 *           console.error('Customer closed PayPal popup.');
 *           break;
 *         case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
 *           console.error('PayPal tokenization failed. See details:', tokenizeErr.details);
 *           break;
 *         case 'PAYPAL_FLOW_FAILED':
 *           console.error('Unable to initialize PayPal flow. Are your options correct?', tokenizeErr.details);
 *           break;
 *         default:
 *           console.error('Error!', tokenizeErr);
 *       }
 *     } else {
 *       // Submit payload.nonce to your server
 *     }
 *   });
 * });

 * @example
 * <caption>Tokenizing with the checkout flow</caption>
 * button.addEventListener('click', function () {
 *   // Disable the button so that we don't attempt to open multiple popups.
 *   button.setAttribute('disabled', 'disabled');
 *
 *   // Because PayPal tokenization opens a popup, this must be called
 *   // as a result of a user action, such as a button click.
 *   paypalInstance.tokenize({
 *     flow: 'checkout', // Required
 *     amount: '10.00', // Required
 *     currency: 'USD' // Required
 *     // Any other tokenization options
 *   }, function (tokenizeErr, payload) {
 *     button.removeAttribute('disabled');
 *
 *     if (tokenizeErr) {
 *       // Handle tokenization errors or premature flow closure
 *
 *       switch (tokenizeErr.code) {
 *         case 'PAYPAL_POPUP_CLOSED':
 *           console.error('Customer closed PayPal popup.');
 *           break;
 *         case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
 *           console.error('PayPal tokenization failed. See details:', tokenizeErr.details);
 *           break;
 *         case 'PAYPAL_FLOW_FAILED':
 *           console.error('Unable to initialize PayPal flow. Are your options correct?', tokenizeErr.details);
 *           break;
 *         default:
 *           console.error('Error!', tokenizeErr);
 *       }
 *     } else {
 *       // Submit payload.nonce to your server
 *     }
 *   });
 * });
 * @returns {Promise|PayPal~tokenizeReturn} A handle to manage the PayPal checkout frame. If no callback is provided, returns a promise.
 */ PayPal.prototype.tokenize = function(options, callback) {
                    var self1 = this;
                    var client = this._client;
                    var tokenizePromise, optionError;
                    if (callback) callback = once(deferred(callback));
                    if (!options || !constants.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) {
                        optionError = new BraintreeError(errors.PAYPAL_FLOW_OPTION_REQUIRED);
                        if (callback) {
                            callback(optionError);
                            return this._frameService.createNoopHandler();
                        }
                        return Promise.reject(optionError);
                    }
                    tokenizePromise = new Promise(function(resolve, reject) {
                        if (self1._authorizationInProgress) {
                            analytics.sendEvent(client, "paypal.tokenization.error.already-opened");
                            reject(new BraintreeError(errors.PAYPAL_TOKENIZATION_REQUEST_ACTIVE));
                        } else {
                            self1._authorizationInProgress = true;
                            if (!window.popupBridge) analytics.sendEvent(client, "paypal.tokenization.opened");
                            if (options.offerCredit === true) analytics.sendEvent(client, "paypal.credit.offered");
                            if (options.offerPayLater === true) analytics.sendEvent(client, "paypal.paylater.offered");
                            self1._navigateFrameToAuth(options)["catch"](reject);
                            // self MUST happen after _navigateFrameToAuth for Metro browsers to work.
                            self1._frameService.open({}, self1._createFrameServiceCallback(options, resolve, reject));
                        }
                    });
                    if (callback) {
                        tokenizePromise.then(function(res) {
                            callback(null, res);
                        })["catch"](callback);
                        return this._frameService.createHandler({
                            beforeClose: function beforeClose() {
                                analytics.sendEvent(client, "paypal.tokenization.closed.by-merchant");
                            }
                        });
                    }
                    return tokenizePromise;
                };
                PayPal.prototype._createFrameServiceCallback = function(options, resolve, reject) {
                    var self1 = this;
                    var client = this._client;
                    if (window.popupBridge) return function(err, payload) {
                        var canceled = payload && payload.path && payload.path.substring(0, 7) === "/cancel";
                        self1._authorizationInProgress = false;
                        // `err` exists when the user clicks "Done" button of browser view
                        if (err || canceled) {
                            analytics.sendEvent(client, "paypal.tokenization.closed-popupbridge.by-user");
                            // Call merchant's tokenize callback with an error
                            reject(new BraintreeError(errors.PAYPAL_POPUP_CLOSED));
                        } else if (payload) self1._tokenizePayPal(options, payload.queryItems).then(resolve)["catch"](reject);
                    };
                    return function(err, params) {
                        self1._authorizationInProgress = false;
                        if (err) {
                            if (err.code === "FRAME_SERVICE_FRAME_CLOSED") {
                                analytics.sendEvent(client, "paypal.tokenization.closed.by-user");
                                reject(new BraintreeError(errors.PAYPAL_POPUP_CLOSED));
                            } else if (err.code && err.code.indexOf("FRAME_SERVICE_FRAME_OPEN_FAILED") > -1) reject(new BraintreeError({
                                code: errors.PAYPAL_POPUP_OPEN_FAILED.code,
                                type: errors.PAYPAL_POPUP_OPEN_FAILED.type,
                                message: errors.PAYPAL_POPUP_OPEN_FAILED.message,
                                details: {
                                    originalError: err
                                }
                            }));
                        } else if (params) self1._tokenizePayPal(options, params).then(resolve)["catch"](reject);
                    };
                };
                PayPal.prototype._tokenizePayPal = function(options, params) {
                    var self1 = this;
                    var client = this._client;
                    if (!window.popupBridge) this._frameService.redirect(this._loadingFrameUrl);
                    return client.request({
                        endpoint: "payment_methods/paypal_accounts",
                        method: "post",
                        data: this._formatTokenizeData(options, params)
                    }).then(function(response) {
                        var payload = self1._formatTokenizePayload(response);
                        if (window.popupBridge) analytics.sendEvent(client, "paypal.tokenization.success-popupbridge");
                        else analytics.sendEvent(client, "paypal.tokenization.success");
                        if (payload.creditFinancingOffered) analytics.sendEvent(client, "paypal.credit.accepted");
                        self1._frameService.close();
                        return payload;
                    })["catch"](function(err) {
                        if (window.popupBridge) analytics.sendEvent(client, "paypal.tokenization.failed-popupbridge");
                        else analytics.sendEvent(client, "paypal.tokenization.failed");
                        self1._frameService.close();
                        return Promise.reject(convertToBraintreeError(err, {
                            type: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
                            code: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
                            message: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message
                        }));
                    });
                };
                PayPal.prototype._formatTokenizePayload = function(response) {
                    var payload;
                    var account = {};
                    if (response.paypalAccounts) account = response.paypalAccounts[0];
                    payload = {
                        nonce: account.nonce,
                        details: {},
                        type: account.type
                    };
                    if (account.details && account.details.payerInfo) payload.details = account.details.payerInfo;
                    if (account.details && account.details.creditFinancingOffered) payload.creditFinancingOffered = account.details.creditFinancingOffered;
                    return payload;
                };
                PayPal.prototype._formatTokenizeData = function(options, params) {
                    var clientConfiguration = this._client.getConfiguration();
                    var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
                    var isTokenizationKey = clientConfiguration.authorizationType === "TOKENIZATION_KEY";
                    var data = {
                        paypalAccount: {
                            correlationId: params.ba_token || params.token,
                            options: {
                                validate: options.flow === "vault" && !isTokenizationKey
                            }
                        }
                    };
                    if (params.ba_token) data.paypalAccount.billingAgreementToken = params.ba_token;
                    else {
                        data.paypalAccount.paymentToken = params.paymentId;
                        data.paypalAccount.payerId = params.PayerID;
                        data.paypalAccount.unilateral = gatewayConfiguration.paypal.unvettedMerchant;
                        if (options.hasOwnProperty("intent")) data.paypalAccount.intent = options.intent;
                    }
                    return data;
                };
                PayPal.prototype._navigateFrameToAuth = function(options) {
                    var self1 = this;
                    var client = this._client;
                    var endpoint = "paypal_hermes/" + constants.FLOW_ENDPOINTS[options.flow];
                    return client.request({
                        endpoint: endpoint,
                        method: "post",
                        data: this._formatPaymentResourceData(options)
                    }).then(function(response) {
                        var redirectUrl;
                        if (options.flow === "checkout") redirectUrl = response.paymentResource.redirectUrl;
                        else redirectUrl = response.agreementSetup.approvalUrl;
                        if (options.useraction === "commit") redirectUrl = querystring.queryify(redirectUrl, {
                            useraction: "commit"
                        });
                        if (window.popupBridge) analytics.sendEvent(client, "paypal.tokenization.opened-popupbridge");
                        self1._frameService.redirect(redirectUrl);
                    })["catch"](function(err) {
                        var status = err.details && err.details.httpStatus;
                        self1._frameService.close();
                        self1._authorizationInProgress = false;
                        if (status === 422) return Promise.reject(new BraintreeError({
                            type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
                            code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
                            message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
                            details: {
                                originalError: err
                            }
                        }));
                        return Promise.reject(convertToBraintreeError(err, {
                            type: errors.PAYPAL_FLOW_FAILED.type,
                            code: errors.PAYPAL_FLOW_FAILED.code,
                            message: errors.PAYPAL_FLOW_FAILED.message
                        }));
                    });
                };
                PayPal.prototype._formatPaymentResourceData = function(options) {
                    var key;
                    var gatewayConfiguration = this._client.getConfiguration().gatewayConfiguration;
                    var serviceId = this._frameService._serviceId;
                    var paymentResource = {
                        returnUrl: gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION + "/html/redirect-frame" + useMin(this._isDebug) + ".html?channel=" + serviceId,
                        cancelUrl: gatewayConfiguration.paypal.assetsUrl + "/web/" + VERSION + "/html/cancel-frame" + useMin(this._isDebug) + ".html?channel=" + serviceId,
                        offerPaypalCredit: options.offerCredit === true,
                        offerPayLater: options.offerPayLater === true,
                        experienceProfile: {
                            brandName: options.displayName || gatewayConfiguration.paypal.displayName,
                            localeCode: options.locale,
                            noShipping: (!options.enableShippingAddress).toString(),
                            addressOverride: options.shippingAddressEditable === false,
                            landingPageType: options.landingPageType
                        }
                    };
                    if (window.popupBridge && typeof window.popupBridge.getReturnUrlPrefix === "function") {
                        paymentResource.returnUrl = window.popupBridge.getReturnUrlPrefix() + "return";
                        paymentResource.cancelUrl = window.popupBridge.getReturnUrlPrefix() + "cancel";
                    }
                    if (options.flow === "checkout") {
                        paymentResource.amount = options.amount;
                        paymentResource.currencyIsoCode = options.currency;
                        if (options.hasOwnProperty("intent")) paymentResource.intent = options.intent;
                        for(key in options.shippingAddressOverride)if (options.shippingAddressOverride.hasOwnProperty(key)) paymentResource[key] = options.shippingAddressOverride[key];
                    } else {
                        paymentResource.shippingAddress = options.shippingAddressOverride;
                        if (options.billingAgreementDescription) paymentResource.description = options.billingAgreementDescription;
                    }
                    return paymentResource;
                };
                /**
 * Closes the PayPal window if it is open.
 * @public
 * @example
 * paypalInstance.closeWindow();
 * @returns {void}
 */ PayPal.prototype.closeWindow = function() {
                    if (this._authorizationInProgress) analytics.sendEvent(this._client, "paypal.tokenize.closed.by-merchant");
                    this._frameService.close();
                };
                /**
 * Focuses the PayPal window if it is open.
 * @public
 * @example
 * paypalInstance.focusWindow();
 * @returns {void}
 */ PayPal.prototype.focusWindow = function() {
                    this._frameService.focus();
                };
                /**
 * Cleanly remove anything set up by {@link module:braintree-web/paypal.create|create}.
 * @public
 * @param {callback} [callback] Called on completion.
 * @example
 * paypalInstance.teardown();
 * @example <caption>With callback</caption>
 * paypalInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ PayPal.prototype.teardown = wrapPromise(function() {
                    var self1 = this; // eslint-disable-line no-invalid-this
                    self1._frameService.teardown();
                    convertMethodsToError(self1, methods(PayPal.prototype));
                    analytics.sendEvent(self1._client, "paypal.teardown-completed");
                    return Promise.resolve();
                });
                module1.exports = PayPal;
            },
            {
                "../../lib/analytics": 138,
                "../../lib/braintree-error": 143,
                "../../lib/constants": 145,
                "../../lib/convert-methods-to-error": 146,
                "../../lib/convert-to-braintree-error": 147,
                "../../lib/deferred": 151,
                "../../lib/frame-service/external": 158,
                "../../lib/methods": 175,
                "../../lib/once": 176,
                "../../lib/querystring": 177,
                "../../lib/use-min": 180,
                "../shared/constants": 200,
                "../shared/errors": 201,
                "@braintree/wrap-promise": 40
            }
        ],
        199: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/paypal
 * @description A component to integrate with PayPal.
 * @deprecated Use the {@link PayPalCheckout|PayPal Checkout component} instead.
 */ var analytics = _dereq_("../lib/analytics");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var errors = _dereq_("./shared/errors");
                var PayPal = _dereq_("./external/paypal");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} callback The second argument, `data`, is the {@link PayPal} instance.
 * @example
 * // We recommend creating your PayPal button with button.js
 * // For an example, see https://codepen.io/braintree/pen/LNKJWa
 * var paypalButton = document.querySelector('.paypal-button');
 *
 * braintree.client.create({
 *   authorization: CLIENT_AUTHORIZATION
 * }, function (clientErr, clientInstance) {
 *   if (clientErr) {
 *     console.error('Error creating client:', clientErr);
 *     return;
 *   }
 *
 *   braintree.paypal.create({
 *     client: clientInstance
 *   }, function (paypalErr, paypalInstance) {
 *     if (paypalErr) {
 *       console.error('Error creating PayPal:', paypalErr);
 *       return;
 *     }
 *
 *     paypalButton.removeAttribute('disabled');
 *
 *     // When the button is clicked, attempt to tokenize.
 *     paypalButton.addEventListener('click', function (event) {
 *       // Because tokenization opens a popup, this has to be called as a result of
 *       // customer action, like clicking a button. You cannot call this at any time.
 *       paypalInstance.tokenize({
 *         flow: 'vault'
 *         // For more tokenization options, see the full PayPal tokenization documentation
 *         // https://braintree.github.io/braintree-web/current/PayPal.html#tokenize
 *       }, function (tokenizeErr, payload) {
 *         if (tokenizeErr) {
 *           if (tokenizeErr.type !== 'CUSTOMER') {
 *             console.error('Error tokenizing:', tokenizeErr);
 *           }
 *           return;
 *         }
 *
 *         // Tokenization succeeded
 *         paypalButton.setAttribute('disabled', true);
 *         console.log('Got a nonce! You should submit this to your server.');
 *         console.log(payload.nonce);
 *       });
 *     }, false);
 *   });
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "PayPal";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        var pp;
                        var config = client.getConfiguration();
                        options.client = client;
                        if (config.gatewayConfiguration.paypalEnabled !== true) return Promise.reject(new BraintreeError(errors.PAYPAL_NOT_ENABLED));
                        analytics.sendEvent(options.client, "paypal.initialized");
                        pp = new PayPal(options);
                        return pp._initialize();
                    });
                }
                /**
 * @static
 * @function isSupported
 * @description Returns true if PayPal [supports this browser](index.html#browser-support-webviews).
 * @example
 * if (braintree.paypal.isSupported()) {
 *   // Add PayPal button to the page
 * } else {
 *   // Hide PayPal payment option
 * }
 * @returns {Boolean} Returns true if PayPal supports this browser.
 */ function isSupported() {
                    return true;
                }
                module1.exports = {
                    create: wrapPromise(create),
                    isSupported: isSupported,
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/analytics": 138,
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./external/paypal": 198,
                "./shared/errors": 201,
                "@braintree/wrap-promise": 40
            }
        ],
        200: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    LANDING_FRAME_NAME: "braintreepaypallanding",
                    FLOW_ENDPOINTS: {
                        checkout: "create_payment_resource",
                        vault: "setup_billing_agreement"
                    },
                    REQUIRED_OPTIONS: [
                        "paymentId",
                        "currency"
                    ]
                };
            },
            {}
        ],
        201: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.PayPal - Creation Error Codes
 * @description Errors that occur when [creating the PayPal component](./module-braintree-web_paypal.html#.create).
 * @property {MERCHANT} PAYPAL_NOT_ENABLED Occurs when PayPal is not enabled on the Braintree control panel.
 */ /**
 * @name BraintreeError.PayPal - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./PayPal.html#tokenize).
 * @property {MERCHANT} PAYPAL_TOKENIZATION_REQUEST_ACTIVE Occurs when a tokenization request is already in progress.
 * @property {MERCHANT} PAYPAL_FLOW_OPTION_REQUIRED Occurs when flow option is not provided.
 * @property {NETWORK} PAYPAL_ACCOUNT_TOKENIZATION_FAILED Occurs when PayPal account could not be tokenized.
 * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when PayPal flow could not be initiated.
 * @property {MERCHANT} PAYPAL_POPUP_OPEN_FAILED Occurs when PayPal window could not be opened.
 * @property {CUSTOMER} PAYPAL_POPUP_CLOSED Occurs when customer closes the PayPal window before completing the flow.
 * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an invalid payment option is passed.
 */ var BraintreeError = _dereq_("../../lib/braintree-error");
                module1.exports = {
                    PAYPAL_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_NOT_ENABLED",
                        message: "PayPal is not enabled for this merchant."
                    },
                    PAYPAL_TOKENIZATION_REQUEST_ACTIVE: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_TOKENIZATION_REQUEST_ACTIVE",
                        message: "Another tokenization request is active."
                    },
                    PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "PAYPAL_ACCOUNT_TOKENIZATION_FAILED",
                        message: "Could not tokenize user's PayPal account."
                    },
                    PAYPAL_FLOW_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "PAYPAL_FLOW_FAILED",
                        message: "Could not initialize PayPal flow."
                    },
                    PAYPAL_FLOW_OPTION_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_FLOW_OPTION_REQUIRED",
                        message: "PayPal flow property is invalid or missing."
                    },
                    PAYPAL_POPUP_OPEN_FAILED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_POPUP_OPEN_FAILED",
                        message: "PayPal popup failed to open, make sure to tokenize in response to a user action."
                    },
                    PAYPAL_POPUP_CLOSED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "PAYPAL_POPUP_CLOSED",
                        message: "Customer closed PayPal popup before authorizing."
                    },
                    PAYPAL_INVALID_PAYMENT_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "PAYPAL_INVALID_PAYMENT_OPTION",
                        message: "PayPal payment options are invalid."
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        202: [
            function(_dereq_, module1, exports) {
                "use strict";
                /** @module braintree-web/preferred-payment-methods */ var wrapPromise = _dereq_("@braintree/wrap-promise");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var PreferredPaymentMethods = _dereq_("./preferred-payment-methods");
                var VERSION = "3.110.0";
                // NEXT_MAJOR_VERSION
                // Remove this integration entirely. It doesn't work, isn't documented, and otherwise isn't going to be pursued further beyond the non-operational beta it is in.
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link PreferredPaymentMethods} instance.
 * @example
 * braintree.preferredPaymentMethods.create({
 *   client: clientInstance
 * }).then(function (preferredPaymentMethodsInstance) {
 *   // preferredPaymentMethodsInstance is ready to be used.
 * }).catch(function (error) {
 *   // handle creation error
 * });
 * @returns {Promise|void} Returns a Promise with resolves with the PreferredPaymentMethods instance.
 */ function create(options) {
                    var name = "PreferredPaymentMethods";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        var instance = new PreferredPaymentMethods();
                        return instance.initialize(options);
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "./preferred-payment-methods": 203,
                "@braintree/wrap-promise": 40
            }
        ],
        203: [
            function(_dereq_, module1, exports) {
                "use strict";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var analytics = _dereq_("../lib/analytics");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                /**
 * @class
 * @param {object} options See {@link module:braintree-web/preferred-payment-methods.create|preferred-payment-methods.create}
 */ function PreferredPaymentMethods() {}
                PreferredPaymentMethods.prototype.initialize = function(options) {
                    var self1 = this;
                    this._clientPromise = createDeferredClient.create({
                        authorization: options.authorization,
                        client: options.client,
                        debug: options.debug,
                        assetsUrl: createAssetsUrl.create(options.authorization),
                        name: "PreferredPaymentMethods"
                    })["catch"](function(err) {
                        self1._setupError = err;
                        return Promise.reject(err);
                    });
                    analytics.sendEvent(this._clientPromise, "preferred-payment-methods.initialized");
                    return Promise.resolve(this);
                };
                /**
 * Fetches information about which payment methods are preferred on the device.
 * Used to determine which payment methods are given preference in your UI,
 * not whether they are presented entirely.
 *
 * This class is currently in beta and may change in future releases.
 * @public
 * @returns {Promise|void} Returns a promise if no callback is provided.
 * @example
 * <caption>Preferred Payment Methods</caption>
 * preferredPaymentMethodsInstance.fetchPreferredPaymentMethods().then(function (result) {
 *   if (result.paypalPreferred) {
 *     // PayPal preferred
 *   } else {
 *     // PayPal not preferred
 *   }
 *
 *   if (result.venmoPreferred) {
 *     // Venmo preferred
 *   } else {
 *     // Venmo not preferred
 *   }
 * });
 */ PreferredPaymentMethods.prototype.fetchPreferredPaymentMethods = function() {
                    var client;
                    var self1 = this;
                    return this._clientPromise.then(function(clientInstance) {
                        client = clientInstance;
                        return client.request({
                            api: "graphQLApi",
                            data: {
                                query: "query PreferredPaymentMethods { preferredPaymentMethods { paypalPreferred venmoPreferred } }"
                            }
                        });
                    }).then(function(result) {
                        var paypalPreferred = result.data.preferredPaymentMethods.paypalPreferred;
                        var venmoPreferred = result.data.preferredPaymentMethods.venmoPreferred;
                        analytics.sendEvent(client, "preferred-payment-methods.paypal.api-detected." + paypalPreferred);
                        analytics.sendEvent(client, "preferred-payment-methods.venmo.api-detected." + venmoPreferred);
                        return {
                            paypalPreferred: paypalPreferred,
                            venmoPreferred: venmoPreferred
                        };
                    })["catch"](function() {
                        if (self1._setupError) return Promise.reject(self1._setupError);
                        analytics.sendEvent(client, "preferred-payment-methods.api-error");
                        return {
                            paypalPreferred: false,
                            venmoPreferred: false
                        };
                    });
                };
                module1.exports = wrapPromise.wrapPrototype(PreferredPaymentMethods);
            },
            {
                "../lib/analytics": 138,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "@braintree/wrap-promise": 40
            }
        ],
        204: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var sepaErrors = _dereq_("../shared/errors");
                var frameService = _dereq_("../../lib/frame-service/external");
                var analytics = _dereq_("../../lib/analytics");
                var useMin = _dereq_("../../lib/use-min");
                var billingAddressOptions = _dereq_("../shared/constants").BILLING_ADDRESS_OPTIONS;
                var snakeCaseToCamelCase = _dereq_("../../lib/snake-case-to-camel-case");
                var assign = _dereq_("../../lib/assign").assign;
                var POPUP_WIDTH = 400;
                var POPUP_HEIGHT = 570;
                /**
 * @ignore
 * @typedef CreateMandateResponse
 * @property {string} approvalUrl The URL to present to the customer for payment approval.
 * @property {string} last4 The last four digits of the iban.
 * @property {string} bankReferenceToken The tokenized payment source to fun the payment.
 */ /**
 *
 * A function that creates a mandate so that we can present the mandate to the customer via a popup.
 *
 * @ignore
 * @static
 * @function createMandate
 * @param {object} client The Braintree client.
 * @param {object} options All options for intiating the SEPA payment flow.
 * @param {string} [options.accountHolderName] The account holder name.
 * @param {object} [options.billingAddress] The customer's billing address
 * @param {string} [options.billingAddress.addressLine1] Line 1 of the Address (eg. number, street, etc). An error will occur if this address is not valid.
 * @param {string} [options.billingAddress.addressLine2] Line 2 of the Address (eg. suite, apt #, etc.). An error will occur if this address is not valid.
 * @param {string} [options.billingAddress.adminArea1] Customer's city.
 * @param {string} [options.billingAddress.adminArea2] Customer's region or state.
 * @param {string} [options.billingAddress.postalCode] Customer's postal code.
 * @param {string} [options.cancelUrl] The URL to redirect to if authorization is cancelled.
 * @param {string} [options.countryCode] The customer's country code. Also used as billing address country code.
 * @param {string} [options.customerId] The customer's id.
 * @param {string} [options.iban] The customer's International Bank Account Number.
 * @param {string} [options.locale] The BCP 47-formatted locale. See https://developer.paypal.com/reference/locale-codes/ for a list of possible values.
 * @param {string} [options.mandateType] Specify ONE_OFF or RECURRENT payment.
 * @param {string} [options.merchantAccountId] The merchant's account id.
 * @param {string} [options.merchantId] The merchant id.
 * @param {string} [options.returnUrl] The URL to redirect to if authorization is successful.
 * @returns {Promise<CreateMandateResponse|Error>} Returns a promise with the mandate response or an error.
 */ function createMandate(client, options) {
                    // Disabling eslint because api is expecting snake_case format for the keys
                    /* eslint-disable */ var data = {
                        sepa_debit: {
                            account_holder_name: options.accountHolderName,
                            billing_address: {
                                country_code: options.countryCode
                            },
                            iban: options.iban,
                            merchant_or_partner_customer_id: options.customerId,
                            mandate_type: options.mandateType
                        },
                        locale: options.locale,
                        cancel_url: options.cancelUrl,
                        return_url: options.returnUrl,
                        merchant_account_id: options.merchantAccountId
                    };
                    if (options.billingAddress) billingAddressOptions.forEach(function(option) {
                        var ccOption = snakeCaseToCamelCase(option);
                        if (ccOption in options.billingAddress) data.sepa_debit.billing_address[option] = options.billingAddress[ccOption]; // camelCase equivilent of option (eg. postal_code = postalCode) ]
                    });
                    /* eslint-enable */ return client.request({
                        api: "clientApi",
                        method: "post",
                        endpoint: "sepa_debit",
                        data: data
                    }).then(function(response) {
                        var sepaDebitAccount = response.message.body.sepaDebitAccount;
                        if (!sepaDebitAccount) throw new BraintreeError(sepaErrors.SEPA_CREATE_MANDATE_FAILED);
                        return {
                            approvalUrl: sepaDebitAccount.approvalUrl,
                            last4: sepaDebitAccount.last4,
                            bankReferenceToken: sepaDebitAccount.bankReferenceToken
                        };
                    })["catch"](function() {
                        throw new BraintreeError(sepaErrors.SEPA_CREATE_MANDATE_FAILED);
                    });
                }
                /**
 *
 * A function for opening and managing the popup used for authorization.
 *
 * @ignore
 * @param {string} client The Braintree client.
 * @param {string} options The input options needed to manage the popup portion of the flow.
 * @param {string} [options.assetsUrl] The url to the Braintree asset to be used in frameservice.
 * @param {string} [options.approvalUrl] The url to open for SEPA authorization. It is `approvalUrl` coming back from the mandate creation, but commonly refered to as the mandate link.
 * @param {string} [options.debug] Whether to use debugging modes or not.
 * @returns {Promise<void|Error>} Returns a promise.
 */ function openPopup(client, options) {
                    var popupName = "sepadirectdebit";
                    var assetsBaseUrl = options.assetsUrl + "/html";
                    var debug = options.debug || false;
                    return new Promise(function(resolve, reject) {
                        var popupLocation = centeredPopupDimensions();
                        frameService.create({
                            name: popupName,
                            dispatchFrameUrl: assetsBaseUrl + "/dispatch-frame" + useMin(debug) + ".html",
                            openFrameUrl: assetsBaseUrl + "/sepa-landing-frame" + useMin(debug) + ".html",
                            top: popupLocation.top,
                            left: popupLocation.left,
                            height: POPUP_HEIGHT,
                            width: POPUP_WIDTH
                        }, function(frameServiceInstance) {
                            analytics.sendEvent(client, "sepa.popup.initialized");
                            frameServiceInstance.open({}, function(err, params) {
                                if (mandateApproved(params)) {
                                    frameServiceInstance.close();
                                    return resolve();
                                }
                                if (customerCanceled(params, err)) {
                                    frameServiceInstance.close();
                                    return reject(new BraintreeError(sepaErrors.SEPA_CUSTOMER_CANCELED));
                                }
                                frameServiceInstance.close();
                                return reject(new BraintreeError(sepaErrors.SEPA_TOKENIZATION_FAILED));
                            });
                            frameServiceInstance.redirect(options.approvalUrl);
                        });
                    });
                }
                function redirectPage(approvalUrl) {
                    window.location.href = approvalUrl;
                }
                function mandateApproved(params) {
                    return params && params.success;
                }
                function customerCanceled(params, error) {
                    return params && params.cancel || error && error.code === "FRAME_SERVICE_FRAME_CLOSED";
                }
                function centeredPopupDimensions() {
                    var popupTop = Math.round((window.outerHeight - POPUP_HEIGHT) / 2) + window.screenTop;
                    var popupLeft = Math.round((window.outerWidth - POPUP_WIDTH) / 2) + window.screenLeft;
                    return {
                        top: popupTop,
                        left: popupLeft
                    };
                }
                /**
 *
 * A function that creates a mandate so that we can present the mandate to the customer via a popup.
 *
 * @ignore
 * @static
 * @function handleApproval
 * @param {object} client The Braintree client.
 * @param {object} options All options for intiating the SEPA payment flow.
 * @param {string} [options.bankReferenceToken] The tokenized payment source to fun the payment.
 * @param {string} [options.customerId] The customer's id.
 * @param {string} [options.last4] The last four digits of iban.
 * @param {string} [options.mandateType] The mandate type being used. Specify ONE_OFF or RECURRENT payment.
 * @param {string} [options.merchantAccountId] The merchant's account id.
 * @param {string} [options.merchantId] The merchant id.
 * @returns {Promise<tokenizePayload|Error>} Returns a promise with the approval response or an error.
 */ function handleApproval(client, options) {
                    // Disabling eslint because api is expecting snake_case format for the keys
                    /* eslint-disable */ var data = {
                        sepa_debit_account: {
                            last_4: options.last4,
                            merchant_or_partner_customer_id: options.customerId,
                            bank_reference_token: options.bankReferenceToken,
                            mandate_type: options.mandateType
                        },
                        merchant_account_id: options.merchantAccountId
                    };
                    /* eslint-enable */ return client.request({
                        api: "clientApi",
                        method: "post",
                        endpoint: "payment_methods/sepa_debit_accounts",
                        data: data
                    }).then(function(response) {
                        if (!response.nonce) throw new BraintreeError(sepaErrors.SEPA_TRANSACTION_FAILED);
                        return {
                            nonce: response.nonce,
                            ibanLastFour: options.last4,
                            customerId: options.customerId,
                            mandateType: options.mandateType
                        };
                    })["catch"](function() {
                        throw new BraintreeError(sepaErrors.SEPA_TRANSACTION_FAILED);
                    });
                }
                function handleApprovalForFullPageRedirect(client, options) {
                    return client.request({
                        api: "clientApi",
                        method: "get",
                        endpoint: "sepa_debit/" + options.cart_id
                    }).then(function(response) {
                        var payload = response.sepaDebitMandateDetail;
                        analytics.sendEvent(client, "sepa.redirect.mandate.approved");
                        assign(options, {
                            last4: payload.last4,
                            customerId: payload.merchantOrPartnerCustomerId,
                            mandateType: payload.mandateType,
                            bankReferenceToken: payload.bankReferenceToken
                        });
                        return handleApproval(client, options);
                    }).then(function(response) {
                        analytics.sendEvent(client, "sepa.redirect.tokenization.success");
                        return response;
                    })["catch"](function() {
                        analytics.sendEvent(client, "sepa.redirect.handle-approval.failed");
                        throw new BraintreeError(sepaErrors.SEPA_TRANSACTION_FAILED);
                    });
                }
                module1.exports = {
                    createMandate: createMandate,
                    openPopup: openPopup,
                    handleApproval: handleApproval,
                    POPUP_WIDTH: POPUP_WIDTH,
                    POPUP_HEIGHT: POPUP_HEIGHT,
                    redirectPage: redirectPage,
                    handleApprovalForFullPageRedirect: handleApprovalForFullPageRedirect
                };
            },
            {
                "../../lib/analytics": 138,
                "../../lib/assign": 140,
                "../../lib/braintree-error": 143,
                "../../lib/frame-service/external": 158,
                "../../lib/snake-case-to-camel-case": 179,
                "../../lib/use-min": 180,
                "../shared/constants": 207,
                "../shared/errors": 208
            }
        ],
        205: [
            function(_dereq_, module1, exports) {
                "use strict";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var sepaErrors = _dereq_("../shared/errors");
                var constants = _dereq_("../shared/constants");
                var mandates = _dereq_("./mandate");
                var hasMissingOption = _dereq_("../shared/has-missing-option");
                var analytics = _dereq_("../../lib/analytics");
                var VERSION = "3.110.0";
                var assign = _dereq_("../../lib/assign").assign;
                /**
 * @class
 * @param {object} options see {@link module:braintree-web/sepa.create|sepa.create}
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/sepa.create|braintree-web.sepa.create} instead.</strong>
 * @classdesc This class represents a SEPA component produced by {@link module:braintree-web/sepa.create|braintree-web.sepa.create}. Instances provide methods for tokenizing SEPA payments.
 */ function SEPA(options) {
                    var getConfiguration = options.client.getConfiguration();
                    this._client = options.client;
                    this._assetsUrl = getConfiguration.gatewayConfiguration.assetsUrl + "/web/" + VERSION;
                    this._isDebug = getConfiguration.isDebug;
                    if (options.redirectUrl) {
                        this._returnUrl = options.redirectUrl;
                        this._cancelUrl = options.redirectUrl + "?cancel=1";
                        this._isRedirectFlow = true;
                    } else {
                        this._returnUrl = this._assetsUrl + "/html/redirect-frame.html?success=1";
                        this._cancelUrl = this._assetsUrl + "/html/redirect-frame.html?cancel=1";
                    }
                    if (options.tokenizePayload) this.tokenizePayload = options.tokenizePayload;
                    analytics.sendEvent(this._client, "sepa.component.initialized");
                }
                /**
 * SEPA tokenize payload.
 * @typedef SEPA~tokenizePayload
 * @property {string} nonce The payment nonce.
 * @property {string} ibanLastFour The last four digits of the customer's IBAN.
 * @property {string} mandateType The specified mandateType used.
 * @property {string} customerId The provided customer id.
 */ /**
 * @public
 * @param {object} options All options for intiating the SEPA payment flow.
 * @param {string} [options.accountHolderName] The account holder name.
 * @param {string} [options.customerId] The customer's id.
 * @param {string} [options.iban] The customer's International Bank Account Number.
 * @param {string} [options.mandateType] Specify ONE_OFF or RECURRENT payment.
 * @param {string} [options.countryCode] The customer's country code.
 * @param {string} [options.merchantAccountId] The merchant's account id.
 * @param {callback} [callback] The first argument is an error object, where the second is a {@link SEPA~tokenizePayload|tokenizePayload}
 * @returns {(Promise<tokenizePayload|error>)} Returns a promise if no callback is provided.
 *
 * @example
 * button.addEventListener('click', function () {
 *   var tokenizeInputs = {
 *     accountHolderName: "some-accnt-holder-name",
 *     customerId: "a-customer-id",
 *     iban: "a-full-iban",
 *     mandateType: "ONE_OFF",
 *     countryCode: "LI",
 *     merchantAccountId: "a-merchant-account-id"
 *   }
 *   sepaInstance.tokenize(tokenizeInputs).then(function (payload) {
 *      // Submit payload.nonce to your server
 *   }).catch(function(tokenizationErr) {
 *     // Handle errors in the flow
 *   })
 * })
 */ SEPA.prototype.tokenize = function(options) {
                    var self1 = this;
                    var popupPromise;
                    var createMandateOptions = assign({
                        cancelUrl: self1._cancelUrl,
                        returnUrl: self1._returnUrl
                    }, options);
                    if (!options || hasMissingOption(options, constants.REQUIRED_OPTIONS)) {
                        analytics.sendEvent(self1._client, "sepa.input-validation.missing-options");
                        return Promise.reject(new BraintreeError(sepaErrors.SEPA_TOKENIZE_MISSING_REQUIRED_OPTION));
                    }
                    if (!constants.MANDATE_TYPE_ENUM.includes(options.mandateType)) {
                        analytics.sendEvent(self1._client, "sepa.input-validation.invalid-mandate");
                        return Promise.reject(new BraintreeError(sepaErrors.SEPA_INVALID_MANDATE_TYPE));
                    }
                    popupPromise = mandates.createMandate(self1._client, createMandateOptions).then(function(mandateResponse) {
                        analytics.sendEvent(self1._client, "sepa.create-mandate.success");
                        if (self1._isRedirectFlow) return mandates.redirectPage(mandateResponse.approvalUrl);
                        options.last4 = mandateResponse.last4;
                        options.bankReferenceToken = mandateResponse.bankReferenceToken;
                        return mandates.openPopup(self1._client, {
                            approvalUrl: mandateResponse.approvalUrl,
                            assetsUrl: self1._assetsUrl
                        });
                    });
                    // Must be outside of .then() to return from top-level function
                    if (self1._isRedirectFlow) return Promise.resolve();
                    // At this point, we know the promise came from the popup flow
                    return popupPromise.then(function() {
                        analytics.sendEvent(self1._client, "sepa.mandate.approved");
                        return mandates.handleApproval(self1._client, {
                            bankReferenceToken: options.bankReferenceToken,
                            last4: options.last4,
                            customerId: options.customerId,
                            mandateType: options.mandateType,
                            merchantAccountId: options.merchantAccountId
                        });
                    }).then(function(approval) {
                        analytics.sendEvent(self1._client, "sepa.tokenization.success");
                        return Promise.resolve(approval);
                    })["catch"](function(err) {
                        analytics.sendEvent(self1._client, "sepa." + err.details + ".failed");
                        return Promise.reject(err);
                    });
                };
                module1.exports = wrapPromise.wrapPrototype(SEPA);
            },
            {
                "../../lib/analytics": 138,
                "../../lib/assign": 140,
                "../../lib/braintree-error": 143,
                "../shared/constants": 207,
                "../shared/errors": 208,
                "../shared/has-missing-option": 209,
                "./mandate": 204,
                "@braintree/wrap-promise": 40
            }
        ],
        206: [
            function(_dereq_, module1, exports) {
                "use strict";
                /** @module braintree-web/sepa */ var analytics = _dereq_("../lib/analytics");
                var SEPA = _dereq_("./external/sepa");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var VERSION = "3.110.0";
                var parse = _dereq_("../lib/querystring").parse;
                var assign = _dereq_("../lib/assign").assign;
                var mandate = _dereq_("./external/mandate");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.debug] A debug flag.
 * @param {string} [options.redirectUrl] When provided, triggers full page redirect flow instead of popup flow.
 * @param {callback} [callback] When provided, will be used instead of a promise. First argument is an error object, where the second is an instance of {@link SEPA|SEPA}.
 * @returns {Promise<void|error>} Returns the SEPA instance.
 * @example
 * braintree.sepa.create({
 *   client: clientInstance
 * }).then(function (sepaInstance) {
 *   // sepaInstance is ready to be used.
 * }).catch(function (createErr) {
 *   console.error('Error creating SEPA instance', createErr);
 * });
 * @example <caption>Creating a SEPA component</caption>
 * braintree.sepa.create({
 *   client: clientInstance,
 * }).then(function (sepaInstance) {
 *   // sepaInstance is ready to be used.
 * }).catch(function (createErr) {
 *   console.error('Error creating SEPA instance', createErr);
 * });
 */ function create(options) {
                    var name = "SEPA";
                    var params = parse(window.location.href);
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        options.client = client;
                        analytics.sendEvent(client, "sepa.client.initialized");
                        return new SEPA(options);
                    }).then(function(sepaInstance) {
                        // This cart_id is actually a V2 orderId
                        var redirectComplete = params.success && params.success === "true" && params.cart_id;
                        if (redirectComplete) {
                            options = assign(options, params);
                            // Pick up redirect flow where it left off
                            return mandate.handleApprovalForFullPageRedirect(options.client, options).then(function(payload) {
                                sepaInstance.tokenizePayload = payload;
                                return sepaInstance;
                            })["catch"](function(err) {
                                console.error("Problem while finishing tokenizing: ", err);
                            });
                        } else if (params.cancel) analytics.sendEvent(options.client, "sepa.redirect.customer-canceled.failed");
                        return sepaInstance;
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/analytics": 138,
                "../lib/assign": 140,
                "../lib/basic-component-verification": 141,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "../lib/querystring": 177,
                "./external/mandate": 204,
                "./external/sepa": 205,
                "@braintree/wrap-promise": 40
            }
        ],
        207: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    REQUIRED_OPTIONS: [
                        "iban",
                        "merchantAccountId",
                        "mandateType",
                        "customerId",
                        "accountHolderName",
                        "countryCode"
                    ],
                    BILLING_ADDRESS_OPTIONS: [
                        "address_line_1",
                        "address_line_2",
                        "admin_area_1",
                        "admin_area_2",
                        "postal_code"
                    ],
                    MANDATE_TYPE_ENUM: [
                        "ONE_OFF",
                        "RECURRENT"
                    ]
                };
            },
            {}
        ],
        208: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../../lib/braintree-error");
                /**
 * @name BraintreeError.SEPA - tokenize Error Codes
 * @description Errors that occur when using the {@link module:braintree-web/sepa.tokenize|sepa.tokenize} method.
 * @property {MERCHANT} SEPA_CREATE_MANDATE_FAILED Occurs when there was an issue creating a mandate. This can occur if the request fails, or if the merchant does not have SEPA enabled.
 * @property {CUSTOMER} SEPA_CUSTOMER_CANCELED Occurs when the customer has canceled the SEPA authorization process. This can be within the mandate approval popup, or by canceling the popup itself.
 * @property {MERCHANT} SEPA_INVALID_MANDATE_TYPE Occurs when an invalid mandate type is provided.
 * @property {UNKNOWN} SEPA_TOKENIZATION_FAILED Occurs when tokenization fails during the mandate approval process for unknown reasons.
 * @property {MERCHANT} SEPA_TOKENIZE_MISSING_REQUIRED_OPTION Occurs when there are required input options not provided.
 * @property {UNKNOWN} SEPA_TRANSACTION_FAILED Occurs when final tokenization fails.
 */ // Those with a "details" property are used in specific locations and this prop serves to identify where in the imlpementation the error originates.
                module1.exports = {
                    SEPA_CREATE_MANDATE_FAILED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "SEPA_CREATE_MANDATE_FAILED",
                        message: "SEPA create mandate failed.",
                        details: "create-mandate"
                    },
                    SEPA_CUSTOMER_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "SEPA_CUSTOMER_CANCELED",
                        message: "User canceled SEPA authorization",
                        details: "customer-canceled"
                    },
                    SEPA_INVALID_MANDATE_TYPE: {
                        type: BraintreeError.types.MERCHANT,
                        code: "SEPA_INVALID_MANDATE_TYPE",
                        message: "SEPA mandate type is invalid"
                    },
                    SEPA_TOKENIZATION_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "SEPA_TOKENIZATION_FAILED",
                        message: "SEPA encountered a problem",
                        details: "open-popup"
                    },
                    SEPA_TOKENIZE_MISSING_REQUIRED_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "SEPA_TOKENIZE_MISSING_REQUIRED_OPTION",
                        message: "Missing required option for tokenize."
                    },
                    SEPA_TRANSACTION_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "SEPA_TRANSACTION_FAILED",
                        message: "SEPA transaction failed",
                        details: "handle-approval"
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        209: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @ignore
 * @static
 * @function hasMissingOption
 * @param {object} options All options provided for intiating the SEPA payment flow.
 * @param {array} required A list of required inputs that must be include as part of the options.
 * @returns {boolean} Returns a boolean.
 */ function hasMissingOption(options, required) {
                    var i, option;
                    required = required || [];
                    for(i = 0; i < required.length; i++){
                        option = required[i];
                        if (!options.hasOwnProperty(option)) return true;
                    }
                    return false;
                }
                module1.exports = hasMissingOption;
            },
            {}
        ],
        210: [
            function(_dereq_, module1, exports) {
                "use strict";
                var assign = _dereq_("../../../lib/assign").assign;
                var analytics = _dereq_("../../../lib/analytics");
                var BraintreeError = _dereq_("../../../lib/braintree-error");
                var isVerifiedDomain = _dereq_("../../../lib/is-verified-domain");
                var ExtendedPromise = _dereq_("@braintree/extended-promise");
                var EventEmitter = _dereq_("@braintree/event-emitter");
                var errors = _dereq_("../../shared/errors");
                var iFramer = _dereq_("@braintree/iframer");
                var Bus = _dereq_("framebus");
                var constants = _dereq_("../../shared/constants");
                var uuid = _dereq_("@braintree/uuid");
                var events = _dereq_("../../shared/events");
                var useMin = _dereq_("../../../lib/use-min");
                var BUS_CONFIGURATION_REQUEST_EVENT = _dereq_("../../../lib/constants").BUS_CONFIGURATION_REQUEST_EVENT;
                var VERSION = "3.110.0";
                var IFRAME_HEIGHT = 400;
                var IFRAME_WIDTH = 400;
                ExtendedPromise.suppressUnhandledPromiseMessage = true;
                function BaseFramework(options) {
                    EventEmitter.call(this);
                    this._client = options.client;
                    this._createPromise = options.createPromise;
                    this._createOptions = options;
                    if (this._client) {
                        this._isDebug = this._client.getConfiguration().isDebug;
                        this._assetsUrl = this._client.getConfiguration().gatewayConfiguration.assetsUrl;
                    } else {
                        this._isDebug = Boolean(options.isDebug);
                        this._assetsUrl = options.assetsUrl;
                    }
                    this._assetsUrl = this._assetsUrl + "/web/" + VERSION;
                }
                EventEmitter.createChild(BaseFramework);
                BaseFramework.prototype._waitForClient = function() {
                    if (this._client) return Promise.resolve();
                    return this._createPromise.then((function(client) {
                        this._client = client;
                    }).bind(this));
                };
                BaseFramework.prototype.setUpEventListeners = function() {
                    throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
                };
                BaseFramework.prototype.verifyCard = function(options, privateOptions) {
                    var formattedOptions, error;
                    var self1 = this;
                    privateOptions = privateOptions || {};
                    error = this._checkForVerifyCardError(options, privateOptions);
                    if (error) return Promise.reject(error);
                    this._verifyCardInProgress = true;
                    formattedOptions = this._formatVerifyCardOptions(options);
                    return this._formatLookupData(formattedOptions).then(function(data) {
                        analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.started");
                        return self1._performLookup(formattedOptions.nonce, data);
                    }).then(function(response) {
                        analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.3ds-version." + response.lookup.threeDSecureVersion);
                        return self1._onLookupComplete(response, formattedOptions);
                    }).then(function(response) {
                        return self1.initializeChallengeWithLookupResponse(response, formattedOptions);
                    }).then(function(payload) {
                        self1._resetVerificationState();
                        analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.completed");
                        return payload;
                    })["catch"](function(err) {
                        self1._resetVerificationState();
                        analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.failed");
                        return Promise.reject(err);
                    });
                };
                BaseFramework.prototype._checkForFrameworkSpecificVerifyCardErrors = function() {
                    throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
                };
                BaseFramework.prototype._presentChallenge = function() {
                    throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
                };
                BaseFramework.prototype.prepareLookup = function() {
                    throw new BraintreeError(errors.THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED);
                };
                BaseFramework.prototype._resetVerificationState = function() {
                    this._verifyCardInProgress = false;
                    this._verifyCardPromisePlus = null;
                    if (typeof this._reloadThreeDSecure === "function") this._reloadThreeDSecure();
                };
                BaseFramework.prototype._performLookup = function(nonce, data) {
                    var self1 = this;
                    var url = "payment_methods/" + nonce + "/three_d_secure/lookup";
                    return this._waitForClient().then(function() {
                        return self1._client.request({
                            endpoint: url,
                            method: "post",
                            data: data
                        })["catch"](function(err) {
                            var status = err && err.details && err.details.httpStatus;
                            var analyticsMessage = "three-d-secure.verification-flow.lookup-failed";
                            var lookupError;
                            if (status === 404) {
                                lookupError = errors.THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR;
                                analyticsMessage += ".404";
                            } else if (status === 422) {
                                lookupError = errors.THREEDS_LOOKUP_VALIDATION_ERROR;
                                analyticsMessage += ".422";
                            } else lookupError = errors.THREEDS_LOOKUP_ERROR;
                            analytics.sendEvent(self1._createPromise, analyticsMessage);
                            return Promise.reject(new BraintreeError({
                                type: lookupError.type,
                                code: lookupError.code,
                                message: lookupError.message,
                                details: {
                                    originalError: err
                                }
                            }));
                        });
                    });
                };
                BaseFramework.prototype._existsAndIsNumeric = function(value) {
                    /**
   * Returns true if value is numeric and false if value is:
   *  - undefined
   *  - null
   *  - an array
   *  - an empty string
   *  - boolean
   *  - otherwise non-numeric value (e.g. {}, "cows")
   */ return !(value === undefined || // eslint-disable-line no-undefined
                    value === null || Array.isArray(value) || typeof value === "boolean" || typeof value === "string" && value.trim() === "" || isNaN(Number(value)));
                };
                BaseFramework.prototype._checkForVerifyCardError = function(options, privateOptions) {
                    var errorOption;
                    if (this._verifyCardInProgress === true) return new BraintreeError(errors.THREEDS_AUTHENTICATION_IN_PROGRESS);
                    else if (!options.nonce) errorOption = "a nonce";
                    else if (// eslint-disable-next-line no-undefined
                    !this._existsAndIsNumeric(options.amount)) errorOption = "an amount";
                    if (!errorOption) errorOption = this._checkForFrameworkSpecificVerifyCardErrors(options, privateOptions);
                    if (errorOption) return new BraintreeError({
                        type: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.type,
                        code: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.code,
                        message: "verifyCard options must include " + errorOption + "."
                    });
                    return null;
                };
                BaseFramework.prototype.initializeChallengeWithLookupResponse = function(lookupResponse, options) {
                    var self1 = this;
                    options = options || {};
                    this._lookupPaymentMethod = lookupResponse.paymentMethod;
                    // sets this in the case that initializeChallengeWithLookupResponse is
                    // called as a standalone method from a server side lookup. In a normal
                    // verifyCard flow, this promise will already exist
                    self1._verifyCardPromisePlus = self1._verifyCardPromisePlus || new ExtendedPromise();
                    self1._handleLookupResponse(lookupResponse, options);
                    return self1._verifyCardPromisePlus.then(function(payload) {
                        analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.liability-shifted." + String(payload.liabilityShifted));
                        analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.liability-shift-possible." + String(payload.liabilityShiftPossible));
                        return payload;
                    });
                };
                BaseFramework.prototype._handleLookupResponse = function(lookupResponse, options) {
                    var challengeShouldBePresented = Boolean(lookupResponse.lookup && lookupResponse.lookup.acsUrl);
                    var details;
                    analytics.sendEvent(this._createPromise, "three-d-secure.verification-flow.challenge-presented." + String(challengeShouldBePresented));
                    if (challengeShouldBePresented) this._presentChallenge(lookupResponse, options);
                    else {
                        details = this._formatAuthResponse(lookupResponse.paymentMethod, lookupResponse.threeDSecureInfo);
                        details.verificationDetails = lookupResponse.threeDSecureInfo;
                        this._verifyCardPromisePlus.resolve(details);
                    }
                };
                BaseFramework.prototype._onLookupComplete = function(response) {
                    this._lookupPaymentMethod = response.paymentMethod;
                    this._verifyCardPromisePlus = new ExtendedPromise();
                    return Promise.resolve(response);
                };
                BaseFramework.prototype._formatAuthResponse = function(paymentMethod, threeDSecureInfo) {
                    return {
                        nonce: paymentMethod.nonce,
                        type: paymentMethod.type,
                        binData: paymentMethod.binData,
                        details: paymentMethod.details,
                        description: paymentMethod.description && paymentMethod.description.replace(/\+/g, " "),
                        liabilityShifted: threeDSecureInfo && threeDSecureInfo.liabilityShifted,
                        liabilityShiftPossible: threeDSecureInfo && threeDSecureInfo.liabilityShiftPossible,
                        threeDSecureInfo: paymentMethod.threeDSecureInfo
                    };
                };
                BaseFramework.prototype._formatVerifyCardOptions = function(options) {
                    return assign({}, options);
                };
                BaseFramework.prototype._formatLookupData = function(options) {
                    var data = {
                        amount: options.amount
                    };
                    if (options.collectDeviceData === true) {
                        data.browserColorDepth = window.screen.colorDepth;
                        data.browserJavaEnabled = window.navigator.javaEnabled();
                        data.browserJavascriptEnabled = true;
                        data.browserLanguage = window.navigator.language;
                        data.browserScreenHeight = window.screen.height;
                        data.browserScreenWidth = window.screen.width;
                        data.browserTimeZone = new Date().getTimezoneOffset();
                        data.deviceChannel = "Browser";
                    }
                    return Promise.resolve(data);
                };
                BaseFramework.prototype._handleV1AuthResponse = function(data) {
                    var authResponse = JSON.parse(data.auth_response);
                    if (authResponse.success) this._verifyCardPromisePlus.resolve(this._formatAuthResponse(authResponse.paymentMethod, authResponse.threeDSecureInfo));
                    else if (authResponse.threeDSecureInfo && authResponse.threeDSecureInfo.liabilityShiftPossible) this._verifyCardPromisePlus.resolve(this._formatAuthResponse(this._lookupPaymentMethod, authResponse.threeDSecureInfo));
                    else this._verifyCardPromisePlus.reject(new BraintreeError({
                        type: BraintreeError.types.UNKNOWN,
                        code: "UNKNOWN_AUTH_RESPONSE",
                        message: authResponse.error.message
                    }));
                };
                BaseFramework.prototype.cancelVerifyCard = function() {
                    var response, threeDSecureInfo;
                    this._verifyCardInProgress = false;
                    if (!this._lookupPaymentMethod) return Promise.reject(new BraintreeError(errors.THREEDS_NO_VERIFICATION_PAYLOAD));
                    threeDSecureInfo = this._lookupPaymentMethod.threeDSecureInfo;
                    response = assign({}, this._lookupPaymentMethod, {
                        liabilityShiftPossible: threeDSecureInfo && threeDSecureInfo.liabilityShiftPossible,
                        liabilityShifted: threeDSecureInfo && threeDSecureInfo.liabilityShifted,
                        verificationDetails: threeDSecureInfo && threeDSecureInfo.verificationDetails
                    });
                    return Promise.resolve(response);
                };
                BaseFramework.prototype._setupV1Bus = function(options) {
                    var clientConfiguration = this._client.getConfiguration();
                    var parentURL = window.location.href.split("#")[0];
                    var lookupResponse = options.lookupResponse;
                    var channel = uuid();
                    var bus = new Bus({
                        channel: channel,
                        verifyDomain: isVerifiedDomain
                    });
                    var authenticationCompleteBaseUrl = this._assetsUrl + "/html/three-d-secure-authentication-complete-frame.html?channel=" + encodeURIComponent(channel) + "&";
                    bus.on(BUS_CONFIGURATION_REQUEST_EVENT, function(reply) {
                        reply({
                            clientConfiguration: clientConfiguration,
                            nonce: options.nonce,
                            acsUrl: lookupResponse.acsUrl,
                            pareq: lookupResponse.pareq,
                            termUrl: lookupResponse.termUrl + "&three_d_secure_version=" + VERSION + "&authentication_complete_base_url=" + encodeURIComponent(authenticationCompleteBaseUrl),
                            md: lookupResponse.md,
                            parentUrl: parentURL
                        });
                    });
                    bus.on(events.AUTHENTICATION_COMPLETE, options.handleAuthResponse);
                    return bus;
                };
                BaseFramework.prototype._setupV1Iframe = function(options) {
                    var url = this._assetsUrl + "/html/three-d-secure-bank-frame" + useMin(this._isDebug) + ".html?showLoader=" + options.showLoader;
                    var bankIframe = iFramer({
                        src: url,
                        height: IFRAME_HEIGHT,
                        width: IFRAME_WIDTH,
                        name: constants.LANDING_FRAME_NAME + "_" + this._v1Bus.channel,
                        title: "3D Secure Authorization Frame"
                    });
                    return bankIframe;
                };
                BaseFramework.prototype._setupV1Elements = function(options) {
                    this._v1Bus = this._setupV1Bus(options);
                    this._v1Iframe = this._setupV1Iframe(options);
                };
                BaseFramework.prototype._teardownV1Elements = function() {
                    if (this._v1Bus) {
                        this._v1Bus.teardown();
                        this._v1Bus = null;
                    }
                    if (this._v1Iframe && this._v1Iframe.parentNode) {
                        this._v1Iframe.parentNode.removeChild(this._v1Iframe);
                        this._v1Iframe = null;
                    }
                    if (this._onV1Keyup) {
                        document.removeEventListener("keyup", this._onV1Keyup);
                        this._onV1Keyup = null;
                    }
                };
                BaseFramework.prototype.teardown = function() {
                    analytics.sendEvent(this._createPromise, "three-d-secure.teardown-completed");
                    this._teardownV1Elements();
                    return Promise.resolve();
                };
                module1.exports = BaseFramework;
            },
            {
                "../../../lib/analytics": 138,
                "../../../lib/assign": 140,
                "../../../lib/braintree-error": 143,
                "../../../lib/constants": 145,
                "../../../lib/is-verified-domain": 173,
                "../../../lib/use-min": 180,
                "../../shared/constants": 219,
                "../../shared/errors": 220,
                "../../shared/events": 221,
                "@braintree/event-emitter": 30,
                "@braintree/extended-promise": 31,
                "@braintree/iframer": 32,
                "@braintree/uuid": 36,
                framebus: 50
            }
        ],
        211: [
            function(_dereq_, module1, exports) {
                "use strict";
                // NEXT_MAJOR_VERSION drop support for Bootstrap framework,
                // recomend using inline frame version and putting it in
                // the merchant's own bootstrap modal
                var SongbirdFramework = _dereq_("./songbird");
                function Bootstrap3ModalFramework(options) {
                    SongbirdFramework.call(this, options);
                }
                Bootstrap3ModalFramework.prototype = Object.create(SongbirdFramework.prototype, {
                    constructor: SongbirdFramework
                });
                Bootstrap3ModalFramework.prototype._createV1IframeModalElement = function(iframe) {
                    var modal = document.createElement("div");
                    modal.innerHTML = '<div class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="CCAFrameModal-label" aria-hidden="true" style="display: block;"><div class="modal-dialog" style="width:440px;z-index:999999;"><div class="modal-content"><div class="modal-body" data-braintree-v1-fallback-iframe-container><button type="button" data-braintree-v1-fallback-close-button class="close" data-dismiss="modal" aria-hidden="true">\xd7</button></div></div></div><div data-braintree-v1-fallback-backdrop style="position: fixed;cursor: pointer;z-index: 999998;top: 0;left: 0;width: 100%;height: 100%;"></div></div>';
                    modal.querySelector("[data-braintree-v1-fallback-iframe-container]").appendChild(iframe);
                    return modal;
                };
                Bootstrap3ModalFramework.prototype._createCardinalConfigurationOptions = function(setupOptions) {
                    var options = SongbirdFramework.prototype._createCardinalConfigurationOptions.call(this, setupOptions);
                    options.payment.framework = "bootstrap3";
                    return options;
                };
                module1.exports = Bootstrap3ModalFramework;
            },
            {
                "./songbird": 216
            }
        ],
        212: [
            function(_dereq_, module1, exports) {
                "use strict";
                var SongbirdFramework = _dereq_("./songbird");
                function CardinalModalFramework(options) {
                    SongbirdFramework.call(this, options);
                }
                CardinalModalFramework.prototype = Object.create(SongbirdFramework.prototype, {
                    constructor: SongbirdFramework
                });
                CardinalModalFramework.prototype._createV1IframeModalElement = function(iframe) {
                    var modal = document.createElement("div");
                    var addCloseButton = Boolean(this._createOptions && this._createOptions.cardinalSDKConfig && this._createOptions.cardinalSDKConfig.payment && this._createOptions.cardinalSDKConfig.payment.displayExitButton);
                    modal.innerHTML = '<div style="position: fixed;z-index: 999999;top: 50%;left: 50%;padding: 24px 20px;transform: translate(-50%,-50%);border-radius: 2px;background: #fff;max-width: 100%;overflow: auto;"><div><button data-braintree-v1-fallback-close-button style="font-family: Helvetica,Arial,sans-serif;font-size: 25px;line-height: 12px;position: absolute;top: 2px;right: 0px;cursor: pointer;color: #999;border: 0;outline: none;background: none;" onMouseOver="this.style.color=\'#000\'" onMouseOut="this.style.color=\'#999\'">\xd7</button></div><div data-braintree-v1-fallback-iframe-container style="height: 400px;"></div></div><div data-braintree-v1-fallback-backdrop style="position: fixed;z-index: 999998;cursor: pointer;top: 0;left: 0;width: 100%;height: 100%;transition: opacity 1ms ease;background: rgba(0,0,0,.6);"></div>';
                    if (!addCloseButton) modal.querySelector("[data-braintree-v1-fallback-close-button]").style.display = "none";
                    modal.querySelector("[data-braintree-v1-fallback-iframe-container]").appendChild(iframe);
                    return modal;
                };
                module1.exports = CardinalModalFramework;
            },
            {
                "./songbird": 216
            }
        ],
        213: [
            function(_dereq_, module1, exports) {
                "use strict";
                var LegacyFramework = _dereq_("./legacy");
                var CardinalModalFramework = _dereq_("./cardinal-modal");
                var Bootstrap3ModalFramework = _dereq_("./bootstrap3-modal");
                var InlineIframeFramework = _dereq_("./inline-iframe");
                module1.exports = {
                    legacy: LegacyFramework,
                    "cardinal-modal": CardinalModalFramework,
                    "bootstrap3-modal": Bootstrap3ModalFramework,
                    "inline-iframe": InlineIframeFramework
                };
            },
            {
                "./bootstrap3-modal": 211,
                "./cardinal-modal": 212,
                "./inline-iframe": 214,
                "./legacy": 215
            }
        ],
        214: [
            function(_dereq_, module1, exports) {
                "use strict";
                var SongbirdFramework = _dereq_("./songbird");
                var BraintreeError = _dereq_("../../../lib/braintree-error");
                var errors = _dereq_("../../shared/errors");
                var enumerate = _dereq_("../../../lib/enumerate");
                function InlineIframeFramework(options) {
                    SongbirdFramework.call(this, options);
                }
                InlineIframeFramework.prototype = Object.create(SongbirdFramework.prototype, {
                    constructor: SongbirdFramework
                });
                InlineIframeFramework.events = enumerate([
                    "AUTHENTICATION_IFRAME_AVAILABLE"
                ], "inline-iframe-framework:");
                InlineIframeFramework.prototype.setUpEventListeners = function(reply) {
                    SongbirdFramework.prototype.setUpEventListeners.call(this, reply);
                    this.on(InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE, function(payload, next) {
                        reply("authentication-iframe-available", payload, next);
                    });
                };
                InlineIframeFramework.prototype._createCardinalConfigurationOptions = function(setupOptions) {
                    var options = SongbirdFramework.prototype._createCardinalConfigurationOptions.call(this, setupOptions);
                    options.payment.framework = "inline";
                    return options;
                };
                InlineIframeFramework.prototype._addV1IframeToPage = function() {
                    this._emit(InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE, {
                        element: this._v1Modal
                    }, function() {
                    // NOOP
                    });
                };
                InlineIframeFramework.prototype._setupFrameworkSpecificListeners = function() {
                    this.setCardinalListener("ui.inline.setup", this._onInlineSetup.bind(this));
                };
                InlineIframeFramework.prototype._onInlineSetup = function(htmlTemplate, details, resolve, reject) {
                    var container, hasError;
                    if (!htmlTemplate || !details) hasError = true;
                    else if (details.paymentType !== "CCA") hasError = true;
                    else if (!(details.data.mode === "suppress" || details.data.mode === "static")) hasError = true;
                    if (hasError) {
                        reject(new BraintreeError(errors.THREEDS_INLINE_IFRAME_DETAILS_INCORRECT));
                        return;
                    }
                    container = document.createElement("div");
                    container.innerHTML = htmlTemplate;
                    if (details.data.mode === "suppress") {
                        container.style.display = "none";
                        document.body.appendChild(container);
                        resolve();
                    } else if (details.data.mode === "static") this._emit(InlineIframeFramework.events.AUTHENTICATION_IFRAME_AVAILABLE, {
                        element: container
                    }, function() {
                        resolve();
                    });
                };
                module1.exports = InlineIframeFramework;
            },
            {
                "../../../lib/braintree-error": 143,
                "../../../lib/enumerate": 153,
                "../../shared/errors": 220,
                "./songbird": 216
            }
        ],
        215: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BaseFramework = _dereq_("./base");
                var deferred = _dereq_("../../../lib/deferred");
                function LegacyFramework(options) {
                    BaseFramework.call(this, options);
                }
                LegacyFramework.prototype = Object.create(BaseFramework.prototype, {
                    constructor: LegacyFramework
                });
                LegacyFramework.prototype.setUpEventListeners = function() {
                // noop
                };
                LegacyFramework.prototype.transformV1CustomerBillingAddress = function(customer) {
                    customer.billingAddress.line1 = customer.billingAddress.streetAddress;
                    customer.billingAddress.line2 = customer.billingAddress.extendedAddress;
                    customer.billingAddress.city = customer.billingAddress.locality;
                    customer.billingAddress.state = customer.billingAddress.region;
                    customer.billingAddress.countryCode = customer.billingAddress.countryCodeAlpha2;
                    delete customer.billingAddress.streetAddress;
                    delete customer.billingAddress.extendedAddress;
                    delete customer.billingAddress.locality;
                    delete customer.billingAddress.region;
                    delete customer.billingAddress.countryCodeAlpha2;
                    return customer;
                };
                LegacyFramework.prototype._createIframe = function(options) {
                    var self1 = this;
                    this._setupV1Elements({
                        nonce: options.nonce,
                        lookupResponse: options.lookupResponse,
                        showLoader: options.showLoader,
                        handleAuthResponse: function handleAuthResponse(data) {
                            self1._handleAuthResponse(data, options);
                        }
                    });
                    return this._v1Iframe;
                };
                LegacyFramework.prototype._handleAuthResponse = function(data, options) {
                    this._v1Bus.teardown();
                    options.removeFrame();
                    // This also has to be in a setTimeout so it executes after the `removeFrame`.
                    deferred((function() {
                        this._handleV1AuthResponse(data);
                    }).bind(this))();
                };
                LegacyFramework.prototype._checkForFrameworkSpecificVerifyCardErrors = function(options) {
                    var errorOption;
                    if (typeof options.addFrame !== "function") errorOption = "an addFrame function";
                    else if (typeof options.removeFrame !== "function") errorOption = "a removeFrame function";
                    return errorOption;
                };
                LegacyFramework.prototype._formatVerifyCardOptions = function(options) {
                    var modifiedOptions = BaseFramework.prototype._formatVerifyCardOptions.call(this, options);
                    modifiedOptions.addFrame = deferred(options.addFrame);
                    modifiedOptions.removeFrame = deferred(options.removeFrame);
                    modifiedOptions.showLoader = options.showLoader !== false;
                    return modifiedOptions;
                };
                LegacyFramework.prototype._formatLookupData = function(options) {
                    var self1 = this;
                    return BaseFramework.prototype._formatLookupData.call(this, options).then(function(data) {
                        if (options.customer && options.customer.billingAddress) data.customer = self1.transformV1CustomerBillingAddress(options.customer);
                        return data;
                    });
                };
                LegacyFramework.prototype._presentChallenge = function(lookupResponse, options) {
                    options.addFrame(null, this._createIframe({
                        showLoader: options.showLoader,
                        lookupResponse: lookupResponse.lookup,
                        nonce: lookupResponse.paymentMethod.nonce,
                        removeFrame: options.removeFrame
                    }));
                };
                module1.exports = LegacyFramework;
            },
            {
                "../../../lib/deferred": 151,
                "./base": 210
            }
        ],
        216: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BaseFramework = _dereq_("./base");
                var assign = _dereq_("../../../lib/assign").assign;
                var deferred = _dereq_("../../../lib/deferred");
                var BraintreeError = _dereq_("../../../lib/braintree-error");
                var convertToBraintreeError = _dereq_("../../../lib/convert-to-braintree-error");
                var analytics = _dereq_("../../../lib/analytics");
                var assets = _dereq_("../../../lib/assets");
                var errors = _dereq_("../../shared/errors");
                var enumerate = _dereq_("../../../lib/enumerate");
                var constants = _dereq_("../../shared/constants");
                var ExtendedPromise = _dereq_("@braintree/extended-promise");
                var INTEGRATION_TIMEOUT_MS = _dereq_("../../../lib/constants").INTEGRATION_TIMEOUT_MS;
                var PLATFORM = _dereq_("../../../lib/constants").PLATFORM;
                var VERSION = "3.110.0";
                var CUSTOMER_CANCELED_SONGBIRD_MODAL = "01";
                var SONGBIRD_UI_EVENTS = [
                    "ui.close",
                    "ui.render",
                    // TODO these events are not documented in the
                    // client reference because so far we have
                    // not been able to trigger them in our testing
                    "ui.renderHidden",
                    "ui.loading.close",
                    "ui.loading.render"
                ];
                var SCA_EXEMPTION_TYPES = [
                    "low_value",
                    "transaction_risk_analysis"
                ];
                ExtendedPromise.suppressUnhandledPromiseMessage = true;
                function SongbirdFramework(options) {
                    BaseFramework.call(this, options);
                    this._songbirdInitFailed = false;
                    this._clientMetadata = {
                        requestedThreeDSecureVersion: "2",
                        sdkVersion: PLATFORM + "/" + VERSION
                    };
                    this.originalSetupOptions = options;
                    this._getDfReferenceIdPromisePlus = new ExtendedPromise();
                    this.setupSongbird(options);
                    this._cardinalEvents = [];
                }
                SongbirdFramework.prototype = Object.create(BaseFramework.prototype, {
                    constructor: SongbirdFramework
                });
                SongbirdFramework.events = enumerate([
                    "LOOKUP_COMPLETE",
                    "CUSTOMER_CANCELED",
                    "UI.CLOSE",
                    "UI.RENDER",
                    "UI.RENDERHIDDEN",
                    "UI.LOADING.CLOSE",
                    "UI.LOADING.RENDER"
                ], "songbird-framework:");
                SongbirdFramework.prototype.setUpEventListeners = function(reply) {
                    this.on(SongbirdFramework.events.LOOKUP_COMPLETE, function(data, next) {
                        reply("lookup-complete", data, next);
                    });
                    this.on(SongbirdFramework.events.CUSTOMER_CANCELED, function() {
                        reply("customer-canceled");
                    });
                    this.on(SongbirdFramework.events["UI.CLOSE"], function() {
                        reply("authentication-modal-close");
                    });
                    this.on(SongbirdFramework.events["UI.RENDER"], function() {
                        reply("authentication-modal-render");
                    });
                    this.on(SongbirdFramework.events["UI.RENDERHIDDEN"], function() {
                        reply("authentication-modal-render-hidden");
                    });
                    this.on(SongbirdFramework.events["UI.LOADING.CLOSE"], function() {
                        reply("authentication-modal-loader-close");
                    });
                    this.on(SongbirdFramework.events["UI.LOADING.RENDER"], function() {
                        reply("authentication-modal-loader-render");
                    });
                };
                SongbirdFramework.prototype.prepareLookup = function(options) {
                    var data = assign({}, options);
                    var self1 = this;
                    return this.getDfReferenceId().then(function(id) {
                        data.dfReferenceId = id;
                    }).then(function() {
                        return self1._triggerCardinalBinProcess(options.bin);
                    })["catch"](function() {
                    // catch and ignore errors from looking up
                    // df reference and Cardinal bin process
                    }).then(function() {
                        return self1._waitForClient();
                    }).then(function() {
                        data.clientMetadata = self1._clientMetadata;
                        data.authorizationFingerprint = self1._client.getConfiguration().authorizationFingerprint;
                        data.braintreeLibraryVersion = "braintree/web/" + VERSION;
                        return data;
                    });
                };
                SongbirdFramework.prototype.initializeChallengeWithLookupResponse = function(lookupResponse, options) {
                    return this.setupSongbird().then((function() {
                        return BaseFramework.prototype.initializeChallengeWithLookupResponse.call(this, lookupResponse, options);
                    }).bind(this));
                };
                SongbirdFramework.prototype.handleSongbirdError = function(errorType) {
                    this._songbirdInitFailed = true;
                    this._removeSongbirdListeners();
                    analytics.sendEvent(this._createPromise, "three-d-secure.cardinal-sdk.songbird-error." + errorType);
                    if (this._songbirdPromise) this._songbirdPromise.resolve();
                };
                SongbirdFramework.prototype._triggerCardinalBinProcess = function(bin) {
                    var self1 = this;
                    var issuerStartTime = Date.now();
                    return window.Cardinal.trigger("bin.process", bin).then(function(binResults) {
                        self1._clientMetadata.issuerDeviceDataCollectionTimeElapsed = Date.now() - issuerStartTime;
                        self1._clientMetadata.issuerDeviceDataCollectionResult = binResults && binResults.Status;
                    });
                };
                SongbirdFramework.prototype.transformBillingAddress = function(additionalInformation, billingAddress) {
                    if (billingAddress) {
                        // map from public API to the API that the Gateway expects
                        extractAddressData(billingAddress, additionalInformation, "billing");
                        additionalInformation.billingPhoneNumber = billingAddress.phoneNumber;
                        additionalInformation.billingGivenName = billingAddress.givenName;
                        additionalInformation.billingSurname = billingAddress.surname;
                    }
                    return additionalInformation;
                };
                SongbirdFramework.prototype.transformShippingAddress = function(additionalInformation) {
                    var shippingAddress = additionalInformation.shippingAddress;
                    if (shippingAddress) {
                        // map from public API to the API that the Gateway expects
                        extractAddressData(shippingAddress, additionalInformation, "shipping");
                        delete additionalInformation.shippingAddress;
                    }
                    return additionalInformation;
                };
                SongbirdFramework.prototype._createV1IframeModalElement = function(iframe) {
                    var modal = document.createElement("div");
                    modal.innerHTML = '<div data-braintree-v1-fallback-iframe-container="true" style="height: 400px;"></div>';
                    modal.querySelector('[data-braintree-v1-fallback-iframe-container="true"]').appendChild(iframe);
                    return modal;
                };
                SongbirdFramework.prototype._createV1IframeModal = function(iframe) {
                    var modal = this._createV1IframeModalElement(iframe);
                    var btn = modal.querySelector("[data-braintree-v1-fallback-close-button]");
                    var backdrop = modal.querySelector("[data-braintree-v1-fallback-backdrop]");
                    var self1 = this;
                    function closeHandler() {
                        modal.parentNode.removeChild(modal);
                        self1.cancelVerifyCard(errors.THREEDS_CARDINAL_SDK_CANCELED);
                        document.removeEventListener("keyup", self1._onV1Keyup);
                        self1._onV1Keyup = null;
                    }
                    this._onV1Keyup = function(e) {
                        if (e.key !== "Escape") return;
                        if (!modal.parentNode) // modal not on page
                        return;
                        closeHandler();
                    };
                    if (btn) btn.addEventListener("click", closeHandler);
                    if (backdrop) backdrop.addEventListener("click", closeHandler);
                    document.addEventListener("keyup", this._onV1Keyup);
                    return modal;
                };
                SongbirdFramework.prototype._addV1IframeToPage = function() {
                    document.body.appendChild(this._v1Modal);
                };
                SongbirdFramework.prototype.setupSongbird = function(setupOptions) {
                    var self1 = this;
                    var startTime = Date.now();
                    if (this._songbirdPromise) return this._songbirdPromise;
                    setupOptions = setupOptions || {};
                    this._songbirdPromise = new ExtendedPromise();
                    this._v2SetupFailureReason = "reason-unknown";
                    self1._loadCardinalScript(setupOptions).then(function() {
                        if (!window.Cardinal) {
                            self1._v2SetupFailureReason = "cardinal-global-unavailable";
                            return Promise.reject(new BraintreeError(errors.THREEDS_CARDINAL_SDK_SETUP_FAILED));
                        }
                        return self1._configureCardinalSdk({
                            setupOptions: setupOptions,
                            setupStartTime: startTime
                        });
                    })["catch"](function(err) {
                        var error = convertToBraintreeError(err, {
                            type: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.type,
                            code: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.code,
                            message: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.message
                        });
                        self1._getDfReferenceIdPromisePlus.reject(error);
                        window.clearTimeout(self1._songbirdSetupTimeoutReference);
                        analytics.sendEvent(self1._client, "three-d-secure.cardinal-sdk.init.setup-failed");
                        self1.handleSongbirdError("cardinal-sdk-setup-failed." + self1._v2SetupFailureReason);
                    });
                    return this._songbirdPromise;
                };
                SongbirdFramework.prototype._configureCardinalSdk = function(config) {
                    var self1 = this;
                    return this._waitForClient().then(function() {
                        var threeDSConfig = self1._client.getConfiguration().gatewayConfiguration.threeDSecure;
                        return threeDSConfig;
                    }).then(function(threeDSConfig) {
                        var jwt = threeDSConfig.cardinalAuthenticationJWT;
                        var setupOptions = config.setupOptions;
                        var setupStartTime = config.setupStartTime;
                        var cardinalConfiguration = self1._createCardinalConfigurationOptions(setupOptions);
                        SONGBIRD_UI_EVENTS.forEach(function(eventName) {
                            self1.setCardinalListener(eventName, function() {
                                self1._emit(SongbirdFramework.events[eventName.toUpperCase()]);
                            });
                        });
                        self1.setCardinalListener("payments.setupComplete", self1._createPaymentsSetupCompleteCallback());
                        self1._setupFrameworkSpecificListeners();
                        window.Cardinal.configure(cardinalConfiguration);
                        window.Cardinal.setup("init", {
                            jwt: jwt
                        });
                        self1._clientMetadata.cardinalDeviceDataCollectionTimeElapsed = Date.now() - setupStartTime;
                        self1.setCardinalListener("payments.validated", self1._createPaymentsValidatedCallback());
                    })["catch"](function(err) {
                        self1._v2SetupFailureReason = "cardinal-configuration-threw-error";
                        return Promise.reject(err);
                    });
                };
                SongbirdFramework.prototype.setCardinalListener = function(eventName, cb) {
                    this._cardinalEvents.push(eventName);
                    window.Cardinal.on(eventName, cb);
                };
                SongbirdFramework.prototype._setupFrameworkSpecificListeners = function() {
                // noop
                };
                SongbirdFramework.prototype._createCardinalConfigurationOptions = function(setupOptions) {
                    var cardinalConfiguration = setupOptions.cardinalSDKConfig || {};
                    var paymentSettings = cardinalConfiguration.payment || {};
                    if (!cardinalConfiguration.logging && setupOptions.loggingEnabled) cardinalConfiguration.logging = {
                        level: "verbose"
                    };
                    cardinalConfiguration.payment = {};
                    if (paymentSettings.hasOwnProperty("displayLoading")) cardinalConfiguration.payment.displayLoading = paymentSettings.displayLoading;
                    if (paymentSettings.hasOwnProperty("displayExitButton")) cardinalConfiguration.payment.displayExitButton = paymentSettings.displayExitButton;
                    return cardinalConfiguration;
                };
                SongbirdFramework.prototype._loadCardinalScript = function(setupOptions) {
                    var self1 = this;
                    return this._waitForClient().then(function() {
                        var scriptSource = self1._getCardinalScriptSource();
                        self1._songbirdSetupTimeoutReference = window.setTimeout(function() {
                            analytics.sendEvent(self1._client, "three-d-secure.cardinal-sdk.init.setup-timeout");
                            self1.handleSongbirdError("cardinal-sdk-setup-timeout");
                        }, setupOptions.timeout || INTEGRATION_TIMEOUT_MS);
                        return assets.loadScript({
                            src: scriptSource
                        });
                    })["catch"](function(err) {
                        self1._v2SetupFailureReason = "songbird-js-failed-to-load";
                        return Promise.reject(convertToBraintreeError(err, errors.THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED));
                    });
                };
                SongbirdFramework.prototype._getCardinalScriptSource = function() {
                    var gatewayConfig = this._client.getConfiguration().gatewayConfiguration;
                    if (gatewayConfig && gatewayConfig.environment === "production") return constants.CARDINAL_SCRIPT_SOURCE.production;
                    return constants.CARDINAL_SCRIPT_SOURCE.sandbox;
                };
                SongbirdFramework.prototype._createPaymentsSetupCompleteCallback = function() {
                    var self1 = this;
                    return function(data) {
                        self1._getDfReferenceIdPromisePlus.resolve(data.sessionId);
                        window.clearTimeout(self1._songbirdSetupTimeoutReference);
                        analytics.sendEvent(self1._createPromise, "three-d-secure.cardinal-sdk.init.setup-completed");
                        self1._songbirdPromise.resolve();
                    };
                };
                SongbirdFramework.prototype.getDfReferenceId = function() {
                    return this._getDfReferenceIdPromisePlus;
                };
                SongbirdFramework.prototype._performJWTValidation = function(rawCardinalSDKVerificationData, jwt) {
                    var self1 = this;
                    var nonce = this._lookupPaymentMethod.nonce;
                    var url = "payment_methods/" + nonce + "/three_d_secure/authenticate_from_jwt";
                    var cancelCode = rawCardinalSDKVerificationData && rawCardinalSDKVerificationData.Payment && rawCardinalSDKVerificationData.Payment.ExtendedData && rawCardinalSDKVerificationData.Payment.ExtendedData.ChallengeCancel;
                    if (cancelCode) {
                        // see ChallengeCancel docs here for different values:
                        // https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects
                        analytics.sendEvent(this._createPromise, "three-d-secure.verification-flow.cardinal-sdk.cancel-code." + cancelCode);
                        if (cancelCode === CUSTOMER_CANCELED_SONGBIRD_MODAL) this._emit(SongbirdFramework.events.CUSTOMER_CANCELED);
                    }
                    analytics.sendEvent(this._createPromise, "three-d-secure.verification-flow.upgrade-payment-method.started");
                    return this._waitForClient().then(function() {
                        return self1._client.request({
                            method: "post",
                            endpoint: url,
                            data: {
                                jwt: jwt,
                                paymentMethodNonce: nonce
                            }
                        });
                    }).then(function(response) {
                        var paymentMethod = response.paymentMethod || self1._lookupPaymentMethod;
                        var formattedResponse = self1._formatAuthResponse(paymentMethod, response.threeDSecureInfo);
                        formattedResponse.rawCardinalSDKVerificationData = rawCardinalSDKVerificationData;
                        analytics.sendEvent(self1._client, "three-d-secure.verification-flow.upgrade-payment-method.succeeded");
                        return Promise.resolve(formattedResponse);
                    })["catch"](function(err) {
                        var error = new BraintreeError({
                            type: errors.THREEDS_JWT_AUTHENTICATION_FAILED.type,
                            code: errors.THREEDS_JWT_AUTHENTICATION_FAILED.code,
                            message: errors.THREEDS_JWT_AUTHENTICATION_FAILED.message,
                            details: {
                                originalError: err
                            }
                        });
                        analytics.sendEvent(self1._client, "three-d-secure.verification-flow.upgrade-payment-method.errored");
                        return Promise.reject(error);
                    });
                };
                SongbirdFramework.prototype._createPaymentsValidatedCallback = function() {
                    var self1 = this;
                    /**
   * @param {object} data Response Data
   * @see {@link https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects#ResponseObjects-ObjectDefinition}
   * @param {string} data.ActionCode The resulting state of the transaction.
   * @param {boolean} data.Validated Represents whether transaction was successfully or not.
   * @param {object} data.Payment Represents additional information about the verification.
   * @param {number} data.ErrorNumber A non-zero value represents the error encountered while attempting the process the message request.
   * @param {string} data.ErrorDescription Application error description for the associated error number.
   * @param {string} validatedJwt Response JWT
   * @returns {void}
   * */ return function(data, validatedJwt) {
                        var formattedError;
                        analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.cardinal-sdk.action-code." + data.ActionCode.toLowerCase());
                        if (!self1._verifyCardPromisePlus) {
                            self1.handleSongbirdError("cardinal-sdk-setup-error.number-" + data.ErrorNumber);
                            return;
                        }
                        switch(data.ActionCode){
                            // Handle these scenarios based on liability shift information in the response.
                            case "SUCCESS":
                            case "NOACTION":
                            case "FAILURE":
                                self1._performJWTValidation(data, validatedJwt).then(function(result) {
                                    self1._verifyCardPromisePlus.resolve(result);
                                })["catch"](function(err) {
                                    self1._verifyCardPromisePlus.reject(err);
                                });
                                break;
                            case "ERROR":
                                analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.cardinal-sdk-error." + data.ErrorNumber);
                                switch(data.ErrorNumber){
                                    case 10001:
                                    case 10002:
                                        formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT);
                                        break;
                                    case 10003:
                                    case 10007:
                                    case 10009:
                                        formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT);
                                        break;
                                    case 10005:
                                    case 10006:
                                        formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_BAD_CONFIG);
                                        break;
                                    case 10008:
                                    case 10010:
                                        formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_BAD_JWT);
                                        break;
                                    case 10011:
                                        // This may never get called, according to the Cardinal docs:
                                        // The user has canceled the transaction. This is generally found in alternative
                                        // payments that supply a cancel button on the payment brand side.
                                        analytics.sendEvent(self1._createPromise, "three-d-secure.verification-flow.canceled");
                                        formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_CANCELED);
                                        break;
                                    default:
                                        formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_ERROR);
                                }
                                formattedError.details = {
                                    originalError: {
                                        code: data.ErrorNumber,
                                        description: data.ErrorDescription
                                    }
                                };
                                self1._verifyCardPromisePlus.reject(formattedError);
                                break;
                            default:
                        }
                    };
                };
                SongbirdFramework.prototype._checkForVerifyCardError = function(options, privateOptions) {
                    if (!options.bin) return new BraintreeError({
                        type: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.type,
                        code: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.code,
                        message: "verifyCard options must include a BIN."
                    });
                    return BaseFramework.prototype._checkForVerifyCardError.call(this, options, privateOptions);
                };
                SongbirdFramework.prototype._checkForFrameworkSpecificVerifyCardErrors = function(options, privateOptions) {
                    var errorOption;
                    if (typeof options.onLookupComplete !== "function" && !privateOptions.ignoreOnLookupCompleteRequirement) errorOption = "an onLookupComplete function";
                    return errorOption;
                };
                SongbirdFramework.prototype._formatVerifyCardOptions = function(options) {
                    var modifiedOptions = BaseFramework.prototype._formatVerifyCardOptions.call(this, options);
                    var additionalInformation = modifiedOptions.additionalInformation || {};
                    additionalInformation = this.transformBillingAddress(additionalInformation, options.billingAddress);
                    additionalInformation = this.transformShippingAddress(additionalInformation);
                    if (options.onLookupComplete) modifiedOptions.onLookupComplete = deferred(options.onLookupComplete);
                    if (options.email) additionalInformation.email = options.email;
                    if (options.mobilePhoneNumber) additionalInformation.mobilePhoneNumber = options.mobilePhoneNumber;
                    modifiedOptions.additionalInformation = additionalInformation;
                    return modifiedOptions;
                };
                SongbirdFramework.prototype._onLookupComplete = function(lookupResponse, options) {
                    var self1 = this;
                    return BaseFramework.prototype._onLookupComplete.call(this, lookupResponse).then(function(response) {
                        return new Promise(function(resolve, reject) {
                            // NEXT_MAJOR_VERSION format this response object to look like the mobile sdk response
                            // which is basically the lookup param at the top level with some additional accessors
                            response.requiresUserAuthentication = Boolean(response.lookup && response.lookup.acsUrl);
                            function next() {
                                resolve(response);
                            }
                            self1._verifyCardPromisePlus["catch"](reject);
                            // If both event and callback are mistakenly used together,
                            // prefer the callback when it is passed into the verifyCard options
                            if (options.onLookupComplete) options.onLookupComplete(response, next);
                            else self1._emit(SongbirdFramework.events.LOOKUP_COMPLETE, response, next);
                        });
                    });
                };
                SongbirdFramework.prototype._presentChallenge = function(lookupResponse) {
                    // transactionId is required for the Songbird flow, so if it
                    // does not exist, we just return
                    if (this._songbirdInitFailed || !lookupResponse.lookup.transactionId) return;
                    // set up listener for ref id to call out to bt before calling verify callback
                    window.Cardinal["continue"]("cca", {
                        AcsUrl: lookupResponse.lookup.acsUrl,
                        Payload: lookupResponse.lookup.pareq
                    }, {
                        OrderDetails: {
                            TransactionId: lookupResponse.lookup.transactionId
                        }
                    });
                };
                SongbirdFramework.prototype._formatLookupData = function(options) {
                    var self1 = this;
                    return BaseFramework.prototype._formatLookupData.call(this, options).then(function(data) {
                        data.additionalInfo = options.additionalInformation;
                        if (options.accountType) data.accountType = options.accountType;
                        if (options.challengeRequested) data.challengeRequested = options.challengeRequested;
                        if (options.requestedExemptionType) {
                            if (!SCA_EXEMPTION_TYPES.includes(options.requestedExemptionType)) throw new BraintreeError({
                                code: errors.THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID.code,
                                type: errors.THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID.type,
                                message: "requestedExemptionType `" + options.requestedExemptionType + "` is not a valid exemption. The accepted values are: `" + SCA_EXEMPTION_TYPES.join("`, `") + "`"
                            });
                            data.requestedExemptionType = options.requestedExemptionType;
                        }
                        if (options.customFields) data.customFields = options.customFields;
                        if (options.dataOnlyRequested) data.dataOnlyRequested = options.dataOnlyRequested;
                        if (options.exemptionRequested) data.exemptionRequested = options.exemptionRequested;
                        if (options.requestVisaDAF) data.requestVisaDAF = options.requestVisaDAF;
                        if (options.bin) data.bin = options.bin;
                        // NEXT_MAJOR_VERSION remove cardAdd in favor of cardAddChallengeRequested
                        if (options.cardAdd != null) data.cardAdd = options.cardAdd;
                        if (options.cardAddChallengeRequested != null) data.cardAdd = options.cardAddChallengeRequested;
                        if (options.merchantName) data.merchantName = options.merchantName;
                        return self1.prepareLookup(data);
                    });
                };
                SongbirdFramework.prototype.cancelVerifyCard = function(verifyCardError) {
                    var self1 = this;
                    return BaseFramework.prototype.cancelVerifyCard.call(this).then(function(response) {
                        if (self1._verifyCardPromisePlus) {
                            verifyCardError = verifyCardError || new BraintreeError(errors.THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT);
                            self1._verifyCardPromisePlus.reject(verifyCardError);
                        }
                        return response;
                    });
                };
                SongbirdFramework.prototype._removeSongbirdListeners = function() {
                    this._cardinalEvents.forEach(function(eventName) {
                        window.Cardinal.off(eventName);
                    });
                    this._cardinalEvents = [];
                };
                SongbirdFramework.prototype.teardown = function() {
                    if (window.Cardinal) this._removeSongbirdListeners();
                    // we intentionally do not remove the Cardinal SDK
                    // from the page when tearing down. Subsequent
                    // component creations will be faster because
                    // the asset is already on the page
                    return BaseFramework.prototype.teardown.call(this);
                };
                SongbirdFramework.prototype._reloadThreeDSecure = function() {
                    var self1 = this;
                    var startTime = Date.now();
                    return self1.teardown().then(function() {
                        self1._configureCardinalSdk({
                            setupOptions: self1.originalSetupOptions,
                            setupStartTime: startTime
                        });
                    });
                };
                function extractAddressData(source, target, prefix) {
                    target[prefix + "Line1"] = source.streetAddress;
                    target[prefix + "Line2"] = source.extendedAddress;
                    target[prefix + "Line3"] = source.line3;
                    target[prefix + "City"] = source.locality;
                    target[prefix + "State"] = source.region;
                    target[prefix + "PostalCode"] = source.postalCode;
                    target[prefix + "CountryCode"] = source.countryCodeAlpha2;
                }
                module1.exports = SongbirdFramework;
            },
            {
                "../../../lib/analytics": 138,
                "../../../lib/assets": 139,
                "../../../lib/assign": 140,
                "../../../lib/braintree-error": 143,
                "../../../lib/constants": 145,
                "../../../lib/convert-to-braintree-error": 147,
                "../../../lib/deferred": 151,
                "../../../lib/enumerate": 153,
                "../../shared/constants": 219,
                "../../shared/errors": 220,
                "./base": 210,
                "@braintree/extended-promise": 31
            }
        ],
        217: [
            function(_dereq_, module1, exports) {
                "use strict";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var methods = _dereq_("../../lib/methods");
                var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
                var EventEmitter = _dereq_("@braintree/event-emitter");
                var FRAMEWORKS = _dereq_("./frameworks");
                /**
 * @deprecated
 * @callback ThreeDSecure~addFrameCallback
 * @param {?BraintreeError} [err] `null` or `undefined` if there was no error.
 * @param {HTMLIFrameElement} iframe An iframe element containing the bank's authentication page that you must put on your page.
 * @description **Deprecated** The callback used for options.addFrame in 3DS 1.0's {@link ThreeDSecure#verifyCard|verifyCard}.
 * @returns {void}
 */ /**
 * @deprecated
 * @callback ThreeDSecure~removeFrameCallback
 * @description **Deprecated** The callback used for options.removeFrame in 3DS 1.0's {@link ThreeDSecure#verifyCard|verifyCard}.
 * @returns {void}
 */ /**
 * @deprecated
 * @typedef {object} ThreeDSecure~verifyCardCustomerObject
 * @property {string} [customer.mobilePhoneNumber] The mobile phone number used for verification. Only numbers; remove dashes, parenthesis and other characters.
 * @property {string} [customer.email] The email used for verification.
 * @property {string} [customer.shippingMethod] The 2-digit string indicating the shipping method chosen for the transaction.
 * @property {string} [customer.billingAddress.firstName] The first name associated with the address.
 * @property {string} [customer.billingAddress.lastName] The last name associated with the address.
 * @property {string} [customer.billingAddress.streetAddress] Line 1 of the Address (eg. number, street, etc).
 * @property {string} [customer.billingAddress.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.).
 * @property {string} [customer.billingAddress.locality] The locality (city) name associated with the address.
 * @property {string} [customer.billingAddress.region] The 2 letter code for US states or an ISO-3166-2 country subdivision code of up to three letters.
 * @property {string} [customer.billingAddress.postalCode] The zip code or equivalent for countries that have them.
 * @property {string} [customer.billingAddress.countryCodeAlpha2] The 2 character country code.
 * @property {string} [customer.billingAddress.phoneNumber] The phone number associated with the address. Only numbers; remove dashes, parenthesis and other characters.
 * @description **Deprecated** Optional customer information to be passed to 3DS 1.0 for verification.
 */ /**
 * @typedef {object} ThreeDSecure~verifyPayload
 * @property {string} nonce The new payment method nonce produced by the 3D Secure lookup. The original nonce passed into {@link ThreeDSecure#verifyCard|verifyCard} was consumed. This new nonce should be used to transact on your server.
 * @property {string} type The payment method type.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 * @property {boolean} liabilityShiftPossible *Deprecated:* Use `threeDSecureInfo.liabilityShiftPossible` instead.
 * @property {boolean} liabilityShifted *Deprecated:* Use `threeDSecureInfo.liabilityShifted` instead.
 * @property {object} threeDSecureInfo 3DS information about the card. Note: This information should be verified on the server by using the [payment method nonce find method](https://developer.paypal.com/braintree/docs/reference/request/payment-method-nonce/find). The values provided here are merely for convenience. Only values looked up on the server should determine the logic about how to process a transaction.
 * @property {string} threeDSecureInfo.acsTransactionId The transaction identifier from the issuing bank.
 * @property {string} threeDSecureInfo.cavv Cardholder authentication verification value or CAVV. The main encrypted message issuers and card networks use to verify authentication has occurred. Mastercard uses an AVV message and American Express uses an AEVV message, each of which should also be passed in the cavv parameter.
 * @property {string} threeDSecureInfo.dsTransactionId Transaction identifier resulting from 3D Secure 2 authentication.
 * @property {string} threeDSecureInfo.eciFlag The value of the electronic commerce indicator (ECI) flag, which indicates the outcome of the 3DS authentication. This will be a two-digit value.
 * @property {boolean} threeDSecureInfo.enrolled Indicates the status of 3D Secure authentication eligibility with the card issuer.
 * @property {boolean} threeDSecureInfo.liabilityShifted Indicates whether the liability for fraud has been shifted away from the merchant.
 * @property {boolean} threeDSecureInfo.liabilityShiftPossible Indicates whether liability shift is still possible on a retry.
 * @property {string} threeDSecureInfo.paresStatus Transaction status result identifier.
 * @property {string} threeDSecureInfo.status Indicates the outcome of the 3D Secure event.
 * @property {string} threeDSecureInfo.threeDSecureAuthenticationId ID of the 3D Secure authentication performed for this transaction. Do not provide this field as a transaction sale parameter if you are using the returned payment method nonce from the payload.
 * @property {string} threeDSecureInfo.threeDSecureServerTransactionId Transaction identifier provided by the issuing bank who recieved the 3D Secure event.
 * @property {string} threeDSecureInfo.threeDSecureVersion The version of 3D Secure authentication used for the transaction.
 * @property {string} threeDSecureInfo.xid Transaction identifier resulting from 3D Secure authentication. Uniquely identifies the transaction and sometimes required in the authorization message. This is a base64-encoded value. This field will no longer be used in 3D Secure 2 authentications for Visa and Mastercard, however it will be supported by American Express.
 * @property {string} threeDSecureInfo.lookup.transStatus Error code returned from the 3D Secure MPI provider.
 * @property {string} threeDSecureInfo.lookup.transStatusReason Description correlating to the transStatus error code.
 * @property {string} threeDSecureInfo.authentication.transStatus Error code returned from the 3D Secure MPI provider.
 * @property {string} threeDSecureInfo.authentication.transStatusReason Description correlating to the transStatus error code.
 * @property {object} rawCardinalSDKVerificationData The response back from the Cardinal SDK after verification has completed. See [Cardinal's Documentation](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects) for more information. If the customer was not required to do a 3D Secure challenge, this object will not be available.
 */ /**
 * @typedef {string} ThreeDSecure~prepareLookupPayload The client data to pass on when doing a server side lookup call.
 */ /**
 * @typedef {object} ThreeDSecure~verificationData
 * @property {boolean} requiresUserAuthentication When `true`, the user will be presented with a 3D Secure challenge when calling `next` in the {@link ThreeDSecure#event:lookup-complete|`lookup-complete` event}.
 * @property {object} threeDSecureInfo Contains liability shift details.
 * @property {boolean} threeDSecureInfo.liabilityShiftPossible Indicates whether the card was eligible for 3D Secure.
 * @property {boolean} threeDSecureInfo.liabilityShifted Indicates whether the liability for fraud has been shifted away from the merchant.
 * @property {object} paymentMethod A {@link ThreeDSecure~verifyPayload|verifyPayload} object.
 * @property {object} lookup Details about the 3D Secure lookup.
 * @property {string} lookup.threeDSecureVersion The version of 3D Secure that will be used for the 3D Secure challenge.
 */ /**
 * @typedef {object} ThreeDSecure~billingAddress
 * @property {string} [givenName] The first name associated with the billing address. (maximum length 50, ASCII characters)
 * @property {string} [surname] The last name associated with the billing address. (maximum length 50, ASCII characters)
 * @property {string} [phoneNumber] The phone number associated with the billing address. Only numbers; remove dashes, parenthesis and other characters.
 * @property {string} [streetAddress] Line 1 of the billing address (eg. number, street, etc). (maximum length 50)
 * @property {string} [extendedAddress] Line 2 of the billing address (eg. suite, apt #, etc.). (maximum length 50)
 * @property {string} [line3] Line 3 of the billing address if needed (eg. suite, apt #, etc). (maximum length 50)
 * @property {string} [locality] The locality (city) name associated with the billing address.
 * @property {string} [region] This field expects an ISO3166-2 subdivision code. The subdivision code is what follows the hyphen separator in the full ISO 3166-2 code. For example, the state of Ohio in the United States we expect "OH" as opposed to the full ISO 3166-2 code "US-OH".
 * @property {string} [postalCode] The zip code or equivalent for countries that have them.
 * @property {string} [countryCodeAlpha2] The 2 character country code.
 */ /**
 * @typedef {object} ThreeDSecure~additionalInformation
 * @property {string} [workPhoneNumber] The work phone number used for verification. Only numbers; remove dashes, parenthesis and other characters. (maximum length 25)
 * @property {string} [shippingGivenName] The first name associated with the shipping address. (maximum length 50, ASCII characters)
 * @property {string} [shippingSurname] The last name associated with the shipping address. (maximum length 50, ASCII characters)
 * @property {object} [shippingAddress]
 * @property {string} [shippingAddress.streetAddress] Line 1 of the shipping address (eg. number, street, etc). (maximum length 50)
 * @property {string} [shippingAddress.extendedAddress] Line 2 of the shipping address (eg. suite, apt #, etc.). (maximum length 50)
 * @property {string} [shippingAddress.line3] Line 3 of the shipping address if needed (eg. suite, apt #, etc). (maximum length 50)
 * @property {string} [shippingAddress.locality] The locality (city) name associated with the shipping address. (maximum length 50)
 * @property {string} [shippingAddress.region] This field expects an ISO3166-2 subdivision code. The subdivision code is what follows the hyphen separator in the full ISO 3166-2 code. For example, the state of Ohio in the United States we expect "OH" as opposed to the full ISO 3166-2 code "US-OH".
 * @property {string} [shippingAddress.postalCode] The zip code or equivalent for countries that have them. (maximum length 10)
 * @property {string} [shippingAddress.countryCodeAlpha2] The 2 character country code. (maximum length 2)
 * @property {string} [shippingPhone] The phone number associated with the shipping address. Only numbers; remove dashes, parenthesis and other characters. (maximum length 20)
 * @property {string} [shippingMethod] The 2-digit string indicating the name of the shipping method chosen for the transaction. (maximum length 50) Possible values:
 * - `01` Same Day
 * - `02` Overnight / Expedited
 * - `03` Priority (2-3 Days)
 * - `04` Ground
 * - `05` Electronic Delivery
 * - `06` Ship to Store
 * @property {string} [shippingMethodIndicator] The 2-digit string indicating the shipping method chosen for the transaction Possible values.
 * - `01` Ship to cardholder billing address
 * - `02` Ship to another verified address on file with merchant
 * - `03` Ship to address that is different from billing address
 * - `04` Ship to store (store address should be populated on request)
 * - `05` Digital goods
 * - `06` Travel and event tickets, not shipped
 * - `07` Other
 * @property {string} [productCode] The 3-letter string representing the merchant product code. Possible values:
 * - `AIR` Airline
 * - `GEN` General Retail
 * - `DIG` Digital Goods
 * - `SVC` Services
 * - `RES` Restaurant
 * - `TRA` Travel
 * - `DSP` Cash Dispensing
 * - `REN` Car Rental
 * - `GAS` Fuel
 * - `LUX` Luxury Retail
 * - `ACC` Accommodation Retail
 * - `TBD` Other
 * @property {string} [deliveryTimeframe] The 2-digit number indicating the delivery time frame. Possible values:
 * - `01` Electronic delivery
 * - `02` Same day shipping
 * - `03` Overnight shipping
 * - `04` Two or more day shipping
 * @property {string} [deliveryEmail] For electronic delivery, email address to which the merchandise was delivered. (maximum length 254)
 * @property {string} [reorderindicator] The 2-digit number indicating whether the cardholder is reordering previously purchased merchandise. possible values:
 * - `01` First time ordered
 * - `02` Reordered
 * @property {string} [preorderIndicator] The 2-digit number indicating whether cardholder is placing an order with a future availability or release date. possible values:
 * - `01` Merchandise available
 * - `02` Future availability
 * @property {string} [preorderDate] The 8-digit number (format: YYYYMMDD) indicating expected date that a pre-ordered purchase will be available.
 * @property {string} [giftCardAmount] The purchase amount total for prepaid gift cards in major units. (maximum length 15)
 * @property {string} [giftCardCurrencyCode] ISO 4217 currency code for the gift card purchased. (maximum length 3)
 * @property {string} [giftCardCount] Total count of individual prepaid gift cards purchased. (maximum length 2)
 * @property {string} [accountAgeIndicator] The 2-digit value representing the length of time cardholder has had account. Possible values:
 * - `01` No Account
 * - `02` Created during transaction
 * - `03` Less than 30 days
 * - `04` 30-60 days
 * - `05` More than 60 days
 * @property {string} [accountCreateDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder opened the account.
 * @property {string} [accountChangeIndicator] The 2-digit value representing the length of time since the last change to the cardholder account. This includes shipping address, new payment account or new user added. Possible values:
 * - `01` Changed during transaction
 * - `02` Less than 30 days
 * - `03` 30-60 days
 * - `04` More than 60 days
 * @property {string} [accountChangeDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder's account was last changed. This includes changes to the billing or shipping address, new payment accounts or new users added.
 * @property {string} [accountPwdChangeIndicator] The 2-digit value representing the length of time since the cardholder changed or reset the password on the account. Possible values:
 * - `01` No change
 * - `02` Changed during transaction
 * - `03` Less than 30 days
 * - `04` 30-60 days
 * - `05` More than 60 days
 * @property {string} [accountPwdChangeDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder last changed or reset password on account.
 * @property {string} [shippingAddressUsageIndicator] The 2-digit value indicating when the shipping address used for transaction was first used. Possible values:
 * - `01` This transaction
 * - `02` Less than 30 days
 * - `03` 30-60 days
 * - `04` More than 60 days
 * @property {string} [shippingAddressUsageDate] The 8-digit number (format: YYYYMMDD) indicating the date when the shipping address used for this transaction was first used.
 * @property {string} [transactionCountDay] Number of transactions (successful or abandoned) for this cardholder account within the last 24 hours. (maximum length 3)
 * @property {string} [transactionCountYear] Number of transactions (successful or abandoned) for this cardholder account within the last year. (maximum length 3)
 * @property {string} [addCardAttempts] Number of add card attempts in the last 24 hours. (maximum length 3)
 * @property {string} [accountPurchases] Number of purchases with this cardholder account during the previous six months.
 * @property {string} [fraudActivity] The 2-digit value indicating whether the merchant experienced suspicious activity (including previous fraud) on the account. Possible values:
 * - `01` No suspicious activity
 * - `02` Suspicious activity observed
 * @property {string} [shippingNameIndicator] The 2-digit value indicating if the cardholder name on the account is identical to the shipping name used for the transaction. Possible values:
 * - `01` Account and shipping name identical
 * - `02` Account and shipping name differ
 * @property {string} [paymentAccountIndicator] The 2-digit value indicating the length of time that the payment account was enrolled in the merchant account. Possible values:
 * - `01` No account (guest checkout)
 * - `02` During the transaction
 * - `03` Less than 30 days
 * - `04` 30-60 days
 * - `05` More than 60 days
 * @property {string} [paymentAccountAge] The 8-digit number (format: YYYYMMDD) indicating the date the payment account was added to the cardholder account.
 * @property {string} [acsWindowSize] The 2-digit number to set the challenge window size to display to the end cardholder.  The ACS will reply with content that is formatted appropriately to this window size to allow for the best user experience.  The sizes are width x height in pixels of the window displayed in the cardholder browser window. Possible values:
 * - `01` 250x400
 * - `02` 390x400
 * - `03` 500x600
 * - `04` 600x400
 * - `05` Full page
 * @property {string} [sdkMaxTimeout] The 2-digit number of minutes (minimum 05) to set the maximum amount of time for all 3DS 2.0 messages to be communicated between all components.
 * @property {string} [addressMatch] The 1-character value (Y/N) indicating whether cardholder billing and shipping addresses match.
 * @property {string} [accountId] Additional cardholder account information. (maximum length 64)
 * @property {string} [ipAddress] The IP address of the consumer. IPv4 and IPv6 are supported.
 * - only one IP address supported
 * - only numbers, letters, period '.' chars, or colons ':' are acceptable
 * @property {string} [orderDescription] Brief description of items purchased. (maximum length 256)
 * @property {string} [taxAmount] Unformatted tax amount without any decimalization (ie. $123.67 = 12367). (maximum length 20)
 * @property {string} [userAgent] The exact content of the HTTP user agent header. (maximum length 500)
 * @property {string} [authenticationIndicator] The 2-digit number indicating the type of authentication request. Possible values:
 *  - `01` Payment
 *  - `02` Recurring transaction
 *  - `03` Installment
 *  - `04` Add card
 *  - `05` Maintain card
 *  - `06` Cardholder verification as part of EMV token ID&V
 *  - `08` Split Shipment
 *  - `09` Delayed Shipment
 *  - `85` Payment with multiple merchants
 * @property {string} [installment] An integer value greater than 1 indicating the maximum number of permitted authorizations for installment payments. (maximum length 3)
 * @property {string} [purchaseDate] The 14-digit number (format: YYYYMMDDHHMMSS) indicating the date in UTC of original purchase.
 * @property {string} [recurringEnd] The 8-digit number (format: YYYYMMDD) indicating the date after which no further recurring authorizations should be performed.
 * @property {string} [recurringFrequency] Integer value indicating the minimum number of days between recurring authorizations. A frequency of monthly is indicated by the value 28. Multiple of 28 days will be used to indicate months (ex. 6 months = 168). (maximum length 3)
 */ /**
 * @name ThreeDSecure#on
 * @function
 * @param {string} event The name of the event to which you are subscribing.
 * @param {function} handler A callback to handle the event.
 * @description Subscribes a handler function to a named event. The following events are available:
 *   * {@link ThreeDSecure#event:lookup-complete|lookup-complete}
 *   * {@link ThreeDSecure#event:customer-canceled|customer-canceled}
 *   * {@link ThreeDSecure#event:authentication-iframe-available|authentication-iframe-available}
 *   * {@link ThreeDSecure#event:authentication-modal-render|authentication-modal-render}
 *   * {@link ThreeDSecure#event:authentication-modal-close|authentication-modal-close}
 * @example
 * <caption>Listening to a 3D Secure event</caption>
 * braintree.threeDSecure.create({ ... }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('lookup-complete', function (data, next) {
 *     console.log('data from the lookup', data);
 *     next();
 *   });
 *   threeDSecureInstance.on('customer-canceled', function () {
 *     console.log('log that the customer canceled');
 *   });
 * });
 * @returns {void}
 */ /**
 * @name ThreeDSecure#off
 * @function
 * @param {string} event The name of the event to which you are unsubscribing.
 * @param {function} handler The callback for the event you are unsubscribing from.
 * @description Unsubscribes the handler function to a named event.
 * @example
 * <caption>Subscribing and then unsubscribing from a 3D Secure eld event</caption>
 * braintree.threeDSecure.create({ ... }, function (createErr, threeDSecureInstance) {
 *   var lookupCallback = function (data, next) {
 *     console.log(data);
 *     next();
 *   };
 *   var cancelCallback = function () {
 *     // log the cancelation
 *     // or update UI
 *   };
 *
 *   threeDSecureInstance.on('lookup-complete', lookupCallback);
 *   threeDSecureInstance.on('customer-canceled', cancelCallback);
 *
 *   // later on
 *   threeDSecureInstance.off('lookup-complete', lookupCallback);
 *   threeDSecureInstance.off('customer-canceled', cancelCallback);
 * });
 * @returns {void}
 */ /**
 * This event is emitted when the `2-inline-iframe` version is specified when creating the 3D Secure instance and the authentication iframe becomes available.
 * @event ThreeDSecure#authentication-iframe-available
 * @example
 * <caption>Listening for the authentication iframe to be available</caption>
 *   threeDSecureInstance.on('authentication-iframe-available', function (event, next) {
 *     document.body.appendChild(event.element); // add iframe element to page
 *
 *     next(); // let the SDK know the iframe is ready
 *   });
 * });
 */ /**
 * This event is emitted when using the 3D Secure 2.0 flow and the initial lookup request completes. If this is not used, a `onLookupComplete` callback must be passed into the `verifyCard` method.
 * @event ThreeDSecure#lookup-complete
 * @example
 * <caption>Listening for when the lookup request is complete</caption>
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('lookup-complete', function (data, next) {
 *     // inspect the data
 *
 *     // call next when ready to proceed with the challenge
 *     next();
 *   });
 * });
 */ /**
 * This event is emitted when using the 3D Secure 2.0 flow and the customer cancels the 3D Secure challenge.
 * @event ThreeDSecure#customer-canceled
 * @example
 * <caption>Listening for when the customer cancels the 3D Secure challenge</caption>
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('customer-canceled', function () {
 *     // the customer canceled the 3D Secure challenge
 *   });
 * });
 */ /**
 * This event is emitted when using the 3D Secure 2.0 flow and the authentication modal closes, either because the authentication was completed or because the customer canceled the process.
 * @event ThreeDSecure#authentication-modal-close
 * @example
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('authentication-modal-close', function () {
 *     // the modal was closed
 *   });
 * });
 */ /**
 * This event is emitted when using the 3D Secure 2.0 flow and the authentication modal is rendered.
 * @event ThreeDSecure#authentication-modal-render
 * @example
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createErr, threeDSecureInstance) {
 *   threeDSecureInstance.on('authentication-modal-render', function () {
 *     // the modal was rendered, presenting the authentication form to the customer
 *   });
 * });
 */ /**
 * @class
 * @param {object} options 3D Secure {@link module:braintree-web/three-d-secure.create create} options
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/three-d-secure.create|braintree.threeDSecure.create} instead.</strong>
 * @classdesc This class represents a ThreeDSecure component produced by {@link module:braintree-web/three-d-secure.create|braintree.threeDSecure.create}. Instances of this class have a method for launching a 3D Secure authentication flow.
 *
 * If you use the Braintree SDK from within an iframe, you must not use the `sandbox` attribute on your iframe or the 3D Secure modal will not function correctly.
 *
 * **Note**: 3D Secure 2.0 is documented below and will become the default integration method in a future version of Braintree-web. Until then, version 1.0 will continue to be supported. To view 3D Secure 1.0 documentation, look at Braintree-web documentation from version [3.40.0](https://braintree.github.io/braintree-web/3.40.0/ThreeDSecure.html) and earlier, or upgrade your integration by referring to the [3D Secure 2.0 adoption guide](https://developer.paypal.com/braintree/docs/guides/3d-secure/migration/javascript/v3).
 */ function ThreeDSecure(options) {
                    var self1 = this;
                    var Framework = FRAMEWORKS[options.framework];
                    EventEmitter.call(this);
                    this._framework = new Framework(options);
                    this._framework.setUpEventListeners(function() {
                        self1._emit.apply(self1, arguments);
                    });
                }
                EventEmitter.createChild(ThreeDSecure);
                // NEXT_MAJOR_VERSION remove exemptionRequested entirely in favor of `requestedExemptionType`
                /**
 * Launch the 3D Secure login flow, returning a nonce payload.
 *
 * @public
 * @param {object} options Options for card verification.
 * @param {string} options.nonce The nonce representing the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.nonce`.
 * @param {string} options.bin The numeric Bank Identification Number (bin) of the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.details.bin`.
 * @param {string} options.amount The amount of the transaction in the current merchant account's currency. This must be expressed in numbers with an optional decimal (using `.`) and precision up to the hundredths place. For example, if you're processing a transaction for 1.234,56 € then `amount` should be `1234.56`.
 * @param {string} [options.accountType] The account type for the card (if known). Accepted values: `credit` or `debit`.
 * @param {boolean} [options.cardAddChallengeRequested] If set to `true`, a card-add challenge will be requested from the issuer. If set to `false`, a card-add challenge will not be requested. If the param is missing, a card-add challenge will only be requested for $0 amount. An authentication created using this flag should only be used for vaulting operations (creation of customers' credit cards or payment methods) and not for creating transactions.
 * @param {boolean} [options.cardAdd] *Deprecated:* Use `cardAddChallengeRequested` instead.
 * @param {boolean} [options.challengeRequested] If set to true, an authentication challenge will be forced if possible.
 * @param {boolean} [options.dataOnlyRequested] Indicates whether to use the data only flow. In this flow, frictionless 3DS is ensured for Mastercard cardholders as the card scheme provides a risk score for the issuer to determine whether to approve. If data only is not supported by the processor, a validation error will be raised. Non-Mastercard cardholders will fallback to a normal 3DS flow.
 * @param {boolean} [options.exemptionRequested] *Deprecated:* Use `requestedExemptionType` instead.
 * @param {boolean} [options.requestVisaDAF] Request to use VISA Digital Authentication Framework. If set to true, a Visa DAF authenticated payment credential will be created and/or used for authentication if the merchant is eligible.
 * @param {string} [options.merchantName] Allows to override the merchant name that is shown in the challenge.
 * @param {string} [options.requestedExemptionType] If an exemption is requested and the exemption's conditions are satisfied, then it will be applied. The following supported exemptions are defined as per PSD2 regulation: `low_value`, `transaction_risk_analysis`
 * @param {object} [options.customFields] Object where each key is the name of a custom field which has been configured in the Control Panel. In the Control Panel you can configure 3D Secure Rules which trigger on certain values.
 * @param {function} [options.onLookupComplete] *Deprecated:* Use {@link ThreeDSecure#event:lookup-complete|`threeDSecureInstance.on('lookup-complete')`} instead. Function to execute when lookup completes. The first argument, `data`, is a {@link ThreeDSecure~verificationData|verificationData} object, and the second argument, `next`, is a callback. `next` must be called to continue.
 * @param {string} [options.email] The email used for verification. (maximum length 255)
 * @param {string} [options.mobilePhoneNumber] The mobile phone number used for verification. Only numbers; remove dashes, parenthesis and other characters. (maximum length 25)
 * @param {object} [options.billingAddress] An {@link ThreeDSecure~billingAddress|billingAddress} object for verification.
 * @param {object} [options.additionalInformation] An {@link ThreeDSecure~additionalInformation|additionalInformation} object for verification.
 * @param {object} [options.collectDeviceData] If set to `true`, device data such as browser screen dimensions, language and time zone is submitted with lookup data.
 * @param {object} [options.customer] **Deprecated** Customer information for use in 3DS 1.0 verifications. Can contain any subset of a {@link ThreeDSecure~verifyCardCustomerObject|verifyCardCustomerObject}. Only to be used for 3DS 1.0 integrations.
 * @param {callback} options.addFrame **Deprecated** This {@link ThreeDSecure~addFrameCallback|addFrameCallback} will be called when the bank frame needs to be added to your page. Only to be used for 3DS 1.0 integrations.
 * @param {callback} options.removeFrame **Deprecated** For use in 3DS 1.0 Flows. This {@link ThreeDSecure~removeFrameCallback|removeFrameCallback} will be called when the bank frame needs to be removed from your page. Only to be used in 3DS 1.0 integrations.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ThreeDSecure~verifyPayload|verifyPayload}. If no callback is provided, it will return a promise that resolves {@link ThreeDSecure~verifyPayload|verifyPayload}.

 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * <caption>Verifying a payment method nonce with 3DS 2.0</caption>
 * var my3DSContainer;
 *
 * // set up listener after initialization
 * threeDSecure.on(('lookup-complete', function (data, next) {
 *   // use `data` here, then call `next()`
 *   next();
 * });
 *
 * // call verifyCard after tokenizing a card
 * threeDSecure.verifyCard({
 *   amount: '123.45',
 *   nonce: hostedFieldsTokenizationPayload.nonce,
 *   bin: hostedFieldsTokenizationPayload.details.bin,
 *   email: 'test@example.com'
 *   billingAddress: {
 *     givenName: 'Jill',
 *     surname: 'Doe',
 *     phoneNumber: '8101234567',
 *     streetAddress: '555 Smith St.',
 *     extendedAddress: '#5',
 *     locality: 'Oakland',
 *     region: 'CA',
 *     postalCode: '12345',
 *     countryCodeAlpha2: 'US'
 *   },
 *   additionalInformation: {
 *     workPhoneNumber: '5555555555',
 *     shippingGivenName: 'Jill',
 *     shippingSurname: 'Doe',
 *     shippingAddress: {
 *       streetAddress: '555 Smith st',
 *       extendedAddress: '#5',
 *       locality: 'Oakland',
 *       region: 'CA',
 *       postalCode: '12345',
 *       countryCodeAlpha2: 'US'
 *     }
 *     shippingPhone: '8101234567'
 *   }
 * }, function (err, payload) {
 *   if (err) {
 *     console.error(err);
 *     return;
 *   }
 *
 *   if (payload.liabilityShifted) {
 *     // Liability has shifted
 *     submitNonceToServer(payload.nonce);
 *   } else if (payload.liabilityShiftPossible) {
 *     // Liability may still be shifted
 *     // Decide if you want to submit the nonce
 *   } else {
 *     // Liability has not shifted and will not shift
 *     // Decide if you want to submit the nonce
 *   }
 * });
 * @example
 * <caption>Verifying a payment method nonce with 3DS 2.0 with onLookupComplete callback</caption>
 * var my3DSContainer;
 *
 * threeDSecure.verifyCard({
 *   amount: '123.45',
 *   nonce: hostedFieldsTokenizationPayload.nonce,
 *   bin: hostedFieldsTokenizationPayload.details.bin,
 *   email: 'test@example.com'
 *   billingAddress: {
 *     givenName: 'Jill',
 *     surname: 'Doe',
 *     phoneNumber: '8101234567',
 *     streetAddress: '555 Smith St.',
 *     extendedAddress: '#5',
 *     locality: 'Oakland',
 *     region: 'CA',
 *     postalCode: '12345',
 *     countryCodeAlpha2: 'US'
 *   },
 *   additionalInformation: {
 *     workPhoneNumber: '5555555555',
 *     shippingGivenName: 'Jill',
 *     shippingSurname: 'Doe',
 *     shippingAddress: {
 *       streetAddress: '555 Smith st',
 *       extendedAddress: '#5',
 *       locality: 'Oakland',
 *       region: 'CA',
 *       postalCode: '12345',
 *       countryCodeAlpha2: 'US'
 *     }
 *     shippingPhone: '8101234567'
 *   },
 *   onLookupComplete: function (data, next) {
 *     // use `data` here, then call `next()`
 *     next();
 *   }
 * }, function (err, payload) {
 *   if (err) {
 *     console.error(err);
 *     return;
 *   }
 *
 *   if (payload.liabilityShifted) {
 *     // Liability has shifted
 *     submitNonceToServer(payload.nonce);
 *   } else if (payload.liabilityShiftPossible) {
 *     // Liability may still be shifted
 *     // Decide if you want to submit the nonce
 *   } else {
 *     // Liability has not shifted and will not shift
 *     // Decide if you want to submit the nonce
 *   }
 * });
 * @example
 * <caption>Handling 3DS lookup errors</caption>
 * var my3DSContainer;
 *
 * // set up listener after initialization
 * threeDSecure.on(('lookup-complete', function (data, next) {
 *   // use `data` here, then call `next()`
 *   next();
 * });
 *
 * // call verifyCard after tokenizing a card
 * threeDSecure.verifyCard({
 *   amount: '123.45',
 *   nonce: hostedFieldsTokenizationPayload.nonce,
 *   bin: hostedFieldsTokenizationPayload.details.bin,
 *   email: 'test@example.com',
 *   billingAddress: billingAddressFromCustomer,
 *   additionalInformation: additionalInfoFromCustomer
 * }, function (err, payload) {
 *   if (err) {
 *     if (err.code.indexOf('THREEDS_LOOKUP') === 0) {
 *       // an error occurred during the initial lookup request
 *
 *       if (err.code === 'THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR') {
 *         // either the passed payment method nonce does not exist
 *         // or it was already consumed before the lookup call was made
 *       } else if (err.code.indexOf('THREEDS_LOOKUP_VALIDATION') === 0) {
 *         // a validation error occurred
 *         // likely some non-ascii characters were included in the billing
 *         // address given name or surname fields, or the cardholdername field
 *
 *         // Instruct your user to check their data and try again
 *       } else {
 *         // an unknown lookup error occurred
 *       }
 *     } else {
 *       // some other kind of error
 *     }
 *     return;
 *   }
 *
 *   // handle success
 * });
 */ ThreeDSecure.prototype.verifyCard = function(options) {
                    var privateOptions;
                    if (this.hasListener("lookup-complete")) privateOptions = {
                        ignoreOnLookupCompleteRequirement: true
                    };
                    return this._framework.verifyCard(options, privateOptions);
                };
                /* eslint-disable-next-line valid-jsdoc */ /**
 * Launch the iframe challenge using a 3D Secure lookup response from a server side lookup.
 *
 * @public
 * @param {(object|string)} lookupResponse The lookup response from the server side call to lookup the 3D Secure information. The raw string or a parsed object can be passed.
 * @returns {Promise} Returns a promise.
 * @example
 * var my3DSContainer;
 *
 * threeDSecure.initializeChallengeWithLookupResponse(lookupResponseFromServer).then(function (payload) {
 *   if (payload.liabilityShifted) {
 *     // Liability has shifted
 *     submitNonceToServer(payload.nonce);
 *   } else if (payload.liabilityShiftPossible) {
 *     // Liability may still be shifted
 *     // Decide if you want to submit the nonce
 *   } else {
 *     // Liability has not shifted and will not shift
 *     // Decide if you want to submit the nonce
 *   }
 * });
 */ ThreeDSecure.prototype.initializeChallengeWithLookupResponse = function(lookupResponse) {
                    if (typeof lookupResponse === "string") lookupResponse = JSON.parse(lookupResponse);
                    return this._framework.initializeChallengeWithLookupResponse(lookupResponse);
                };
                /**
 * Gather the data needed for a 3D Secure lookup call.
 *
 * @public
 * @param {object} options Options for 3D Secure lookup.
 * @param {string} options.nonce The nonce representing the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.nonce`.
 * @param {string} options.bin The numeric Bank Identification Number (bin) of the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.details.bin`.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ThreeDSecure~prepareLookupPayload|prepareLookupPayload}. If no callback is provided, it will return a promise that resolves {@link ThreeDSecure~prepareLookupPayload|prepareLookupPayload}.

 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * <caption>Preparing data for a 3D Secure lookup</caption>
 * threeDSecure.prepareLookup({
 *   nonce: hostedFieldsTokenizationPayload.nonce,
 *   bin: hostedFieldsTokenizationPayload.details.bin
 * }, function (err, payload) {
 *   if (err) {
 *     console.error(err);
 *     return;
 *   }
 *
 *   // send payload to server to do server side lookup
 * });
 */ ThreeDSecure.prototype.prepareLookup = function(options) {
                    return this._framework.prepareLookup(options).then(function(data) {
                        return JSON.stringify(data);
                    });
                };
                /**
 * Cancel the 3DS flow and return the verification payload if available. If using 3D Secure version 2, this will not close the UI of the authentication modal. It is recommended that this method only be used in the {@link ThreeDSecure#event:lookup-complete|`lookup-complete`} event or the `onLookupComplete` callback.
 * @public
 * @param {callback} [callback] The second argument is a {@link ThreeDSecure~verifyPayload|verifyPayload}. If there is no verifyPayload (the initial lookup did not complete), an error will be returned. If no callback is passed, `cancelVerifyCard` will return a promise.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example <caption>Cancel the verification in `lookup-complete` event</caption>
 * // set up listener after instantiation
 * threeDSecure.on('lookup-complete', function (data, next) {
 *   // determine if you want to call next to start the challenge,
 *   // if not, call cancelVerifyCard
 *   threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
 *     if (err) {
 *       // Handle error
 *       console.log(err.message); // No verification payload available
 *       return;
 *     }
 *
 *     verifyPayload.nonce; // The nonce returned from the 3ds lookup call
 *     verifyPayload.liabilityShifted; // boolean
 *     verifyPayload.liabilityShiftPossible; // boolean
 *   });
 * });
 *
 * // after tokenizing a credit card
 * threeDSecure.verifyCard({
 *   amount: '100.00',
 *   nonce: nonceFromTokenizationPayload,
 *   bin: binFromTokenizationPayload
 *   // other fields such as billing address
 * }, function (verifyError, payload) {
 *   if (verifyError) {
 *     if (verifyError.code === 'THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT ') {
 *       // flow was canceled by merchant, 3ds info can be found in the payload
 *       // for cancelVerifyCard
 *     }
 *   }
 * });
 * @example <caption>Cancel the verification in onLookupComplete callback</caption>
 * threeDSecure.verifyCard({
 *   amount: '100.00',
 *   nonce: nonceFromTokenizationPayload,
 *   bin: binFromTokenizationPayload,
 *   // other fields such as billing address
 *   onLookupComplete: function (data, next) {
 *     // determine if you want to call next to start the challenge,
 *     // if not, call cancelVerifyCard
 *     threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
 *       if (err) {
 *         // Handle error
 *         console.log(err.message); // No verification payload available
 *         return;
 *       }
 *
 *       verifyPayload.nonce; // The nonce returned from the 3ds lookup call
 *       verifyPayload.liabilityShifted; // boolean
 *       verifyPayload.liabilityShiftPossible; // boolean
 *     });
 *   }
 * }, function (verifyError, payload) {
 *   if (verifyError) {
 *     if (verifyError.code === 'THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT ') {
 *       // flow was canceled by merchant, 3ds info can be found in the payload
 *       // for cancelVerifyCard
 *     }
 *   }
 * });
 * @example <caption>Cancel the verification in 3D Secure version 1</caption>
 * // unlike with v2, this will not cause `verifyCard` to error, it will simply
 * // never call the callback
 * threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
 *   if (err) {
 *     // Handle error
 *     console.log(err.message); // No verification payload available
 *     return;
 *   }
 *
 *   verifyPayload.nonce; // The nonce returned from the 3ds lookup call
 *   verifyPayload.liabilityShifted; // boolean
 *   verifyPayload.liabilityShiftPossible; // boolean
 * });
 */ ThreeDSecure.prototype.cancelVerifyCard = function() {
                    return this._framework.cancelVerifyCard();
                };
                /**
 * Cleanly remove anything set up by {@link module:braintree-web/three-d-secure.create|create}, with the exception that the Cardinal SDK, on window.Cardinal, will remain.
 * @public
 * @param {callback} [callback] Called on completion. If no callback is passed, `teardown` will return a promise.
 * @example
 * threeDSecure.teardown();
 * @example <caption>With callback</caption>
 * threeDSecure.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ ThreeDSecure.prototype.teardown = function() {
                    var methodNames = methods(ThreeDSecure.prototype).concat(methods(EventEmitter.prototype));
                    convertMethodsToError(this, methodNames);
                    return this._framework.teardown();
                };
                module1.exports = wrapPromise.wrapPrototype(ThreeDSecure);
            },
            {
                "../../lib/convert-methods-to-error": 146,
                "../../lib/methods": 175,
                "./frameworks": 213,
                "@braintree/event-emitter": 30,
                "@braintree/wrap-promise": 40
            }
        ],
        218: [
            function(_dereq_, module1, exports) {
                "use strict";
                /** @module braintree-web/three-d-secure */ var ThreeDSecure = _dereq_("./external/three-d-secure");
                var isHTTPS = _dereq_("../lib/is-https").isHTTPS;
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var analytics = _dereq_("../lib/analytics");
                var errors = _dereq_("./shared/errors");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {object} [options.cardinalSDKConfig] A config for the underlying Cardinal SDK.
 * @param {object} [options.cardinalSDKConfig.logging] The logging configuration for the Cardinal SDK. See [Cardinal's documentation for the logging object](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-Logging) for more information.
 * @param {number} [options.cardinalSDKConfig.timeout] The time in milliseconds to wait before a request to Cardinal's API times out. See [Cardinal's documentation for root level configuration](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-RootLevelConfiguration) for more information.
 * @param {number} [options.cardinalSDKConfig.maxRequestRetries] How many times a request should be re-attempted to Cardinal's API before giving up as a failure. See [Cardinal's documentation for root level configuration](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-RootLevelConfiguration) for more information.
 * @param {object} [options.cardinalSDKConfig.payment] An object to describe how you want the user interactions to behave. Only a subset of the [Cardinal SDK payment configuration object](https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/1409568/Configurations#Configurations-Payment) are supported: `displayLoading` and `displayExitButton`.
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {(number|string)} [options.version=1] The version of 3D Secure to use. Possible options:
 * * 1 - The legacy 3D Secure v1.0 integration.
 * * 2 - A 3D Secure v2.0 integration that uses a modal to host the 3D Secure iframe.
 * * 2-bootstrap3-modal - A 3D Secure v2.0 integration that uses a modal styled with Bootstrap 3 styles to host the 3D Secure iframe. Requires having the Bootstrap 3 script files and stylesheets on your page.
 * * 2-inline-iframe - A 3D Secure v2.0 integration that provides the authentication iframe directly to the merchant.
 * @param {callback} [callback] The second argument, `data`, is the {@link ThreeDSecure} instance. If no callback is provided, it returns a promise that resolves the {@link ThreeDSecure} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
@example
 * <caption>Creating a v2 3D Secure component using 2 version (Cardinal modal)</caption>
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2'
 * }, function (createError, threeDSecure) {
 *   // set up lookup-complete listener
 *   threeDSecure.on('lookup-complete', function (data, next) {
 *     // check lookup data
 *
 *     next();
 *   });
 *
 *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
 *
 *   threeDSecure.verifyCard({
 *     nonce: nonceFromTokenizationPayload,,
 *     bin: binFromTokenizationPayload,
 *     amount: '100.00'
 *   }, function (verifyError, payload) {
 *     // inspect payload
 *     // send payload.nonce to your server
 *   });
 * });
 * @example
 * <caption>Creating a v2 3D Secure component using 2-bootstrap3-modal version</caption>
 * // must have the boostrap js, css and jquery files on your page
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2-bootstrap3-modal'
 * }, function (createError, threeDSecure) {
 *   // set up lookup-complete listener
 *   threeDSecure.on('lookup-complete', function (data, next) {
 *     // check lookup data
 *
 *     next();
 *   });
 *
 *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
 *
 *   // challenge will be presented in a bootstrap 3 modal
 *   threeDSecure.verifyCard({
 *     nonce: nonceFromTokenizationPayload,
 *     bin: binFromTokenizationPayload,
 *     amount: '100.00'
 *   }, function (verifyError, payload) {
 *     // inspect payload
 *     // send payload.nonce to your server
 *   });
 * });
 * @example
 * <caption>Creating a v2 3D Secure component using 2-inline-iframe version</caption>
 * braintree.threeDSecure.create({
 *   client: clientInstance,
 *   version: '2-inline-iframe'
 * }, function (createError, threeDSecure) {
 *   // set up lookup-complete listener
 *   threeDSecure.on('lookup-complete', function (data, next) {
 *     // check lookup data
 *
 *     next();
 *   });
 *   // set up iframe listener
 *   threeDSecure.on('authentication-iframe-available', function (event, next) {
 *     var element = event.element; // an html element that contains the iframe
 *
 *     document.body.appendChild(element); // put it on your page
 *
 *     next(); // let the sdk know the element has been added to the page
 *   });
 *
 *   // using Hosted Fields, use `tokenize` to get back a credit card nonce
 *
 *   threeDSecure.verifyCard({
 *     nonce: nonceFromTokenizationPayload,,
 *     bin: binFromTokenizationPayload,
 *     amount: '100.00'
 *   }, function (verifyError, payload) {
 *     // inspect payload
 *     // send payload.nonce to your server
 *   });
 * });
 */ function create(options) {
                    var name = "3D Secure";
                    var framework = getFramework(options);
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        var assetsUrl = createAssetsUrl.create(options.authorization);
                        var createPromise = createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: assetsUrl,
                            name: name
                        }).then(function(client) {
                            var error, isProduction;
                            var config = client.getConfiguration();
                            var gwConfig = config.gatewayConfiguration;
                            options.client = client;
                            if (!gwConfig.threeDSecureEnabled) error = errors.THREEDS_NOT_ENABLED;
                            if (config.authorizationType === "TOKENIZATION_KEY") error = errors.THREEDS_CAN_NOT_USE_TOKENIZATION_KEY;
                            isProduction = gwConfig.environment === "production";
                            if (isProduction && !isHTTPS()) error = errors.THREEDS_HTTPS_REQUIRED;
                            if (framework !== "legacy" && !(gwConfig.threeDSecure && gwConfig.threeDSecure.cardinalAuthenticationJWT)) {
                                analytics.sendEvent(options.client, "three-d-secure.initialization.failed.missing-cardinalAuthenticationJWT");
                                error = errors.THREEDS_NOT_ENABLED_FOR_V2;
                            }
                            if (error) return Promise.reject(new BraintreeError(error));
                            analytics.sendEvent(options.client, "three-d-secure.initialized");
                            return client;
                        });
                        var instance = new ThreeDSecure({
                            client: options.client,
                            assetsUrl: assetsUrl,
                            createPromise: createPromise,
                            loggingEnabled: options.loggingEnabled,
                            cardinalSDKConfig: options.cardinalSDKConfig,
                            framework: framework
                        });
                        if (options.client) return createPromise.then(function() {
                            return instance;
                        });
                        return instance;
                    });
                }
                function getFramework(options) {
                    var version = String(options.version || "");
                    if (!version || version === "1") throw new BraintreeError({
                        code: errors.THREEDS_UNSUPPORTED_VERSION.code,
                        type: errors.THREEDS_UNSUPPORTED_VERSION.type,
                        message: errors.THREEDS_UNSUPPORTED_VERSION.message
                    });
                    switch(version){
                        case "2":
                        case "2-cardinal-modal":
                            return "cardinal-modal";
                        case "2-bootstrap3-modal":
                            return "bootstrap3-modal";
                        case "2-inline-iframe":
                            return "inline-iframe";
                        default:
                            throw new BraintreeError({
                                code: errors.THREEDS_UNRECOGNIZED_VERSION.code,
                                type: errors.THREEDS_UNRECOGNIZED_VERSION.type,
                                message: "Version `" + options.version + "` is not a recognized version. You may need to update the version of your Braintree SDK to support this version."
                            });
                    }
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/analytics": 138,
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "../lib/is-https": 172,
                "./external/three-d-secure": 217,
                "./shared/errors": 220,
                "@braintree/wrap-promise": 40
            }
        ],
        219: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    LANDING_FRAME_NAME: "braintreethreedsecurelanding",
                    CARDINAL_SCRIPT_SOURCE: {
                        production: "https://songbird.cardinalcommerce.com/edge/v1/songbird.js",
                        sandbox: "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js"
                    }
                };
            },
            {}
        ],
        220: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.3D Secure - Creation Error Codes
 * @description Errors that occur when [creating the 3D Secure component](./module-braintree-web_three-d-secure.html#.create).
 * @property {MERCHANT} THREEDS_NOT_ENABLED Occurs when 3D Secure is not enabled in the Braintree control panel.
 * @property {MERCHANT} THREEDS_CAN_NOT_USE_TOKENIZATION_KEY Occurs when 3D Secure component is created without a Client Token.
 * @property {MERCHANT} THREEDS_HTTPS_REQUIRED Occurs when 3D Secure component is created in production over HTTPS.
 * @property {MERCHANT} THREEDS_NOT_ENABLED_FOR_V2 Occurs when 3D Secure component is created with version 2 parameter, but merchant is not enabled to use version 2.
 * @property {MERCHANT} THREEDS_UNRECOGNIZED_VERSION Occurs when unrecognized version enum is passed into the create call.
 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_SETUP_FAILED Occurs when Cardinal's Songbird.js library fails to setup for an unknown reason.
 * @property {NETWORK} THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED Occurs when using version 2 and Cardinal's Songbird.js script could not be loaded.
 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT Occurs when Cardinal's Songbird.js library takes longer than 60 seconds to set up.
 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT Occurs when Cardinal sends a response indicating a timeout on /Validate, /Confirm, or /Continue.
 * @property {MERCHANT} THREEDS_CARDINAL_SDK_BAD_CONFIG Occurs when there is no JWT in the request. Also when there's some other malformed aspect of config.
 * @property {MERCHANT} THREEDS_CARDINAL_SDK_BAD_JWT Occurs when a malformed config causes a either a missing response JWT or a malformed Cardinal response.
 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_ERROR Occurs when a "general error" or a Cardinal hosted fields error happens. Description contains more details.
 * @property {CUSTOMER} THREEDS_CARDINAL_SDK_CANCELED Occurs when customer cancels the transaction mid-flow, usually with alt-pays that have their own cancel buttons.
 * @property {MERCHANT} THREEDS_UNSUPPORTED_VERSION Occurs when 3D Secure component is created with version 1 (or default version) parameter.
 */ /**
 * @name BraintreeError.3D Secure - verifyCard Error Codes
 * @description Errors that occur when using the [`verifyCard` method](./ThreeDSecure.html#verifyCard).
 * @property {MERCHANT} THREEDS_AUTHENTICATION_IN_PROGRESS Occurs when another verification is already in progress.
 * @property {MERCHANT} THREEDS_MISSING_VERIFY_CARD_OPTION Occurs when a required option is missing.
 * @property {UNKNOWN} THREEDS_JWT_AUTHENTICATION_FAILED Occurs when something went wrong authenticating the JWT from the Cardinal SDK.
 * @property {MERCHANT} THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR Occurs when the supplied payment method nonce does not exist or the payment method nonce has already been consumed.
 * @property {CUSTOMER} THREEDS_LOOKUP_VALIDATION_ERROR Occurs when a validation error occurs during the 3D Secure lookup.
 * @property {UNKNOWN} THREEDS_LOOKUP_ERROR An unknown error occurred while attempting the 3D Secure lookup.
 * @property {MERCHANT} THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT Occurs when the 3D Secure flow is canceled by the merchant using `cancelVerifyCard` (3D Secure v2 flows only).
 * @property {UNKNOWN} THREEDS_INLINE_IFRAME_DETAILS_INCORRECT An unknown error occurred while attempting to use the inline iframe framework.
 * @property {MERCHANT} THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID Occurs when unrecognized exemption enum value is passed into verifyCard.
 */ /**
 * @name BraintreeError.3D Secure - cancelVerifyCard Error Codes
 * @description Errors that occur when using the [`cancelVerifyCard` method](./ThreeDSecure.html#cancelVerifyCard).
 * @property {MERCHANT} THREEDS_NO_VERIFICATION_PAYLOAD Occurs when the 3D Secure flow is canceled, but there is no 3D Secure information available.
 */ /**
 * @name BraintreeError.3D Secure - Internal Error Codes
 * @ignore
 * @description Errors that occur internally
 * @property {INTERNAL} THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN Occurs when iframe is initialized on a non-verified domain.
 * @property {INTERNAL} THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED Occurs when a 3D Secure framework method is not implemented.
 */ var BraintreeError = _dereq_("../../lib/braintree-error");
                module1.exports = {
                    THREEDS_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_NOT_ENABLED",
                        message: "3D Secure is not enabled for this merchant."
                    },
                    THREEDS_CAN_NOT_USE_TOKENIZATION_KEY: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_CAN_NOT_USE_TOKENIZATION_KEY",
                        message: "3D Secure can not use a tokenization key for authorization."
                    },
                    THREEDS_HTTPS_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_HTTPS_REQUIRED",
                        message: "3D Secure requires HTTPS."
                    },
                    THREEDS_NOT_ENABLED_FOR_V2: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_NOT_ENABLED_FOR_V2",
                        message: "3D Secure version 2 is not enabled for this merchant. Contact Braintree Support for assistance at https://help.braintreepayments.com/"
                    },
                    THREEDS_UNRECOGNIZED_VERSION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_UNRECOGNIZED_VERSION"
                    },
                    THREEDS_CARDINAL_SDK_SETUP_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "THREEDS_CARDINAL_SDK_SETUP_FAILED",
                        message: "Something went wrong setting up Cardinal's Songbird.js library."
                    },
                    THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED",
                        message: "Cardinal's Songbird.js library could not be loaded."
                    },
                    THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT",
                        message: "Cardinal's Songbird.js took too long to setup."
                    },
                    THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT",
                        message: "Cardinal's API took too long to respond."
                    },
                    THREEDS_CARDINAL_SDK_BAD_CONFIG: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_CARDINAL_SDK_BAD_CONFIG",
                        message: "JWT or other required field missing. Please check your setup configuration."
                    },
                    THREEDS_CARDINAL_SDK_BAD_JWT: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_CARDINAL_SDK_BAD_JWT",
                        message: "Cardinal JWT missing or malformed. Please check your setup configuration."
                    },
                    THREEDS_CARDINAL_SDK_ERROR: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "THREEDS_CARDINAL_SDK_ERROR",
                        message: "A general error has occurred with Cardinal. See description for more information."
                    },
                    THREEDS_CARDINAL_SDK_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "THREEDS_CARDINAL_SDK_CANCELED",
                        message: "Canceled by user."
                    },
                    THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_VERIFY_CARD_CANCELED_BY_MERCHANT",
                        message: "3D Secure verfication canceled by merchant."
                    },
                    THREEDS_AUTHENTICATION_IN_PROGRESS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_AUTHENTICATION_IN_PROGRESS",
                        message: "Cannot call verifyCard while existing authentication is in progress."
                    },
                    THREEDS_MISSING_VERIFY_CARD_OPTION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_MISSING_VERIFY_CARD_OPTION"
                    },
                    THREEDS_JWT_AUTHENTICATION_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "THREEDS_JWT_AUTHENTICATION_FAILED",
                        message: "Something went wrong authenticating the JWT from Cardinal"
                    },
                    THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR",
                        message: "Either the payment method nonce passed to `verifyCard` does not exist, or it was already consumed"
                    },
                    THREEDS_LOOKUP_VALIDATION_ERROR: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "THREEDS_LOOKUP_VALIDATION_ERROR",
                        message: "The data passed in `verifyCard` did not pass validation checks. See details for more info"
                    },
                    THREEDS_LOOKUP_ERROR: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "THREEDS_LOOKUP_ERROR",
                        message: "Something went wrong during the 3D Secure lookup"
                    },
                    THREEDS_INLINE_IFRAME_DETAILS_INCORRECT: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "THREEDS_INLINE_IFRAME_DETAILS_INCORRECT",
                        message: "Something went wrong when attempting to add the authentication iframe to the page."
                    },
                    THREEDS_NO_VERIFICATION_PAYLOAD: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_NO_VERIFICATION_PAYLOAD",
                        message: "No verification payload available."
                    },
                    THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN: {
                        type: BraintreeError.types.INTERNAL,
                        code: "THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN",
                        message: "Term Url must be on a Braintree domain."
                    },
                    THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED: {
                        type: BraintreeError.types.INTERNAL,
                        code: "THREEDS_FRAMEWORK_METHOD_NOT_IMPLEMENTED",
                        message: "Method not implemented for this framework."
                    },
                    THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_REQUESTED_EXEMPTION_TYPE_INVALID",
                        message: "Requested Exemption Type is invalid."
                    },
                    THREEDS_UNSUPPORTED_VERSION: {
                        type: BraintreeError.types.MERCHANT,
                        code: "THREEDS_UNSUPPORTED_VERSION",
                        message: "3D Secure `1` is deprecated and no longer supported. See available versions at https://braintree.github.io/braintree-web/current/module-braintree-web_three-d-secure.html#.create"
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        221: [
            function(_dereq_, module1, exports) {
                "use strict";
                var enumerate = _dereq_("../../lib/enumerate");
                module1.exports = enumerate([
                    "AUTHENTICATION_COMPLETE"
                ], "threedsecure:");
            },
            {
                "../../lib/enumerate": 153
            }
        ],
        222: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/unionpay
 * @description This module allows you to accept UnionPay payments. *It is currently in beta and is subject to change.*
 */ var UnionPay = _dereq_("./shared/unionpay");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var analytics = _dereq_("../lib/analytics");
                var errors = _dereq_("./shared/errors");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link UnionPay} instance. If no callback is provided, `create` returns a promise that resolves with the {@link UnionPay} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * braintree.unionpay.create({ client: clientInstance }, function (createErr, unionpayInstance) {
 *   if (createErr) {
 *     console.error(createErr);
 *     return;
 *   }
 *   // ...
 * });
 */ function create(options) {
                    var name = "UnionPay";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        var config = client.getConfiguration();
                        options.client = client;
                        if (!config.gatewayConfiguration.unionPay || config.gatewayConfiguration.unionPay.enabled !== true) return Promise.reject(new BraintreeError(errors.UNIONPAY_NOT_ENABLED));
                        analytics.sendEvent(options.client, "unionpay.initialized");
                        return new UnionPay(options);
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/analytics": 138,
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./shared/errors": 224,
                "./shared/unionpay": 225,
                "@braintree/wrap-promise": 40
            }
        ],
        223: [
            function(_dereq_, module1, exports) {
                "use strict";
                var enumerate = _dereq_("../../lib/enumerate");
                module1.exports = {
                    events: enumerate([
                        "HOSTED_FIELDS_FETCH_CAPABILITIES",
                        "HOSTED_FIELDS_ENROLL",
                        "HOSTED_FIELDS_TOKENIZE"
                    ], "union-pay:"),
                    HOSTED_FIELDS_FRAME_NAME: "braintreeunionpayhostedfields"
                };
            },
            {
                "../../lib/enumerate": 153
            }
        ],
        224: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Union Pay - Creation Error Codes
 * @description Errors that occur when [creating the Union Pay component](./module-braintree-web_union-pay.html#.create).
 * @property {MERCHANT} UNIONPAY_NOT_ENABLED Occurs when Union Pay is not enabled on the Braintree control panel.
 */ /**
 * @name BraintreeError.Union Pay - Shared Error Codes
 * @description Errors that occur when starting the Union Pay Flow
 * @property {MERCHANT} UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES Occurs when a method is used with both card details and a Hosted Fields instance.
 * @property {MERCHANT} UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID Occurs when Hosted Fields instance used is not a valid Hosted Fields instance.
 * @property {MERCHANT} UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED Occurs when neither card details or Hosted Fields are used.
 * @property {MERCHANT} UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED Occurs when Hosted Fields cannot be found on the page.
 */ /**
 * @name BraintreeError.Union Pay - fetchCapabilities Error Codes
 * @description Errors that occur when using the [`fetchCapabilities` method](./UnionPay.html#fetchCapabilities).
 * @property {NETWORK} UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR Occurs when there is an error looking up the Union Pay capabilities.
 */ /**
 * @name BraintreeError.Union Pay - enroll Error Codes
 * @description Errors that occur when using the [`enroll` method](./UnionPay.html#enroll).
 * @property {MERCHANT} UNIONPAY_MISSING_MOBILE_PHONE_DATA Occurs when no mobile phone data is provided.
 * @property {MERCHANT} UNIONPAY_EXPIRATION_DATE_INCOMPLETE Occurs when expiration date is incomplete.
 * @property {CUSTOMER} UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID Occurs when customer enrollment input is invalid.
 * @property {NETWORK} UNIONPAY_ENROLLMENT_NETWORK_ERROR Occurs when there is an error during enrollment.
 */ /**
 * @name BraintreeError.Union Pay - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./UnionPay.html#tokenize).
 * @property {CUSTOMER} UNIONPAY_FAILED_TOKENIZATION Occurs when data cannot be tokenized.
 * @property {NETWORK} UNIONPAY_TOKENIZATION_NETWORK_ERROR Occurs when the Braintree gateway cannot be reached.
 */ var BraintreeError = _dereq_("../../lib/braintree-error");
                module1.exports = {
                    UNIONPAY_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "UNIONPAY_NOT_ENABLED",
                        message: "UnionPay is not enabled for this merchant."
                    },
                    UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID: {
                        type: BraintreeError.types.MERCHANT,
                        code: "UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID",
                        message: "Found an invalid Hosted Fields instance. Please use a valid Hosted Fields instance."
                    },
                    UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "UNIONPAY_HOSTED_FIELDS_INSTANCE_REQUIRED",
                        message: "Could not find the Hosted Fields instance."
                    },
                    UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED",
                        message: "A card or a Hosted Fields instance is required. Please supply a card or a Hosted Fields instance."
                    },
                    UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES: {
                        type: BraintreeError.types.MERCHANT,
                        code: "UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES",
                        message: "Please supply either a card or a Hosted Fields instance, not both."
                    },
                    UNIONPAY_EXPIRATION_DATE_INCOMPLETE: {
                        type: BraintreeError.types.MERCHANT,
                        code: "UNIONPAY_EXPIRATION_DATE_INCOMPLETE",
                        message: "You must supply expiration month and year or neither."
                    },
                    UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID",
                        message: "Enrollment failed due to user input error."
                    },
                    UNIONPAY_ENROLLMENT_NETWORK_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "UNIONPAY_ENROLLMENT_NETWORK_ERROR",
                        message: "Could not enroll UnionPay card."
                    },
                    UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR",
                        message: "Could not fetch card capabilities."
                    },
                    UNIONPAY_TOKENIZATION_NETWORK_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "UNIONPAY_TOKENIZATION_NETWORK_ERROR",
                        message: "A tokenization network error occurred."
                    },
                    UNIONPAY_MISSING_MOBILE_PHONE_DATA: {
                        type: BraintreeError.types.MERCHANT,
                        code: "UNIONPAY_MISSING_MOBILE_PHONE_DATA",
                        message: "A `mobile` with `countryCode` and `number` is required."
                    },
                    UNIONPAY_FAILED_TOKENIZATION: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "UNIONPAY_FAILED_TOKENIZATION",
                        message: "The supplied card data failed tokenization."
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        225: [
            function(_dereq_, module1, exports) {
                "use strict";
                var analytics = _dereq_("../../lib/analytics");
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var Bus = _dereq_("framebus");
                var constants = _dereq_("./constants");
                var isVerifiedDomain = _dereq_("../../lib/is-verified-domain");
                var useMin = _dereq_("../../lib/use-min");
                var convertMethodsToError = _dereq_("../../lib/convert-methods-to-error");
                var errors = _dereq_("./errors");
                var events = constants.events;
                var iFramer = _dereq_("@braintree/iframer");
                var methods = _dereq_("../../lib/methods");
                var VERSION = "3.110.0";
                var uuid = _dereq_("@braintree/uuid");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var BUS_CONFIGURATION_REQUEST_EVENT = _dereq_("../../lib/constants").BUS_CONFIGURATION_REQUEST_EVENT;
                /**
 * @class
 * @param {object} options See {@link module:braintree-web/unionpay.create|unionpay.create}.
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/unionpay.create|braintree-web.unionpay.create} instead.</strong>
 * @classdesc This class represents a UnionPay component. Instances of this class have methods for {@link UnionPay#fetchCapabilities fetching capabilities} of UnionPay cards, {@link UnionPay#enroll enrolling} a UnionPay card, and {@link UnionPay#tokenize tokenizing} a UnionPay card.
 */ function UnionPay(options) {
                    this._options = options;
                }
                /**
 * @typedef {object} UnionPay~fetchCapabilitiesPayload
 * @property {boolean} isUnionPay Determines if this card is a UnionPay card.
 * @property {boolean} isDebit Determines if this card is a debit card. This property is only present if `isUnionPay` is `true`.
 * @property {object} unionPay UnionPay specific properties. This property is only present if `isUnionPay` is `true`.
 * @property {boolean} unionPay.supportsTwoStepAuthAndCapture Determines if the card allows for an authorization, but settling the transaction later.
 * @property {boolean} unionPay.isSupported Determines if Braintree can process this UnionPay card. When false, Braintree cannot process this card and the user should use a different card.
 */ /**
 * Fetches the capabilities of a card, including whether or not the SMS enrollment process is required.
 * @public
 * @param {object} options UnionPay {@link UnionPay#fetchCapabilities fetchCapabilities} options
 * @param {object} [options.card] The card from which to fetch capabilities. Note that this will only have one property, `number`. Required if you are not using the `hostedFields` option.
 * @param {string} options.card.number Card number.
 * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay#fetchCapabilitiesPayload fetchCapabilitiesPayload}. If no callback is provided, `fetchCapabilities` returns a promise that resolves with a {@link UnionPay#fetchCapabilitiesPayload fetchCapabilitiesPayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ UnionPay.prototype.fetchCapabilities = function(options) {
                    var self1 = this;
                    var client = this._options.client;
                    var cardNumber = options.card ? options.card.number : null;
                    var hostedFields = options.hostedFields;
                    if (cardNumber && hostedFields) return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES));
                    else if (cardNumber) return client.request({
                        method: "get",
                        endpoint: "payment_methods/credit_cards/capabilities",
                        data: {
                            _meta: {
                                source: "unionpay"
                            },
                            creditCard: {
                                number: cardNumber
                            }
                        }
                    }).then(function(response) {
                        analytics.sendEvent(client, "unionpay.capabilities-received");
                        return response;
                    })["catch"](function(err) {
                        var status = err.details && err.details.httpStatus;
                        analytics.sendEvent(client, "unionpay.capabilities-failed");
                        if (status === 403) return Promise.reject(err);
                        return Promise.reject(new BraintreeError({
                            type: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.type,
                            code: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.code,
                            message: errors.UNIONPAY_FETCH_CAPABILITIES_NETWORK_ERROR.message,
                            details: {
                                originalError: err
                            }
                        }));
                    });
                    else if (hostedFields) {
                        if (!hostedFields._bus) return Promise.reject(new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID));
                        return self1._initializeHostedFields().then(function() {
                            return new Promise(function(resolve, reject) {
                                self1._bus.emit(events.HOSTED_FIELDS_FETCH_CAPABILITIES, {
                                    hostedFields: hostedFields
                                }, function(response) {
                                    if (response.err) {
                                        reject(new BraintreeError(response.err));
                                        return;
                                    }
                                    resolve(response.payload);
                                });
                            });
                        });
                    }
                    return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED));
                };
                /**
 * @typedef {object} UnionPay~enrollPayload
 * @property {string} enrollmentId UnionPay enrollment ID. This value should be passed to `tokenize`.
 * @property {boolean} smsCodeRequired UnionPay `smsCodeRequired` flag.
 * </p><b>true</b> - the user will receive an SMS code that needs to be supplied for tokenization.
 * </p><b>false</b> - the card can be immediately tokenized.
 */ /**
 * Enrolls a UnionPay card. Use {@link UnionPay#fetchCapabilities|fetchCapabilities} to determine if the SMS enrollment process is required.
 * @public
 * @param {object} options UnionPay enrollment options:
 * @param {object} [options.card] The card to enroll. Required if you are not using the `hostedFields` option.
 * @param {string} options.card.number The card number.
 * @param {string} [options.card.expirationDate] The card's expiration date. May be in the form `MM/YY` or `MM/YYYY`. When defined `expirationMonth` and `expirationYear` are ignored.
 * @param {string} [options.card.expirationMonth] The card's expiration month. This should be used with the `expirationYear` parameter. When `expirationDate` is defined this parameter is ignored.
 * @param {string} [options.card.expirationYear] The card's expiration year. This should be used with the `expirationMonth` parameter. When `expirationDate` is defined this parameter is ignored.
 * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
 * @param {object} options.mobile The mobile information collected from the customer.
 * @param {string} options.mobile.countryCode The country code of the customer's mobile phone number.
 * @param {string} options.mobile.number The customer's mobile phone number.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay~enrollPayload|enrollPayload}. If no callback is provided, `enroll` returns a promise that resolves with {@link UnionPay~enrollPayload|enrollPayload}.
 * @returns {void}
 */ UnionPay.prototype.enroll = function(options) {
                    var self1 = this;
                    var client = this._options.client;
                    var card = options.card;
                    var mobile = options.mobile;
                    var hostedFields = options.hostedFields;
                    var data;
                    if (!mobile) return Promise.reject(new BraintreeError(errors.UNIONPAY_MISSING_MOBILE_PHONE_DATA));
                    if (hostedFields) {
                        if (!hostedFields._bus) return Promise.reject(new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID));
                        else if (card) return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES));
                        return new Promise(function(resolve, reject) {
                            self1._initializeHostedFields().then(function() {
                                self1._bus.emit(events.HOSTED_FIELDS_ENROLL, {
                                    hostedFields: hostedFields,
                                    mobile: mobile
                                }, function(response) {
                                    if (response.err) {
                                        reject(new BraintreeError(response.err));
                                        return;
                                    }
                                    resolve(response.payload);
                                });
                            });
                        });
                    } else if (card && card.number) {
                        data = {
                            _meta: {
                                source: "unionpay"
                            },
                            unionPayEnrollment: {
                                number: card.number,
                                mobileCountryCode: mobile.countryCode,
                                mobileNumber: mobile.number
                            }
                        };
                        if (card.expirationDate) data.unionPayEnrollment.expirationDate = card.expirationDate;
                        else if (card.expirationMonth || card.expirationYear) {
                            if (card.expirationMonth && card.expirationYear) {
                                data.unionPayEnrollment.expirationYear = card.expirationYear;
                                data.unionPayEnrollment.expirationMonth = card.expirationMonth;
                            } else return Promise.reject(new BraintreeError(errors.UNIONPAY_EXPIRATION_DATE_INCOMPLETE));
                        }
                        return client.request({
                            method: "post",
                            endpoint: "union_pay_enrollments",
                            data: data
                        }).then(function(response) {
                            analytics.sendEvent(client, "unionpay.enrollment-succeeded");
                            return {
                                enrollmentId: response.unionPayEnrollmentId,
                                smsCodeRequired: response.smsCodeRequired
                            };
                        })["catch"](function(err) {
                            var error;
                            var status = err.details && err.details.httpStatus;
                            if (status === 403) error = err;
                            else if (status < 500) {
                                error = new BraintreeError(errors.UNIONPAY_ENROLLMENT_CUSTOMER_INPUT_INVALID);
                                error.details = {
                                    originalError: err
                                };
                            } else {
                                error = new BraintreeError(errors.UNIONPAY_ENROLLMENT_NETWORK_ERROR);
                                error.details = {
                                    originalError: err
                                };
                            }
                            analytics.sendEvent(client, "unionpay.enrollment-failed");
                            return Promise.reject(error);
                        });
                    }
                    return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED));
                };
                /**
 * @typedef {object} UnionPay~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type Always <code>CreditCard</code>.
 * @property {object} details Additional account details:
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 */ /**
 * Tokenizes a UnionPay card and returns a nonce payload.
 * @public
 * @param {object} options UnionPay tokenization options:
 * @param {object} [options.card] The card to enroll. Required if you are not using the `hostedFields` option.
 * @param {string} options.card.number The card number.
 * @param {string} [options.card.expirationDate] The card's expiration date. May be in the form `MM/YY` or `MM/YYYY`. When defined `expirationMonth` and `expirationYear` are ignored.
 * @param {string} [options.card.expirationMonth] The card's expiration month. This should be used with the `expirationYear` parameter. When `expirationDate` is defined this parameter is ignored.
 * @param {string} [options.card.expirationYear] The card's expiration year. This should be used with the `expirationMonth` parameter. When `expirationDate` is defined this parameter is ignored.
 * @param {string} [options.card.cvv] The card's security number.
 * @param {HostedFields} [options.hostedFields] The Hosted Fields instance used to collect card data. Required if you are not using the `card` option.
 * @param {string} options.enrollmentId The enrollment ID from {@link UnionPay#enroll}.
 * @param {string} [options.smsCode] The SMS code received from the user if {@link UnionPay#enroll} payload have `smsCodeRequired`. if `smsCodeRequired` is false, smsCode should not be passed.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link UnionPay~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with a {@link UnionPay~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ UnionPay.prototype.tokenize = function(options) {
                    var data;
                    var self1 = this;
                    var client = this._options.client;
                    var card = options.card;
                    var hostedFields = options.hostedFields;
                    if (card && hostedFields) return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_AND_HOSTED_FIELDS_INSTANCES));
                    else if (card) {
                        data = {
                            _meta: {
                                source: "unionpay"
                            },
                            creditCard: {
                                number: options.card.number,
                                options: {
                                    unionPayEnrollment: {
                                        id: options.enrollmentId
                                    }
                                }
                            }
                        };
                        if (options.smsCode) data.creditCard.options.unionPayEnrollment.smsCode = options.smsCode;
                        if (card.expirationDate) data.creditCard.expirationDate = card.expirationDate;
                        else if (card.expirationMonth && card.expirationYear) {
                            data.creditCard.expirationYear = card.expirationYear;
                            data.creditCard.expirationMonth = card.expirationMonth;
                        }
                        if (options.card.cvv) data.creditCard.cvv = options.card.cvv;
                        return client.request({
                            method: "post",
                            endpoint: "payment_methods/credit_cards",
                            data: data
                        }).then(function(response) {
                            var tokenizedCard = response.creditCards[0];
                            delete tokenizedCard.consumed;
                            delete tokenizedCard.threeDSecureInfo;
                            analytics.sendEvent(client, "unionpay.nonce-received");
                            return tokenizedCard;
                        })["catch"](function(err) {
                            var error;
                            var status = err.details && err.details.httpStatus;
                            analytics.sendEvent(client, "unionpay.nonce-failed");
                            if (status === 403) error = err;
                            else if (status < 500) {
                                error = new BraintreeError(errors.UNIONPAY_FAILED_TOKENIZATION);
                                error.details = {
                                    originalError: err
                                };
                            } else {
                                error = new BraintreeError(errors.UNIONPAY_TOKENIZATION_NETWORK_ERROR);
                                error.details = {
                                    originalError: err
                                };
                            }
                            return Promise.reject(error);
                        });
                    } else if (hostedFields) {
                        if (!hostedFields._bus) return Promise.reject(new BraintreeError(errors.UNIONPAY_HOSTED_FIELDS_INSTANCE_INVALID));
                        return new Promise(function(resolve, reject) {
                            self1._initializeHostedFields().then(function() {
                                self1._bus.emit(events.HOSTED_FIELDS_TOKENIZE, options, function(response) {
                                    if (response.err) {
                                        reject(new BraintreeError(response.err));
                                        return;
                                    }
                                    resolve(response.payload);
                                });
                            });
                        });
                    }
                    return Promise.reject(new BraintreeError(errors.UNIONPAY_CARD_OR_HOSTED_FIELDS_INSTANCE_REQUIRED));
                };
                /**
 * Cleanly remove anything set up by {@link module:braintree-web/unionpay.create|create}. This only needs to be called when using UnionPay with Hosted Fields.
 * @public
 * @param {callback} [callback] Called on completion. If no callback is provided, returns a promise.
 * @example
 * unionpayInstance.teardown();
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ UnionPay.prototype.teardown = function() {
                    if (this._bus) {
                        this._hostedFieldsFrame.parentNode.removeChild(this._hostedFieldsFrame);
                        this._bus.teardown();
                    }
                    convertMethodsToError(this, methods(UnionPay.prototype));
                    return Promise.resolve();
                };
                UnionPay.prototype._initializeHostedFields = function() {
                    var assetsUrl, isDebug;
                    var componentId = uuid();
                    var self1 = this;
                    if (this._hostedFieldsInitializePromise) return this._hostedFieldsInitializePromise;
                    this._hostedFieldsInitializePromise = new Promise(function(resolve) {
                        assetsUrl = self1._options.client.getConfiguration().gatewayConfiguration.assetsUrl;
                        isDebug = self1._options.client.getConfiguration().isDebug;
                        self1._bus = new Bus({
                            channel: componentId,
                            verifyDomain: isVerifiedDomain
                        });
                        self1._hostedFieldsFrame = iFramer({
                            name: constants.HOSTED_FIELDS_FRAME_NAME + "_" + componentId,
                            src: assetsUrl + "/web/" + VERSION + "/html/unionpay-hosted-fields-frame" + useMin(isDebug) + ".html",
                            height: 0,
                            width: 0
                        });
                        self1._bus.on(BUS_CONFIGURATION_REQUEST_EVENT, function(reply) {
                            reply(self1._options.client);
                            resolve();
                        });
                        document.body.appendChild(self1._hostedFieldsFrame);
                    });
                    return this._hostedFieldsInitializePromise;
                };
                module1.exports = wrapPromise.wrapPrototype(UnionPay);
            },
            {
                "../../lib/analytics": 138,
                "../../lib/braintree-error": 143,
                "../../lib/constants": 145,
                "../../lib/convert-methods-to-error": 146,
                "../../lib/is-verified-domain": 173,
                "../../lib/methods": 175,
                "../../lib/use-min": 180,
                "./constants": 223,
                "./errors": 224,
                "@braintree/iframer": 32,
                "@braintree/uuid": 36,
                "@braintree/wrap-promise": 40,
                framebus: 50
            }
        ],
        226: [
            function(_dereq_, module1, exports) {
                "use strict";
                module1.exports = {
                    PLAID_LINK_JS: "https://cdn.plaid.com/link/v2/stable/link-initialize.js"
                };
            },
            {}
        ],
        227: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Us Bank Account - Creation Error Codes
 * @description Errors that occur when [creating the Us Bank Account component](./module-braintree-web_us-bank-account.html#.create).
 * @property {MERCHANT} US_BANK_ACCOUNT_NOT_ENABLED Occurs when US Bank Account is not enabled in the Braintree control panel.
 */ /**
 * @name BraintreeError.Us Bank Account - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./UsBankAccount.html#tokenize).
 * @property {MERCHANT} US_BANK_ACCOUNT_OPTION_REQUIRED Occurs when a required option is not passed.
 * @property {MERCHANT} US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS Occurs when 1 or more incompatible options are passed.
 * @property {NETWORK} US_BANK_ACCOUNT_LOGIN_LOAD_FAILED Occurs when bank login flow fails.
 * @property {CUSTOMER} US_BANK_ACCOUNT_LOGIN_CLOSED Occurs when bank login window is closed.
 * @property {MERCHANT} US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE Occurs when a bank login flow is already active.
 * @property {NETWORK} US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR Occurs when payment details could not be tokenized.
 * @property {CUSTOMER} US_BANK_ACCOUNT_FAILED_TOKENIZATION Occurs when payment details failed to be tokenized.
 * @property {MERCHANT} US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED Occurs when bank login flow is not enabled in the Braintree control panel.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    US_BANK_ACCOUNT_OPTION_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "US_BANK_ACCOUNT_OPTION_REQUIRED"
                    },
                    US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS: {
                        type: BraintreeError.types.MERCHANT,
                        code: "US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS"
                    },
                    US_BANK_ACCOUNT_LOGIN_LOAD_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "US_BANK_ACCOUNT_LOGIN_LOAD_FAILED",
                        message: "Bank login flow failed to load."
                    },
                    US_BANK_ACCOUNT_LOGIN_CLOSED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "US_BANK_ACCOUNT_LOGIN_CLOSED",
                        message: "Customer closed bank login flow before authorizing."
                    },
                    US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE: {
                        type: BraintreeError.types.MERCHANT,
                        code: "US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE",
                        message: "Another bank login tokenization request is active."
                    },
                    US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR",
                        message: "A tokenization network error occurred."
                    },
                    US_BANK_ACCOUNT_FAILED_TOKENIZATION: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "US_BANK_ACCOUNT_FAILED_TOKENIZATION",
                        message: "The supplied data failed tokenization."
                    },
                    US_BANK_ACCOUNT_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "US_BANK_ACCOUNT_NOT_ENABLED",
                        message: "US bank account is not enabled."
                    },
                    US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED",
                        message: "Bank login is not enabled."
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        228: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/us-bank-account
 * @description This module is for accepting payments of US bank accounts.
 */ var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var errors = _dereq_("./errors");
                var USBankAccount = _dereq_("./us-bank-account");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link USBankAccount} instance. If no callback is provided, `create` returns a promise that resolves with the {@link USBankAccount} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "US Bank Account";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        var usBankAccount;
                        options.client = client;
                        usBankAccount = options.client.getConfiguration().gatewayConfiguration.usBankAccount;
                        if (!usBankAccount) return Promise.reject(new BraintreeError(errors.US_BANK_ACCOUNT_NOT_ENABLED));
                        return new USBankAccount(options);
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./errors": 227,
                "./us-bank-account": 229,
                "@braintree/wrap-promise": 40
            }
        ],
        229: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../lib/braintree-error");
                var constants = _dereq_("./constants");
                var errors = _dereq_("./errors");
                var sharedErrors = _dereq_("../lib/errors");
                var analytics = _dereq_("../lib/analytics");
                var once = _dereq_("../lib/once");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var methods = _dereq_("../lib/methods");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var TOKENIZE_BANK_DETAILS_MUTATION = createGraphQLMutation("UsBankAccount");
                var TOKENIZE_BANK_LOGIN_MUTATION = createGraphQLMutation("UsBankLogin");
                /**
 * @typedef {object} USBankAccount~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `us_bank_account`.
 * @property {object} details Additional account details. Currently empty.
 */ /**
 * @class
 * @param {object} options See {@link module:braintree-web/us-bank-account.create|us-bank-account.create}.
 * @classdesc This class represents a US Bank Account component. Instances of this class can tokenize raw bank details or present a bank login. <strong>You cannot use this constructor directly. Use {@link module:braintree-web/us-bank-account.create|braintree.us-bank-account.create} instead.</strong>
 */ function USBankAccount(options) {
                    this._client = options.client;
                    this._isTokenizingBankLogin = false;
                    analytics.sendEvent(this._client, "usbankaccount.initialized");
                }
                /**
 * Tokenizes bank information to return a payment method nonce. You can tokenize bank details by providing information like account and routing numbers. You can also tokenize with a bank login UI that prompts the customer to log into their bank account.
 * @public
 * @param {object} options All tokenization options for the US Bank Account component.
 * @param {string} options.mandateText A string for proof of customer authorization. For example, `'I authorize Braintree to debit my bank account on behalf of My Online Store.'`.
 * @param {object} [options.bankDetails] Bank detail information (such as account and routing numbers). `bankDetails` or `bankLogin` option must be provided.
 * @param {string} options.bankDetails.routingNumber The customer's bank routing number, such as `'307075259'`.
 * @param {string} options.bankDetails.accountNumber The customer's bank account number, such as `'999999999'`.
 * @param {string} options.bankDetails.accountType The customer's bank account type. Must be `'checking'` or `'savings'`.
 * @param {string} options.bankDetails.ownershipType The customer's bank account ownership type. Must be `'personal'` or `'business'`.
 * @param {string} [options.bankDetails.firstName] The customer's first name. Required when account ownership type is `personal`.
 * @param {string} [options.bankDetails.lastName] The customer's last name. Required when account ownership type is `personal`.
 * @param {string} [options.bankDetails.businessName] The customer's business name. Required when account ownership type is `business`.
 * @param {object} options.bankDetails.billingAddress The customer's billing address.
 * @param {string} options.bankDetails.billingAddress.streetAddress The street address for the customer's billing address, such as `'123 Fake St'`.
 * @param {string} [options.bankDetails.billingAddress.extendedAddress] The extended street address for the customer's billing address, such as `'Apartment B'`.
 * @param {string} options.bankDetails.billingAddress.locality The locality for the customer's billing address. This is typically a city, such as `'San Francisco'`.
 * @param {string} options.bankDetails.billingAddress.region The region for the customer's billing address. This is typically a state, such as `'CA'`.
 * @param {string} options.bankDetails.billingAddress.postalCode The postal code for the customer's billing address. This is typically a ZIP code, such as `'94119'`.
 * @param {object} [options.bankLogin] Bank login information. `bankLogin` or `bankDetails` option must be provided.
 * @param {string} options.bankLogin.displayName Display name for the bank login UI, such as `'My Store'`.
 * @param {string} options.bankLogin.ownershipType The customer's bank account ownership type. Must be `'personal'` or `'business'`.
 * @param {string} [options.bankLogin.firstName] The customer's first name. Required when account ownership type is `personal`.
 * @param {string} [options.bankLogin.lastName] The customer's last name. Required when account ownership type is `personal`.
 * @param {string} [options.bankLogin.businessName] The customer's business name. Required when account ownership type is `business`.
 * @param {object} options.bankLogin.billingAddress The customer's billing address.
 * @param {string} options.bankLogin.billingAddress.streetAddress The street address for the customer's billing address, such as `'123 Fake St'`.
 * @param {string} [options.bankLogin.billingAddress.extendedAddress] The extended street address for the customer's billing address, such as `'Apartment B'`.
 * @param {string} options.bankLogin.billingAddress.locality The locality for the customer's billing address. This is typically a city, such as `'San Francisco'`.
 * @param {string} options.bankLogin.billingAddress.region The region for the customer's billing address. This is typically a state, such as `'CA'`.
 * @param {string} options.bankLogin.billingAddress.postalCode The postal code for the customer's billing address. This is typically a ZIP code, such as `'94119'`.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link USBankAccount~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with {@link USBankAccount~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * <caption>Tokenizing raw bank details</caption>
 * var routingNumberInput = document.querySelector('input[name="routing-number"]');
 * var accountNumberInput = document.querySelector('input[name="account-number"]');
 * var accountTypeInput = document.querySelector('input[name="account-type"]:checked');
 * var ownershipTypeInput = document.querySelector('input[name="ownership-type"]:checked');
 * var firstNameInput = document.querySelector('input[name="first-name"]');
 * var lastNameInput = document.querySelector('input[name="last-name"]');
 * var businessNameInput = document.querySelector('input[name="business-name"]');
 * var billingAddressStreetInput = document.querySelector('input[name="street-address"]');
 * var billingAddressExtendedInput = document.querySelector('input[name="extended-address"]');
 * var billingAddressLocalityInput = document.querySelector('input[name="locality"]');
 * var billingAddressRegionSelect = document.querySelector('select[name="region"]');
 * var billingAddressPostalInput = document.querySelector('input[name="postal-code"]');
 *
 * submitButton.addEventListener('click', function (event) {
 *   var bankDetails = {
 *     routingNumber: routingNumberInput.value,
 *     accountNumber: accountNumberInput.value,
 *     accountType: accountTypeInput.value,
 *     ownershipType: ownershipTypeInput.value,
 *     billingAddress: {
 *       streetAddress: billingAddressStreetInput.value,
 *       extendedAddress: billingAddressExtendedInput.value,
 *       locality: billingAddressLocalityInput.value,
 *       region: billingAddressRegionSelect.value,
 *       postalCode: billingAddressPostalInput.value
 *     }
 *   };
 *
 *   if (bankDetails.ownershipType === 'personal') {
 *     bankDetails.firstName = firstNameInput.value;
 *     bankDetails.lastName = lastNameInput.value;
 *   } else {
 *     bankDetails.businessName = businessNameInput.value;
 *   }
 *
 *   event.preventDefault();
 *
 *   usBankAccountInstance.tokenize({
 *     bankDetails: bankDetails,
 *     mandateText: 'I authorize Braintree to debit my bank account on behalf of My Online Store.'
 *   }, function (tokenizeErr, tokenizedPayload) {
 *     if (tokenizeErr) {
 *       console.error('There was an error tokenizing the bank details.');
 *       return;
 *     }
 *
 *     // Send tokenizePayload.nonce to your server here!
 *   });
 * });
 * @example
 * <caption>Tokenizing with bank login UI</caption>
 * var ownershipTypeInput = document.querySelector('input[name="ownership-type"]:checked');
 * var firstNameInput = document.querySelector('input[name="first-name"]');
 * var lastNameInput = document.querySelector('input[name="last-name"]');
 * var businessNameInput = document.querySelector('input[name="business-name"]');
 * var billingAddressStreetInput = document.querySelector('input[name="street-address"]');
 * var billingAddressExtendedInput = document.querySelector('input[name="extended-address"]');
 * var billingAddressLocalityInput = document.querySelector('input[name="locality"]');
 * var billingAddressRegionSelect = document.querySelector('select[name="region"]');
 * var billingAddressPostalInput = document.querySelector('input[name="postal-code"]');
 *
 * bankLoginButton.addEventListener('click', function (event) {
 *   var bankLogin = {
 *     displayName: 'My Online Store',
 *     ownershipType: ownershipTypeInput.value,
 *     billingAddress: {
 *       streetAddress: billingAddressStreetInput.value,
 *       extendedAddress: billingAddressExtendedInput.value,
 *       locality: billingAddressLocalityInput.value,
 *       region: billingAddressRegionSelect.value,
 *       postalCode: billingAddressPostalInput.value
 *     }
 *   }
 *   event.preventDefault();
 *
 *   if (bankLogin.ownershipType === 'personal') {
 *     bankLogin.firstName = firstNameInput.value;
 *     bankLogin.lastName = lastNameInput.value;
 *   } else {
 *     bankLogin.businessName = businessNameInput.value;
 *   }
 *
 *   usBankAccountInstance.tokenize({
 *     bankLogin: bankLogin,
 *     mandateText: 'I authorize Braintree to debit my bank account on behalf of My Online Store.'
 *   }, function (tokenizeErr, tokenizedPayload) {
 *     if (tokenizeErr) {
 *       console.error('There was an error tokenizing the bank details.');
 *       return;
 *     }
 *
 *     // Send tokenizePayload.nonce to your server here!
 *   });
 * });
 */ USBankAccount.prototype.tokenize = function(options) {
                    options = options || {};
                    if (!options.mandateText) return Promise.reject(new BraintreeError({
                        type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
                        code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
                        message: "mandateText property is required."
                    }));
                    if (options.bankDetails && options.bankLogin) return Promise.reject(new BraintreeError({
                        type: errors.US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS.type,
                        code: errors.US_BANK_ACCOUNT_MUTUALLY_EXCLUSIVE_OPTIONS.code,
                        message: "tokenize must be called with bankDetails or bankLogin, not both."
                    }));
                    else if (options.bankDetails) return this._tokenizeBankDetails(options);
                    else if (options.bankLogin) return this._tokenizeBankLogin(options);
                    return Promise.reject(new BraintreeError({
                        type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
                        code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
                        message: "tokenize must be called with bankDetails or bankLogin."
                    }));
                };
                USBankAccount.prototype._tokenizeBankDetails = function(options) {
                    var client = this._client;
                    var bankDetails = options.bankDetails;
                    var data = {
                        achMandate: options.mandateText,
                        routingNumber: bankDetails.routingNumber,
                        accountNumber: bankDetails.accountNumber,
                        accountType: bankDetails.accountType.toUpperCase(),
                        billingAddress: formatBillingAddressForGraphQL(bankDetails.billingAddress || {})
                    };
                    formatDataForOwnershipType(data, bankDetails);
                    return client.request({
                        api: "graphQLApi",
                        data: {
                            query: TOKENIZE_BANK_DETAILS_MUTATION,
                            variables: {
                                input: {
                                    usBankAccount: data
                                }
                            }
                        }
                    }).then(function(response) {
                        analytics.sendEvent(client, "usbankaccount.bankdetails.tokenization.succeeded");
                        return Promise.resolve(formatTokenizeResponseFromGraphQL(response, "tokenizeUsBankAccount"));
                    })["catch"](function(err) {
                        var error = errorFrom(err);
                        analytics.sendEvent(client, "usbankaccount.bankdetails.tokenization.failed");
                        return Promise.reject(error);
                    });
                };
                USBankAccount.prototype._tokenizeBankLogin = function(options) {
                    var self1 = this;
                    var client = this._client;
                    var gatewayConfiguration = client.getConfiguration().gatewayConfiguration;
                    var isProduction = gatewayConfiguration.environment === "production";
                    var plaidConfig = gatewayConfiguration.usBankAccount.plaid;
                    if (!options.bankLogin.displayName) return Promise.reject(new BraintreeError({
                        type: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.type,
                        code: errors.US_BANK_ACCOUNT_OPTION_REQUIRED.code,
                        message: "displayName property is required when using bankLogin."
                    }));
                    if (!plaidConfig) return Promise.reject(new BraintreeError(errors.US_BANK_ACCOUNT_BANK_LOGIN_NOT_ENABLED));
                    if (this._isTokenizingBankLogin) return Promise.reject(new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_REQUEST_ACTIVE));
                    this._isTokenizingBankLogin = true;
                    return new Promise(function(resolve, reject) {
                        self1._loadPlaid(function(plaidLoadErr, plaid) {
                            if (plaidLoadErr) {
                                reject(plaidLoadErr);
                                return;
                            }
                            plaid.create({
                                clientName: options.bankLogin.displayName,
                                apiVersion: "v2",
                                env: isProduction ? "production" : "sandbox",
                                key: plaidConfig.publicKey,
                                product: "auth",
                                selectAccount: true,
                                onExit: function onExit() {
                                    self1._isTokenizingBankLogin = false;
                                    analytics.sendEvent(client, "usbankaccount.banklogin.tokenization.closed.by-user");
                                    reject(new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_CLOSED));
                                },
                                onSuccess: function onSuccess(publicToken, metadata) {
                                    var bankLogin = options.bankLogin;
                                    var data = {
                                        publicToken: publicToken,
                                        accountId: isProduction ? metadata.account_id : "plaid_account_id",
                                        accountType: metadata.account.subtype.toUpperCase(),
                                        achMandate: options.mandateText,
                                        billingAddress: formatBillingAddressForGraphQL(bankLogin.billingAddress || {})
                                    };
                                    formatDataForOwnershipType(data, bankLogin);
                                    client.request({
                                        api: "graphQLApi",
                                        data: {
                                            query: TOKENIZE_BANK_LOGIN_MUTATION,
                                            variables: {
                                                input: {
                                                    usBankLogin: data
                                                }
                                            }
                                        }
                                    }).then(function(response) {
                                        self1._isTokenizingBankLogin = false;
                                        analytics.sendEvent(client, "usbankaccount.banklogin.tokenization.succeeded");
                                        resolve(formatTokenizeResponseFromGraphQL(response, "tokenizeUsBankLogin"));
                                    })["catch"](function(tokenizeErr) {
                                        var error;
                                        self1._isTokenizingBankLogin = false;
                                        error = errorFrom(tokenizeErr);
                                        analytics.sendEvent(client, "usbankaccount.banklogin.tokenization.failed");
                                        reject(error);
                                    });
                                }
                            }).open();
                            analytics.sendEvent(client, "usbankaccount.banklogin.tokenization.started");
                        });
                    });
                };
                function errorFrom(err) {
                    var error;
                    var status = err.details && err.details.httpStatus;
                    if (status === 401) error = new BraintreeError(sharedErrors.BRAINTREE_API_ACCESS_RESTRICTED);
                    else if (status < 500) error = new BraintreeError(errors.US_BANK_ACCOUNT_FAILED_TOKENIZATION);
                    else error = new BraintreeError(errors.US_BANK_ACCOUNT_TOKENIZATION_NETWORK_ERROR);
                    error.details = {
                        originalError: err
                    };
                    return error;
                }
                function formatTokenizeResponseFromGraphQL(response, type) {
                    var data = response.data[type].paymentMethod;
                    var last4 = data.details.last4;
                    var description = "US bank account ending in - " + last4;
                    return {
                        nonce: data.id,
                        details: {},
                        description: description,
                        type: "us_bank_account"
                    };
                }
                USBankAccount.prototype._loadPlaid = function(callback) {
                    var existingScript, script;
                    callback = once(callback);
                    if (window.Plaid) {
                        callback(null, window.Plaid);
                        return;
                    }
                    existingScript = document.querySelector('script[src="' + constants.PLAID_LINK_JS + '"]');
                    if (existingScript) addLoadListeners(existingScript, callback);
                    else {
                        script = document.createElement("script");
                        script.src = constants.PLAID_LINK_JS;
                        script.async = true;
                        addLoadListeners(script, callback);
                        document.body.appendChild(script);
                        this._plaidScript = script;
                    }
                };
                function addLoadListeners(script, callback) {
                    function loadHandler() {
                        var readyState = this.readyState; // eslint-disable-line no-invalid-this
                        if (!readyState || readyState === "loaded" || readyState === "complete") {
                            removeLoadListeners();
                            callback(null, window.Plaid);
                        }
                    }
                    function errorHandler() {
                        script.parentNode.removeChild(script);
                        callback(new BraintreeError(errors.US_BANK_ACCOUNT_LOGIN_LOAD_FAILED));
                    }
                    function removeLoadListeners() {
                        script.removeEventListener("error", errorHandler);
                        script.removeEventListener("load", loadHandler);
                        script.removeEventListener("readystatechange", loadHandler);
                    }
                    script.addEventListener("error", errorHandler);
                    script.addEventListener("load", loadHandler);
                    script.addEventListener("readystatechange", loadHandler);
                }
                function formatBillingAddressForGraphQL(address) {
                    return {
                        streetAddress: address.streetAddress,
                        extendedAddress: address.extendedAddress,
                        city: address.locality,
                        state: address.region,
                        zipCode: address.postalCode
                    };
                }
                function formatDataForOwnershipType(data, details) {
                    if (details.ownershipType === "personal") data.individualOwner = {
                        firstName: details.firstName,
                        lastName: details.lastName
                    };
                    else if (details.ownershipType === "business") data.businessOwner = {
                        businessName: details.businessName
                    };
                }
                function createGraphQLMutation(type) {
                    return "mutation Tokenize" + type + "($input: Tokenize" + type + "Input!) {" + "  tokenize" + type + "(input: $input) {" + "    paymentMethod {" + "      id" + "      details {" + "        ... on UsBankAccountDetails {" + "          last4" + "        }" + "      }" + "    }" + "  }" + "}";
                }
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/us-bank-account.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * usBankAccountInstance.teardown();
 * @example <caption>With callback</caption>
 * usBankAccountInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ USBankAccount.prototype.teardown = function() {
                    if (this._plaidScript) document.body.removeChild(this._plaidScript);
                    convertMethodsToError(this, methods(USBankAccount.prototype));
                    return Promise.resolve();
                };
                module1.exports = wrapPromise.wrapPrototype(USBankAccount);
            },
            {
                "../lib/analytics": 138,
                "../lib/braintree-error": 143,
                "../lib/convert-methods-to-error": 146,
                "../lib/errors": 154,
                "../lib/methods": 175,
                "../lib/once": 176,
                "./constants": 226,
                "./errors": 227,
                "@braintree/wrap-promise": 40
            }
        ],
        230: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Vault Manager - deletePaymentMethod Error Codes
 * @description Errors that occur when using the [`deletePaymentMethod` method](./VaultManager.html#deletePaymentMethod).
 * @property {MERCHANT} VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN Occurs when vault manager is initialized with a tokenization key instead of a Client Token.
 * @property {MERCHANT} VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND Occurs when the specified payment method can not be found.
 * @property {UNKNOWN} VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR Occurs when there is an error attempting to delete the payment method.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN",
                        message: "A client token with a customer id must be used to delete a payment method nonce."
                    },
                    VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND"
                    },
                    VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR"
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        231: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/vault-manager
 * @description Manages customer's payment methods.
 */ var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var VaultManager = _dereq_("./vault-manager");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} callback The second argument, `data`, is the {@link VaultManager} instance.
 * @returns {void}
 */ function create(options) {
                    var name = "Vault Manager";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return new VaultManager({
                            createPromise: createDeferredClient.create({
                                authorization: options.authorization,
                                client: options.client,
                                debug: options.debug,
                                assetsUrl: createAssetsUrl.create(options.authorization),
                                name: name
                            })
                        });
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/basic-component-verification": 141,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./vault-manager": 232,
                "@braintree/wrap-promise": 40
            }
        ],
        232: [
            function(_dereq_, module1, exports) {
                "use strict";
                var analytics = _dereq_("../lib/analytics");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var errors = _dereq_("./errors");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var methods = _dereq_("../lib/methods");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var DELETE_PAYMENT_METHOD_MUTATION = "mutation DeletePaymentMethodFromSingleUseToken($input: DeletePaymentMethodFromSingleUseTokenInput!) {  deletePaymentMethodFromSingleUseToken(input: $input) {    clientMutationId  }}";
                /**
 * @typedef {array} VaultManager~fetchPaymentMethodsPayload The customer's payment methods.
 * @property {object} paymentMethod The payment method object.
 * @property {string} paymentMethod.nonce A nonce that can be sent to your server to transact on the payment method.
 * @property {boolean} paymentMethod.default Whether or not this is the default payment method for the customer.
 * @property {object} paymentMethod.details Any additional details about the payment method. Varies depending on the type of payment method.
 * @property {string} paymentMethod.type A constant indicating the type of payment method.
 * @property {?string} paymentMethod.description Additional description about the payment method.
 * @property {?object} paymentMethod.binData Bin data about the payment method.
 *
 */ /**
 * @class
 * @param {object} options Options
 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/vault-manager.create|braintree.vault-manager.create} instead.</strong>
 * @classdesc This class allows you to manage a customer's payment methods on the client.
 */ function VaultManager(options) {
                    this._createPromise = options.createPromise;
                }
                /**
 * Fetches payment methods owned by the customer whose id was used to generate the client token used to create the {@link module:braintree-web/client|client}.
 * @public
 * @param {object} [options] Options for fetching payment methods.
 * @param {boolean} [options.defaultFirst = false] If `true`, the payment methods will be returned with the default payment method for the customer first. Otherwise, order is not guaranteed.
 * @param {callback} [callback] The second argument is a {@link VaultManager~fetchPaymentMethodsPayload|fetchPaymentMethodsPayload}. This is also what is resolved by the promise if no callback is provided.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * vaultManagerInstance.fetchPaymentMethods(function (err, paymentMethods) {
 *   paymentMethods.forEach(function (paymentMethod) {
 *     // add payment method to UI
 *     // paymentMethod.nonce <- transactable nonce associated with payment method
 *     // paymentMethod.details <- object with additional information about payment method
 *     // paymentMethod.type <- a constant signifying the type
 *   });
 * });
 */ VaultManager.prototype.fetchPaymentMethods = function(options) {
                    var defaultFirst;
                    options = options || {};
                    defaultFirst = options.defaultFirst === true ? 1 : 0;
                    return this._createPromise.then(function(client) {
                        return client.request({
                            endpoint: "payment_methods",
                            method: "get",
                            data: {
                                defaultFirst: defaultFirst
                            }
                        });
                    }).then((function(paymentMethodsPayload) {
                        analytics.sendEvent(this._createPromise, "vault-manager.fetch-payment-methods.succeeded");
                        return paymentMethodsPayload.paymentMethods.map(formatPaymentMethodPayload);
                    }).bind(this));
                };
                /**
 * Deletes a payment method owned by the customer whose id was used to generate the client token used to create the {@link module:braintree-web/client|client}.
 * @public
 * @param {string} paymentMethodNonce The payment method nonce that references a vaulted payment method.
 * @param {callback} [callback] No data is returned if the operation is successful.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * vaultManagerInstance.deletePaymentMethod('nonce-to-delete', function (err) {
 *   // handle err if it exists
 * });
 */ VaultManager.prototype.deletePaymentMethod = function(paymentMethodNonce) {
                    return this._createPromise.then(function(client) {
                        var usesClientToken = client.getConfiguration().authorizationType === "CLIENT_TOKEN";
                        if (!usesClientToken) return Promise.reject(new BraintreeError(errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN));
                        return client.request({
                            api: "graphQLApi",
                            data: {
                                query: DELETE_PAYMENT_METHOD_MUTATION,
                                variables: {
                                    input: {
                                        singleUseTokenId: paymentMethodNonce
                                    }
                                },
                                operationName: "DeletePaymentMethodFromSingleUseToken"
                            }
                        }).then(function() {
                            analytics.sendEvent(client, "vault-manager.delete-payment-method.succeeded");
                        // noop to prevent sending back the raw graphql data
                        })["catch"](function(error) {
                            var originalError = error.details.originalError;
                            var formattedError;
                            analytics.sendEvent(client, "vault-manager.delete-payment-method.failed");
                            if (originalError[0] && originalError[0].extensions.errorClass === "NOT_FOUND") formattedError = new BraintreeError({
                                type: errors.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.type,
                                code: errors.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.code,
                                message: "A payment method for payment method nonce `" + paymentMethodNonce + "` could not be found.",
                                details: {
                                    originalError: originalError
                                }
                            });
                            if (!formattedError) formattedError = new BraintreeError({
                                type: errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.type,
                                code: errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.code,
                                message: "An unknown error occured when attempting to delete the payment method assocaited with the payment method nonce `" + paymentMethodNonce + "`.",
                                details: {
                                    originalError: originalError
                                }
                            });
                            return Promise.reject(formattedError);
                        });
                    });
                };
                function formatPaymentMethodPayload(paymentMethod) {
                    var formattedPaymentMethod = {
                        nonce: paymentMethod.nonce,
                        "default": paymentMethod["default"],
                        details: paymentMethod.details,
                        hasSubscription: paymentMethod.hasSubscription,
                        type: paymentMethod.type
                    };
                    if (paymentMethod.description) formattedPaymentMethod.description = paymentMethod.description;
                    if (paymentMethod.binData) formattedPaymentMethod.binData = paymentMethod.binData;
                    return formattedPaymentMethod;
                }
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/vault-manager.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * vaultManagerInstance.teardown();
 * @example <caption>With callback</caption>
 * vaultManagerInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ VaultManager.prototype.teardown = function() {
                    convertMethodsToError(this, methods(VaultManager.prototype));
                    return Promise.resolve();
                };
                module1.exports = wrapPromise.wrapPrototype(VaultManager);
            },
            {
                "../lib/analytics": 138,
                "../lib/braintree-error": 143,
                "../lib/convert-methods-to-error": 146,
                "../lib/methods": 175,
                "./errors": 230,
                "@braintree/wrap-promise": 40
            }
        ],
        233: [
            function(_dereq_, module1, exports) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                var venmo_desktop_1 = __importDefault(_dereq_("./venmo-desktop"));
                module1.exports = function createVenmoDesktop(options) {
                    var instance = new venmo_desktop_1["default"](options);
                    return instance.initialize();
                };
            },
            {
                "./venmo-desktop": 235
            }
        ],
        234: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VENMO_PAYMENT_CONTEXT_STATUS_QUERY = exports.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY = exports.UPDATE_PAYMENT_CONTEXT_QUERY = exports.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY = exports.CREATE_PAYMENT_CONTEXT_QUERY = exports.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY = void 0;
                exports.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY = "mutation CreateVenmoQRCodePaymentContext($input: CreateVenmoQRCodePaymentContextInput!) {\n  createVenmoQRCodePaymentContext(input: $input) {\n    clientMutationId\n    venmoQRCodePaymentContext {\n      id\n      merchantId\n      createdAt\n      expiresAt\n    }\n  }\n}";
                exports.CREATE_PAYMENT_CONTEXT_QUERY = "mutation CreateVenmoPaymentContext($input: CreateVenmoPaymentContextInput!) {\n  createVenmoPaymentContext(input: $input) {\n    clientMutationId\n    venmoPaymentContext {\n      id\n      merchantId\n      createdAt\n      expiresAt\n    }\n  }\n}";
                exports.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY = "mutation UpdateVenmoQRCodePaymentContext($input: UpdateVenmoQRCodePaymentContextInput!) {\n  updateVenmoQRCodePaymentContext(input: $input) {\n    clientMutationId\n  }\n}";
                exports.UPDATE_PAYMENT_CONTEXT_QUERY = "mutation UpdateVenmoPaymentContextStatus($input: UpdateVenmoPaymentContextStatusInput!) {\n  updateVenmoPaymentContextStatus(input: $input) {\n    clientMutationId\n  }\n}";
                exports.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY = "query PaymentContext($id: ID!) {\n  node(id: $id) {\n    ... on VenmoQRCodePaymentContext {\n      status\n      paymentMethodId\n      userName\n    }\n  }\n}";
                exports.VENMO_PAYMENT_CONTEXT_STATUS_QUERY = "query PaymentContext($id: ID!) {\n  node(id: $id) {\n    ... on VenmoPaymentContext {\n      status\n      paymentMethodId\n      userName\n      payerInfo {\n        firstName\n        lastName\n        phoneNumber\n        email\n        externalId\n        userName\n        billingAddress {\n          fullName\n          addressLine1\n          addressLine2\n          adminArea1\n          adminArea2\n          postalCode\n          countryCode\n        }\n        shippingAddress {\n          fullName\n          addressLine1\n          addressLine2\n          adminArea1\n          adminArea2\n          postalCode\n          countryCode\n        }\n      }\n    }\n  }\n}";
            },
            {}
        ],
        235: [
            function(_dereq_, module1, exports) {
                "use strict";
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var framebus_1 = __importDefault(_dereq_("framebus"));
                var iframer_1 = __importDefault(_dereq_("@braintree/iframer"));
                var uuid_1 = __importDefault(_dereq_("@braintree/uuid"));
                var events_1 = _dereq_("../shared/events");
                var queries_1 = _dereq_("./queries");
                var VENMO_DESKTOP_POLLING_INTERVAL = 1000; // 1 second
                var VISUAL_DELAY_BEFORE_SIGNALLING_COMPLETION = 2000; // 2 seconds
                var VenmoDesktop = /** @class */ function() {
                    function VenmoDesktop(options) {
                        this.isHidden = true;
                        this.env = options.environment;
                        this.id = uuid_1["default"]();
                        this.profileId = options.profileId;
                        this.displayName = options.displayName;
                        this.paymentMethodUsage = options.paymentMethodUsage;
                        this.shouldUseLegacyQRCodeMutation = !this.paymentMethodUsage;
                        var frameUrl = options.url + "#" + this.env + "_" + this.id;
                        this.bus = new framebus_1["default"]({
                            channel: this.id,
                            verifyDomain: options.verifyDomain,
                            targetFrames: []
                        });
                        this.apiRequest = options.apiRequest;
                        this.sendEvent = options.sendEvent;
                        this.Promise = options.Promise;
                        this.alertBox = document.createElement("div");
                        this.alertBox.setAttribute("data-venmo-desktop-id", this.id);
                        this.alertBox.setAttribute("role", "alert");
                        this.alertBox.style.position = "fixed";
                        this.alertBox.style.display = "none";
                        this.alertBox.style.height = "1px";
                        this.alertBox.style.width = "1px";
                        this.alertBox.style.overflow = "hidden";
                        this.alertBox.style.zIndex = "0";
                        this.iframe = iframer_1["default"]({
                            src: frameUrl,
                            name: "venmo-desktop-iframe",
                            style: {
                                display: "none",
                                position: "fixed",
                                top: "0",
                                bottom: "0",
                                right: "0",
                                left: "0",
                                height: "100%",
                                width: "100%",
                                zIndex: "9999999"
                            },
                            title: "Venmo Desktop"
                        });
                        this.bus.addTargetFrame(this.iframe);
                    }
                    VenmoDesktop.prototype.initialize = function() {
                        var _this = this;
                        return new this.Promise(function(resolve) {
                            _this.bus.on(events_1.VENMO_DESKTOP_IFRAME_READY, function() {
                                resolve(_this);
                            });
                            _this.bus.on(events_1.VENMO_DESKTOP_REQUEST_NEW_QR_CODE, function() {
                                _this.sendEvent("venmo.tokenize.desktop.restarted-from-error-view");
                                _this.startPolling();
                            });
                            document.body.appendChild(_this.iframe);
                            document.body.appendChild(_this.alertBox);
                        });
                    };
                    VenmoDesktop.prototype.launchDesktopFlow = function() {
                        var _this = this;
                        this.isHidden = false;
                        var promise = new this.Promise(function(resolve, reject) {
                            _this.launchDesktopPromiseRejectFunction = reject;
                            var removeListeners = function removeListeners() {
                                /* eslint-disable @typescript-eslint/no-use-before-define */ _this.bus.off(events_1.VENMO_DESKTOP_CUSTOMER_CANCELED, customerCancelledHandler);
                                _this.bus.off(events_1.VENMO_DESKTOP_UNKNOWN_ERROR, unknownErrorHandler);
                            /* eslint-enable @typescript-eslint/no-use-before-define */ };
                            var unknownErrorHandler = function unknownErrorHandler(err) {
                                removeListeners();
                                _this.sendEvent("venmo.tokenize.desktop.unknown-error");
                                reject({
                                    allowUIToHandleError: false,
                                    reason: "UNKNOWN_ERROR",
                                    err: err
                                });
                            };
                            var customerCancelledHandler = function customerCancelledHandler() {
                                removeListeners();
                                _this.updateVenmoDesktopPaymentContext("CANCELED");
                                _this.sendEvent("venmo.tokenize.desktop.status-change.canceled-from-modal");
                                reject({
                                    allowUIToHandleError: false,
                                    reason: "CUSTOMER_CANCELED"
                                });
                            };
                            _this.completedHandler = function(payload) {
                                removeListeners();
                                resolve(payload);
                            };
                            _this.bus.on(events_1.VENMO_DESKTOP_CUSTOMER_CANCELED, customerCancelledHandler);
                            _this.bus.on(events_1.VENMO_DESKTOP_UNKNOWN_ERROR, unknownErrorHandler);
                        });
                        this.iframe.style.display = "block";
                        this.setAlert("Generating a QR code, get your Venmo app ready");
                        this.iframe.focus();
                        this.startPolling();
                        return promise.then(function(result) {
                            delete _this.venmoContextId;
                            delete _this.launchDesktopPromiseRejectFunction;
                            return result;
                        })["catch"](function(err) {
                            delete _this.venmoContextId;
                            delete _this.launchDesktopPromiseRejectFunction;
                            return _this.Promise.reject(err);
                        });
                    };
                    VenmoDesktop.prototype.triggerCompleted = function(result) {
                        var _this = this;
                        if (this.isHidden) return;
                        setTimeout(function() {
                            if (_this.completedHandler) _this.completedHandler(result);
                            delete _this.completedHandler;
                        }, VISUAL_DELAY_BEFORE_SIGNALLING_COMPLETION);
                    };
                    VenmoDesktop.prototype.triggerRejected = function(err) {
                        if (this.launchDesktopPromiseRejectFunction) this.launchDesktopPromiseRejectFunction(err);
                    };
                    VenmoDesktop.prototype.hideDesktopFlow = function() {
                        this.setAlert("");
                        this.iframe.style.display = "none";
                        this.bus.emit(events_1.VENMO_DESKTOP_CLOSED_FROM_PARENT);
                        this.isHidden = true;
                    };
                    VenmoDesktop.prototype.displayError = function(message) {
                        if (this.isHidden) return;
                        this.bus.emit(events_1.VENMO_DESKTOP_DISPLAY_ERROR, {
                            message: message
                        });
                        this.setAlert(message);
                    };
                    VenmoDesktop.prototype.displayQRCode = function(id, merchantId) {
                        if (this.isHidden) return;
                        this.bus.emit(events_1.VENMO_DESKTOP_DISPLAY_QR_CODE, {
                            id: id,
                            merchantId: merchantId
                        });
                        this.setAlert("To scan the QR code, open your Venmo app");
                    };
                    VenmoDesktop.prototype.authorize = function() {
                        if (this.isHidden) return;
                        this.bus.emit(events_1.VENMO_DESKTOP_AUTHORIZE);
                        this.setAlert("Venmo account authorized");
                    };
                    VenmoDesktop.prototype.authorizing = function() {
                        if (this.isHidden) return;
                        this.bus.emit(events_1.VENMO_DESKTOP_AUTHORIZING);
                        this.setAlert("Authorize on your Venmo app");
                    };
                    VenmoDesktop.prototype.startPolling = function() {
                        var _this = this;
                        return this.createVenmoDesktopPaymentContext().then(function(result) {
                            var expiresIn = new Date(result.expiresAt).getTime() - new Date(result.createdAt).getTime();
                            var expiredTime = Date.now() + expiresIn;
                            _this.displayQRCode(result.id, result.merchantId);
                            return _this.pollForStatusChange(result.status, expiredTime);
                        }).then(function(result) {
                            if (!result) return;
                            // since we are manually adding a prepended @ sign
                            // we want to make sure that the username does not
                            // start giving us the @ sign up front in the future
                            var username = result.userName || "";
                            username = "@" + username.replace("@", "");
                            _this.triggerCompleted({
                                paymentMethodNonce: result.paymentMethodId,
                                username: username,
                                payerInfo: result.payerInfo,
                                id: _this.venmoContextId || ""
                            });
                        })["catch"](function(err) {
                            if (err.allowUIToHandleError) // noop here and let the UI handle the customer error
                            return;
                            _this.sendEvent("venmo.tokenize.desktop.unhandled-error");
                            _this.triggerRejected(err);
                        });
                    };
                    VenmoDesktop.prototype.pollForStatusChange = function(status, expiredTime) {
                        var _this = this;
                        if (!this.venmoContextId) return this.Promise.resolve();
                        if (Date.now() > expiredTime) return this.updateVenmoDesktopPaymentContext("EXPIRED").then(function() {
                            _this.displayError("Something went wrong");
                            _this.sendEvent("venmo.tokenize.desktop.status-change.sdk-timeout");
                            return _this.Promise.reject({
                                allowUIToHandleError: true,
                                reason: "TIMEOUT"
                            });
                        });
                        return this.lookupVenmoDesktopPaymentContext().then(function(response) {
                            if (!_this.venmoContextId || !response) return _this.Promise.resolve();
                            var newStatus = response.status;
                            if (newStatus !== status) {
                                status = newStatus;
                                _this.sendEvent("venmo.tokenize.desktop.status-change." + status.toLowerCase());
                                switch(status){
                                    case "CREATED":
                                        break;
                                    case "EXPIRED":
                                    case "FAILED":
                                    case "CANCELED":
                                        var message = status === "CANCELED" ? "The authorization was canceled" : "Something went wrong";
                                        _this.displayError(message);
                                        // these are all terminal states, so we end it here
                                        return _this.Promise.reject({
                                            allowUIToHandleError: true,
                                            reason: status
                                        });
                                    case "SCANNED":
                                        _this.authorizing();
                                        break;
                                    case "APPROVED":
                                        _this.authorize();
                                        return _this.Promise.resolve(response);
                                    default:
                                }
                            }
                            return new _this.Promise(function(resolve, reject) {
                                setTimeout(function() {
                                    _this.pollForStatusChange(status, expiredTime).then(resolve)["catch"](reject);
                                }, VENMO_DESKTOP_POLLING_INTERVAL);
                            });
                        });
                    };
                    VenmoDesktop.prototype.teardown = function() {
                        this.bus.teardown();
                        if (this.iframe.parentNode) this.iframe.parentNode.removeChild(this.iframe);
                        if (this.alertBox.parentNode) this.alertBox.parentNode.removeChild(this.alertBox);
                    };
                    VenmoDesktop.prototype.setAlert = function(message) {
                        this.alertBox.style.display = message ? "block" : "none";
                        this.alertBox.textContent = message;
                    };
                    VenmoDesktop.prototype.createPaymentContextFromGraphqlLegacyQRCodeMutation = function(intent) {
                        return this.apiRequest(queries_1.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY, {
                            input: {
                                environment: this.env,
                                intent: intent
                            }
                        }).then(function(response) {
                            return response.createVenmoQRCodePaymentContext.venmoQRCodePaymentContext;
                        });
                    };
                    VenmoDesktop.prototype.createPaymentContextFromGraphQL = function(intent) {
                        var input = {
                            intent: intent,
                            paymentMethodUsage: this.paymentMethodUsage,
                            customerClient: "DESKTOP"
                        };
                        if (this.profileId) input.merchantProfileId = this.profileId;
                        if (this.displayName) input.displayName = this.displayName;
                        return this.apiRequest(queries_1.CREATE_PAYMENT_CONTEXT_QUERY, {
                            input: input
                        }).then(function(response) {
                            return response.createVenmoPaymentContext.venmoPaymentContext;
                        });
                    };
                    VenmoDesktop.prototype.createVenmoDesktopPaymentContext = function() {
                        var _this = this;
                        var contextPromise = this.shouldUseLegacyQRCodeMutation ? this.createPaymentContextFromGraphqlLegacyQRCodeMutation("PAY_FROM_APP") : this.createPaymentContextFromGraphQL("PAY_FROM_APP");
                        return contextPromise.then(function(context) {
                            _this.venmoContextId = context.id;
                            var merchantId = _this.profileId || context.merchantId;
                            return {
                                id: context.id,
                                status: context.status,
                                merchantId: merchantId,
                                createdAt: context.createdAt,
                                expiresAt: context.expiresAt
                            };
                        });
                    };
                    VenmoDesktop.prototype.updateVenmoDesktopPaymentContext = function(status, additionalOptions) {
                        if (additionalOptions === void 0) additionalOptions = {};
                        if (!this.venmoContextId) return this.Promise.resolve();
                        var data = {
                            input: __assign({
                                id: this.venmoContextId,
                                status: status
                            }, additionalOptions)
                        };
                        var query = this.shouldUseLegacyQRCodeMutation ? queries_1.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY : queries_1.UPDATE_PAYMENT_CONTEXT_QUERY;
                        return this.apiRequest(query, data).then(function() {
                        // noop so we can resolve without any data to match the type
                        });
                    };
                    VenmoDesktop.prototype.lookupVenmoDesktopPaymentContext = function() {
                        if (!this.venmoContextId) return this.Promise.resolve();
                        var query = this.shouldUseLegacyQRCodeMutation ? queries_1.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY : queries_1.VENMO_PAYMENT_CONTEXT_STATUS_QUERY;
                        return this.apiRequest(query, {
                            id: this.venmoContextId
                        }).then(function(response) {
                            return response.node;
                        });
                    };
                    return VenmoDesktop;
                }();
                exports["default"] = VenmoDesktop;
            },
            {
                "../shared/events": 240,
                "./queries": 234,
                "@braintree/iframer": 32,
                "@braintree/uuid": 36,
                framebus: 50
            }
        ],
        236: [
            function(_dereq_, module1, exports) {
                "use strict";
                /** @module braintree-web/venmo */ var analytics = _dereq_("../lib/analytics");
                var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var errors = _dereq_("./shared/errors");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var Venmo = _dereq_("./venmo");
                var supportsVenmo = _dereq_("./shared/supports-venmo");
                var VERSION = "3.110.0";
                /**
 * @typedef {object} Venmo~lineItem
 * @property {number} quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
 * @property {string} unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {string} name Item name. Maximum 127 characters.
 * @property {string} kind Indicates whether the line item is a debit (sale) or credit (refund) to the customer. Accepted values: `debit` and `credit`.
 * @property {?string} unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
 * @property {?string} description Item description. Maximum 127 characters.
 * @property {?string} productCode Product or UPC code for the item. Maximum 127 characters.
 * @property {?string} url The URL to product information.
 */ /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {boolean} [options.allowNewBrowserTab=true] This should be set to false if your payment flow requires returning to the same tab, e.g. single page applications. Doing so causes {@link Venmo#isBrowserSupported|isBrowserSupported} to return true only for mobile web browsers that support returning from the Venmo app to the same tab.
 * @param {boolean} [options.allowWebviews=true] This should be set to false if your payment flow does not occur from within a webview that you control. Doing so causes {@link Venmo#isBrowserSupported|isBrowserSupported} to return true only for mobile web browsers that are not webviews.
 * @param {boolean} [options.ignoreHistoryChanges=false] When the Venmo app returns to the website, it will modify the hash of the url to include data about the tokenization. By default, the SDK will put the state of the hash back to where it was before the change was made. Pass `true` to handle the hash change instead of the SDK.
 * @param {string} [options.profileId] The Venmo profile ID to be used during payment authorization. Customers will see the business name and logo associated with this Venmo profile, and it will show up in the Venmo app as a "Connected Merchant". Venmo profile IDs can be found in the Braintree Control Panel. Omitting this value will use the default Venmo profile.
 * @param {string} [options.deepLinkReturnUrl] An override for the URL that the Venmo iOS app opens to return from an app switch.
 * @param {boolean} [options.requireManualReturn=false] When `true`, the customer will have to manually switch back to the browser/webview that is presenting Venmo to complete the payment.
 * @param {boolean} [options.useRedirectForIOS=false] Normally, the Venmo flow is launched using `window.open` and the Venmo app intercepts that call and opens the Venmo app instead. If the customer does not have the Venmo app installed, it opens the Venmo website in a new window and instructs the customer to install the app.
 
 * In iOS webviews and Safari View Controllers (a webview-like environment which is indistinguishable from Safari for JavaScript environments), this call to `window.open` will always fail to app switch to Venmo, resulting instead in a white screen. Because of this, an alternate approach is required to launch the Venmo flow.
 *
 * When `useRedirectForIOS` is `true` and the Venmo flow is started in an iOS environment, the Venmo flow will be started by setting `window.location.href` to the Venmo website (which will still be intercepted by the Venmo app and should be the same behavior as if `window.open` was called). However, if the customer does not have the Venmo app installed, the merchant page will instead be replaced with the Venmo website and the customer will need to use the browser's back button to return to the merchant's website. Ensure that your customer's checkout information will not be lost if they are navigated away from the website and return using the browser back button.
 *
 * Due to a bug in iOS's implementation of `window.open` in iOS webviews and Safari View Controllers, if `useRedirectForIOS` is not set to `true` and the flow is launched from an iOS webview or Safari View Controller, the customer will be presented with a blank screen, halting the flow and leaving the customer unable to return to the merchant's website. Setting `useRedirectForIOS` to `true` will allow the flow to continue, but the Venmo app will be unable to return back to the webview/Safari View Controller. It will instead open the merchant's site in a new window in the customer's browser, which means the merchant site must be able to process the Venmo payment. If the SDK is configured with `allowNewBrowserTab = false`, it is unlikely that the website is set up to process the Venmo payment from a new window.
 *
 * If processing the payment from a new window is not possible, use this flag in conjunction with `requireManualReturn` so that the customer may start the flow from a webview/Safari View Controller or their Safari browser and manually return to the place that originated the flow once the Venmo app has authorized the payment and instructed them to do so.
 * @param {string} [options.paymentMethodUsage] The intended usage for the Venmo payment method nonce. Possible options are:
 * * single_use - intended as a one time transaction
 * * multi_use - intended to be vaulted and used for multiple transactions
 * @param {string} [options.displayName] The business name that will be displayed in the Venmo app payment approval screen. Only applicable when used with `paymentMethodUsage` and used by merchants onboarded as PayFast channel partners.
 * @param {boolean} [options.allowDesktop] Used to support desktop users. When enabled, the default mode is to render a scannable QR-code customers scan with their phone's to approve via the mobile app.
 * @param {boolean} [options.allowDesktopWebLogin=false] When `true`, the customer will authorize payment via a window popup that allows them to sign in to their Venmo account. This is used explicitly for customers operating from desktop browsers wanting to avoid the QR Code flow.
 * @param {boolean} [options.mobileWebFallBack] Use this option when you want to use a web-login experience, such as if on mobile and the Venmo app isn't installed.
 * @param {boolean} [options.allowAndroidRecreation=true] This flag is for when your integration uses the [Android PopupBridge](https://github.com/braintree/popup-bridge-android). Setting this flag to false will avoid a page refresh when returning to your page after payment authorization. If not specified, it defaults to true and the Android activity will be recreated, resulting in a page refresh.
 * @param {boolean} [options.collectCustomerBillingAddress] When `true`, the customer's billing address will be collected and displayed on the Venmo paysheet (provided the Enriched Customer Data checkbox is also enabled for the merchant account).
 * @param {boolean} [options.collectCustomerShippingAddress] When `true`, the customer's shipping address will be collected and displayed on the Venmo paysheet (provided the Enriched Customer Data checkbox is also enabled for the merchant account).
 * @param {boolean} [options.isFinalAmount=false] When `true`, it denotes that the purchase amount (`totalAmount`) is final and will not change.
 * @param {lineItem[]} [options.lineItems] The {@link Venmo~lineItem|line items} belonging to the transaction. It can include up to 249 line items.
 * @param {string} [options.subTotalAmount] The subtotal amount of the transaction, excluding taxes, discounts, and shipping.
 * @param {string} [options.discountAmount] The total discount amount applied on the transaction.
 * @param {string} [options.shippingAmount] Shipping amount to be charged for the transaction.
 * @param {string} [options.taxAmount] The total tax amount applied to the transaction. This value can't be negative or zero.
 * @param {string} [options.totalAmount] The grand total amount of the transaction.
 *
 * Note: This flow currently requires a full page redirect, which means to utilize this flow your page will need to be able to handle the checkout session across different pages.
 * @param {callback} [callback] The second argument, `data`, is the {@link Venmo} instance. If no callback is provided, `create` returns a promise that resolves with the {@link Venmo} instance.
 * @example
 * braintree.venmo.create({
 *   client: clientInstance
 * }).then(function (venmoInstance) {
 *   // venmoInstance is ready to be used.
 * }).catch(function (createErr) {
 *   console.error('Error creating Venmo instance', createErr);
 * });
 * @example <caption>Allow desktop flow to be used</caption>
 * braintree.venmo.create({
 *   client: clientInstance,
 *   allowDesktop: true
 * }).then(function (venmoInstance) {
 *   // venmoInstance is ready to be used.
 * }).catch(function (createErr) {
 *   console.error('Error creating Venmo instance', createErr);
 * });
 * @returns {(Promise|void)} Returns the Venmo instance.
 */ function create(options) {
                    var name = "Venmo";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        var createPromise, instance;
                        if (options.profileId && typeof options.profileId !== "string") return Promise.reject(new BraintreeError(errors.VENMO_INVALID_PROFILE_ID));
                        if (options.deepLinkReturnUrl && typeof options.deepLinkReturnUrl !== "string") return Promise.reject(new BraintreeError(errors.VENMO_INVALID_DEEP_LINK_RETURN_URL));
                        createPromise = createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        }).then(function(client) {
                            var configuration = client.getConfiguration();
                            options.client = client;
                            if (!configuration.gatewayConfiguration.payWithVenmo) return Promise.reject(new BraintreeError(errors.VENMO_NOT_ENABLED));
                            return client;
                        });
                        options.createPromise = createPromise;
                        instance = new Venmo(options);
                        analytics.sendEvent(createPromise, "venmo.initialized");
                        return createPromise.then(function() {
                            return instance;
                        });
                    });
                }
                /**
 * @static
 * @function isBrowserSupported
 * @param {object} [options] browser support options:
 * @param {boolean} [options.allowNewBrowserTab=true] This should be set to false if your payment flow requires returning to the same tab, e.g. single page applications.
 * @param {boolean} [options.allowWebviews=true] This should be set to false if your payment flow does not occur from within a webview that you control.
 * @example
 * if (braintree.venmo.isBrowserSupported()) {
 *   // set up Venmo
 * }
 * @example <caption>Explicitly require browser support returning to the same tab</caption>
 * if (braintree.venmo.isBrowserSupported({
 *   allowNewBrowserTab: false
 * })) {
 *   // set up Venmo
 * }
 * @example <caption>Explicitly set webviews as disallowed browsers</caption>
 * if (braintree.venmo.isBrowserSupported({
 *   allowWebviews: false
 * })) {
 *   // set up Venmo
 * }
 * @returns {boolean} Whether or not the browser supports Venmo.
 */ function isBrowserSupported(options) {
                    return supportsVenmo.isBrowserSupported(options);
                }
                module1.exports = {
                    create: wrapPromise(create),
                    isBrowserSupported: isBrowserSupported,
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/analytics": 138,
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./shared/errors": 239,
                "./shared/supports-venmo": 242,
                "./venmo": 244,
                "@braintree/wrap-promise": 40
            }
        ],
        237: [
            function(_dereq_, module1, exports) {
                "use strict";
                var isAndroid = _dereq_("@braintree/browser-detection/is-android");
                var isChrome = _dereq_("@braintree/browser-detection/is-chrome");
                var isIos = _dereq_("@braintree/browser-detection/is-ios");
                var isIosSafari = _dereq_("@braintree/browser-detection/is-ios-safari");
                var isIosWebview = _dereq_("@braintree/browser-detection/is-ios-webview");
                var isSamsung = _dereq_("@braintree/browser-detection/is-samsung");
                function isAndroidWebview() {
                    return isAndroid() && window.navigator.userAgent.toLowerCase().indexOf("wv") > -1;
                }
                function doesNotSupportWindowOpenInIos() {
                    if (!isIos()) return false;
                    return isIosWebview() || !isIosSafari();
                }
                function isFacebookOwnedBrowserOnAndroid() {
                    var ua = window.navigator.userAgent.toLowerCase();
                    // Huawei's Facebook useragent does not include Android
                    if (ua.indexOf("huawei") > -1 && ua.indexOf("fban") > -1) return true;
                    if (!isAndroid()) return false;
                    return ua.indexOf("fb_iab") > -1 || ua.indexOf("instagram") > -1;
                }
                function isIosChrome() {
                    return isIos() && isChrome();
                }
                module1.exports = {
                    isAndroid: isAndroid,
                    isAndroidWebview: isAndroidWebview,
                    isChrome: isChrome,
                    isIos: isIos,
                    isIosChrome: isIosChrome,
                    isSamsung: isSamsung,
                    isIosSafari: isIosSafari,
                    isIosWebview: isIosWebview,
                    isFacebookOwnedBrowserOnAndroid: isFacebookOwnedBrowserOnAndroid,
                    doesNotSupportWindowOpenInIos: doesNotSupportWindowOpenInIos
                };
            },
            {
                "@braintree/browser-detection/is-android": 20,
                "@braintree/browser-detection/is-chrome": 22,
                "@braintree/browser-detection/is-ios": 27,
                "@braintree/browser-detection/is-ios-safari": 24,
                "@braintree/browser-detection/is-ios-webview": 25,
                "@braintree/browser-detection/is-samsung": 28
            }
        ],
        238: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * Venmo shared constants
 * @typedef {object} Venmo~venmoConstants
 * @ignore
 * @property {string} VENMO_APP_OR_MOBILE_AUTH_URL A deep-linked url that will open the Venmo app if installed, or navigate to a Venmo web-login experience if the Venmo app is not present.
 * @property {string} VENMO_MOBILE_APP_AUTH_ONLY_URL A deep-linked url that leads to a Venmo dead-end page if the Venmo app is not installed (page asks customer to download the app).
 * @property {string} VENMO_WEB_LOGIN_URL A non-deeplinked url that leads to a Venmo login page. For use when explicitly wanting to avoid using the Venmo mobile app via a deep-linked url.
 */ module1.exports = {
                    DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY: 500,
                    DEFAULT_PROCESS_RESULTS_DELAY: 1000,
                    VENMO_APP_OR_MOBILE_AUTH_URL: "https://venmo.com/go/checkout",
                    VENMO_MOBILE_APP_AUTH_ONLY_URL: "https://venmo.com/braintree/checkout",
                    VENMO_WEB_LOGIN_URL: "https://account.venmo.com/go/web"
                };
            },
            {}
        ],
        239: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Venmo - Creation Error Codes
 * @description Errors that occur when [creating the Venmo component](./module-braintree-web_venmo.html#.create).
 * @property {MERCHANT} VENMO_NOT_ENABLED Occurs when Venmo is not enabled on the Braintree control panel.
 * @property {MERCHANT} VENMO_INVALID_PROFILE_ID Occurs when Venmo is initialized with a profile id, but it is invalid.
 * @property {UNKNOWN} VENMO_MOBILE_POLLING_SETUP_FAILED __Deprecated__ No longer returned. Use `VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED` instead.
 * @property {UNKNOWN} VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED Occurs when the request to set up a Venmo Payment Context object fails.
 */ /**
 * @name BraintreeError.Venmo - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./Venmo.html#tokenize).
 * @property {CUSTOMER} VENMO_APP_CANCELED Occurs when customer cancels flow from the Venmo app.
 * @property {UNKNOWN} VENMO_APP_FAILED Occurs when tokenization fails.
 * @property {CUSTOMER} VENMO_CANCELED Occurs when customer cancels the flow or Venmo app is not available.
 * @property {CUSTOMER} VENMO_CUSTOMER_CANCELED Occurs when customer cancels the flow.
 * @property {CUSTOMER} VENMO_DESKTOP_CANCELED Occurs when customer cancels the Venmo Desktop flow by closing the modal.
 * @property {UNKNOWN} VENMO_DESKTOP_UNKNOWN_ERROR Occurs when an unknown error causes the Venmo Desktop flow to fail.
 * @property {UNKNOWN} VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR Occurs when an unknown network error causes the mobile polling process to fail.
 * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED Occurs when the polling has expired and the payment cannot be completed.
 * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED Occurs when the polling operation is canceled by the customer.
 * @property {CUSTOMER} VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT Occurs when customer takes too long to complete payment.
 * @property {UNKNOWN} VENMO_MOBILE_POLLING_TOKENIZATION_FAILED Occurs if there is an unknown error during the mobile polling process.
 * @property {NETWORK} VENMO_NETWORK_ERROR Occurs when a network error causes a request to fail.
 * @property {MERCHANT} VENMO_TOKENIZATION_CANCELED_BY_MERCHANT Occurs when `cancelTokenization` is called while tokenization is in progress.
 * @property {UNKNOWN} VENMO_TOKENIZATION_FAILED Occurs when there is an unknown error during the web login experience.
 * @property {MERCHANT} VENMO_TOKENIZATION_REQUEST_ACTIVE Occurs when `tokenize` is called when the flow is already in progress.
 * @property {MERCHANT} VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE Occurs when `cancelTokenization` is called when the flow is not in progress.
 * @property {MERCHANT} VENMO_ECD_DISABLED Occurs when the merchant tries to access customer details without enabling Enriched Customer Data.
 */ var BraintreeError = _dereq_("../../lib/braintree-error");
                module1.exports = {
                    VENMO_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VENMO_NOT_ENABLED",
                        message: "Venmo is not enabled for this merchant."
                    },
                    VENMO_TOKENIZATION_REQUEST_ACTIVE: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VENMO_TOKENIZATION_REQUEST_ACTIVE",
                        message: "Another tokenization request is active."
                    },
                    VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE",
                        message: "No tokenization in progress."
                    },
                    VENMO_APP_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "VENMO_APP_FAILED",
                        message: "Venmo app encountered a problem."
                    },
                    VENMO_APP_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "VENMO_APP_CANCELED",
                        message: "Venmo app authorization was canceled."
                    },
                    VENMO_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "VENMO_CANCELED",
                        message: "User canceled Venmo authorization, or Venmo app is not available."
                    },
                    VENMO_CUSTOMER_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "VENMO_CUSTOMER_CANCELED",
                        message: "User canceled Venmo authorization."
                    },
                    VENMO_NETWORK_ERROR: {
                        type: BraintreeError.types.NETWORK,
                        code: "VENMO_NETWORK_ERROR",
                        message: "Something went wrong making the request"
                    },
                    VENMO_DESKTOP_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "VENMO_DESKTOP_CANCELED",
                        message: "User canceled Venmo authorization by closing the Venmo Desktop modal."
                    },
                    VENMO_TOKENIZATION_CANCELED_BY_MERCHANT: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VENMO_TOKENIZATION_CANCELED_BY_MERCHANT",
                        message: "The Venmo tokenization was canceled by the merchant."
                    },
                    VENMO_DESKTOP_UNKNOWN_ERROR: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "VENMO_DESKTOP_UNKNOWN_ERROR",
                        message: "Something went wrong with the Venmo Desktop flow."
                    },
                    VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED: {
                        type: BraintreeError.types.NETWORK,
                        code: "VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED",
                        message: "Something went wrong creating the Venmo Payment Context."
                    },
                    VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR",
                        message: "Something went wrong during mobile polling."
                    },
                    VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "VENMO_MOBILE_POLLING_TOKENIZATION_EXPIRED",
                        message: "The Venmo authorization request is expired."
                    },
                    VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED",
                        message: "The Venmo authorization was canceled"
                    },
                    VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT: {
                        type: BraintreeError.types.CUSTOMER,
                        code: "VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT",
                        message: "Customer took too long to authorize Venmo payment."
                    },
                    VENMO_MOBILE_POLLING_TOKENIZATION_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "VENMO_MOBILE_POLLING_TOKENIZATION_FAILED",
                        message: "The Venmo authorization failed."
                    },
                    VENMO_INVALID_PROFILE_ID: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VENMO_INVALID_PROFILE_ID",
                        message: "Venmo profile ID is invalid."
                    },
                    VENMO_INVALID_DEEP_LINK_RETURN_URL: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VENMO_INVALID_DEEP_LINK_RETURN_URL",
                        message: "Venmo deep link return URL is invalid."
                    },
                    VENMO_TOKENIZATION_FAILED: {
                        type: BraintreeError.types.UNKNOWN,
                        code: "VENMO_TOKENIZATION_FAILED",
                        message: "Venmo encountered a problem"
                    },
                    VENMO_ECD_DISABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "ECD_DISABLED",
                        message: "Cannot collect customer data when ECD is disabled. Enable this feature in the Control Panel to collect this data."
                    }
                };
            },
            {
                "../../lib/braintree-error": 143
            }
        ],
        240: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VENMO_DESKTOP_UNKNOWN_ERROR = exports.VENMO_DESKTOP_REQUEST_NEW_QR_CODE = exports.VENMO_DESKTOP_CLOSED_FROM_PARENT = exports.VENMO_DESKTOP_IFRAME_READY = exports.VENMO_DESKTOP_DISPLAY_QR_CODE = exports.VENMO_DESKTOP_DISPLAY_ERROR = exports.VENMO_DESKTOP_CUSTOMER_CANCELED = exports.VENMO_DESKTOP_AUTHORIZING = exports.VENMO_DESKTOP_AUTHORIZE = exports.VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT = void 0;
                exports.VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT = "VENMO_DESKTOP_AUTHORIZATION_TIMED_OUT";
                exports.VENMO_DESKTOP_AUTHORIZE = "VENMO_DESKTOP_AUTHORIZE";
                exports.VENMO_DESKTOP_AUTHORIZING = "VENMO_DESKTOP_AUTHORIZING";
                exports.VENMO_DESKTOP_CUSTOMER_CANCELED = "VENMO_DESKTOP_CUSTOMER_CANCELED";
                exports.VENMO_DESKTOP_DISPLAY_ERROR = "VENMO_DESKTOP_DISPLAY_ERROR";
                exports.VENMO_DESKTOP_DISPLAY_QR_CODE = "VENMO_DESKTOP_DISPLAY_QR_CODE";
                exports.VENMO_DESKTOP_IFRAME_READY = "VENMO_DESKTOP_IFRAME_READY";
                exports.VENMO_DESKTOP_CLOSED_FROM_PARENT = "VENMO_DESKTOP_CLOSED_FROM_PARENT";
                exports.VENMO_DESKTOP_REQUEST_NEW_QR_CODE = "VENMO_DESKTOP_REQUEST_NEW_QR_CODE";
                exports.VENMO_DESKTOP_UNKNOWN_ERROR = "VENMO_DESKTOP_UNKNOWN_ERROR";
            },
            {}
        ],
        241: [
            function(_dereq_, module1, exports) {
                "use strict";
                var venmoConstants = _dereq_("./constants");
                function getVenmoUrl(options) {
                    if (options.useAllowDesktopWebLogin) return venmoConstants.VENMO_WEB_LOGIN_URL;
                    if (options.mobileWebFallBack) return venmoConstants.VENMO_APP_OR_MOBILE_AUTH_URL;
                    return venmoConstants.VENMO_MOBILE_APP_AUTH_ONLY_URL;
                }
                module1.exports = getVenmoUrl;
            },
            {
                "./constants": 238
            }
        ],
        242: [
            function(_dereq_, module1, exports) {
                "use strict";
                var browserDetection = _dereq_("./browser-detection");
                var inIframe = _dereq_("../../lib/in-iframe");
                function isBrowserSupported(options) {
                    var isKnownUnsupportedMobileBrowser, merchantAllowsDesktopBrowsers, merchantAllowsIosChrome, merchantAllowsReturningToNewBrowserTab, merchantAllowsWebviews;
                    var isAndroid = browserDetection.isAndroid();
                    var isMobileDevice = isAndroid || browserDetection.isIos();
                    var isAndroidChrome = isAndroid && browserDetection.isChrome();
                    var isMobileDeviceThatSupportsReturnToSameTab = browserDetection.isIosSafari() || isAndroidChrome;
                    options = options || {};
                    // NEXT_MAJOR_VERSION allowDesktop will default to true, but can be opted out
                    merchantAllowsDesktopBrowsers = (options.allowDesktopWebLogin || options.allowDesktop) === true;
                    merchantAllowsReturningToNewBrowserTab = options.hasOwnProperty("allowNewBrowserTab") ? options.allowNewBrowserTab : true;
                    // NEXT_MAJOR_VERSION webviews are not supported, except for the case where
                    // the merchant themselves is presenting venmo in a webview using the deep
                    // link url to get back to their app. For the next major version, we should
                    // just not have this option and instead require the merchant to determine
                    // if the venmo button should be displayed when presenting it in the
                    // merchant's app via a webview.
                    merchantAllowsWebviews = options.hasOwnProperty("allowWebviews") ? options.allowWebviews : true;
                    // Venmo only works on iOS Chrome when the
                    // button is not rendered in an iFrame and
                    // allowNewBrowserTab is set to true
                    merchantAllowsIosChrome = merchantAllowsReturningToNewBrowserTab && !inIframe();
                    isKnownUnsupportedMobileBrowser = !merchantAllowsIosChrome && browserDetection.isIosChrome() || browserDetection.isFacebookOwnedBrowserOnAndroid() || browserDetection.isSamsung();
                    if (isKnownUnsupportedMobileBrowser) return false;
                    if (!merchantAllowsWebviews && (browserDetection.isAndroidWebview() || browserDetection.isIosWebview())) return false;
                    if (!isMobileDevice) return merchantAllowsDesktopBrowsers;
                    if (!merchantAllowsReturningToNewBrowserTab) return isMobileDeviceThatSupportsReturnToSameTab;
                    return isMobileDevice;
                }
                module1.exports = {
                    isBrowserSupported: isBrowserSupported
                };
            },
            {
                "../../lib/in-iframe": 169,
                "./browser-detection": 237
            }
        ],
        243: [
            function(_dereq_, module1, exports) {
                "use strict";
                var frameService = _dereq_("../../lib/frame-service/external");
                var useMin = _dereq_("../../lib/use-min");
                var ExtendedPromise = _dereq_("@braintree/extended-promise");
                var errors = _dereq_("../shared/errors");
                var BraintreeError = _dereq_("../../lib/braintree-error");
                var VERSION = "3.110.0";
                var VENMO_LOGO_SVG = '<svg width="198" height="58" viewBox="0 0 198 58" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M43.0702 13.6572C44.1935 15.4585 44.6999 17.3139 44.6999 19.6576C44.6999 27.1328 38.1277 36.8436 32.7935 43.6625H20.6099L15.7236 15.2939L26.3917 14.3105L28.9751 34.4966C31.389 30.6783 34.3678 24.6779 34.3678 20.587C34.3678 18.3477 33.9727 16.8225 33.3553 15.5666L43.0702 13.6572Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M56.8965 26.1491C58.8596 26.1491 63.8018 25.2772 63.8018 22.5499C63.8018 21.2402 62.8481 20.587 61.7242 20.587C59.7579 20.587 57.1776 22.8763 56.8965 26.1491ZM56.6715 31.5506C56.6715 34.8807 58.5787 36.1873 61.107 36.1873C63.8603 36.1873 66.4966 35.534 69.923 33.8433L68.6324 42.3523C66.2183 43.4976 62.4559 44.2617 58.8039 44.2617C49.5403 44.2617 46.2249 38.8071 46.2249 31.9879C46.2249 23.1496 51.6179 13.765 62.7365 13.765C68.858 13.765 72.2809 17.0949 72.2809 21.7317C72.2815 29.2066 62.4005 31.4965 56.6715 31.5506Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M103.067 20.3142C103.067 21.4052 102.897 22.9875 102.727 24.0216L99.5262 43.6622H89.1385L92.0585 25.658C92.1139 25.1696 92.284 24.1865 92.284 23.6411C92.284 22.3314 91.4414 22.0047 90.4282 22.0047C89.0826 22.0047 87.7337 22.6042 86.8354 23.0418L83.5234 43.6625H73.0772L77.8495 14.257H86.8908L87.0052 16.6041C89.1382 15.2404 91.9469 13.7656 95.932 13.7656C101.212 13.765 103.067 16.3845 103.067 20.3142Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M133.906 16.9841C136.881 14.9131 139.69 13.765 143.563 13.765C148.897 13.765 150.753 16.3845 150.753 20.3142C150.753 21.4052 150.583 22.9875 150.413 24.0216L147.216 43.6622H136.825L139.801 25.2774C139.855 24.786 139.971 24.1865 139.971 23.8063C139.971 22.3317 139.128 22.0047 138.115 22.0047C136.824 22.0047 135.535 22.5501 134.577 23.0418L131.266 43.6625H120.878L123.854 25.2777C123.908 24.7863 124.02 24.1868 124.02 23.8065C124.02 22.332 123.177 22.0049 122.167 22.0049C120.819 22.0049 119.473 22.6045 118.574 23.0421L115.26 43.6628H104.817L109.589 14.2573H118.52L118.8 16.7122C120.878 15.241 123.684 13.7662 127.446 13.7662C130.704 13.765 132.837 15.129 133.906 16.9841Z" fill="white"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M171.426 25.5502C171.426 23.1496 170.808 21.513 168.956 21.513C164.857 21.513 164.015 28.55 164.015 32.1498C164.015 34.8807 164.802 36.5709 166.653 36.5709C170.528 36.5709 171.426 29.1497 171.426 25.5502ZM153.458 31.7152C153.458 22.442 158.511 13.765 170.136 13.765C178.896 13.765 182.098 18.7854 182.098 25.7148C182.098 34.8805 177.099 44.3723 165.194 44.3723C156.378 44.3723 153.458 38.7525 153.458 31.7152Z" fill="white"/>\n</svg>';
                var CONTINUE_OR_CANCEL_INSTRUCTIONS = "Tap cancel payment to cancel and return to the business. Continue payment will relaunch the payment window.";
                var POPUP_WIDTH = 400;
                var POPUP_HEIGHT = 570;
                var ELEMENT_IDS = {
                    backdrop: "venmo-desktop-web-backdrop",
                    backdropHidden: "venmo-desktop-web-backdrop.hidden",
                    backdropContainer: "venmo-backdrop-container",
                    cancelButton: "venmo-popup-cancel-button",
                    continueButton: "venmo-popup-continue-button",
                    message: "venmo-message",
                    instructions: "venmo-instructions",
                    venmoLogo: "venmo-full-logo"
                };
                ExtendedPromise.suppressUnhandledPromiseMessage = true;
                function openPopup(options) {
                    var frameServiceInstance = options.frameServiceInstance;
                    var venmoUrl = options.venmoUrl;
                    var checkForStatusChange = options.checkForStatusChange;
                    var cancelTokenization = options.cancelTokenization;
                    var checkPaymentContextStatus = options.checkPaymentContextStatus;
                    var extendedPromise = new ExtendedPromise();
                    document.getElementById(ELEMENT_IDS.continueButton).addEventListener("click", function() {
                        frameServiceInstance.focus();
                    });
                    document.getElementById(ELEMENT_IDS.cancelButton).addEventListener("click", function() {
                        frameServiceInstance.close();
                        cancelTokenization();
                        closeBackdrop();
                    });
                    frameServiceInstance.open({}, function(frameServiceErr) {
                        var retryStartingCount = 1;
                        if (frameServiceErr) extendedPromise.reject(frameServiceErr);
                        else checkForStatusChange(retryStartingCount).then(function(data) {
                            extendedPromise.resolve(data);
                        })["catch"](function(statusCheckError) {
                            // We add this check here because at this point
                            // the status should not be in CREATED status.
                            // However, there is an edge case where if a buyer
                            // cancels in the popup, the popup might close itself
                            // before it can send the graphQL mutation to update its status.
                            // In these cases, the status will be stuck in CREATED status, and
                            // tokenization would fail, incorrectly throwing a tokenization error
                            // instead of informing the merchant that the customer canceled.
                            checkPaymentContextStatus().then(function(node) {
                                if (node.status === "CREATED") extendedPromise.reject(new BraintreeError(errors.VENMO_CUSTOMER_CANCELED));
                                else extendedPromise.reject(statusCheckError);
                            });
                        });
                        frameServiceInstance.close();
                        closeBackdrop();
                    });
                    frameServiceInstance.redirect(venmoUrl);
                    return extendedPromise;
                }
                function centeredPopupDimensions() {
                    var popupTop = Math.round((window.outerHeight - POPUP_HEIGHT) / 2) + window.screenTop;
                    var popupLeft = Math.round((window.outerWidth - POPUP_WIDTH) / 2) + window.screenLeft;
                    return {
                        top: popupTop,
                        left: popupLeft
                    };
                }
                function closeBackdrop() {
                    document.getElementById("venmo-desktop-web-backdrop").classList.add("hidden");
                }
                function getElementStyles() {
                    var backdropStyles = [
                        "#" + ELEMENT_IDS.backdropHidden + " {",
                        "display: none;",
                        "}",
                        "#" + ELEMENT_IDS.backdrop + " {",
                        "z-index: 3141592632;",
                        "cursor: pointer;",
                        "position: fixed;",
                        "top: 0;",
                        "left: 0;",
                        "bottom: 0;",
                        "width: 100%;",
                        "background: rgba(0, 0, 0, 0.8);",
                        "}"
                    ];
                    var backdropContainerStyles = [
                        "#" + ELEMENT_IDS.backdropContainer + " {",
                        "display: flex;",
                        "align-content: center;",
                        "justify-content: center;",
                        "align-items: center;",
                        "width: 100%;",
                        "height: 100%;",
                        "flex-direction: column;",
                        "}"
                    ];
                    var cancelButtonStyles = [
                        "#" + ELEMENT_IDS.cancelButton + " {",
                        "height: 24px;",
                        "width: 380px;",
                        "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;",
                        "font-style: normal;",
                        "font-weight: 700;",
                        "font-size: 18px;",
                        "line-height: 24px;",
                        "text-align: center;",
                        "background-color: transparent;",
                        "border: none;",
                        "color: #FFFFFF;",
                        "margin-top: 28px;",
                        "}"
                    ];
                    var continueButtonStyles = [
                        "#" + ELEMENT_IDS.continueButton + " {",
                        "width: 400px;",
                        "height: 50px;",
                        "background: #0074DE;",
                        "border-radius: 24px;",
                        "border: none;",
                        "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;",
                        "font-style: normal;",
                        "font-weight: 700;",
                        "font-size: 18px;",
                        "color: #FFFFFF;",
                        "margin-top: 44px;",
                        "}"
                    ];
                    var messageStyles = [
                        "#" + ELEMENT_IDS.message + " {",
                        "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;",
                        "font-style: normal;",
                        "font-weight: 500;",
                        "font-size: 24px;",
                        "line-height: 32px;",
                        "text-align: center;",
                        "color: #FFFFFF;",
                        "margin-top: 32px;",
                        "}"
                    ];
                    var instructionStyles = [
                        "#" + ELEMENT_IDS.instructions + " {",
                        "font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;",
                        "font-style: normal;",
                        "font-weight: 400;",
                        "font-size: 16px;",
                        "line-height: 20px;",
                        "text-align: center;",
                        "color: #FFFFFF;",
                        "margin-top: 16px;",
                        "width: 400px;",
                        "}"
                    ];
                    var allStyles = backdropStyles.concat(backdropContainerStyles, cancelButtonStyles, continueButtonStyles, messageStyles, instructionStyles);
                    return allStyles.join("\n");
                }
                function buildAndStyleElements() {
                    var alreadyRenderedBackdrop = document.getElementById(ELEMENT_IDS.backdrop);
                    var backdropStylesElement, backdropDiv, backDropContentContainer, venmoLogoDiv, venmoMessageDiv, instructionsDiv, continueButton, cancelButton;
                    if (alreadyRenderedBackdrop) {
                        alreadyRenderedBackdrop.classList.remove("hidden");
                        return;
                    }
                    backdropStylesElement = document.createElement("style");
                    backdropDiv = document.createElement("div");
                    backDropContentContainer = document.createElement("div");
                    venmoLogoDiv = document.createElement("div");
                    venmoMessageDiv = document.createElement("div");
                    instructionsDiv = document.createElement("div");
                    continueButton = document.createElement("button");
                    cancelButton = document.createElement("button");
                    backdropStylesElement.id = "venmo-desktop-web__injected-styles";
                    backdropStylesElement.innerHTML = getElementStyles();
                    backdropDiv.id = ELEMENT_IDS.backdrop;
                    backDropContentContainer.id = ELEMENT_IDS.backdropContainer;
                    venmoLogoDiv.id = ELEMENT_IDS.venmoLogo;
                    venmoLogoDiv.innerHTML = VENMO_LOGO_SVG;
                    venmoMessageDiv.id = ELEMENT_IDS.message;
                    venmoMessageDiv.innerText = "What would you like to do?";
                    instructionsDiv.id = ELEMENT_IDS.instructions;
                    instructionsDiv.innerText = CONTINUE_OR_CANCEL_INSTRUCTIONS;
                    continueButton.id = ELEMENT_IDS.continueButton;
                    continueButton.innerText = "Continue payment";
                    cancelButton.id = ELEMENT_IDS.cancelButton;
                    cancelButton.innerText = "Cancel payment";
                    document.head.appendChild(backdropStylesElement);
                    backDropContentContainer.appendChild(venmoLogoDiv);
                    backDropContentContainer.appendChild(venmoMessageDiv);
                    backDropContentContainer.appendChild(instructionsDiv);
                    backDropContentContainer.appendChild(continueButton);
                    backDropContentContainer.appendChild(cancelButton);
                    backdropDiv.appendChild(backDropContentContainer);
                    document.body.appendChild(backdropDiv);
                    backdropDiv.addEventListener("click", function(event) {
                        event.stopPropagation();
                    });
                }
                /**
 * Applies a backdrop over the page, and opens a popup to the supplied url. Uses supplied status and cancel functions to handle the flow.
 * @function runWebLogin
 * @ignore
 * @param {object} options Options for running the web login flow.
 * @param {string} options.venmoUrl Venmo url that is to be used for logging in.
 * @param {Venmo~checkPaymentContextStatusAndProcessResult} options.checkForStatusChange {@link Venmo~checkPaymentContextStatusAndProcessResult} to be invoked in order to check for a payment context status update.
 * @param {Venmo~cancelTokenization} options.cancelTokenization {@link Venmo~cancelTokenization} to be invoked when the appropriate payment context status is retrieved.
 * @param {boolean} options.debug A flag to control whether to use minified assets or not.
 * @returns {Promise} Returns a promise
 */ function runWebLogin(options) {
                    buildAndStyleElements();
                    return openPopup(options);
                }
                /**
 * When using frameservice, it needs to be created separately from the action of opening. The setup process includes
 * steps that browsers may consider async or too disconnected from the user action required to open a popup.
 *
 * This function enables us to do that setup at an appropriate time.
 * @function setupDesktopWebLogin
 * @ignore
 * @param {object} options Options use for setting up the Desktop Web Login flow.
 * @param {string} options.assetsUrl Url that points to the hosted Braintree assets.
 * @param {boolean} options.debug A flag to control whether to use minified assets or not.

 * @returns {Promise} Returns a promise
 */ function setupDesktopWebLogin(options) {
                    var extendedPromise = new ExtendedPromise();
                    var popupName = "venmoDesktopWebLogin";
                    var assetsUrl = options.assetsUrl;
                    var debug = options.debug || false;
                    var popupLocation = centeredPopupDimensions();
                    var assetsBaseUrl = assetsUrl + "/web/" + VERSION + "/html";
                    frameService.create({
                        name: popupName,
                        dispatchFrameUrl: assetsBaseUrl + "/dispatch-frame" + useMin(debug) + ".html",
                        openFrameUrl: assetsBaseUrl + "/venmo-landing-frame" + useMin(debug) + ".html",
                        top: popupLocation.top,
                        left: popupLocation.left,
                        height: POPUP_HEIGHT,
                        width: POPUP_WIDTH
                    }, function(frameServiceInstance) {
                        extendedPromise.resolve(frameServiceInstance);
                    });
                    return extendedPromise;
                }
                module1.exports = {
                    runWebLogin: runWebLogin,
                    openPopup: openPopup,
                    setupDesktopWebLogin: setupDesktopWebLogin,
                    POPUP_WIDTH: POPUP_WIDTH,
                    POPUP_HEIGHT: POPUP_HEIGHT
                };
            },
            {
                "../../lib/braintree-error": 143,
                "../../lib/frame-service/external": 158,
                "../../lib/use-min": 180,
                "../shared/errors": 239,
                "@braintree/extended-promise": 31
            }
        ],
        244: [
            function(_dereq_, module1, exports) {
                "use strict";
                var analytics = _dereq_("../lib/analytics");
                var isBrowserSupported = _dereq_("./shared/supports-venmo");
                var browserDetection = _dereq_("./shared/browser-detection");
                var constants = _dereq_("./shared/constants");
                var errors = _dereq_("./shared/errors");
                var querystring = _dereq_("../lib/querystring");
                var isVerifiedDomain = _dereq_("../lib/is-verified-domain");
                var methods = _dereq_("../lib/methods");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var inIframe = _dereq_("../lib/in-iframe");
                var ExtendedPromise = _dereq_("@braintree/extended-promise");
                var getVenmoUrl = _dereq_("./shared/get-venmo-url");
                var desktopWebLogin = _dereq_("./shared/web-login-backdrop");
                var snakeCaseToCamelCase = _dereq_("../lib/snake-case-to-camel-case");
                // NEXT_MAJOR_VERSION the source code for this is actually in a
                // typescript repo called venmo-desktop, once the SDK is migrated
                // to typescript, we can move the TS files out of that separate
                // repo and into the web SDK properly
                var createVenmoDesktop = _dereq_("./external/");
                var graphqlQueries = _dereq_("./external/queries");
                var VERSION = "3.110.0";
                var DEFAULT_MOBILE_POLLING_INTERVAL = 250; // 1/4 second
                var DEFAULT_MOBILE_EXPIRING_THRESHOLD = 300000; // 5 minutes
                ExtendedPromise.suppressUnhandledPromiseMessage = true;
                /**
 * Venmo tokenize payload.
 * @typedef {object} Venmo~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {string} type The payment method type, always `VenmoAccount`.
 * @property {object} details Additional Venmo account details.
 * @property {string} details.username The username of the Venmo account.
 * @property {string} details.paymentContextId The context ID of the Venmo payment. Only available when used with {@link https://braintree.github.io/braintree-web/current/module-braintree-web_venmo.html#.create|`paymentMethodUsage`}.
 */ /**
 * @class
 * @param {object} options The Venmo {@link module:braintree-web/venmo.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/venmo.create|braintree-web.venmo.create} instead.</strong>
 * @classdesc This class represents a Venmo component produced by {@link module:braintree-web/venmo.create|braintree-web/venmo.create}. Instances of this class have methods for tokenizing Venmo payments.
 */ function Venmo(options) {
                    var self1 = this;
                    this._allowDesktopWebLogin = options.allowDesktopWebLogin || false;
                    this._mobileWebFallBack = options.mobileWebFallBack || false;
                    this._createPromise = options.createPromise;
                    this._allowNewBrowserTab = options.allowNewBrowserTab !== false;
                    this._allowWebviews = options.allowWebviews !== false;
                    this._allowDesktop = options.allowDesktop === true;
                    this._useRedirectForIOS = options.useRedirectForIOS === true;
                    this._profileId = options.profileId;
                    this._displayName = options.displayName;
                    this._deepLinkReturnUrl = options.deepLinkReturnUrl;
                    this._ignoreHistoryChanges = options.ignoreHistoryChanges;
                    this._paymentMethodUsage = (options.paymentMethodUsage || "").toUpperCase();
                    this._shouldUseLegacyFlow = !this._paymentMethodUsage;
                    this._requireManualReturn = options.requireManualReturn === true;
                    this._useDesktopQRFlow = this._allowDesktop && this._isDesktop() && !this._allowDesktopWebLogin;
                    this._useAllowDesktopWebLogin = this._allowDesktopWebLogin && this._isDesktop();
                    this._cannotHaveReturnUrls = inIframe() || this._requireManualReturn;
                    this._allowAndroidRecreation = options.allowAndroidRecreation !== false;
                    this._maxRetryCount = 3;
                    this._collectCustomerBillingAddress = options.collectCustomerBillingAddress || false;
                    this._collectCustomerShippingAddress = options.collectCustomerShippingAddress || false;
                    this._isFinalAmount = options.isFinalAmount || false;
                    this._lineItems = options.lineItems;
                    this._subTotalAmount = options.subTotalAmount;
                    this._discountAmount = options.discountAmount;
                    this._taxAmount = options.taxAmount;
                    this._shippingAmount = options.shippingAmount;
                    this._totalAmount = options.totalAmount;
                    this._shouldCreateVenmoPaymentContext = this._cannotHaveReturnUrls || !this._shouldUseLegacyFlow;
                    analytics.sendEvent(this._createPromise, "venmo.desktop-flow.configured." + String(Boolean(this._allowDesktop)));
                    // if the url has a tokenization result, that indicates
                    // that it cannot be the desktop flow or the manual return
                    // flow. If it's the hash change with paymentMethodUsage
                    // flow, we want to skip creating a new payment context, since
                    // there is already a pending payment context waiting to be
                    // processed. For the hash change flow without paymentMethodUsage,
                    // no further actions are needed.
                    if (this.hasTokenizationResult()) analytics.sendEvent(this._createPromise, "venmo.appswitch.return-in-new-tab");
                    else if (this._useDesktopQRFlow) this._createPromise = this._createPromise.then(function(client) {
                        var config = client.getConfiguration().gatewayConfiguration;
                        return createVenmoDesktop({
                            url: config.assetsUrl + "/web/" + VERSION + "/html/venmo-desktop-frame.html",
                            environment: config.environment === "production" ? "PRODUCTION" : "SANDBOX",
                            profileId: self1._profileId || config.payWithVenmo.merchantId,
                            paymentMethodUsage: self1._paymentMethodUsage,
                            displayName: self1._displayName,
                            Promise: Promise,
                            apiRequest: function apiRequest(query, data) {
                                return client.request({
                                    api: "graphQLApi",
                                    data: {
                                        query: query,
                                        variables: data
                                    }
                                }).then(function(response) {
                                    return response.data;
                                });
                            },
                            sendEvent: function sendEvent(eventName) {
                                analytics.sendEvent(self1._createPromise, eventName);
                            },
                            verifyDomain: isVerifiedDomain
                        }).then(function(venmoDesktopInstance) {
                            self1._venmoDesktopInstance = venmoDesktopInstance;
                            analytics.sendEvent(self1._createPromise, "venmo.desktop-flow.presented");
                            return client;
                        })["catch"](function() {
                            analytics.sendEvent(self1._createPromise, "venmo.desktop-flow.setup-failed");
                            self1._useDesktopQRFlow = false;
                            return client;
                        });
                    });
                    else if (this._shouldCreateVenmoPaymentContext) {
                        // these variables are only relevant for the manual return flow
                        // and they are only set to make testing easier (so they can
                        // be overwritten with smaller values in the tests)
                        this._mobilePollingInterval = DEFAULT_MOBILE_POLLING_INTERVAL;
                        this._mobilePollingExpiresThreshold = DEFAULT_MOBILE_EXPIRING_THRESHOLD;
                        this._createPromise = this._createPromise.then(function(client) {
                            var paymentContextPromise, webLoginPromise;
                            var analyticsCategory = self1._cannotHaveReturnUrls ? "manual-return" : "mobile-payment-context";
                            var config = client.getConfiguration();
                            webLoginPromise = desktopWebLogin.setupDesktopWebLogin({
                                assetsUrl: config.gatewayConfiguration.assetsUrl,
                                debug: config.isDebug
                            }).then(function(frameServiceInstance) {
                                self1._frameServiceInstance = frameServiceInstance;
                            })["catch"](function(desktopWebErr) {
                                return desktopWebErr;
                            });
                            self1._mobilePollingContextEnvironment = config.gatewayConfiguration.environment.toUpperCase();
                            paymentContextPromise = self1._createVenmoPaymentContext(client).then(function() {
                                analytics.sendEvent(self1._createPromise, "venmo." + analyticsCategory + ".presented");
                                return client;
                            })["catch"](function(err) {
                                analytics.sendEvent(self1._createPromise, "venmo." + analyticsCategory + ".setup-failed");
                                return Promise.reject(new BraintreeError({
                                    type: errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.type,
                                    code: errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.code,
                                    message: isValidationError(err) ? err.details.originalError[0].message : errors.VENMO_MOBILE_PAYMENT_CONTEXT_SETUP_FAILED.message,
                                    details: {
                                        originalError: err
                                    }
                                }));
                            });
                            return ExtendedPromise.all([
                                webLoginPromise,
                                paymentContextPromise
                            ]).then(function(results) {
                                var paymentContextResult = results[1]; // We only care about the returned value of the paymentContextPromise
                                return Promise.resolve(paymentContextResult);
                            })["catch"](function(promiseErr) {
                                // ExtendedPromise.all returns just one error and it's either which fails first/at all.
                                return Promise.reject(promiseErr);
                            });
                        });
                    }
                }
                function isValidationError(err) {
                    return err.details && err.details.originalError && err.details.originalError[0] && err.details.originalError[0].extensions && err.details.originalError[0].extensions.errorClass === "VALIDATION" && err.details.originalError[0].extensions.errorType === "user_error";
                }
                Venmo.prototype._createVenmoPaymentContext = function(client, cancelIfTokenizationInProgress) {
                    var self1 = this;
                    var promise, transactionDetails;
                    var configuration = client.getConfiguration();
                    var venmoConfiguration = configuration.gatewayConfiguration.payWithVenmo;
                    var transactionDetailsPresent = false;
                    var customerClientChannel = self1._useAllowDesktopWebLogin ? "NATIVE_WEB" : "MOBILE_WEB";
                    if (!this._shouldCreateVenmoPaymentContext) return Promise.resolve();
                    if (this._shouldUseLegacyFlow) promise = client.request({
                        api: "graphQLApi",
                        data: {
                            query: graphqlQueries.LEGACY_CREATE_PAYMENT_CONTEXT_QUERY,
                            variables: {
                                input: {
                                    environment: this._mobilePollingContextEnvironment,
                                    intent: "PAY_FROM_APP"
                                }
                            }
                        }
                    }).then(function(response) {
                        return response.data.createVenmoQRCodePaymentContext.venmoQRCodePaymentContext;
                    });
                    else {
                        // Merchants are not allowed to collect user addresses unless ECD (Enriched Customer Data) is enabled on the BT Control Panel.
                        if ((this._collectCustomerBillingAddress || this._collectCustomerShippingAddress) && !venmoConfiguration.enrichedCustomerDataEnabled) return Promise.reject(new BraintreeError(errors.VENMO_ECD_DISABLED));
                        if (this._lineItems) this._lineItems.forEach(function(item) {
                            item.unitTaxAmount = item.unitTaxAmount || "0";
                        });
                        transactionDetails = {
                            subTotalAmount: this._subTotalAmount,
                            discountAmount: this._discountAmount,
                            taxAmount: this._taxAmount,
                            shippingAmount: this._shippingAmount,
                            totalAmount: this._totalAmount,
                            lineItems: this._lineItems
                        };
                        transactionDetailsPresent = Object.keys(transactionDetails).some(function(detail) {
                            return transactionDetails[detail] !== undefined; // eslint-disable-line no-undefined
                        });
                        promise = client.request({
                            api: "graphQLApi",
                            data: {
                                query: graphqlQueries.CREATE_PAYMENT_CONTEXT_QUERY,
                                variables: {
                                    input: {
                                        paymentMethodUsage: this._paymentMethodUsage,
                                        intent: "CONTINUE",
                                        customerClient: customerClientChannel,
                                        isFinalAmount: this._isFinalAmount,
                                        displayName: this._displayName,
                                        paysheetDetails: {
                                            collectCustomerBillingAddress: this._collectCustomerBillingAddress,
                                            collectCustomerShippingAddress: this._collectCustomerShippingAddress,
                                            transactionDetails: transactionDetailsPresent ? transactionDetails : undefined
                                        }
                                    }
                                }
                            }
                        }).then(function(response) {
                            return response.data.createVenmoPaymentContext.venmoPaymentContext;
                        });
                    }
                    return promise.then(function(context) {
                        var expiredTime = new Date(context.expiresAt) - new Date(context.createdAt);
                        var refreshIn = expiredTime * 0.6666;
                        // prevents multiple setTimeouts from firing from separate calls
                        // to create a payment context by canceling the previous one
                        // if there is a pending call
                        clearTimeout(self1._refreshPaymentContextTimeout);
                        self1._refreshPaymentContextTimeout = setTimeout(function() {
                            if (self1._tokenizationInProgress) return;
                            self1._createVenmoPaymentContext(client, true);
                        }, refreshIn);
                        if (cancelIfTokenizationInProgress && self1._tokenizationInProgress) return;
                        self1._venmoPaymentContextStatus = context.status;
                        self1._venmoPaymentContextId = context.id;
                    });
                };
                Venmo.prototype.appSwitch = function(url) {
                    if (this._deepLinkReturnUrl) {
                        if (isIosWebviewInDeepLinkReturnUrlFlow()) {
                            analytics.sendEvent(this._createPromise, "venmo.appswitch.start.ios-webview");
                            // Deep link URLs do not launch iOS apps from a webview when using window.open or PopupBridge.open.
                            window.location.href = url;
                        } else if (window.popupBridge && typeof window.popupBridge.open === "function") {
                            analytics.sendEvent(this._createPromise, "venmo.appswitch.start.popup-bridge");
                            window.popupBridge.open(url);
                        } else {
                            analytics.sendEvent(this._createPromise, "venmo.appswitch.start.webview");
                            window.open(url);
                        }
                    } else {
                        analytics.sendEvent(this._createPromise, "venmo.appswitch.start.browser");
                        if (browserDetection.doesNotSupportWindowOpenInIos() || this._shouldUseRedirectStrategy()) window.location.href = url;
                        else window.open(url);
                    }
                };
                Venmo.prototype.getUrl = function() {
                    return this._createPromise.then((function(client) {
                        var configuration = client.getConfiguration();
                        var params = {};
                        var currentUrl = this._deepLinkReturnUrl || window.location.href.replace(window.location.hash, "");
                        var venmoConfiguration = configuration.gatewayConfiguration.payWithVenmo;
                        var analyticsMetadata = configuration.analyticsMetadata;
                        var accessToken = venmoConfiguration.accessToken;
                        var braintreeData = {
                            _meta: {
                                version: analyticsMetadata.sdkVersion,
                                integration: analyticsMetadata.integration,
                                platform: analyticsMetadata.platform,
                                sessionId: analyticsMetadata.sessionId
                            }
                        };
                        this._isDebug = configuration.isDebug;
                        this._assetsUrl = configuration.gatewayConfiguration.assetsUrl;
                        currentUrl = currentUrl.replace(/#*$/, "");
                        /* eslint-disable camelcase */ if (this._venmoPaymentContextId) {
                            if (this._shouldUseLegacyFlow) // NEXT_MAJOR_VERSION stop adding the context id to the access token.
                            // the context id is placed here for backwards compatiblity
                            // with versions of the venmo app that did not support
                            // pulling the resource id off of the query params
                            accessToken += "|pcid:" + this._venmoPaymentContextId;
                            else params.resource_id = this._venmoPaymentContextId;
                        }
                        if (this._shouldIncludeReturnUrls() || this._useAllowDesktopWebLogin) {
                            if (this._useAllowDesktopWebLogin) currentUrl = this._assetsUrl + "/web/" + VERSION + "/html/redirect-frame.html";
                            params["x-success"] = currentUrl + "#venmoSuccess=1";
                            params["x-cancel"] = currentUrl + "#venmoCancel=1";
                            params["x-error"] = currentUrl + "#venmoError=1";
                        } else {
                            params["x-success"] = "NOOP";
                            params["x-cancel"] = "NOOP";
                            params["x-error"] = "NOOP";
                        }
                        if (!this._allowAndroidRecreation) params.allowAndroidRecreation = 0;
                        else params.allowAndroidRecreation = 1;
                        params.ua = window.navigator.userAgent;
                        params.braintree_merchant_id = this._profileId || venmoConfiguration.merchantId;
                        params.braintree_access_token = accessToken;
                        params.braintree_environment = venmoConfiguration.environment;
                        params.braintree_sdk_data = btoa(JSON.stringify(braintreeData));
                        return getVenmoUrl({
                            useAllowDesktopWebLogin: this._useAllowDesktopWebLogin,
                            mobileWebFallBack: this._mobileWebFallBack
                        }) + "?" + querystring.stringify(params);
                    }).bind(this));
                };
                /**
 * Returns a boolean indicating whether the current browser supports Venmo as a payment method. Please note that iOS Chrome is not supported when the Venmo button is rendered in an iFrame.
 *
 * If `options.allowNewBrowserTab` is false when calling {@link module:braintree-web/venmo.create|venmo.create}, this method will return true only for browsers known to support returning from the Venmo app to the same browser tab. Currently, this is limited to iOS Safari and Android Chrome.
 * If `options.allowWebviews` is false when calling {@link module:braintree-web/venmo.create|venmo.create}, this method will return true only for mobile browsers that are not webviews.
 * @public
 * @returns {boolean} True if the current browser is supported, false if not.
 */ Venmo.prototype.isBrowserSupported = function() {
                    return isBrowserSupported.isBrowserSupported({
                        allowNewBrowserTab: this._allowNewBrowserTab,
                        allowWebviews: this._allowWebviews,
                        allowDesktop: this._allowDesktop,
                        allowDesktopWebLogin: this._allowDesktopWebLogin
                    });
                };
                /**
 * Returns a boolean indicating whether a Venmo tokenization result is ready to be processed immediately.
 *
 * This method should be called after initialization to see if the result of Venmo authorization is available. If it returns true, call {@link Venmo#tokenize|tokenize} immediately to process the results.
 *
 * @public
 * @returns {boolean} True if the results of Venmo payment authorization are available and ready to process.
 */ Venmo.prototype.hasTokenizationResult = function() {
                    return this._hasTokenizationResult();
                };
                // a private version that lets us pass in a custom hash
                // when listening on a hashchange event
                Venmo.prototype._hasTokenizationResult = function(hash) {
                    var params = getFragmentParameters(hash);
                    return typeof (params.venmoSuccess || params.venmoError || params.venmoCancel) !== "undefined";
                };
                Venmo.prototype._shouldIncludeReturnUrls = function() {
                    // when a deep link return url is passed, we should always
                    // respect it and include the return urls so the venmo app
                    // can app switch back to it
                    if (this._deepLinkReturnUrl) return true;
                    // when the sdk is initialized within an iframe, it's
                    // impossible to return back to the correct place automatically
                    // without also setting a deepLinkReturnUrl. When the return
                    // urls are omitted, the Venmo app prompts the user to return
                    // manually.
                    return !this._cannotHaveReturnUrls;
                };
                Venmo.prototype._isDesktop = function() {
                    return !(browserDetection.isIos() || browserDetection.isAndroid());
                };
                /**
 * Launches the Venmo flow and returns a nonce payload.
 *
 * If {@link Venmo#hasTokenizationResult|hasTokenizationResult} returns true, calling tokenize will immediately process and return the results without initiating the Venmo payment authorization flow.
 *
 * Only one Venmo flow can be active at a time. One way to achieve this is to disable your Venmo button while the flow is open.
 * @public
 * @param {object} [options] Options for tokenization.
 * @param {number} [options.processResultsDelay=500] The amount of time in milliseconds to delay processing the results. In most cases, this value should be left as the default.
 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link Venmo~tokenizePayload|tokenizePayload}. If no callback is provided, the method will return a Promise that resolves with a {@link Venmo~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * button.addEventListener('click', function () {
 *   // Disable the button so that we don't attempt to open multiple popups.
 *   button.setAttribute('disabled', 'disabled');
 *
 *   // Because tokenize opens a new window, this must be called
 *   // as a result of a user action, such as a button click.
 *   venmoInstance.tokenize().then(function (payload) {
 *     // Submit payload.nonce to your server
 *     // Use payload.username to get the Venmo username and display any UI
 *   }).catch(function (tokenizeError) {
 *     // Handle flow errors or premature flow closure
 *     switch (tokenizeErr.code) {
 *       case 'VENMO_APP_CANCELED':
 *         console.log('User canceled Venmo flow.');
 *         break;
 *       case 'VENMO_CANCELED':
 *         console.log('User canceled Venmo, or Venmo app is not available.');
 *         break;
 *       default:
 *         console.error('Error!', tokenizeErr);
 *     }
 *   }).then(function () {
 *     button.removeAttribute('disabled');
 *   });
 * });
 */ Venmo.prototype.tokenize = function(options) {
                    var self1 = this;
                    var tokenizationPromise;
                    options = options || {};
                    if (this._tokenizationInProgress === true) return Promise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_REQUEST_ACTIVE));
                    this._tokenizationInProgress = true;
                    if (this._useDesktopQRFlow) // for the desktop flow, we create a venmo payment
                    // context and then present a qr code modal to the
                    // customer and they will open up their venmo app
                    // and scan it and approve the purchase on their
                    // mobile device. The sdk will start polling
                    // in order to determine when the status of the
                    // payment context has updated and then pass the
                    // resulting nonce back to the merchant.
                    tokenizationPromise = this._tokenizeForDesktopQRFlow(options);
                    else if (this._useAllowDesktopWebLogin) /**
     * For Desktop Web Login, we open a browser popup to allow for authorization. Once authorized, the redirect urls are used by Venmo, and we query the API for a payment context status update.
     *
     * - Payment context is created on initialization
     * - Popup is opened to Venmo login url.
     *  - The payment is authorized or canceled, and the popup is closed
     * - Once the popup is closed, we query the API for a payment context status update
     *
     * This is an alternate, opt-in flow to be used the Desktop QR Flow is not desired for Pay with Venmo desktop experiences.
     */ tokenizationPromise = this._tokenizeWebLoginWithRedirect();
                    else if (this._cannotHaveReturnUrls) // in the manual return strategy, we create the payment
                    // context on initialization, then continually poll once
                    // the app switch begins until we get a response indiciating
                    // the payment context was approved by the customer on the
                    // Venmo app. The payment context response also includes a
                    // nonce. There are 2 cases where we use the manual return
                    // strategy:
                    // 1. the sdk is instantiated in an iframe, because
                    //    the venmo app is unable to redirect automatically
                    //    when that is the case so we rely on the customer
                    //    to do a manual redirect and continunally poll for
                    //    updates on the payment context to get the nonce
                    // 2. same deal for when `requireManualReturn` is configured
                    tokenizationPromise = this._tokenizeForMobileWithManualReturn();
                    else // the default mobile flow is to app switch to the
                    // venmo app, and then have the venmo app switch
                    // back to the page with the venmo nonce details
                    // encoded into the hash portion of the url. If
                    // `paymentMethodUsage` is provided when instantiating
                    // the sdk, we also create a payment context and pass
                    // the resource id to the Venmo app during the app switch.
                    // Once we get a succesful return, we ping the payment
                    // context query to get any additional data needed
                    // to send back to the merchant.
                    tokenizationPromise = this._tokenizeForMobileWithHashChangeListeners(options);
                    return tokenizationPromise.then(function(payload) {
                        return self1._createPromise.then(function(client) {
                            return self1._createVenmoPaymentContext(client);
                        }).then(function() {
                            self1._tokenizationInProgress = false;
                            return formatTokenizePayload(payload);
                        });
                    })["catch"](function(err) {
                        return self1._createPromise.then(function(client) {
                            // We create a new Payment Context because if the last one failed, then presumably we don't want to use it again.
                            // On the first pass, we create the payment context at initialization, and since we used that first one we now need to create a new one
                            // for the next time someone tries to tokenize.
                            return self1._createVenmoPaymentContext(client);
                        }).then(function() {
                            self1._tokenizationInProgress = false;
                            return Promise.reject(err);
                        });
                    });
                };
                /**
 * Cancels the venmo tokenization process
 *
 * @public
 * @function Venmo~cancelTokenization
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 * @example
 * venmoTokenizeButton.addEventListener('click', function () {
 *   venmoInstance.tokenize().then(function (payload) {
 *     // handle payload
 *   }).catch(function (err) {
 *     if (err.code === 'VENMO_TOKENIZATION_CANCELED_BY_MERCHANT') {
 *       // tokenization was canceled by calling cancelTokenization
 *     }
 *   });
 * });
 *
 * venmoCancelButton.addEventListener('click', function () {
 *   // Hide the button when the venmo flow is not in progress
 *   venmoCancelButton.style.display = "none";
 *
 *   venmoInstance.cancelTokenization().then(function () {
 *     // done canceling the flow
 *   }).catch(function (err) {
 *     // should only get here if there is no tokenization in progress
 *   });
 * });
 */ Venmo.prototype.cancelTokenization = function() {
                    if (!this._tokenizationInProgress) return Promise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_REQUEST_NOT_ACTIVE));
                    this._removeVisibilityEventListener();
                    // important to reject the tokenization promise first
                    // so the tokenize method rejects with this error
                    // rather than a customer canceled error in the mobile
                    // polling and desktop flows
                    if (this._tokenizePromise) this._tokenizePromise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_CANCELED_BY_MERCHANT));
                    return Promise.all([
                        this._cancelMobilePaymentContext(),
                        this._cancelVenmoDesktopContext()
                    ]);
                };
                Venmo.prototype._tokenizeWebLoginWithRedirect = function() {
                    var self1 = this;
                    analytics.sendEvent(self1._createPromise, "venmo.tokenize.web-login.start");
                    this._tokenizePromise = new ExtendedPromise();
                    return this.getUrl().then(function(url) {
                        desktopWebLogin.runWebLogin({
                            checkForStatusChange: self1._checkPaymentContextStatusAndProcessResult.bind(self1),
                            cancelTokenization: self1.cancelTokenization.bind(self1),
                            frameServiceInstance: self1._frameServiceInstance,
                            venmoUrl: url,
                            debug: self1._isDebug,
                            checkPaymentContextStatus: self1._checkPaymentContextStatus.bind(self1)
                        }).then(function(payload) {
                            analytics.sendEvent(self1._createPromise, "venmo.tokenize.web-login.success");
                            self1._tokenizePromise.resolve({
                                paymentMethodNonce: payload.paymentMethodId,
                                username: payload.userName,
                                payerInfo: payload.payerInfo,
                                id: self1._venmoPaymentContextId
                            });
                        })["catch"](function(err) {
                            analytics.sendEvent(self1._createPromise, "venmo.tokenize.web-login.failure");
                            self1._tokenizePromise.reject(err);
                        });
                        return self1._tokenizePromise;
                    });
                };
                Venmo.prototype._queryPaymentContextStatus = function(id) {
                    var self1 = this;
                    return this._createPromise.then(function(client) {
                        var query = self1._shouldUseLegacyFlow ? graphqlQueries.LEGACY_VENMO_PAYMENT_CONTEXT_STATUS_QUERY : graphqlQueries.VENMO_PAYMENT_CONTEXT_STATUS_QUERY;
                        return client.request({
                            api: "graphQLApi",
                            data: {
                                query: query,
                                variables: {
                                    id: id
                                }
                            }
                        });
                    }).then(function(response) {
                        return response.data.node;
                    });
                };
                /**
 * Queries the GraphQL API to get the payment context and process the status. Retries until there is an update to the payment context status.
 * @name Venmo~checkPaymentContextStatusAndProcessResult
 * @ignore
 * @param {number} retryCount The counter for tracking number of retries made against the API.
 * @returns {Promise} Returns a promise
 */ Venmo.prototype._checkPaymentContextStatusAndProcessResult = function(retryCount) {
                    var self1 = this;
                    return self1._checkPaymentContextStatus().then(function(node) {
                        var resultStatus = node.status;
                        if (resultStatus !== self1._venmoPaymentContextStatus) {
                            self1._venmoPaymentContextStatus = resultStatus;
                            analytics.sendEvent(self1._createPromise, "venmo.tokenize.web-login.status-change");
                            switch(resultStatus){
                                case "APPROVED":
                                    return Promise.resolve(node);
                                case "CANCELED":
                                    return Promise.reject(new BraintreeError(errors.VENMO_CUSTOMER_CANCELED));
                                case "FAILED":
                                    return Promise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_FAILED));
                                default:
                            }
                        }
                        return new Promise(function(resolve, reject) {
                            if (retryCount < self1._maxRetryCount) {
                                retryCount++;
                                return self1._checkPaymentContextStatusAndProcessResult(retryCount).then(resolve)["catch"](reject);
                            }
                            return reject(new BraintreeError(errors.VENMO_TOKENIZATION_FAILED));
                        });
                    });
                };
                Venmo.prototype._checkPaymentContextStatus = function() {
                    var self1 = this;
                    return self1._queryPaymentContextStatus(self1._venmoPaymentContextId)["catch"](function(networkError) {
                        return Promise.reject(new BraintreeError({
                            type: errors.VENMO_NETWORK_ERROR.type,
                            code: errors.VENMO_NETWORK_ERROR.code,
                            message: errors.VENMO_NETWORK_ERROR.message,
                            details: networkError
                        }));
                    }).then(function(node) {
                        return Promise.resolve(node);
                    });
                };
                Venmo.prototype._pollForStatusChange = function() {
                    var self1 = this;
                    if (Date.now() > self1._mobilePollingContextExpiresIn) return Promise.reject(new BraintreeError(errors.VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT));
                    return this._queryPaymentContextStatus(this._venmoPaymentContextId)["catch"](function(networkError) {
                        return Promise.reject(new BraintreeError({
                            type: errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.type,
                            code: errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.code,
                            message: errors.VENMO_MOBILE_POLLING_TOKENIZATION_NETWORK_ERROR.message,
                            details: {
                                originalError: networkError
                            }
                        }));
                    }).then(function(node) {
                        var newStatus = node.status;
                        if (newStatus !== self1._venmoPaymentContextStatus) {
                            self1._venmoPaymentContextStatus = newStatus;
                            analytics.sendEvent(self1._createPromise, "venmo.tokenize.manual-return.status-change." + newStatus.toLowerCase());
                            switch(newStatus){
                                case "EXPIRED":
                                case "FAILED":
                                case "CANCELED":
                                    return Promise.reject(new BraintreeError(errors["VENMO_MOBILE_POLLING_TOKENIZATION_" + newStatus]));
                                case "APPROVED":
                                    return Promise.resolve(node);
                                case "CREATED":
                                case "SCANNED":
                                default:
                            }
                        }
                        return new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                self1._pollForStatusChange().then(resolve)["catch"](reject);
                            }, self1._mobilePollingInterval);
                        });
                    });
                };
                Venmo.prototype._tokenizeForMobileWithManualReturn = function() {
                    var self1 = this;
                    analytics.sendEvent(this._createPromise, "venmo.tokenize.manual-return.start");
                    this._mobilePollingContextExpiresIn = Date.now() + this._mobilePollingExpiresThreshold;
                    this._tokenizePromise = new ExtendedPromise();
                    this._pollForStatusChange().then(function(payload) {
                        analytics.sendEvent(self1._createPromise, "venmo.tokenize.manual-return.success");
                        self1._tokenizePromise.resolve({
                            paymentMethodNonce: payload.paymentMethodId,
                            username: payload.userName,
                            payerInfo: payload.payerInfo,
                            id: self1._venmoPaymentContextId
                        });
                    })["catch"](function(err) {
                        analytics.sendEvent(self1._createPromise, "venmo.tokenize.manual-return.failure");
                        self1._tokenizePromise.reject(err);
                    });
                    return this.getUrl().then(function(url) {
                        self1.appSwitch(url);
                        return self1._tokenizePromise;
                    });
                };
                Venmo.prototype._shouldUseRedirectStrategy = function() {
                    if (!browserDetection.isIos()) return false;
                    if (this._mobileWebFallBack === true) return true;
                    return this._useRedirectForIOS;
                };
                Venmo.prototype._tokenizeForMobileWithHashChangeListeners = function(options) {
                    var self1 = this;
                    var resultProcessingInProgress, visibilityChangeListenerTimeout;
                    if (this.hasTokenizationResult()) return this.processHashChangeFlowResults();
                    analytics.sendEvent(this._createPromise, "venmo.tokenize.mobile.start");
                    this._tokenizePromise = new ExtendedPromise();
                    this._previousHash = window.location.hash;
                    function completeFlow(hash) {
                        var error;
                        self1.processHashChangeFlowResults(hash)["catch"](function(err) {
                            error = err;
                        }).then(function(res) {
                            if (!self1._ignoreHistoryChanges && window.location.hash !== self1._previousHash) window.location.hash = self1._previousHash;
                            self1._removeVisibilityEventListener();
                            if (error) self1._tokenizePromise.reject(error);
                            else self1._tokenizePromise.resolve(res);
                            delete self1._tokenizePromise;
                        });
                    }
                    // The Venmo SDK app switches back with the results of the
                    // tokenization encoded in the hash
                    this._onHashChangeListener = function(e) {
                        var hash = e.newURL.split("#")[1];
                        if (!self1._hasTokenizationResult(hash)) return;
                        resultProcessingInProgress = true;
                        clearTimeout(visibilityChangeListenerTimeout);
                        completeFlow(hash);
                    };
                    window.addEventListener("hashchange", this._onHashChangeListener, false);
                    // Subscribe to document visibility change events to detect when app switch
                    // has returned. Acts as a fallback for the hashchange listener and catches
                    // the cancel case via manual app switch back
                    this._visibilityChangeListener = function() {
                        var delay = options.processResultsDelay || constants.DEFAULT_PROCESS_RESULTS_DELAY;
                        if (!window.document.hidden) {
                            if (!resultProcessingInProgress) visibilityChangeListenerTimeout = setTimeout(completeFlow, delay);
                        }
                    };
                    return this.getUrl().then(function(url) {
                        self1.appSwitch(url);
                        // Add a brief delay to ignore visibility change events that occur right before app switch
                        setTimeout(function() {
                            window.document.addEventListener(documentVisibilityChangeEventName(), self1._visibilityChangeListener);
                        }, constants.DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY);
                        return self1._tokenizePromise;
                    });
                };
                Venmo.prototype._tokenizeForDesktopQRFlow = function() {
                    var self1 = this;
                    analytics.sendEvent(this._createPromise, "venmo.tokenize.desktop.start");
                    this._tokenizePromise = new ExtendedPromise();
                    this._createPromise.then(function() {
                        return self1._venmoDesktopInstance.launchDesktopFlow();
                    }).then(function(payload) {
                        self1._venmoDesktopInstance.hideDesktopFlow();
                        analytics.sendEvent(self1._createPromise, "venmo.tokenize.desktop.success");
                        self1._tokenizePromise.resolve(payload);
                    })["catch"](function(err) {
                        analytics.sendEvent(self1._createPromise, "venmo.tokenize.desktop.failure");
                        if (self1._venmoDesktopInstance) self1._venmoDesktopInstance.hideDesktopFlow();
                        if (err && err.reason === "CUSTOMER_CANCELED") {
                            self1._tokenizePromise.reject(new BraintreeError(errors.VENMO_DESKTOP_CANCELED));
                            return;
                        }
                        self1._tokenizePromise.reject(new BraintreeError({
                            type: errors.VENMO_DESKTOP_UNKNOWN_ERROR.type,
                            code: errors.VENMO_DESKTOP_UNKNOWN_ERROR.code,
                            message: errors.VENMO_DESKTOP_UNKNOWN_ERROR.message,
                            details: {
                                originalError: err
                            }
                        }));
                    });
                    return this._tokenizePromise;
                };
                Venmo.prototype._cancelMobilePaymentContext = function() {
                    var self1 = this;
                    return this._createPromise.then(function(client) {
                        var query;
                        if (self1._venmoPaymentContextId) {
                            query = self1._shouldUseLegacyFlow ? graphqlQueries.LEGACY_UPDATE_PAYMENT_CONTEXT_QUERY : graphqlQueries.UPDATE_PAYMENT_CONTEXT_QUERY;
                            return client.request({
                                api: "graphQLApi",
                                data: {
                                    query: query,
                                    variables: {
                                        input: {
                                            id: self1._venmoPaymentContextId,
                                            status: "CANCELED"
                                        }
                                    }
                                }
                            });
                        }
                        return Promise.resolve();
                    });
                };
                Venmo.prototype._cancelVenmoDesktopContext = function() {
                    var self1 = this;
                    return this._createPromise.then(function() {
                        if (self1._venmoDesktopInstance) self1._venmoDesktopInstance.updateVenmoDesktopPaymentContext("CANCELED");
                        return Promise.resolve();
                    });
                };
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/venmo.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * venmoInstance.teardown();
 * @example <caption>With callback</caption>
 * venmoInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ Venmo.prototype.teardown = function() {
                    var self1 = this;
                    this._removeVisibilityEventListener();
                    return this._createPromise.then((function() {
                        if (self1._venmoDesktopInstance) self1._venmoDesktopInstance.teardown();
                        clearTimeout(self1._refreshPaymentContextTimeout);
                        self1._cancelMobilePaymentContext();
                        convertMethodsToError(this, methods(Venmo.prototype));
                    }).bind(this));
                };
                Venmo.prototype._removeVisibilityEventListener = function() {
                    window.removeEventListener("hashchange", this._onHashChangeListener);
                    window.document.removeEventListener(documentVisibilityChangeEventName(), this._visibilityChangeListener);
                    delete this._visibilityChangeListener;
                    delete this._onHashChangeListener;
                };
                /**
 * The hash parameter in this function is optional. If no hash parameter is passed, the `getFragmentParameters` function will default to the hash present in the website's URL instead.
 *
 * There are two scenarios where this method is called:
 *
 * 1. When called within a browser that is capable of returning to the same tab that started the Venmo flow, we set up a listener to detect hash changes in the url. Part of the return to the merchant's website from the Venmo app includes encoding the details of the purchase in the hash of the url. The callback is invoked and the hash is pulled off from the event payload. The reason we pull the hash off of the event payload instead of pulling it directly from the URL is because sometimes a single page app will use the hash parameter for it's routing system, and it's possible to hit a race condition where the routing code has already removed the Venmo specific attributes from the hash before we are able to pull it off the url. Grabbing the hash from the event handler instead ensures we get the Venmo details, no matter what the url is converted to.
 * 2. The other scenario is for browsers that cannot return to the same tab, and instead the Venmo app must open a new tab. Since there is no hash listener to pull the hash from, we pull the hash details directly from the url using the `getFragmentParameters` method.
 *
 * @ignore
 * @param {string} [hash] Optionally provided browser url hash.
 * @returns {Promise} Returns a promise
 */ Venmo.prototype.processHashChangeFlowResults = function(hash) {
                    var self1 = this;
                    var params = getFragmentParameters(hash);
                    // NEXT_MAJOR_VERSION only rely on payment context status call and stop relying on the
                    // content of the hash
                    return new Promise(function(resolve, reject) {
                        if (!self1._shouldUseLegacyFlow) self1._pollForStatusChange().then(function(payload) {
                            analytics.sendEvent(self1._createPromise, "venmo.appswitch.handle.payment-context-status-query.success");
                            return resolve({
                                paymentMethodNonce: payload.paymentMethodId,
                                username: payload.userName,
                                payerInfo: payload.payerInfo,
                                id: self1._venmoPaymentContextId
                            });
                        })["catch"](function(err) {
                            if (err.type === errors.VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED.type) // We want to reject in this case because if it the process was canceled, we don't want to take the happy path
                            reject(err);
                            analytics.sendEvent(self1._createPromise, "venmo.process-results.payment-context-status-query-failed");
                            // If the polling request fails, but not because of cancelization, we will rely on the params provided from the hash
                            resolve(params);
                        });
                        else if (params.venmoSuccess) {
                            analytics.sendEvent(self1._createPromise, "venmo.appswitch.handle.success");
                            resolve(params);
                        } else if (params.venmoError) {
                            analytics.sendEvent(self1._createPromise, "venmo.appswitch.handle.error");
                            reject(new BraintreeError({
                                type: errors.VENMO_APP_FAILED.type,
                                code: errors.VENMO_APP_FAILED.code,
                                message: errors.VENMO_APP_FAILED.message,
                                details: {
                                    originalError: {
                                        message: decodeURIComponent(params.errorMessage),
                                        code: params.errorCode
                                    }
                                }
                            }));
                        } else if (params.venmoCancel) {
                            analytics.sendEvent(self1._createPromise, "venmo.appswitch.handle.cancel");
                            reject(new BraintreeError(errors.VENMO_APP_CANCELED));
                        } else {
                            // User has either manually switched back to browser, or app is not available for app switch
                            analytics.sendEvent(self1._createPromise, "venmo.appswitch.cancel-or-unavailable");
                            reject(new BraintreeError(errors.VENMO_CANCELED));
                        }
                        self1._clearFragmentParameters();
                    });
                };
                Venmo.prototype._clearFragmentParameters = function() {
                    if (this._ignoreHistoryChanges) return;
                    if (typeof window.history.replaceState === "function" && window.location.hash) history.pushState({}, "", window.location.href.slice(0, window.location.href.indexOf("#")));
                };
                function getFragmentParameters(hash) {
                    var keyValuesArray = (hash || window.location.hash.substring(1)).split("&");
                    var parsedParams = keyValuesArray.reduce(function(toReturn, keyValue) {
                        var parts = keyValue.split("=");
                        // some Single Page Apps may pre-pend a / to the first value
                        // in the hash, assuming it's a route in their app
                        // instead of information from Venmo, this removes all
                        // non-alphanumeric characters from the keys in the params
                        var decodedKey = decodeURIComponent(parts[0]).replace(/\W/g, "");
                        var key = snakeCaseToCamelCase(decodedKey);
                        var value = decodeURIComponent(parts[1]);
                        toReturn[key] = value;
                        return toReturn;
                    }, {});
                    if (parsedParams.resourceId) parsedParams.id = parsedParams.resourceId;
                    return parsedParams;
                }
                function formatUserName(username) {
                    username = username || "";
                    // NEXT_MAJOR_VERSION the web sdks have a prepended @ sign
                    // but the ios and android ones do not. This should be standardized
                    return "@" + username.replace("@", "");
                }
                function formatTokenizePayload(payload) {
                    var formattedPayload = {
                        nonce: payload.paymentMethodNonce,
                        type: "VenmoAccount",
                        details: {
                            username: formatUserName(payload.username),
                            paymentContextId: payload.id
                        }
                    };
                    if (payload.payerInfo) {
                        formattedPayload.details.payerInfo = payload.payerInfo;
                        formattedPayload.details.payerInfo.userName = formatUserName(payload.payerInfo.userName);
                    }
                    return formattedPayload;
                }
                // From https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
                function documentVisibilityChangeEventName() {
                    var visibilityChange;
                    if (typeof window.document.hidden !== "undefined") // Opera 12.10 and Firefox 18 and later support
                    visibilityChange = "visibilitychange";
                    else if (typeof window.document.msHidden !== "undefined") visibilityChange = "msvisibilitychange";
                    else if (typeof window.document.webkitHidden !== "undefined") visibilityChange = "webkitvisibilitychange";
                    return visibilityChange;
                }
                function isIosWebviewInDeepLinkReturnUrlFlow() {
                    // we know it's a webview because this flow only gets
                    // used when checking the deep link flow
                    // test the platform here to get around custom useragents
                    return window.navigator.platform && /iPhone|iPad|iPod/.test(window.navigator.platform);
                }
                module1.exports = wrapPromise.wrapPrototype(Venmo);
            },
            {
                "../lib/analytics": 138,
                "../lib/braintree-error": 143,
                "../lib/convert-methods-to-error": 146,
                "../lib/in-iframe": 169,
                "../lib/is-verified-domain": 173,
                "../lib/methods": 175,
                "../lib/querystring": 177,
                "../lib/snake-case-to-camel-case": 179,
                "./external/": 233,
                "./external/queries": 234,
                "./shared/browser-detection": 237,
                "./shared/constants": 238,
                "./shared/errors": 239,
                "./shared/get-venmo-url": 241,
                "./shared/supports-venmo": 242,
                "./shared/web-login-backdrop": 243,
                "@braintree/extended-promise": 31,
                "@braintree/wrap-promise": 40
            }
        ],
        245: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @name BraintreeError.Visa Checkout - Creation Error Codes
 * @description Errors that occur when [creating the Visa Checkout component](./module-braintree-web_venmo.html#.create).
 * @property {MERCHANT} VISA_CHECKOUT_NOT_ENABLED Occurs when Visa Checkout is not enabled in the Braintree control panel.
 */ /**
 * @name BraintreeError.Visa Checkout - createInitOptions Error Codes
 * @description Errors that occur when using the [`createInitOptions` method](./VisaCheckout.html#createInitOptions).
 * @property {MERCHANT} VISA_CHECKOUT_INIT_OPTIONS_REQUIRED Occurs when no options are provided to method.
 */ /**
 * @name BraintreeError.Visa Checkout - tokenize Error Codes
 * @description Errors that occur when using the [`tokenize` method](./VisaCheckout.html#tokenize).
 * @property {MERCHANT} VISA_CHECKOUT_PAYMENT_REQUIRED Occurs when no payment data is not provided.
 * @property {NETWORK} VISA_CHECKOUT_TOKENIZATION Occurs when tokenization fails.
 */ var BraintreeError = _dereq_("../lib/braintree-error");
                module1.exports = {
                    VISA_CHECKOUT_NOT_ENABLED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VISA_CHECKOUT_NOT_ENABLED",
                        message: "Visa Checkout is not enabled for this merchant."
                    },
                    VISA_CHECKOUT_INIT_OPTIONS_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VISA_CHECKOUT_INIT_OPTIONS_REQUIRED",
                        message: "initOptions requires an object."
                    },
                    VISA_CHECKOUT_PAYMENT_REQUIRED: {
                        type: BraintreeError.types.MERCHANT,
                        code: "VISA_CHECKOUT_PAYMENT_REQUIRED",
                        message: "tokenize requires callid, encKey, and encPaymentData."
                    },
                    VISA_CHECKOUT_TOKENIZATION: {
                        type: BraintreeError.types.NETWORK,
                        code: "VISA_CHECKOUT_TOKENIZATION",
                        message: "A network error occurred when processing the Visa Checkout payment."
                    }
                };
            },
            {
                "../lib/braintree-error": 143
            }
        ],
        246: [
            function(_dereq_, module1, exports) {
                "use strict";
                /**
 * @module braintree-web/visa-checkout
 * @description Processes Visa Checkout. *This component is currently in beta and is subject to change.*
 */ var basicComponentVerification = _dereq_("../lib/basic-component-verification");
                var BraintreeError = _dereq_("../lib/braintree-error");
                var createDeferredClient = _dereq_("../lib/create-deferred-client");
                var createAssetsUrl = _dereq_("../lib/create-assets-url");
                var VisaCheckout = _dereq_("./visa-checkout");
                var analytics = _dereq_("../lib/analytics");
                var errors = _dereq_("./errors");
                var VERSION = "3.110.0";
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                /**
 * @static
 * @function create
 * @param {object} options Creation options:
 * @param {Client} [options.client] A {@link Client} instance.
 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
 * @param {callback} [callback] The second argument, `data`, is the {@link VisaCheckout} instance. If no callback is provided, `create` returns a promise that resolves with the {@link VisaCheckout} instance.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ function create(options) {
                    var name = "Visa Checkout";
                    return basicComponentVerification.verify({
                        name: name,
                        client: options.client,
                        authorization: options.authorization
                    }).then(function() {
                        return createDeferredClient.create({
                            authorization: options.authorization,
                            client: options.client,
                            debug: options.debug,
                            assetsUrl: createAssetsUrl.create(options.authorization),
                            name: name
                        });
                    }).then(function(client) {
                        options.client = client;
                        if (!options.client.getConfiguration().gatewayConfiguration.visaCheckout) return Promise.reject(new BraintreeError(errors.VISA_CHECKOUT_NOT_ENABLED));
                        analytics.sendEvent(options.client, "visacheckout.initialized");
                        return new VisaCheckout(options);
                    });
                }
                module1.exports = {
                    create: wrapPromise(create),
                    /**
   * @description The current version of the SDK, i.e. `{@pkg version}`.
   * @type {string}
   */ VERSION: VERSION
                };
            },
            {
                "../lib/analytics": 138,
                "../lib/basic-component-verification": 141,
                "../lib/braintree-error": 143,
                "../lib/create-assets-url": 148,
                "../lib/create-deferred-client": 150,
                "./errors": 245,
                "./visa-checkout": 247,
                "@braintree/wrap-promise": 40
            }
        ],
        247: [
            function(_dereq_, module1, exports) {
                "use strict";
                var BraintreeError = _dereq_("../lib/braintree-error");
                var analytics = _dereq_("../lib/analytics");
                var errors = _dereq_("./errors");
                var jsonClone = _dereq_("../lib/json-clone");
                var methods = _dereq_("../lib/methods");
                var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
                var wrapPromise = _dereq_("@braintree/wrap-promise");
                var cardTypeTransformMap = {
                    Visa: "VISA",
                    MasterCard: "MASTERCARD",
                    Discover: "DISCOVER",
                    "American Express": "AMEX"
                };
                /**
 * Visa Checkout Address object.
 * @typedef {object} VisaCheckout~Address
 * @property {string} countryCode The customer's country code.
 * @property {string} extendedAddress The customer's extended address.
 * @property {string} firstName The customer's first name.
 * @property {string} lastName The customer's last name.
 * @property {string} locality The customer's locality.
 * @property {string} postalCode The customer's postal code.
 * @property {string} region The customer's region.
 * @property {string} streetAddress The customer's street address.
 * @property {string} phoneNumber The customer's phone number.
 */ /**
 * Visa Checkout UserData object.
 * @typedef {object} VisaCheckout~UserData
 * @property {string} userEmail The customer's email address.
 * @property {string} userFirstName The customer's first name.
 * @property {string} userLastName The customer's last name.
 * @property {string} userFullName The customer's full name.
 * @property {string} userName The customer's username.
 */ /**
 * Visa Checkout tokenize payload.
 * @typedef {object} VisaCheckout~tokenizePayload
 * @property {string} nonce The payment method nonce.
 * @property {object} details Additional account details.
 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
 * @property {string} details.lastFour Last four digits of card number.
 * @property {string} details.lastTwo Last two digits of card number.
 * @property {string} description A human-readable description.
 * @property {string} type The payment method type, always `VisaCheckoutCard`.
 * @property {VisaCheckout~Address} billingAddress The customer's billing address.
 * @property {VisaCheckout~Address} shippingAddress The customer's shipping address.
 * @property {VisaCheckout~UserData} userData Information about the customer.
 * @property {object} binData Information about the card based on the bin.
 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.countryOfIssuance The country of issuance.
 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.issuingBank The issuing bank.
 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
 * @property {string} binData.productId The product id.
 */ /**
 * @class
 * @param {object} options The Visa Checkout {@link module:braintree-web/visa-checkout.create create} options.
 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/visa-checkout.create|braintree-web.visa-checkout.create} instead.</strong>
 * @classdesc This class represents a Visa Checkout component produced by {@link module:braintree-web/visa-checkout.create|braintree-web/visa-checkout.create}. Instances of this class have methods for interacting with Visa Checkout's JavaScript library.
 */ function VisaCheckout(options) {
                    this._client = options.client;
                }
                function transformCardTypes(cardTypes) {
                    return cardTypes.reduce(function(acc, type) {
                        if (cardTypeTransformMap.hasOwnProperty(type)) return acc.concat(cardTypeTransformMap[type]);
                        return acc;
                    }, []);
                }
                /**
 * Creates an `initOptions` object from the passed `options`, applying properties that Braintree needs to transact Visa Checkout.
 *
 * Braintree will apply these properties if they do not exist on the given `options`:
 *  - `apikey`
 *  - `externalClientId`
 *  - `settings.payment.cardBrands`
 *
 * Braintree will overwrite `settings.dataLevel = 'FULL'` to access the full payment method.
 * @public
 * @param {object} options The base `initOptions` that will be used to init Visa Checkout.
 * @param {string} [options.apikey] The API key used to initialize Visa Checkout. When not supplied, Braintree will set this property.
 * @param {string} [options.externalClientId] The external client ID key used to initialize Visa Checkout. When not supplied, Braintree will set this property.
 * @param {object} [options.settings] The settings object used to initialize Visa Checkout.
 * @param {string} [options.settings.dataLevel] The data level used to initialize Visa Checkout. Braintree will overwrite this property to 'FULL'.
 * @param {object} [options.settings.payment] The payment object used to initialize Visa Checkout.
 * @param {string[]} [options.settings.payment.cardBrands] The card brands that Visa Checkout will allow the customer to pay with. When not supplied, Braintree will set this property.
 * @returns {object} `initOptions` The `initOptions` that Visa Checkout should be initialized with.
 */ VisaCheckout.prototype.createInitOptions = function(options) {
                    var initOptions;
                    var gatewayConfiguration = this._client.getConfiguration().gatewayConfiguration;
                    var visaCheckoutConfiguration = gatewayConfiguration.visaCheckout;
                    if (!options) throw new BraintreeError(errors.VISA_CHECKOUT_INIT_OPTIONS_REQUIRED);
                    initOptions = jsonClone(options);
                    initOptions.apikey = initOptions.apikey || visaCheckoutConfiguration.apikey;
                    initOptions.encryptionKey = visaCheckoutConfiguration.encryptionKey;
                    initOptions.externalClientId = initOptions.externalClientId || visaCheckoutConfiguration.externalClientId;
                    initOptions.settings = initOptions.settings || {};
                    initOptions.settings.dataLevel = "FULL";
                    initOptions.settings.payment = initOptions.settings.payment || {};
                    if (!initOptions.settings.payment.cardBrands) initOptions.settings.payment.cardBrands = transformCardTypes(gatewayConfiguration.visaCheckout.supportedCardTypes);
                    return initOptions;
                };
                /**
 * Tokenizes the Visa Checkout payload, returning a payment method nonce.
 * @public
 * @param {object} payment The object that Visa Checkout supplies on `payment.success`.
 * @param {string} payment.callid Visa Checkout transaction ID associated with this payment.
 * @param {string} payment.encKey The encrypted key used to decrypt the payment data.
 * @param {string} payment.encPaymentData The encrypted payment data.
 * @param {callback} [callback] The second argument, <code>tokenizePayload</code> is a {@link VisaCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with the {@link VisaCheckout~tokenizePayload|tokenizePayload}.
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ VisaCheckout.prototype.tokenize = function(payment) {
                    var self1 = this;
                    if (!payment.callid || !payment.encKey || !payment.encPaymentData) return Promise.reject(new BraintreeError(errors.VISA_CHECKOUT_PAYMENT_REQUIRED));
                    return this._client.request({
                        method: "post",
                        endpoint: "payment_methods/visa_checkout_cards",
                        data: {
                            _meta: {
                                source: "visa-checkout"
                            },
                            visaCheckoutCard: {
                                callId: payment.callid,
                                encryptedPaymentData: payment.encPaymentData,
                                encryptedKey: payment.encKey
                            }
                        }
                    }).then(function(response) {
                        analytics.sendEvent(self1._client, "visacheckout.tokenize.succeeded");
                        return response.visaCheckoutCards[0];
                    })["catch"](function(err) {
                        analytics.sendEvent(self1._client, "visacheckout.tokenize.failed");
                        return Promise.reject(new BraintreeError({
                            type: errors.VISA_CHECKOUT_TOKENIZATION.type,
                            code: errors.VISA_CHECKOUT_TOKENIZATION.code,
                            message: errors.VISA_CHECKOUT_TOKENIZATION.message,
                            details: {
                                originalError: err
                            }
                        }));
                    });
                };
                /**
 * Cleanly tear down anything set up by {@link module:braintree-web/visa-checkout.create|create}.
 * @public
 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
 * @example
 * visaCheckoutInstance.teardown();
 * @example <caption>With callback</caption>
 * visaCheckoutInstance.teardown(function () {
 *   // teardown is complete
 * });
 * @returns {(Promise|void)} Returns a promise if no callback is provided.
 */ VisaCheckout.prototype.teardown = function() {
                    convertMethodsToError(this, methods(VisaCheckout.prototype));
                    return Promise.resolve();
                };
                module1.exports = wrapPromise.wrapPrototype(VisaCheckout);
            },
            {
                "../lib/analytics": 138,
                "../lib/braintree-error": 143,
                "../lib/convert-methods-to-error": 146,
                "../lib/json-clone": 174,
                "../lib/methods": 175,
                "./errors": 245,
                "@braintree/wrap-promise": 40
            }
        ]
    }, {}, [
        136
    ])(136);
});



var $769377b54b8399a0$export$a04f4fe972622dd3 = function BriantreeService(fc, buttonIds) {
    "use strict";
    var _this = this;
    var _this1 = this;
    (0, $fvacx._)(this, BriantreeService);
    this.maybeRenderButtons = function() {
        var _this_fc_config = _this.fc.config, applePayEnabled = _this_fc_config.applePayEnabled, googlePayEnabled = _this_fc_config.googlePayEnabled;
        var appleButtonCont = document.getElementById("applePayContainer");
        if (appleButtonCont) appleButtonCont.style.display = applePayEnabled && BriantreeService.appleAvailable ? "flex" : "none";
        var gpayButtonCont = document.getElementById("googlePayContainer");
        if (gpayButtonCont) gpayButtonCont.style.display = googlePayEnabled && BriantreeService.gPayAvailable ? "flex" : "none";
    };
    this.createGPayOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(product) {
            var price, paymentRequest, paymentResponse, e;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        price = (product.finalPrice + product.shippingPrice).toFixed(2);
                        return [
                            4,
                            BriantreeService.gPay.createPaymentDataRequest({
                                transactionInfo: {
                                    currencyCode: product.currencyCode,
                                    totalPriceStatus: "FINAL",
                                    totalPrice: price
                                }
                            })
                        ];
                    case 1:
                        paymentRequest = _state.sent();
                        return [
                            4,
                            BriantreeService.gPayClient.loadPaymentData(paymentRequest)
                        ];
                    case 2:
                        paymentResponse = _state.sent();
                        return [
                            4,
                            BriantreeService.gPay.parseResponse(paymentResponse)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 4:
                        e = _state.sent();
                        Errors.report(e, {
                            product: product
                        }, false, false);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(product) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createApplePaymentRequest = function(countryCode, product) {
        var expressButton = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var _totalAmount, _subTotalAmount;
        var addons = _this1.fc.getSelectedAddons();
        var totalAmount = (product === null || product === void 0 ? void 0 : product.finalPrice) + product.shippingPrice;
        if (addons && Array.isArray(addons)) addons.forEach(function(addon) {
            totalAmount += addon.finalPrice;
        });
        var subTotalAmount = product.finalPrice;
        if (addons && Array.isArray(addons)) addons.forEach(function(addon) {
            subTotalAmount += addon.finalPrice;
        });
        var shippingPrice = product.shippingPrice;
        var contactFields = expressButton ? [
            "email",
            "phone",
            "name",
            "postalAddress"
        ] : [];
        return BriantreeService.applePay.createPaymentRequest({
            countryCode: countryCode,
            currencyCode: product.currencyCode,
            total: {
                label: window.BRAND.toUpperCase(),
                amount: (_totalAmount = totalAmount) === null || _totalAmount === void 0 ? void 0 : _totalAmount.toFixed(2)
            },
            requiredShippingContactFields: contactFields,
            lineItems: [
                {
                    label: "Subtotal",
                    amount: (_subTotalAmount = subTotalAmount) === null || _subTotalAmount === void 0 ? void 0 : _subTotalAmount.toFixed(2)
                },
                {
                    label: "Shipping",
                    amount: shippingPrice === null || shippingPrice === void 0 ? void 0 : shippingPrice.toFixed(2)
                }
            ]
        });
    };
    var _this2 = this;
    this.createAppleSession = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(checkout) {
            var expressButton, _this$fc$lead, product, country, pr, session;
            var _arguments = arguments;
            return (0, $33z5g.__generator)(this, function(_state) {
                expressButton = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                product = _this2.fc.getSelectedProduct();
                country = ((_this$fc$lead = _this2.fc.lead) === null || _this$fc$lead === void 0 ? void 0 : _this$fc$lead.lead.country) || window.GEO.country;
                pr = _this2.createApplePaymentRequest(country, product, expressButton);
                session = new window.ApplePaySession(3, pr);
                session.onvalidatemerchant = function() {
                    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                        var data, e, _this$fc$lead2;
                        return (0, $33z5g.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        BriantreeService.applePay.performValidation({
                                            validationURL: ev.validationURL,
                                            displayName: window.BRAND.toUpperCase(),
                                            merchantIdentifier: (0, $42a1df290c3667d2$export$e506a1d27d1eaa20).BR_ID
                                        })
                                    ];
                                case 1:
                                    data = _state.sent();
                                    session.completeMerchantValidation(data);
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    e = _state.sent();
                                    Errors.report(e, {
                                        product: product,
                                        geo: window.GEO,
                                        config: _this2.fc.config,
                                        lead: (_this$fc$lead2 = _this2.fc.lead) === null || _this$fc$lead2 === void 0 ? void 0 : _this$fc$lead2.lead
                                    }, false, false);
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(ev) {
                        return _ref.apply(this, arguments);
                    };
                }();
                session.onpaymentauthorized = function() {
                    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                        var data;
                        return (0, $33z5g.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        BriantreeService.applePay.tokenize({
                                            token: ev.payment.token
                                        })
                                    ];
                                case 1:
                                    data = _state.sent();
                                    if (!expressButton) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        checkout.createApplePayOrderExpress(data.nonce, session, ev.payment.shippingContact)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 3:
                                    return [
                                        4,
                                        checkout.createApplePayOrder(data.nonce, session)
                                    ];
                                case 4:
                                    _state.sent();
                                    _state.label = 5;
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(ev) {
                        return _ref.apply(this, arguments);
                    };
                }();
                return [
                    2,
                    session
                ];
            });
        });
        return function(checkout) {
            return _ref.apply(this, arguments);
        };
    }();
    this.fc = fc;
    this.buttonIds = buttonIds;
};
$769377b54b8399a0$export$a04f4fe972622dd3.gPayAvailable = false;
$769377b54b8399a0$export$a04f4fe972622dd3.appleAvailable = false;
$769377b54b8399a0$export$a04f4fe972622dd3.checkAvailability = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
    var _window, _window$ApplePaySessi, _window$ApplePaySessi2, res, _, _1, _tmp, e;
    return (0, $33z5g.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    4
                ]);
                $769377b54b8399a0$export$a04f4fe972622dd3.appleAvailable = !!((_window = window) !== null && _window !== void 0 && _window.ApplePaySession && (_window$ApplePaySessi = window.ApplePaySession) !== null && _window$ApplePaySessi !== void 0 && _window$ApplePaySessi.supportsVersion(3) && (_window$ApplePaySessi2 = window.ApplePaySession) !== null && _window$ApplePaySessi2 !== void 0 && _window$ApplePaySessi2.canMakePayments());
                $769377b54b8399a0$export$a04f4fe972622dd3.gPayClient = new google.payments.api.PaymentsClient({
                    environment: window.DEBUG ? "TEST" : "PRODUCTION"
                });
                _1 = (_ = $769377b54b8399a0$export$a04f4fe972622dd3.gPayClient).isReadyToPay;
                _tmp = {
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    existingPaymentMethodRequired: true
                };
                return [
                    4,
                    $769377b54b8399a0$export$a04f4fe972622dd3.gPay.createPaymentDataRequest()
                ];
            case 1:
                return [
                    4,
                    _1.apply(_, [
                        (_tmp.allowedPaymentMethods = _state.sent().allowedPaymentMethods, _tmp)
                    ])
                ];
            case 2:
                res = _state.sent();
                $769377b54b8399a0$export$a04f4fe972622dd3.gPayAvailable = !!res.result;
                return [
                    3,
                    4
                ];
            case 3:
                e = _state.sent();
                Errors.report(e, undefined, false, false);
                return [
                    3,
                    4
                ];
            case 4:
                return [
                    2
                ];
        }
    });
});
$769377b54b8399a0$export$a04f4fe972622dd3.init = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(fc, buttonIds) {
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($769377b54b8399a0$export$a04f4fe972622dd3.instance) return [
                        2,
                        new $769377b54b8399a0$export$a04f4fe972622dd3(fc, buttonIds)
                    ];
                    return [
                        4,
                        (0, $a3012b76ed9b4143$exports.client).create({
                            authorization: (0, $42a1df290c3667d2$export$e506a1d27d1eaa20).BR_KEY
                        })
                    ];
                case 1:
                    $769377b54b8399a0$export$a04f4fe972622dd3.instance = _state.sent();
                    return [
                        4,
                        (0, $a3012b76ed9b4143$exports.googlePayment).create({
                            googlePayVersion: 2,
                            client: $769377b54b8399a0$export$a04f4fe972622dd3.instance,
                            googleMerchantId: (0, $42a1df290c3667d2$export$e506a1d27d1eaa20).BR_ID
                        })
                    ];
                case 2:
                    $769377b54b8399a0$export$a04f4fe972622dd3.gPay = _state.sent();
                    return [
                        4,
                        (0, $a3012b76ed9b4143$exports.applePay).create({
                            client: $769377b54b8399a0$export$a04f4fe972622dd3.instance
                        })
                    ];
                case 3:
                    $769377b54b8399a0$export$a04f4fe972622dd3.applePay = _state.sent();
                    return [
                        4,
                        $769377b54b8399a0$export$a04f4fe972622dd3.checkAvailability()
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        new $769377b54b8399a0$export$a04f4fe972622dd3(fc, buttonIds)
                    ];
            }
        });
    });
    return function(fc, buttonIds) {
        return _ref.apply(this, arguments);
    };
}();




var $fvacx = parcelRequire("fvacx");

var $33z5g = parcelRequire("33z5g");




var $fb3d0779aa31a0b1$export$9bffb86ad85bf93d = function KlarnaService(fc, containerId) {
    "use strict";
    var _this = this;
    (0, $fvacx._)(this, KlarnaService);
    var _this1 = this;
    this.initSession = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(country) {
            var lead, locale, product, _window$Klarna, _calculatePrices, unitPrice, totalAmount, res, _window, _window$Klarna2, _window$Klarna2$Payme, e;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this1.fc.lead.lead;
                        locale = _this1.fc.config.locale;
                        product = _this1.fc.getSelectedProduct();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (_this1.fc.config.klarnaEnabled && typeof ((_window$Klarna = window.Klarna) === null || _window$Klarna === void 0 ? void 0 : _window$Klarna.Payments) === "undefined") throw new Error("Klarna enabled but not defined");
                        _calculatePrices = (0, $bb370a6f0f5e546c$export$fca6a3397460b397)(product.finalPrice, product.quantity, product.shippingPrice || 0), unitPrice = _calculatePrices.unitPrice, totalAmount = _calculatePrices.totalAmount;
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).getKlarnaPaymentSession({
                                client: window.BRAND,
                                intent: "buy_and_tokenize",
                                purchase_country: country || window.GEO.country,
                                purchase_currency: product.currencyCode,
                                locale: locale || "en",
                                order_amount: totalAmount,
                                order_tax_amount: 0,
                                order_lines: [
                                    {
                                        name: product.name,
                                        quantity: product.quantity,
                                        unit_price: unitPrice,
                                        tax_rate: 0,
                                        total_amount: unitPrice * Number(product.quantity),
                                        total_tax_amount: 0
                                    },
                                    {
                                        name: "Shipping Standard",
                                        quantity: 1,
                                        reference: "shipping-standard",
                                        tax_rate: 0,
                                        total_amount: Number(product.shippingPrice) * 100,
                                        total_tax_amount: 0,
                                        unit_price: Number(product.shippingPrice) * 100
                                    }
                                ]
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        if (window.DEBUG) console.log(res);
                        if (res !== null && res !== void 0 && res.client_token) {
                            ;
                            (_window = window) === null || _window === void 0 || (_window$Klarna2 = _window.Klarna) === null || _window$Klarna2 === void 0 || (_window$Klarna2$Payme = _window$Klarna2.Payments) === null || _window$Klarna2$Payme === void 0 || _window$Klarna2$Payme.init({
                                client_token: res === null || res === void 0 ? void 0 : res.client_token
                            });
                            window.Klarna.Payments.load({
                                container: _this1.containerId,
                                payment_method_category: "klarna"
                            });
                            (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showAvailablePaymentMethods(res.payment_method_categories);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        Errors.report(e, {
                            lead: lead || "undefined",
                            product: product || "undefined",
                            config: _this1.fc.config || "undefined"
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(country) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createKlarnaOrderObj = function(product) {
        var redirect = (0, $5afc064d4f10b824$export$7138c24907de3954)(_this.fc.config.redirectTo || "", {
            prospect_id: String(_this.fc.lead.lead.orderId)
        });
        var _calculatePrices = (0, $bb370a6f0f5e546c$export$fca6a3397460b397)(product.finalPrice, product.quantity, product.shippingPrice || 0), unitPrice = _calculatePrices.unitPrice, totalAmount = _calculatePrices.totalAmount;
        return {
            client: window.BRAND,
            authorizationToken: "",
            intent: "buy_and_tokenize",
            purchase_country: _this.fc.lead.lead.country,
            purchase_currency: product.currencyCode,
            locale: _this.fc.config.locale || "en",
            shipping_address: {
                given_name: _this.fc.lead.lead.firstName,
                family_name: _this.fc.lead.lead.lastName,
                email: _this.fc.lead.lead.emailAddress,
                street_address: _this.fc.lead.lead.address1,
                postal_code: _this.fc.lead.lead.postalCode,
                city: _this.fc.lead.lead.city,
                region: _this.fc.lead.lead.state,
                phone: _this.fc.lead.lead.phoneNumber,
                country: _this.fc.lead.lead.country
            },
            order_amount: totalAmount,
            order_tax_amount: 0,
            order_lines: [
                {
                    name: product.name,
                    quantity: product.quantity,
                    unit_price: unitPrice,
                    tax_rate: 0,
                    total_amount: unitPrice * Number(product.quantity),
                    total_tax_amount: 0,
                    image_url: product.image
                },
                {
                    name: "Shipping Standard",
                    quantity: 1,
                    reference: "shipping-standard",
                    tax_rate: 0,
                    total_amount: Number(product.shippingPrice) * 100,
                    total_tax_amount: 0,
                    unit_price: Number(product.shippingPrice) * 100
                }
            ],
            merchant_urls: {
                confirmation: redirect,
                checkout: redirect
            }
        };
    };
    var _this2 = this;
    this.authorizeOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(product) {
            var order, resultPromise, _ref, authorizationToken, error, approved, klarnaApproved;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        order = _this2.createKlarnaOrderObj(product);
                        resultPromise = new Promise(function(resolve) {
                            _this2.klarnaPayments.authorize({
                                payment_method_category: "klarna"
                            }, order, function(res) {
                                resolve({
                                    approved: res.approved,
                                    authorizationToken: res === null || res === void 0 ? void 0 : res.authorization_token,
                                    error: (res === null || res === void 0 ? void 0 : res.authorization_token) === "undefined"
                                });
                            });
                        });
                        return [
                            4,
                            resultPromise
                        ];
                    case 1:
                        _ref = _state.sent(), authorizationToken = _ref.authorizationToken, error = _ref.error, approved = _ref.approved;
                        if (error) throw new Error("Klarna not authorized order");
                        order.authorizationToken = authorizationToken;
                        klarnaApproved = approved;
                        return [
                            2,
                            {
                                klarnaApproved: klarnaApproved,
                                order: order
                            }
                        ];
                }
            });
        });
        return function(product) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createExpressKlarnaOrderObj = function(product, authToken, collected_shipping_address) {
        var _calculatePrices = (0, $bb370a6f0f5e546c$export$fca6a3397460b397)(product.finalPrice, product.quantity, product.shippingPrice || 0), unitPrice = _calculatePrices.unitPrice, totalAmount = _calculatePrices.totalAmount;
        var orderPayload = {
            client: window.BRAND,
            intent: "buy_and_tokenize",
            locale: _this.fc.config.locale || "en",
            order_amount: totalAmount,
            order_lines: [
                {
                    name: product.name,
                    quantity: product.quantity,
                    unit_price: unitPrice,
                    tax_rate: 0,
                    total_amount: unitPrice * Number(product.quantity),
                    total_tax_amount: 0,
                    image_url: product.image
                },
                {
                    name: "Shipping Standard",
                    quantity: 1,
                    reference: "shipping-standard",
                    tax_rate: 0,
                    total_amount: Number(product.shippingPrice) * 100,
                    total_tax_amount: 0,
                    unit_price: Number(product.shippingPrice) * 100
                }
            ],
            order_tax_amount: 0,
            purchase_country: _this.fc.lead.lead.country,
            purchase_currency: product.currencyCode
        };
        if (authToken) orderPayload.authorizationToken = authToken;
        if (collected_shipping_address) {
            orderPayload.shipping_address = collected_shipping_address;
            orderPayload.purchase_country = collected_shipping_address.country;
        }
        return orderPayload;
    };
    this.fc = fc;
    this.klarnaPayments = window.Klarna.Payments;
    this.containerId = containerId;
};


var $56ab4c05fb950c51$export$2a51769b07fe601;
(function(PaySource) {
    PaySource["ONE_CLICK"] = "ONE_CLICK";
    PaySource["PAYPAL"] = "PAYPAL";
    PaySource["KLARNA"] = "KLARNA";
    PaySource["CREDITCARD"] = "CREDITCARD";
    PaySource["APPLEPAY"] = "APPLEPAY";
    PaySource["GOOGLEPAY"] = "GOOGLEPAY";
    PaySource["PREPAID"] = "PREPAID";
    PaySource["WITHREACH_PAYPAL"] = "WITHREACH_PAYPAL";
    PaySource["STRIPE_KLARNA"] = "STRIPE_KLARNA";
    PaySource["PAYPAL_CONFIRM"] = "PAYPAL_CONFIRM";
})($56ab4c05fb950c51$export$2a51769b07fe601 || ($56ab4c05fb950c51$export$2a51769b07fe601 = {}));


var $7b29a6ccdf5c2334$export$8b32abc48eb67713;
(function(OrderFlow) {
    OrderFlow["ONE_CLICK"] = "1click";
    OrderFlow["CHECKOUT"] = "checkout";
    OrderFlow["CHECKOUT_1CLICK"] = "checkout-1click";
})($7b29a6ccdf5c2334$export$8b32abc48eb67713 || ($7b29a6ccdf5c2334$export$8b32abc48eb67713 = {}));




var $33z5g = parcelRequire("33z5g");
var $3391119dba56c39d$export$22b283b94688ae65 = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(script) {
        var fn, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    fn = new Function(script);
                    return [
                        4,
                        fn()
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, {
                        script: script
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function runScript(script) {
        return _ref.apply(this, arguments);
    };
}();







var $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = null;
var $3dd279f8370fe9d2$export$8cc5b49137b63d = function CheckoutController(fc) {
    "use strict";
    var _this = this;
    var _this1 = this;
    (0, $fvacx._)(this, CheckoutController);
    this.ccConfig = window.FLAGS.cc_profile;
    this.ppConfig = window.FLAGS.pp_profile;
    this.getCardGwId = function(cardType) {
        if (!_this.ccConfig) return undefined;
        if (window.BRAND !== _this.ccConfig.brand.toLowerCase()) return undefined;
        switch(cardType){
            case "visa":
                return _this.ccConfig.visa;
            case "mastercard":
                return _this.ccConfig.mastercard;
            case "american-express":
                return _this.ccConfig.amex_discovery;
            case "discover":
                return _this.ccConfig.amex_discovery;
            default:
                return _this.ccConfig.mastercard;
        }
    };
    this.getParams = function(cardInfo) {
        var _this$ppConfig, _this$ppConfig2, _this$fc$config, _this$fc$config2, _this$ccConfig;
        var auid = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_auid;
        // Custom URL params, that will be added to payloads
        var custom_order_m_ab_var = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_m_ab_var;
        var custom_order_m_ab_name = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_m_ab_name;
        var custom_order_ab_name = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_ab_name;
        var custom_order_ab_var = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_ab_var;
        var lead = _this.fc.lead.lead;
        var sessionId = _this.fc.config.sessionId || _this.fc.lead.lead.sessionId;
        var orderId = _this.fc.lead.lead.orderId;
        var product = _this.fc.getSelectedProduct();
        var paypalType = ((_this$ppConfig = _this.ppConfig) === null || _this$ppConfig === void 0 ? void 0 : _this$ppConfig.paypal_type) || "default";
        var paypalMid = ((_this$ppConfig2 = _this.ppConfig) === null || _this$ppConfig2 === void 0 ? void 0 : _this$ppConfig2.paypal_mid) || _this.fc.config.paypalId;
        // Redirect to first upsell onsuccess
        var successRedirect = (_this$fc$config = _this.fc.config) === null || _this$fc$config === void 0 ? void 0 : _this$fc$config.redirectTo;
        var serverRedirectUrl = (_this$fc$config2 = _this.fc.config) === null || _this$fc$config2 === void 0 ? void 0 : _this$fc$config2.ppSuccessRedirectUrl;
        var taxExemption = ((_this$ccConfig = _this.ccConfig) === null || _this$ccConfig === void 0 ? void 0 : _this$ccConfig.tax) === "no_tax" ? "no_tax" : undefined;
        var errorRedirect = (0, $5afc064d4f10b824$export$7138c24907de3954)(location.href, {
            cancel_url: "1"
        });
        var forceLoadBalancerId = cardInfo && _this.getCardGwId(cardInfo.cardType);
        var forceMerchantId = undefined;
        if (_this.fc.config.forceMerchantId) forceMerchantId = parseInt(_this.fc.config.forceMerchantId, 10);
        if (!product) throw new Error("Error: Products is undefined");
        if (!successRedirect) throw new Error("Error: successRedirect is undefined");
        if (!serverRedirectUrl) throw new Error("Error: serverRedirUrl is undefined");
        // Redirect to PM eg Paypal, Klarna, Reach
        var pmExternalRedirect = (0, $5afc064d4f10b824$export$7138c24907de3954)(serverRedirectUrl, {
            redirectTo: successRedirect
        });
        return {
            auid: auid,
            lead: lead,
            orderId: orderId,
            product: product,
            paypalMid: paypalMid,
            sessionId: sessionId,
            paypalType: paypalType,
            taxExemption: taxExemption,
            errorRedirect: errorRedirect,
            forceMerchantId: forceMerchantId,
            successRedirect: successRedirect,
            pmExternalRedirect: pmExternalRedirect,
            forceLoadBalancerId: forceLoadBalancerId,
            customPayloadParams: {
                custom_order_m_ab_var: custom_order_m_ab_var,
                custom_order_m_ab_name: custom_order_m_ab_name,
                custom_order_ab_name: custom_order_ab_name,
                custom_order_ab_var: custom_order_ab_var
            }
        };
    };
    /**
   * Set a cookie with the currently selected product
   */ this._setSelectedProductCookie = function() {
        var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "selected", expiration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
        (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)(key, {
            product: _this1.fc.getSelectedProduct(),
            subscription: window.subSelected
        }, expiration);
    };
    /**
   * Add extra parameters to the order payload
   */ this._addExtraParameters = function(payload, paymentMethod) {
        if (payload) {
            if (payload.custom_order_ev_click_id && payload.custom_order_ev_click_id.includes(",")) payload.custom_order_ev_click_id = payload.custom_order_ev_click_id.split(",")[0];
            var evClickId = sessionStorage.getItem("ev_click_id");
            if (evClickId) payload.custom_order_ev_click_id = evClickId.split(",")[0];
            if (payload.custom_order_ev_oid && payload.custom_order_ev_oid.includes(",")) payload.custom_order_ev_oid = payload.custom_order_ev_oid.split(",")[0];
            var evOid = sessionStorage.getItem("ev_oid");
            if (evOid) payload.custom_order_ev_oid = evOid.split(",")[0];
            if (paymentMethod) {
                (0, $5afc064d4f10b824$export$4f2e34905c9fb7fa)({
                    pm: paymentMethod
                });
                sessionStorage.setItem("pm", paymentMethod);
            }
            var urlParams = sessionStorage.getItem("url_params");
            if (urlParams) try {
                var urlParamsData = JSON.parse(urlParams);
                if (urlParamsData && urlParamsData.force && !payload.custom_order_force) payload.custom_order_force = urlParamsData.force;
            } catch (error) {
                console.log(error);
            }
        }
    };
    this.maybeInitKlarna = function(country) {
        var slug = (0, $5afc064d4f10b824$export$29f5936f887dc758)();
        var enabled = _this.fc.config.klarnaEnabled && (0, $8930f014d14fb0b6$export$105adf7faeb879c1).some(function(locale) {
            return slug === null || slug === void 0 ? void 0 : slug.startsWith(locale);
        });
        if (enabled) {
            waitFor("Klarna", function() {
                _this.klarna = new (0, $fb3d0779aa31a0b1$export$9bffb86ad85bf93d)(_this.fc, "#klarna-payments-container");
                _this.klarna.initSession(country);
            });
            setTimeout(function() {
                if (!_this.klarna) Errors.report(new Error("Klarna not initialized after 2s"));
            }, 2000);
        }
    };
    this.maybeInitBraintree = function(buttonIds) {
        var _this1 = _this;
        waitFor("google", /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, $769377b54b8399a0$export$a04f4fe972622dd3).init(_this1.fc, buttonIds)
                        ];
                    case 1:
                        _this1.braintree = _state.sent();
                        _this1.braintree.maybeRenderButtons();
                        return [
                            2
                        ];
                }
            });
        }));
    };
    var _this2 = this;
    this.maybeInitStripeApplePay = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var stripeApplePayEnabled;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    stripeApplePayEnabled = _this2.fc.config.stripeApplePayEnabled;
                    if (!stripeApplePayEnabled) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $b7b0e6aa61a021b0$export$976c4951f137bc87).init(_this2.fc)
                    ];
                case 1:
                    _this2.stripeApplePay = _state.sent();
                    _this2.stripeApplePay.maybeRenderButtons();
                    _this2.stripeApplePay.createApplePayment(_this2, false);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    var _this3 = this;
    this.createCreditCardOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(cardInfo) {
            var _this$fc$config3, _navigator, _window$GEO, _this_getParams, auid, lead, orderId, product, sessionId, taxExemption, errorRedirect, successRedirect, pmExternalRedirect, forceLoadBalancerId, customPayloadParams, phoneNumber, cardYear, campaignId, orderData, res, e, _e$response, _e$response$data, orderId1;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        _this_getParams = _this3.getParams(cardInfo), auid = _this_getParams.auid, lead = _this_getParams.lead, orderId = _this_getParams.orderId, product = _this_getParams.product, sessionId = _this_getParams.sessionId, taxExemption = _this_getParams.taxExemption, errorRedirect = _this_getParams.errorRedirect, successRedirect = _this_getParams.successRedirect, pmExternalRedirect = _this_getParams.pmExternalRedirect, forceLoadBalancerId = _this_getParams.forceLoadBalancerId, customPayloadParams = _this_getParams.customPayloadParams;
                        (0, $48bbe448a6f79255$export$ea94ad0a55726449)(lead);
                        // Phone number is required for delivery in Israel
                        phoneNumber = (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).getPhoneNumber("phoneNumber");
                        if ((window.GEO.country === "IL" || (_this$fc$config3 = _this3.fc.config) !== null && _this$fc$config3 !== void 0 && _this$fc$config3.phoneRequired) && !phoneNumber) throw new Error("Phone number is required");
                        cardYear = cardInfo.expirationYear.length === 2 ? "20".concat(cardInfo.expirationYear) : cardInfo.expirationYear;
                        // If subscribtion product selected
                        campaignId = window.subSelected ? _this3.fc.config.subscriptionCampaignId || _this3.fc.config.campaignId : _this3.fc.config.campaignId;
                        orderData = (0, $e2Ogy._)({
                            client: window.BRAND,
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD,
                            orderId: orderId,
                            campaignId: campaignId,
                            taxExemption: taxExemption,
                            companyName: "unfullfiled",
                            fullUrl: location.href,
                            errorRedirectsTo: errorRedirect,
                            redirectsTo: pmExternalRedirect,
                            salesUrl: location.href,
                            cardNumber: cardInfo.number,
                            cardYear: cardYear,
                            cardMonth: cardInfo.expirationMonth,
                            cardSecurityCode: cardInfo.cvv,
                            product1_id: String(product.id),
                            product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                            product1_shipPrice: product.shippingPrice || 0,
                            address1: lead.address1,
                            city: lead.city,
                            forceLoadBalancerId: forceLoadBalancerId,
                            postalCode: lead.postalCode,
                            shipPostalCode: lead.shipPostalCode,
                            emailAddress: lead.emailAddress,
                            custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                            custom2: "credit_card",
                            custom3: "".concat(window.location.origin + window.location.pathname),
                            sourceValue3: auid,
                            custom_order_auid: auid,
                            custom_order_sid: sessionId,
                            custom_order_paymentType: "credit_card",
                            custom_order_initial: product.id.toString(),
                            custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD,
                            custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                            note: "initial",
                            userAgent: (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent,
                            ipAddress: ((_window$GEO = window.GEO) === null || _window$GEO === void 0 ? void 0 : _window$GEO.ip) || "::1",
                            custom_order_force: new URL(location.href).searchParams.get("force") || ""
                        }, customPayloadParams);
                        if (window.DEBUG) console.log(product);
                        _this3.fc.addAddonsToPurchasePayload(orderData);
                        _this3._addExtraParameters(orderData, "creditcard");
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD);
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder((0, $e2Ogy._)({}, _this3.fc.lead.lead, orderData), {
                            paymentType: "$credit_card",
                            cardInfo: cardInfo,
                            returnScore: false
                        });
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importCreditCardOrder(orderData)
                        ];
                    case 1:
                        res = _state.sent();
                        if (window.DEBUG) console.log("res: ", res);
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                            returnScore: true,
                            cardInfo: cardInfo
                        });
                        if ((0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url)) window.location.href = res.url;
                        else if (res.script) (0, $3391119dba56c39d$export$22b283b94688ae65)(res.script);
                        else (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, _this3.fc.lead.lead);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        Errors.report(e, {
                            geo: window.GEO,
                            config: _this3.fc.config || "undefined",
                            lead: _this3.fc.lead.lead || "undefined",
                            product: _this3.fc.getSelectedProduct() || "undefined",
                            productIdx: window["productIdx"].value || "undefined",
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD
                        });
                        orderId1 = _this3.getParams(cardInfo).orderId;
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId1, null, {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD,
                            errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.message[0]),
                            cardInfo: cardInfo
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(cardInfo) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this4 = this;
    this.createKlarnaStripeOrder = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var _navigator2, _window$GEO2, _this_getParams, auid, lead, orderId, product, sessionId, errorRedirect, pmExternalRedirect, customPayloadParams, forceMerchantId, phoneInput, orderData, res, e, _e$response2, _e$response2$data, orderId1;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        3,
                        4
                    ]);
                    _this_getParams = _this4.getParams(), auid = _this_getParams.auid, lead = _this_getParams.lead, orderId = _this_getParams.orderId, product = _this_getParams.product, sessionId = _this_getParams.sessionId, errorRedirect = _this_getParams.errorRedirect, pmExternalRedirect = _this_getParams.pmExternalRedirect, customPayloadParams = _this_getParams.customPayloadParams, forceMerchantId = _this_getParams.forceMerchantId;
                    phoneInput = (0, $5743262db8c9d9ed$export$bf2a34abc2ea9c3)("phoneNumber");
                    orderData = (0, $e2Ogy._)({
                        orderId: orderId,
                        client: window.BRAND,
                        fullUrl: location.href,
                        salesUrl: location.href,
                        companyName: "unfullfiled",
                        paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PREPAID,
                        prepaidType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                        campaignId: _this4.fc.config.campaignId,
                        product1_id: String(product.id),
                        product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                        product1_shipPrice: product.shippingPrice || 0,
                        redirectsTo: pmExternalRedirect,
                        errorRedirectsTo: errorRedirect,
                        emailAddress: lead.emailAddress || "",
                        custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                        phoneNumber: phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.value,
                        forceMerchantId: forceMerchantId || 117,
                        custom2: "klarna_stripe",
                        custom3: "".concat(window.location.origin + window.location.pathname),
                        sourceValue3: auid,
                        custom_order_auid: auid,
                        custom_order_sid: sessionId,
                        custom_order_paymentType: "klarna_stripe",
                        custom_order_initial: product.id.toString(),
                        custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                        custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).STRIPE_KLARNA,
                        custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                        note: "initial",
                        userAgent: (_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.userAgent,
                        ipAddress: ((_window$GEO2 = window.GEO) === null || _window$GEO2 === void 0 ? void 0 : _window$GEO2.ip) || "::1",
                        custom_order_force: new URL(location.href).searchParams.get("force") || ""
                    }, customPayloadParams);
                    if (window.DEBUG) console.log(product);
                    _this4.fc.addAddonsToPurchasePayload(orderData);
                    _this4._addExtraParameters(orderData, "klarna_stripe");
                    $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).STRIPE_KLARNA);
                    // Track create_order event in Sift with orderData containing all products
                    // Use isExpressPayment flag for express PayPal to allow sending event without orderId
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder((0, $e2Ogy._)({}, _this4.fc.lead.lead, orderData), {
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                        returnScore: false
                    });
                    _this4._setSelectedProductCookie();
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importKlarnaStripeOrder(orderData)
                    ];
                case 1:
                    res = _state.sent();
                    if (window.DEBUG) console.log(res);
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                        returnScore: true,
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA
                    });
                    if (res.url && (0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url)) window.location.href = res.url;
                    return [
                        3,
                        4
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        config: _this4.fc.config || "undefined",
                        lead: _this4.fc.lead.lead || "undefined",
                        product: _this4.fc.getSelectedProduct() || "undefined",
                        productIdx: window["productIdx"].value || "undefined"
                    });
                    orderId1 = _this4.getParams().orderId;
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId1, null, {
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                        errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.message[0])
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    var _this5 = this;
    this.createPayPalOrder = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var _this_getParams, paypalMid, paypalType, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        6,
                        7
                    ]);
                    _this_getParams = _this5.getParams(), paypalMid = _this_getParams.paypalMid, paypalType = _this_getParams.paypalType;
                    if (!paypalMid) throw new Error("Error: paypalId is undefined");
                    $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL);
                    _this5._setSelectedProductCookie();
                    if (!(paypalType === "reach")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        _this5.createReachPayPalOrder(paypalMid)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        _this5.createDefaultPayPalOrder(paypalMid, paypalType)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        config: _this5.fc.config || "undefined",
                        lead: _this5.fc.lead.lead || "undefined",
                        product: _this5.fc.getSelectedProduct() || "undefined",
                        productIdx: window["productIdx"].value || "undefined"
                    });
                    return [
                        3,
                        7
                    ];
                case 6:
                    $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                    return [
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    var _this6 = this;
    this.createDefaultPayPalOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(paypalMid, paypalType) {
            var _this$fc$config4, _navigator3, _window$GEO3, params, _this_getParams, auid, lead, orderId, product, sessionId, errorRedirect, pmExternalRedirect, customPayloadParams, paypalBillerId, custom2, optinCheckboxes, optinCheckbox, storage, optinValue, phoneNumber, campaignId, finalOrderId, orderData, res;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = new URLSearchParams(document.location.search);
                        _this_getParams = _this6.getParams(), auid = _this_getParams.auid, lead = _this_getParams.lead, orderId = _this_getParams.orderId, product = _this_getParams.product, sessionId = _this_getParams.sessionId, errorRedirect = _this_getParams.errorRedirect, pmExternalRedirect = _this_getParams.pmExternalRedirect, customPayloadParams = _this_getParams.customPayloadParams;
                        if (_this6.fc.config.expressPaypal) paypalType = "express";
                        paypalBillerId = paypalType === "express" ? paypalMid : undefined;
                        custom2 = paypalType === "default" ? "paypal_".concat(paypalMid) : "paypal_".concat(paypalType, "_").concat(paypalMid);
                        if (!(paypalType === "express")) return [
                            3,
                            8
                        ];
                        optinCheckboxes = (0, $5743262db8c9d9ed$export$3b7aa821f91b0b75)("optinCheckbox");
                        optinCheckbox = (optinCheckboxes === null || optinCheckboxes === void 0 ? void 0 : optinCheckboxes.filter(function(el) {
                            return el === null || el === void 0 ? void 0 : el.checked;
                        })[0]) || optinCheckboxes[0];
                        storage = (0, $f7052bb2eb427bc1$export$4395c3ac0493290e).getInstance();
                        if (!paypalBillerId) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            storage.setValue("express_paypal_mid", paypalBillerId.toString())
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (!sessionId) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            storage.setValue("express_session_id", sessionId)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (!product.id) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            storage.setValue("express_product_id", product.id.toString())
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        if (!optinCheckbox) return [
                            3,
                            8
                        ];
                        optinValue = optinCheckbox ? "".concat(optinCheckbox.checked) : "0";
                        (0, $4aacaa5cfd9fe25b$export$110700823644f4a6)("marketing_opt_in", optinValue);
                        return [
                            4,
                            storage.setValue("marketing_opt_in", optinValue)
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        if (paypalType !== "express") (0, $48bbe448a6f79255$export$ea94ad0a55726449)(lead);
                        phoneNumber = (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).getPhoneNumber("phoneNumber");
                        if ((window.GEO.country === "IL" || (_this$fc$config4 = _this6.fc.config) !== null && _this$fc$config4 !== void 0 && _this$fc$config4.phoneRequired) && !phoneNumber) throw new Error("Phone number is required");
                        // If subscribtion product selected
                        campaignId = window.subSelected ? _this6.fc.config.subscriptionCampaignId || _this6.fc.config.campaignId : _this6.fc.config.campaignId;
                        finalOrderId = orderId;
                        if (paypalType === "express") finalOrderId = undefined;
                        orderData = (0, $e2Ogy._)({
                            orderId: finalOrderId,
                            campaignId: campaignId,
                            paypalBillerId: paypalBillerId,
                            client: window.BRAND,
                            fullUrl: location.href,
                            salesUrl: location.href,
                            phoneNumber: phoneNumber,
                            companyName: "unfullfiled",
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                            forceMerchantId: paypalMid,
                            product1_id: String(product.id),
                            product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                            product1_shipPrice: product.shippingPrice || 0,
                            redirectsTo: pmExternalRedirect,
                            errorRedirectsTo: errorRedirect,
                            emailAddress: lead.emailAddress || "",
                            custom2: custom2,
                            custom3: "".concat(window.location.origin + window.location.pathname),
                            affId: params.get("affid") || undefined,
                            custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                            sourceValue3: auid,
                            custom_order_auid: auid,
                            custom_order_sid: sessionId,
                            custom_order_paymentType: custom2,
                            custom_order_initial: product.id.toString(),
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                            custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                            note: "initial",
                            custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                            userAgent: (_navigator3 = navigator) === null || _navigator3 === void 0 ? void 0 : _navigator3.userAgent,
                            ipAddress: ((_window$GEO3 = window.GEO) === null || _window$GEO3 === void 0 ? void 0 : _window$GEO3.ip) || "::1",
                            custom_order_force: new URL(location.href).searchParams.get("force") || ""
                        }, customPayloadParams);
                        if (window.DEBUG) console.log(product);
                        _this6.fc.addAddonsToPurchasePayload(orderData);
                        _this6._addExtraParameters(orderData, "paypal_default");
                        // Track create_order event in Sift with orderData containing all products
                        // For express PayPal, we need to use isExpressPayment flag since orderId isn't available yet
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder((0, $e2Ogy._)({}, _this6.fc.lead.lead, orderData), {
                            isExpressPayment: paypalType === "express",
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                            returnScore: false
                        });
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importPaypalOrder(orderData)
                        ];
                    case 9:
                        res = _state.sent();
                        if (window.DEBUG) console.log(res);
                        if ((0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url) || (0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.paypalUrl)) {
                            (0, $13c7326b49cbd18b$export$154e6e3e573edb4e)();
                            window.location.href = (0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url) ? res.url : res.paypalUrl;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(paypalMid, paypalType) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this7 = this;
    this.createReachPayPalOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(paypalMid) {
            var _navigator4, _window$GEO4, params, _this_getParams, auid, lead, orderId, product, sessionId, errorRedirect, pmExternalRedirect, customPayloadParams, campaignId, orderData, res;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = new URLSearchParams(document.location.search);
                        _this_getParams = _this7.getParams(), auid = _this_getParams.auid, lead = _this_getParams.lead, orderId = _this_getParams.orderId, product = _this_getParams.product, sessionId = _this_getParams.sessionId, errorRedirect = _this_getParams.errorRedirect, pmExternalRedirect = _this_getParams.pmExternalRedirect, customPayloadParams = _this_getParams.customPayloadParams;
                        // If subscribtion product selected
                        campaignId = window.subSelected ? _this7.fc.config.subscriptionCampaignId || _this7.fc.config.campaignId : _this7.fc.config.campaignId;
                        orderData = (0, $e2Ogy._)({
                            orderId: orderId,
                            campaignId: campaignId,
                            sourceValue3: auid,
                            client: window.BRAND,
                            fullUrl: location.href,
                            salesUrl: location.href,
                            companyName: "unfullfiled",
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PREPAID,
                            forceMerchantId: paypalMid,
                            prepaidType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).WITHREACH_PAYPAL,
                            product1_id: String(product.id),
                            product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                            product1_shipPrice: product.shippingPrice || 0,
                            redirectsTo: pmExternalRedirect,
                            errorRedirectsTo: errorRedirect,
                            emailAddress: lead.emailAddress || "",
                            custom2: "paypal_reach_".concat(paypalMid),
                            custom3: "".concat(window.location.origin + window.location.pathname),
                            affId: params.get("affid") || undefined,
                            custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                            custom_order_auid: auid,
                            custom_order_sid: sessionId,
                            custom_order_paymentType: "paypal_reach_".concat(paypalMid),
                            custom_order_initial: product.id.toString(),
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).WITHREACH_PAYPAL,
                            custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                            note: "initial",
                            custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                            userAgent: (_navigator4 = navigator) === null || _navigator4 === void 0 ? void 0 : _navigator4.userAgent,
                            ipAddress: ((_window$GEO4 = window.GEO) === null || _window$GEO4 === void 0 ? void 0 : _window$GEO4.ip) || "::1",
                            custom_order_force: new URL(location.href).searchParams.get("force") || ""
                        }, customPayloadParams);
                        if (window.DEBUG) console.log(product);
                        _this7.fc.addAddonsToPurchasePayload(orderData);
                        _this7._addExtraParameters(orderData, "paypal_reach");
                        // Track create_order event in Sift with orderData containing all products
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder((0, $e2Ogy._)({}, _this7.fc.lead.lead, orderData), {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).WITHREACH_PAYPAL,
                            returnScore: false
                        });
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importPaypalOrder(orderData)
                        ];
                    case 1:
                        res = _state.sent();
                        if (window.DEBUG) console.log(res);
                        if (res.script) (0, $3391119dba56c39d$export$22b283b94688ae65)(res.script);
                        else if ((0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url) || (0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.paypalUrl)) {
                            (0, $13c7326b49cbd18b$export$154e6e3e573edb4e)();
                            window.location.href = (0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url) ? res.url : res.paypalUrl;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(paypalMid) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this8 = this;
    this.confirmPaypalOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(props) {
            var _this$fc$config5, _this$ppConfig3, customPayloadParams, auid, successRedirect, baToken, paypalMid, ppToken, product, sessionId, finalPaypalMid, persistedUrlParameters, params, customCustomerParams, urlQueryParameters, marketingOptin, _navigator5, _window$GEO5, _this$fc$config6, orderData, res, locale, e, _e$response3, _e$response3$data, orderId;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showPpLoaderModal(true);
                        customPayloadParams = _this8.getParams().customPayloadParams;
                        auid = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_auid;
                        successRedirect = (_this$fc$config5 = _this8.fc.config) === null || _this$fc$config5 === void 0 ? void 0 : _this$fc$config5.redirectTo;
                        baToken = props.baToken, paypalMid = props.paypalMid, ppToken = props.ppToken, product = props.product, sessionId = props.sessionId;
                        finalPaypalMid = paypalMid || ((_this$ppConfig3 = _this8.ppConfig) === null || _this$ppConfig3 === void 0 ? void 0 : _this$ppConfig3.paypal_mid) || _this8.fc.config.paypalId;
                        persistedUrlParameters = (0, $13c7326b49cbd18b$export$154e6e3e573edb4e)();
                        params = new URLSearchParams(persistedUrlParameters);
                        customCustomerParams = (0, $27fc5057b004f1e0$export$dbb70a91bbe8b436)(params);
                        urlQueryParameters = (0, $27fc5057b004f1e0$export$fa3c4e23308a0d5b)();
                        marketingOptin = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("marketing_opt_in");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL_CONFIRM);
                        _this8._setSelectedProductCookie();
                        if (window.DEBUG) console.log(product);
                        orderData = (0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)({
                            baToken: baToken,
                            sessionId: sessionId,
                            token: ppToken,
                            emailAddress: "",
                            sourceValue3: auid,
                            client: window.BRAND,
                            campaignId: _this8.fc.config.campaignId,
                            paypalBillerId: String(finalPaypalMid),
                            product1_id: String(product.id),
                            product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                            product1_shipPrice: product.shippingPrice || 0,
                            page: "checkoutPage",
                            custom1: params.get("ad_id") || "",
                            custom2: "paypal_express_".concat(finalPaypalMid),
                            custom3: "".concat(window.location.origin + window.location.pathname),
                            custom_order_sid: sessionId,
                            custom_order_initial: product.id.toString(),
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                            custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                            custom_order_language: _this8.fc.config.locale,
                            custom_order_paymentType: "paypal_express_".concat(finalPaypalMid),
                            custom_order_marketing_opt_in: "".concat(marketingOptin),
                            custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                            note: "initial"
                        }, (0, $50a3061aa036fb76$export$a5202107d3e3cdb0)(), urlQueryParameters), {
                            userAgent: (_navigator5 = navigator) === null || _navigator5 === void 0 ? void 0 : _navigator5.userAgent,
                            ipAddress: ((_window$GEO5 = window.GEO) === null || _window$GEO5 === void 0 ? void 0 : _window$GEO5.ip) || "::1",
                            custom_order_force: new URL(location.href).searchParams.get("force") || ""
                        }), customPayloadParams);
                        if (!orderData.custom_order_force) orderData.custom_order_force = new URL(orderData.custom_order_http_referer).searchParams.get("force") || "";
                        _this8.fc.addAddonsToPurchasePayload(orderData);
                        _this8._addExtraParameters(orderData, "paypal_express");
                        _this8.confirm_pp_p = orderData;
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).confirmPaypalPayment(orderData)
                        ];
                    case 2:
                        res = _state.sent();
                        if (window.DEBUG) console.log(res);
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                            isExpressPayment: true,
                            returnScore: true,
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL
                        });
                        locale = ((_this$fc$config6 = _this8.fc.config) === null || _this$fc$config6 === void 0 ? void 0 : _this$fc$config6.locale) || "";
                        (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackStartedCheckoutV2(res.emailAddress, res.firstName || "", res.lastName || "", product, locale);
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).updateCustomer((0, $e2Ogy._)({
                            customerId: res.customerId,
                            custom_user_agent: navigator.userAgent,
                            custom_http_referer: "".concat(window.location.origin).concat(window.location.pathname, "?").concat(persistedUrlParameters)
                        }, customCustomerParams));
                        if (successRedirect) (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, {
                            orderId: res === null || res === void 0 ? void 0 : res.orderId
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        Errors.report(e, {
                            geo: window.GEO,
                            inputProps: props,
                            product: product || "undefined",
                            config: _this8.fc.config || "undefined",
                            lead: _this8.fc.lead.lead || "undefined",
                            productIdx: window["productIdx"].value || "undefined"
                        });
                        orderId = _this8.getParams().orderId;
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId, _this8.confirm_pp_p, {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                            errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : _e$response3$data.message[0])
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                        return [
                            7
                        ];
                    case 5:
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showPpLoaderModal(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this9 = this;
    this.confirmPaypalOrderWOBaToken = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(props) {
            var _this$fc$config7, _this$ppConfig4, customPayloadParams, auid, successRedirect, paypalMid, ppToken, product, sessionId, payerId, finalPaypalMid, persistedUrlParameters, params, customCustomerParams, urlQueryParameters, marketingOptin, _navigator6, _window$GEO6, _this$fc$config8, orderData, res, locale, e, _e$response4, _e$response4$data, orderId;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showPpLoaderModal(true);
                        customPayloadParams = _this9.getParams().customPayloadParams;
                        auid = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_auid;
                        successRedirect = (_this$fc$config7 = _this9.fc.config) === null || _this$fc$config7 === void 0 ? void 0 : _this$fc$config7.redirectTo;
                        paypalMid = props.paypalMid, ppToken = props.ppToken, product = props.product, sessionId = props.sessionId, payerId = props.payerId;
                        finalPaypalMid = paypalMid || ((_this$ppConfig4 = _this9.ppConfig) === null || _this$ppConfig4 === void 0 ? void 0 : _this$ppConfig4.paypal_mid) || _this9.fc.config.paypalId;
                        persistedUrlParameters = (0, $13c7326b49cbd18b$export$154e6e3e573edb4e)();
                        params = new URLSearchParams(persistedUrlParameters);
                        customCustomerParams = (0, $27fc5057b004f1e0$export$dbb70a91bbe8b436)(params);
                        urlQueryParameters = (0, $27fc5057b004f1e0$export$fa3c4e23308a0d5b)();
                        marketingOptin = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("marketing_opt_in");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL_CONFIRM);
                        _this9._setSelectedProductCookie();
                        orderData = (0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)({
                            sessionId: sessionId,
                            token: ppToken,
                            emailAddress: "",
                            sourceValue3: auid,
                            client: window.BRAND,
                            campaignId: _this9.fc.config.campaignId,
                            paypalBillerId: String(finalPaypalMid),
                            product1_id: String(product.id),
                            product1_price: product.finalPrice,
                            product1_shipPrice: product.shippingPrice || 0,
                            page: "checkoutPage",
                            custom1: params.get("ad_id") || "",
                            custom2: "paypal_express_".concat(finalPaypalMid),
                            custom3: "".concat(window.location.origin + window.location.pathname),
                            custom_order_sid: sessionId,
                            custom_order_initial: product.id.toString(),
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                            custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                            custom_order_language: _this9.fc.config.locale,
                            custom_order_paymentType: "paypal_express_".concat(finalPaypalMid),
                            custom_order_marketing_opt_in: "".concat(marketingOptin),
                            custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                            note: "initial"
                        }, (0, $50a3061aa036fb76$export$a5202107d3e3cdb0)(), urlQueryParameters), {
                            userAgent: (_navigator6 = navigator) === null || _navigator6 === void 0 ? void 0 : _navigator6.userAgent,
                            ipAddress: ((_window$GEO6 = window.GEO) === null || _window$GEO6 === void 0 ? void 0 : _window$GEO6.ip) || "::1",
                            payerId: payerId,
                            custom_order_force: new URL(location.href).searchParams.get("force") || ""
                        }), customPayloadParams);
                        if (!orderData.custom_order_force) orderData.custom_order_force = new URL(orderData.custom_order_http_referer).searchParams.get("force") || "";
                        _this9.fc.addAddonsToPurchasePayload(orderData);
                        _this9._addExtraParameters(orderData, "paypal_express");
                        _this9.confirm_pp_p = orderData;
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).confirmPaypalPayment(orderData)
                        ];
                    case 2:
                        res = _state.sent();
                        if (window.DEBUG) console.log(res);
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                            isExpressPayment: true,
                            returnScore: true,
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL
                        });
                        locale = ((_this$fc$config8 = _this9.fc.config) === null || _this$fc$config8 === void 0 ? void 0 : _this$fc$config8.locale) || "";
                        (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackStartedCheckoutV2(res.emailAddress, res.firstName || "", res.lastName || "", product, locale);
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).updateCustomer((0, $e2Ogy._)({
                            customerId: res.customerId,
                            custom_user_agent: navigator.userAgent,
                            custom_http_referer: "".concat(window.location.origin).concat(window.location.pathname, "?").concat(persistedUrlParameters)
                        }, customCustomerParams));
                        if (successRedirect) (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, {
                            orderId: res === null || res === void 0 ? void 0 : res.orderId
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        Errors.report(e, {
                            geo: window.GEO,
                            inputProps: props,
                            product: product || "undefined",
                            config: _this9.fc.config || "undefined",
                            lead: _this9.fc.lead.lead || "undefined",
                            productIdx: window["productIdx"].value || "undefined"
                        });
                        orderId = _this9.getParams().orderId;
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId, _this9.confirm_pp_p, {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                            errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.message[0])
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                        return [
                            7
                        ];
                    case 5:
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showPpLoaderModal(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this10 = this;
    this.createKlarnaOrder = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var _this_getParams, auid, lead, product, sessionId, successRedirect, customPayloadParams, _ref, order, klarnaApproved, customerTokenResponse, klarnaOrderResponse, _navigator7, _window$GEO7, optinCheckboxes, optinCheckbox, orderData, res, e, _e$response5, _e$response5$data, orderId;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        7,
                        8,
                        9
                    ]);
                    if (!_this10.klarna) throw new Error("Klarna service undefined");
                    _this_getParams = _this10.getParams(), auid = _this_getParams.auid, lead = _this_getParams.lead, product = _this_getParams.product, sessionId = _this_getParams.sessionId, successRedirect = _this_getParams.successRedirect, customPayloadParams = _this_getParams.customPayloadParams;
                    (0, $48bbe448a6f79255$export$ea94ad0a55726449)(lead);
                    return [
                        4,
                        _this10.klarna.authorizeOrder(product)
                    ];
                case 1:
                    _ref = _state.sent(), order = _ref.order, klarnaApproved = _ref.klarnaApproved;
                    if (!klarnaApproved) return [
                        2
                    ];
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).getCustomerToken(order)
                    ];
                case 2:
                    customerTokenResponse = _state.sent();
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).createKlarnaPaymentsOrder(order)
                    ];
                case 3:
                    klarnaOrderResponse = _state.sent();
                    if (!(klarnaOrderResponse !== null && klarnaOrderResponse !== void 0 && klarnaOrderResponse.order_id)) return [
                        3,
                        5
                    ];
                    $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA);
                    _this10._setSelectedProductCookie();
                    optinCheckboxes = (0, $5743262db8c9d9ed$export$3b7aa821f91b0b75)("optinCheckbox");
                    optinCheckbox = (optinCheckboxes === null || optinCheckboxes === void 0 ? void 0 : optinCheckboxes.filter(function(el) {
                        return el === null || el === void 0 ? void 0 : el.checked;
                    })[0]) || optinCheckboxes[0];
                    orderData = (0, $e2Ogy._)({
                        client: window.BRAND,
                        fullUrl: location.href,
                        orderId: _this10.fc.lead.lead.orderId || "",
                        emailAddress: _this10.fc.lead.lead.emailAddress,
                        product1_id: String(product.id),
                        product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                        klarnaOrderId: klarnaOrderResponse.order_id,
                        quantity: product.quantity,
                        klarnaAuthToken: "token",
                        product1_shipPrice: product.shippingPrice || 0,
                        paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PREPAID,
                        campaignId: _this10.fc.config.campaignId,
                        custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                        custom2: "klarna",
                        custom3: "".concat(window.location.origin + window.location.pathname),
                        sourceValue3: auid,
                        sourceValue4: "id=".concat(_this10.fc.lead.lead.orderId),
                        companyName: "unfullfiled",
                        currency: product.currencyCode,
                        custom_order_auid: auid,
                        custom_order_sid: sessionId,
                        custom_order_paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                        custom_order_initial: product.id.toString(),
                        custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                        custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                        custom_order_klarnaToken: customerTokenResponse === null || customerTokenResponse === void 0 ? void 0 : customerTokenResponse.token_id,
                        custom_order_marketing_opt_in: optinCheckbox ? "".concat(optinCheckbox.checked) : "0",
                        custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                        note: "initial",
                        userAgent: (_navigator7 = navigator) === null || _navigator7 === void 0 ? void 0 : _navigator7.userAgent,
                        ipAddress: ((_window$GEO7 = window.GEO) === null || _window$GEO7 === void 0 ? void 0 : _window$GEO7.ip) || "::1",
                        custom_order_force: new URL(location.href).searchParams.get("force") || ""
                    }, customPayloadParams);
                    _this10.fc.addAddonsToPurchasePayload(orderData);
                    _this10._addExtraParameters(orderData, "klarna");
                    // Track create_order event in Sift with orderData containing all products
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder((0, $e2Ogy._)({}, _this10.fc.lead.lead, orderData), {
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                        returnScore: false
                    });
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importKlarnaOrder(orderData)
                    ];
                case 4:
                    res = _state.sent();
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                        returnScore: true,
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA
                    });
                    if (window.DEBUG) console.log(res);
                    (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, _this10.fc.lead.lead);
                    return [
                        3,
                        6
                    ];
                case 5:
                    throw new Error("Invalid Klarna order response");
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        config: _this10.fc.config || "undefined",
                        lead: _this10.fc.lead.lead || "undefined",
                        product: _this10.fc.getSelectedProduct() || "undefined",
                        productIdx: window["productIdx"].value || "undefined"
                    });
                    orderId = _this10.getParams().orderId;
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId, null, {
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                        errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response5 = e.response) === null || _e$response5 === void 0 ? void 0 : (_e$response5$data = _e$response5.data) === null || _e$response5$data === void 0 ? void 0 : _e$response5$data.message[0])
                    });
                    return [
                        3,
                        9
                    ];
                case 8:
                    $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                    return [
                        7
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
    var _this11 = this;
    this.createApplePayOrderExpress = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(nonce, session, contactInformation) {
            var _this$fc$config9, locale, _this_getParams, product, customPayloadParams, urlQueryParameters, optinCheckboxes, optinCheckbox, trackStartedCheckoutV2, _this$fc$config10, _navigator8, _window$GEO8, params, _this_getParams1, auid, lead, sessionId, successRedirect, orderData, res, updatedLead, e, _e$response6, _e$response6$data, orderId;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        locale = ((_this$fc$config9 = _this11.fc.config) === null || _this$fc$config9 === void 0 ? void 0 : _this$fc$config9.locale) || "";
                        _this_getParams = _this11.getParams(), product = _this_getParams.product, customPayloadParams = _this_getParams.customPayloadParams;
                        urlQueryParameters = (0, $27fc5057b004f1e0$export$fa3c4e23308a0d5b)();
                        optinCheckboxes = (0, $5743262db8c9d9ed$export$3b7aa821f91b0b75)("optinCheckbox");
                        optinCheckbox = (optinCheckboxes === null || optinCheckboxes === void 0 ? void 0 : optinCheckboxes.filter(function(el) {
                            return el === null || el === void 0 ? void 0 : el.checked;
                        })[0]) || optinCheckboxes[0];
                        trackStartedCheckoutV2 = function() {
                            (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackStartedCheckoutV2(contactInformation.emailAddress, contactInformation.givenName || contactInformation.familyName, contactInformation.familyName || contactInformation.givenName, product, locale);
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        params = new URLSearchParams(document.location.search);
                        _this_getParams1 = _this11.getParams(), auid = _this_getParams1.auid, lead = _this_getParams1.lead, sessionId = _this_getParams1.sessionId, successRedirect = _this_getParams1.successRedirect;
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY);
                        _this11._setSelectedProductCookie();
                        orderData = (0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)({
                            client: window.BRAND,
                            affId: params.get("affid") || undefined,
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            campaignId: _this11.fc.config.campaignId,
                            product1_id: String(product.id),
                            product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                            product1_shipPrice: product.shippingPrice || 0,
                            emailAddress: contactInformation.emailAddress,
                            sessionId: sessionId,
                            firstName: contactInformation.givenName || contactInformation.familyName,
                            lastName: contactInformation.familyName || contactInformation.givenName,
                            address1: contactInformation !== null && contactInformation !== void 0 && contactInformation.addressLines[0] ? contactInformation === null || contactInformation === void 0 ? void 0 : contactInformation.addressLines[0] : "",
                            city: contactInformation.locality,
                            state: contactInformation.administrativeArea || "",
                            postalCode: contactInformation.postalCode || "",
                            country: contactInformation.countryCode || "",
                            phoneNumber: contactInformation.phoneNumber || "",
                            custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                            forceMerchantId: Number((_this$fc$config10 = _this11.fc.config) === null || _this$fc$config10 === void 0 ? void 0 : _this$fc$config10.appleGooglePayMerchantId),
                            companyName: "unfulfilled",
                            fullUrl: location.href,
                            applePayToken: nonce,
                            sourceValue3: auid,
                            custom_order_sid: sessionId,
                            custom2: "apple_pay_express",
                            custom3: "".concat(window.location.origin + window.location.pathname),
                            custom_order_initial: product.id.toString(),
                            custom_order_language: _this11.fc.config.locale,
                            custom_order_paymentType: "apple_pay_express",
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                            note: "initial"
                        }, (0, $50a3061aa036fb76$export$a5202107d3e3cdb0)()), {
                            custom_order_marketing_opt_in: optinCheckbox ? "".concat(optinCheckbox.checked) : "0"
                        }), urlQueryParameters), {
                            userAgent: (_navigator8 = navigator) === null || _navigator8 === void 0 ? void 0 : _navigator8.userAgent,
                            ipAddress: ((_window$GEO8 = window.GEO) === null || _window$GEO8 === void 0 ? void 0 : _window$GEO8.ip) || "::1",
                            custom_order_force: new URL(location.href).searchParams.get("force") || ""
                        }), customPayloadParams);
                        _this11.fc.addAddonsToPurchasePayload(orderData);
                        _this11._addExtraParameters(orderData, "applepay_express");
                        // Track create_order event in Sift with orderData containing all products
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder((0, $e2Ogy._)({}, _this11.fc.lead.lead, orderData), {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            isExpressPayment: true,
                            returnScore: false
                        });
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importApplePayOrderExpress(orderData)
                        ];
                    case 2:
                        res = _state.sent();
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                            isExpressPayment: true,
                            returnScore: true,
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY
                        });
                        trackStartedCheckoutV2();
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).updateCustomer((0, $e2Ogy._)({
                            customerId: res.customerId,
                            custom_user_agent: navigator.userAgent,
                            custom_http_referer: window.location.href
                        }, (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)()));
                        if (window.DEBUG) console.log(res);
                        updatedLead = (0, $ioWVw._)((0, $e2Ogy._)({}, lead), {
                            sessionId: sessionId,
                            orderId: res === null || res === void 0 ? void 0 : res.orderId
                        });
                        session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
                        (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, updatedLead);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        trackStartedCheckoutV2();
                        session.abort();
                        Errors.report(e, {
                            geo: window.GEO,
                            config: _this11.fc.config || "undefined",
                            lead: _this11.fc.lead.lead || "undefined",
                            product: _this11.fc.getSelectedProduct() || "undefined",
                            productIdx: window["productIdx"].value || "undefined"
                        });
                        orderId = _this11.getParams().orderId;
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId, null, {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response6 = e.response) === null || _e$response6 === void 0 ? void 0 : (_e$response6$data = _e$response6.data) === null || _e$response6$data === void 0 ? void 0 : _e$response6$data.message[0])
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(nonce, session, contactInformation) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this12 = this;
    this.createStripeApplePayOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(nonce, event, contactInformation) {
            var _this$fc$config11, locale, _this_getParams, product, customPayloadParams, urlQueryParameters, optinCheckboxes, optinCheckbox, trackStartedCheckoutV2, _contactInformation$a, _this$fc$config12, _navigator9, _window$GEO9, params, _this_getParams1, auid, lead, sessionId, successRedirect, orderData, res, updatedLead, e, _e$response7, _e$response7$data, orderId;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        locale = ((_this$fc$config11 = _this12.fc.config) === null || _this$fc$config11 === void 0 ? void 0 : _this$fc$config11.locale) || "";
                        _this_getParams = _this12.getParams(), product = _this_getParams.product, customPayloadParams = _this_getParams.customPayloadParams;
                        urlQueryParameters = (0, $27fc5057b004f1e0$export$fa3c4e23308a0d5b)();
                        optinCheckboxes = (0, $5743262db8c9d9ed$export$3b7aa821f91b0b75)("optinCheckbox");
                        optinCheckbox = (optinCheckboxes === null || optinCheckboxes === void 0 ? void 0 : optinCheckboxes.filter(function(el) {
                            return el === null || el === void 0 ? void 0 : el.checked;
                        })[0]) || optinCheckboxes[0];
                        trackStartedCheckoutV2 = function() {
                            (0, $0d2dbb712d561fc5$export$b2b7e2b234995bfd).trackStartedCheckoutV2(contactInformation.emailAddress, contactInformation.givenName || contactInformation.familyName, contactInformation.familyName || contactInformation.givenName, product, locale);
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        params = new URLSearchParams(document.location.search);
                        _this_getParams1 = _this12.getParams(), auid = _this_getParams1.auid, lead = _this_getParams1.lead, sessionId = _this_getParams1.sessionId, successRedirect = _this_getParams1.successRedirect;
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY);
                        _this12._setSelectedProductCookie();
                        orderData = (0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)({
                            client: window.BRAND,
                            affId: params.get("affid") || undefined,
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            campaignId: _this12.fc.config.campaignId,
                            product1_id: String(product.id),
                            product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                            product1_shipPrice: product.shippingPrice || 0,
                            emailAddress: contactInformation.emailAddress,
                            sessionId: sessionId,
                            firstName: contactInformation.givenName || contactInformation.familyName,
                            lastName: contactInformation.familyName || contactInformation.givenName,
                            address1: contactInformation !== null && contactInformation !== void 0 && (_contactInformation$a = contactInformation.addressLines) !== null && _contactInformation$a !== void 0 && _contactInformation$a[0] ? contactInformation === null || contactInformation === void 0 ? void 0 : contactInformation.addressLines[0] : "",
                            city: contactInformation.locality,
                            state: contactInformation.administrativeArea || "",
                            postalCode: contactInformation.postalCode || "",
                            country: contactInformation.countryCode || "",
                            phoneNumber: contactInformation.phoneNumber || "",
                            custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                            forceMerchantId: Number((_this$fc$config12 = _this12.fc.config) === null || _this$fc$config12 === void 0 ? void 0 : _this$fc$config12.appleGooglePayMerchantId),
                            companyName: "unfulfilled",
                            fullUrl: location.href,
                            applePayToken: nonce,
                            sourceValue3: auid,
                            custom_order_sid: sessionId,
                            custom2: "apple_pay_express",
                            custom3: "".concat(window.location.origin + window.location.pathname),
                            custom_order_initial: product.id.toString(),
                            custom_order_language: _this12.fc.config.locale,
                            custom_order_paymentType: "apple_pay_express",
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                            note: "initial"
                        }, (0, $50a3061aa036fb76$export$a5202107d3e3cdb0)()), {
                            custom_order_marketing_opt_in: optinCheckbox ? "".concat(optinCheckbox.checked) : "0"
                        }), urlQueryParameters), {
                            userAgent: (_navigator9 = navigator) === null || _navigator9 === void 0 ? void 0 : _navigator9.userAgent,
                            ipAddress: ((_window$GEO9 = window.GEO) === null || _window$GEO9 === void 0 ? void 0 : _window$GEO9.ip) || "::1",
                            custom_order_force: new URL(location.href).searchParams.get("force") || ""
                        }), customPayloadParams);
                        _this12.fc.addAddonsToPurchasePayload(orderData);
                        _this12._addExtraParameters(orderData, "applepay_stripe");
                        // Track create_order event in Sift with orderData containing all products
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder((0, $e2Ogy._)({}, _this12.fc.lead.lead, orderData), {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            isExpressPayment: true,
                            returnScore: false
                        });
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importApplePayOrderExpress(orderData)
                        ];
                    case 2:
                        res = _state.sent();
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                            isExpressPayment: true,
                            returnScore: true,
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY
                        });
                        trackStartedCheckoutV2();
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).updateCustomer((0, $e2Ogy._)({
                            customerId: res.customerId,
                            custom_user_agent: navigator.userAgent,
                            custom_http_referer: window.location.href
                        }, (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)()));
                        if (window.DEBUG) console.log(res);
                        updatedLead = (0, $ioWVw._)((0, $e2Ogy._)({}, lead), {
                            sessionId: sessionId,
                            orderId: res === null || res === void 0 ? void 0 : res.orderId
                        });
                        event.complete("success");
                        (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, updatedLead);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        trackStartedCheckoutV2();
                        event.complete("fail");
                        Errors.report(e, {
                            geo: window.GEO,
                            config: _this12.fc.config || "undefined",
                            lead: _this12.fc.lead.lead || "undefined",
                            product: _this12.fc.getSelectedProduct() || "undefined",
                            productIdx: window["productIdx"].value || "undefined"
                        });
                        orderId = _this12.getParams().orderId;
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId, null, {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response7 = e.response) === null || _e$response7 === void 0 ? void 0 : (_e$response7$data = _e$response7.data) === null || _e$response7$data === void 0 ? void 0 : _e$response7$data.message[0])
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(nonce, event, contactInformation) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this13 = this;
    this.createApplePayOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(nonce, session) {
            var _this$fc$config13, _navigator10, _window$GEO10, _this_getParams, auid, lead, orderId, product, sessionId, successRedirect, customPayloadParams, orderData, res, updatedLead, e;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        _this_getParams = _this13.getParams(), auid = _this_getParams.auid, lead = _this_getParams.lead, orderId = _this_getParams.orderId, product = _this_getParams.product, sessionId = _this_getParams.sessionId, successRedirect = _this_getParams.successRedirect, customPayloadParams = _this_getParams.customPayloadParams;
                        if (!lead) {
                            session.abort();
                            return [
                                2
                            ];
                        }
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY);
                        _this13._setSelectedProductCookie();
                        orderData = (0, $e2Ogy._)({
                            orderId: orderId,
                            custom2: "apple_pay",
                            custom3: "".concat(window.location.origin + window.location.pathname),
                            client: window.BRAND,
                            applePayToken: nonce,
                            fullUrl: location.href,
                            companyName: "unfulfilled",
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            product1_id: String(product.id),
                            custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                            product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                            emailAddress: lead.emailAddress || "",
                            campaignId: _this13.fc.config.campaignId,
                            product1_shipPrice: product.shippingPrice || 0,
                            forceMerchantId: Number((_this$fc$config13 = _this13.fc.config) === null || _this$fc$config13 === void 0 ? void 0 : _this$fc$config13.appleGooglePayMerchantId),
                            sourceValue3: auid,
                            custom_order_auid: auid,
                            custom_order_sid: sessionId,
                            custom_order_paymentType: "apple_pay",
                            custom_order_initial: product.id.toString(),
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                            custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                            note: "initial",
                            userAgent: (_navigator10 = navigator) === null || _navigator10 === void 0 ? void 0 : _navigator10.userAgent,
                            ipAddress: ((_window$GEO10 = window.GEO) === null || _window$GEO10 === void 0 ? void 0 : _window$GEO10.ip) || "::1",
                            custom_order_force: new URL(location.href).searchParams.get("force") || ""
                        }, customPayloadParams);
                        _this13.fc.addAddonsToPurchasePayload(orderData);
                        _this13._addExtraParameters(orderData, "applepay");
                        // Track create_order event in Sift with orderData
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder(orderData, {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            returnScore: false
                        });
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importApplePayOrder(orderData)
                        ];
                    case 1:
                        res = _state.sent();
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                            isExpressPayment: true,
                            returnScore: true,
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY
                        });
                        if (window.DEBUG) console.log(res);
                        updatedLead = (0, $ioWVw._)((0, $e2Ogy._)({}, lead), {
                            sessionId: sessionId,
                            orderId: res === null || res === void 0 ? void 0 : res.orderId
                        });
                        session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
                        (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, updatedLead);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        session.abort();
                        Errors.report(e, {
                            geo: window.GEO,
                            config: _this13.fc.config || "undefined",
                            lead: _this13.fc.lead.lead || "undefined",
                            product: _this13.fc.getSelectedProduct() || "undefined",
                            productIdx: window["productIdx"].value || "undefined"
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearInterval($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(nonce, session) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this14 = this;
    this.initAppleSession = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(leadCb, expressButton) {
            var _this$braintree, session, mid, lead;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (_this$braintree = _this14.braintree) === null || _this$braintree === void 0 ? void 0 : _this$braintree.createAppleSession(_this14, _this14.fc.config.expressApplePay)
                        ];
                    case 1:
                        session = _state.sent();
                        session === null || session === void 0 || session.begin();
                        if (!!expressButton) return [
                            3,
                            3
                        ];
                        mid = _this14.fc.config.appleGooglePayMerchantId;
                        return [
                            4,
                            leadCb("apple_pay", true, mid)
                        ];
                    case 2:
                        lead = _state.sent();
                        if (!lead) session === null || session === void 0 || session.abort();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(leadCb, expressButton) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this15 = this;
    this.initStripeApplePay = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(expressButton) {
            var _this$stripeApplePay;
            return (0, $33z5g.__generator)(this, function(_state) {
                if (window.DEBUG) // Maybe remove latter
                console.log(expressButton);
                (_this$stripeApplePay = _this15.stripeApplePay) === null || _this$stripeApplePay === void 0 || _this$stripeApplePay.createApplePayment(_this15, _this15.fc.config.expressApplePay);
                return [
                    2
                ];
            });
        });
        return function(expressButton) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this16 = this;
    this.createGooglePayOrder = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var _this$braintree2, _this$fc$config14, _this$fc$config15, _this$fc$config16, _navigator11, _window$GEO11, _this_getParams, auid, lead, orderId, product, sessionId, successRedirect, customPayloadParams, result, orderData, res, e, _e$response8, _e$response8$data, orderId1;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    _this_getParams = _this16.getParams(), auid = _this_getParams.auid, lead = _this_getParams.lead, orderId = _this_getParams.orderId, product = _this_getParams.product, sessionId = _this_getParams.sessionId, successRedirect = _this_getParams.successRedirect, customPayloadParams = _this_getParams.customPayloadParams;
                    return [
                        4,
                        (_this$braintree2 = _this16.braintree) === null || _this$braintree2 === void 0 ? void 0 : _this$braintree2.createGPayOrder(product)
                    ];
                case 1:
                    result = _state.sent();
                    if (!(result !== null && result !== void 0 && result.nonce)) return [
                        2
                    ];
                    $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY);
                    orderData = (0, $e2Ogy._)({
                        orderId: orderId,
                        client: window.BRAND,
                        fullUrl: location.href,
                        paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY,
                        product1_id: String(product.id),
                        emailAddress: lead.emailAddress,
                        product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                        campaignId: _this16.fc.config.campaignId,
                        product1_shipPrice: product.shippingPrice || 0,
                        custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                        forceMerchantId: Number((_this$fc$config14 = _this16.fc.config) !== null && _this$fc$config14 !== void 0 && _this$fc$config14.braintreeAppleGooglePayMerchantId ? (_this$fc$config15 = _this16.fc.config) === null || _this$fc$config15 === void 0 ? void 0 : _this$fc$config15.braintreeAppleGooglePayMerchantId : (_this$fc$config16 = _this16.fc.config) === null || _this$fc$config16 === void 0 ? void 0 : _this$fc$config16.appleGooglePayMerchantId),
                        companyName: "unfulfilled",
                        googlePayToken: (result === null || result === void 0 ? void 0 : result.nonce) || "",
                        custom2: "google_pay",
                        custom3: "".concat(window.location.origin + window.location.pathname),
                        custom_order_paymentType: "google_pay",
                        sourceValue3: auid,
                        custom_order_auid: auid,
                        custom_order_sid: sessionId,
                        custom_order_initial: product.id.toString(),
                        custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY,
                        custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                        custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT,
                        note: "initial",
                        userAgent: (_navigator11 = navigator) === null || _navigator11 === void 0 ? void 0 : _navigator11.userAgent,
                        ipAddress: ((_window$GEO11 = window.GEO) === null || _window$GEO11 === void 0 ? void 0 : _window$GEO11.ip) || "::1",
                        custom_order_force: new URL(location.href).searchParams.get("force") || ""
                    }, customPayloadParams);
                    _this16.fc.addAddonsToPurchasePayload(orderData);
                    _this16._addExtraParameters(orderData, "googlepay");
                    // Track create_order event in Sift with orderData
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder(orderData, {
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY,
                        returnScore: false
                    });
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importGooglePayOrder(orderData)
                    ];
                case 2:
                    res = _state.sent();
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                        isExpressPayment: true,
                        returnScore: true,
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY
                    });
                    if (window.DEBUG) console.log(res);
                    (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, _this16.fc.lead.lead);
                    return [
                        3,
                        5
                    ];
                case 3:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        config: _this16.fc.config || "undefined",
                        lead: _this16.fc.lead.lead || "undefined",
                        product: _this16.fc.getSelectedProduct() || "undefined",
                        productIdx: window["productIdx"].value || "undefined"
                    });
                    orderId1 = _this16.getParams().orderId;
                    (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId1, null, {
                        paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY,
                        errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response8 = e.response) === null || _e$response8 === void 0 ? void 0 : (_e$response8$data = _e$response8.data) === null || _e$response8$data === void 0 ? void 0 : _e$response8$data.message[0])
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    $3dd279f8370fe9d2$var$NON_RESPONSIVE_TS && clearTimeout($3dd279f8370fe9d2$var$NON_RESPONSIVE_TS);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    var _this17 = this;
    this.createExpressKlarnaOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(authorize, callback) {
            var _this_getParams, auid, product, sessionId, successRedirect, customPayloadParams, order, e, _e$response9, _e$response9$data, orderId;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!_this17.klarna) throw new Error("Klarna service undefined");
                        _this_getParams = _this17.getParams(), auid = _this_getParams.auid, product = _this_getParams.product, sessionId = _this_getParams.sessionId, successRedirect = _this_getParams.successRedirect, customPayloadParams = _this_getParams.customPayloadParams;
                        order = _this17.klarna.createExpressKlarnaOrderObj(product);
                        _this17._setSelectedProductCookie();
                        return [
                            4,
                            authorize({
                                auto_finalize: true,
                                collect_shipping_address: true
                            }, order, function() {
                                var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(result) {
                                    var _this$klarna, orderPayload, customerTokenResponse, klarnaOrderResponse, optinCheckboxes, optinCheckbox, lead, _navigator12, _window$GEO12, orderData, res;
                                    return (0, $33z5g.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (window.DEBUG) console.log("result: ", result);
                                                if (!(result.authorization_token && result.collected_shipping_address)) return [
                                                    3,
                                                    10
                                                ];
                                                _this17.fc.lead.setLeadInfo(result.collected_shipping_address.given_name, result.collected_shipping_address.family_name, result.collected_shipping_address.postal_code, result.collected_shipping_address.city, result.collected_shipping_address.country, result.collected_shipping_address.email, result.collected_shipping_address.phone, result.collected_shipping_address.street_address);
                                                return [
                                                    4,
                                                    _this17.fc.lead.prefillForm()
                                                ];
                                            case 1:
                                                _state.sent();
                                                orderPayload = (_this$klarna = _this17.klarna) === null || _this$klarna === void 0 ? void 0 : _this$klarna.createExpressKlarnaOrderObj(product, result.authorization_token, result.collected_shipping_address);
                                                return [
                                                    4,
                                                    (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).getCustomerToken(orderPayload)
                                                ];
                                            case 2:
                                                customerTokenResponse = _state.sent();
                                                return [
                                                    4,
                                                    (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).createKlarnaPaymentsOrder(orderPayload)
                                                ];
                                            case 3:
                                                klarnaOrderResponse = _state.sent();
                                                optinCheckboxes = (0, $5743262db8c9d9ed$export$3b7aa821f91b0b75)("optinCheckbox");
                                                optinCheckbox = (optinCheckboxes === null || optinCheckboxes === void 0 ? void 0 : optinCheckboxes.filter(function(el) {
                                                    return el === null || el === void 0 ? void 0 : el.checked;
                                                })[0]) || optinCheckboxes[0];
                                                if (!(klarnaOrderResponse !== null && klarnaOrderResponse !== void 0 && klarnaOrderResponse.order_id)) return [
                                                    3,
                                                    8
                                                ];
                                                return [
                                                    4,
                                                    _this17.fc.lead.createLead("PREPAID", false)
                                                ];
                                            case 4:
                                                lead = _state.sent();
                                                if (!lead) return [
                                                    3,
                                                    6
                                                ];
                                                orderData = (0, $e2Ogy._)((0, $ioWVw._)((0, $e2Ogy._)({
                                                    client: window.BRAND,
                                                    fullUrl: location.href,
                                                    orderId: _this17.fc.lead.lead.orderId || "",
                                                    emailAddress: _this17.fc.lead.lead.emailAddress,
                                                    product1_id: String(product.id),
                                                    product1_price: product.discountPrice ? product.finalPrice - product.discountPrice : product.finalPrice,
                                                    klarnaOrderId: klarnaOrderResponse.order_id,
                                                    quantity: product.quantity,
                                                    klarnaAuthToken: "token",
                                                    product1_shipPrice: product.shippingPrice || 0,
                                                    paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PREPAID,
                                                    campaignId: _this17.fc.config.campaignId,
                                                    custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                                                    custom2: "klarna",
                                                    custom3: "".concat(window.location.origin + window.location.pathname),
                                                    sourceValue3: auid,
                                                    sourceValue4: "id=".concat(_this17.fc.lead.lead.orderId),
                                                    companyName: "unfullfiled",
                                                    currency: product.currencyCode,
                                                    custom_order_language: _this17.fc.config.locale,
                                                    custom_order_auid: auid,
                                                    custom_order_sid: sessionId,
                                                    custom_order_paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                                                    custom_order_initial: product.id.toString(),
                                                    custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                                                    custom_order_freeGift: (product === null || product === void 0 ? void 0 : product.freeGift) || false,
                                                    custom_order_klarnaToken: customerTokenResponse === null || customerTokenResponse === void 0 ? void 0 : customerTokenResponse.token_id,
                                                    custom_order_order_flow: window.IS_1_CLICK ? (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT_1CLICK : (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).CHECKOUT
                                                }, (0, $50a3061aa036fb76$export$a5202107d3e3cdb0)()), {
                                                    custom_order_marketing_opt_in: optinCheckbox ? "".concat(optinCheckbox.checked) : "0",
                                                    note: "initial",
                                                    userAgent: (_navigator12 = navigator) === null || _navigator12 === void 0 ? void 0 : _navigator12.userAgent,
                                                    ipAddress: ((_window$GEO12 = window.GEO) === null || _window$GEO12 === void 0 ? void 0 : _window$GEO12.ip) || "::1",
                                                    custom_order_force: new URL(location.href).searchParams.get("force") || ""
                                                }), customPayloadParams);
                                                _this17.fc.addAddonsToPurchasePayload(orderData);
                                                _this17._addExtraParameters(orderData, "klarna_express");
                                                (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).createOrder(orderData, {
                                                    paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                                                    isExpressPayment: true,
                                                    returnScore: false
                                                });
                                                return [
                                                    4,
                                                    (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importKlarnaOrder(orderData)
                                                ];
                                            case 5:
                                                res = _state.sent();
                                                (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackTransaction(orderData, res, {
                                                    isExpressPayment: true,
                                                    returnScore: true,
                                                    paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA
                                                });
                                                if (callback) callback(result);
                                                (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, _this17.fc.lead.lead);
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 6:
                                                throw new Error("Invalid Express Klarna order response");
                                            case 7:
                                                return [
                                                    3,
                                                    9
                                                ];
                                            case 8:
                                                if (callback) callback(result);
                                                _state.label = 9;
                                            case 9:
                                                return [
                                                    3,
                                                    11
                                                ];
                                            case 10:
                                                if (callback) callback(result);
                                                _state.label = 11;
                                            case 11:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(result) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        Errors.report(e, {
                            geo: window.GEO,
                            config: _this17.fc.config || "undefined",
                            lead: _this17.fc.lead.lead || "undefined",
                            product: _this17.fc.getSelectedProduct() || "undefined",
                            productIdx: window["productIdx"].value || "undefined"
                        });
                        orderId = _this17.getParams().orderId;
                        (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackFailedTransaction(orderId, null, {
                            paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                            errorMessage: "".concat(e === null || e === void 0 ? void 0 : (_e$response9 = e.response) === null || _e$response9 === void 0 ? void 0 : (_e$response9$data = _e$response9.data) === null || _e$response9$data === void 0 ? void 0 : _e$response9$data.message[0])
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(authorize, callback) {
            return _ref.apply(this, arguments);
        };
    }();
    this.fc = fc;
    if (window.DEBUG) console.log("FF_FLAGS", window.FLAGS);
};




var $fvacx = parcelRequire("fvacx");

var $e2Ogy = parcelRequire("e2Ogy");

var $33z5g = parcelRequire("33z5g");





var $33z5g = parcelRequire("33z5g");


var $7a2c65771269a328$export$cf8d79860d2e0daa = function() {
    var _window$ApplePaySessi, _window$ApplePaySessi2;
    return !!(window.ApplePaySession && (_window$ApplePaySessi = window.ApplePaySession) !== null && _window$ApplePaySessi !== void 0 && _window$ApplePaySessi.supportsVersion(3) && (_window$ApplePaySessi2 = window.ApplePaySession) !== null && _window$ApplePaySessi2 !== void 0 && _window$ApplePaySessi2.canMakePayments());
};
var $7a2c65771269a328$export$ea3e311f52f5f415 = function(paySource) {
    if (!paySource) return "";
    switch(paySource.toUpperCase()){
        case "CREDITCARD":
            return "credit_card";
        case "PAYPAL":
            return "paypal";
        default:
            return "";
    }
};
var $7a2c65771269a328$export$e7e7f0e9205430e8 = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var paymentsClient, clientInstance, googlePaymentInstance, isReadyToPay, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    paymentsClient = new google.payments.api.PaymentsClient({
                        environment: "PRODUCTION"
                    });
                    return [
                        4,
                        (0, $a3012b76ed9b4143$exports.client).create({
                            authorization: (0, $42a1df290c3667d2$export$e506a1d27d1eaa20).BR_KEY
                        })
                    ];
                case 1:
                    clientInstance = _state.sent();
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            (0, (/*@__PURE__*/$parcel$interopDefault($a3012b76ed9b4143$exports))).googlePayment.create({
                                client: clientInstance,
                                googlePayVersion: 2,
                                googleMerchantId: (0, $42a1df290c3667d2$export$e506a1d27d1eaa20).BR_ID
                            }, function(err, instance) {
                                if (err) reject(err);
                                else resolve(instance);
                            });
                        })
                    ];
                case 2:
                    googlePaymentInstance = _state.sent();
                    return [
                        4,
                        paymentsClient.isReadyToPay({
                            apiVersion: 2,
                            apiVersionMinor: 0,
                            allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
                            existingPaymentMethodRequired: true
                        })
                    ];
                case 3:
                    isReadyToPay = _state.sent();
                    return [
                        2,
                        {
                            isReadyToPayResult: isReadyToPay.result
                        }
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        2,
                        {
                            isReadyToPayResult: false
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function isGooglePayAvailable() {
        return _ref.apply(this, arguments);
    };
}();
var $7a2c65771269a328$export$495d015e1534431d = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(param) {
        var googleEnabled, appleEnabled, applePayAvailable, googlePayAvailable, googlePayData;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    googleEnabled = param.googleEnabled, appleEnabled = param.appleEnabled;
                    applePayAvailable = false;
                    googlePayAvailable = false;
                    if (appleEnabled) applePayAvailable = $7a2c65771269a328$export$cf8d79860d2e0daa();
                    if (!(googleEnabled && !applePayAvailable)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $7a2c65771269a328$export$e7e7f0e9205430e8()
                    ];
                case 1:
                    googlePayData = _state.sent();
                    googlePayAvailable = googlePayData.isReadyToPayResult;
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        {
                            applePayAvailable: applePayAvailable,
                            googlePayAvailable: googlePayAvailable
                        }
                    ];
            }
        });
    });
    return function showExpressButtons(_) {
        return _ref.apply(this, arguments);
    };
}();









var $5a0dbbbbdfb7a66a$var$NON_RESPONSIVE_TS = null;
var $5a0dbbbbdfb7a66a$export$c6274960077a35ad = function OneClickController(fc) {
    "use strict";
    var _this = this;
    (0, $fvacx._)(this, OneClickController);
    this.getParams = function() {
        var _this$fc$config, _this$fc$config2;
        var auid = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)().custom_order_auid;
        var lead = _this.fc.lead.lead;
        var orderId = lead.orderId;
        var sessionId = _this.fc.config.sessionId;
        var product = _this.fc.getSelectedProduct();
        var successRedirect = (_this$fc$config = _this.fc.config) === null || _this$fc$config === void 0 ? void 0 : _this$fc$config.redirectTo;
        var serverRedirectUrl = (_this$fc$config2 = _this.fc.config) === null || _this$fc$config2 === void 0 ? void 0 : _this$fc$config2.ppSuccessRedirectUrl;
        if (!product) throw new Error("Error: Products is undefined");
        if (!sessionId) throw new Error("Error: sessionId is undefined in OneClick");
        if (!successRedirect) throw new Error("Error: successRedirect is undefined");
        if (!serverRedirectUrl) throw new Error("Error: serverRedirUrl is undefined");
        return {
            auid: auid,
            lead: lead,
            orderId: orderId,
            product: product,
            sessionId: sessionId,
            successRedirect: successRedirect,
            serverRedirectUrl: serverRedirectUrl
        };
    };
    var _this1 = this;
    this.createOneClickOrder = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var _this_getParams, auid, lead, orderId, product, sessionId, successRedirect, serverRedirectUrl, disallowedToBuy, orderData, res, newOrderId, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setUpsellButtonLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    _this_getParams = _this1.getParams(), auid = _this_getParams.auid, lead = _this_getParams.lead, orderId = _this_getParams.orderId, product = _this_getParams.product, sessionId = _this_getParams.sessionId, successRedirect = _this_getParams.successRedirect, serverRedirectUrl = _this_getParams.serverRedirectUrl;
                    if (!successRedirect) throw new Error("Error: successRedirect is undefined");
                    if (!serverRedirectUrl) throw new Error("Error: serverRedirectUrl is undefined");
                    // User can make only one 1click order per hour
                    disallowedToBuy = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("disallow_click_order");
                    if (disallowedToBuy) {
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setUpsellButtonLoading(false);
                        return [
                            2,
                            "block"
                        ];
                    }
                    // TODO: Fix paypal reach 1click flow
                    orderData = (0, $e2Ogy._)({
                        orderId: orderId,
                        sessionId: sessionId,
                        sourceValue3: auid,
                        client: window.BRAND,
                        salesUrl: location.href,
                        custom1: (0, $5afc064d4f10b824$export$49b9065228a93aae)("ad_id"),
                        custom2: lead.paymentType || (0, $7a2c65771269a328$export$ea3e311f52f5f415)(lead.paySource),
                        custom3: "".concat(window.location.origin + window.location.pathname),
                        product1_id: product.id.toString(),
                        product1_price: product.finalPrice,
                        campaignId: _this1.fc.config.campaignId,
                        product1_shipPrice: product.shippingPrice || 0,
                        redirectsTo: (0, $5afc064d4f10b824$export$7138c24907de3954)(serverRedirectUrl, {
                            redirectTo: successRedirect
                        }),
                        errorRedirectsTo: (0, $5afc064d4f10b824$export$7138c24907de3954)("/products-order/us", {
                            cancel_url: "1",
                            order_id: orderId
                        }),
                        custom_order_sid: sessionId,
                        custom_user_agent: navigator.userAgent,
                        custom_http_referer: window.location.href,
                        custom_order_initial: product.id.toString(),
                        custom_order_paymentMethod: lead.paymentMethod || "",
                        custom_order_paymentType: lead.paymentType || "",
                        custom_order_order_flow: (0, $7b29a6ccdf5c2334$export$8b32abc48eb67713).ONE_CLICK,
                        custom_order_prev_order_id: orderId,
                        custom_order_mg_tracking_id: (0, $5afc064d4f10b824$export$49b9065228a93aae)("mg_tracking_id"),
                        note: "initial-1click"
                    }, (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)());
                    $5a0dbbbbdfb7a66a$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton((0, $56ab4c05fb950c51$export$2a51769b07fe601).ONE_CLICK);
                    return [
                        4,
                        (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importOneClick(orderData)
                    ];
                case 2:
                    res = _state.sent();
                    if (window.DEBUG) console.log(res);
                    newOrderId = res.orderId;
                    (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("order_id", newOrderId, 10);
                    if (!window.DEBUG) (0, $4aacaa5cfd9fe25b$export$5dec5dc3bcf1b35)("disallow_click_order", "true");
                    if ((0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url)) window.location.href = res.url;
                    else if (res.script) (0, $3391119dba56c39d$export$22b283b94688ae65)(res.script);
                    else (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(successRedirect, {
                        orderId: newOrderId,
                        sessionId: sessionId
                    });
                    return [
                        2,
                        "success"
                    ];
                case 3:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        config: _this1.fc.config || "undefined",
                        lead: _this1.fc.lead.lead || "undefined",
                        product: _this1.fc.getSelectedProduct() || "undefined",
                        productIdx: window["productIdx"].value || "undefined"
                    }, false, false);
                    return [
                        2,
                        "error"
                    ];
                case 4:
                    $5a0dbbbbdfb7a66a$var$NON_RESPONSIVE_TS && clearTimeout($5a0dbbbbdfb7a66a$var$NON_RESPONSIVE_TS);
                    (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setUpsellButtonLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    this.fc = fc;
};




var $fvacx = parcelRequire("fvacx");

var $33z5g = parcelRequire("33z5g");


var $cc2840e193756acd$export$c730d5a0156b5bea = function ThankYouController(fc) {
    "use strict";
    (0, $fvacx._)(this, ThankYouController);
    var _this = this;
    this.fetchOrderItems = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var lead;
        return (0, $33z5g.__generator)(this, function(_state) {
            lead = _this.fc.lead.lead;
            try {
                if (lead && lead.orderId) return [
                    2,
                    (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).queryOrder(lead.orderId)
                ];
            } catch (e) {
                Errors.report(e, {
                    geo: window.GEO,
                    config: _this.fc.config,
                    lead: _this.fc.lead.lead
                });
            }
            return [
                2
            ];
        });
    });
    var _this1 = this;
    this.injectInfo = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var orderSummary, currency, totalAmount, products, demoRow, summaryTable;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _this1.fetchOrderItems()
                    ];
                case 1:
                    orderSummary = _state.sent();
                    try {
                        currency = orderSummary === null || orderSummary === void 0 ? void 0 : orderSummary.currencySymbol;
                        totalAmount = document.getElementById("totalAmount");
                        if (totalAmount) totalAmount.textContent = "".concat(currency).concat(orderSummary === null || orderSummary === void 0 ? void 0 : orderSummary.totalAmount);
                        products = orderSummary === null || orderSummary === void 0 ? void 0 : orderSummary.products;
                        demoRow = document.getElementById("productRow");
                        summaryTable = document.getElementById("summaryTable");
                        if (summaryTable && demoRow && products && (products === null || products === void 0 ? void 0 : products.length) > 0) products.forEach(function(p) {
                            var newRow = demoRow.cloneNode(true);
                            newRow.id = "productRow".concat(p.productId);
                            var image = newRow.querySelector("#productImage");
                            var title = newRow.querySelector("#productTitle");
                            var price = newRow.querySelector("#productPrice");
                            var shippingPrice = newRow.querySelector("#productShipPrice");
                            var totalPrice = newRow.querySelector("#productTotal");
                            if (image && p !== null && p !== void 0 && p.imageUrl) image.src = p.imageUrl;
                            if (title) title.textContent = p.name;
                            if (price) price.textContent = "".concat(currency).concat(p.price);
                            if (shippingPrice) shippingPrice.textContent = "".concat(currency).concat(p.shipping);
                            if (totalPrice) {
                                var totalProductAmount = (0, $bb370a6f0f5e546c$export$51c33147a10dff3e)(p.price, p.shipping);
                                totalPrice.textContent = "".concat(currency).concat(totalProductAmount.toFixed(2));
                            }
                            summaryTable.append(newRow);
                        });
                        demoRow === null || demoRow === void 0 || demoRow.remove();
                    } catch (e) {
                        Errors.report(e, {
                            orderSummary: orderSummary,
                            geo: window.GEO,
                            config: _this1.fc.config,
                            lead: _this1.fc.lead.lead
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    });
    this.fc = fc;
};




var $fvacx = parcelRequire("fvacx");

var $e2Ogy = parcelRequire("e2Ogy");

var $ioWVw = parcelRequire("ioWVw");

var $3F6om = parcelRequire("3F6om");

var $33z5g = parcelRequire("33z5g");











var $e4eceaf0997e714b$export$954bfa722e9216d8 = function(url) {
    var urlInput = url || window.location.href;
    var urlObject = new URL(urlInput);
    var pathSegments = urlObject.pathname.split("/").filter(function(segment) {
        return segment !== "";
    });
    var upsellPage = pathSegments[0] || "";
    var lastChar = upsellPage.charAt(upsellPage.length - 1);
    var upsellKey = parseInt(lastChar, 10) - 1;
    if (typeof upsellKey === "number" && !isNaN(upsellKey)) return upsellKey;
    return undefined;
};
var $e4eceaf0997e714b$export$3be0e5f461bd5034 = function(upsellKeyOverride) {
    var upsellKey = upsellKeyOverride || $e4eceaf0997e714b$export$954bfa722e9216d8();
    if (typeof upsellKey === "number") return "custom_order_promo".concat(upsellKey + 1);
    return undefined;
};
var $e4eceaf0997e714b$export$85d6a57246cafc26 = function(no) {
    if (typeof no === "number") return "custom_order_promo".concat(no + 1);
    else if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(1)) return "custom_order_promo1";
    else if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(2)) return "custom_order_promo2";
    else if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(3)) return "custom_order_promo3";
    else if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(4)) return "custom_order_promo4";
    return undefined;
};
var $e4eceaf0997e714b$export$220fd3a74ae8d54 = function(lead) {
    if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(1)) return lead.initial;
    else if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(2)) return lead.promo1;
    else if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(3)) return lead.promo2;
    else if ((0, $13c7326b49cbd18b$export$504c889bcc104ed7)(4)) return lead.promo3;
    else if ((0, $13c7326b49cbd18b$export$200a98ceebf95bbb)()) {
        var upsellKey = $e4eceaf0997e714b$export$954bfa722e9216d8(document.referrer);
        if (typeof upsellKey === "number") {
            var promoField = "promo".concat(upsellKey + 1);
            return lead[promoField];
        }
        return undefined;
    }
    return undefined;
};





var $5e716b66697175e6$var$NON_RESPONSIVE_TS = null;
var $5e716b66697175e6$export$d9442176d2557838 = function UpsellController(fc, upsellKey) {
    "use strict";
    (0, $fvacx._)(this, UpsellController);
    this.ppConfig = window.FLAGS.pp_profile;
    var _this = this;
    // TODO create getParams method
    this.createPaypalUpsellOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(paySource, upsellKey) {
            var lead, product, storage, upsellData, promoFieldName;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this.fc.lead.lead;
                        product = _this.fc.getSelectedProduct();
                        storage = (0, $f7052bb2eb427bc1$export$4395c3ac0493290e).getInstance();
                        return [
                            4,
                            storage.setValue("selectedProductInstance", product)
                        ];
                    case 1:
                        _state.sent();
                        (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackUpsellButtonClick(paySource, lead.orderId, lead.customerId, lead.auid);
                        upsellData = {
                            orderId: (lead === null || lead === void 0 ? void 0 : lead.orderId) || "",
                            sessionId: lead.sessionId,
                            client: window.BRAND,
                            campaignId: _this.fc.config.campaignId,
                            paySource: paySource,
                            product1_id: product.id,
                            product1_price: product.finalPrice,
                            product1_shipPrice: _this.fc.config.shippingPrice || 0,
                            salesUrl: location.href,
                            errorRedirectsTo: location.href,
                            redirectsTo: (0, $5afc064d4f10b824$export$7138c24907de3954)(_this.fc.config.redirectTo || "", {
                                orderId: lead.orderId || ""
                            }),
                            custom_order_sid: lead.sessionId,
                            custom_order_auid: lead.auid || "",
                            custom_order_paymentType: lead.paymentType || "",
                            custom_order_paymentMethod: lead.paymentMethod || "",
                            note: upsellKey !== undefined ? "".concat(product !== null && product !== void 0 && product.isDownsell ? "downsell" : "upsell").concat(upsellKey + 1) : ""
                        };
                        promoFieldName = (0, $e4eceaf0997e714b$export$85d6a57246cafc26)(_this.upsellKey);
                        if (promoFieldName) upsellData[promoFieldName] = String(product.id);
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importPaypalUpsell(upsellData)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(paySource, upsellKey) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this1 = this;
    this.createStripeKlarnaUpsellOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(upsellKey) {
            var _this$fc$config, lead, product, upsellData, promoFieldName;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this1.fc.lead.lead;
                        product = _this1.fc.getSelectedProduct();
                        if (!((_this$fc$config = _this1.fc.config) !== null && _this$fc$config !== void 0 && _this$fc$config.redirectTo)) throw new Error("Error: redirectTo is undefined");
                        upsellData = {
                            orderId: (lead === null || lead === void 0 ? void 0 : lead.orderId) || "",
                            sessionId: lead.sessionId,
                            client: window.BRAND,
                            campaignId: _this1.fc.config.campaignId,
                            prepaidType: "KLARNA",
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PREPAID,
                            product1_id: String(product.id),
                            product1_price: product.finalPrice,
                            product1_shipPrice: _this1.fc.config.shippingPrice || 0,
                            forceMerchantId: _this1.fc.config.forceMerchantId || "117",
                            salesUrl: location.href,
                            errorRedirectsTo: location.href,
                            redirectsTo: (0, $5afc064d4f10b824$export$7138c24907de3954)(_this1.fc.config.ppSuccessRedirectUrl || "", {
                                redirectTo: _this1.fc.config.redirectTo
                            }),
                            custom_order_sid: lead.sessionId,
                            custom_order_auid: lead.auid || "",
                            custom_order_paymentType: lead.paymentType || "",
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).STRIPE_KLARNA,
                            note: upsellKey !== undefined ? "".concat(product !== null && product !== void 0 && product.isDownsell ? "downsell" : "upsell").concat(upsellKey + 1) : ""
                        };
                        promoFieldName = (0, $e4eceaf0997e714b$export$85d6a57246cafc26)(_this1.upsellKey);
                        if (promoFieldName) upsellData[promoFieldName] = String(product.id);
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importKlarnaStripeUpsell(upsellData)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(upsellKey) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this2 = this;
    this.createCreditCardUpsellOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(upsellKey) {
            var _this$fc$config2, lead, product, upsellData, promoFieldName;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this2.fc.lead.lead;
                        product = _this2.fc.getSelectedProduct();
                        (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackUpsellButtonClick((0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD, lead.orderId, lead.customerId, lead.auid);
                        if (!((_this$fc$config2 = _this2.fc.config) !== null && _this$fc$config2 !== void 0 && _this$fc$config2.redirectTo)) throw new Error("Error: redirectTo is undefined");
                        upsellData = {
                            errorRedirectsTo: location.href,
                            redirectsTo: (0, $5afc064d4f10b824$export$7138c24907de3954)(_this2.fc.config.ppSuccessRedirectUrl || "", {
                                redirectTo: _this2.fc.config.redirectTo
                            }),
                            salesUrl: location.href,
                            orderId: (lead === null || lead === void 0 ? void 0 : lead.orderId) || "",
                            sessionId: lead.sessionId,
                            client: window.BRAND,
                            campaignId: _this2.fc.config.campaignId,
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD,
                            product1_id: product.id,
                            product1_price: product.finalPrice,
                            product1_shipPrice: _this2.fc.config.shippingPrice || 0,
                            custom_order_sid: lead.sessionId,
                            custom_order_auid: lead.auid || "",
                            custom_order_paymentType: lead.paymentType || "",
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD,
                            note: upsellKey !== undefined ? "".concat(product !== null && product !== void 0 && product.isDownsell ? "downsell" : "upsell").concat(upsellKey + 1) : ""
                        };
                        promoFieldName = (0, $e4eceaf0997e714b$export$85d6a57246cafc26)(_this2.upsellKey);
                        if (promoFieldName) upsellData[promoFieldName] = String(product.id);
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importCreditCardUpsell(upsellData)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(upsellKey) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this3 = this;
    this.createApplePayUpsell = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(upsellKey) {
            var lead, product, upsellData, promoFieldName;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this3.fc.lead.lead;
                        product = _this3.fc.getSelectedProduct();
                        (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackUpsellButtonClick((0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY, lead.orderId, lead.customerId, lead.auid);
                        upsellData = {
                            emailAddress: lead.emailAddress,
                            campaignId: _this3.fc.config.campaignId,
                            orderId: (lead === null || lead === void 0 ? void 0 : lead.orderId) || "",
                            product1_id: Number(product.id),
                            product1_price: product.finalPrice,
                            product1_shipPrice: product.shippingPrice,
                            sessionId: lead.sessionId,
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            client: window.BRAND,
                            custom_order_sid: lead.sessionId,
                            custom_order_auid: lead.auid || "",
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY,
                            custom_order_paymentType: lead.paymentType || "",
                            note: upsellKey !== undefined ? "".concat(product !== null && product !== void 0 && product.isDownsell ? "downsell" : "upsell").concat(upsellKey + 1) : ""
                        };
                        promoFieldName = (0, $e4eceaf0997e714b$export$85d6a57246cafc26)(_this3.upsellKey);
                        if (promoFieldName) upsellData[promoFieldName] = String(product.id);
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importApplePayUpsell(upsellData)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(upsellKey) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this4 = this;
    this.createGooglePayUpsell = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(upsellKey) {
            var lead, product, upsellData, promoFieldName;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this4.fc.lead.lead;
                        product = _this4.fc.getSelectedProduct();
                        (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackUpsellButtonClick((0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY, lead.orderId, lead.customerId, lead.auid);
                        upsellData = {
                            emailAddress: lead.emailAddress,
                            campaignId: _this4.fc.config.campaignId,
                            orderId: (lead === null || lead === void 0 ? void 0 : lead.orderId) || "",
                            client: window.BRAND,
                            product1_id: product.id,
                            product1_price: product.finalPrice,
                            product1_shipPrice: product.shippingPrice,
                            sessionId: lead.sessionId,
                            paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY,
                            custom_order_sid: lead.sessionId,
                            custom_order_auid: lead.auid || "",
                            custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY,
                            custom_order_paymentType: lead.paymentType || "",
                            note: upsellKey !== undefined ? "".concat(product !== null && product !== void 0 && product.isDownsell ? "downsell" : "upsell").concat(upsellKey + 1) : ""
                        };
                        promoFieldName = (0, $e4eceaf0997e714b$export$85d6a57246cafc26)(_this4.upsellKey);
                        if (promoFieldName) upsellData[promoFieldName] = String(product.id);
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importGooglePayUpsell(upsellData)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(upsellKey) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this5 = this;
    this.createKlarnaUpsellOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(upsellKey) {
            var lead, product, redirect, _calculatePrices, unitPrice, totalAmount, isTaken, upsellData, upsellCustomKey;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this5.fc.lead.lead;
                        product = _this5.fc.getSelectedProduct();
                        (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackUpsellButtonClick((0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA, lead.orderId, lead.customerId, lead.auid);
                        redirect = (0, $5afc064d4f10b824$export$7138c24907de3954)(_this5.fc.config.redirectTo || "", {
                            prospect_id: String(_this5.fc.lead.lead.orderId)
                        });
                        _calculatePrices = (0, $bb370a6f0f5e546c$export$fca6a3397460b397)(product.finalPrice, product.quantity, product.shippingPrice), unitPrice = _calculatePrices.unitPrice, totalAmount = _calculatePrices.totalAmount;
                        return [
                            4,
                            (0, $7754e9c9dfeff508$export$8f28b0615eb59db7)(lead.orderId || "", String(product.id))
                        ];
                    case 1:
                        isTaken = _state.sent();
                        if (!isTaken) return [
                            3,
                            2
                        ];
                        throw new Error("Upsale already taken");
                    case 2:
                        upsellData = {
                            client: window.BRAND,
                            klarnaPayload: {
                                customerToken: String(lead.klarnaToken),
                                locale: _this5.fc.config.locale || "en",
                                purchase_currency: product.currencyCode || "EUR",
                                order_amount: totalAmount,
                                order_tax_amount: 0,
                                order_lines: [
                                    {
                                        name: product.name,
                                        quantity: product.quantity,
                                        unit_price: unitPrice,
                                        tax_rate: 0,
                                        total_amount: unitPrice * product.quantity,
                                        total_tax_amount: 0,
                                        image_url: product.image
                                    }
                                ],
                                merchant_urls: {
                                    confirmation: redirect
                                }
                            },
                            konnektivePayload: {
                                orderId: String(lead.orderId),
                                campaignId: String(_this5.fc.config.campaignId),
                                product1_id: String(product.id),
                                product1_price: product.finalPrice,
                                product1_shipPrice: product.shippingPrice,
                                paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                                prepaidType: "KLARNA",
                                sessionId: lead.sessionId,
                                currency: product.currencyCode || "EUR",
                                custom_order_sid: lead.sessionId,
                                custom_order_auid: lead.auid || "",
                                custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA,
                                custom_order_paymentType: lead.paymentType || "",
                                note: upsellKey !== undefined ? "".concat(product !== null && product !== void 0 && product.isDownsell ? "downsell" : "upsell").concat(upsellKey + 1) : ""
                            }
                        };
                        upsellCustomKey = (0, $e4eceaf0997e714b$export$85d6a57246cafc26)(_this5.upsellKey);
                        if (upsellCustomKey) upsellData.konnektivePayload[upsellCustomKey] = String(product.id);
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).createKlarnaCustomerTokenOrder(upsellData)
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(upsellKey) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this6 = this;
    this.createUpsellOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(upsellKey) {
            var lead, product, _this$fc$config3, res, paySource, _res, _res$items$, upsellData, orderDataWithProduct, e;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("UPSELL KEY: " + upsellKey);
                        lead = _this6.fc.lead.lead;
                        product = _this6.fc.getSelectedProduct();
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showModalLoader(true);
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setUpsellButtonLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            16,
                            17,
                            18
                        ]);
                        if (!lead.paySource) throw new Error("Error: lead does not have paySource set.");
                        if (!lead.orderId) throw new Error("Error: order ID is not set.");
                        if (!product) throw new Error("Error: Products is undefined");
                        paySource = lead.paymentMethod || lead.paySource;
                        if (paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).PREPAID) throw new Error("User paySource was set to PREPAID in upsell page");
                        $5e716b66697175e6$var$NON_RESPONSIVE_TS = Errors.maybeReportNonResponsivePaymentButton(paySource);
                        if (!(paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this6.createCreditCardUpsellOrder(upsellKey)
                        ];
                    case 2:
                        res = _state.sent();
                        _state.label = 3;
                    case 3:
                        if (!(paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).WITHREACH_PAYPAL)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            _this6.createPaypalUpsellOrder((0, $56ab4c05fb950c51$export$2a51769b07fe601).WITHREACH_PAYPAL, upsellKey)
                        ];
                    case 4:
                        res = _state.sent();
                        _state.label = 5;
                    case 5:
                        if (!(paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            _this6.createPaypalUpsellOrder((0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL, upsellKey)
                        ];
                    case 6:
                        res = _state.sent();
                        _state.label = 7;
                    case 7:
                        if (!(paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).STRIPE_KLARNA)) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            _this6.createStripeKlarnaUpsellOrder(upsellKey)
                        ];
                    case 8:
                        res = _state.sent();
                        _state.label = 9;
                    case 9:
                        if (!(paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).KLARNA)) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            _this6.createKlarnaUpsellOrder(upsellKey)
                        ];
                    case 10:
                        res = _state.sent();
                        _state.label = 11;
                    case 11:
                        if (!(paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).APPLEPAY)) return [
                            3,
                            13
                        ];
                        return [
                            4,
                            _this6.createApplePayUpsell(upsellKey)
                        ];
                    case 12:
                        res = _state.sent();
                        _state.label = 13;
                    case 13:
                        if (!(paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).GOOGLEPAY)) return [
                            3,
                            15
                        ];
                        return [
                            4,
                            _this6.createGooglePayUpsell(upsellKey)
                        ];
                    case 14:
                        res = _state.sent();
                        _state.label = 15;
                    case 15:
                        (0, $bb523a3383634612$export$6b835e0e2980707e)(product, false, upsellKey);
                        if (window.DEBUG) console.log(res);
                        // Track the upsell in Sift using the update_order event
                        if (res && res.orderId && product) {
                            ;
                            // Create a simple upsell data object for Sift tracking
                            upsellData = {
                                product1_id: product.id,
                                product1_name: product.name,
                                product1_price: product.finalPrice,
                                product1_qty: product.quantity || 1,
                                paySource: paySource,
                                custom_order_paymentMethod: paySource,
                                currency_code: product.currencyCode || "USD",
                                // Include info that this is an upsell
                                note: upsellKey !== undefined ? "upsell".concat(upsellKey + 1) : "upsell"
                            };
                            // Track the upsell as an order update
                            (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).updateOrder(lead, upsellData, res);
                            // Also track the payment transaction with product details
                            // Merge lead data with product details to ensure products are found
                            orderDataWithProduct = (0, $ioWVw._)((0, $e2Ogy._)({}, lead, upsellData), {
                                // Include all product details
                                orderId: lead.orderId,
                                sessionId: lead.sessionId,
                                emailAddress: lead.emailAddress,
                                forceMerchantId: (_res = res) === null || _res === void 0 ? void 0 : (_res$items$ = _res.items[0]) === null || _res$items$ === void 0 ? void 0 : _res$items$.merchantId // Include merchant ID for gateway lookup
                            });
                            if (window.DEBUG) console.log("[Sift Debug] trackTransaction for upsell with enriched data:", {
                                orderDataSample: Object.keys(orderDataWithProduct),
                                productIncluded: !!orderDataWithProduct.product1_id,
                                merchantId: orderDataWithProduct.forceMerchantId
                            });
                            // Pass payment source directly to trackTransaction (it will map internally)
                            (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackUpsellTransaction(orderDataWithProduct, res, {
                                paymentType: paySource // The SiftEvents class will map this to the correct format
                            }, true);
                        }
                        if (!((_this$fc$config3 = _this6.fc.config) !== null && _this$fc$config3 !== void 0 && _this$fc$config3.redirectTo)) throw new Error("Error: redirectTo is undefined");
                        if (paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD && res.url && (0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url)) {
                            window.location.href = res.url;
                            return [
                                2
                            ];
                        }
                        if (paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL && res.paypalUrl && (0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.paypalUrl)) {
                            window.location.href = res.paypalUrl;
                            return [
                                2
                            ];
                        }
                        if (paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).STRIPE_KLARNA && res.url && (0, $48bbe448a6f79255$export$bef94a5618bf18bf)(res.url)) {
                            window.location.href = res.url;
                            return [
                                2
                            ];
                        }
                        if (paySource === (0, $56ab4c05fb950c51$export$2a51769b07fe601).CREDITCARD && res.script) {
                            (0, $3391119dba56c39d$export$22b283b94688ae65)(res.script);
                            return [
                                2
                            ];
                        }
                        (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(_this6.fc.config.redirectTo);
                        return [
                            3,
                            18
                        ];
                    case 16:
                        e = _state.sent();
                        Errors.report(e, {
                            geo: window.GEO,
                            upsellKey: _this6.upsellKey,
                            lead: lead || "undefined",
                            product: product || "undefined",
                            config: _this6.fc.config || "undefined",
                            paySource: lead.paySource
                        });
                        return [
                            3,
                            18
                        ];
                    case 17:
                        $5e716b66697175e6$var$NON_RESPONSIVE_TS && clearTimeout($5e716b66697175e6$var$NON_RESPONSIVE_TS);
                        return [
                            7
                        ];
                    case 18:
                        setTimeout(function() {
                            (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showModalLoader(false);
                            (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setUpsellButtonLoading(false);
                        }, 3000);
                        return [
                            2
                        ];
                }
            });
        });
        return function(upsellKey) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this7 = this;
    this.confirmPayPalOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(redirectTo) {
            var _params$paypalAccept, lead, params, ppToken, baToken, confirmed, payerId, storage, _ref, paypalMid, sessionId, productId, referrer, hasAllParams, message, res, storageInstance, product, upsellData, orderDataWithProduct, e;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this7.fc.lead.lead;
                        params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
                        ppToken = params["token"];
                        baToken = params["ba_token"];
                        confirmed = ((_params$paypalAccept = params["paypalAccept"]) === null || _params$paypalAccept === void 0 ? void 0 : _params$paypalAccept.toLowerCase()) === "1";
                        payerId = params["PayerID"];
                        (0, $5afc064d4f10b824$export$4f9c066ec897736f)([
                            "token",
                            "ba_token",
                            "paypalAccept"
                        ]);
                        storage = (0, $f7052bb2eb427bc1$export$4395c3ac0493290e).getInstance();
                        return [
                            4,
                            Promise.all([
                                storage.getValue("express_paypal_mid"),
                                storage.getValue("express_session_id"),
                                storage.getValue("express_product_id")
                            ])
                        ];
                    case 1:
                        _ref = (0, $3F6om._).apply(void 0, [
                            _state.sent(),
                            3
                        ]), paypalMid = _ref[0], sessionId = _ref[1], productId = _ref[2];
                        referrer = window.document.referrer;
                        hasAllParams = payerId && ppToken && lead.sessionId;
                        if (window.DEBUG) console.log("confirmPayPalOrder:", {
                            ppToken: ppToken,
                            baToken: baToken,
                            confirmed: confirmed,
                            paypalMid: paypalMid,
                            sessionId: sessionId,
                            productId: productId,
                            params: params,
                            referrer: referrer
                        });
                        if (referrer.includes("paypal.com") && confirmed && !hasAllParams) {
                            message = "PayPalError: Express missing params: paypalMid: ".concat(paypalMid, ", sessionId: ").concat(sessionId, ", productId: ").concat(productId);
                            Errors.report(new Error(message), {
                                paypalMid: paypalMid,
                                sessionId: sessionId,
                                productId: productId,
                                referrer: referrer
                            }, false, false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            Promise.all([
                                storage.deleteValue("express_paypal_mid"),
                                storage.deleteValue("express_session_id"),
                                storage.deleteValue("express_product_id")
                            ])
                        ];
                    case 2:
                        _state.sent();
                        if (!(payerId && ppToken && lead.sessionId)) return [
                            3,
                            9
                        ];
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            7,
                            8,
                            9
                        ]);
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showModalLoader(true);
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setUpsellButtonLoading(true);
                        return [
                            4,
                            _this7.sendUpsaleAfterPaypalConfirmation((0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL, _this7.upsellKey, ppToken, confirmed, payerId)
                        ];
                    case 4:
                        res = _state.sent();
                        if (!(res && res.orderId)) return [
                            3,
                            6
                        ];
                        storageInstance = (0, $f7052bb2eb427bc1$export$4395c3ac0493290e).getInstance();
                        return [
                            4,
                            storageInstance.getValue("selectedProductInstance")
                        ];
                    case 5:
                        product = _state.sent();
                        if (product) {
                            // Create upsell data for Sift tracking
                            upsellData = {
                                product1_id: product.id,
                                product1_name: product.name || "",
                                product1_price: product.finalPrice,
                                product1_qty: product.quantity || 1,
                                paySource: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                                custom_order_paymentMethod: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL,
                                currency_code: product.currencyCode || "USD",
                                // Include info that this is an upsell
                                note: _this7.upsellKey !== undefined ? "upsell".concat(_this7.upsellKey + 1) : "upsell"
                            };
                            // Track the upsell as an order update
                            (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).updateOrder(lead, upsellData, res);
                            // Also track the payment transaction with product details
                            // Merge lead data with product details to ensure products are found
                            orderDataWithProduct = (0, $ioWVw._)((0, $e2Ogy._)({}, lead, upsellData), {
                                // Include all product details
                                orderId: lead.orderId,
                                sessionId: lead.sessionId,
                                emailAddress: lead.emailAddress,
                                forceMerchantId: res.merchantId // Include merchant ID for gateway lookup
                            });
                            if (window.DEBUG) console.log("[Sift Debug] trackTransaction for PayPal upsell with enriched data:", {
                                orderDataSample: Object.keys(orderDataWithProduct),
                                productIncluded: !!orderDataWithProduct.product1_id,
                                merchantId: orderDataWithProduct.forceMerchantId
                            });
                            // Pass payment source directly (will be mapped internally in SiftEvents)
                            (0, $d51a064fdf16ba1e$export$a3905c512d58c56d).trackUpsellTransaction(orderDataWithProduct, res, {
                                paymentType: (0, $56ab4c05fb950c51$export$2a51769b07fe601).PAYPAL
                            }, true);
                        }
                        _state.label = 6;
                    case 6:
                        (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(redirectTo || _this7.fc.config.redirectTo || "");
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showModalLoader(false);
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setUpsellButtonLoading(false);
                        Errors.report(e, {
                            geo: window.GEO,
                            upsellKey: _this7.upsellKey,
                            lead: lead || "undefined",
                            config: _this7.fc.config || "undefined",
                            paySource: lead.paySource
                        });
                        return [
                            3,
                            9
                        ];
                    case 8:
                        $5e716b66697175e6$var$NON_RESPONSIVE_TS && clearTimeout($5e716b66697175e6$var$NON_RESPONSIVE_TS);
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function(redirectTo) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this8 = this;
    this.sendUpsaleAfterPaypalConfirmation = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(paySource, upsellKey, ppToken, confirmed, payerId) {
            var lead, storage, product, upsellData, promoFieldName;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lead = _this8.fc.lead.lead;
                        (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackUpsellButtonClick(paySource, lead.orderId, lead.customerId, lead.auid);
                        storage = (0, $f7052bb2eb427bc1$export$4395c3ac0493290e).getInstance();
                        return [
                            4,
                            storage.getValue("selectedProductInstance")
                        ];
                    case 1:
                        product = _state.sent();
                        upsellData = {
                            orderId: (lead === null || lead === void 0 ? void 0 : lead.orderId) || "",
                            sessionId: lead.sessionId,
                            client: window.BRAND,
                            campaignId: _this8.fc.config.campaignId,
                            paySource: paySource,
                            product1_id: product.id,
                            product1_price: product.finalPrice,
                            product1_shipPrice: _this8.fc.config.shippingPrice || 0,
                            salesUrl: location.href,
                            errorRedirectsTo: location.href,
                            redirectsTo: (0, $5afc064d4f10b824$export$7138c24907de3954)(_this8.fc.config.redirectTo || "", {
                                orderId: lead.orderId || ""
                            }),
                            custom_order_sid: lead.sessionId,
                            custom_order_auid: lead.auid || "",
                            custom_order_paymentType: lead.paymentType || "",
                            custom_order_paymentMethod: lead.paymentMethod || "",
                            note: upsellKey !== undefined ? "".concat(product !== null && product !== void 0 && product.isDownsell ? "downsell" : "upsell").concat(upsellKey + 1) : "",
                            token: ppToken,
                            paypalAccept: confirmed ? 1 : 0,
                            payerId: payerId
                        };
                        promoFieldName = (0, $e4eceaf0997e714b$export$85d6a57246cafc26)(_this8.upsellKey);
                        if (promoFieldName) upsellData[promoFieldName] = String(product.id);
                        return [
                            4,
                            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).importPaypalUpsell(upsellData)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(paySource, upsellKey, ppToken, confirmed, payerId) {
            return _ref.apply(this, arguments);
        };
    }();
    this.fc = fc;
    this.upsellKey = upsellKey;
};



var $f7075f7532ca71b9$export$c96660f4c0708e49 = function FunnelController(config, lead) {
    "use strict";
    var _this = this;
    var _this1 = this;
    (0, $fvacx._)(this, FunnelController);
    this.products = pageProducts;
    this.subscriptions = pageSubscriptions;
    this.addons = window.pageAddons ? window.pageAddons : [];
    this.reportUrlErrors = function() {
        var params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
        (0, $5afc064d4f10b824$export$4f9c066ec897736f)([
            "errorMsg"
        ]);
        if (typeof params["errorMsg"] === "string") {
            var _this$lead;
            Errors.report(new Error(params["errorMsg"]), {
                geo: window.GEO,
                config: _this.config,
                lead: (_this$lead = _this.lead) === null || _this$lead === void 0 ? void 0 : _this$lead.lead,
                pp_profile: window.FLAGS.pp_profile
            }, false, false);
        }
    };
    var _this2 = this;
    this.initSession = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var params, isConfirmPaypal, _this$lead$lead, _this$lead$lead2, oldSessionId, _, e, _this$lead2;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = new URLSearchParams(window.location.search);
                    isConfirmPaypal = params.get("paypalAccept");
                    if (!!isConfirmPaypal) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    oldSessionId = (0, $13c7326b49cbd18b$export$bfaa5087b7d8bc5d)() ? undefined : params.get("session_id") || ((_this$lead$lead = _this2.lead.lead) === null || _this$lead$lead === void 0 ? void 0 : _this$lead$lead.sessionId);
                    _ = _this2.config;
                    return [
                        4,
                        (0, $9b533d68ba0137ef$export$12151e9ef3722552)({
                            ip: window.GEO.ip,
                            client: window.BRAND,
                            sessionId: oldSessionId,
                            pageType: _this2.config.pageType,
                            campaignId: _this2.config.campaignId,
                            leadEmail: (_this$lead$lead2 = _this2.lead.lead) === null || _this$lead$lead2 === void 0 ? void 0 : _this$lead$lead2.emailAddress,
                            isCheckout: _this2.config.pageType === "checkoutPage"
                        })
                    ];
                case 2:
                    _.sessionId = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        config: _this2.config,
                        lead: (_this$lead2 = _this2.lead) === null || _this$lead2 === void 0 ? void 0 : _this$lead2.lead
                    });
                    _this2.config.sessionId = "";
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    this.reportAffId = function() {
        var params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
        if ("affid" in params) {
            var _this$lead$lead3, _this$lead$lead4, _this$lead$lead5;
            (0, $6ce0d775c50793cb$export$bf71da7aebe9ddc1).reportAffId({
                url: window.location.href,
                brand: window.BRAND,
                email: (_this$lead$lead3 = _this.lead.lead) === null || _this$lead$lead3 === void 0 ? void 0 : _this$lead$lead3.emailAddress,
                orderId: ((_this$lead$lead4 = _this.lead.lead) === null || _this$lead$lead4 === void 0 ? void 0 : _this$lead$lead4.orderId) || (params === null || params === void 0 ? void 0 : params["order_id"]),
                sessionId: ((_this$lead$lead5 = _this.lead.lead) === null || _this$lead$lead5 === void 0 ? void 0 : _this$lead$lead5.sessionId) || (params === null || params === void 0 ? void 0 : params["session_id"])
            });
        }
    };
    this.checkIfFreeShipping = function() {
        var params = new URLSearchParams(window.location.search);
        var freeShippingUtm = params.get("utm_mail_ab");
        if (freeShippingUtm === "3fee3d5") {
            (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).setFreeShipping();
            _this.config.shippingPrice = 0;
            _this.products.forEach(function(p) {
                p.shippingPrice = 0;
            });
        }
    };
    var _this3 = this;
    this.maybeInitOneClickProduct = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var storage, pid, _tmp, selectedIdx, pidx;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0, $13c7326b49cbd18b$export$4117b60638bd0579)()) return [
                        3,
                        3
                    ];
                    storage = (0, $f7052bb2eb427bc1$export$4395c3ac0493290e).getInstance();
                    _tmp = (0, $5afc064d4f10b824$export$49b9065228a93aae)("pid");
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        storage.getValue("express_product_id")
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    pid = _tmp;
                    selectedIdx = _this3.products.findIndex(function(p) {
                        return p.id.toString() === pid;
                    });
                    pidx = selectedIdx !== -1 ? selectedIdx : 0;
                    window["productIdx"].value = pidx;
                    (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).populateOneClickProductCard(_this3.products[pidx]);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    this.initSubscriptionPaymentBasedRouting = function(payload) {
        try {
            if (payload.oneTimePaymentSelecorId && payload.oneTimePaymentRoutingPath && payload.subscriptionPaymentSelecorId && payload.subscriptionPaymentRoutingPath) {
                var _JSON$parse;
                var selectedCookieProduct = _this.getProductFromCookie();
                var subscriptionSelected = selectedCookieProduct ? (_JSON$parse = JSON.parse(selectedCookieProduct)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.subscription : undefined;
                if (window.DEBUG) console.log("selected product - ", selectedCookieProduct);
                if (subscriptionSelected || subscriptionSelected === undefined) {
                    _this.config.redirectTo = payload.subscriptionPaymentRoutingPath;
                    if (window.DEBUG) console.log("setting default redirect to - ".concat(payload.subscriptionPaymentRoutingPath));
                }
                document.querySelectorAll("#".concat(payload.subscriptionPaymentSelecorId)).forEach(function(b) {
                    b.addEventListener("click", function() {
                        _this.config.redirectTo = payload.subscriptionPaymentRoutingPath;
                        if (window.DEBUG) console.log("setting redirect to - ".concat(payload.subscriptionPaymentRoutingPath));
                    });
                });
                document.querySelectorAll("#".concat(payload.oneTimePaymentSelecorId)).forEach(function(b) {
                    b.addEventListener("click", function() {
                        _this.config.redirectTo = payload.oneTimePaymentRoutingPath;
                        if (window.DEBUG) console.log("setting redirect to - ".concat(payload.oneTimePaymentRoutingPath));
                    });
                });
            }
        } catch (e) {
            var _this$lead3;
            Errors.report(e, {
                geo: window.GEO,
                config: _this.config,
                lead: (_this$lead3 = _this.lead) === null || _this$lead3 === void 0 ? void 0 : _this$lead3.lead
            });
            _this.config.sessionId = "";
        }
    };
    var _this4 = this;
    this.confirmPayPalOrder = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(controller, redirectTo) {
            var _params$paypalAccept, params, ppToken, baToken, confirmed, payerId, storage, _ref, paypalMid, sessionId, productId, referrer, hasAllParams, message, findProductOrSubscription, productOrSubscription;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
                        ppToken = params["token"];
                        baToken = params["ba_token"];
                        confirmed = ((_params$paypalAccept = params["paypalAccept"]) === null || _params$paypalAccept === void 0 ? void 0 : _params$paypalAccept.toLowerCase()) === "1";
                        payerId = params["PayerID"];
                        (0, $5afc064d4f10b824$export$4f9c066ec897736f)([
                            "token",
                            "ba_token",
                            "paypalAccept"
                        ]);
                        storage = (0, $f7052bb2eb427bc1$export$4395c3ac0493290e).getInstance();
                        return [
                            4,
                            Promise.all([
                                storage.getValue("express_paypal_mid"),
                                storage.getValue("express_session_id"),
                                storage.getValue("express_product_id")
                            ])
                        ];
                    case 1:
                        _ref = (0, $3F6om._).apply(void 0, [
                            _state.sent(),
                            3
                        ]), paypalMid = _ref[0], sessionId = _ref[1], productId = _ref[2];
                        referrer = window.document.referrer;
                        hasAllParams = paypalMid && sessionId && productId;
                        if (window.DEBUG) console.log("confirmPayPalOrder:", {
                            ppToken: ppToken,
                            baToken: baToken,
                            confirmed: confirmed,
                            paypalMid: paypalMid,
                            sessionId: sessionId,
                            productId: productId,
                            params: params,
                            referrer: referrer
                        });
                        if (referrer.includes("paypal.com") && confirmed && !hasAllParams) {
                            message = "PayPalError: Express missing params: paypalMid: ".concat(paypalMid, ", sessionId: ").concat(sessionId, ", productId: ").concat(productId);
                            Errors.report(new Error(message), {
                                paypalMid: paypalMid,
                                sessionId: sessionId,
                                productId: productId,
                                referrer: referrer
                            }, false, false);
                            return [
                                2
                            ];
                        }
                        findProductOrSubscription = function(id) {
                            if (!id) return null;
                            var product = _this4.products.find(function(p) {
                                return p.id.toString() === id;
                            });
                            if (product) return product;
                            if (_this4.subscriptions && _this4.subscriptions.length > 0) {
                                var subscriptionProduct = _this4.subscriptions.find(function(p) {
                                    return p.id.toString() === id;
                                });
                                if (subscriptionProduct) return subscriptionProduct;
                            }
                        };
                        productOrSubscription = findProductOrSubscription(productId);
                        return [
                            4,
                            Promise.all([
                                storage.deleteValue("express_paypal_mid"),
                                storage.deleteValue("express_session_id"),
                                storage.deleteValue("express_product_id")
                            ])
                        ];
                    case 2:
                        _state.sent();
                        if (!(confirmed && paypalMid && ppToken && baToken && sessionId)) return [
                            3,
                            4
                        ];
                        _this4.lead.lead.sessionId = sessionId;
                        return [
                            4,
                            controller.confirmPaypalOrder({
                                baToken: baToken,
                                ppToken: ppToken,
                                sessionId: sessionId,
                                redirectTo: redirectTo,
                                paypalMid: paypalMid,
                                product: productOrSubscription
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (!(confirmed && paypalMid && ppToken && sessionId && !baToken && payerId)) return [
                            3,
                            6
                        ];
                        _this4.lead.lead.sessionId = sessionId;
                        return [
                            4,
                            controller.confirmPaypalOrderWOBaToken({
                                payerId: payerId,
                                ppToken: ppToken !== null && ppToken !== void 0 ? ppToken : "",
                                sessionId: sessionId !== null && sessionId !== void 0 ? sessionId : "",
                                redirectTo: redirectTo !== null && redirectTo !== void 0 ? redirectTo : "",
                                paypalMid: paypalMid !== null && paypalMid !== void 0 ? paypalMid : "",
                                product: productOrSubscription !== null && productOrSubscription !== void 0 ? productOrSubscription : undefined
                            })
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(controller, redirectTo) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getCurrency = function() {
        var product = _this.products[0];
        if (product) return product.currencyCode;
        return undefined;
    };
    this.getProductFromCookie = function() {
        var selectedProduct = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("selected");
        return selectedProduct;
    };
    this.getSelectedProduct = function(productId) {
        var _product;
        var product;
        if (productId) // Search by ID in both subscriptions and products
        product = _this.subscriptions.find(function(p) {
            return p.id.toString() === productId;
        }) || _this.products.find(function(p) {
            return p.id.toString() === productId;
        });
        else {
            var _window$productIdx;
            // Get product by index from either subscriptions or products array
            var productIdx = parseInt((_window$productIdx = window["productIdx"]) === null || _window$productIdx === void 0 ? void 0 : _window$productIdx.value, 10);
            product = window.subSelected ? _this.subscriptions[productIdx] : _this.products[productIdx];
        }
        // Save product size if it exists for socks 1click
        if ((_product = product) !== null && _product !== void 0 && _product.size) localStorage.setItem("product_size", product.size);
        return product;
    };
    this.getSelectedAddon = function() {
        var _window$addonIdx;
        var addonIdxStr = (_window$addonIdx = window["addonIdx"]) === null || _window$addonIdx === void 0 ? void 0 : _window$addonIdx.value;
        var addonIdx = parseInt(addonIdxStr, 10);
        var addon = _this.addons[addonIdx];
        if (window.DEBUG) console.log(addon);
        return addon;
    };
    this.getSelectedAddons = function() {
        var _window_addonIdxs;
        var addonIdxs = (_window_addonIdxs = window["addonIdxs"]) !== null && _window_addonIdxs !== void 0 ? _window_addonIdxs : [];
        if (window.pageAddons && Array.isArray(window.pageAddons)) {
            var addons = window.pageAddons.map(function(el, index) {
                var addonIdx = addonIdxs.find(function(addon) {
                    return (addon === null || addon === void 0 ? void 0 : addon.value) === index;
                });
                if (addonIdx && addonIdx.quantity) return (0, $ioWVw._)((0, $e2Ogy._)({}, el), {
                    quantity: addonIdx.quantity
                });
                return null;
            }).filter(Boolean);
            if (window.DEBUG) console.log("Selected Addons:", addons);
            return addons;
        }
    };
    this.addAddonsToPurchasePayload = function(payload) {
        var addons = _this.getSelectedAddons();
        if (addons && addons.length > 0) {
            var note = payload === null || payload === void 0 ? void 0 : payload.note;
            addons.forEach(function(addon, index) {
                if (window.DEBUG) console.log(addon);
                note = "".concat(note, ", addon_").concat(index + 1);
                var addonDiscountPrice = addon.discountPrice;
                var addonFinalPrice = addon.finalPrice;
                payload["product".concat(index + 2, "_id")] = String(addon === null || addon === void 0 ? void 0 : addon.id);
                payload["product".concat(index + 2, "_price")] = addonDiscountPrice ? addonFinalPrice - addonDiscountPrice : addonFinalPrice;
                payload["product".concat(index + 2, "_shipPrice")] = (addon === null || addon === void 0 ? void 0 : addon.shippingPrice) || 0;
                payload["product".concat(index + 2, "_qty")] = 1;
            });
            payload.note = note;
        }
    };
    this.listenForEvents = function() {
        window.addEventListener("klaviyoForms", function(e) {
            var ev = e;
            if (ev.detail.type === "open") (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackEmailPopupOpen();
            if (ev.detail.type === "close") (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackEmailPopupClose();
            if (ev.detail.type === "submit") {
                (0, $5afc064d4f10b824$export$4f2e34905c9fb7fa)({
                    utm_medium: "popup"
                });
                (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackPopupEmailSubmit(ev.detail.metaData.$email);
                setTimeout(function() {
                    var closeBtn = document.querySelector(".klaviyo-close-form");
                    if (closeBtn) closeBtn === null || closeBtn === void 0 || closeBtn.click();
                }, 3000);
                var crossedPrices = document.querySelectorAll("#crossed-price");
                crossedPrices.forEach(function(el) {
                    el.style.display = "flex";
                });
                _this.products.forEach(function(p) {
                    var reducedPrice = p.popupPrice ? parseFloat(p.popupPrice) : p.finalPrice;
                    p.finalPrice = reducedPrice;
                    var productCard = document.querySelector('[data-product-id="'.concat(p.id, '"]'));
                    if (productCard) {
                        var finalPrice = productCard.querySelector("#finalPrice");
                        if (finalPrice) finalPrice.textContent = reducedPrice.toString();
                    }
                });
            }
        });
    };
    var _this5 = this;
    this.initCheckout = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(props) {
            var _this$lead4, _this$lead4$lead, _this$config, controller, checkoutForm, e;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        setTimeout(function() {
                            return FunnelController.reportNoAuidError(_this5.config);
                        }, 500);
                        controller = new (0, $3dd279f8370fe9d2$export$8cc5b49137b63d)(_this5);
                        controller.maybeInitKlarna((_this$lead4 = _this5.lead) === null || _this$lead4 === void 0 ? void 0 : (_this$lead4$lead = _this$lead4.lead) === null || _this$lead4$lead === void 0 ? void 0 : _this$lead4$lead.country);
                        controller.maybeInitBraintree(props);
                        controller.maybeInitStripeApplePay();
                        checkoutForm = new (0, $a0037ed5cf274a1f$export$85b4408868ed49d0)(_this5, controller, props);
                        checkoutForm.initCheckoutForm();
                        return [
                            4,
                            _this5.initSession()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this5.confirmPayPalOrder(controller, _this5.config.redirectTo || "")
                        ];
                    case 2:
                        _state.sent();
                        if ((_this$config = _this5.config) !== null && _this$config !== void 0 && _this$config.trackingName) (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackPageView("Order", _this5.config.trackingName);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        Errors.report(e, {
                            geo: window.GEO,
                            config: _this5.config,
                            lead: _this5.lead.lead
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this6 = this;
    this.initUpsell = function() {
        var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(upsellKey) {
            var _this$lead5, _this$lead5$lead, _this$lead5$lead$firs, _this$config2, controller, _this$lead6, _this$lead6$lead, firstName, e;
            return (0, $33z5g.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        (0, $5afc064d4f10b824$export$4f2e34905c9fb7fa)({
                            promo_step: (upsellKey + 1).toString()
                        });
                        return [
                            4,
                            _this6.initSession()
                        ];
                    case 1:
                        _state.sent();
                        _this6.reportAffId();
                        controller = new (0, $5e716b66697175e6$export$d9442176d2557838)(_this6, upsellKey);
                        // Inject lead name 1st upsell
                        if (((_this$lead5 = _this6.lead) === null || _this$lead5 === void 0 ? void 0 : (_this$lead5$lead = _this$lead5.lead) === null || _this$lead5$lead === void 0 ? void 0 : (_this$lead5$lead$firs = _this$lead5$lead.firstName) === null || _this$lead5$lead$firs === void 0 ? void 0 : _this$lead5$lead$firs.length) > 0) {
                            ;
                            firstName = (_this$lead6 = _this6.lead) === null || _this$lead6 === void 0 ? void 0 : (_this$lead6$lead = _this$lead6.lead) === null || _this$lead6$lead === void 0 ? void 0 : _this$lead6$lead.firstName.trim();
                            (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).injectLeadName("leadNameU0", "".concat((0, $86f961742fd27aa4$export$9a00dee1beb8f576)(firstName), ", "));
                        }
                        document.querySelectorAll("#buyButton").forEach(function(btn) {
                            btn.addEventListener("click", function(e) {
                                e.preventDefault();
                                controller.createUpsellOrder(upsellKey);
                            });
                        });
                        if ((_this$config2 = _this6.config) !== null && _this$config2 !== void 0 && _this$config2.trackingName) (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackPageView("Upsell".concat(upsellKey + 1), _this6.config.trackingName);
                        return [
                            4,
                            controller.confirmPayPalOrder(_this6.config.redirectTo || "")
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        Errors.report(e, {
                            upsellKey: upsellKey,
                            geo: window.GEO,
                            config: _this6.config,
                            lead: _this6.lead.lead
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(upsellKey) {
            return _ref.apply(this, arguments);
        };
    }();
    this.shouldReportInvalidOneClick = function() {
        var params = (0, $5afc064d4f10b824$export$49b9065228a93aae)();
        var orderId = params["order_id"];
        var prospectId = params["prospect_id"];
        var notTest = params["utm_source"] !== "test";
        return notTest && !orderId && !prospectId;
    };
    var _this7 = this;
    this.initOneClick = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var _this$lead7, _this$lead7$lead, _this$lead7$lead$firs, _this$config3, controller, _this$lead8, _this$lead8$lead, firstName, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    setTimeout(function() {
                        return FunnelController.reportNoAuidError(_this7.config);
                    }, 500);
                    return [
                        4,
                        _this7.initSession()
                    ];
                case 1:
                    _state.sent();
                    controller = new (0, $5a0dbbbbdfb7a66a$export$c6274960077a35ad)(_this7);
                    // Inject lead name in one click
                    if (((_this$lead7 = _this7.lead) === null || _this$lead7 === void 0 ? void 0 : (_this$lead7$lead = _this$lead7.lead) === null || _this$lead7$lead === void 0 ? void 0 : (_this$lead7$lead$firs = _this$lead7$lead.firstName) === null || _this$lead7$lead$firs === void 0 ? void 0 : _this$lead7$lead$firs.length) > 0) {
                        ;
                        firstName = (_this$lead8 = _this7.lead) === null || _this$lead8 === void 0 ? void 0 : (_this$lead8$lead = _this$lead8.lead) === null || _this$lead8$lead === void 0 ? void 0 : _this$lead8$lead.firstName.trim();
                        (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).injectLeadName("leadNameU0", "".concat((0, $86f961742fd27aa4$export$9a00dee1beb8f576)(firstName), ", "));
                    }
                    if ((_this$config3 = _this7.config) !== null && _this$config3 !== void 0 && _this$config3.trackingName) (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackPageView(_this7.config.pageType, _this7.config.trackingName);
                    if (_this7.shouldReportInvalidOneClick()) Errors.report(new Error("OneClickError: Missing order_id and prospect_id"), {
                        geo: window.GEO,
                        config: _this7.config,
                        lead: _this7.lead.lead
                    }, false, false);
                    document.querySelectorAll("#buyButton").forEach(function(btn) {
                        btn.addEventListener("click", function() {
                            var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(ev) {
                                var _getAppUtms, _this$lead$lead6, _this$lead$lead6$cust, _this$lead$lead7, auid, sessionId, status, _this$config4, _this$lead9, locale, checkoutSlug, product, checkoutUrl;
                                return (0, $33z5g.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            ev.preventDefault();
                                            auid = (_getAppUtms = (0, $27fc5057b004f1e0$export$b8d9f037f0c03914)()) === null || _getAppUtms === void 0 ? void 0 : _getAppUtms.custom_order_auid;
                                            sessionId = new URLSearchParams(window.location.search).get("session_id") || "";
                                            (0, $8db4f4049cc051a6$export$9ab4d56492766a00).trackBuyButtonClick(((_this$lead$lead6 = _this7.lead.lead) === null || _this$lead$lead6 === void 0 ? void 0 : (_this$lead$lead6$cust = _this$lead$lead6.customerId) === null || _this$lead$lead6$cust === void 0 ? void 0 : _this$lead$lead6$cust.toString()) || "", ((_this$lead$lead7 = _this7.lead.lead) === null || _this$lead$lead7 === void 0 ? void 0 : _this$lead$lead7.orderId) || "", "one_click", auid, sessionId);
                                            return [
                                                4,
                                                controller.createOneClickOrder()
                                            ];
                                        case 1:
                                            status = _state.sent();
                                            if (status === "block") (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).showErrorModal("You have recently made a purchase, please check back later as we limit special discount offers.");
                                            if (status === "error") {
                                                ;
                                                locale = (0, $5afc064d4f10b824$export$8244edb2ebc64140)();
                                                checkoutSlug = (_this$config4 = _this7.config) !== null && _this$config4 !== void 0 && _this$config4.oneClickCheckoutSlug ? _this7.config.oneClickCheckoutSlug : locale;
                                                product = _this7.getSelectedProduct();
                                                checkoutUrl = "/products-order/".concat(checkoutSlug);
                                                if (window.DEBUG) console.log("TO_CHECKOUT 1:", checkoutUrl);
                                                (0, $13c7326b49cbd18b$export$ff7962acd6052c28)(checkoutUrl, (_this$lead9 = _this7.lead) === null || _this$lead9 === void 0 ? void 0 : _this$lead9.lead, {
                                                    pid: product.id.toString()
                                                });
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(ev) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        config: _this7.config,
                        lead: _this7.lead.lead
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    var _this8 = this;
    this.initThankYouPage = /*#__PURE__*/ (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function() {
        var e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _this8.initSession()
                    ];
                case 1:
                    _state.sent();
                    _this8.reportAffId();
                    setTimeout(function() {
                        var controller = new (0, $cc2840e193756acd$export$c730d5a0156b5bea)(_this8);
                        controller.injectInfo();
                    }, 500);
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, {
                        geo: window.GEO,
                        config: _this8.config,
                        lead: _this8.lead.lead
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    this.replaceTextInHtml = function(id, replaceStr, replaceWith) {
        var element = document.querySelector(id);
        if (element) element.innerHTML = element.innerHTML.replace(replaceStr, replaceWith);
    };
    this.initPersonalizedHeader = function(skeletonId, defaultHeaderId, personalizedHeaderId) {
        var replaceStr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "{name}";
        var _this$lead10, _this$lead10$lead, _this$lead10$lead$fir;
        var skeleton = document.querySelector(skeletonId);
        var defaultHeader = document.querySelector(defaultHeaderId);
        var personalizedHeader = document.querySelector(personalizedHeaderId);
        skeleton === null || skeleton === void 0 || skeleton.remove();
        if (skeleton && (!personalizedHeader || !defaultHeader)) {
            Errors.report(new Error("UiError: error with personalized heading"), undefined, false, false);
            return;
        }
        if (((_this$lead10 = _this1.lead) === null || _this$lead10 === void 0 ? void 0 : (_this$lead10$lead = _this$lead10.lead) === null || _this$lead10$lead === void 0 ? void 0 : (_this$lead10$lead$fir = _this$lead10$lead.firstName) === null || _this$lead10$lead$fir === void 0 ? void 0 : _this$lead10$lead$fir.length) > 0) {
            var firstName = (0, $86f961742fd27aa4$export$9a00dee1beb8f576)(_this1.lead.lead.firstName.trim());
            if (personalizedHeader) {
                var replacedHtml = personalizedHeader.innerHTML.replace(replaceStr, firstName);
                personalizedHeader.innerHTML = replacedHtml;
                personalizedHeader.style.display = "block";
            }
        } else if (defaultHeader) defaultHeader.style.display = "block";
    };
    // --------------------------------------- BELOW IS AOV TEST CODE BLOCK TO REMOVE IF IT FAILS ---------------------------------------
    // Padejau cia kad nestovetu front'e, po testo istrinsiu arba sutvarkysiu
    this.initAddonAovTest = function() {
        var getDiscountPrice = function getDiscountPrice(baseTotal) {
            var discountPercentage = baseTotal >= 80 ? 0.1 : 0;
            var discountPrice = 0;
            var productIdx = window["productIdx"];
            if (productIdx) {
                var selectedProduct = window.pageProducts[parseInt(productIdx.value, 10)];
                if (selectedProduct) discountPrice += parseFloat((selectedProduct.finalPrice * discountPercentage).toFixed(2));
            }
            var selectedAddonIdxs = window["addonIdxs"];
            if (selectedAddonIdxs) selectedAddonIdxs.forEach(function(addonIdx) {
                var idx = parseInt(addonIdx.value, 10);
                var selectedAddon = window.pageAddons[idx];
                if (selectedAddon) discountPrice += parseFloat((selectedAddon.finalPrice * discountPercentage).toFixed(2));
            });
            return discountPrice;
        };
        var getSelectedProductBasePrice = // Helper functions: Get base prices (without shipping)
        function getSelectedProductBasePrice() {
            var price = 0;
            var productIdx = window["productIdx"];
            if (productIdx) {
                var selectedProduct = window.pageProducts[parseInt(productIdx.value, 10)];
                if (selectedProduct) price += selectedProduct.finalPrice;
            }
            return price;
        };
        var getSelectedAddonBasePrice = function getSelectedAddonBasePrice() {
            var price = 0;
            var selectedAddonIdxs = window["addonIdxs"];
            if (selectedAddonIdxs) selectedAddonIdxs.forEach(function(addonIdx) {
                var idx = parseInt(addonIdx.value, 10);
                var pageAddons = window.pageAddons;
                if (pageAddons && Array.isArray(pageAddons)) {
                    var selectedAddon = pageAddons[idx];
                    if (selectedAddon) price += selectedAddon.finalPrice;
                }
            });
            return price;
        };
        var updateShippingPrices = // Update shipping prices based on base total
        function updateShippingPrices(baseAmount) {
            // Shipping is free if baseAmount >= 60, otherwise 4.95
            var shippingPrice = baseAmount >= 60 ? 0 : 4.95;
            // Update shipping price for each product
            window.pageProducts.forEach(function(product) {
                product.shippingPrice = shippingPrice;
            });
            // Update the shipping price in DOM elements (if used)
            document.querySelectorAll("#productItem").forEach(function(item) {
                item.setAttribute("data-shipping-price", shippingPrice.toString());
            });
            var standartPriceBoxes = document.querySelectorAll("#standart-price-box");
            var freePriceBoxes = document.querySelectorAll("#free-price-box");
            if (baseAmount >= 60) {
                standartPriceBoxes.forEach(function(standartPriceBox) {
                    if (standartPriceBox) standartPriceBox.style.display = "none";
                });
                freePriceBoxes.forEach(function(freePriceBox) {
                    if (freePriceBox) freePriceBox.style.display = "flex";
                });
            } else {
                standartPriceBoxes.forEach(function(standartPriceBox) {
                    if (standartPriceBox) standartPriceBox.style.display = "flex";
                });
                freePriceBoxes.forEach(function(freePriceBox) {
                    if (freePriceBox) freePriceBox.style.display = "none";
                });
            }
            return shippingPrice;
        };
        var updateProgressPoints = // Update visual progress points (and addonIdxs) – works with SVGs having multiple path elements
        function updateProgressPoints(amount) {
            // Define thresholds and corresponding background/SVG container elements
            var thresholds = [
                60,
                80,
                100
            ];
            var bgElements = [
                document.getElementById("addon-progress-poin1-bg"),
                document.getElementById("addon-progress-poin2-bg"),
                document.getElementById("addon-progress-poin3-bg")
            ];
            var svgContainers = [
                document.getElementById("addon-progress-poin1-img"),
                document.getElementById("addon-progress-poin2-img"),
                document.getElementById("addon-progress-poin3-img")
            ];
            thresholds.forEach(function(threshold, index) {
                if (amount >= threshold) {
                    if (bgElements[index]) bgElements[index].style.backgroundImage = "linear-gradient(135deg, #c322eb, #381743)";
                    if (svgContainers[index]) {
                        // Update fill for every path element inside the SVG container
                        var paths = svgContainers[index].querySelectorAll("path");
                        paths.forEach(function(path) {
                            path.style.fill = "#fff";
                        });
                    }
                } else {
                    if (bgElements[index]) bgElements[index].style.backgroundImage = "none";
                    if (svgContainers[index]) {
                        // Revert fill for every path element inside the SVG container
                        var paths1 = svgContainers[index].querySelectorAll("path");
                        paths1.forEach(function(path) {
                            path.style.fill = "#BF48E0";
                        });
                    }
                }
            });
            updateShippingPrices(amount);
            if (amount >= 100 && window.addonIdxs && Array.isArray(window.addonIdxs)) {
                var found = window.addonIdxs.find(function(obj) {
                    return obj.value === 8;
                });
                if (!found) window.addonIdxs.push({
                    value: 8,
                    quantity: 1
                });
            } else if (amount < 100 && window.addonIdxs && Array.isArray(window.addonIdxs)) window.addonIdxs = window.addonIdxs.filter(function(obj) {
                return obj.value !== 8;
            });
        };
        var updateProgressBar = // Update progress bar width based on total amount
        function updateProgressBar(totalAmount) {
            var progressBarElement = document.querySelector("#addon-progress-bar");
            var progress;
            if (totalAmount < 60) progress = totalAmount * 0.55;
            else progress = 33 + (totalAmount - 60) * 1.675;
            progress = Math.min(progress, 100);
            if (progressBarElement) progressBarElement.style.width = progress.toString() + "%";
            updateProgressPoints(totalAmount);
        };
        var initAddonButtons = function initAddonButtons() {
            var cookieAddonIdxs = (0, $4aacaa5cfd9fe25b$export$4be65e66cfa2648a)("addonIdxs");
            if (cookieAddonIdxs) window["addonIdxs"] = JSON.parse(cookieAddonIdxs);
            // Retrieve the allowed range for each product type from the corresponding add button.
            var nasalAddButton = document.getElementById("nasal-addon-add-button");
            var sleepsprayAddButton = document.getElementById("sleepspray-addon-add-button");
            var nasalMin = 0, nasalMax = 0, sleepsprayMin = 0, sleepsprayMax = 0;
            if (nasalAddButton) {
                nasalMin = parseInt(nasalAddButton.getAttribute("data-addon-min-idx") || "0", 10);
                nasalMax = parseInt(nasalAddButton.getAttribute("data-addon-max-idx") || "0", 10);
            }
            if (sleepsprayAddButton) {
                sleepsprayMin = parseInt(sleepsprayAddButton.getAttribute("data-addon-min-idx") || "0", 10);
                sleepsprayMax = parseInt(sleepsprayAddButton.getAttribute("data-addon-max-idx") || "0", 10);
            }
            // Calculate total quantities for each product type.
            var nasalQuantity = 0;
            var sleepsprayQuantity = 0;
            if (Array.isArray(window["addonIdxs"])) window["addonIdxs"].forEach(function(item) {
                if (item && item.quantity != null) {
                    var qty = parseInt(item.quantity, 10) || 0;
                    // Only count an item if its value falls within the corresponding range.
                    if (item.value >= nasalMin && item.value <= nasalMax) nasalQuantity += qty;
                    else if (item.value >= sleepsprayMin && item.value <= sleepsprayMax) sleepsprayQuantity += qty;
                }
            });
            // Update quantity display elements.
            var nasalQntElem = document.getElementById("nasal-addon-quantity");
            var sleepsprayQntElem = document.getElementById("sleepspray-addon-quantity");
            if (nasalQntElem) nasalQntElem.innerText = nasalQuantity.toString();
            if (sleepsprayQntElem) sleepsprayQntElem.innerText = sleepsprayQuantity.toString();
            // Update button statuses for nasal add-ons.
            var nasalAddBtn = document.getElementById("nasal-addon-add-button");
            var nasalRemoveBtn = document.getElementById("nasal-addon-remove-button");
            if (nasalAddBtn) {
                if (nasalQuantity >= 4) {
                    nasalAddBtn.disabled = true;
                    nasalAddBtn.style.opacity = "0.5";
                } else {
                    nasalAddBtn.disabled = false;
                    nasalAddBtn.style.opacity = "1";
                }
            }
            if (nasalRemoveBtn) {
                if (nasalQuantity > 0) {
                    nasalRemoveBtn.disabled = false;
                    nasalRemoveBtn.style.opacity = "1";
                } else {
                    nasalRemoveBtn.disabled = true;
                    nasalRemoveBtn.style.opacity = "0.5";
                }
            }
            // Update button statuses for sleepspray add-ons.
            var sleepsprayAddBtn = document.getElementById("sleepspray-addon-add-button");
            var sleepsprayRemoveBtn = document.getElementById("sleepspray-addon-remove-button");
            if (sleepsprayAddBtn) {
                if (sleepsprayQuantity >= 4) {
                    sleepsprayAddBtn.disabled = true;
                    sleepsprayAddBtn.style.opacity = "0.5";
                } else {
                    sleepsprayAddBtn.disabled = false;
                    sleepsprayAddBtn.style.opacity = "1";
                }
            }
            if (sleepsprayRemoveBtn) {
                if (sleepsprayQuantity > 0) {
                    sleepsprayRemoveBtn.disabled = false;
                    sleepsprayRemoveBtn.style.opacity = "1";
                } else {
                    sleepsprayRemoveBtn.disabled = true;
                    sleepsprayRemoveBtn.style.opacity = "0.5";
                }
            }
            // Optionally update styling/text of the add buttons.
            var nasalAddBtnElement = document.querySelector(".nasal-add-button");
            if (nasalAddBtnElement) {
                if (nasalQuantity === 0) {
                    nasalAddBtnElement.style.position = "absolute";
                    nasalAddBtnElement.innerText = "+Add";
                } else {
                    nasalAddBtnElement.style.position = "relative";
                    nasalAddBtnElement.innerText = "+";
                }
            }
            var sleepsprayAddBtnElement = document.querySelector(".sleepspray-add-button");
            if (sleepsprayAddBtnElement) {
                if (sleepsprayQuantity === 0) {
                    sleepsprayAddBtnElement.style.position = "absolute";
                    sleepsprayAddBtnElement.innerText = "+Add";
                } else {
                    sleepsprayAddBtnElement.style.position = "relative";
                    sleepsprayAddBtnElement.innerText = "+";
                }
            }
        };
        var setTotalAmount = function() {
            var _getDiscountPrice;
            var baseTotal = getSelectedProductBasePrice() + getSelectedAddonBasePrice();
            if (window.DEBUG) console.log("baseTotal: ", baseTotal);
            var subtotalAmount = parseFloat(baseTotal.toFixed(2));
            if (window.DEBUG) console.log("subtotalAmount: ", subtotalAmount);
            var subtotalAmountText = document.querySelector("#addon-progress-subtotal-price");
            if (subtotalAmountText) subtotalAmountText.innerText = subtotalAmount;
            var discountAmount = (_getDiscountPrice = getDiscountPrice(baseTotal)) === null || _getDiscountPrice === void 0 ? void 0 : _getDiscountPrice.toFixed(2);
            if (window.DEBUG) console.log("discountAmount: ", discountAmount);
            var discountElement = document.getElementById("addon-progress-discount-price");
            if (discountElement) discountElement.innerText = discountAmount;
            if (baseTotal >= 80) {
                if (Array.isArray(window.pageProducts) && Array.isArray(_this.products)) {
                    window.pageProducts.forEach(function(el) {
                        el.discountPrice = parseFloat((el.finalPrice * 0.1).toFixed(2));
                    });
                    _this.products.forEach(function(el) {
                        el.discountPrice = parseFloat((el.finalPrice * 0.1).toFixed(2));
                    });
                }
                if (Array.isArray(window.pageAddons) && Array.isArray(_this.addons)) {
                    window.pageAddons.forEach(function(el) {
                        el.discountPrice = parseFloat((el.finalPrice * 0.1).toFixed(2));
                    });
                    _this.addons.forEach(function(el) {
                        el.discountPrice = parseFloat((el.finalPrice * 0.1).toFixed(2));
                    });
                }
            } else {
                if (Array.isArray(window.pageProducts) && Array.isArray(_this.products)) {
                    window.pageProducts.forEach(function(el) {
                        el.discountPrice = 0;
                    });
                    _this.products.forEach(function(el) {
                        el.discountPrice = 0;
                    });
                }
                if (Array.isArray(window.pageAddons) && Array.isArray(_this.addons)) {
                    window.pageAddons.forEach(function(el) {
                        el.discountPrice = 0;
                    });
                    _this.addons.forEach(function(el) {
                        el.discountPrice = 0;
                    });
                }
            }
            var shippingPrice = updateShippingPrices(baseTotal);
            if (window.DEBUG) console.log("shippingPrice: ", shippingPrice);
            var totalAmount = parseFloat((baseTotal - discountAmount + shippingPrice).toFixed(2));
            if (window.DEBUG) console.log("totalAmount: ", totalAmount);
            var totalElement = document.getElementById("addon-progress-total-price");
            if (totalElement) totalElement.innerText = totalAmount;
            updateProgressBar(baseTotal);
        };
        window.setTotalAmount = setTotalAmount;
        return {
            setTotalAmount: setTotalAmount,
            initAddonButtons: initAddonButtons
        };
    };
    this.lead = lead;
    this.config = config;
    this.maybeInitOneClickProduct();
    this.reportUrlErrors();
    this.checkIfFreeShipping();
    (0, $13f670394c23e173$export$7bcc3fa3b490ab9e).removeInvisibleElements();
    // Change product upsellKey when upsell flow is custom
    if (typeof config.upsellKey === "number") {
        var firstProductUpsellKey = this.products[0].upsellKey;
        if (typeof firstProductUpsellKey === "number" && firstProductUpsellKey !== config.upsellKey) this.products = this.products.map(function(p) {
            return (0, $ioWVw._)((0, $e2Ogy._)({}, p), {
                upsellKey: config.upsellKey
            });
        });
    }
    if (window.DEBUG) console.log("FunnelController:", this);
};
$f7075f7532ca71b9$export$c96660f4c0708e49.reportNoAuidError = function(config) {
// COMMENTED OUT 2025.07.07
// const params = new URLSearchParams(window.location.search);
// const auid = params.get('utm_auid');
// const isTest = params.get('utm_source') === 'test';
// if (!window.DEBUG && !auid && !isTest) {
//   Errors.report(
//     new Error('ProxyError: No auid found on production website'),
//     {
//       geo: window.GEO,
//       config,
//     },
//     false,
//     false,
//   );
// }
};
$f7075f7532ca71b9$export$c96660f4c0708e49.init = function() {
    var _ref = (0, $3ccd832df3dc4d34$export$7c398597f8905a1)(function(config) {
        var lead, e;
        return (0, $33z5g.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $cbec8c04d0200356$export$821ec1715007eb78).init(config)
                    ];
                case 1:
                    lead = _state.sent();
                    return [
                        2,
                        new $f7075f7532ca71b9$export$c96660f4c0708e49(config, lead)
                    ];
                case 2:
                    e = _state.sent();
                    Errors.report(e, {
                        config: config
                    }, false, false);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}();



try {
    window.fc = (0, $f7075f7532ca71b9$export$c96660f4c0708e49);
    window.ui = (0, $13f670394c23e173$export$7bcc3fa3b490ab9e);
} catch (e) {
    Errors.report(e);
}

})();
//# sourceMappingURL=index.js.map
